
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$defineInteropFlag(a) {
  Object.defineProperty(a, '__esModule', {value: true, configurable: true});
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequire94c2"];
var parcelRegister = parcelRequire.register;
parcelRegister("alfJ7", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $3dd514a20c2c7d64$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");
parcelRequire("kQSGw");

var $hTLlD = parcelRequire("hTLlD");

var $3LiTJ = parcelRequire("3LiTJ");

var $53ciZ = parcelRequire("53ciZ");

var $lNfG4 = parcelRequire("lNfG4");

var $0cdA8 = parcelRequire("0cdA8");

var $1ybV0 = parcelRequire("1ybV0");

var $5as0a = parcelRequire("5as0a");

var $62aVz = parcelRequire("62aVz");

var $1HaD6 = parcelRequire("1HaD6");

var $jccNB = parcelRequire("jccNB");

var $3wKQY = parcelRequire("3wKQY");

var $lB25E = parcelRequire("lB25E");

var $6vrw7 = parcelRequire("6vrw7");

var $jK1pm = parcelRequire("jK1pm");

var $kHSe2 = parcelRequire("kHSe2");
const $3dd514a20c2c7d64$var$BROWSER_METRICS_INTERACTION_APP_KEY = 'jira.global-issue-navigator';
const $3dd514a20c2c7d64$var$initInteractions = ()=>({
        pagination: {
            metrics: (0, $lNfG4.metrics).interaction({
                key: `${$3dd514a20c2c7d64$var$BROWSER_METRICS_INTERACTION_APP_KEY}.pagination.start-end.diff`
            }),
            properties: {}
        },
        refinement: {
            metrics: (0, $lNfG4.metrics).interaction({
                key: `${$3dd514a20c2c7d64$var$BROWSER_METRICS_INTERACTION_APP_KEY}.refinement.start-end.diff`
            }),
            properties: {}
        },
        filter: {
            metrics: (0, $lNfG4.metrics).interaction({
                key: `${$3dd514a20c2c7d64$var$BROWSER_METRICS_INTERACTION_APP_KEY}.filter.start-end.diff`
            }),
            properties: {}
        },
        'list-view': {
            metrics: (0, $lNfG4.metrics).interaction({
                key: `${$3dd514a20c2c7d64$var$BROWSER_METRICS_INTERACTION_APP_KEY}.list-view.start-end.diff`
            }),
            properties: {}
        },
        'split-view': {
            metrics: (0, $lNfG4.metrics).interaction({
                key: `${$3dd514a20c2c7d64$var$BROWSER_METRICS_INTERACTION_APP_KEY}.split-view.start-end.diff`
            }),
            properties: {}
        },
        'column-configuration': {
            metrics: (0, $lNfG4.metrics).interaction({
                key: `${$3dd514a20c2c7d64$var$BROWSER_METRICS_INTERACTION_APP_KEY}.column-configuration.start-end.diff`
            }),
            properties: {}
        }
    });
// eslint-disable-next-line jira/react/no-class-components
class $3dd514a20c2c7d64$var$GlobalIssueNavigatorSPAWrapper extends (0, $eUqFw.Component) {
    constructor(props){
        super(props);
        this.state = {
            initialised: false,
            issueKey: this.props.match?.params.issueKey ?? ''
        };
        /**
	 * Update the currently selected issue in the URL.
	 *
	 * @param issueKey Issue key to update in the URL
	 * @param isSelectedByUserInteraction True if this issue was selected by a user interaction, e.g. clicking an issue
	 * in the list. This will be false if an issue was automatically selected by the app, e.g. automatically selecting
	 * the first issue once the issue list has loaded.
	 */ this.onChangeIssue = (issueKey, isSelectedByUserInteraction)=>{
            // Replace the history entry when an issue is auto selected by the app so we're not pushing redundant entries to
            // the history stack
            this.push({
                issueKey: issueKey
            }, !isSelectedByUserInteraction);
        };
        this.onChangePage = ()=>{
            this.startInteraction('pagination', {
                view: this.view
            });
        };
        this.onSetView = (newView, issueKey)=>{
            this.startInteraction((0, $3wKQY.convertToView)(newView));
            this.view = newView;
            if (issueKey !== undefined) this.push({
                issueKey: issueKey
            }, true);
        };
        this.onRefinement = ()=>{
            this.startInteraction('refinement');
        };
        /**
	 * Callback function called when internal changes are made to PIN's state which generates new JQL.
	 *
	 * @param jql string The new JQL string
	 * @param clearFilter boolean When true we clear the filter from url params
	 */ this.onChangeJql = (jql, clearFilter = false)=>{
            this.push({
                ...clearFilter ? {
                    filter: undefined
                } : {},
                jql: jql,
                // Clear issue key from URL whenever JQL changes
                issueKey: (0, $6vrw7.toIssueKey)('')
            });
        };
        this.onPageDataLoad = (selectedView)=>{
            if (selectedView !== undefined) this.view = selectedView;
            if (!this.state.initialised) this.setState({
                initialised: true
            });
            this.endInteractions();
        };
        this.onStartFilterChangeInteractionIfAny = (filter)=>{
            if (this.lastFilter !== filter) {
                this.lastFilter = filter;
                if (filter != null && (!(0, $1ybV0.ff)('nin-remove-ugc-from-browsermetrics_4qrsr') || (0, $5as0a.isFilterId)(filter))) this.startInteraction('filter', {
                    filterId: filter
                });
            }
        };
        this.onChangeColumnConfiguration = ()=>{
            this.startInteraction('column-configuration');
        };
        this.onChangeFilter = (filter)=>{
            this.push({
                ...filter ? {
                    filter: filter,
                    jql: undefined
                } : {
                    jql: undefined
                }
            }, true);
        };
        this.startInteraction = (key, properties)=>{
            if (!this.activeInteractions.includes(key)) this.activeInteractions.push(key);
            const interaction = this.interactions[key];
            if (interaction) {
                interaction.properties = properties || {};
                interaction.metrics.start();
            }
        };
        this.endInteractions = ()=>{
            this.activeInteractions.forEach((key)=>{
                this.interactions[key]?.metrics.stop({
                    customData: this.interactions[key]?.properties
                });
            });
            this.activeInteractions = [];
        };
        this.getQueryStringParams = ()=>{
            const { location: location } = this.props;
            const { filter: filter, jql: jql } = (0, $53ciZ.parse)(location.search, {
                // @ts-expect-error - The "comma" option requires query-string v6.4.0 or newer. JFE currently uses v5.1.1.
                arrayFormat: 'comma'
            });
            return {
                filter: filter,
                jql: jql
            };
        };
        const { location: location } = props;
        this.locationSearchStr = location.search;
        this.activeInteractions = [];
        this.view = (0, $jccNB.DEFAULT_VIEW_ID);
        this.interactions = $3dd514a20c2c7d64$var$initInteractions();
    }
    componentDidUpdate(prevProps) {
        const prevIssueKey = prevProps.match?.params.issueKey ?? '';
        const issueKey = this.props.match?.params.issueKey ?? '';
        // If issue key has changed from the router and does not match our internal key then update our state
        if (issueKey !== prevIssueKey && issueKey !== this.state.issueKey) this.setState({
            issueKey: issueKey
        });
    }
    push(newParams, shouldReplace = false) {
        const { push: push, location: location, replace: replace } = this.props;
        const historyAction = shouldReplace ? replace : push;
        const oldIssueKey = this.state.issueKey;
        const { issueKey: issueKey = oldIssueKey ?? '', ...params } = newParams;
        const issueKeyChanged = newParams.issueKey !== oldIssueKey;
        // @ts-expect-error - The "comma" option requires query-string v6.4.0 or newer. JFE currently uses v5.1.1.
        const query = (0, $53ciZ.parse)(location.search, {
            arrayFormat: 'comma'
        });
        const queryParamsChanged = Object.keys(params).length !== 0 && !(0, (/*@__PURE__*/$parcel$interopDefault($hTLlD)))((0, (/*@__PURE__*/$parcel$interopDefault($3LiTJ)))(params, (param)=>param), query);
        if (issueKeyChanged || queryParamsChanged) // @ts-expect-error - React-resource-router's external type interface claims push/replace only accept "string", however the underlying code works with the `Location` object we're using
        historyAction({
            pathname: `/issues/${issueKey ?? ''}`,
            // @ts-expect-error - The "comma" option requires query-string v6.4.0 or newer. JFE currently uses v5.1.1.
            search: (0, $53ciZ.stringify)({
                ...query,
                ...params
            }, {
                arrayFormat: 'comma'
            })
        });
        if (issueKeyChanged) // We explicitly set this into state instead of being purely prop driven as browser history actions are not
        // re-rendered synchronously. Setting into state makes our render order more reliable.
        this.setState({
            issueKey: issueKey ?? ''
        });
        return true;
    }
    render() {
        const { filter: filter, jql: jql } = this.getQueryStringParams();
        this.onStartFilterChangeInteractionIfAny(filter);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $kHSe2.default), {
            issueKey: (0, $6vrw7.toIssueKey)(this.state.issueKey),
            jql: jql,
            onChangeIssue: this.onChangeIssue,
            onChangePage: this.onChangePage,
            onPageDataLoad: this.onPageDataLoad,
            onChangeColumnConfiguration: this.onChangeColumnConfiguration,
            onChangeJql: this.onChangeJql,
            onChangeFilter: this.onChangeFilter,
            initialised: this.state.initialised,
            onRefinement: this.onRefinement,
            onSetView: this.onSetView,
            view: (0, $3wKQY.convertToView)(this.view),
            filter: filter
        }), this.state.initialised && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $0cdA8.JSErrorBoundary), {
            id: "smartQueryDetectedFlag",
            packageName: "jiraSpaAppsGlobalIssueNavigator",
            teamName: "empanada",
            fallback: "unmount"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $62aVz.SmartQueryDetectedFlag), {
            jql: jql
        })), this.state.initialised && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $0cdA8.JSErrorBoundary), {
            id: "wildcardAddedFlag",
            packageName: "jiraSpaAppsGlobalIssueNavigator",
            teamName: "empanada",
            fallback: "unmount"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1HaD6.WildcardAddedFlag), null)));
    }
}
const $3dd514a20c2c7d64$var$GlobalIssueNavigatorSPAWrapperRouterConsumer = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $jK1pm.default), {
        name: "global-issue-navigator"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $lB25E.RouterActions), null, ({ push: push, replace: replace })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $lB25E.RouterSubscriber), null, ({ location: location, match: match })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($3dd514a20c2c7d64$var$GlobalIssueNavigatorSPAWrapper, {
                push: push,
                location: location,
                match: match,
                replace: replace
            }))));
var $3dd514a20c2c7d64$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, $eUqFw.memo)($3dd514a20c2c7d64$var$GlobalIssueNavigatorSPAWrapperRouterConsumer);

});
parcelRegister("62aVz", function(module, exports) {

$parcel$export(module.exports, "SmartQueryDetectedFlag", () => $572c890627cab2de$export$8b388d8aa2182f84);

var $eUqFw = parcelRequire("eUqFw");

var $53ciZ = parcelRequire("53ciZ");

var $1Yimi = parcelRequire("1Yimi");

var $eo17r = parcelRequire("eo17r");
var $k8Qyf = parcelRequire("k8Qyf");

var $90ffs = parcelRequire("90ffs");

var $5JgJ2 = parcelRequire("5JgJ2");

var $jMP2a = parcelRequire("jMP2a");
var $bFzGY = parcelRequire("bFzGY");

var $lB25E = parcelRequire("lB25E");

var $hBDw2 = parcelRequire("hBDw2");

var $hz7y5 = parcelRequire("hz7y5");


var $dzTTP = parcelRequire("dzTTP");
const $572c890627cab2de$var$flagId = (0, $eo17r.toFlagId)((0, $6580074e500623eb$export$aead6163e23d2a49));
const $572c890627cab2de$export$48ea269755562084 = (props)=>{
    const { dismissFlag: dismissFlag } = (0, $k8Qyf.useFlagsService)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bFzGY.useAnalyticsEvents)();
    const onDismissed = ()=>{
        dismissFlag($572c890627cab2de$var$flagId);
        (0, $jMP2a.fireTrackAnalytics)(createAnalyticsEvent({}), 'smartQueryDetectedFlag dismissed');
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $90ffs.default), {
        ...props,
        onDismissed: onDismissed
    });
};
function $572c890627cab2de$var$useDontShowAgainAction() {
    const { update: updateSmartQueryDontShowPreference } = (0, $hBDw2.useBooleanPreferenceSet)('user.smart.query.flag.dont.show');
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bFzGY.useAnalyticsEvents)();
    const { dismissFlag: dismissFlag } = (0, $k8Qyf.useFlagsService)();
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    return {
        dontShowAgainAction: (0, $eUqFw.useMemo)(()=>({
                content: formatMessage((0, $dzTTP.default).flagDontShowAgainAction),
                onClick: ()=>{
                    updateSmartQueryDontShowPreference();
                    (0, $jMP2a.fireTrackAnalytics)(createAnalyticsEvent({}), 'smartQueryDetectedFlagDontShowAgain clicked');
                    dismissFlag($572c890627cab2de$var$flagId);
                }
            }), [
            formatMessage,
            updateSmartQueryDontShowPreference,
            createAnalyticsEvent,
            dismissFlag
        ])
    };
}
const $572c890627cab2de$export$a9400f40005bf958 = ()=>{
    const { showFlag: showFlag, hasFlag: hasFlag } = (0, $k8Qyf.useFlagsService)();
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const { dontShowAgainAction: dontShowAgainAction } = $572c890627cab2de$var$useDontShowAgainAction();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bFzGY.useAnalyticsEvents)();
    const flagActions = (0, $eUqFw.useMemo)(()=>[
            dontShowAgainAction
        ], [
        dontShowAgainAction
    ]);
    const displayFlag = (0, $eUqFw.useCallback)(()=>{
        if (!hasFlag?.($572c890627cab2de$var$flagId)) {
            showFlag({
                id: $572c890627cab2de$var$flagId,
                render: (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($572c890627cab2de$export$48ea269755562084, {
                        ...props,
                        id: $572c890627cab2de$var$flagId,
                        key: $572c890627cab2de$var$flagId,
                        title: formatMessage((0, $dzTTP.default).flagTitle),
                        description: formatMessage((0, $dzTTP.default).flagDescription, {
                            strong: (chunks)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1Yimi.default), {
                                    as: "strong"
                                }, chunks)
                        }),
                        actions: flagActions,
                        testId: "issue-navigator-flags.ui.smart-query-detected-flag.smart-query-detected-flag"
                    })
            });
            (0, $jMP2a.fireUIAnalytics)(createAnalyticsEvent({}), 'smartQueryDetectedFlag shown');
        }
    }, [
        hasFlag,
        showFlag,
        formatMessage,
        flagActions,
        createAnalyticsEvent
    ]);
    return {
        displayFlag: displayFlag
    };
};
const $572c890627cab2de$export$8b388d8aa2182f84 = ({ jql: jql })=>{
    const { displayFlag: displayFlag } = $572c890627cab2de$export$a9400f40005bf958();
    const [route, { replace: replace }] = (0, $lB25E.useRouter)();
    const params = (0, $eUqFw.useMemo)(()=>(0, $53ciZ.parse)(route.location.search), [
        route.location.search
    ]);
    const wildcardAddedBool = params.wildcardAdded === 'true';
    const smartQueryDisabledBool = params.smartQueryDisabled === 'true';
    const { isSmartQuery: isSmartQuery, data: data } = (0, $hz7y5.useSmartQueryCheck)({
        jql: smartQueryDisabledBool ? jql : undefined,
        wildcardAdded: wildcardAddedBool
    });
    (0, $eUqFw.useEffect)(()=>{
        if (isSmartQuery) displayFlag();
    }, [
        isSmartQuery,
        displayFlag
    ]);
    // detection check should will remove smartQueryDisabled and wildcardAdded from the search params, making sure we don't show the flag again
    (0, $eUqFw.useEffect)(()=>{
        // if smart query is not disabled, still need to get rid of wildcardAdded param
        if (data || !smartQueryDisabledBool && wildcardAddedBool) {
            // remove smartQueryDisabled and wildcardAdded from the search params, including any & at the start
            // using fromQueryString here so that it encodes the JQL in the same format everything else does
            const newSearch = {
                ...params
            };
            if (newSearch.smartQueryDisabled) delete newSearch.smartQueryDisabled;
            if (newSearch.wildcardAdded) delete newSearch.wildcardAdded;
            // @ts-expect-error - The "comma" option requires query-string v6.4.0 or newer. JFE currently uses v5.1.1.
            const newSearchString = `?${(0, $53ciZ.stringify)(newSearch, {
                arrayFormat: 'comma'
            })}`;
            // @ts-expect-error - The "comma" option requires query-string v6.4.0 or newer. JFE currently uses v5.1.1.
            const oldSearchString = `?${(0, $53ciZ.stringify)(params, {
                arrayFormat: 'comma'
            })}`;
            if (newSearchString !== oldSearchString) replace({
                ...route.location,
                search: newSearchString
            });
        }
    }, [
        data,
        route,
        replace,
        smartQueryDisabledBool,
        wildcardAddedBool,
        params
    ]);
    return null;
};
var $572c890627cab2de$export$2e2bcd8739ae039 = $572c890627cab2de$export$8b388d8aa2182f84;

});
parcelRegister("90ffs", function(module, exports) {

$parcel$export(module.exports, "default", () => $8b69c2b71403c7d4$export$2e2bcd8739ae039);

var $kQ0RL = parcelRequire("kQ0RL");
var $8b69c2b71403c7d4$export$2e2bcd8739ae039 = (0, $kQ0RL.InfoFlag);

});
parcelRegister("kQ0RL", function(module, exports) {

$parcel$export(module.exports, "CommonFlag", () => $2ffdc518941fd08c$export$13d73238a031436b);
$parcel$export(module.exports, "ErrorFlag", () => $2ffdc518941fd08c$export$518ba8e0e60f145f);
$parcel$export(module.exports, "ErrorAutoDismissFlag", () => $2ffdc518941fd08c$export$3f75672bb90a4431);
$parcel$export(module.exports, "InfoFlag", () => $2ffdc518941fd08c$export$6a55b52e74c1e48e);
$parcel$export(module.exports, "SuccessAutoDismissFlag", () => $2ffdc518941fd08c$export$74a3c0748aa31355);
$parcel$export(module.exports, "SuccessFlag", () => $2ffdc518941fd08c$export$93bd4963a1d00fd5);
$parcel$export(module.exports, "WarningFlag", () => $2ffdc518941fd08c$export$23695d8281998f27);
$parcel$export(module.exports, "FlagGroup", () => $2ffdc518941fd08c$export$a2c3479950310d7d);
// eslint-disable-next-line jira/restricted/react-component-props

var $eUqFw = parcelRequire("eUqFw");

var $7rh0R = parcelRequire("7rh0R");

var $5L0Jp = parcelRequire("5L0Jp");

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $2ffdc518941fd08c$var$ForPaintJiraCommonFlag = (0, $7rh0R.lazyForPaint)(()=>(parcelRequire("bmR0P")).then(({ JiraCommonFlag: JiraCommonFlag })=>JiraCommonFlag), {
    ssr: false,
    moduleId: "./src/packages/platform/ui/flags/src/common/ui/components/common-flag-v2/index.tsx"
});

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $2ffdc518941fd08c$var$AfterPaintJiraCommonFlag = (0, $7rh0R.lazyAfterPaint)(()=>// eslint-disable-next-line jira/import/webpack-magic-comment-entries
    (parcelRequire("bmR0P")).then(({ JiraCommonFlag: JiraCommonFlag })=>JiraCommonFlag), {
    ssr: false,
    moduleId: "./src/packages/platform/ui/flags/src/common/ui/components/common-flag-v2/index.tsx"
});
const $2ffdc518941fd08c$var$CommonFlagImpl = (props)=>__SPA__ ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($2ffdc518941fd08c$var$AfterPaintJiraCommonFlag, props) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($2ffdc518941fd08c$var$ForPaintJiraCommonFlag, props);

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $2ffdc518941fd08c$var$ForPaintFlagGroup = (0, $7rh0R.lazyForPaint)(// eslint-disable-next-line jira/import/webpack-magic-comment-entries
()=>(parcelRequire("eWPgg")), {
    ssr: false,
    moduleId: "./src/packages/platform/ui/flags/src/common/ui/components/group-flag-v2/index.tsx"
});

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $2ffdc518941fd08c$var$AfterPaintFlagGroup = (0, $7rh0R.lazyAfterPaint)(// eslint-disable-next-line jira/import/webpack-magic-comment-entries
()=>(parcelRequire("eWPgg")), {
    ssr: false,
    moduleId: "./src/packages/platform/ui/flags/src/common/ui/components/group-flag-v2/index.tsx"
});
const $2ffdc518941fd08c$var$FlagGroupImpl = (props)=>__SPA__ ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($2ffdc518941fd08c$var$AfterPaintFlagGroup, props) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($2ffdc518941fd08c$var$ForPaintFlagGroup, props);
const $2ffdc518941fd08c$export$13d73238a031436b = ({ packageName: packageName = 'flags', ...props })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5L0Jp.FlagsBoundary), {
        packageName: packageName
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($2ffdc518941fd08c$var$CommonFlagImpl, props));
const $2ffdc518941fd08c$export$518ba8e0e60f145f = ({ packageName: packageName = 'flags', ...props })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5L0Jp.FlagsBoundary), {
        packageName: packageName
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($2ffdc518941fd08c$var$CommonFlagImpl, {
        flagType: "error",
        ...props
    }));
const $2ffdc518941fd08c$export$3f75672bb90a4431 = ({ packageName: packageName = 'flags', ...props })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5L0Jp.FlagsBoundary), {
        packageName: packageName
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($2ffdc518941fd08c$var$CommonFlagImpl, {
        flagType: "error",
        isAutoDismiss: true,
        ...props
    }));
const $2ffdc518941fd08c$export$6a55b52e74c1e48e = ({ packageName: packageName = 'flags', ...props })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5L0Jp.FlagsBoundary), {
        packageName: packageName
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($2ffdc518941fd08c$var$CommonFlagImpl, {
        flagType: "info",
        ...props
    }));
const $2ffdc518941fd08c$export$74a3c0748aa31355 = ({ packageName: packageName = 'flags', ...props })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5L0Jp.FlagsBoundary), {
        packageName: packageName
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($2ffdc518941fd08c$var$CommonFlagImpl, {
        flagType: "success",
        isAutoDismiss: true,
        ...props
    }));
const $2ffdc518941fd08c$export$93bd4963a1d00fd5 = ({ packageName: packageName = 'flags', ...props })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5L0Jp.FlagsBoundary), {
        packageName: packageName
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($2ffdc518941fd08c$var$CommonFlagImpl, {
        flagType: "success",
        ...props
    }));
const $2ffdc518941fd08c$export$23695d8281998f27 = ({ packageName: packageName = 'flags', ...props })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5L0Jp.FlagsBoundary), {
        packageName: packageName
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($2ffdc518941fd08c$var$CommonFlagImpl, {
        flagType: "warning",
        ...props
    }));
const $2ffdc518941fd08c$export$a2c3479950310d7d = ({ packageName: packageName = 'flags', ...props })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5L0Jp.FlagsBoundary), {
        packageName: packageName
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($2ffdc518941fd08c$var$FlagGroupImpl, props));

});
parcelRegister("bmR0P", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = Promise.all([
    $d1Cng("eNmuD"),
    $d1Cng("hPzOn"),
    $d1Cng("2hmUs"),
    $d1Cng("bCeK4"),
    $d1Cng("h2MrD"),
    $d1Cng("bYT2S"),
    $d1Cng("cCYJs")
]).then(()=>parcelRequire('kbpOk'));

});

parcelRegister("eWPgg", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = $d1Cng("hkLGi").then(()=>parcelRequire('jkRT2'));

});



parcelRegister("hBDw2", function(module, exports) {

$parcel$export(module.exports, "useBooleanPreferenceSet", () => $8ebd7b76ca3d23b6$export$2e9a7ecf87efb1e6);

var $eUqFw = parcelRequire("eUqFw");

var $eEzyV = parcelRequire("eEzyV");

var $guiFP = parcelRequire("guiFP");

var $lRmyA = parcelRequire("lRmyA");
const $8ebd7b76ca3d23b6$export$2e9a7ecf87efb1e6 = (key)=>{
    const setPreferenceToTrue = (0, $eUqFw.useCallback)(()=>(0, $lRmyA.performPutRequest)(`/rest/api/3/mypreferences?key=${key}`, {
            body: 'true'
        }), [
        key
    ]);
    // eslint-disable-next-line @typescript-eslint/no-invalid-void-type
    const { loading: loading, error: error, fetch: update } = (0, $eEzyV.useService)(setPreferenceToTrue);
    (0, $eUqFw.useEffect)(()=>{
        if (error) (0, $guiFP.default)({
            meta: {
                id: 'useBooleanPreferenceSet',
                packageName: 'jiraIssueNavigatorFlags',
                teamName: 'empanada'
            },
            error: error,
            attributes: {
                key: key
            }
        });
    }, [
        error,
        key
    ]);
    return {
        loading: loading,
        error: error,
        update: update
    };
};
var $8ebd7b76ca3d23b6$export$2e2bcd8739ae039 = $8ebd7b76ca3d23b6$export$2e9a7ecf87efb1e6;

});

parcelRegister("hz7y5", function(module, exports) {

$parcel$export(module.exports, "useSmartQueryCheck", () => $edad580f3eb6944a$export$26a66faebe7f7b65);

var $eUqFw = parcelRequire("eUqFw");

var $53ciZ = parcelRequire("53ciZ");

var $eEzyV = parcelRequire("eEzyV");

var $guiFP = parcelRequire("guiFP");

var $1ybV0 = parcelRequire("1ybV0");

var $2OdyW = parcelRequire("2OdyW");

var $gd0Sp = parcelRequire("gd0Sp");
const $edad580f3eb6944a$var$JQL_REGEX_OLD = /(?:text ~ )(.*?)(?= AND .*| OR .*| ORDER BY .*|$)/;
const $edad580f3eb6944a$var$JQL_REGEX = /(?:summary ~ )(.*?)( OR description ~ )(.*?)(?= AND .*| OR .*| ORDER BY .*|$)/;
const $edad580f3eb6944a$export$26a66faebe7f7b65 = ({ jql: jql, wildcardAdded: wildcardAdded })=>{
    const { atlassianAccountId: atlassianAccountId } = (0, $gd0Sp.useTenantContext)();
    const request = (0, $eUqFw.useCallback)(async ()=>{
        if (!atlassianAccountId || !jql) return undefined;
        let searchString;
        if ((0, $1ybV0.ff)('nin_expose_text_option_jql_builder_4kwzo')) searchString = ($edad580f3eb6944a$var$JQL_REGEX.exec(jql)?.[1] || '').replaceAll('"', '');
        else searchString = ($edad580f3eb6944a$var$JQL_REGEX_OLD.exec(jql)?.[1] || '').replaceAll('"', '');
        if (wildcardAdded) // remove the wildcard from the search string
        searchString = searchString.slice(0, -1);
        const queryStr = (0, $53ciZ.stringify)({
            searchString: searchString,
            ignorePreference: true
        });
        return (0, $2OdyW.default)(`/rest/navigation/4/quicksearch?${queryStr}`);
    }, [
        atlassianAccountId,
        jql,
        wildcardAdded
    ]);
    const { loading: loading, error: error, data: data, fetch: fetch } = (0, $eEzyV.useService)(request);
    (0, $eUqFw.useEffect)(()=>{
        fetch();
    }, [
        fetch
    ]);
    const isSmartQuery = (0, $eUqFw.useMemo)(()=>{
        const quicksearchUrl = data?.url;
        if (quicksearchUrl) {
            // @ts-expect-error - The "comma" option requires query-string v6.4.0 or newer. JFE currently uses v5.1.1.
            const query = (0, $53ciZ.parse)(quicksearchUrl, {
                arrayFormat: 'comma'
            });
            if (query.quickSearchQuery !== undefined) return true;
        }
        return false;
    }, [
        data
    ]);
    (0, $eUqFw.useEffect)(()=>{
        if (error) (0, $guiFP.default)({
            meta: {
                id: 'quicksearchSmartQueryDisabledFetch',
                packageName: 'jiraIssueNavigatorFlags',
                teamName: 'empanada'
            },
            error: error
        });
    }, [
        error
    ]);
    return {
        loading: loading,
        error: error,
        data: data,
        fetch: fetch,
        isSmartQuery: isSmartQuery
    };
};
var $edad580f3eb6944a$export$2e2bcd8739ae039 = $edad580f3eb6944a$export$26a66faebe7f7b65;

});

const $6580074e500623eb$export$aead6163e23d2a49 = 'SMART_QUERY_DETECTED_FLAG_ID';

parcelRegister("dzTTP", function(module, exports) {

$parcel$export(module.exports, "default", () => $9deb8c78fc155cd6$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $9deb8c78fc155cd6$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    flagTitle: {
        "id": "issue-navigator-flags.smart-query-detected-flag.flag-title",
        "defaultMessage": "Trying to search using a smart query?"
    },
    flagDescription: {
        "id": "issue-navigator-flags.smart-query-detected-flag.flag-description",
        "defaultMessage": "Smart queries are turned off by default. You can enable them in your <strong>personal settings</strong>."
    },
    flagDontShowAgainAction: {
        "id": "issue-navigator-flags.smart-query-detected-flag.flag-dont-show-again-action",
        "defaultMessage": "Don\u2019t show me this again"
    }
});

});


parcelRegister("1HaD6", function(module, exports) {

$parcel$export(module.exports, "WildcardAddedFlag", () => $a8f095a1afd18c1e$export$cec045e2d66506ad);

var $eUqFw = parcelRequire("eUqFw");

var $eo17r = parcelRequire("eo17r");
var $k8Qyf = parcelRequire("k8Qyf");

var $5JgJ2 = parcelRequire("5JgJ2");

var $jMP2a = parcelRequire("jMP2a");
var $bFzGY = parcelRequire("bFzGY");

var $lB25E = parcelRequire("lB25E");

var $hBDw2 = parcelRequire("hBDw2");


var $gotF1 = parcelRequire("gotF1");
const $a8f095a1afd18c1e$var$flagId = (0, $eo17r.toFlagId)((0, $ad6bdd540a6e5dc0$export$8ba446e2fadf2828));
const $a8f095a1afd18c1e$var$useWildcardAddedFlag = ()=>{
    const { showFlag: showFlag, hasFlag: hasFlag } = (0, $k8Qyf.useFlagsService)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bFzGY.useAnalyticsEvents)();
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const displayFlag = (0, $eUqFw.useCallback)(()=>{
        if (!hasFlag?.($a8f095a1afd18c1e$var$flagId)) {
            showFlag({
                id: $a8f095a1afd18c1e$var$flagId,
                key: $a8f095a1afd18c1e$var$flagId,
                type: 'info',
                title: formatMessage((0, $gotF1.default).wildcardAddedFlagTitle),
                description: formatMessage((0, $gotF1.default).wildcardAddedFlagDescription),
                actions: [
                    {
                        content: (0, $gotF1.default).wildcardAddedFlagLearnMoreAction,
                        target: '_blank',
                        href: 'https://support.atlassian.com/jira-software-cloud/docs/search-for-issues-using-the-text-field/#Term-searches'
                    }
                ],
                testId: 'issue-navigator-flags.ui.wildcard-added-flag.smart-query-detected-flag'
            });
            (0, $jMP2a.fireUIAnalytics)(createAnalyticsEvent({}), 'wildcardAddedFlag shown');
        }
    }, [
        hasFlag,
        showFlag,
        createAnalyticsEvent,
        formatMessage
    ]);
    return {
        displayFlag: displayFlag
    };
};
const $a8f095a1afd18c1e$export$cec045e2d66506ad = ()=>{
    const { displayFlag: displayFlag } = $a8f095a1afd18c1e$var$useWildcardAddedFlag();
    const { update: updateWildcardShown } = (0, $hBDw2.useBooleanPreferenceSet)('user.query.wildcard.flag.dont.show');
    const [wildcardFlag, setWildcardFlag] = (0, $lB25E.useQueryParam)('wildcardFlag');
    const shouldShowFlag = wildcardFlag === 'true';
    (0, $eUqFw.useEffect)(()=>{
        if (shouldShowFlag) {
            displayFlag();
            updateWildcardShown();
            setWildcardFlag(undefined, 'replace');
        }
    }, [
        shouldShowFlag,
        displayFlag,
        setWildcardFlag,
        updateWildcardShown
    ]);
    return null;
};
var $a8f095a1afd18c1e$export$2e2bcd8739ae039 = $a8f095a1afd18c1e$export$cec045e2d66506ad;

});
const $ad6bdd540a6e5dc0$export$8ba446e2fadf2828 = 'WILDCARD_ADDED_FLAG_ID';

parcelRegister("gotF1", function(module, exports) {

$parcel$export(module.exports, "default", () => $27f02f69bc2094b6$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $27f02f69bc2094b6$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    wildcardAddedFlagLearnMoreAction: {
        "id": "issue-navigator-flags.wildcard-added-flag.wildcard-added-flag-learn-more-action",
        "defaultMessage": "Learn more about searching for issues"
    },
    wildcardAddedFlagDescription: {
        "id": "issue-navigator-flags.wildcard-added-flag.wildcard-added-flag-description",
        "defaultMessage": "Use a wildcard to return more relevant results and find the work you need."
    },
    wildcardAddedFlagTitle: {
        "id": "issue-navigator-flags.wildcard-added-flag.wildcard-added-flag-title",
        "defaultMessage": "We've added a wildcard (*) to your query"
    }
});

});


parcelRegister("3wKQY", function(module, exports) {

$parcel$export(module.exports, "createRememoizeSelector", () => $5765d28cb6e68fa6$export$982d75deeca693ef);
$parcel$export(module.exports, "isNormalClick", () => $5765d28cb6e68fa6$export$729f3684d5c2b9b9);
$parcel$export(module.exports, "isNonNullish", () => $5765d28cb6e68fa6$export$70573498ee17fe1d);
$parcel$export(module.exports, "parseIssueNavigatorViewIdOrDefault", () => $5765d28cb6e68fa6$export$ad0c80ba9128e83a);
$parcel$export(module.exports, "isFilterViewId", () => $5765d28cb6e68fa6$export$194f1a1e890054c9);
$parcel$export(module.exports, "convertToIssueNavigatorId", () => $5765d28cb6e68fa6$export$6ce707b3eccb341d);
$parcel$export(module.exports, "convertToView", () => $5765d28cb6e68fa6$export$95ef66082092aa68);
$parcel$export(module.exports, "convertFilterIdToIssueNavigatorId", () => $5765d28cb6e68fa6$export$ec4f6e9ea23bb55d);

var $df4Sl = parcelRequire("df4Sl");

var $jccNB = parcelRequire("jccNB");
const $5765d28cb6e68fa6$export$982d75deeca693ef = (0, $df4Sl.createSelectorCreator)((0, $df4Sl.defaultMemoize), // @ts-expect-error - TS2339 - Property '_rememoize' does not exist on type 'T'. | TS2339 - Property '_rememoize' does not exist on type 'T'.
(a, b)=>a._rememoize === b._rememoize);
const $5765d28cb6e68fa6$export$729f3684d5c2b9b9 = (e)=>!(e.button || e.metaKey || e.altKey || e.ctrlKey || e.shiftKey);
function $5765d28cb6e68fa6$var$isPossibleValueEntry(entry) {
    return typeof entry[1] === 'string' || typeof entry[1] === 'number' || Array.isArray(entry[1]) && entry[1].length > 0;
}
const $5765d28cb6e68fa6$export$20fba0bc14771b28 = (state)=>{
    const definedEntries = Object.entries(state).filter($5765d28cb6e68fa6$var$isPossibleValueEntry);
    return definedEntries.map((entry)=>({
            key: entry[0],
            value: Array.isArray(entry[1]) ? entry[1].map((values)=>values.value) : entry[1]
        }));
};
const $5765d28cb6e68fa6$export$6256478a5735e738 = (state)=>// eslint-disable-next-line @typescript-eslint/no-explicit-any
    Object.keys(state).reduce((acc, key)=>{
        const value = state[key];
        if (key === 'search') {
            if (typeof value !== 'string') throw new Error('Unexpected non-string literal for search.');
            acc[key] = value;
        } else if (Array.isArray(value)) acc[key] = value.map((values)=>values.value);
        else if (typeof value === 'string' || typeof value === 'undefined') acc[key] = value || [];
        else acc[key] = value;
        return acc;
    }, {});
const $5765d28cb6e68fa6$export$28dade55d1b3964b = (viewId)=>viewId === 'detail' ? (0, $jccNB.views).detail : (0, $jccNB.views).list;
const $5765d28cb6e68fa6$export$587f73d78d2a7579 = (viewMode)=>viewMode === (0, $jccNB.views).detail ? 'detail' : 'list_default';
const $5765d28cb6e68fa6$export$5786a571e562003d = (viewMode)=>viewMode === (0, $jccNB.views).detail ? 'DETAIL' : 'LIST';
function $5765d28cb6e68fa6$export$70573498ee17fe1d(value) {
    return value != null;
}
const $5765d28cb6e68fa6$export$ad0c80ba9128e83a = (viewId, defaultValue = 'list_default')=>{
    if (!viewId) return defaultValue;
    switch(viewId){
        case 'list_default':
            return 'list_default';
        case 'list_system':
            return 'list_system';
        case 'detail':
            return 'detail';
        default:
            if ($5765d28cb6e68fa6$export$194f1a1e890054c9(viewId)) // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            return viewId;
            return defaultValue;
    }
};
const $5765d28cb6e68fa6$export$194f1a1e890054c9 = (viewId)=>/^list_filter_\d+$/.test(viewId);
const $5765d28cb6e68fa6$export$6ce707b3eccb341d = (view)=>view === (0, $jccNB.views).detail ? 'detail' : 'list_default';
const $5765d28cb6e68fa6$export$95ef66082092aa68 = (issueNavigatorViewId)=>issueNavigatorViewId === 'detail' ? (0, $jccNB.views).detail : (0, $jccNB.views).list;
const $5765d28cb6e68fa6$export$ec4f6e9ea23bb55d = (filterId)=>{
    if (typeof filterId === 'number') return `list_filter_${filterId}`;
    const filterIdInt = Number(filterId);
    if (Number.isNaN(filterIdInt)) throw new Error('filterId is invalid');
    return `list_filter_${filterIdInt}`;
};

});

parcelRegister("kHSe2", function(module, exports) {

$parcel$export(module.exports, "default", () => $4e20441cdc9f3e69$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $1lXFP = parcelRequire("1lXFP");

var $aR8n6 = parcelRequire("aR8n6");

var $1ybV0 = parcelRequire("1ybV0");

var $5jdgn = parcelRequire("5jdgn");

var $5as0a = parcelRequire("5as0a");

var $cHJdq = parcelRequire("cHJdq");

var $jBY8A = parcelRequire("jBY8A");

var $cWCvn = parcelRequire("cWCvn");

var $eMGKM = parcelRequire("eMGKM");

var $gGtKh = parcelRequire("gGtKh");

var $8WuJm = parcelRequire("8WuJm");

var $5yh8X = parcelRequire("5yh8X");

var $7vf5z = parcelRequire("7vf5z");

var $buJlM = parcelRequire("buJlM");

var $cWgoa = parcelRequire("cWgoa");

var $cCQm1 = parcelRequire("cCQm1");

var $kKpAY = parcelRequire("kKpAY");

var $fO5rB = parcelRequire("fO5rB");

var $iJHZm = parcelRequire("iJHZm");
const $4e20441cdc9f3e69$var$AsyncGlobalIssueNavigatorWrapper = ({ filter: filter, jql: jqlParam, initialised: initialised, view: view, ...props })=>{
    const onMutateJqlParam = (0, $eMGKM.useUpdateUrlQueryParamCallback)('jql');
    const defaultJql = (0, $cCQm1.getDefaultJqlGin)();
    const jql = (0, $eMGKM.getJqlFromParamValues)(defaultJql, jqlParam, filter, undefined, onMutateJqlParam);
    const searchInput = (0, $eUqFw.useMemo)(()=>(0, $eMGKM.getSearchInput)(jql, filter), [
        jql,
        filter
    ]);
    const filterForAnalytics = filter && (0, $5as0a.isFilterId)(filter) ? filter : 'default';
    const attributes = {
        navigatorScope: 'global',
        viewLayout: view || '',
        // jql='' is a valid jql parameter, so we track empty jql
        jql: jqlParam !== undefined,
        filter: filterForAnalytics,
        ...(0, $jBY8A.getIssueNavigatorFFAndFG)()
    };
    const extraInfo = {
        scope: 'global',
        filterId: filterForAnalytics,
        isJqlParamPresent: !!jqlParam,
        ...attributes
    };
    const response = (0, $buJlM.useRelayResource)((0, $cWgoa.issueNavigatorRelayResource));
    const { queryReference: queryReference } = response;
    const filterResponse = (0, $buJlM.useRelayResource)((0, $cWgoa.issueNavigatorFilterRelayResource));
    const filterQueryReference = filterResponse.queryReference;
    // During SSR our issueNavigatorRelayResource must wait until the query finishes before returning the
    // queryReference as SSR does not support Suspense. We return the page skeleton as an intermediary state until
    // the query has resolved (or SSR times out and the query is loaded on the client).
    if (queryReference == null) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $kKpAY.GlobalIssueNavigatorSkeleton), null);
    // During SSR our issueNavigatorFilterRelayResource must wait until the query finishes before returning the
    // queryReference as SSR does not support Suspense. We return the page skeleton as an intermediary state until
    // the query has resolved (or SSR times out and the query is loaded on the client).
    if (filterQueryReference == null) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $kKpAY.GlobalIssueNavigatorSkeleton), null);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8WuJm.ContextualAnalyticsData), {
        attributes: attributes,
        ...filter !== null && filter !== undefined && (0, $5as0a.isFilterId)(filter) && {
            containers: {
                issueFilter: {
                    id: filter
                }
            }
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $aR8n6.default), {
        id: "unhandled",
        packageName: "jiraSpaAppsGlobalIssueNavigator",
        teamName: "empanada",
        sendToPrivacyUnsafeSplunk: true,
        attributes: (0, $1lXFP.isLoaderErrorAttributes)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gGtKh.default), {
        name: "global-issue-navigator-app",
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $kKpAY.GlobalIssueNavigatorSkeleton), null)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $cHJdq.EnableNinChangeboardingProvider), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5jdgn.default), {
        ...props,
        searchInput: searchInput,
        defaultJql: defaultJql,
        queryReference: queryReference || undefined,
        filterQueryReference: filterQueryReference || undefined
    })))), initialised && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7vf5z.default), {
        appName: "global-issue-navigator",
        isExpectedToHaveSsr: true,
        withMarks: [
            (0, $5yh8X.appBundleReadyMark),
            (0, $5yh8X.prefetchApiReadyMark)
        ],
        ttrSlo: 3000,
        ttiSlo: 4000,
        extra: extraInfo,
        metric: (0, $cWCvn.NINPageLoad),
        emitOnAnimationFrame: (0, $1ybV0.ff)('bm3.emit-on-raf.top-experiences')
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $iJHZm.SpaStatePageReady), null)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $fO5rB.SubProductUpdater), {
        subProduct: "platform"
    }));
};
var $4e20441cdc9f3e69$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, $eUqFw.memo)($4e20441cdc9f3e69$var$AsyncGlobalIssueNavigatorWrapper);

});
parcelRegister("1lXFP", function(module, exports) {

$parcel$export(module.exports, "isLoaderErrorAttributes", () => $1c31f74fac112a78$export$c7209ce2e0d060ea);

var $7rh0R = parcelRequire("7rh0R");
const $1c31f74fac112a78$export$c7209ce2e0d060ea = (error)=>({
        isLoaderError: (0, $7rh0R.isLoaderError)(error)
    });

});

parcelRegister("5jdgn", function(module, exports) {

$parcel$export(module.exports, "default", () => $8432292afd325e2b$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $8GfI5 = parcelRequire("8GfI5");

var $5INU9 = parcelRequire("5INU9");

var $51WJq = parcelRequire("51WJq");
const $8432292afd325e2b$var$GlobalIssueNavigator = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8GfI5.default), {
        CustomHeader: (0, $51WJq.default),
        HeaderSkeletonImage: (0, $5INU9.GlobalIssueNavigatorHeaderSkeleton),
        isFeedbackButtonDisabled: true,
        ...props
    });
var $8432292afd325e2b$export$2e2bcd8739ae039 = $8432292afd325e2b$var$GlobalIssueNavigator;

});
parcelRegister("8GfI5", function(module, exports) {

$parcel$export(module.exports, "default", () => $8432ffc32f4cd4cc$export$2e2bcd8739ae039);

var $2ktFK = parcelRequire("2ktFK");

var $fI66u = parcelRequire("fI66u");

var $bzxxY = parcelRequire("bzxxY");

var $lk02k = parcelRequire("lk02k");

var $1zgpM = parcelRequire("1zgpM");

var $k7wca = parcelRequire("k7wca");

var $eUqFw = parcelRequire("eUqFw");

var $iWLL0 = parcelRequire("iWLL0");

var $1ybV0 = parcelRequire("1ybV0");

var $b2n8w = parcelRequire("b2n8w");

var $jccNB = parcelRequire("jccNB");

var $cWCvn = parcelRequire("cWCvn");

var $651im = parcelRequire("651im");

var $1ydM0 = parcelRequire("1ydM0");

var $3mEVr = parcelRequire("3mEVr");

var $dCaOY = parcelRequire("dCaOY");

var $cQBUE = parcelRequire("cQBUE");

var $8CJEL = parcelRequire("8CJEL");

var $jtc88 = parcelRequire("jtc88");
const $8432ffc32f4cd4cc$export$e111e6466962b82b = (0, $k7wca.default);
// We memo as an optimisation to reduce forced re-renders when the immediate parent renders. In this case it's
// AppContextualAnalytics which will re-render when interacting with the JQL builder, e.g. opening picker.
const $8432ffc32f4cd4cc$var$FilterAndJqlProvider = /*#__PURE__*/ (0, $eUqFw.memo)(({ children: children, jql: jql, refetch: refetch, filterId: filterId, isFilterEditable: isFilterEditable, filterJql: filterJql })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $dCaOY.FilterQueryProvider), {
        query: $8432ffc32f4cd4cc$export$e111e6466962b82b,
        refetch: refetch,
        filterId: filterId
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $3mEVr.ActiveJqlProvider), {
        filterId: filterId,
        filterJql: filterJql,
        jql: jql,
        isFilterEditable: isFilterEditable
    }, children)));
const $8432ffc32f4cd4cc$var$getFilter = (searchParam)=>{
    if (searchParam?.type === (0, $jccNB.SearchInputTypes).JQL) return undefined;
    return searchParam.type === (0, $jccNB.SearchInputTypes).FILTER_AND_JQL ? searchParam.filter : searchParam;
};
const $8432ffc32f4cd4cc$var$IssueNavigator = ({ issueKey: issueKey, queryReference: queryReference, filterQueryReference: filterQueryReference, CustomHeader: CustomHeader, ActionMenu: ActionMenu, HeaderSkeletonImage: HeaderSkeletonImage, onChangeIssue: onChangeIssue, onChangeFilter: onChangeFilter, onRefinement: onRefinement, onChangePage: onChangePage, onPageDataLoad: onPageDataLoad, onChangeColumnConfiguration: onChangeColumnConfiguration, onChangeJql: onChangeJql, onSetView: onSetView, defaultJql: defaultJql, searchInput: searchInput, jqlBuilderProps: jqlBuilderProps, isFeedbackButtonDisabled: isFeedbackButtonDisabled, issueTableProps: issueTableProps })=>{
    (0, $cWCvn.markOnce)((0, $cWCvn.marks).ISSUE_NAVIGATOR_START);
    (0, $eUqFw.useLayoutEffect)(()=>{
        (0, $cWCvn.markOnce)((0, $cWCvn.marks).ISSUE_NAVIGATOR_END);
    }, []);
    const filterInput = searchInput ? $8432ffc32f4cd4cc$var$getFilter(searchInput) : undefined;
    const issueQuery = (0, $iWLL0.usePreloadedQuery)((0, $1zgpM.default), queryReference);
    /* eslint-disable @atlassian/relay/unused-fields */ const [resultsData, refetchIssues] = (0, $iWLL0.useRefetchableFragment)((0, $lk02k.default), issueQuery);
    /* eslint-enable @atlassian/relay/unused-fields */ const userPreferencesData = (0, $iWLL0.useFragment)((0, $bzxxY.default), issueQuery.jira?.userPreferences ?? null);
    const jqlBuilderWithAiData = (0, $iWLL0.useFragment)((0, $fI66u.default), // @ts-expect-error - No overload matches this call.
    issueQuery.jira);
    const issueResultsData = resultsData.jira?.issueSearchStable ?? null;
    const viewData = resultsData.jira?.issueSearchViewByNamespaceAndViewId ?? null;
    const viewResultData = resultsData.jira?.issueSearchViewResult ?? null;
    const filterQuery = (0, $iWLL0.usePreloadedQuery)($8432ffc32f4cd4cc$export$e111e6466962b82b, filterQueryReference);
    /* eslint-disable @atlassian/relay/must-colocate-fragment-spreads */ const [filterData, refetchFilter] = (0, $iWLL0.useRefetchableFragment)((0, $2ktFK.default), filterQuery);
    /*
   * IssueSearchQueryProvider and SelectedViewContainer expect viewData as a JiraIssueSearchView | null type.
   * When viewResultData is a QueryError, we null it so it receives the expected type.
   */ let issueSearchViewData = null;
    if ((0, $1ybV0.ff)('handle-404-filter-errors-gracefully-in-the-ui-by-showing-filter-not-found-view_t3d2m')) issueSearchViewData = viewResultData?.__typename === 'JiraIssueSearchView' ? viewResultData : null;
    else issueSearchViewData = viewData;
    /* eslint-enable @atlassian/relay/must-colocate-fragment-spreads */ return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $651im.AppContextualAnalytics), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($8432ffc32f4cd4cc$var$FilterAndJqlProvider, {
        refetch: refetchFilter,
        filterId: filterInput?.type === (0, $jccNB.FilterTypes).ID ? filterInput?.value : undefined,
        filterJql: filterInput?.type === (0, $jccNB.FilterTypes).JQL ? filterInput?.value : filterData?.jira?.filter?.jql,
        isFilterEditable: filterData.jira?.filter?.isEditable !== null ? filterData.jira?.filter?.isEditable : undefined,
        jql: searchInput?.type === (0, $jccNB.SearchInputTypes).FILTER_AND_JQL || searchInput?.type === (0, $jccNB.SearchInputTypes).JQL ? searchInput?.jql : undefined
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $cQBUE.IssueSearchQueryProvider), {
        refetch: refetchIssues,
        issueResults: issueResultsData,
        view: issueSearchViewData,
        query: (0, $b2n8w.default),
        onPageDataLoad: onPageDataLoad,
        onChangePage: onChangePage
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $jtc88.SelectedViewContainer), {
        onSetView: onSetView,
        fragment: issueSearchViewData
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1ydM0.SelectedIssueContainer), {
        selectedIssueKey: issueKey,
        onChange: onChangeIssue,
        issueResults: issueResultsData
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8CJEL.default), {
        CustomHeader: CustomHeader,
        ActionMenu: ActionMenu,
        HeaderSkeletonImage: HeaderSkeletonImage,
        filter: filterData?.jira?.filter ?? null,
        onChangeIssue: onChangeIssue,
        onChangeFilter: onChangeFilter,
        onPageDataLoad: onPageDataLoad,
        onChangeColumnConfiguration: onChangeColumnConfiguration,
        onChangeJql: onChangeJql,
        onRefinement: onRefinement,
        defaultJql: defaultJql,
        issueResults: issueResultsData,
        view: viewData,
        viewResult: viewResultData,
        userPreferences: userPreferencesData,
        jqlBuilderProps: jqlBuilderProps,
        jqlBuilderWithAiKey: jqlBuilderWithAiData,
        isFeedbackButtonDisabled: isFeedbackButtonDisabled,
        issueTableProps: issueTableProps
    }))))));
};
var $8432ffc32f4cd4cc$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, $eUqFw.memo)($8432ffc32f4cd4cc$var$IssueNavigator);

});
parcelRegister("2ktFK", function(module, exports) {

$parcel$export(module.exports, "default", () => $7169b3b90081b930$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<50c8e9868b3e511de3ea4f420144c717>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck

var $9dp8J = parcelRequire("9dp8J");
const $7169b3b90081b930$var$node = {
    "argumentDefinitions": [
        {
            "kind": "RootArgument",
            "name": "filterAri"
        },
        {
            "kind": "RootArgument",
            "name": "includeFilter"
        }
    ],
    "kind": "Fragment",
    "metadata": {
        "refetch": {
            "fragmentPathInResult": [],
            "operation": (0, $9dp8J.default)
        }
    },
    "name": "main_issueNavigator_IssueNavigator_filterQuery",
    "selections": [
        {
            "concreteType": "JiraQuery",
            "kind": "LinkedField",
            "name": "jira",
            "plural": false,
            "selections": [
                {
                    "condition": "includeFilter",
                    "kind": "Condition",
                    "passingValue": true,
                    "selections": [
                        {
                            "args": [
                                {
                                    "kind": "Variable",
                                    "name": "id",
                                    "variableName": "filterAri"
                                }
                            ],
                            "kind": "LinkedField",
                            "name": "filter",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "jql"
                                },
                                {
                                    "kind": "InlineFragment",
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "isEditable"
                                        }
                                    ],
                                    "type": "JiraCustomFilter"
                                },
                                {
                                    "kind": "FragmentSpread",
                                    "name": "main_issueNavigator_Header_filter"
                                },
                                {
                                    "kind": "FragmentSpread",
                                    "name": "topBar_issueNavigator_filter"
                                },
                                {
                                    "kind": "FragmentSpread",
                                    "name": "jqlBuilder_issueNavigator_JQLBuilderWrapper_filter"
                                },
                                {
                                    "kind": "FragmentSpread",
                                    "name": "main_issueNavigator_ListView_filter"
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    ],
    "type": "Query"
};
$7169b3b90081b930$var$node.hash = "26da718314f181d4824f62928229af2b";
var $7169b3b90081b930$export$2e2bcd8739ae039 = $7169b3b90081b930$var$node;

});
parcelRegister("9dp8J", function(module, exports) {

$parcel$export(module.exports, "default", () => $e1f2570326db46ca$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<0913b38543a4ac835cf7eeb194420fa3>>
 * @relayHash d4259e050915cf8816f8c8a4884d4afb
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID fa55db43feb181a2ea2d08440aa1fca705fd8ddbbea5388f6c28457a3933a61e
const $e1f2570326db46ca$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "filterAri"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "includeFilter"
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "FilterRefetchQuery",
            "selections": [
                {
                    "kind": "FragmentSpread",
                    "name": "main_issueNavigator_IssueNavigator_filterQuery"
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "FilterRefetchQuery",
            "selections": [
                {
                    "concreteType": "JiraQuery",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "condition": "includeFilter",
                            "kind": "Condition",
                            "passingValue": true,
                            "selections": [
                                {
                                    "args": [
                                        {
                                            "kind": "Variable",
                                            "name": "id",
                                            "variableName": "filterAri"
                                        }
                                    ],
                                    "kind": "LinkedField",
                                    "name": "filter",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "__typename"
                                        },
                                        {
                                            "kind": "TypeDiscriminator",
                                            "abstractKey": "__isJiraFilter"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "jql"
                                        },
                                        {
                                            "kind": "InlineFragment",
                                            "selections": [
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "isEditable"
                                                }
                                            ],
                                            "type": "JiraCustomFilter"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "filterId"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "name"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "isFavourite"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "id"
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "fa55db43feb181a2ea2d08440aa1fca705fd8ddbbea5388f6c28457a3933a61e",
            "metadata": {},
            "name": "FilterRefetchQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$e1f2570326db46ca$var$node.hash = "26da718314f181d4824f62928229af2b";
var $e1f2570326db46ca$export$2e2bcd8739ae039 = $e1f2570326db46ca$var$node;

});


parcelRegister("fI66u", function(module, exports) {

$parcel$export(module.exports, "default", () => $011baa0df1c255ea$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<9b849f64e4a61be907eaec3accbf05bb>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $011baa0df1c255ea$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "main_issueNavigator_IssueNavigator_jira",
    "selections": [
        {
            "kind": "FragmentSpread",
            "name": "main_issueNavigator_IssueNavigatorUI_jqlBuilderWithAiKey"
        }
    ],
    "type": "JiraQuery"
};
$011baa0df1c255ea$var$node.hash = "e871bd0eb341a6573bd1df76ea8e5df1";
var $011baa0df1c255ea$export$2e2bcd8739ae039 = $011baa0df1c255ea$var$node;

});

parcelRegister("bzxxY", function(module, exports) {

$parcel$export(module.exports, "default", () => $6c1adef7b0668deb$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<1ecec124bc87c6002f2c45127804b4c1>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $6c1adef7b0668deb$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "main_issueNavigator_IssueNavigator_userPreferences",
    "selections": [
        {
            "kind": "FragmentSpread",
            "name": "main_issueNavigator_IssueNavigatorUI_userPreferences"
        }
    ],
    "type": "JiraUserPreferences"
};
$6c1adef7b0668deb$var$node.hash = "1143e00ad7112d3bc319370b0e0a4b27";
var $6c1adef7b0668deb$export$2e2bcd8739ae039 = $6c1adef7b0668deb$var$node;

});

parcelRegister("lk02k", function(module, exports) {

$parcel$export(module.exports, "default", () => $efaadc155685505c$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<cfe123c1dd5771714f6f164d987c2df3>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck

var $b2n8w = parcelRequire("b2n8w");
const $efaadc155685505c$var$node = function() {
    var v0 = {
        "kind": "Variable",
        "name": "cloudId",
        "variableName": "cloudId"
    }, v1 = [
        v0 /*: any*/ ,
        {
            "kind": "Variable",
            "name": "filterId",
            "variableName": "filterId"
        },
        {
            "kind": "Variable",
            "name": "namespace",
            "variableName": "namespace"
        },
        {
            "kind": "Variable",
            "name": "viewId",
            "variableName": "viewId"
        }
    ], v2 = {
        "kind": "FragmentSpread",
        "name": "issueSearchQuery_issueNavigator_IssueSearchQueryProvider_view"
    }, v3 = {
        "kind": "FragmentSpread",
        "name": "selectedView_issueNavigator_SelectedViewContainer"
    };
    return {
        "argumentDefinitions": [
            {
                "kind": "RootArgument",
                "name": "__relay_internal__pv__atlassianjirarelayprovidersrcissuesearchviewresultrelayprovider"
            },
            {
                "kind": "RootArgument",
                "name": "after"
            },
            {
                "kind": "RootArgument",
                "name": "amountOfColumns"
            },
            {
                "kind": "RootArgument",
                "name": "before"
            },
            {
                "kind": "RootArgument",
                "name": "cloudId"
            },
            {
                "kind": "RootArgument",
                "name": "fieldSetIds"
            },
            {
                "kind": "RootArgument",
                "name": "filterId"
            },
            {
                "kind": "RootArgument",
                "name": "first"
            },
            {
                "kind": "RootArgument",
                "name": "issueSearchInput"
            },
            {
                "kind": "RootArgument",
                "name": "last"
            },
            {
                "kind": "RootArgument",
                "name": "namespace"
            },
            {
                "kind": "RootArgument",
                "name": "options"
            },
            {
                "kind": "RootArgument",
                "name": "queryStatusForIssuekeyStrikethrough"
            },
            {
                "kind": "RootArgument",
                "name": "shouldQueryFieldSetsById"
            },
            {
                "kind": "RootArgument",
                "name": "viewId"
            }
        ],
        "kind": "Fragment",
        "metadata": {
            "refetch": {
                "fragmentPathInResult": [],
                "operation": (0, $b2n8w.default)
            }
        },
        "name": "main_issueNavigator_IssueNavigator_issueQuery",
        "selections": [
            {
                "concreteType": "JiraQuery",
                "kind": "LinkedField",
                "name": "jira",
                "plural": false,
                "selections": [
                    {
                        "args": [
                            {
                                "kind": "Variable",
                                "name": "after",
                                "variableName": "after"
                            },
                            {
                                "kind": "Variable",
                                "name": "before",
                                "variableName": "before"
                            },
                            v0 /*: any*/ ,
                            {
                                "kind": "Variable",
                                "name": "first",
                                "variableName": "first"
                            },
                            {
                                "kind": "Variable",
                                "name": "issueSearchInput",
                                "variableName": "issueSearchInput"
                            },
                            {
                                "kind": "Variable",
                                "name": "last",
                                "variableName": "last"
                            },
                            {
                                "kind": "Variable",
                                "name": "options",
                                "variableName": "options"
                            }
                        ],
                        "concreteType": "JiraIssueConnection",
                        "kind": "LinkedField",
                        "name": "issueSearchStable",
                        "plural": false,
                        "selections": [
                            {
                                "concreteType": "JiraIssueEdge",
                                "kind": "LinkedField",
                                "name": "edges",
                                "plural": true,
                                "selections": [
                                    {
                                        "concreteType": "JiraIssue",
                                        "kind": "LinkedField",
                                        "name": "node",
                                        "plural": false,
                                        "selections": [
                                            {
                                                "kind": "ScalarField",
                                                "name": "key"
                                            }
                                        ]
                                    }
                                ]
                            },
                            {
                                "kind": "FragmentSpread",
                                "name": "issueSearchQuery_issueNavigator_IssueSearchQueryProvider_issueResults"
                            },
                            {
                                "kind": "FragmentSpread",
                                "name": "selectedIssueState_issueNavigator_SelectedIssueContainer"
                            },
                            {
                                "kind": "FragmentSpread",
                                "name": "main_issueNavigator_IssueNavigatorUI_issueResults"
                            }
                        ]
                    },
                    {
                        "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcissuesearchviewresultrelayprovider",
                        "kind": "Condition",
                        "passingValue": false,
                        "selections": [
                            {
                                "args": v1 /*: any*/ ,
                                "concreteType": "JiraIssueSearchView",
                                "kind": "LinkedField",
                                "name": "issueSearchViewByNamespaceAndViewId",
                                "plural": false,
                                "selections": [
                                    v2 /*: any*/ ,
                                    v3 /*: any*/ ,
                                    {
                                        "kind": "FragmentSpread",
                                        "name": "main_issueNavigator_IssueNavigatorUI_view"
                                    }
                                ]
                            }
                        ]
                    },
                    {
                        "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcissuesearchviewresultrelayprovider",
                        "kind": "Condition",
                        "passingValue": true,
                        "selections": [
                            {
                                "args": v1 /*: any*/ ,
                                "kind": "LinkedField",
                                "name": "issueSearchViewResult",
                                "plural": false,
                                "selections": [
                                    {
                                        "kind": "InlineFragment",
                                        "selections": [
                                            {
                                                "kind": "ScalarField",
                                                "name": "__typename"
                                            },
                                            v2 /*: any*/ ,
                                            v3 /*: any*/ 
                                        ],
                                        "type": "JiraIssueSearchView"
                                    },
                                    {
                                        "kind": "FragmentSpread",
                                        "name": "main_issueNavigator_IssueNavigatorUI_viewResult"
                                    }
                                ]
                            }
                        ]
                    }
                ]
            }
        ],
        "type": "Query"
    };
}();
$efaadc155685505c$var$node.hash = "26781166e998baf3bd27efa514147837";
var $efaadc155685505c$export$2e2bcd8739ae039 = $efaadc155685505c$var$node;

});
parcelRegister("b2n8w", function(module, exports) {

$parcel$export(module.exports, "default", () => $5dc6948a5a3de181$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<8b765c8577f7fb07c5601b8dd5c99e53>>
 * @relayHash 1823b2e92a4adfb747ed76a297c1a715
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 1915f89f81c6650603b9a50fb9b7f5596c54549f0c7e5c1eeb34512d71a1b148

var $dbXJb = parcelRequire("dbXJb");

var $alD35 = parcelRequire("alD35");

var $91oFA = parcelRequire("91oFA");

var $lWCGp = parcelRequire("lWCGp");

var $kpHqV = parcelRequire("kpHqV");

var $fY4Nv = parcelRequire("fY4Nv");
const $5dc6948a5a3de181$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "after"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "amountOfColumns"
    }, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "before"
    }, v3 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "cloudId"
    }, v4 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "fieldSetIds"
    }, v5 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "filterId"
    }, v6 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "first"
    }, v7 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "isIssueSearchViewResultEnabled"
    }, v8 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "issueSearchInput"
    }, v9 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "last"
    }, v10 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "namespace"
    }, v11 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "options"
    }, v12 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "queryStatusForIssuekeyStrikethrough"
    }, v13 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "shouldQueryFieldSetsById"
    }, v14 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "viewId"
    }, v15 = {
        "kind": "Variable",
        "name": "cloudId",
        "variableName": "cloudId"
    }, v16 = {
        "kind": "ScalarField",
        "name": "key"
    }, v17 = {
        "kind": "ScalarField",
        "name": "id"
    }, v18 = {
        "kind": "Variable",
        "name": "filterId",
        "variableName": "filterId"
    }, v19 = {
        "kind": "Variable",
        "name": "first",
        "variableName": "amountOfColumns"
    }, v20 = {
        "kind": "Variable",
        "name": "namespace",
        "variableName": "namespace"
    }, v21 = {
        "kind": "Variable",
        "name": "viewId",
        "variableName": "viewId"
    }, v22 = [
        v18 /*: any*/ ,
        v19 /*: any*/ ,
        v20 /*: any*/ ,
        v21 /*: any*/ 
    ], v23 = {
        "kind": "ScalarField",
        "name": "__typename"
    }, v24 = {
        "kind": "ScalarField",
        "name": "fieldId"
    }, v25 = {
        "kind": "ScalarField",
        "name": "name"
    }, v26 = {
        "kind": "ScalarField",
        "name": "text"
    }, v27 = {
        "kind": "ScalarField",
        "name": "picture"
    }, v28 = {
        "concreteType": "JiraAvatar",
        "kind": "LinkedField",
        "name": "avatar",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "small"
            }
        ]
    }, v29 = {
        "kind": "ScalarField",
        "name": "statusCategoryId"
    }, v30 = {
        "concreteType": "JiraStatusCategory",
        "kind": "LinkedField",
        "name": "statusCategory",
        "plural": false,
        "selections": [
            v29 /*: any*/ ,
            v17 /*: any*/ 
        ]
    }, v31 = [
        {
            "kind": "Variable",
            "name": "fieldSetIds",
            "variableName": "fieldSetIds"
        },
        v19 /*: any*/ 
    ], v32 = {
        "kind": "ScalarField",
        "name": "type"
    }, v33 = {
        "kind": "ScalarField",
        "name": "fieldSetId"
    }, v34 = {
        "kind": "TypeDiscriminator",
        "abstractKey": "__isJiraIssueField"
    }, v35 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "concreteType": "JiraAffectedServiceConnection",
                "kind": "LinkedField",
                "name": "selectedAffectedServicesConnection",
                "plural": false,
                "selections": [
                    {
                        "concreteType": "JiraAffectedServiceEdge",
                        "kind": "LinkedField",
                        "name": "edges",
                        "plural": true,
                        "selections": [
                            {
                                "concreteType": "JiraAffectedService",
                                "kind": "LinkedField",
                                "name": "node",
                                "plural": false,
                                "selections": [
                                    {
                                        "kind": "ScalarField",
                                        "name": "serviceId"
                                    },
                                    v25 /*: any*/ 
                                ]
                            }
                        ]
                    }
                ]
            }
        ],
        "type": "JiraAffectedServicesField"
    }, v36 = {
        "kind": "ScalarField",
        "name": "message"
    }, v37 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "concreteType": "JiraCmdbObjectConnection",
                "kind": "LinkedField",
                "name": "selectedCmdbObjectsConnection",
                "plural": false,
                "selections": [
                    {
                        "concreteType": "JiraCmdbObjectEdge",
                        "kind": "LinkedField",
                        "name": "edges",
                        "plural": true,
                        "selections": [
                            {
                                "concreteType": "JiraCmdbObject",
                                "kind": "LinkedField",
                                "name": "node",
                                "plural": false,
                                "selections": [
                                    {
                                        "kind": "ScalarField",
                                        "name": "objectId"
                                    },
                                    {
                                        "kind": "ScalarField",
                                        "name": "label"
                                    },
                                    {
                                        "concreteType": "JiraCmdbAvatar",
                                        "kind": "LinkedField",
                                        "name": "avatar",
                                        "plural": false,
                                        "selections": [
                                            {
                                                "kind": "ScalarField",
                                                "name": "url48"
                                            }
                                        ]
                                    }
                                ]
                            }
                        ]
                    },
                    {
                        "concreteType": "QueryError",
                        "kind": "LinkedField",
                        "name": "errors",
                        "plural": true,
                        "selections": [
                            v36 /*: any*/ 
                        ]
                    }
                ]
            }
        ],
        "type": "JiraCMDBField"
    }, v38 = [
        v25 /*: any*/ ,
        v17 /*: any*/ 
    ], v39 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "concreteType": "JiraComponentConnection",
                "kind": "LinkedField",
                "name": "selectedComponentsConnection",
                "plural": false,
                "selections": [
                    {
                        "concreteType": "JiraComponentEdge",
                        "kind": "LinkedField",
                        "name": "edges",
                        "plural": true,
                        "selections": [
                            {
                                "concreteType": "JiraComponent",
                                "kind": "LinkedField",
                                "name": "node",
                                "plural": false,
                                "selections": v38 /*: any*/ 
                            }
                        ]
                    }
                ]
            }
        ],
        "type": "JiraComponentsField"
    }, v40 = {
        "concreteType": "JiraFieldConfig",
        "kind": "LinkedField",
        "name": "fieldConfig",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "isRequired"
            }
        ]
    }, v41 = {
        "kind": "ClientExtension",
        "selections": [
            {
                "kind": "ScalarField",
                "name": "lazyIsEditableInIssueView"
            }
        ]
    }, v42 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "kind": "ScalarField",
                "name": "date"
            },
            v25 /*: any*/ ,
            v40 /*: any*/ ,
            v41 /*: any*/ 
        ],
        "type": "JiraDatePickerField"
    }, v43 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "kind": "ScalarField",
                "name": "dateTime"
            }
        ],
        "type": "JiraDateTimePickerField"
    }, v44 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "concreteType": "JiraEpic",
                "kind": "LinkedField",
                "name": "epic",
                "plural": false,
                "selections": [
                    v16 /*: any*/ ,
                    {
                        "kind": "ScalarField",
                        "name": "summary"
                    },
                    {
                        "kind": "ScalarField",
                        "name": "color"
                    },
                    v17 /*: any*/ 
                ]
            }
        ],
        "type": "JiraEpicLinkField"
    }, v45 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "kind": "ScalarField",
                "name": "renderedFieldHtml"
            }
        ],
        "type": "JiraFallbackField"
    }, v46 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "concreteType": "JiraStatus",
                "kind": "LinkedField",
                "name": "status",
                "plural": false,
                "selections": [
                    v25 /*: any*/ ,
                    {
                        "kind": "ScalarField",
                        "name": "statusId"
                    },
                    v30 /*: any*/ ,
                    v17 /*: any*/ 
                ]
            }
        ],
        "type": "JiraStatusField"
    }, v47 = [
        {
            "kind": "Literal",
            "name": "first",
            "value": 1000
        }
    ], v48 = [
        v25 /*: any*/ 
    ], v49 = {
        "kind": "ScalarField",
        "name": "totalCount"
    }, v50 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "args": v47 /*: any*/ ,
                "concreteType": "JiraLabelConnection",
                "kind": "LinkedField",
                "name": "selectedLabelsConnection",
                "plural": false,
                "selections": [
                    {
                        "concreteType": "JiraLabelEdge",
                        "kind": "LinkedField",
                        "name": "edges",
                        "plural": true,
                        "selections": [
                            {
                                "concreteType": "JiraLabel",
                                "kind": "LinkedField",
                                "name": "node",
                                "plural": false,
                                "selections": v48 /*: any*/ 
                            }
                        ]
                    },
                    v49 /*: any*/ 
                ],
                "storageKey": "selectedLabelsConnection(first:1000)"
            },
            v25 /*: any*/ ,
            v41 /*: any*/ 
        ],
        "type": "JiraLabelsField"
    }, v51 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "concreteType": "JiraIssueType",
                "kind": "LinkedField",
                "name": "issueType",
                "plural": false,
                "selections": [
                    v28 /*: any*/ ,
                    v25 /*: any*/ ,
                    v17 /*: any*/ 
                ]
            }
        ],
        "type": "JiraIssueTypeField"
    }, v52 = {
        "concreteType": "JiraSingleLineTextField",
        "kind": "LinkedField",
        "name": "summaryField",
        "plural": false,
        "selections": [
            v26 /*: any*/ ,
            v17 /*: any*/ 
        ]
    }, v53 = {
        "concreteType": "JiraAvatar",
        "kind": "LinkedField",
        "name": "avatar",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "xsmall"
            }
        ]
    }, v54 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "concreteType": "JiraIssue",
                "kind": "LinkedField",
                "name": "parentIssue",
                "plural": false,
                "selections": [
                    v16 /*: any*/ ,
                    {
                        "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcparentfromissueviewrelayprovider",
                        "kind": "Condition",
                        "passingValue": true,
                        "selections": [
                            v52 /*: any*/ 
                        ]
                    },
                    {
                        "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcparentfromissueviewrelayprovider",
                        "kind": "Condition",
                        "passingValue": false,
                        "selections": [
                            {
                                "args": [
                                    {
                                        "kind": "Literal",
                                        "name": "ids",
                                        "value": [
                                            "issuetype",
                                            "summary"
                                        ]
                                    }
                                ],
                                "concreteType": "JiraIssueFieldConnection",
                                "kind": "LinkedField",
                                "name": "fieldsById",
                                "plural": false,
                                "selections": [
                                    {
                                        "concreteType": "JiraIssueFieldEdge",
                                        "kind": "LinkedField",
                                        "name": "edges",
                                        "plural": true,
                                        "selections": [
                                            {
                                                "kind": "LinkedField",
                                                "name": "node",
                                                "plural": false,
                                                "selections": [
                                                    v23 /*: any*/ ,
                                                    v24 /*: any*/ ,
                                                    v51 /*: any*/ ,
                                                    {
                                                        "kind": "InlineFragment",
                                                        "selections": [
                                                            v26 /*: any*/ 
                                                        ],
                                                        "type": "JiraSingleLineTextField"
                                                    },
                                                    v17 /*: any*/ 
                                                ]
                                            }
                                        ]
                                    }
                                ],
                                "storageKey": "fieldsById(ids:[\"issuetype\",\"summary\"])"
                            }
                        ]
                    },
                    v17 /*: any*/ 
                ]
            },
            {
                "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcparentfromissueviewrelayprovider",
                "kind": "Condition",
                "passingValue": true,
                "selections": [
                    {
                        "concreteType": "JiraIssue",
                        "kind": "LinkedField",
                        "name": "parentIssue",
                        "plural": false,
                        "selections": [
                            {
                                "concreteType": "JiraColorField",
                                "kind": "LinkedField",
                                "name": "issueColorField",
                                "plural": false,
                                "selections": [
                                    {
                                        "concreteType": "JiraColor",
                                        "kind": "LinkedField",
                                        "name": "color",
                                        "plural": false,
                                        "selections": [
                                            {
                                                "kind": "ScalarField",
                                                "name": "colorKey"
                                            },
                                            v17 /*: any*/ 
                                        ]
                                    },
                                    v17 /*: any*/ 
                                ]
                            },
                            {
                                "concreteType": "JiraIssueTypeField",
                                "kind": "LinkedField",
                                "name": "issueTypeField",
                                "plural": false,
                                "selections": [
                                    {
                                        "concreteType": "JiraIssueType",
                                        "kind": "LinkedField",
                                        "name": "issueType",
                                        "plural": false,
                                        "selections": [
                                            v53 /*: any*/ ,
                                            v25 /*: any*/ ,
                                            v17 /*: any*/ 
                                        ]
                                    },
                                    v17 /*: any*/ 
                                ]
                            },
                            v52 /*: any*/ 
                        ]
                    }
                ]
            }
        ],
        "type": "JiraParentIssueField"
    }, v55 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "concreteType": "JiraPriority",
                "kind": "LinkedField",
                "name": "priority",
                "plural": false,
                "selections": [
                    v25 /*: any*/ ,
                    {
                        "kind": "ScalarField",
                        "name": "iconUrl"
                    },
                    v17 /*: any*/ 
                ]
            },
            v25 /*: any*/ ,
            v41 /*: any*/ 
        ],
        "type": "JiraPriorityField"
    }, v56 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "concreteType": "JiraProject",
                "kind": "LinkedField",
                "name": "project",
                "plural": false,
                "selections": [
                    v25 /*: any*/ ,
                    v16 /*: any*/ ,
                    {
                        "concreteType": "JiraAvatar",
                        "kind": "LinkedField",
                        "name": "avatar",
                        "plural": false,
                        "selections": [
                            {
                                "kind": "ScalarField",
                                "name": "large"
                            }
                        ]
                    },
                    v17 /*: any*/ 
                ]
            }
        ],
        "type": "JiraProjectField"
    }, v57 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "concreteType": "JiraResolution",
                "kind": "LinkedField",
                "name": "resolution",
                "plural": false,
                "selections": v38 /*: any*/ 
            }
        ],
        "type": "JiraResolutionField"
    }, v58 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "concreteType": "JiraSprintConnection",
                "kind": "LinkedField",
                "name": "selectedSprintsConnection",
                "plural": false,
                "selections": [
                    {
                        "concreteType": "JiraSprintEdge",
                        "kind": "LinkedField",
                        "name": "edges",
                        "plural": true,
                        "selections": [
                            {
                                "concreteType": "JiraSprint",
                                "kind": "LinkedField",
                                "name": "node",
                                "plural": false,
                                "selections": [
                                    v17 /*: any*/ ,
                                    {
                                        "kind": "ScalarField",
                                        "name": "sprintId"
                                    },
                                    v25 /*: any*/ ,
                                    {
                                        "kind": "ScalarField",
                                        "name": "state"
                                    },
                                    {
                                        "kind": "ScalarField",
                                        "name": "endDate"
                                    }
                                ]
                            }
                        ]
                    }
                ]
            },
            v25 /*: any*/ ,
            v41 /*: any*/ 
        ],
        "type": "JiraSprintField"
    }, v59 = {
        "kind": "ScalarField",
        "name": "accountId"
    }, v60 = {
        "kind": "ScalarField",
        "name": "accountStatus"
    }, v61 = {
        "kind": "InlineFragment",
        "selections": [
            v25 /*: any*/ ,
            {
                "concreteType": "JiraVersionConnection",
                "kind": "LinkedField",
                "name": "selectedVersionsConnection",
                "plural": false,
                "selections": [
                    {
                        "concreteType": "JiraVersionEdge",
                        "kind": "LinkedField",
                        "name": "edges",
                        "plural": true,
                        "selections": [
                            {
                                "concreteType": "JiraVersion",
                                "kind": "LinkedField",
                                "name": "node",
                                "plural": false,
                                "selections": v38 /*: any*/ 
                            }
                        ]
                    }
                ]
            }
        ],
        "type": "JiraMultipleVersionPickerField"
    }, v62 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "concreteType": "JiraRichText",
                "kind": "LinkedField",
                "name": "richText",
                "plural": false,
                "selections": [
                    {
                        "concreteType": "JiraADF",
                        "kind": "LinkedField",
                        "name": "adfValue",
                        "plural": false,
                        "selections": [
                            {
                                "concreteType": "JiraAdfToConvertedPlainText",
                                "kind": "LinkedField",
                                "name": "convertedPlainText",
                                "plural": false,
                                "selections": [
                                    {
                                        "kind": "ScalarField",
                                        "name": "plainText"
                                    }
                                ]
                            }
                        ]
                    }
                ]
            }
        ],
        "type": "JiraRichTextField"
    }, v63 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "concreteType": "JiraServiceManagementRequestType",
                "kind": "LinkedField",
                "name": "requestType",
                "plural": false,
                "selections": [
                    v25 /*: any*/ ,
                    v53 /*: any*/ ,
                    v17 /*: any*/ 
                ]
            }
        ],
        "type": "JiraServiceManagementRequestTypeField"
    }, v64 = {
        "kind": "ScalarField",
        "name": "hasNextPage"
    }, v65 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "args": v47 /*: any*/ ,
                "concreteType": "JiraIssueLinkConnection",
                "kind": "LinkedField",
                "name": "issueLinkConnection",
                "plural": false,
                "selections": [
                    {
                        "concreteType": "PageInfo",
                        "kind": "LinkedField",
                        "name": "pageInfo",
                        "plural": false,
                        "selections": [
                            v64 /*: any*/ 
                        ]
                    },
                    {
                        "concreteType": "JiraIssueLinkEdge",
                        "kind": "LinkedField",
                        "name": "edges",
                        "plural": true,
                        "selections": [
                            {
                                "concreteType": "JiraIssueLink",
                                "kind": "LinkedField",
                                "name": "node",
                                "plural": false,
                                "selections": [
                                    {
                                        "concreteType": "JiraIssue",
                                        "kind": "LinkedField",
                                        "name": "issue",
                                        "plural": false,
                                        "selections": [
                                            {
                                                "kind": "ScalarField",
                                                "name": "webUrl"
                                            },
                                            v16 /*: any*/ ,
                                            {
                                                "args": [
                                                    {
                                                        "kind": "Literal",
                                                        "name": "ids",
                                                        "value": [
                                                            "statusCategory"
                                                        ]
                                                    }
                                                ],
                                                "concreteType": "JiraIssueFieldConnection",
                                                "kind": "LinkedField",
                                                "name": "fieldsById",
                                                "plural": false,
                                                "selections": [
                                                    {
                                                        "concreteType": "JiraIssueFieldEdge",
                                                        "kind": "LinkedField",
                                                        "name": "edges",
                                                        "plural": true,
                                                        "selections": [
                                                            {
                                                                "kind": "LinkedField",
                                                                "name": "node",
                                                                "plural": false,
                                                                "selections": [
                                                                    v23 /*: any*/ ,
                                                                    {
                                                                        "kind": "InlineFragment",
                                                                        "selections": [
                                                                            v30 /*: any*/ 
                                                                        ],
                                                                        "type": "JiraStatusCategoryField"
                                                                    },
                                                                    v17 /*: any*/ 
                                                                ]
                                                            }
                                                        ]
                                                    }
                                                ],
                                                "storageKey": "fieldsById(ids:[\"statusCategory\"])"
                                            },
                                            v17 /*: any*/ 
                                        ]
                                    },
                                    {
                                        "kind": "ScalarField",
                                        "name": "relationName"
                                    },
                                    v17 /*: any*/ 
                                ]
                            }
                        ]
                    }
                ],
                "storageKey": "issueLinkConnection(first:1000)"
            }
        ],
        "type": "JiraIssueLinkField"
    }, v66 = {
        "concreteType": "JiraIssueFieldConnection",
        "kind": "LinkedField",
        "name": "fields",
        "plural": false,
        "selections": [
            {
                "concreteType": "JiraIssueFieldEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                    {
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                            v23 /*: any*/ ,
                            v24 /*: any*/ ,
                            v32 /*: any*/ ,
                            v34 /*: any*/ ,
                            v17 /*: any*/ ,
                            v35 /*: any*/ ,
                            v37 /*: any*/ ,
                            v39 /*: any*/ ,
                            v42 /*: any*/ ,
                            v43 /*: any*/ ,
                            v44 /*: any*/ ,
                            v45 /*: any*/ ,
                            {
                                "kind": "InlineFragment",
                                "selections": [
                                    v26 /*: any*/ ,
                                    v25 /*: any*/ ,
                                    v41 /*: any*/ 
                                ],
                                "type": "JiraSingleLineTextField"
                            },
                            {
                                "kind": "InlineFragment",
                                "selections": [
                                    {
                                        "concreteType": "JiraStatusCategory",
                                        "kind": "LinkedField",
                                        "name": "statusCategory",
                                        "plural": false,
                                        "selections": [
                                            v25 /*: any*/ ,
                                            v29 /*: any*/ ,
                                            v17 /*: any*/ 
                                        ]
                                    }
                                ],
                                "type": "JiraStatusCategoryField"
                            },
                            v46 /*: any*/ ,
                            v50 /*: any*/ ,
                            v51 /*: any*/ ,
                            v54 /*: any*/ ,
                            v55 /*: any*/ ,
                            v56 /*: any*/ ,
                            v57 /*: any*/ ,
                            v58 /*: any*/ ,
                            {
                                "kind": "InlineFragment",
                                "selections": [
                                    {
                                        "kind": "LinkedField",
                                        "name": "user",
                                        "plural": false,
                                        "selections": [
                                            v23 /*: any*/ ,
                                            v59 /*: any*/ ,
                                            v27 /*: any*/ ,
                                            v25 /*: any*/ ,
                                            v17 /*: any*/ ,
                                            v60 /*: any*/ 
                                        ]
                                    },
                                    v25 /*: any*/ ,
                                    v40 /*: any*/ ,
                                    v41 /*: any*/ 
                                ],
                                "type": "JiraSingleSelectUserPickerField"
                            },
                            v61 /*: any*/ ,
                            v62 /*: any*/ ,
                            v63 /*: any*/ ,
                            v65 /*: any*/ 
                        ]
                    }
                ]
            }
        ]
    }, v67 = {
        "concreteType": "JiraIssueFieldConnection",
        "kind": "LinkedField",
        "name": "fields",
        "plural": false,
        "selections": [
            {
                "concreteType": "JiraIssueFieldEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                    {
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                            v24 /*: any*/ ,
                            v32 /*: any*/ ,
                            v34 /*: any*/ ,
                            v35 /*: any*/ ,
                            v37 /*: any*/ ,
                            v39 /*: any*/ ,
                            v42 /*: any*/ ,
                            v43 /*: any*/ ,
                            v44 /*: any*/ ,
                            v45 /*: any*/ ,
                            {
                                "kind": "InlineFragment",
                                "selections": [
                                    v32 /*: any*/ ,
                                    v41 /*: any*/ 
                                ],
                                "type": "JiraSingleLineTextField"
                            },
                            {
                                "kind": "InlineFragment",
                                "selections": [
                                    {
                                        "concreteType": "JiraStatusCategory",
                                        "kind": "LinkedField",
                                        "name": "statusCategory",
                                        "plural": false,
                                        "selections": v48 /*: any*/ 
                                    }
                                ],
                                "type": "JiraStatusCategoryField"
                            },
                            v46 /*: any*/ ,
                            v50 /*: any*/ ,
                            v54 /*: any*/ ,
                            v55 /*: any*/ ,
                            v56 /*: any*/ ,
                            v57 /*: any*/ ,
                            v58 /*: any*/ ,
                            {
                                "kind": "InlineFragment",
                                "selections": [
                                    v32 /*: any*/ ,
                                    {
                                        "kind": "LinkedField",
                                        "name": "user",
                                        "plural": false,
                                        "selections": [
                                            v59 /*: any*/ ,
                                            v60 /*: any*/ 
                                        ]
                                    },
                                    v40 /*: any*/ ,
                                    v41 /*: any*/ 
                                ],
                                "type": "JiraSingleSelectUserPickerField"
                            },
                            v61 /*: any*/ ,
                            v62 /*: any*/ ,
                            v63 /*: any*/ ,
                            v65 /*: any*/ 
                        ]
                    }
                ]
            }
        ]
    }, v68 = {
        "kind": "ScalarField",
        "name": "cursor"
    }, v69 = {
        "concreteType": "PageInfo",
        "kind": "LinkedField",
        "name": "pageInfo",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "endCursor"
            },
            v64 /*: any*/ 
        ]
    }, v70 = {
        "kind": "ClientExtension",
        "selections": [
            {
                "kind": "ScalarField",
                "name": "__id"
            }
        ]
    }, v71 = {
        "kind": "ScalarField",
        "name": "isCurrent"
    }, v72 = {
        "kind": "ScalarField",
        "name": "pageNumber"
    }, v73 = [
        v15 /*: any*/ ,
        v18 /*: any*/ ,
        v20 /*: any*/ ,
        v21 /*: any*/ 
    ], v74 = {
        "kind": "ScalarField",
        "name": "displayName"
    }, v75 = [
        {
            "kind": "ScalarField",
            "name": "viewId"
        },
        {
            "args": [
                {
                    "kind": "Literal",
                    "name": "filter",
                    "value": {
                        "fieldSetSelectedState": "SELECTED"
                    }
                },
                v19 /*: any*/ 
            ],
            "concreteType": "JiraIssueSearchFieldSetConnection",
            "kind": "LinkedField",
            "name": "fieldSets",
            "plural": false,
            "selections": [
                {
                    "concreteType": "JiraIssueSearchFieldSetEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                        {
                            "concreteType": "JiraIssueSearchFieldSet",
                            "kind": "LinkedField",
                            "name": "node",
                            "plural": false,
                            "selections": [
                                v33 /*: any*/ ,
                                v32 /*: any*/ ,
                                v74 /*: any*/ ,
                                {
                                    "kind": "ScalarField",
                                    "name": "jqlTerm"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "isSortable"
                                },
                                {
                                    "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcninresizablecolumnsrelayprovider",
                                    "kind": "Condition",
                                    "passingValue": true,
                                    "selections": [
                                        {
                                            "concreteType": "JiraFieldSetPreferences",
                                            "kind": "LinkedField",
                                            "name": "fieldSetPreferences",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "width"
                                                }
                                            ]
                                        }
                                    ]
                                },
                                {
                                    "concreteType": "JiraFieldType",
                                    "kind": "LinkedField",
                                    "name": "fieldType",
                                    "plural": false,
                                    "selections": [
                                        v74 /*: any*/ 
                                    ]
                                }
                            ]
                        }
                    ]
                },
                v49 /*: any*/ ,
                v70 /*: any*/ 
            ]
        },
        v17 /*: any*/ ,
        {
            "kind": "ScalarField",
            "name": "hasDefaultFieldSets"
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v3 /*: any*/ ,
                v4 /*: any*/ ,
                v5 /*: any*/ ,
                v6 /*: any*/ ,
                v7 /*: any*/ ,
                v8 /*: any*/ ,
                v9 /*: any*/ ,
                v10 /*: any*/ ,
                v11 /*: any*/ ,
                v12 /*: any*/ ,
                v13 /*: any*/ ,
                v14 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "IssueNavigatorResultsRefetchQuery",
            "selections": [
                {
                    "kind": "FragmentSpread",
                    "name": "main_issueNavigator_IssueNavigator_issueQuery"
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v3 /*: any*/ ,
                v4 /*: any*/ ,
                v5 /*: any*/ ,
                v6 /*: any*/ ,
                v7 /*: any*/ ,
                v8 /*: any*/ ,
                v9 /*: any*/ ,
                v10 /*: any*/ ,
                v11 /*: any*/ ,
                v12 /*: any*/ ,
                v13 /*: any*/ ,
                v14 /*: any*/ ,
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcissuesearchviewresultrelayprovider"
                },
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcischildissuestotalcountenabledrelayprovider"
                },
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcjscm1apiupdatesrelayprovider"
                },
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcstatusinlineeditrelayprovider"
                },
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcparentfromissueviewrelayprovider"
                },
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcninresizablecolumnsrelayprovider"
                }
            ],
            "kind": "Operation",
            "name": "IssueNavigatorResultsRefetchQuery",
            "selections": [
                {
                    "concreteType": "JiraQuery",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "args": [
                                {
                                    "kind": "Variable",
                                    "name": "after",
                                    "variableName": "after"
                                },
                                {
                                    "kind": "Variable",
                                    "name": "before",
                                    "variableName": "before"
                                },
                                v15 /*: any*/ ,
                                {
                                    "kind": "Variable",
                                    "name": "first",
                                    "variableName": "first"
                                },
                                {
                                    "kind": "Variable",
                                    "name": "issueSearchInput",
                                    "variableName": "issueSearchInput"
                                },
                                {
                                    "kind": "Variable",
                                    "name": "last",
                                    "variableName": "last"
                                },
                                {
                                    "kind": "Variable",
                                    "name": "options",
                                    "variableName": "options"
                                }
                            ],
                            "concreteType": "JiraIssueConnection",
                            "kind": "LinkedField",
                            "name": "issueSearchStable",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "JiraIssueEdge",
                                    "kind": "LinkedField",
                                    "name": "edges",
                                    "plural": true,
                                    "selections": [
                                        {
                                            "concreteType": "JiraIssue",
                                            "kind": "LinkedField",
                                            "name": "node",
                                            "plural": false,
                                            "selections": [
                                                v16 /*: any*/ ,
                                                v17 /*: any*/ ,
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "issueId"
                                                },
                                                {
                                                    "args": v22 /*: any*/ ,
                                                    "concreteType": "JiraIssueFieldSetConnection",
                                                    "kind": "LinkedField",
                                                    "name": "fieldSetsForIssueSearchView",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "concreteType": "JiraIssueFieldSetEdge",
                                                            "kind": "LinkedField",
                                                            "name": "edges",
                                                            "plural": true,
                                                            "selections": [
                                                                {
                                                                    "concreteType": "JiraIssueFieldSet",
                                                                    "kind": "LinkedField",
                                                                    "name": "node",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        {
                                                                            "concreteType": "JiraIssueFieldConnection",
                                                                            "kind": "LinkedField",
                                                                            "name": "fields",
                                                                            "plural": false,
                                                                            "selections": [
                                                                                {
                                                                                    "concreteType": "JiraIssueFieldEdge",
                                                                                    "kind": "LinkedField",
                                                                                    "name": "edges",
                                                                                    "plural": true,
                                                                                    "selections": [
                                                                                        {
                                                                                            "kind": "LinkedField",
                                                                                            "name": "node",
                                                                                            "plural": false,
                                                                                            "selections": [
                                                                                                v23 /*: any*/ ,
                                                                                                {
                                                                                                    "kind": "InlineFragment",
                                                                                                    "selections": [
                                                                                                        v24 /*: any*/ ,
                                                                                                        v25 /*: any*/ ,
                                                                                                        v26 /*: any*/ 
                                                                                                    ],
                                                                                                    "type": "JiraSingleLineTextField"
                                                                                                },
                                                                                                {
                                                                                                    "kind": "InlineFragment",
                                                                                                    "selections": [
                                                                                                        v24 /*: any*/ ,
                                                                                                        v25 /*: any*/ ,
                                                                                                        {
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "user",
                                                                                                            "plural": false,
                                                                                                            "selections": [
                                                                                                                v23 /*: any*/ ,
                                                                                                                v25 /*: any*/ ,
                                                                                                                v27 /*: any*/ ,
                                                                                                                v17 /*: any*/ 
                                                                                                            ]
                                                                                                        }
                                                                                                    ],
                                                                                                    "type": "JiraSingleSelectUserPickerField"
                                                                                                },
                                                                                                {
                                                                                                    "kind": "InlineFragment",
                                                                                                    "selections": [
                                                                                                        v24 /*: any*/ ,
                                                                                                        {
                                                                                                            "concreteType": "JiraIssueType",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "issueType",
                                                                                                            "plural": false,
                                                                                                            "selections": [
                                                                                                                v25 /*: any*/ ,
                                                                                                                v28 /*: any*/ ,
                                                                                                                v17 /*: any*/ 
                                                                                                            ]
                                                                                                        }
                                                                                                    ],
                                                                                                    "type": "JiraIssueTypeField"
                                                                                                },
                                                                                                {
                                                                                                    "kind": "InlineFragment",
                                                                                                    "selections": [
                                                                                                        v24 /*: any*/ ,
                                                                                                        v30 /*: any*/ 
                                                                                                    ],
                                                                                                    "type": "JiraStatusCategoryField"
                                                                                                },
                                                                                                v17 /*: any*/ 
                                                                                            ]
                                                                                        }
                                                                                    ]
                                                                                }
                                                                            ]
                                                                        }
                                                                    ]
                                                                }
                                                            ]
                                                        }
                                                    ]
                                                },
                                                {
                                                    "condition": "queryStatusForIssuekeyStrikethrough",
                                                    "kind": "Condition",
                                                    "passingValue": true,
                                                    "selections": [
                                                        {
                                                            "args": [
                                                                {
                                                                    "kind": "Literal",
                                                                    "name": "ids",
                                                                    "value": [
                                                                        "status"
                                                                    ]
                                                                }
                                                            ],
                                                            "concreteType": "JiraIssueFieldConnection",
                                                            "kind": "LinkedField",
                                                            "name": "fieldsById",
                                                            "plural": false,
                                                            "selections": [
                                                                {
                                                                    "concreteType": "JiraIssueFieldEdge",
                                                                    "kind": "LinkedField",
                                                                    "name": "edges",
                                                                    "plural": true,
                                                                    "selections": [
                                                                        {
                                                                            "kind": "LinkedField",
                                                                            "name": "node",
                                                                            "plural": false,
                                                                            "selections": [
                                                                                v23 /*: any*/ ,
                                                                                {
                                                                                    "kind": "InlineFragment",
                                                                                    "selections": [
                                                                                        v24 /*: any*/ ,
                                                                                        {
                                                                                            "concreteType": "JiraStatus",
                                                                                            "kind": "LinkedField",
                                                                                            "name": "status",
                                                                                            "plural": false,
                                                                                            "selections": [
                                                                                                v30 /*: any*/ ,
                                                                                                v17 /*: any*/ 
                                                                                            ]
                                                                                        }
                                                                                    ],
                                                                                    "type": "JiraStatusField"
                                                                                },
                                                                                v17 /*: any*/ 
                                                                            ]
                                                                        }
                                                                    ]
                                                                }
                                                            ],
                                                            "storageKey": "fieldsById(ids:[\"status\"])"
                                                        }
                                                    ]
                                                },
                                                {
                                                    "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjscm1apiupdatesrelayprovider",
                                                    "kind": "Condition",
                                                    "passingValue": false,
                                                    "selections": [
                                                        {
                                                            "condition": "shouldQueryFieldSetsById",
                                                            "kind": "Condition",
                                                            "passingValue": true,
                                                            "selections": [
                                                                {
                                                                    "args": v31 /*: any*/ ,
                                                                    "concreteType": "JiraIssueFieldSetConnection",
                                                                    "kind": "LinkedField",
                                                                    "name": "fieldSetsById",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        {
                                                                            "concreteType": "JiraIssueFieldSetEdge",
                                                                            "kind": "LinkedField",
                                                                            "name": "edges",
                                                                            "plural": true,
                                                                            "selections": [
                                                                                {
                                                                                    "concreteType": "JiraIssueFieldSet",
                                                                                    "kind": "LinkedField",
                                                                                    "name": "node",
                                                                                    "plural": false,
                                                                                    "selections": [
                                                                                        v32 /*: any*/ ,
                                                                                        v33 /*: any*/ ,
                                                                                        v66 /*: any*/ 
                                                                                    ]
                                                                                }
                                                                            ]
                                                                        }
                                                                    ]
                                                                }
                                                            ]
                                                        },
                                                        {
                                                            "condition": "shouldQueryFieldSetsById",
                                                            "kind": "Condition",
                                                            "passingValue": false,
                                                            "selections": [
                                                                {
                                                                    "args": v22 /*: any*/ ,
                                                                    "concreteType": "JiraIssueFieldSetConnection",
                                                                    "kind": "LinkedField",
                                                                    "name": "fieldSetsForIssueSearchView",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        {
                                                                            "concreteType": "JiraIssueFieldSetEdge",
                                                                            "kind": "LinkedField",
                                                                            "name": "edges",
                                                                            "plural": true,
                                                                            "selections": [
                                                                                {
                                                                                    "concreteType": "JiraIssueFieldSet",
                                                                                    "kind": "LinkedField",
                                                                                    "name": "node",
                                                                                    "plural": false,
                                                                                    "selections": [
                                                                                        v32 /*: any*/ ,
                                                                                        v33 /*: any*/ ,
                                                                                        v67 /*: any*/ 
                                                                                    ]
                                                                                }
                                                                            ]
                                                                        }
                                                                    ]
                                                                }
                                                            ]
                                                        }
                                                    ]
                                                },
                                                {
                                                    "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjscm1apiupdatesrelayprovider",
                                                    "kind": "Condition",
                                                    "passingValue": true,
                                                    "selections": [
                                                        {
                                                            "condition": "shouldQueryFieldSetsById",
                                                            "kind": "Condition",
                                                            "passingValue": true,
                                                            "selections": [
                                                                {
                                                                    "args": v31 /*: any*/ ,
                                                                    "concreteType": "JiraIssueFieldSetConnection",
                                                                    "kind": "LinkedField",
                                                                    "name": "fieldSetsById",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        {
                                                                            "concreteType": "JiraIssueFieldSetEdge",
                                                                            "kind": "LinkedField",
                                                                            "name": "edges",
                                                                            "plural": true,
                                                                            "selections": [
                                                                                v23 /*: any*/ ,
                                                                                v68 /*: any*/ ,
                                                                                {
                                                                                    "concreteType": "JiraIssueFieldSet",
                                                                                    "kind": "LinkedField",
                                                                                    "name": "node",
                                                                                    "plural": false,
                                                                                    "selections": [
                                                                                        v23 /*: any*/ ,
                                                                                        v32 /*: any*/ ,
                                                                                        v33 /*: any*/ ,
                                                                                        v66 /*: any*/ 
                                                                                    ]
                                                                                }
                                                                            ]
                                                                        },
                                                                        v69 /*: any*/ 
                                                                    ]
                                                                },
                                                                {
                                                                    "args": v31 /*: any*/ ,
                                                                    "filters": [],
                                                                    "handle": "connection",
                                                                    "key": "IssueTable_IssueRow__fieldSetsById",
                                                                    "kind": "LinkedHandle",
                                                                    "name": "fieldSetsById"
                                                                }
                                                            ]
                                                        },
                                                        {
                                                            "condition": "shouldQueryFieldSetsById",
                                                            "kind": "Condition",
                                                            "passingValue": false,
                                                            "selections": [
                                                                {
                                                                    "args": v22 /*: any*/ ,
                                                                    "concreteType": "JiraIssueFieldSetConnection",
                                                                    "kind": "LinkedField",
                                                                    "name": "fieldSetsForIssueSearchView",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        {
                                                                            "concreteType": "JiraIssueFieldSetEdge",
                                                                            "kind": "LinkedField",
                                                                            "name": "edges",
                                                                            "plural": true,
                                                                            "selections": [
                                                                                v23 /*: any*/ ,
                                                                                v68 /*: any*/ ,
                                                                                {
                                                                                    "concreteType": "JiraIssueFieldSet",
                                                                                    "kind": "LinkedField",
                                                                                    "name": "node",
                                                                                    "plural": false,
                                                                                    "selections": [
                                                                                        v23 /*: any*/ ,
                                                                                        v32 /*: any*/ ,
                                                                                        v33 /*: any*/ ,
                                                                                        v67 /*: any*/ 
                                                                                    ]
                                                                                }
                                                                            ]
                                                                        },
                                                                        v69 /*: any*/ 
                                                                    ]
                                                                },
                                                                {
                                                                    "args": v22 /*: any*/ ,
                                                                    "filters": [],
                                                                    "handle": "connection",
                                                                    "key": "IssueTable_IssueRow__fieldSetsForIssueSearchView",
                                                                    "kind": "LinkedHandle",
                                                                    "name": "fieldSetsForIssueSearchView"
                                                                }
                                                            ]
                                                        }
                                                    ]
                                                },
                                                {
                                                    "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcischildissuestotalcountenabledrelayprovider",
                                                    "kind": "Condition",
                                                    "passingValue": true,
                                                    "selections": [
                                                        {
                                                            "kind": "LinkedField",
                                                            "name": "childIssues",
                                                            "plural": false,
                                                            "selections": [
                                                                v23 /*: any*/ ,
                                                                {
                                                                    "kind": "InlineFragment",
                                                                    "selections": [
                                                                        {
                                                                            "args": [
                                                                                {
                                                                                    "kind": "Literal",
                                                                                    "name": "activeProjectsOnly",
                                                                                    "value": true
                                                                                },
                                                                                {
                                                                                    "kind": "Literal",
                                                                                    "name": "first",
                                                                                    "value": 10
                                                                                }
                                                                            ],
                                                                            "concreteType": "JiraIssueConnection",
                                                                            "kind": "LinkedField",
                                                                            "name": "issues",
                                                                            "plural": false,
                                                                            "selections": [
                                                                                v49 /*: any*/ 
                                                                            ],
                                                                            "storageKey": "issues(activeProjectsOnly:true,first:10)"
                                                                        }
                                                                    ],
                                                                    "type": "JiraChildIssuesWithinLimit"
                                                                }
                                                            ]
                                                        }
                                                    ]
                                                },
                                                {
                                                    "kind": "ClientExtension",
                                                    "selections": [
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "isHighlightedIssueRow"
                                                        }
                                                    ]
                                                }
                                            ]
                                        },
                                        v23 /*: any*/ ,
                                        v70 /*: any*/ 
                                    ]
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "totalIssueSearchResultCount"
                                },
                                {
                                    "args": [
                                        {
                                            "kind": "Literal",
                                            "name": "maxCursors",
                                            "value": 7
                                        }
                                    ],
                                    "concreteType": "JiraPageCursors",
                                    "kind": "LinkedField",
                                    "name": "pageCursors",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "concreteType": "JiraPageCursor",
                                            "kind": "LinkedField",
                                            "name": "around",
                                            "plural": true,
                                            "selections": [
                                                v68 /*: any*/ ,
                                                v71 /*: any*/ ,
                                                v72 /*: any*/ 
                                            ]
                                        },
                                        {
                                            "concreteType": "JiraPageCursor",
                                            "kind": "LinkedField",
                                            "name": "last",
                                            "plural": false,
                                            "selections": [
                                                v72 /*: any*/ ,
                                                v68 /*: any*/ ,
                                                v71 /*: any*/ 
                                            ]
                                        },
                                        {
                                            "concreteType": "JiraPageCursor",
                                            "kind": "LinkedField",
                                            "name": "first",
                                            "plural": false,
                                            "selections": [
                                                v68 /*: any*/ ,
                                                v72 /*: any*/ ,
                                                v71 /*: any*/ 
                                            ]
                                        }
                                    ],
                                    "storageKey": "pageCursors(maxCursors:7)"
                                },
                                {
                                    "concreteType": "JiraIssueNavigatorPageInfo",
                                    "kind": "LinkedField",
                                    "name": "issueNavigatorPageInfo",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "firstIssuePosition"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "lastIssuePosition"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "firstIssueKeyFromNextPage"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "lastIssueKeyFromPreviousPage"
                                        }
                                    ]
                                },
                                {
                                    "kind": "LinkedField",
                                    "name": "issueSearchError",
                                    "plural": false,
                                    "selections": [
                                        v23 /*: any*/ ,
                                        {
                                            "kind": "InlineFragment",
                                            "selections": [
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "messages"
                                                }
                                            ],
                                            "type": "JiraInvalidJqlError"
                                        },
                                        {
                                            "kind": "InlineFragment",
                                            "selections": [
                                                v36 /*: any*/ ,
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "errorType"
                                                }
                                            ],
                                            "type": "JiraInvalidSyntaxError"
                                        }
                                    ]
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "isCappingIssueSearchResult"
                                },
                                v70 /*: any*/ 
                            ]
                        },
                        {
                            "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcissuesearchviewresultrelayprovider",
                            "kind": "Condition",
                            "passingValue": false,
                            "selections": [
                                {
                                    "args": v73 /*: any*/ ,
                                    "concreteType": "JiraIssueSearchView",
                                    "kind": "LinkedField",
                                    "name": "issueSearchViewByNamespaceAndViewId",
                                    "plural": false,
                                    "selections": v75 /*: any*/ 
                                }
                            ]
                        },
                        {
                            "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcissuesearchviewresultrelayprovider",
                            "kind": "Condition",
                            "passingValue": true,
                            "selections": [
                                {
                                    "args": v73 /*: any*/ ,
                                    "kind": "LinkedField",
                                    "name": "issueSearchViewResult",
                                    "plural": false,
                                    "selections": [
                                        v23 /*: any*/ ,
                                        {
                                            "kind": "TypeDiscriminator",
                                            "abstractKey": "__isJiraIssueSearchViewResult"
                                        },
                                        {
                                            "kind": "InlineFragment",
                                            "selections": v75 /*: any*/ ,
                                            "type": "JiraIssueSearchView"
                                        },
                                        {
                                            "kind": "InlineFragment",
                                            "selections": [
                                                v36 /*: any*/ ,
                                                {
                                                    "kind": "LinkedField",
                                                    "name": "extensions",
                                                    "plural": true,
                                                    "selections": [
                                                        v23 /*: any*/ ,
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "statusCode"
                                                        }
                                                    ]
                                                }
                                            ],
                                            "type": "QueryError"
                                        },
                                        {
                                            "kind": "InlineFragment",
                                            "selections": [
                                                v17 /*: any*/ 
                                            ],
                                            "type": "Node",
                                            "abstractKey": "__isNode"
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "1915f89f81c6650603b9a50fb9b7f5596c54549f0c7e5c1eeb34512d71a1b148",
            "metadata": {},
            "name": "IssueNavigatorResultsRefetchQuery",
            "operationKind": "query",
            "text": null,
            "providedVariables": {
                "isIssueSearchViewResultEnabled": (0, $alD35.default),
                "__relay_internal__pv__atlassianjirarelayprovidersrcissuesearchviewresultrelayprovider": (0, $alD35.default),
                "__relay_internal__pv__atlassianjirarelayprovidersrcischildissuestotalcountenabledrelayprovider": (0, $dbXJb.default),
                "__relay_internal__pv__atlassianjirarelayprovidersrcjscm1apiupdatesrelayprovider": (0, $91oFA.default),
                "__relay_internal__pv__atlassianjirarelayprovidersrcstatusinlineeditrelayprovider": (0, $fY4Nv.default),
                "__relay_internal__pv__atlassianjirarelayprovidersrcparentfromissueviewrelayprovider": (0, $kpHqV.default),
                "__relay_internal__pv__atlassianjirarelayprovidersrcninresizablecolumnsrelayprovider": (0, $lWCGp.default)
            }
        }
    };
}();
$5dc6948a5a3de181$var$node.hash = "26781166e998baf3bd27efa514147837";
var $5dc6948a5a3de181$export$2e2bcd8739ae039 = $5dc6948a5a3de181$var$node;

});


parcelRegister("cWCvn", function(module, exports) {

$parcel$export(module.exports, "marks", () => $eeca211cf721329d$export$3a8025f2f3e0c64);
$parcel$export(module.exports, "NINJqlBuilderAsyncLoad", () => $eeca211cf721329d$export$8ba5b9245ec3f6f9);
$parcel$export(module.exports, "NINPageLoad", () => $eeca211cf721329d$export$248c6c208e271182);
$parcel$export(module.exports, "markOnce", () => $eeca211cf721329d$export$243d158112bae094);

var $lNfG4 = parcelRequire("lNfG4");

var $6oH5O = parcelRequire("6oH5O");
const $eeca211cf721329d$export$3a8025f2f3e0c64 = {
    ISSUE_NAVIGATOR_START: 'ISSUE_NAVIGATOR_START',
    ISSUE_NAVIGATOR_END: 'ISSUE_NAVIGATOR_END',
    ISSUE_NAVIGATOR_UI_START: 'ISSUE_NAVIGATOR_UI_START',
    ISSUE_NAVIGATOR_UI_END: 'ISSUE_NAVIGATOR_UI_END',
    PAGE_ACTIONS_START: 'PAGE_ACTIONS_START',
    PAGE_ACTIONS_END: 'PAGE_ACTIONS_END',
    PAGE_ACTIONS_VIEW_SWITCHER_START: 'PAGE_ACTIONS_VIEW_SWITCHER_START',
    PAGE_ACTIONS_VIEW_SWITCHER_END: 'PAGE_ACTIONS_VIEW_SWITCHER_END',
    REFINEMENT_START: 'REFINEMENT_START',
    REFINEMENT_END: 'REFINEMENT_END',
    ISSUE_RESULTS_START: 'ISSUE_RESULTS_START',
    ISSUE_RESULTS_END: 'ISSUE_RESULTS_END',
    ISSUE_RESULTS_DETAIL_VIEW_START: 'ISSUE_RESULTS_DETAIL_VIEW_START',
    ISSUE_RESULTS_DETAIL_VIEW_END: 'ISSUE_RESULTS_DETAIL_VIEW_END',
    ISSUE_RESULTS_DETAIL_VIEW_CARD_LIST_START: 'ISSUE_RESULTS_DETAIL_VIEW_CARD_LIST_START',
    ISSUE_RESULTS_DETAIL_VIEW_CARD_LIST_END: 'ISSUE_RESULTS_DETAIL_VIEW_CARD_LIST_END',
    ISSUE_RESULTS_LIST_VIEW_START: 'ISSUE_RESULTS_LIST_VIEW_START',
    ISSUE_RESULTS_LIST_VIEW_END: 'ISSUE_RESULTS_LIST_VIEW_END',
    ISSUE_RESULTS_LIST_VIEW_FOOTER_START: 'ISSUE_RESULTS_LIST_VIEW_FOOTER_START',
    ISSUE_RESULTS_LIST_VIEW_FOOTER_END: 'ISSUE_RESULTS_LIST_VIEW_FOOTER_END',
    ISSUE_APP_START: 'ISSUE_APP_START',
    ISSUE_APP_END: 'ISSUE_APP_END',
    ...(0, $6oH5O.JQL_BUILDER_PERFORMANCE_MARKS)
};
const $eeca211cf721329d$var$featureFlags = [
    'child-issues-total-count-performance-experiment_mt1zj',
    'jsv-one-issue-table-spreadsheet-ui_ygrnf',
    'nin_expose_text_option_jql_builder_4kwzo',
    'nin-show-field-options-as-only-unselectable_0s1y2',
    'nin-enable-show-out-of-context-fields-as-only-unselectable_lmsy7'
];
const $eeca211cf721329d$export$8ba5b9245ec3f6f9 = (0, $lNfG4.metrics).pageSegmentLoad({
    key: 'new-issue-navigator-jql-builder',
    timings: [
        {
            key: 'product/issue-navigator/ui/jql-builder',
            startMark: $eeca211cf721329d$export$3a8025f2f3e0c64.JQL_BUILDER_START,
            endMark: $eeca211cf721329d$export$3a8025f2f3e0c64.JQL_BUILDER_END
        },
        {
            key: 'product/issue-navigator/ui/jql-builder/hydrate',
            startMark: $eeca211cf721329d$export$3a8025f2f3e0c64.JQL_BUILDER_HYDRATE_START,
            endMark: $eeca211cf721329d$export$3a8025f2f3e0c64.JQL_BUILDER_HYDRATE_END
        },
        {
            key: 'product/issue-navigator/ui/jql-builder/jql-builder-basic',
            startMark: $eeca211cf721329d$export$3a8025f2f3e0c64.JQL_BUILDER_BASIC_START,
            endMark: $eeca211cf721329d$export$3a8025f2f3e0c64.JQL_BUILDER_BASIC_END
        },
        {
            key: 'product/issue-navigator/ui/jql-builder/jql-builder-basic/js',
            startMark: $eeca211cf721329d$export$3a8025f2f3e0c64.JQL_BUILDER_BASIC_JS_START,
            endMark: $eeca211cf721329d$export$3a8025f2f3e0c64.JQL_BUILDER_BASIC_JS_END
        },
        {
            key: 'product/issue-navigator/ui/jql-builder/jql-builder-advanced',
            startMark: $eeca211cf721329d$export$3a8025f2f3e0c64.JQL_BUILDER_ADVANCED_START,
            endMark: $eeca211cf721329d$export$3a8025f2f3e0c64.JQL_BUILDER_ADVANCED_END
        },
        {
            key: 'product/issue-navigator/ui/jql-builder/jql-builder-advanced/js',
            startMark: $eeca211cf721329d$export$3a8025f2f3e0c64.JQL_BUILDER_ADVANCED_JS_START,
            endMark: $eeca211cf721329d$export$3a8025f2f3e0c64.JQL_BUILDER_ADVANCED_JS_END
        }
    ],
    histogram: {
        initial: {
            fmp: '100_200_500_1000_2500_3000_4000_5000_10000',
            tti: '100_200_500_1000_2500_3000_4000_5000_10000'
        },
        transition: {
            fmp: '100_200_500_1000_2500_3000_4000_5000_10000',
            tti: '100_200_500_1000_2500_3000_4000_5000_10000'
        }
    },
    featureFlags: $eeca211cf721329d$var$featureFlags
});
const $eeca211cf721329d$export$248c6c208e271182 = (0, $lNfG4.metrics).pageLoad({
    key: 'new-issue-navigator',
    slo: {
        fmp: {
            initial: {
                threshold: 3000
            },
            transition: {
                threshold: 3000
            }
        },
        tti: {
            initial: {
                threshold: 4000
            },
            transition: {
                threshold: 4000
            }
        }
    },
    ssr: {
        doneAsFmp: true
    },
    timings: [
        {
            key: 'product/issue-navigator',
            startMark: $eeca211cf721329d$export$3a8025f2f3e0c64.ISSUE_NAVIGATOR_START,
            endMark: $eeca211cf721329d$export$3a8025f2f3e0c64.ISSUE_NAVIGATOR_END
        },
        {
            key: 'product/issue-navigator/ui',
            startMark: $eeca211cf721329d$export$3a8025f2f3e0c64.ISSUE_NAVIGATOR_UI_START,
            endMark: $eeca211cf721329d$export$3a8025f2f3e0c64.ISSUE_NAVIGATOR_UI_END
        },
        {
            key: 'product/issue-navigator/ui/page-actions',
            startMark: $eeca211cf721329d$export$3a8025f2f3e0c64.PAGE_ACTIONS_START,
            endMark: $eeca211cf721329d$export$3a8025f2f3e0c64.PAGE_ACTIONS_END
        },
        {
            key: 'product/issue-navigator/ui/page-actions/view-switcher',
            startMark: $eeca211cf721329d$export$3a8025f2f3e0c64.PAGE_ACTIONS_VIEW_SWITCHER_START,
            endMark: $eeca211cf721329d$export$3a8025f2f3e0c64.PAGE_ACTIONS_VIEW_SWITCHER_END
        },
        {
            key: 'product/issue-navigator/ui/refinement',
            startMark: $eeca211cf721329d$export$3a8025f2f3e0c64.REFINEMENT_START,
            endMark: $eeca211cf721329d$export$3a8025f2f3e0c64.REFINEMENT_END
        },
        {
            key: 'product/issue-navigator/ui/issue-results',
            startMark: $eeca211cf721329d$export$3a8025f2f3e0c64.ISSUE_RESULTS_START,
            endMark: $eeca211cf721329d$export$3a8025f2f3e0c64.ISSUE_RESULTS_END
        },
        {
            key: 'product/issue-navigator/ui/issue-results/detail-view',
            startMark: $eeca211cf721329d$export$3a8025f2f3e0c64.ISSUE_RESULTS_DETAIL_VIEW_START,
            endMark: $eeca211cf721329d$export$3a8025f2f3e0c64.ISSUE_RESULTS_DETAIL_VIEW_END
        },
        {
            key: 'product/issue-navigator/ui/issue-results/detail-view/card-list',
            startMark: $eeca211cf721329d$export$3a8025f2f3e0c64.ISSUE_RESULTS_DETAIL_VIEW_CARD_LIST_START,
            endMark: $eeca211cf721329d$export$3a8025f2f3e0c64.ISSUE_RESULTS_DETAIL_VIEW_CARD_LIST_END
        },
        {
            key: 'product/issue-navigator/ui/issue-results/list-view',
            startMark: $eeca211cf721329d$export$3a8025f2f3e0c64.ISSUE_RESULTS_LIST_VIEW_START,
            endMark: $eeca211cf721329d$export$3a8025f2f3e0c64.ISSUE_RESULTS_LIST_VIEW_END
        },
        {
            key: 'product/issue-navigator/ui/issue-results/list-view/footer',
            startMark: $eeca211cf721329d$export$3a8025f2f3e0c64.ISSUE_RESULTS_LIST_VIEW_FOOTER_START,
            endMark: $eeca211cf721329d$export$3a8025f2f3e0c64.ISSUE_RESULTS_LIST_VIEW_FOOTER_END
        },
        {
            key: 'product/issue-navigator/ui/issue-app',
            startMark: $eeca211cf721329d$export$3a8025f2f3e0c64.ISSUE_APP_START,
            endMark: $eeca211cf721329d$export$3a8025f2f3e0c64.ISSUE_APP_END
        }
    ],
    featureFlags: $eeca211cf721329d$var$featureFlags
});
const $eeca211cf721329d$var$consumedMarks = [];
const $eeca211cf721329d$export$243d158112bae094 = (mark)=>{
    if (!$eeca211cf721329d$var$consumedMarks.includes(mark)) {
        $eeca211cf721329d$var$consumedMarks.push(mark);
        $eeca211cf721329d$export$248c6c208e271182.mark(mark);
        $eeca211cf721329d$export$8ba5b9245ec3f6f9.mark(mark);
    }
};

});
parcelRegister("6oH5O", function(module, exports) {

$parcel$export(module.exports, "JQL_BUILDER_PERFORMANCE_MARKS", () => $40075442b615ad27$export$5fd6d8ece357700d);
// Performance marks
const $40075442b615ad27$var$JQL_BUILDER_START = 'JQL_BUILDER_START';
const $40075442b615ad27$var$JQL_BUILDER_END = 'JQL_BUILDER_END';
const $40075442b615ad27$var$JQL_BUILDER_HYDRATE_START = 'JQL_BUILDER_HYDRATE_START';
const $40075442b615ad27$var$JQL_BUILDER_HYDRATE_END = 'JQL_BUILDER_HYDRATE_END';
const $40075442b615ad27$var$JQL_BUILDER_BASIC_START = 'JQL_BUILDER_BASIC_START';
const $40075442b615ad27$var$JQL_BUILDER_BASIC_END = 'JQL_BUILDER_BASIC_END';
const $40075442b615ad27$var$JQL_BUILDER_BASIC_JS_START = 'JQL_BUILDER_BASIC_JS_START';
const $40075442b615ad27$var$JQL_BUILDER_BASIC_JS_END = 'JQL_BUILDER_BASIC_JS_END';
const $40075442b615ad27$var$JQL_BUILDER_ADVANCED_START = 'JQL_BUILDER_ADVANCED_START';
const $40075442b615ad27$var$JQL_BUILDER_ADVANCED_END = 'JQL_BUILDER_ADVANCED_END';
const $40075442b615ad27$var$JQL_BUILDER_ADVANCED_JS_START = 'JQL_BUILDER_ADVANCED_JS_START';
const $40075442b615ad27$var$JQL_BUILDER_ADVANCED_JS_END = 'JQL_BUILDER_ADVANCED_JS_END';
const $40075442b615ad27$export$5fd6d8ece357700d = {
    JQL_BUILDER_START: /**
	 * JQL_BUILDER
	 * Count how long it takes to load the JQL Builder,
	 * from first render of async component to ready to use
	 */ $40075442b615ad27$var$JQL_BUILDER_START,
    JQL_BUILDER_END: $40075442b615ad27$var$JQL_BUILDER_END,
    JQL_BUILDER_HYDRATE_START: /**
	 * JQL_BUILDER_HYDRATE
	 * Count how long it takes from first try to use hydrated data
	 * to the momento is actually ready to use
	 */ $40075442b615ad27$var$JQL_BUILDER_HYDRATE_START,
    JQL_BUILDER_HYDRATE_END: $40075442b615ad27$var$JQL_BUILDER_HYDRATE_END,
    JQL_BUILDER_BASIC_JS_START: /**
	 * JQL_BUILDER_BASIC_JS
	 * Count how long it takes from FE perspective to load the basic JQL Builder Basic js package
	 */ $40075442b615ad27$var$JQL_BUILDER_BASIC_JS_START,
    JQL_BUILDER_BASIC_JS_END: $40075442b615ad27$var$JQL_BUILDER_BASIC_JS_END,
    JQL_BUILDER_BASIC_START: /**
	 * JQL_BUILDER_BASIC
	 * Count how long it takes to load the JQL Builder Basic,
	 * from first render of async basic component to ready to use
	 */ $40075442b615ad27$var$JQL_BUILDER_BASIC_START,
    JQL_BUILDER_BASIC_END: $40075442b615ad27$var$JQL_BUILDER_BASIC_END,
    JQL_BUILDER_ADVANCED_JS_START: /**
	 * JQL_BUILDER_ADVANCED_JS
	 * Count how long it takes from FE perspective to load the basic JQL Builder Advanced js package
	 */ $40075442b615ad27$var$JQL_BUILDER_ADVANCED_JS_START,
    JQL_BUILDER_ADVANCED_JS_END: $40075442b615ad27$var$JQL_BUILDER_ADVANCED_JS_END,
    JQL_BUILDER_ADVANCED_START: /**
	 * JQL_BUILDER_BASIC
	 * Count how long it takes to load the JQL Builder Advnaced,
	 * from first render of async advanced component to ready to use
	 */ $40075442b615ad27$var$JQL_BUILDER_ADVANCED_START,
    JQL_BUILDER_ADVANCED_END: $40075442b615ad27$var$JQL_BUILDER_ADVANCED_END
};

});


parcelRegister("651im", function(module, exports) {

$parcel$export(module.exports, "useAppContextualAnalyticsActions", () => $da8f29e5e5066bf4$export$8aad1a4e4d637906);
$parcel$export(module.exports, "AppContextualAnalytics", () => $da8f29e5e5066bf4$export$2942dddca20a92ac);

var $eUqFw = parcelRequire("eUqFw");

var $hompL = parcelRequire("hompL");

var $8WuJm = parcelRequire("8WuJm");

var $1yZQx = parcelRequire("1yZQx");
var $96gVp = parcelRequire("96gVp");
var $kEDjj = parcelRequire("kEDjj");
const $da8f29e5e5066bf4$var$Container = (0, $96gVp.createContainer)();
const $da8f29e5e5066bf4$var$Store = (0, $kEDjj.createStore)({
    containedBy: $da8f29e5e5066bf4$var$Container,
    initialState: {
        issueNavigatorSearchSessionId: undefined
    },
    actions: {
        onJourneyStart: ()=>({ setState: setState })=>{
                const issueNavigatorSearchSessionId = (0, (/*@__PURE__*/$parcel$interopDefault($hompL)))();
                setState({
                    issueNavigatorSearchSessionId: issueNavigatorSearchSessionId
                });
                return {
                    issueNavigatorSearchSessionId: issueNavigatorSearchSessionId
                };
            }
    }
});
const $da8f29e5e5066bf4$export$e1e7a4797df1a656 = (0, $1yZQx.createHook)($da8f29e5e5066bf4$var$Store, {
    selector: (state)=>state.issueNavigatorSearchSessionId
});
const $da8f29e5e5066bf4$export$8aad1a4e4d637906 = (0, $1yZQx.createActionsHook)($da8f29e5e5066bf4$var$Store);
const $da8f29e5e5066bf4$var$AppContextualAnalyticsData = ({ children: children })=>{
    const [issueNavigatorSearchSessionId] = $da8f29e5e5066bf4$export$e1e7a4797df1a656();
    const attributes = (0, $eUqFw.useMemo)(()=>({
            issueNavigatorSearchSessionId: issueNavigatorSearchSessionId
        }), [
        issueNavigatorSearchSessionId
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8WuJm.ContextualAnalyticsData), {
        sourceName: "issueNavigator",
        sourceType: (0, $41ea3621645e2acc$export$f636b5b56f1d624a),
        attributes: attributes
    }, children);
};
const $da8f29e5e5066bf4$export$2942dddca20a92ac = ({ children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($da8f29e5e5066bf4$var$Container, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($da8f29e5e5066bf4$var$AppContextualAnalyticsData, null, children));

});
// SCREENS
const $41ea3621645e2acc$export$f636b5b56f1d624a = 'Screen';
const $41ea3621645e2acc$export$9d2de6eebf7462b5 = 'Drawer';
const $41ea3621645e2acc$export$1171103ea9083ffa = 'Modal';
const $41ea3621645e2acc$export$cae2783c9279926 = 'InlineDialog';
const $41ea3621645e2acc$export$d1123261ca8831d2 = 'Dropdown';
const $41ea3621645e2acc$export$238d30785c4bca84 = 'Banner';
const $41ea3621645e2acc$export$a1562d08625f5d7e = 'UI';
const $41ea3621645e2acc$export$947dac6c72b26f81 = 'TRACK';
const $41ea3621645e2acc$export$f1d537d508d2945a = 'SCREEN';
const $41ea3621645e2acc$export$12346a674644c156 = 'OPERATIONAL';


parcelRegister("1ydM0", function(module, exports) {

$parcel$export(module.exports, "selectionState", () => $db8534d766ba6884$export$a01d720722806cd3);
$parcel$export(module.exports, "SelectedIssueContainer", () => $db8534d766ba6884$export$8b7bb55917259a5d);
$parcel$export(module.exports, "useSelectedIssueKey", () => $db8534d766ba6884$export$7cedcbfb2da7e49d);
$parcel$export(module.exports, "useSelectedIssueIndex", () => $db8534d766ba6884$export$a4b375f8f9b094ad);
$parcel$export(module.exports, "useFocusedIssueIndex", () => $db8534d766ba6884$export$4399fa4a8958cb76);
$parcel$export(module.exports, "useSelectedIssueDebouncedState", () => $db8534d766ba6884$export$ed5cb04ac9d88e95);
$parcel$export(module.exports, "useSelectedIssueStateActions", () => $db8534d766ba6884$export$ceb8ccaae9f88d93);
$parcel$export(module.exports, "useIssueSelectionState", () => $db8534d766ba6884$export$d703c03c23d04b26);
$parcel$export(module.exports, "useIsForcedSelectionOnReset", () => $db8534d766ba6884$export$800a67a9f72a46a2);
$parcel$export(module.exports, "useIsFullPageIssueAppMode", () => $db8534d766ba6884$export$988cbddd89e853c0);

var $krTJj = parcelRequire("krTJj");

var $eUqFw = parcelRequire("eUqFw");

var $iWLL0 = parcelRequire("iWLL0");

var $6vrw7 = parcelRequire("6vrw7");

var $96gVp = parcelRequire("96gVp");
var $1yZQx = parcelRequire("1yZQx");
var $kEDjj = parcelRequire("kEDjj");

var $jccNB = parcelRequire("jccNB");

var $3wKQY = parcelRequire("3wKQY");

var $cQBUE = parcelRequire("cQBUE");

var $4RwIp = parcelRequire("4RwIp");

var $dFxja = parcelRequire("dFxja");

const $db8534d766ba6884$var$Store = (0, $kEDjj.createStore)({
    initialState: {
        _rememoize: Date.now(),
        searchKey: '',
        selectedIssue: [
            null,
            (0, $6vrw7.toIssueKey)('')
        ],
        focusedIssue: null,
        nextResetStrategy: (0, $ab4105219851a7f3$export$6953d2fd44491a2f),
        isFullPageIssueAppMode: false
    },
    actions: $dFxja.default,
    name: 'IssueNavigatorSelectedIssueState'
});
const $db8534d766ba6884$export$a01d720722806cd3 = {
    ISSUE_SELECTED: 'ISSUE_SELECTED',
    BLANK_ISSUE_SELECTED: 'BLANK_ISSUE_SELECTED',
    NO_SELECTION: 'NO_SELECTION'
};
const $db8534d766ba6884$var$getSelectedIndex = (issueKeys, selectedIssueKey)=>{
    const index = selectedIssueKey && issueKeys ? issueKeys.indexOf(selectedIssueKey) : null;
    if (index !== null && index >= 0) // If key exists in result set, set selected index to the corresponding position
    return index;
    // Otherwise, set selected index to null (i.e. no visual selection)
    return null;
};
const $db8534d766ba6884$var$Container = (0, $96gVp.createContainer)($db8534d766ba6884$var$Store, {
    onInit: ()=>({ dispatch: dispatch, setState: setState }, { selectedIssueKey: selectedIssueKey, issueKeys: issueKeys, searchKey: searchKey, view: view })=>{
            const isFullPageIssueAppMode = Boolean(selectedIssueKey) && view === (0, $jccNB.views).list;
            const initialIssueKey = selectedIssueKey || dispatch((0, $dFxja.privateActions).getDefaultIssueKey()) || (0, $6vrw7.toIssueKey)('');
            const initialIndex = $db8534d766ba6884$var$getSelectedIndex(issueKeys, initialIssueKey);
            setState({
                _rememoize: Date.now(),
                selectedIssue: [
                    initialIndex,
                    initialIssueKey
                ],
                searchKey: searchKey,
                isFullPageIssueAppMode: isFullPageIssueAppMode
            });
        },
    onUpdate: ()=>({ getState: getState, setState: setState, dispatch: dispatch }, { selectedIssueKey: nextIssueKey, isFetching: isFetching, searchKey: searchKey, firstIssueKeyFromNextPage: firstIssueKeyFromNextPage, lastIssueKeyFromPreviousPage: lastIssueKeyFromPreviousPage })=>{
            if (isFetching) return;
            const state = getState();
            // Reset the selected issue whenever our search key has changed
            if (searchKey !== state.searchKey) {
                dispatch((0, $dFxja.privateActions).resetSelectedIssue(!!nextIssueKey));
                setState({
                    searchKey: searchKey
                });
            } else if (nextIssueKey) {
                // Call our set action to ensure the selected issue index is up to date.
                dispatch($db8534d766ba6884$var$Store.actions.setSelectedIssueByKey(nextIssueKey, false, false, false));
                // If an issue key has been specified while in list view then enter full page issue app mode.
                if (dispatch((0, $dFxja.privateActions).isListViewWithoutIssueApp())) dispatch($db8534d766ba6884$var$Store.actions.enterFullPageIssueAppMode());
                // If the issue key to select matches the first issue key from the next page then emit an event to go to
                // the next page.
                if (nextIssueKey === firstIssueKeyFromNextPage) dispatch($db8534d766ba6884$var$Store.actions.selectFirstIssueOnNextPage());
                else if (nextIssueKey === lastIssueKeyFromPreviousPage) dispatch($db8534d766ba6884$var$Store.actions.selectLastIssueOnPreviousPage());
            } else if (dispatch((0, $dFxja.privateActions).isListViewWithIssueAppAndKey())) dispatch($db8534d766ba6884$var$Store.actions.exitFullPageIssueAppMode());
        }
});
const $db8534d766ba6884$export$8b7bb55917259a5d = ({ selectedIssueKey: selectedIssueKey, issueResults: issueResults, ...props })=>{
    const [{ view: view }] = (0, $4RwIp.useSelectedViewState)();
    const { isFetching: isFetching, searchKey: searchKey, onIssueSearchForPage: onIssueSearchForPage, onIssueSearchForNextPage: onIssueSearchForNextPage, onIssueSearchForPreviousPage: onIssueSearchForPreviousPage } = (0, $cQBUE.useIssueSearchQuery)();
    // eslint-disable-next-line @atlassian/relay/query-restriction
    const issueData = (0, $iWLL0.useFragment)((0, $krTJj.default), issueResults);
    const { firstIssuePosition: firstIssuePosition, lastIssuePosition: lastIssuePosition, firstIssueKeyFromNextPage: firstIssueKeyFromNextPage, lastIssueKeyFromPreviousPage: lastIssueKeyFromPreviousPage } = issueData?.issueNavigatorPageInfo ?? {};
    const issueKeys = (0, $eUqFw.useMemo)(()=>issueData?.edges?.map((edge)=>(0, $6vrw7.toIssueKey)(edge?.node?.key ?? '')) ?? [], [
        issueData?.edges
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($db8534d766ba6884$var$Container, {
        isFetching: isFetching,
        searchKey: searchKey,
        selectedIssueKey: selectedIssueKey,
        issueKeys: issueKeys,
        view: (0, $3wKQY.convertToView)(view),
        onPageChange: onIssueSearchForPage,
        onNextPage: onIssueSearchForNextPage,
        onPreviousPage: onIssueSearchForPreviousPage,
        firstIssuePosition: firstIssuePosition ?? null,
        lastIssuePosition: lastIssuePosition ?? null,
        firstIssueKeyFromNextPage: firstIssueKeyFromNextPage ?? null,
        lastIssueKeyFromPreviousPage: lastIssueKeyFromPreviousPage ?? null,
        ...props
    });
};
const $db8534d766ba6884$export$7cedcbfb2da7e49d = (0, $1yZQx.createHook)($db8534d766ba6884$var$Store, {
    selector: ({ selectedIssue: selectedIssue })=>selectedIssue[1]
});
const $db8534d766ba6884$export$a4b375f8f9b094ad = (0, $1yZQx.createHook)($db8534d766ba6884$var$Store, {
    selector: ({ selectedIssue: selectedIssue })=>selectedIssue[0]
});
const $db8534d766ba6884$export$4399fa4a8958cb76 = (0, $1yZQx.createHook)($db8534d766ba6884$var$Store, {
    selector: ({ focusedIssue: focusedIssue })=>focusedIssue
});
const $db8534d766ba6884$export$ed5cb04ac9d88e95 = (0, $1yZQx.createHook)($db8534d766ba6884$var$Store, {
    selector: (0, $3wKQY.createRememoizeSelector)((state)=>state, ({ selectedIssue: selectedIssue })=>selectedIssue[1])
});
const $db8534d766ba6884$export$ceb8ccaae9f88d93 = (0, $1yZQx.createHook)($db8534d766ba6884$var$Store, {
    selector: null
});
const $db8534d766ba6884$export$d703c03c23d04b26 = (0, $1yZQx.createHook)($db8534d766ba6884$var$Store, {
    selector: ({ selectedIssue: selectedIssue })=>{
        if (selectedIssue[0] !== null && selectedIssue[1].length > 0) return $db8534d766ba6884$export$a01d720722806cd3.ISSUE_SELECTED;
        if (selectedIssue[0] !== null && selectedIssue[1].length === 0) return $db8534d766ba6884$export$a01d720722806cd3.BLANK_ISSUE_SELECTED;
        return $db8534d766ba6884$export$a01d720722806cd3.NO_SELECTION;
    }
});
const $db8534d766ba6884$export$800a67a9f72a46a2 = (0, $1yZQx.createHook)($db8534d766ba6884$var$Store, {
    selector: ({ nextResetStrategy: nextResetStrategy })=>nextResetStrategy === (0, $ab4105219851a7f3$export$7438b768c88f1c5b) || nextResetStrategy === (0, $ab4105219851a7f3$export$9d24b8100c251252)
});
const $db8534d766ba6884$export$988cbddd89e853c0 = (0, $1yZQx.createHook)($db8534d766ba6884$var$Store, {
    selector: ({ isFullPageIssueAppMode: isFullPageIssueAppMode })=>isFullPageIssueAppMode
});

});
parcelRegister("krTJj", function(module, exports) {

$parcel$export(module.exports, "default", () => $71286555b3f77989$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<11d520e79b36b2ae2ede3602da1ec555>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $71286555b3f77989$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "selectedIssueState_issueNavigator_SelectedIssueContainer",
    "selections": [
        {
            "concreteType": "JiraIssueEdge",
            "kind": "LinkedField",
            "name": "edges",
            "plural": true,
            "selections": [
                {
                    "concreteType": "JiraIssue",
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "key"
                        }
                    ]
                }
            ]
        },
        {
            "concreteType": "JiraIssueNavigatorPageInfo",
            "kind": "LinkedField",
            "name": "issueNavigatorPageInfo",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "firstIssuePosition"
                },
                {
                    "kind": "ScalarField",
                    "name": "lastIssuePosition"
                },
                {
                    "kind": "ScalarField",
                    "name": "firstIssueKeyFromNextPage"
                },
                {
                    "kind": "ScalarField",
                    "name": "lastIssueKeyFromPreviousPage"
                }
            ]
        }
    ],
    "type": "JiraIssueConnection"
};
$71286555b3f77989$var$node.hash = "44f9584373caeac4e6403c35d0ddb500";
var $71286555b3f77989$export$2e2bcd8739ae039 = $71286555b3f77989$var$node;

});

parcelRegister("cQBUE", function(module, exports) {

$parcel$export(module.exports, "useIssueSearchQuery", () => $1a73b4f227531979$export$11659072884978f5);
$parcel$export(module.exports, "IssueSearchQueryProvider", () => $1a73b4f227531979$export$3f36a9df094c3109);

var $025Ej = parcelRequire("025Ej");

var $idw3X = parcelRequire("idw3X");

var $eUqFw = parcelRequire("eUqFw");

var $jG2Eu = parcelRequire("jG2Eu");

var $iWLL0 = parcelRequire("iWLL0");

var $5as0a = parcelRequire("5as0a");

var $hzcvF = parcelRequire("hzcvF");

var $5iZBp = parcelRequire("5iZBp");

var $8WuJm = parcelRequire("8WuJm");
var $jMP2a = parcelRequire("jMP2a");
var $bFzGY = parcelRequire("bFzGY");

var $6yplV = parcelRequire("6yplV");

var $jccNB = parcelRequire("jccNB");

var $3wKQY = parcelRequire("3wKQY");

var $3mEVr = parcelRequire("3mEVr");

var $fsuyl = parcelRequire("fsuyl");

var $KuaNm = parcelRequire("KuaNm");

var $jAg40 = parcelRequire("jAg40");

var $edbn4 = parcelRequire("edbn4");

var $9rcnc = parcelRequire("9rcnc");
// Maximum number of times we will attempt to backfill our page of issues, e.g. if the user refreshes on page 3 but
// there are only 100 issues then we refresh page 2.
const $1a73b4f227531979$var$MAX_BACKFILL_RETRIES = 1;
const $1a73b4f227531979$var$IssueSearchQueryContext = /*#__PURE__*/ (0, $eUqFw.createContext)({
    isFetching: false,
    isRefreshing: false,
    hasViewIdChanged: false,
    isNetworkError: false,
    isStalePage: false,
    onDeleteIssue: ()=>'',
    onFetchUncappedTotalIssueCount: (0, (/*@__PURE__*/$parcel$interopDefault($jG2Eu))),
    onIssueSearch: (0, (/*@__PURE__*/$parcel$interopDefault($jG2Eu))),
    onIssueSearchForPage: (0, (/*@__PURE__*/$parcel$interopDefault($jG2Eu))),
    onIssueSearchForCurrentPage: (0, (/*@__PURE__*/$parcel$interopDefault($jG2Eu))),
    onIssueSearchForNextPage: ()=>false,
    onIssueSearchForPreviousPage: ()=>false,
    onIssueSearchForView: (0, (/*@__PURE__*/$parcel$interopDefault($jG2Eu))),
    onIssueSearchRefresh: (0, (/*@__PURE__*/$parcel$interopDefault($jG2Eu))),
    onIssueByFieldsRefetch: (0, (/*@__PURE__*/$parcel$interopDefault($jG2Eu))),
    searchKey: '',
    uncappedTotalIssueCount: {
        ...(0, $jAg40.uncappedTotalInitialState)
    }
});
$1a73b4f227531979$var$IssueSearchQueryContext.displayName = 'IssueSearchQueryContext';
const $1a73b4f227531979$export$11659072884978f5 = ()=>(0, $eUqFw.useContext)($1a73b4f227531979$var$IssueSearchQueryContext);
const $1a73b4f227531979$export$3f36a9df094c3109 = ({ refetch: refetch, issueResults: issueResults, view: view, query: query, onPageDataLoad: onPageDataLoad, onChangePage: onChangePage, children: children })=>{
    /* eslint-disable @atlassian/relay/unused-fields, @atlassian/relay/query-restriction */ const issueResultsData = (0, $iWLL0.useFragment)((0, $idw3X.default), issueResults);
    const viewData = (0, $iWLL0.useFragment)((0, $025Ej.default), view);
    /* eslint-enable @atlassian/relay/unused-fields, @atlassian/relay/query-restriction */ const [isRefreshing, setIsRefreshing] = (0, $eUqFw.useState)(false);
    const { jql: jql, filterId: filterId } = (0, $3mEVr.useActiveJql)();
    // Track if a refetch action is about to be called due to changing issueSearchInput
    const willFetch = (0, $eUqFw.useRef)(false);
    // Track currently selected view as a ref which will be used as an argument for any issue search queries
    const selectedViewId = (0, $eUqFw.useRef)((0, $3wKQY.parseIssueNavigatorViewIdOrDefault)(viewData?.viewId, (0, $jccNB.DEFAULT_VIEW_ID)));
    // Only a fixed set of input variables are recomputed for our refetch query.
    const issueSearchInput = (0, $eUqFw.useMemo)(()=>jql === undefined && (0, $5as0a.isFilterId)(filterId) ? {
            filterId: filterId
        } : {
            jql: jql
        }, [
        filterId,
        jql
    ]);
    const prevIssueSearchInput = (0, $hzcvF.usePreviousWithInitial)(issueSearchInput);
    const fieldSetIds = (0, $eUqFw.useMemo)(()=>viewData?.fieldSets?.edges.filter((0, $3wKQY.isNonNullish)).map(({ node: { fieldSetId: fieldSetId } })=>fieldSetId) ?? [], [
        viewData?.fieldSets?.edges
    ]);
    const { onIssueSearchFail: onIssueSearchFail } = (0, $fsuyl.useExperienceAnalytics)(onPageDataLoad, selectedViewId.current);
    const { isFetching: isFetching, hasViewIdChanged: hasViewIdChanged, isNetworkError: isNetworkError, onIssueSearchRefetch: onIssueSearchRefetch, onIssueByFieldsRefetch: onIssueByFieldsRefetch, searchKey: searchKey, uncappedTotalIssueCount: uncappedTotalIssueCount, onFetchUncappedTotalIssueCount: onFetchUncappedTotalIssueCount } = (0, $KuaNm.useIssueSearchRefetch)(refetch, query, issueSearchInput, selectedViewId.current, issueResultsData?.__id, fieldSetIds, onIssueSearchFail);
    const onIssueSearch = (0, $eUqFw.useCallback)(()=>{
        // Execute a new search against the network with current JQL input arguments
        onIssueSearchRefetch({}, {
            fetchPolicy: 'network-only'
        });
    }, [
        onIssueSearchRefetch
    ]);
    const hasIssueSearchInputChanged = !(0, $5iZBp.isShallowEqual)(issueSearchInput, prevIssueSearchInput);
    if (hasIssueSearchInputChanged) // We track this during render instead of waiting for useEffect to fire so there is no intermediary render for
    // downstream components where `jql` has changed but `isFetching` is still false.
    willFetch.current = true;
    (0, $eUqFw.useEffect)(()=>{
        if (hasIssueSearchInputChanged) {
            willFetch.current = false;
            const shouldLoadWithFilterViewId = selectedViewId.current !== 'detail' && issueSearchInput.filterId && (0, $5as0a.isCustomFilter)(issueSearchInput.filterId);
            const isCurrentViewIdInvalid = (0, $3wKQY.isFilterViewId)(selectedViewId.current) && selectedViewId.current !== `list_filter_${filterId}`;
            if (issueSearchInput.filterId && shouldLoadWithFilterViewId) {
                selectedViewId.current = (0, $3wKQY.convertFilterIdToIssueNavigatorId)(issueSearchInput.filterId);
                onIssueSearchRefetch({
                    viewId: selectedViewId.current
                }, {
                    fetchPolicy: 'network-only'
                });
            } else if (isCurrentViewIdInvalid) {
                selectedViewId.current = (0, $jccNB.DEFAULT_VIEW_ID);
                onIssueSearchRefetch({
                    viewId: selectedViewId.current
                }, {
                    fetchPolicy: 'network-only'
                });
            } else onIssueSearch();
        }
    }, [
        filterId,
        hasIssueSearchInputChanged,
        issueSearchInput,
        onIssueSearch,
        onIssueSearchRefetch,
        prevIssueSearchInput
    ]);
    const cursors = issueResultsData?.pageCursors?.around;
    const currentPageIndex = (0, $eUqFw.useMemo)(()=>cursors?.findIndex((cursor)=>cursor?.isCurrent) ?? -1, [
        cursors
    ]);
    const currentPage = currentPageIndex > -1 ? cursors?.[currentPageIndex] : undefined;
    const currentPageCursor = currentPage?.cursor ?? null;
    const currentPageNumber = currentPage?.pageNumber ?? 1;
    // Ignoring linting errors for the conditional call as the FF does not change during runtime
    const onSelectedViewMutation = (0, $edbn4.useSelectedViewMutation)();
    const isAnonymous = (0, $6yplV.useIsAnonymous)();
    /**
   * This will refetch issue and field configuration data for the provided view.
   */ const onIssueSearchForView = (0, $eUqFw.useCallback)((newViewId)=>{
        // Only allow non-anonymous users to invoke the mutation to update the user preference
        if (!isAnonymous && (0, $3wKQY.convertToView)(newViewId) !== (0, $3wKQY.convertToView)(selectedViewId.current)) onSelectedViewMutation(newViewId);
        // Update our viewId according to the selected view and refetch our issue data
        selectedViewId.current = newViewId;
        // If we have no currentPageCursor then we can assume our search has failed. In this case we need to force a
        // network call as otherwise Relay will serve null data from cache.
        const options = {
            isNewSearchKey: false,
            fetchPolicy: 'network-only'
        };
        onIssueSearchRefetch({
            after: currentPageCursor,
            viewId: selectedViewId.current
        }, options);
    }, [
        currentPageCursor,
        isAnonymous,
        onIssueSearchRefetch,
        onSelectedViewMutation
    ]);
    /**
   * Event emitted when an issue is deleted.
   */ const onDeleteIssue = (0, $9rcnc.useOnDeleteIssue)(issueResultsData);
    /**
   * This will refetch issue and field configuration data for the provided page cursor.
   */ const onIssueSearchForPage = (0, $eUqFw.useCallback)((after, options)=>{
        onIssueSearchRefetch({
            after: after
        }, options);
        onChangePage && onChangePage();
    }, [
        onChangePage,
        onIssueSearchRefetch
    ]);
    const onIssueSearchForNextPage = (0, $eUqFw.useCallback)((options)=>{
        if (currentPageIndex > -1) {
            const nextPage = cursors?.[currentPageIndex + 1];
            if (nextPage && nextPage.cursor != null) {
                onIssueSearchForPage(nextPage.cursor, options);
                return true;
            }
        }
        return false;
    }, [
        currentPageIndex,
        cursors,
        onIssueSearchForPage
    ]);
    const onIssueSearchForPreviousPage = (0, $eUqFw.useCallback)((options)=>{
        if (currentPageIndex > 0) {
            const previousPage = cursors?.[currentPageIndex - 1];
            if (previousPage && previousPage.cursor != null) {
                onIssueSearchForPage(previousPage.cursor, options);
                return true;
            }
        }
        return false;
    }, [
        currentPageIndex,
        cursors,
        onIssueSearchForPage
    ]);
    /**
   * This will refetch issue and field configuration data for the current page.
   */ const onIssueSearchForCurrentPage = (0, $eUqFw.useCallback)(()=>{
        onIssueSearchRefetch({
            after: currentPageCursor
        }, {
            fetchPolicy: 'network-only',
            isNewSearchKey: false
        });
    }, [
        currentPageCursor,
        onIssueSearchRefetch
    ]);
    /**
   * This will refresh issue and field configuration data for the provided page number (or current page if no page
   * number is given), triggering a new search using offset based pagination.
   */ const onIssueSearchRefresh = (0, $eUqFw.useCallback)((pageNumber = currentPageNumber)=>{
        setIsRefreshing(true);
        // Offset based request - API will run a new (i.e. non-stable) search for the given range
        onIssueSearchRefetch({
            first: pageNumber * (0, $jccNB.MAX_ISSUES_PER_PAGE),
            last: (0, $jccNB.MAX_ISSUES_PER_PAGE)
        }, {
            fetchPolicy: 'network-only',
            onComplete: ()=>{
                setIsRefreshing(false);
            },
            onError: ()=>{
                setIsRefreshing(false);
            },
            onUnsubscribe: ()=>{
                setIsRefreshing(false);
            }
        });
    }, [
        currentPageNumber,
        onIssueSearchRefetch
    ]);
    const backfillRetryCount = (0, $eUqFw.useRef)(0);
    const edges = issueResultsData?.edges ?? [];
    const total = issueResultsData?.totalIssueSearchResultCount ?? 0;
    const isStalePage = total > 0 && edges.length === 0;
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bFzGY.useAnalyticsEvents)();
    const prevIssueResultsData = (0, $hzcvF.usePrevious)(issueResultsData);
    /**
   * Handle the edge case where the user refreshes a page (e.g. page 3) and there are no issues present on the page.
   * In this scenario we automatically trigger a refresh request for the last available page with issues.
   */ (0, $eUqFw.useLayoutEffect)(()=>{
        if (issueResultsData !== prevIssueResultsData) {
            if (isStalePage && backfillRetryCount.current <= $1a73b4f227531979$var$MAX_BACKFILL_RETRIES) {
                const pageNumber = // If we've reached our limit then fallback to page 1
                backfillRetryCount.current === $1a73b4f227531979$var$MAX_BACKFILL_RETRIES ? 1 : Math.ceil(total / (0, $jccNB.MAX_ISSUES_PER_PAGE));
                onIssueSearchRefresh(pageNumber);
                backfillRetryCount.current += 1;
                (0, $jMP2a.fireOperationalAnalytics)(createAnalyticsEvent({}), 'issueSearchResults backfill');
                return;
            }
            backfillRetryCount.current = 0;
        }
    }, [
        createAnalyticsEvent,
        issueResultsData,
        prevIssueResultsData,
        isStalePage,
        onIssueSearchRefresh,
        total
    ]);
    const contextValue = (0, $eUqFw.useMemo)(()=>({
            isFetching: isFetching || willFetch.current,
            isRefreshing: isRefreshing,
            hasViewIdChanged: hasViewIdChanged,
            isNetworkError: isNetworkError,
            isStalePage: isStalePage,
            searchKey: searchKey,
            onDeleteIssue: onDeleteIssue,
            onIssueSearch: onIssueSearch,
            onIssueSearchForPage: onIssueSearchForPage,
            onIssueSearchForCurrentPage: onIssueSearchForCurrentPage,
            onIssueSearchForNextPage: onIssueSearchForNextPage,
            onIssueSearchForPreviousPage: onIssueSearchForPreviousPage,
            onIssueSearchForView: onIssueSearchForView,
            onIssueSearchRefresh: onIssueSearchRefresh,
            onIssueByFieldsRefetch: onIssueByFieldsRefetch,
            onFetchUncappedTotalIssueCount: onFetchUncappedTotalIssueCount,
            uncappedTotalIssueCount: uncappedTotalIssueCount
        }), [
        isFetching,
        isRefreshing,
        hasViewIdChanged,
        isNetworkError,
        isStalePage,
        searchKey,
        onDeleteIssue,
        onIssueSearch,
        onIssueSearchForPage,
        onIssueSearchForCurrentPage,
        onIssueSearchForNextPage,
        onIssueSearchForPreviousPage,
        onIssueSearchForView,
        onIssueSearchRefresh,
        onIssueByFieldsRefetch,
        onFetchUncappedTotalIssueCount,
        uncappedTotalIssueCount
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8WuJm.ContextualAnalyticsData), {
        attributes: {
            issuesLoaded: total
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($1a73b4f227531979$var$IssueSearchQueryContext.Provider, {
        value: contextValue
    }, children));
};

});
parcelRegister("025Ej", function(module, exports) {

$parcel$export(module.exports, "default", () => $1e3345995e17f7d6$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<cc976390fd8b29859278e8cbe5af37b2>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $1e3345995e17f7d6$var$node = {
    "argumentDefinitions": [
        {
            "kind": "RootArgument",
            "name": "amountOfColumns"
        }
    ],
    "kind": "Fragment",
    "name": "issueSearchQuery_issueNavigator_IssueSearchQueryProvider_view",
    "selections": [
        {
            "kind": "RequiredField",
            "field": {
                "kind": "ScalarField",
                "name": "viewId"
            },
            "action": "THROW",
            "path": "viewId"
        },
        {
            "kind": "RequiredField",
            "field": {
                "args": [
                    {
                        "kind": "Literal",
                        "name": "filter",
                        "value": {
                            "fieldSetSelectedState": "SELECTED"
                        }
                    },
                    {
                        "kind": "Variable",
                        "name": "first",
                        "variableName": "amountOfColumns"
                    }
                ],
                "concreteType": "JiraIssueSearchFieldSetConnection",
                "kind": "LinkedField",
                "name": "fieldSets",
                "plural": false,
                "selections": [
                    {
                        "kind": "RequiredField",
                        "field": {
                            "concreteType": "JiraIssueSearchFieldSetEdge",
                            "kind": "LinkedField",
                            "name": "edges",
                            "plural": true,
                            "selections": [
                                {
                                    "kind": "RequiredField",
                                    "field": {
                                        "concreteType": "JiraIssueSearchFieldSet",
                                        "kind": "LinkedField",
                                        "name": "node",
                                        "plural": false,
                                        "selections": [
                                            {
                                                "kind": "RequiredField",
                                                "field": {
                                                    "kind": "ScalarField",
                                                    "name": "fieldSetId"
                                                },
                                                "action": "THROW",
                                                "path": "fieldSets.edges.node.fieldSetId"
                                            }
                                        ]
                                    },
                                    "action": "THROW",
                                    "path": "fieldSets.edges.node"
                                }
                            ]
                        },
                        "action": "THROW",
                        "path": "fieldSets.edges"
                    }
                ]
            },
            "action": "THROW",
            "path": "fieldSets"
        }
    ],
    "type": "JiraIssueSearchView"
};
$1e3345995e17f7d6$var$node.hash = "73c821f489985ab33d96817dee8a6600";
var $1e3345995e17f7d6$export$2e2bcd8739ae039 = $1e3345995e17f7d6$var$node;

});

parcelRegister("idw3X", function(module, exports) {

$parcel$export(module.exports, "default", () => $b0810963df552b4b$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<f5558bea4509b675d4b93f377171ac71>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $b0810963df552b4b$var$node = function() {
    var v0 = {
        "kind": "ClientExtension",
        "selections": [
            {
                "kind": "ScalarField",
                "name": "__id"
            }
        ]
    };
    return {
        "argumentDefinitions": [],
        "kind": "Fragment",
        "name": "issueSearchQuery_issueNavigator_IssueSearchQueryProvider_issueResults",
        "selections": [
            {
                "concreteType": "JiraIssueEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                    {
                        "concreteType": "JiraIssue",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                            {
                                "kind": "ScalarField",
                                "name": "key"
                            }
                        ]
                    },
                    v0 /*: any*/ 
                ]
            },
            {
                "kind": "ScalarField",
                "name": "totalIssueSearchResultCount"
            },
            {
                "args": [
                    {
                        "kind": "Literal",
                        "name": "maxCursors",
                        "value": 7
                    }
                ],
                "concreteType": "JiraPageCursors",
                "kind": "LinkedField",
                "name": "pageCursors",
                "plural": false,
                "selections": [
                    {
                        "concreteType": "JiraPageCursor",
                        "kind": "LinkedField",
                        "name": "around",
                        "plural": true,
                        "selections": [
                            {
                                "kind": "ScalarField",
                                "name": "cursor"
                            },
                            {
                                "kind": "ScalarField",
                                "name": "isCurrent"
                            },
                            {
                                "kind": "ScalarField",
                                "name": "pageNumber"
                            }
                        ]
                    }
                ],
                "storageKey": "pageCursors(maxCursors:7)"
            },
            v0 /*: any*/ 
        ],
        "type": "JiraIssueConnection"
    };
}();
$b0810963df552b4b$var$node.hash = "be5101b94f9ee67c52f693de30818ccb";
var $b0810963df552b4b$export$2e2bcd8739ae039 = $b0810963df552b4b$var$node;

});

parcelRegister("3mEVr", function(module, exports) {

$parcel$export(module.exports, "useActiveJql", () => $54d21fadf94bae18$export$caeaf867313163e4);
$parcel$export(module.exports, "ActiveJqlProvider", () => $54d21fadf94bae18$export$c69a9a3114157ae7);
$parcel$export(module.exports, "useResolvedJql", () => $54d21fadf94bae18$export$23e17984875d36b4);

var $eUqFw = parcelRequire("eUqFw");

var $53ciZ = parcelRequire("53ciZ");

var $5as0a = parcelRequire("5as0a");
const $54d21fadf94bae18$var$ActiveJqlContext = /*#__PURE__*/ (0, $eUqFw.createContext)({
    jql: ''
});
$54d21fadf94bae18$var$ActiveJqlContext.displayName = 'ActiveJqlContext';
const $54d21fadf94bae18$export$caeaf867313163e4 = ()=>(0, $eUqFw.useContext)($54d21fadf94bae18$var$ActiveJqlContext);
const $54d21fadf94bae18$export$c69a9a3114157ae7 = ({ jql: jql, filterId: filterId, isFilterEditable: isFilterEditable, filterJql: filterJql, children: children })=>{
    const contextValue = (0, $eUqFw.useMemo)(()=>({
            jql: jql,
            filterId: filterId,
            isFilterEditable: isFilterEditable,
            filterJql: filterJql
        }), [
        jql,
        filterId,
        isFilterEditable,
        filterJql
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($54d21fadf94bae18$var$ActiveJqlContext.Provider, {
        value: contextValue
    }, children);
};
const $54d21fadf94bae18$export$23e17984875d36b4 = ()=>{
    const { jql: jql, filterJql: filterJql } = $54d21fadf94bae18$export$caeaf867313163e4();
    const filter = filterJql !== undefined ? filterJql : '';
    return jql !== undefined ? jql : filter;
};
const $54d21fadf94bae18$export$5d3c8489d1ae8bee = ()=>{
    const { filterId: filterId, jql: jql } = $54d21fadf94bae18$export$caeaf867313163e4();
    return `/issues/?${(0, $53ciZ.stringify)({
        jql: jql,
        ...(0, $5as0a.isFilterId)(filterId) ? {
            filter: filterId
        } : {}
    })}`;
};

});

parcelRegister("fsuyl", function(module, exports) {

$parcel$export(module.exports, "useExperienceAnalytics", () => $15469ae391633960$export$523b242362f30838);

var $eUqFw = parcelRequire("eUqFw");

var $dxIU5 = parcelRequire("dxIU5");

var $4qhD6 = parcelRequire("4qhD6");
var $bDhRl = parcelRequire("bDhRl");
var $fDZ6r = parcelRequire("fDZ6r");

var $jMP2a = parcelRequire("jMP2a");
var $bFzGY = parcelRequire("bFzGY");

var $jccNB = parcelRequire("jccNB");
/**
 * This debouncer is shared between both the success and fail calls so that the last one called in the current event
 * loop tick is the one that gets logged. This helps us overcome weaknesses in the Relay-based rendering where an error
 * being thrown taks an additional render cycle to reach the component managing the analytics.
 */ const $15469ae391633960$var$sharedDebouncer = (0, (/*@__PURE__*/$parcel$interopDefault($dxIU5)))((action)=>action(), 0);
const $15469ae391633960$export$523b242362f30838 = (/**
	 * Event emitted when page data has loaded and the key experience is interactive.
	 */ onPageDataLoad, /**
	 * Currently selected view mode.
	 */ view, /**
	 * Analytics attributes to be emitted as part of success/fail experience events.
	 */ attributes)=>{
    const onExperienceStart = (0, $bDhRl.useExperienceStart)({
        experience: (0, $jccNB.EXPERIENCE_NAME),
        experienceId: undefined,
        analyticsSource: (0, $jccNB.ANALYTICS_SOURCE)
    });
    const onExperienceSuccess = (0, $fDZ6r.useExperienceSuccess)({
        experience: (0, $jccNB.EXPERIENCE_NAME),
        attributes: attributes
    });
    const onExperienceFail = (0, $4qhD6.useExperienceFail)({
        experience: (0, $jccNB.EXPERIENCE_NAME),
        attributes: attributes
    });
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bFzGY.useAnalyticsEvents)();
    const onFireUIAnalyticsEvent = (0, $eUqFw.useCallback)(()=>{
        const event = createAnalyticsEvent({
            action: 'viewed',
            actionSubject: 'screen'
        });
        (0, $jMP2a.fireUIAnalytics)(event, 'issueSearchResults', attributes ?? {});
    }, [
        attributes,
        createAnalyticsEvent
    ]);
    const onIssueSearchSuccess = (0, $eUqFw.useCallback)(()=>{
        $15469ae391633960$var$sharedDebouncer(()=>{
            onExperienceStart();
            onExperienceSuccess();
            onFireUIAnalyticsEvent();
        });
        onPageDataLoad && onPageDataLoad(view);
    }, [
        onExperienceStart,
        onExperienceSuccess,
        onFireUIAnalyticsEvent,
        onPageDataLoad,
        view
    ]);
    const onIssueSearchFail = (0, $eUqFw.useCallback)((location, error)=>{
        $15469ae391633960$var$sharedDebouncer(()=>{
            onExperienceStart();
            onExperienceFail(location, error);
        });
        onPageDataLoad && onPageDataLoad(view);
    }, [
        onExperienceFail,
        onExperienceStart,
        onPageDataLoad,
        view
    ]);
    return {
        onIssueSearchSuccess: onIssueSearchSuccess,
        onIssueSearchFail: onIssueSearchFail
    };
};

});

parcelRegister("KuaNm", function(module, exports) {

$parcel$export(module.exports, "useIssueSearchRefetch", () => $3d0f02e3cc973d83$export$b550b6912621dc5d);

var $eUqFw = parcelRequire("eUqFw");

var $lEfVV = parcelRequire("lEfVV");

var $hTLlD = parcelRequire("hTLlD");

var $iWLL0 = parcelRequire("iWLL0");

var $cNy9K = parcelRequire("cNy9K");

var $hompL = parcelRequire("hompL");

var $1ybV0 = parcelRequire("1ybV0");

var $eI5EY = parcelRequire("eI5EY");

var $eo17r = parcelRequire("eo17r");
var $k8Qyf = parcelRequire("k8Qyf");

var $hzcvF = parcelRequire("hzcvF");

var $gd0Sp = parcelRequire("gd0Sp");

var $jccNB = parcelRequire("jccNB");

var $jAg40 = parcelRequire("jAg40");

var $7YJjT = parcelRequire("7YJjT");

var $1toLw = parcelRequire("1toLw");
const $3d0f02e3cc973d83$var$searchErrorFlagId = (0, $eo17r.toFlagId)('ISSUE_NAVIGATOR_SEARCH_ERROR_FLAG');
const $3d0f02e3cc973d83$var$searchErrorFlag = {
    id: $3d0f02e3cc973d83$var$searchErrorFlagId,
    type: 'error',
    title: (0, $1toLw.default).searchFailedTitle,
    description: (0, $1toLw.default).searchFailedDescription
};
const $3d0f02e3cc973d83$export$b550b6912621dc5d = (refetch, query, issueSearchInput, viewId, connectionId, fieldSetIds, onIssueSearchFail)=>{
    /* eslint-enable @atlassian/relay/unused-fields, @atlassian/relay/query-restriction */ // Used to track and force a network-only request when a failed search has been cached
    const lastVariables = (0, $eUqFw.useRef)();
    const networkOnlyVariables = (0, $eUqFw.useRef)(new Set());
    const connectionIds = (0, $eUqFw.useRef)(new Set());
    const disposableOperations = (0, $eUqFw.useRef)(new Set());
    const [searchKey, setSearchKey] = (0, $eUqFw.useState)((0, (/*@__PURE__*/$parcel$interopDefault($hompL)))());
    const [isFetching, setIsFetching] = (0, $eUqFw.useState)(false);
    const [isNetworkError, setNetworkError] = (0, $eUqFw.useState)(false);
    const { cloudId: cloudId } = (0, $gd0Sp.useTenantContext)();
    const { uncappedTotalIssueCount: uncappedTotalIssueCount, resetTotalIssueCount: resetTotalIssueCount, onFetchUncappedTotalIssueCount: onFetchUncappedTotalIssueCount } = (0, $jAg40.useIssueSearchTotalCount)({
        cloudId: cloudId,
        issueSearchInput: issueSearchInput
    });
    const environment = (0, $iWLL0.useRelayEnvironment)();
    const { showFlag: showFlag, dismissFlag: dismissFlag } = (0, $k8Qyf.useFlagsService)();
    const prevViewId = (0, $hzcvF.usePreviousWithInitial)(viewId);
    const prevFieldSetIds = (0, $hzcvF.usePreviousWithInitial)(fieldSetIds);
    const inFlightRequest = (0, $eUqFw.useRef)();
    // Release data for each fetchQuery operation allowing them to be garbage collected by Relay
    const onDisposeOperations = (0, $eUqFw.useCallback)(()=>{
        disposableOperations.current.forEach((disposable)=>disposable.dispose());
        disposableOperations.current.clear();
    }, []);
    // Dispose operations on unmount. This happens automatically for Relay query hooks, but we need to do it ourselves
    // when using fetchQuery.
    (0, $eUqFw.useEffect)(()=>onDisposeOperations, [
        onDisposeOperations
    ]);
    const onIssueByFieldsRefetch = (0, $7YJjT.useIssueByFieldsRefetch)(fieldSetIds);
    /**
	 * Invalidate all tracked issue connections so any subsequent queries with a matching identifier will hit the
	 * network.
	 */ const onInvalidateIssueConnection = (0, $eUqFw.useCallback)(()=>{
        (0, $cNy9K.commitLocalUpdate)(environment, (store)=>{
            connectionIds.current.forEach((id)=>{
                const connection = store.get(id);
                connection && connection.invalidateRecord();
            });
            connectionIds.current.clear();
        });
    }, [
        environment
    ]);
    const onInvalidateAndDisposeIssueConnection = (0, $eUqFw.useCallback)(()=>{
        onInvalidateIssueConnection();
        onDisposeOperations();
    }, [
        onDisposeOperations,
        onInvalidateIssueConnection
    ]);
    (0, $eUqFw.useEffect)(()=>{
        // If our fieldSetIds have changed then we must invalidate our connections so we don't serve stale issue data
        // with mismatched field sets.
        if (!(0, (/*@__PURE__*/$parcel$interopDefault($hTLlD)))(fieldSetIds, prevFieldSetIds) && viewId === prevViewId) onInvalidateIssueConnection();
        if (connectionId !== undefined) // Track ids of our issue connections so they can be invalidated
        connectionIds.current.add(connectionId);
        else if (lastVariables.current) // If we do not receive a connection id then add the last used variables to our set of network-only
        // variables. This prevents us serving null responses from cache when there is no connection id to invalidate.
        networkOnlyVariables.current.add(lastVariables.current);
    });
    const onIssueSearchRefetch = (0, $eUqFw.useCallback)((variables, options)=>{
        // Some consumers may fire refetch queries before in-flight query
        // has been completed (e.g. while user is toggling columns on and off in
        // the column picker). In these situations, we always want to fetch latest
        // data from the API as column configuration may have changed for the user.
        // To do that, we disable Relay's automatic de-deduping of requests.
        inFlightRequest.current?.unsubscribe();
        const finalVariables = {
            cloudId: cloudId,
            issueSearchInput: issueSearchInput,
            first: (0, $jccNB.MAX_ISSUES_PER_PAGE),
            after: null,
            namespace: 'ISSUE_NAVIGATOR',
            viewId: viewId,
            options: null,
            fieldSetIds: [],
            shouldQueryFieldSetsById: false,
            amountOfColumns: (0, $jccNB.MAX_AMOUNT_OF_COLUMNS),
            filterId: null,
            isIssueSearchViewResultEnabled: (0, $1ybV0.ff)('handle-404-filter-errors-gracefully-in-the-ui-by-showing-filter-not-found-view_t3d2m'),
            queryStatusForIssuekeyStrikethrough: (0, $eI5EY.fg)('jiv-18659-query-status-for-issuekey-strikethrough'),
            ...variables
        };
        setIsFetching(true);
        setNetworkError(false);
        // Hide any search error flags currently visible
        dismissFlag($3d0f02e3cc973d83$var$searchErrorFlagId);
        let fetchPolicy = options?.fetchPolicy ?? 'store-or-network';
        // Check if our final variables match any of our network-only variables, and if so update the fetch policy.
        networkOnlyVariables.current.forEach((value)=>{
            if ((0, (/*@__PURE__*/$parcel$interopDefault($hTLlD)))(finalVariables, value)) {
                fetchPolicy = 'network-only';
                networkOnlyVariables.current.delete(value);
            }
        });
        if (fetchPolicy === 'network-only') onInvalidateAndDisposeIssueConnection();
        inFlightRequest.current = (0, $cNy9K.fetchQuery)(environment, query, finalVariables, {
            fetchPolicy: fetchPolicy,
            networkCacheConfig: {
                metadata: {
                    META_SLOW_ENDPOINT: true
                }
            }
        }).subscribe({
            complete: ()=>{
                /*
					 * fetchQuery will NOT retain the data for the query, meaning that it is not guaranteed that the
					 * data will remain saved in the Relay store at any point after the request completes.
					 * We need to explicitly retain the operation to ensure it doesn't get deleted.
					 * See https://relay.dev/docs/api-reference/fetch-query/#behavior
					 */ const operation = (0, $cNy9K.createOperationDescriptor)((0, $cNy9K.getRequest)(query), finalVariables);
                disposableOperations.current.add(environment.retain(operation));
                lastVariables.current = finalVariables;
                let hasStoreRefetchCompleted = false;
                // We need to batch these updates as without it, Relay will cause multiple renders and invoke the
                // onComplete callback multiple times. This causes our success/fail analytics events to become
                // unreliable.
                // We introduced a similar fix for fetchQuery (see src/packages/platform/graphql/relay-scheduler/src/index.js)
                // and in React 18 will be able to remove this in favour of the startTransition/useTransition APIs.
                (0, (/*@__PURE__*/$parcel$interopDefault($lEfVV))).unstable_batchedUpdates(()=>{
                    refetch(finalVariables, {
                        fetchPolicy: 'store-only',
                        onComplete: ()=>{
                            // Relay will dispose the cached operation after a 5m timeout, in which case it will
                            // refetch the query from the store and retrigger the onComplete callback. We need to
                            // ensure this callback is invoked strictly once to prevent unexpected side effects,
                            // e.g. https://jira.atlassian.com/browse/JRACLOUD-84106.
                            if (hasStoreRefetchCompleted) return;
                            hasStoreRefetchCompleted = true;
                            setIsFetching(false);
                            options?.onComplete && options.onComplete();
                            if (options?.isNewSearchKey ?? true) {
                                setSearchKey((0, (/*@__PURE__*/$parcel$interopDefault($hompL)))());
                                if (/*
										 * Once a refetch has completed, go back and inspect
										 * the request variables for the existence of an `after` cursor.
										 * If an `after` cursor was provided to the query, this means that
										 * the query was triggered via user navigating to a different page of
										 * results for the current search (I.e. by clicking pagination controls).
										 * For such events, do not reset the total issue count. We want it to
										 * be preserved across pagination.
										 */ !finalVariables.after) resetTotalIssueCount();
                            }
                        }
                    });
                });
            },
            error: (error)=>{
                setIsFetching(false);
                setNetworkError(true);
                onIssueSearchFail(`${(0, $jccNB.PACKAGE_NAME)}.issue-search-refetch`, error);
                showFlag($3d0f02e3cc973d83$var$searchErrorFlag);
                options?.onError && options.onError();
            },
            unsubscribe: ()=>{
                options?.onUnsubscribe && options.onUnsubscribe();
            }
        });
    }, [
        cloudId,
        issueSearchInput,
        viewId,
        dismissFlag,
        environment,
        query,
        onInvalidateAndDisposeIssueConnection,
        refetch,
        resetTotalIssueCount,
        onIssueSearchFail,
        showFlag
    ]);
    return {
        isFetching: isFetching,
        hasViewIdChanged: viewId !== prevViewId,
        isNetworkError: isNetworkError,
        onFetchUncappedTotalIssueCount: onFetchUncappedTotalIssueCount,
        onIssueSearchRefetch: onIssueSearchRefetch,
        onIssueByFieldsRefetch: onIssueByFieldsRefetch,
        searchKey: searchKey,
        uncappedTotalIssueCount: uncappedTotalIssueCount
    };
};

});
parcelRegister("jAg40", function(module, exports) {

$parcel$export(module.exports, "uncappedTotalInitialState", () => $74264aab25afb4c1$export$31250fb09166d65c);
$parcel$export(module.exports, "useIssueSearchTotalCount", () => $74264aab25afb4c1$export$409cb8d89f7323a6);

var $7HT6h = parcelRequire("7HT6h");

var $eUqFw = parcelRequire("eUqFw");

var $iWLL0 = parcelRequire("iWLL0");
const $74264aab25afb4c1$export$31250fb09166d65c = {
    count: undefined,
    isFetching: false,
    isError: false
};
const $74264aab25afb4c1$export$409cb8d89f7323a6 = ({ cloudId: cloudId, issueSearchInput: issueSearchInput })=>{
    const environment = (0, $iWLL0.useRelayEnvironment)();
    const [uncappedTotalIssueCount, setUncappedTotalIssueCount] = (0, $eUqFw.useState)({
        ...$74264aab25afb4c1$export$31250fb09166d65c
    });
    const resetTotalIssueCount = (0, $eUqFw.useCallback)(()=>{
        setUncappedTotalIssueCount({
            ...$74264aab25afb4c1$export$31250fb09166d65c
        });
    }, []);
    const onFetchUncappedTotalIssueCount = (0, $eUqFw.useCallback)(()=>{
        setUncappedTotalIssueCount({
            count: undefined,
            isFetching: true,
            isError: false
        });
        (0, $iWLL0.fetchQuery)(environment, (0, $7HT6h.default), {
            cloudId: cloudId,
            issueSearchInput: issueSearchInput
        }, {
            fetchPolicy: 'network-only',
            networkCacheConfig: {
                metadata: {
                    META_SLOW_ENDPOINT: true
                }
            }
        }).toPromise().then((data)=>{
            const count = data ? data.jira?.issueSearchTotalCount : null;
            let isError = false;
            if (count === null || count === undefined) isError = true;
            setUncappedTotalIssueCount({
                count: count,
                isFetching: false,
                isError: isError
            });
        }).catch(()=>{
            setUncappedTotalIssueCount({
                count: null,
                isFetching: false,
                isError: true
            });
        });
    }, [
        cloudId,
        environment,
        issueSearchInput
    ]);
    return (0, $eUqFw.useMemo)(()=>({
            uncappedTotalIssueCount: uncappedTotalIssueCount,
            resetTotalIssueCount: resetTotalIssueCount,
            onFetchUncappedTotalIssueCount: onFetchUncappedTotalIssueCount
        }), [
        uncappedTotalIssueCount,
        resetTotalIssueCount,
        onFetchUncappedTotalIssueCount
    ]);
};

});
parcelRegister("7HT6h", function(module, exports) {

$parcel$export(module.exports, "default", () => $c79110aa5f61d153$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<0a236f27c28dfc2d243f3bcac9e0ef56>>
 * @relayHash 929c7cfdabf85276ab021ca0aaf710c4
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID a3810891dc29174a6ad47903cc92470a66dff964fe69f524a8d29c29992b37a1
const $c79110aa5f61d153$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "cloudId"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "issueSearchInput"
        }
    ], v1 = [
        {
            "concreteType": "JiraQuery",
            "kind": "LinkedField",
            "name": "jira",
            "plural": false,
            "selections": [
                {
                    "args": [
                        {
                            "kind": "Variable",
                            "name": "cloudId",
                            "variableName": "cloudId"
                        },
                        {
                            "kind": "Variable",
                            "name": "issueSearchInput",
                            "variableName": "issueSearchInput"
                        }
                    ],
                    "kind": "ScalarField",
                    "name": "issueSearchTotalCount"
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "issueSearchTotalCountQuery",
            "selections": v1 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "issueSearchTotalCountQuery",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "id": "a3810891dc29174a6ad47903cc92470a66dff964fe69f524a8d29c29992b37a1",
            "metadata": {},
            "name": "issueSearchTotalCountQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$c79110aa5f61d153$var$node.hash = "37773194a6f16231c4993e21b36ed872";
var $c79110aa5f61d153$export$2e2bcd8739ae039 = $c79110aa5f61d153$var$node;

});


parcelRegister("7YJjT", function(module, exports) {

$parcel$export(module.exports, "useIssueByFieldsRefetch", () => $9b70cc47533bb463$export$a3f7fddb3e08cea5);

var $a9FDt = parcelRequire("a9FDt");

var $eUqFw = parcelRequire("eUqFw");

var $iWLL0 = parcelRequire("iWLL0");

var $cNy9K = parcelRequire("cNy9K");

var $gd0Sp = parcelRequire("gd0Sp");

var $jccNB = parcelRequire("jccNB");
const $9b70cc47533bb463$export$a3f7fddb3e08cea5 = (fieldSets)=>{
    const { cloudId: cloudId } = (0, $gd0Sp.useTenantContext)();
    const environment = (0, $iWLL0.useRelayEnvironment)();
    return (0, $eUqFw.useCallback)((issuekey)=>(0, $cNy9K.fetchQuery)(environment, /* eslint-disable @atlassian/relay/unused-fields, @atlassian/relay/must-colocate-fragment-spreads */ (0, $a9FDt.default), /* eslint-enable @atlassian/relay/unused-fields, @atlassian/relay/must-colocate-fragment-spreads */ {
            cloudId: cloudId,
            issueSearchInput: {
                jql: `issueKey=${issuekey}`
            },
            fieldSetIds: fieldSets,
            amountOfColumns: (0, $jccNB.MAX_AMOUNT_OF_COLUMNS)
        }, {
            fetchPolicy: 'network-only'
        }).toPromise(), [
        cloudId,
        environment,
        fieldSets
    ]);
};

});
parcelRegister("a9FDt", function(module, exports) {

$parcel$export(module.exports, "default", () => $4272320f3aceb63a$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<bc60c636c92aefdf68f80cdfeb2ff787>>
 * @relayHash 92374cf2e0e566b89cdefc3862d52528
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 0fa077c6c994de5f4e9e99d88f5ba16ac14180daca6a84b0c7006b2f3df54915

var $kpHqV = parcelRequire("kpHqV");

var $fY4Nv = parcelRequire("fY4Nv");
const $4272320f3aceb63a$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "amountOfColumns"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "cloudId"
    }, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "fieldSetIds"
    }, v3 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "issueSearchInput"
    }, v4 = [
        {
            "kind": "Variable",
            "name": "cloudId",
            "variableName": "cloudId"
        },
        {
            "kind": "Literal",
            "name": "first",
            "value": 1
        },
        {
            "kind": "Variable",
            "name": "issueSearchInput",
            "variableName": "issueSearchInput"
        }
    ], v5 = [
        {
            "kind": "Variable",
            "name": "fieldSetIds",
            "variableName": "fieldSetIds"
        },
        {
            "kind": "Variable",
            "name": "first",
            "variableName": "amountOfColumns"
        }
    ], v6 = {
        "kind": "ScalarField",
        "name": "type"
    }, v7 = {
        "kind": "ScalarField",
        "name": "__typename"
    }, v8 = {
        "kind": "ScalarField",
        "name": "fieldId"
    }, v9 = {
        "kind": "ScalarField",
        "name": "id"
    }, v10 = {
        "kind": "ScalarField",
        "name": "name"
    }, v11 = [
        v10 /*: any*/ ,
        v9 /*: any*/ 
    ], v12 = {
        "concreteType": "JiraFieldConfig",
        "kind": "LinkedField",
        "name": "fieldConfig",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "isRequired"
            }
        ]
    }, v13 = {
        "kind": "ClientExtension",
        "selections": [
            {
                "kind": "ScalarField",
                "name": "lazyIsEditableInIssueView"
            }
        ]
    }, v14 = {
        "kind": "ScalarField",
        "name": "key"
    }, v15 = {
        "kind": "ScalarField",
        "name": "text"
    }, v16 = {
        "kind": "ScalarField",
        "name": "statusCategoryId"
    }, v17 = {
        "concreteType": "JiraStatusCategory",
        "kind": "LinkedField",
        "name": "statusCategory",
        "plural": false,
        "selections": [
            v16 /*: any*/ ,
            v9 /*: any*/ 
        ]
    }, v18 = [
        {
            "kind": "Literal",
            "name": "first",
            "value": 1000
        }
    ], v19 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "concreteType": "JiraIssueType",
                "kind": "LinkedField",
                "name": "issueType",
                "plural": false,
                "selections": [
                    {
                        "concreteType": "JiraAvatar",
                        "kind": "LinkedField",
                        "name": "avatar",
                        "plural": false,
                        "selections": [
                            {
                                "kind": "ScalarField",
                                "name": "small"
                            }
                        ]
                    },
                    v10 /*: any*/ ,
                    v9 /*: any*/ 
                ]
            }
        ],
        "type": "JiraIssueTypeField"
    }, v20 = {
        "concreteType": "JiraSingleLineTextField",
        "kind": "LinkedField",
        "name": "summaryField",
        "plural": false,
        "selections": [
            v15 /*: any*/ ,
            v9 /*: any*/ 
        ]
    }, v21 = {
        "concreteType": "JiraAvatar",
        "kind": "LinkedField",
        "name": "avatar",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "xsmall"
            }
        ]
    };
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v3 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "refetchIssue_IssueNavigatorQuery",
            "selections": [
                {
                    "concreteType": "JiraQuery",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "args": v4 /*: any*/ ,
                            "concreteType": "JiraIssueConnection",
                            "kind": "LinkedField",
                            "name": "issueSearchStable",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "JiraIssueEdge",
                                    "kind": "LinkedField",
                                    "name": "edges",
                                    "plural": true,
                                    "selections": [
                                        {
                                            "concreteType": "JiraIssue",
                                            "kind": "LinkedField",
                                            "name": "node",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "args": v5 /*: any*/ ,
                                                    "concreteType": "JiraIssueFieldSetConnection",
                                                    "kind": "LinkedField",
                                                    "name": "fieldSetsById",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "args": [
                                                                {
                                                                    "kind": "Literal",
                                                                    "name": "isDensityFull",
                                                                    "value": false
                                                                },
                                                                {
                                                                    "kind": "Literal",
                                                                    "name": "isInlineEditingEnabled",
                                                                    "value": true
                                                                }
                                                            ],
                                                            "kind": "FragmentSpread",
                                                            "name": "issueRow_nativeIssueTable_IssueRowWithFragments_fieldSetsForIssueSearchView"
                                                        },
                                                        {
                                                            "kind": "FragmentSpread",
                                                            "name": "main_issueNavigator_Card_fieldSetsForIssueSearchView"
                                                        }
                                                    ]
                                                }
                                            ]
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v1 /*: any*/ ,
                v3 /*: any*/ ,
                v2 /*: any*/ ,
                v0 /*: any*/ ,
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcstatusinlineeditrelayprovider"
                },
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcparentfromissueviewrelayprovider"
                }
            ],
            "kind": "Operation",
            "name": "refetchIssue_IssueNavigatorQuery",
            "selections": [
                {
                    "concreteType": "JiraQuery",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "args": v4 /*: any*/ ,
                            "concreteType": "JiraIssueConnection",
                            "kind": "LinkedField",
                            "name": "issueSearchStable",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "JiraIssueEdge",
                                    "kind": "LinkedField",
                                    "name": "edges",
                                    "plural": true,
                                    "selections": [
                                        {
                                            "concreteType": "JiraIssue",
                                            "kind": "LinkedField",
                                            "name": "node",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "args": v5 /*: any*/ ,
                                                    "concreteType": "JiraIssueFieldSetConnection",
                                                    "kind": "LinkedField",
                                                    "name": "fieldSetsById",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "concreteType": "JiraIssueFieldSetEdge",
                                                            "kind": "LinkedField",
                                                            "name": "edges",
                                                            "plural": true,
                                                            "selections": [
                                                                {
                                                                    "concreteType": "JiraIssueFieldSet",
                                                                    "kind": "LinkedField",
                                                                    "name": "node",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        v6 /*: any*/ ,
                                                                        {
                                                                            "kind": "ScalarField",
                                                                            "name": "fieldSetId"
                                                                        },
                                                                        {
                                                                            "concreteType": "JiraIssueFieldConnection",
                                                                            "kind": "LinkedField",
                                                                            "name": "fields",
                                                                            "plural": false,
                                                                            "selections": [
                                                                                {
                                                                                    "concreteType": "JiraIssueFieldEdge",
                                                                                    "kind": "LinkedField",
                                                                                    "name": "edges",
                                                                                    "plural": true,
                                                                                    "selections": [
                                                                                        {
                                                                                            "kind": "LinkedField",
                                                                                            "name": "node",
                                                                                            "plural": false,
                                                                                            "selections": [
                                                                                                v7 /*: any*/ ,
                                                                                                v8 /*: any*/ ,
                                                                                                v6 /*: any*/ ,
                                                                                                {
                                                                                                    "kind": "TypeDiscriminator",
                                                                                                    "abstractKey": "__isJiraIssueField"
                                                                                                },
                                                                                                v9 /*: any*/ ,
                                                                                                {
                                                                                                    "kind": "InlineFragment",
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "concreteType": "JiraAffectedServiceConnection",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "selectedAffectedServicesConnection",
                                                                                                            "plural": false,
                                                                                                            "selections": [
                                                                                                                {
                                                                                                                    "concreteType": "JiraAffectedServiceEdge",
                                                                                                                    "kind": "LinkedField",
                                                                                                                    "name": "edges",
                                                                                                                    "plural": true,
                                                                                                                    "selections": [
                                                                                                                        {
                                                                                                                            "concreteType": "JiraAffectedService",
                                                                                                                            "kind": "LinkedField",
                                                                                                                            "name": "node",
                                                                                                                            "plural": false,
                                                                                                                            "selections": [
                                                                                                                                {
                                                                                                                                    "kind": "ScalarField",
                                                                                                                                    "name": "serviceId"
                                                                                                                                },
                                                                                                                                v10 /*: any*/ 
                                                                                                                            ]
                                                                                                                        }
                                                                                                                    ]
                                                                                                                }
                                                                                                            ]
                                                                                                        }
                                                                                                    ],
                                                                                                    "type": "JiraAffectedServicesField"
                                                                                                },
                                                                                                {
                                                                                                    "kind": "InlineFragment",
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "concreteType": "JiraCmdbObjectConnection",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "selectedCmdbObjectsConnection",
                                                                                                            "plural": false,
                                                                                                            "selections": [
                                                                                                                {
                                                                                                                    "concreteType": "JiraCmdbObjectEdge",
                                                                                                                    "kind": "LinkedField",
                                                                                                                    "name": "edges",
                                                                                                                    "plural": true,
                                                                                                                    "selections": [
                                                                                                                        {
                                                                                                                            "concreteType": "JiraCmdbObject",
                                                                                                                            "kind": "LinkedField",
                                                                                                                            "name": "node",
                                                                                                                            "plural": false,
                                                                                                                            "selections": [
                                                                                                                                {
                                                                                                                                    "kind": "ScalarField",
                                                                                                                                    "name": "objectId"
                                                                                                                                },
                                                                                                                                {
                                                                                                                                    "kind": "ScalarField",
                                                                                                                                    "name": "label"
                                                                                                                                },
                                                                                                                                {
                                                                                                                                    "concreteType": "JiraCmdbAvatar",
                                                                                                                                    "kind": "LinkedField",
                                                                                                                                    "name": "avatar",
                                                                                                                                    "plural": false,
                                                                                                                                    "selections": [
                                                                                                                                        {
                                                                                                                                            "kind": "ScalarField",
                                                                                                                                            "name": "url48"
                                                                                                                                        }
                                                                                                                                    ]
                                                                                                                                }
                                                                                                                            ]
                                                                                                                        }
                                                                                                                    ]
                                                                                                                },
                                                                                                                {
                                                                                                                    "concreteType": "QueryError",
                                                                                                                    "kind": "LinkedField",
                                                                                                                    "name": "errors",
                                                                                                                    "plural": true,
                                                                                                                    "selections": [
                                                                                                                        {
                                                                                                                            "kind": "ScalarField",
                                                                                                                            "name": "message"
                                                                                                                        }
                                                                                                                    ]
                                                                                                                }
                                                                                                            ]
                                                                                                        }
                                                                                                    ],
                                                                                                    "type": "JiraCMDBField"
                                                                                                },
                                                                                                {
                                                                                                    "kind": "InlineFragment",
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "concreteType": "JiraComponentConnection",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "selectedComponentsConnection",
                                                                                                            "plural": false,
                                                                                                            "selections": [
                                                                                                                {
                                                                                                                    "concreteType": "JiraComponentEdge",
                                                                                                                    "kind": "LinkedField",
                                                                                                                    "name": "edges",
                                                                                                                    "plural": true,
                                                                                                                    "selections": [
                                                                                                                        {
                                                                                                                            "concreteType": "JiraComponent",
                                                                                                                            "kind": "LinkedField",
                                                                                                                            "name": "node",
                                                                                                                            "plural": false,
                                                                                                                            "selections": v11 /*: any*/ 
                                                                                                                        }
                                                                                                                    ]
                                                                                                                }
                                                                                                            ]
                                                                                                        }
                                                                                                    ],
                                                                                                    "type": "JiraComponentsField"
                                                                                                },
                                                                                                {
                                                                                                    "kind": "InlineFragment",
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "kind": "ScalarField",
                                                                                                            "name": "date"
                                                                                                        },
                                                                                                        v10 /*: any*/ ,
                                                                                                        v12 /*: any*/ ,
                                                                                                        v13 /*: any*/ 
                                                                                                    ],
                                                                                                    "type": "JiraDatePickerField"
                                                                                                },
                                                                                                {
                                                                                                    "kind": "InlineFragment",
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "kind": "ScalarField",
                                                                                                            "name": "dateTime"
                                                                                                        }
                                                                                                    ],
                                                                                                    "type": "JiraDateTimePickerField"
                                                                                                },
                                                                                                {
                                                                                                    "kind": "InlineFragment",
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "concreteType": "JiraEpic",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "epic",
                                                                                                            "plural": false,
                                                                                                            "selections": [
                                                                                                                v14 /*: any*/ ,
                                                                                                                {
                                                                                                                    "kind": "ScalarField",
                                                                                                                    "name": "summary"
                                                                                                                },
                                                                                                                {
                                                                                                                    "kind": "ScalarField",
                                                                                                                    "name": "color"
                                                                                                                },
                                                                                                                v9 /*: any*/ 
                                                                                                            ]
                                                                                                        }
                                                                                                    ],
                                                                                                    "type": "JiraEpicLinkField"
                                                                                                },
                                                                                                {
                                                                                                    "kind": "InlineFragment",
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "kind": "ScalarField",
                                                                                                            "name": "renderedFieldHtml"
                                                                                                        }
                                                                                                    ],
                                                                                                    "type": "JiraFallbackField"
                                                                                                },
                                                                                                {
                                                                                                    "kind": "InlineFragment",
                                                                                                    "selections": [
                                                                                                        v15 /*: any*/ ,
                                                                                                        v10 /*: any*/ ,
                                                                                                        v13 /*: any*/ 
                                                                                                    ],
                                                                                                    "type": "JiraSingleLineTextField"
                                                                                                },
                                                                                                {
                                                                                                    "kind": "InlineFragment",
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "concreteType": "JiraStatusCategory",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "statusCategory",
                                                                                                            "plural": false,
                                                                                                            "selections": [
                                                                                                                v10 /*: any*/ ,
                                                                                                                v16 /*: any*/ ,
                                                                                                                v9 /*: any*/ 
                                                                                                            ]
                                                                                                        }
                                                                                                    ],
                                                                                                    "type": "JiraStatusCategoryField"
                                                                                                },
                                                                                                {
                                                                                                    "kind": "InlineFragment",
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "concreteType": "JiraStatus",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "status",
                                                                                                            "plural": false,
                                                                                                            "selections": [
                                                                                                                v10 /*: any*/ ,
                                                                                                                {
                                                                                                                    "kind": "ScalarField",
                                                                                                                    "name": "statusId"
                                                                                                                },
                                                                                                                v17 /*: any*/ ,
                                                                                                                v9 /*: any*/ 
                                                                                                            ]
                                                                                                        }
                                                                                                    ],
                                                                                                    "type": "JiraStatusField"
                                                                                                },
                                                                                                {
                                                                                                    "kind": "InlineFragment",
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "args": v18 /*: any*/ ,
                                                                                                            "concreteType": "JiraLabelConnection",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "selectedLabelsConnection",
                                                                                                            "plural": false,
                                                                                                            "selections": [
                                                                                                                {
                                                                                                                    "concreteType": "JiraLabelEdge",
                                                                                                                    "kind": "LinkedField",
                                                                                                                    "name": "edges",
                                                                                                                    "plural": true,
                                                                                                                    "selections": [
                                                                                                                        {
                                                                                                                            "concreteType": "JiraLabel",
                                                                                                                            "kind": "LinkedField",
                                                                                                                            "name": "node",
                                                                                                                            "plural": false,
                                                                                                                            "selections": [
                                                                                                                                v10 /*: any*/ 
                                                                                                                            ]
                                                                                                                        }
                                                                                                                    ]
                                                                                                                },
                                                                                                                {
                                                                                                                    "kind": "ScalarField",
                                                                                                                    "name": "totalCount"
                                                                                                                }
                                                                                                            ],
                                                                                                            "storageKey": "selectedLabelsConnection(first:1000)"
                                                                                                        },
                                                                                                        v10 /*: any*/ ,
                                                                                                        v13 /*: any*/ 
                                                                                                    ],
                                                                                                    "type": "JiraLabelsField"
                                                                                                },
                                                                                                v19 /*: any*/ ,
                                                                                                {
                                                                                                    "kind": "InlineFragment",
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "concreteType": "JiraIssue",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "parentIssue",
                                                                                                            "plural": false,
                                                                                                            "selections": [
                                                                                                                v14 /*: any*/ ,
                                                                                                                {
                                                                                                                    "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcparentfromissueviewrelayprovider",
                                                                                                                    "kind": "Condition",
                                                                                                                    "passingValue": true,
                                                                                                                    "selections": [
                                                                                                                        v20 /*: any*/ 
                                                                                                                    ]
                                                                                                                },
                                                                                                                {
                                                                                                                    "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcparentfromissueviewrelayprovider",
                                                                                                                    "kind": "Condition",
                                                                                                                    "passingValue": false,
                                                                                                                    "selections": [
                                                                                                                        {
                                                                                                                            "args": [
                                                                                                                                {
                                                                                                                                    "kind": "Literal",
                                                                                                                                    "name": "ids",
                                                                                                                                    "value": [
                                                                                                                                        "issuetype",
                                                                                                                                        "summary"
                                                                                                                                    ]
                                                                                                                                }
                                                                                                                            ],
                                                                                                                            "concreteType": "JiraIssueFieldConnection",
                                                                                                                            "kind": "LinkedField",
                                                                                                                            "name": "fieldsById",
                                                                                                                            "plural": false,
                                                                                                                            "selections": [
                                                                                                                                {
                                                                                                                                    "concreteType": "JiraIssueFieldEdge",
                                                                                                                                    "kind": "LinkedField",
                                                                                                                                    "name": "edges",
                                                                                                                                    "plural": true,
                                                                                                                                    "selections": [
                                                                                                                                        {
                                                                                                                                            "kind": "LinkedField",
                                                                                                                                            "name": "node",
                                                                                                                                            "plural": false,
                                                                                                                                            "selections": [
                                                                                                                                                v7 /*: any*/ ,
                                                                                                                                                v8 /*: any*/ ,
                                                                                                                                                v19 /*: any*/ ,
                                                                                                                                                {
                                                                                                                                                    "kind": "InlineFragment",
                                                                                                                                                    "selections": [
                                                                                                                                                        v15 /*: any*/ 
                                                                                                                                                    ],
                                                                                                                                                    "type": "JiraSingleLineTextField"
                                                                                                                                                },
                                                                                                                                                v9 /*: any*/ 
                                                                                                                                            ]
                                                                                                                                        }
                                                                                                                                    ]
                                                                                                                                }
                                                                                                                            ],
                                                                                                                            "storageKey": "fieldsById(ids:[\"issuetype\",\"summary\"])"
                                                                                                                        }
                                                                                                                    ]
                                                                                                                },
                                                                                                                v9 /*: any*/ 
                                                                                                            ]
                                                                                                        },
                                                                                                        {
                                                                                                            "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcparentfromissueviewrelayprovider",
                                                                                                            "kind": "Condition",
                                                                                                            "passingValue": true,
                                                                                                            "selections": [
                                                                                                                {
                                                                                                                    "concreteType": "JiraIssue",
                                                                                                                    "kind": "LinkedField",
                                                                                                                    "name": "parentIssue",
                                                                                                                    "plural": false,
                                                                                                                    "selections": [
                                                                                                                        {
                                                                                                                            "concreteType": "JiraColorField",
                                                                                                                            "kind": "LinkedField",
                                                                                                                            "name": "issueColorField",
                                                                                                                            "plural": false,
                                                                                                                            "selections": [
                                                                                                                                {
                                                                                                                                    "concreteType": "JiraColor",
                                                                                                                                    "kind": "LinkedField",
                                                                                                                                    "name": "color",
                                                                                                                                    "plural": false,
                                                                                                                                    "selections": [
                                                                                                                                        {
                                                                                                                                            "kind": "ScalarField",
                                                                                                                                            "name": "colorKey"
                                                                                                                                        },
                                                                                                                                        v9 /*: any*/ 
                                                                                                                                    ]
                                                                                                                                },
                                                                                                                                v9 /*: any*/ 
                                                                                                                            ]
                                                                                                                        },
                                                                                                                        {
                                                                                                                            "concreteType": "JiraIssueTypeField",
                                                                                                                            "kind": "LinkedField",
                                                                                                                            "name": "issueTypeField",
                                                                                                                            "plural": false,
                                                                                                                            "selections": [
                                                                                                                                {
                                                                                                                                    "concreteType": "JiraIssueType",
                                                                                                                                    "kind": "LinkedField",
                                                                                                                                    "name": "issueType",
                                                                                                                                    "plural": false,
                                                                                                                                    "selections": [
                                                                                                                                        v21 /*: any*/ ,
                                                                                                                                        v10 /*: any*/ ,
                                                                                                                                        v9 /*: any*/ 
                                                                                                                                    ]
                                                                                                                                },
                                                                                                                                v9 /*: any*/ 
                                                                                                                            ]
                                                                                                                        },
                                                                                                                        v20 /*: any*/ 
                                                                                                                    ]
                                                                                                                }
                                                                                                            ]
                                                                                                        }
                                                                                                    ],
                                                                                                    "type": "JiraParentIssueField"
                                                                                                },
                                                                                                {
                                                                                                    "kind": "InlineFragment",
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "concreteType": "JiraPriority",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "priority",
                                                                                                            "plural": false,
                                                                                                            "selections": [
                                                                                                                v10 /*: any*/ ,
                                                                                                                {
                                                                                                                    "kind": "ScalarField",
                                                                                                                    "name": "iconUrl"
                                                                                                                },
                                                                                                                v9 /*: any*/ 
                                                                                                            ]
                                                                                                        },
                                                                                                        v10 /*: any*/ ,
                                                                                                        v13 /*: any*/ 
                                                                                                    ],
                                                                                                    "type": "JiraPriorityField"
                                                                                                },
                                                                                                {
                                                                                                    "kind": "InlineFragment",
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "concreteType": "JiraProject",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "project",
                                                                                                            "plural": false,
                                                                                                            "selections": [
                                                                                                                v10 /*: any*/ ,
                                                                                                                v14 /*: any*/ ,
                                                                                                                {
                                                                                                                    "concreteType": "JiraAvatar",
                                                                                                                    "kind": "LinkedField",
                                                                                                                    "name": "avatar",
                                                                                                                    "plural": false,
                                                                                                                    "selections": [
                                                                                                                        {
                                                                                                                            "kind": "ScalarField",
                                                                                                                            "name": "large"
                                                                                                                        }
                                                                                                                    ]
                                                                                                                },
                                                                                                                v9 /*: any*/ 
                                                                                                            ]
                                                                                                        }
                                                                                                    ],
                                                                                                    "type": "JiraProjectField"
                                                                                                },
                                                                                                {
                                                                                                    "kind": "InlineFragment",
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "concreteType": "JiraResolution",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "resolution",
                                                                                                            "plural": false,
                                                                                                            "selections": v11 /*: any*/ 
                                                                                                        }
                                                                                                    ],
                                                                                                    "type": "JiraResolutionField"
                                                                                                },
                                                                                                {
                                                                                                    "kind": "InlineFragment",
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "concreteType": "JiraSprintConnection",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "selectedSprintsConnection",
                                                                                                            "plural": false,
                                                                                                            "selections": [
                                                                                                                {
                                                                                                                    "concreteType": "JiraSprintEdge",
                                                                                                                    "kind": "LinkedField",
                                                                                                                    "name": "edges",
                                                                                                                    "plural": true,
                                                                                                                    "selections": [
                                                                                                                        {
                                                                                                                            "concreteType": "JiraSprint",
                                                                                                                            "kind": "LinkedField",
                                                                                                                            "name": "node",
                                                                                                                            "plural": false,
                                                                                                                            "selections": [
                                                                                                                                v9 /*: any*/ ,
                                                                                                                                {
                                                                                                                                    "kind": "ScalarField",
                                                                                                                                    "name": "sprintId"
                                                                                                                                },
                                                                                                                                v10 /*: any*/ ,
                                                                                                                                {
                                                                                                                                    "kind": "ScalarField",
                                                                                                                                    "name": "state"
                                                                                                                                },
                                                                                                                                {
                                                                                                                                    "kind": "ScalarField",
                                                                                                                                    "name": "endDate"
                                                                                                                                }
                                                                                                                            ]
                                                                                                                        }
                                                                                                                    ]
                                                                                                                }
                                                                                                            ]
                                                                                                        },
                                                                                                        v10 /*: any*/ ,
                                                                                                        v13 /*: any*/ 
                                                                                                    ],
                                                                                                    "type": "JiraSprintField"
                                                                                                },
                                                                                                {
                                                                                                    "kind": "InlineFragment",
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "user",
                                                                                                            "plural": false,
                                                                                                            "selections": [
                                                                                                                v7 /*: any*/ ,
                                                                                                                {
                                                                                                                    "kind": "ScalarField",
                                                                                                                    "name": "accountId"
                                                                                                                },
                                                                                                                {
                                                                                                                    "kind": "ScalarField",
                                                                                                                    "name": "picture"
                                                                                                                },
                                                                                                                v10 /*: any*/ ,
                                                                                                                v9 /*: any*/ ,
                                                                                                                {
                                                                                                                    "kind": "ScalarField",
                                                                                                                    "name": "accountStatus"
                                                                                                                }
                                                                                                            ]
                                                                                                        },
                                                                                                        v10 /*: any*/ ,
                                                                                                        v12 /*: any*/ ,
                                                                                                        v13 /*: any*/ 
                                                                                                    ],
                                                                                                    "type": "JiraSingleSelectUserPickerField"
                                                                                                },
                                                                                                {
                                                                                                    "kind": "InlineFragment",
                                                                                                    "selections": [
                                                                                                        v10 /*: any*/ ,
                                                                                                        {
                                                                                                            "concreteType": "JiraVersionConnection",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "selectedVersionsConnection",
                                                                                                            "plural": false,
                                                                                                            "selections": [
                                                                                                                {
                                                                                                                    "concreteType": "JiraVersionEdge",
                                                                                                                    "kind": "LinkedField",
                                                                                                                    "name": "edges",
                                                                                                                    "plural": true,
                                                                                                                    "selections": [
                                                                                                                        {
                                                                                                                            "concreteType": "JiraVersion",
                                                                                                                            "kind": "LinkedField",
                                                                                                                            "name": "node",
                                                                                                                            "plural": false,
                                                                                                                            "selections": v11 /*: any*/ 
                                                                                                                        }
                                                                                                                    ]
                                                                                                                }
                                                                                                            ]
                                                                                                        }
                                                                                                    ],
                                                                                                    "type": "JiraMultipleVersionPickerField"
                                                                                                },
                                                                                                {
                                                                                                    "kind": "InlineFragment",
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "concreteType": "JiraRichText",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "richText",
                                                                                                            "plural": false,
                                                                                                            "selections": [
                                                                                                                {
                                                                                                                    "concreteType": "JiraADF",
                                                                                                                    "kind": "LinkedField",
                                                                                                                    "name": "adfValue",
                                                                                                                    "plural": false,
                                                                                                                    "selections": [
                                                                                                                        {
                                                                                                                            "concreteType": "JiraAdfToConvertedPlainText",
                                                                                                                            "kind": "LinkedField",
                                                                                                                            "name": "convertedPlainText",
                                                                                                                            "plural": false,
                                                                                                                            "selections": [
                                                                                                                                {
                                                                                                                                    "kind": "ScalarField",
                                                                                                                                    "name": "plainText"
                                                                                                                                }
                                                                                                                            ]
                                                                                                                        }
                                                                                                                    ]
                                                                                                                }
                                                                                                            ]
                                                                                                        }
                                                                                                    ],
                                                                                                    "type": "JiraRichTextField"
                                                                                                },
                                                                                                {
                                                                                                    "kind": "InlineFragment",
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "concreteType": "JiraServiceManagementRequestType",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "requestType",
                                                                                                            "plural": false,
                                                                                                            "selections": [
                                                                                                                v10 /*: any*/ ,
                                                                                                                v21 /*: any*/ ,
                                                                                                                v9 /*: any*/ 
                                                                                                            ]
                                                                                                        }
                                                                                                    ],
                                                                                                    "type": "JiraServiceManagementRequestTypeField"
                                                                                                },
                                                                                                {
                                                                                                    "kind": "InlineFragment",
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "args": v18 /*: any*/ ,
                                                                                                            "concreteType": "JiraIssueLinkConnection",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "issueLinkConnection",
                                                                                                            "plural": false,
                                                                                                            "selections": [
                                                                                                                {
                                                                                                                    "concreteType": "PageInfo",
                                                                                                                    "kind": "LinkedField",
                                                                                                                    "name": "pageInfo",
                                                                                                                    "plural": false,
                                                                                                                    "selections": [
                                                                                                                        {
                                                                                                                            "kind": "ScalarField",
                                                                                                                            "name": "hasNextPage"
                                                                                                                        }
                                                                                                                    ]
                                                                                                                },
                                                                                                                {
                                                                                                                    "concreteType": "JiraIssueLinkEdge",
                                                                                                                    "kind": "LinkedField",
                                                                                                                    "name": "edges",
                                                                                                                    "plural": true,
                                                                                                                    "selections": [
                                                                                                                        {
                                                                                                                            "concreteType": "JiraIssueLink",
                                                                                                                            "kind": "LinkedField",
                                                                                                                            "name": "node",
                                                                                                                            "plural": false,
                                                                                                                            "selections": [
                                                                                                                                {
                                                                                                                                    "concreteType": "JiraIssue",
                                                                                                                                    "kind": "LinkedField",
                                                                                                                                    "name": "issue",
                                                                                                                                    "plural": false,
                                                                                                                                    "selections": [
                                                                                                                                        {
                                                                                                                                            "kind": "ScalarField",
                                                                                                                                            "name": "webUrl"
                                                                                                                                        },
                                                                                                                                        v14 /*: any*/ ,
                                                                                                                                        {
                                                                                                                                            "args": [
                                                                                                                                                {
                                                                                                                                                    "kind": "Literal",
                                                                                                                                                    "name": "ids",
                                                                                                                                                    "value": [
                                                                                                                                                        "statusCategory"
                                                                                                                                                    ]
                                                                                                                                                }
                                                                                                                                            ],
                                                                                                                                            "concreteType": "JiraIssueFieldConnection",
                                                                                                                                            "kind": "LinkedField",
                                                                                                                                            "name": "fieldsById",
                                                                                                                                            "plural": false,
                                                                                                                                            "selections": [
                                                                                                                                                {
                                                                                                                                                    "concreteType": "JiraIssueFieldEdge",
                                                                                                                                                    "kind": "LinkedField",
                                                                                                                                                    "name": "edges",
                                                                                                                                                    "plural": true,
                                                                                                                                                    "selections": [
                                                                                                                                                        {
                                                                                                                                                            "kind": "LinkedField",
                                                                                                                                                            "name": "node",
                                                                                                                                                            "plural": false,
                                                                                                                                                            "selections": [
                                                                                                                                                                v7 /*: any*/ ,
                                                                                                                                                                {
                                                                                                                                                                    "kind": "InlineFragment",
                                                                                                                                                                    "selections": [
                                                                                                                                                                        v17 /*: any*/ 
                                                                                                                                                                    ],
                                                                                                                                                                    "type": "JiraStatusCategoryField"
                                                                                                                                                                },
                                                                                                                                                                v9 /*: any*/ 
                                                                                                                                                            ]
                                                                                                                                                        }
                                                                                                                                                    ]
                                                                                                                                                }
                                                                                                                                            ],
                                                                                                                                            "storageKey": "fieldsById(ids:[\"statusCategory\"])"
                                                                                                                                        },
                                                                                                                                        v9 /*: any*/ 
                                                                                                                                    ]
                                                                                                                                },
                                                                                                                                {
                                                                                                                                    "kind": "ScalarField",
                                                                                                                                    "name": "relationName"
                                                                                                                                },
                                                                                                                                v9 /*: any*/ 
                                                                                                                            ]
                                                                                                                        }
                                                                                                                    ]
                                                                                                                }
                                                                                                            ],
                                                                                                            "storageKey": "issueLinkConnection(first:1000)"
                                                                                                        }
                                                                                                    ],
                                                                                                    "type": "JiraIssueLinkField"
                                                                                                }
                                                                                            ]
                                                                                        }
                                                                                    ]
                                                                                }
                                                                            ]
                                                                        }
                                                                    ]
                                                                }
                                                            ]
                                                        }
                                                    ]
                                                },
                                                v9 /*: any*/ 
                                            ]
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "0fa077c6c994de5f4e9e99d88f5ba16ac14180daca6a84b0c7006b2f3df54915",
            "metadata": {},
            "name": "refetchIssue_IssueNavigatorQuery",
            "operationKind": "query",
            "text": null,
            "providedVariables": {
                "__relay_internal__pv__atlassianjirarelayprovidersrcstatusinlineeditrelayprovider": (0, $fY4Nv.default),
                "__relay_internal__pv__atlassianjirarelayprovidersrcparentfromissueviewrelayprovider": (0, $kpHqV.default)
            }
        }
    };
}();
$4272320f3aceb63a$var$node.hash = "a1923415f412cb59e7b5d21b9573d30f";
var $4272320f3aceb63a$export$2e2bcd8739ae039 = $4272320f3aceb63a$var$node;

});


parcelRegister("1toLw", function(module, exports) {

$parcel$export(module.exports, "default", () => $cdab0c2bb92238a0$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $cdab0c2bb92238a0$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    searchFailedTitle: {
        "id": "issue-navigator.services.issue-search-refetch.search-failed-title",
        "defaultMessage": "We couldn't load your search results"
    },
    searchFailedDescription: {
        "id": "issue-navigator.services.issue-search-refetch.search-failed-description",
        "defaultMessage": "Refresh and try again."
    }
});

});


parcelRegister("edbn4", function(module, exports) {

$parcel$export(module.exports, "useSelectedViewMutation", () => $b7766e5802077f74$export$765f658bb8bac50f);

var $iQw8K = parcelRequire("iQw8K");

var $eUqFw = parcelRequire("eUqFw");

var $iWLL0 = parcelRequire("iWLL0");

var $guiFP = parcelRequire("guiFP");

var $dWLk9 = parcelRequire("dWLk9");

var $jccNB = parcelRequire("jccNB");
const $b7766e5802077f74$export$5786a571e562003d = (view)=>view.startsWith('list_') ? 'LIST' : 'DETAIL';
const $b7766e5802077f74$export$765f658bb8bac50f = ()=>{
    const userCloudId = (0, $dWLk9.useCloudId)();
    const [commitMutation] = (0, $iWLL0.useMutation)((0, $iQw8K.default));
    return (0, $eUqFw.useCallback)((view)=>{
        commitMutation({
            variables: {
                cloudId: userCloudId,
                searchLayout: $b7766e5802077f74$export$5786a571e562003d(view)
            },
            onError: (error)=>{
                (0, $guiFP.default)({
                    sendToPrivacyUnsafeSplunk: true,
                    error: error,
                    meta: {
                        id: 'mainSelectedViewMutation',
                        packageName: (0, $jccNB.PACKAGE_NAME),
                        teamName: (0, $jccNB.TEAM_NAME)
                    }
                });
            },
            optimisticResponse: {
                jira: {
                    userPreferences: {
                        setIssueNavigatorSearchLayout: {
                            success: true,
                            errors: [],
                            issueNavigatorSearchLayout: $b7766e5802077f74$export$5786a571e562003d(view)
                        }
                    }
                }
            }
        });
    }, [
        commitMutation,
        userCloudId
    ]);
};

});
parcelRegister("iQw8K", function(module, exports) {

$parcel$export(module.exports, "default", () => $e1a2486ffe7c40fe$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<03678eaaa27509a9eaff05b3536ed7a3>>
 * @relayHash 411c1701f9d22f072c495ac536a98400
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID f11f424abd082a8324c0f881b823fe5b84699dcb133b3f8c6933ee47e9907505
const $e1a2486ffe7c40fe$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "cloudId"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "searchLayout"
        }
    ], v1 = [
        {
            "concreteType": "JiraMutation",
            "kind": "LinkedField",
            "name": "jira",
            "plural": false,
            "selections": [
                {
                    "args": [
                        {
                            "kind": "Variable",
                            "name": "cloudId",
                            "variableName": "cloudId"
                        }
                    ],
                    "concreteType": "JiraUserPreferencesMutation",
                    "kind": "LinkedField",
                    "name": "userPreferences",
                    "plural": false,
                    "selections": [
                        {
                            "args": [
                                {
                                    "kind": "Variable",
                                    "name": "searchLayout",
                                    "variableName": "searchLayout"
                                }
                            ],
                            "concreteType": "JiraIssueNavigatorSearchLayoutMutationPayload",
                            "kind": "LinkedField",
                            "name": "setIssueNavigatorSearchLayout",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "success"
                                },
                                {
                                    "concreteType": "MutationError",
                                    "kind": "LinkedField",
                                    "name": "errors",
                                    "plural": true,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "message"
                                        }
                                    ]
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "issueNavigatorSearchLayout"
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "selectedView_updateUserViewModeMutation",
            "selections": v1 /*: any*/ ,
            "type": "Mutation"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "selectedView_updateUserViewModeMutation",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "id": "f11f424abd082a8324c0f881b823fe5b84699dcb133b3f8c6933ee47e9907505",
            "metadata": {},
            "name": "selectedView_updateUserViewModeMutation",
            "operationKind": "mutation",
            "text": null
        }
    };
}();
$e1a2486ffe7c40fe$var$node.hash = "57781762cebd4351d1b1402acc6af4c4";
var $e1a2486ffe7c40fe$export$2e2bcd8739ae039 = $e1a2486ffe7c40fe$var$node;

});


parcelRegister("9rcnc", function(module, exports) {

$parcel$export(module.exports, "useOnDeleteIssue", () => $ae50790b46487e81$export$45e2b3c3de4980ed);

var $eUqFw = parcelRequire("eUqFw");

var $iWLL0 = parcelRequire("iWLL0");

var $cNy9K = parcelRequire("cNy9K");
const $ae50790b46487e81$export$45e2b3c3de4980ed = (data)=>{
    const environment = (0, $iWLL0.useRelayEnvironment)();
    return (0, $eUqFw.useCallback)((issueKeyToDelete)=>{
        const issueResultEdges = data?.edges ?? [];
        let previousIssueKey;
        let nextIssueKey;
        (0, $cNy9K.commitLocalUpdate)(environment, (store)=>{
            let record;
            for(let i = 0; i < issueResultEdges.length; i++){
                const edge = issueResultEdges[i];
                const key = edge?.node?.key;
                // If we have not found the record holding the deleted issue
                if (!record) {
                    // Check if we've found the deleted issue
                    if (edge && key === issueKeyToDelete) record = store.get(edge.__id);
                    else if (key != null) previousIssueKey = key;
                } else if (key != null) {
                    nextIssueKey = key;
                    break;
                }
            }
            // Nullify the issue node which we'll handle in our UI as a deleted issue
            record?.setValue(null, 'node');
        });
        // Return the next issue key to select. If there is no next issue key then return the previous key.
        return nextIssueKey ?? previousIssueKey ?? '';
    }, [
        environment,
        data?.edges
    ]);
};

});


parcelRegister("4RwIp", function(module, exports) {

$parcel$export(module.exports, "Container", () => $62f8b6bd8485eb34$export$42a852a2b6b56249);
$parcel$export(module.exports, "useSelectedViewState", () => $62f8b6bd8485eb34$export$b94206faaa871f9e);

var $96gVp = parcelRequire("96gVp");
var $1yZQx = parcelRequire("1yZQx");
var $kEDjj = parcelRequire("kEDjj");

var $jccNB = parcelRequire("jccNB");
const $62f8b6bd8485eb34$export$42a852a2b6b56249 = (0, $96gVp.createContainer)();
const $62f8b6bd8485eb34$var$Store = (0, $kEDjj.createStore)({
    initialState: {
        view: (0, $jccNB.DEFAULT_VIEW_ID)
    },
    containedBy: $62f8b6bd8485eb34$export$42a852a2b6b56249,
    actions: {
        setView: (view, issueKey)=>({ setState: setState }, { onSetView: onSetView, onIssueSearchForView: onIssueSearchForView })=>{
                setState({
                    view: view
                });
                onSetView(view, issueKey);
                onIssueSearchForView && onIssueSearchForView(view);
            }
    },
    handlers: {
        onInit: ()=>({ setState: setState }, { view: view })=>{
                setState({
                    view: view
                });
            },
        onContainerUpdate: (nextProps, prevProps)=>({ setState: setState })=>{
                if (nextProps.view !== prevProps.view) setState({
                    view: nextProps.view
                });
            }
    },
    name: 'IssueNavigatorSelectedViewStateNew'
});
const $62f8b6bd8485eb34$export$b94206faaa871f9e = (0, $1yZQx.createHook)($62f8b6bd8485eb34$var$Store);

});

parcelRegister("dFxja", function(module, exports) {

$parcel$export(module.exports, "privateActions", () => $bb09f8384f81377d$export$3f1be494d407b77a);
$parcel$export(module.exports, "default", () => $bb09f8384f81377d$export$2e2bcd8739ae039);

var $dxIU5 = parcelRequire("dxIU5");

var $6vrw7 = parcelRequire("6vrw7");

var $jccNB = parcelRequire("jccNB");

const $bb09f8384f81377d$var$doSideEffectUpdate = ({ setState: setState, getState: getState, onChange: onChange, shouldNotifyOnChange: shouldNotifyOnChange, isSelectedByUserInteraction: isSelectedByUserInteraction })=>{
    const { selectedIssue: selectedIssue } = getState();
    setState({
        _rememoize: Date.now()
    });
    const key = selectedIssue[1];
    shouldNotifyOnChange && onChange && onChange(key, isSelectedByUserInteraction);
};
const $bb09f8384f81377d$var$doDebouncedSideEffectUpdate = (0, (/*@__PURE__*/$parcel$interopDefault($dxIU5)))($bb09f8384f81377d$var$doSideEffectUpdate, 600);
const $bb09f8384f81377d$var$doSideEffectUpdates = (shouldDebounce, setState, getState, onChange, shouldNotifyOnChange, isSelectedByUserInteraction)=>{
    if (shouldDebounce) $bb09f8384f81377d$var$doDebouncedSideEffectUpdate({
        setState: setState,
        getState: getState,
        onChange: onChange,
        shouldNotifyOnChange: shouldNotifyOnChange,
        isSelectedByUserInteraction: isSelectedByUserInteraction
    });
    else $bb09f8384f81377d$var$doSideEffectUpdate({
        setState: setState,
        getState: getState,
        onChange: onChange,
        shouldNotifyOnChange: shouldNotifyOnChange,
        isSelectedByUserInteraction: isSelectedByUserInteraction
    });
};
const $bb09f8384f81377d$var$setSelectedIssueByKey = (issueKey, shouldDebounce = false, shouldNotifyOnChange = true, isSelectedByUserInteraction = true)=>({ setState: setState, getState: getState }, { onChange: onChange, issueKeys: issueKeys })=>{
        if (!issueKey.length) return;
        const index = issueKey.length ? issueKeys?.findIndex((key)=>key === issueKey) : -1;
        if (index !== -1) setState({
            selectedIssue: [
                index,
                issueKey
            ]
        });
        else setState({
            selectedIssue: [
                null,
                issueKey
            ]
        });
        $bb09f8384f81377d$var$doSideEffectUpdates(shouldDebounce, setState, getState, onChange, shouldNotifyOnChange, isSelectedByUserInteraction);
    };
const $bb09f8384f81377d$var$setSelectedIssueByIndex = (issueIndex, shouldDebounce = false, shouldNotifyOnChange = true, isSelectedByUserInteraction = true)=>({ setState: setState, getState: getState }, { onChange: onChange, issueKeys: issueKeys })=>{
        if (issueIndex >= issueKeys.length) return;
        const key = issueKeys[issueIndex];
        setState({
            selectedIssue: [
                issueIndex,
                key
            ]
        });
        $bb09f8384f81377d$var$doSideEffectUpdates(shouldDebounce, setState, getState, onChange, shouldNotifyOnChange, isSelectedByUserInteraction);
    };
/**
 * Return the position of the currently selected issue in the search results or `null` if the selected issue could not
 * be found.
 */ const $bb09f8384f81377d$var$getSelectedIssuePosition = ()=>({ getState: getState }, { firstIssuePosition: firstIssuePosition, lastIssuePosition: lastIssuePosition, firstIssueKeyFromNextPage: firstIssueKeyFromNextPage, lastIssueKeyFromPreviousPage: lastIssueKeyFromPreviousPage })=>{
        // Incomplete page info from our search results so don't compute the position
        if (firstIssuePosition === null || lastIssuePosition === null) return null;
        const { selectedIssue: selectedIssue, nextResetStrategy: nextResetStrategy } = getState();
        const [selectedIssueIndex, selectedIssueKey] = selectedIssue;
        // If the first issue key from next page is selected or if we are forcing selection of the first issue on
        // pagination then we optimistically compute the issue position.
        if (selectedIssueKey === firstIssueKeyFromNextPage || nextResetStrategy === (0, $ab4105219851a7f3$export$7438b768c88f1c5b)) return lastIssuePosition + 1;
        // If the last issue key from previous page is selected or if we are forcing selection of the last issue on
        // pagination then we optimistically compute the issue position.
        if (selectedIssueKey === lastIssueKeyFromPreviousPage || nextResetStrategy === (0, $ab4105219851a7f3$export$9d24b8100c251252)) return firstIssuePosition - 1;
        if (selectedIssueIndex !== null) return selectedIssueIndex + firstIssuePosition;
        return null;
    };
/**
 * Returns true if the currently selected issue is within the page of issues.
 */ const $bb09f8384f81377d$var$isSelectedIssueOnPage = ()=>({ dispatch: dispatch }, { firstIssuePosition: firstIssuePosition, lastIssuePosition: lastIssuePosition })=>{
        const selectedIssuePosition = dispatch($bb09f8384f81377d$var$getSelectedIssuePosition());
        return selectedIssuePosition !== null && firstIssuePosition !== null && lastIssuePosition !== null && selectedIssuePosition >= firstIssuePosition && selectedIssuePosition <= lastIssuePosition;
    };
/**
 * Returns true if the currently selected issue is the first issue on the page.
 */ const $bb09f8384f81377d$var$isFirstIssueOnPage = ()=>({ dispatch: dispatch }, { firstIssuePosition: firstIssuePosition })=>{
        const selectedIssuePosition = dispatch($bb09f8384f81377d$var$getSelectedIssuePosition());
        return selectedIssuePosition !== null && selectedIssuePosition === firstIssuePosition;
    };
/**
 * Returns true if the currently selected issue is the last issue on the page.
 */ const $bb09f8384f81377d$var$isLastIssueOnPage = ()=>({ dispatch: dispatch }, { lastIssuePosition: lastIssuePosition })=>{
        const selectedIssuePosition = dispatch($bb09f8384f81377d$var$getSelectedIssuePosition());
        return selectedIssuePosition !== null && selectedIssuePosition === lastIssuePosition;
    };
/**
 * Return the next issue in the search results from the currently selected issue. If the selected issue is the last item
 * in the page of search results then the first key from the next page is returned with a boolean indicating the issue
 * belongs to the next page.
 */ const $bb09f8384f81377d$var$getNextIssue = ()=>({ getState: getState, dispatch: dispatch }, { firstIssueKeyFromNextPage: firstIssueKeyFromNextPage, issueKeys: issueKeys })=>{
        const { selectedIssue: selectedIssue } = getState();
        const [selectedIssueIndex] = selectedIssue;
        let nextIssueKey = '';
        let nextIssueIndex = null;
        let isOnNextPage = false;
        if (dispatch($bb09f8384f81377d$var$isLastIssueOnPage())) {
            nextIssueKey = firstIssueKeyFromNextPage ?? '';
            isOnNextPage = true;
        } else if (selectedIssueIndex !== null && dispatch($bb09f8384f81377d$var$isSelectedIssueOnPage())) {
            nextIssueIndex = selectedIssueIndex + 1;
            nextIssueKey = issueKeys[nextIssueIndex];
        }
        return {
            issueKey: nextIssueKey,
            issueIndex: nextIssueIndex,
            isOnNextPage: isOnNextPage
        };
    };
/**
 * Return the previous issue in the search results from the currently selected issue. If the selected issue is the first
 * item in the page of search results then the last key from the previous page is returned with a boolean indicating the
 * issue belongs to the previous page.
 */ const $bb09f8384f81377d$var$getPreviousIssue = ()=>({ getState: getState, dispatch: dispatch }, { lastIssueKeyFromPreviousPage: lastIssueKeyFromPreviousPage, issueKeys: issueKeys })=>{
        const { selectedIssue: selectedIssue } = getState();
        const [selectedIssueIndex] = selectedIssue;
        let previousIssueKey = '';
        let previousIssueIndex = null;
        let isOnPreviousPage = false;
        const selectedIssuePosition = dispatch($bb09f8384f81377d$var$getSelectedIssuePosition());
        // Ignore the first issue on the first page, which always has position '1'
        if (selectedIssuePosition === 1) return {
            issueKey: previousIssueKey,
            issueIndex: previousIssueIndex,
            isOnPreviousPage: isOnPreviousPage
        };
        if (dispatch($bb09f8384f81377d$var$isFirstIssueOnPage())) {
            previousIssueKey = lastIssueKeyFromPreviousPage ?? '';
            isOnPreviousPage = true;
        } else if (selectedIssueIndex !== null && dispatch($bb09f8384f81377d$var$isSelectedIssueOnPage())) {
            previousIssueIndex = selectedIssueIndex - 1;
            previousIssueKey = issueKeys[previousIssueIndex];
        }
        return {
            issueKey: previousIssueKey,
            issueIndex: previousIssueIndex,
            isOnPreviousPage: isOnPreviousPage
        };
    };
/**
 * Emit an event to fetch the next page of issues and force the first issue on the page (including null issues) to
 * be selected when the new connection of search results is loaded.
 */ const $bb09f8384f81377d$var$selectFirstIssueOnNextPage = ()=>({ setState: setState }, { onNextPage: onNextPage })=>{
        setState({
            nextResetStrategy: (0, $ab4105219851a7f3$export$7438b768c88f1c5b)
        });
        const revertStrategy = ()=>setState({
                nextResetStrategy: (0, $ab4105219851a7f3$export$6953d2fd44491a2f)
            });
        // Revert the reset strategy if the pagination request was interrupted (e.g. toggling view) or failed.
        const handled = onNextPage({
            onError: revertStrategy,
            onUnsubscribe: revertStrategy
        });
        // Revert the reset strategy if the page was unchanged
        if (!handled) revertStrategy();
    };
/**
 * Emit an event to fetch the previous page of issues and force the last issue on the page (including null issues)
 * to be selected when the new connection of search results is loaded.
 */ const $bb09f8384f81377d$var$selectLastIssueOnPreviousPage = ()=>({ setState: setState }, { onPreviousPage: onPreviousPage })=>{
        setState({
            nextResetStrategy: (0, $ab4105219851a7f3$export$9d24b8100c251252)
        });
        const revertStrategy = ()=>setState({
                nextResetStrategy: (0, $ab4105219851a7f3$export$6953d2fd44491a2f)
            });
        // Revert the reset strategy if the pagination request was interrupted (e.g. toggling view) or failed.
        const handled = onPreviousPage({
            onError: revertStrategy,
            onUnsubscribe: revertStrategy
        });
        // Revert the reset strategy if the page was unchanged
        if (!handled) revertStrategy();
    };
const $bb09f8384f81377d$var$selectIssueOnPage = (after, shouldSelectLastIssue)=>({ setState: setState }, { onPageChange: onPageChange })=>{
        setState({
            nextResetStrategy: shouldSelectLastIssue ? (0, $ab4105219851a7f3$export$9d24b8100c251252) : (0, $ab4105219851a7f3$export$7438b768c88f1c5b)
        });
        const revertStrategy = ()=>setState({
                nextResetStrategy: (0, $ab4105219851a7f3$export$6953d2fd44491a2f)
            });
        // Revert the reset strategy if the pagination request was interrupted (e.g. toggling view) or failed.
        onPageChange(after, {
            onError: revertStrategy,
            onUnsubscribe: revertStrategy
        });
    };
/**
 * Select the next issue in the search results (if there is a valid selection). Returns `true` if an issue was selected,
 * otherwise `false`.
 */ const $bb09f8384f81377d$var$selectNextIssue = (shouldDebounce)=>({ dispatch: dispatch })=>{
        const { issueKey: issueKey, issueIndex: issueIndex, isOnNextPage: isOnNextPage } = dispatch($bb09f8384f81377d$var$getNextIssue());
        if (issueIndex !== null) {
            dispatch($bb09f8384f81377d$var$setSelectedIssueByIndex(issueIndex, shouldDebounce));
            return true;
        }
        if (issueKey !== '') {
            dispatch($bb09f8384f81377d$var$setSelectedIssueByKey(issueKey, shouldDebounce));
            return true;
        }
        // If we do not have an issue key but our issue to select is on the next page (i.e. deleted issue) then we
        // dispatch an action to fetch the next page (rather than relying on the container update action).
        if (isOnNextPage) {
            dispatch($bb09f8384f81377d$var$selectFirstIssueOnNextPage());
            return true;
        }
        return false;
    };
/**
 * Select the previous issue in the search results (if there is a valid selection). Returns `true` if an issue was
 * selected, otherwise `false`.
 */ const $bb09f8384f81377d$var$selectPreviousIssue = (shouldDebounce)=>({ dispatch: dispatch })=>{
        const { issueKey: issueKey, issueIndex: issueIndex, isOnPreviousPage: isOnPreviousPage } = dispatch($bb09f8384f81377d$var$getPreviousIssue());
        if (issueIndex !== null) {
            dispatch($bb09f8384f81377d$var$setSelectedIssueByIndex(issueIndex, shouldDebounce));
            return true;
        }
        if (issueKey !== '') {
            dispatch($bb09f8384f81377d$var$setSelectedIssueByKey(issueKey, shouldDebounce));
            return true;
        }
        // If we do not have an issue key but our issue to select is on the previous page (i.e. deleted issue) then we
        // dispatch an action to fetch the previous page (rather than relying on the container update action).
        if (isOnPreviousPage) {
            dispatch($bb09f8384f81377d$var$selectLastIssueOnPreviousPage());
            return true;
        }
        return false;
    };
const $bb09f8384f81377d$var$setFocusedIssueByIndex = (issueIndex)=>({ setState: setState })=>{
        setState({
            focusedIssue: issueIndex
        });
    };
const $bb09f8384f81377d$var$resetFocusedIssue = ()=>({ setState: setState })=>{
        setState({
            focusedIssue: null
        });
    };
const $bb09f8384f81377d$var$deselectIssue = (shouldDebounce = false, shouldNotifyOnChange = true, isSelectedByUserInteraction = true)=>({ setState: setState, getState: getState }, { onChange: onChange })=>{
        setState({
            selectedIssue: [
                null,
                (0, $6vrw7.toIssueKey)('')
            ]
        });
        $bb09f8384f81377d$var$doSideEffectUpdates(shouldDebounce, setState, getState, onChange, shouldNotifyOnChange, isSelectedByUserInteraction);
    };
const $bb09f8384f81377d$var$enterFullPageIssueAppMode = ()=>({ setState: setState })=>setState({
            isFullPageIssueAppMode: true
        });
const $bb09f8384f81377d$var$exitFullPageIssueAppMode = ()=>({ setState: setState })=>setState({
            isFullPageIssueAppMode: false
        });
const $bb09f8384f81377d$var$getDefaultIssueKey = ()=>(_, { issueKeys: issueKeys })=>issueKeys.find((nonEmptyKey)=>Boolean(nonEmptyKey));
/**
 * Return true if we're in default list view mode without the full page issue app visible.
 */ const $bb09f8384f81377d$var$isListViewWithoutIssueApp = ()=>({ getState: getState }, { view: view })=>{
        const { isFullPageIssueAppMode: isFullPageIssueAppMode } = getState();
        return view === (0, $jccNB.views).list && !isFullPageIssueAppMode;
    };
/**
 * Return true if we're in default list view mode with the full page issue app visible and a selected issue key.
 */ const $bb09f8384f81377d$var$isListViewWithIssueAppAndKey = ()=>({ getState: getState }, { view: view })=>{
        const { isFullPageIssueAppMode: isFullPageIssueAppMode, selectedIssue: selectedIssue } = getState();
        return view === (0, $jccNB.views).list && isFullPageIssueAppMode && !!selectedIssue[1];
    };
/**
 * Reset the selected issue based on the current reset strategy.
 *
 * @param hasNextIssueKey `true` if a selected issue key is specified in the URL
 */ const $bb09f8384f81377d$var$resetSelectedIssue = (hasNextIssueKey)=>({ dispatch: dispatch, getState: getState, setState: setState }, { issueKeys: issueKeys })=>{
        const { nextResetStrategy: nextResetStrategy } = getState();
        // Update to default reset strategy
        setState({
            nextResetStrategy: (0, $ab4105219851a7f3$export$6953d2fd44491a2f)
        });
        // We only want to update issue key in the URL if our view mode uses external issue key selection, i.e. detail
        // view or full page issue app in list view. For the default list view mode we want to keep the selected issue
        // state internal.
        const shouldNotifyOnChange = !dispatch($bb09f8384f81377d$var$isListViewWithoutIssueApp());
        // If there is a selected issue specified in the URL, e.g. pagination, then `isSelectedByUserInteraction` should
        // be `true` to push a new entry in the browser history stack. Otherwise, if there is no selected issue in the
        // URL, e.g. new search, then `isSelectedByUserInteraction` should be false to replace the existing entry.
        const isSelectedByUserInteraction = hasNextIssueKey;
        // Index of the last issue on the issue list
        const lastIssueIndex = issueKeys.length - 1;
        switch(nextResetStrategy){
            case 0, $ab4105219851a7f3$export$9d24b8100c251252:
                dispatch($bb09f8384f81377d$var$setSelectedIssueByIndex(lastIssueIndex, false, shouldNotifyOnChange, isSelectedByUserInteraction));
                dispatch($bb09f8384f81377d$var$setFocusedIssueByIndex(lastIssueIndex));
                break;
            case 0, $ab4105219851a7f3$export$7438b768c88f1c5b:
                dispatch($bb09f8384f81377d$var$setSelectedIssueByIndex(0, false, shouldNotifyOnChange, isSelectedByUserInteraction));
                dispatch($bb09f8384f81377d$var$setFocusedIssueByIndex(0));
                break;
            case 0, $ab4105219851a7f3$export$6953d2fd44491a2f:
            default:
                dispatch($bb09f8384f81377d$var$setSelectedIssueByIndex(0, false, shouldNotifyOnChange, isSelectedByUserInteraction));
                break;
        }
    };
const $bb09f8384f81377d$export$e324594224ef24da = {
    setSelectedIssueByKey: $bb09f8384f81377d$var$setSelectedIssueByKey,
    setSelectedIssueByIndex: $bb09f8384f81377d$var$setSelectedIssueByIndex,
    getSelectedIssuePosition: $bb09f8384f81377d$var$getSelectedIssuePosition,
    getNextIssue: $bb09f8384f81377d$var$getNextIssue,
    getPreviousIssue: $bb09f8384f81377d$var$getPreviousIssue,
    selectNextIssue: $bb09f8384f81377d$var$selectNextIssue,
    selectPreviousIssue: $bb09f8384f81377d$var$selectPreviousIssue,
    setFocusedIssueByIndex: $bb09f8384f81377d$var$setFocusedIssueByIndex,
    deselectIssue: $bb09f8384f81377d$var$deselectIssue,
    selectFirstIssueOnNextPage: $bb09f8384f81377d$var$selectFirstIssueOnNextPage,
    selectLastIssueOnPreviousPage: $bb09f8384f81377d$var$selectLastIssueOnPreviousPage,
    selectIssueOnPage: $bb09f8384f81377d$var$selectIssueOnPage,
    enterFullPageIssueAppMode: $bb09f8384f81377d$var$enterFullPageIssueAppMode,
    exitFullPageIssueAppMode: $bb09f8384f81377d$var$exitFullPageIssueAppMode,
    resetFocusedIssue: $bb09f8384f81377d$var$resetFocusedIssue
};
const $bb09f8384f81377d$export$3f1be494d407b77a = {
    getDefaultIssueKey: $bb09f8384f81377d$var$getDefaultIssueKey,
    isListViewWithoutIssueApp: $bb09f8384f81377d$var$isListViewWithoutIssueApp,
    isListViewWithIssueAppAndKey: $bb09f8384f81377d$var$isListViewWithIssueAppAndKey,
    resetSelectedIssue: $bb09f8384f81377d$var$resetSelectedIssue
};
var $bb09f8384f81377d$export$2e2bcd8739ae039 = $bb09f8384f81377d$export$e324594224ef24da;

});
const $ab4105219851a7f3$export$6953d2fd44491a2f = 'DEFAULT_FIRST';
const $ab4105219851a7f3$export$7438b768c88f1c5b = 'FORCE_FIRST';
const $ab4105219851a7f3$export$9d24b8100c251252 = 'FORCE_LAST';



parcelRegister("dCaOY", function(module, exports) {

$parcel$export(module.exports, "useFilterQuery", () => $99e32d8ca2cce6d8$export$5576614cd48b552);
$parcel$export(module.exports, "FilterQueryProvider", () => $99e32d8ca2cce6d8$export$78b7af8c530bd7a4);

var $eUqFw = parcelRequire("eUqFw");

var $iWLL0 = parcelRequire("iWLL0");

var $5as0a = parcelRequire("5as0a");

var $jpJd3 = parcelRequire("jpJd3");

var $huI7r = parcelRequire("huI7r");

var $bFzGY = parcelRequire("bFzGY");

var $4rWQe = parcelRequire("4rWQe");
var $dWLk9 = parcelRequire("dWLk9");
const $99e32d8ca2cce6d8$var$FilterQueryContext = /*#__PURE__*/ (0, $eUqFw.createContext)({
    filterQueryIsFetching: false,
    filterQueryIsNetworkError: false
});
$99e32d8ca2cce6d8$var$FilterQueryContext.displayName = 'FilterQueryContext';
const $99e32d8ca2cce6d8$export$5576614cd48b552 = ()=>(0, $eUqFw.useContext)($99e32d8ca2cce6d8$var$FilterQueryContext);
const $99e32d8ca2cce6d8$export$78b7af8c530bd7a4 = ({ refetch: refetch, query: query, children: children, filterId: filterId })=>{
    const [filterQueryIsFetching, setFilterQueryIsFetching] = (0, $eUqFw.useState)(false);
    const [filterQueryIsNetworkError, setFilterQueryNetworkError] = (0, $eUqFw.useState)(false);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bFzGY.useAnalyticsEvents)();
    const activationId = (0, $4rWQe.useActivationId)();
    const cloudId = (0, $dWLk9.useCloudId)();
    const environment = (0, $iWLL0.useRelayEnvironment)();
    const inFlightRequest = (0, $eUqFw.useRef)();
    (0, $eUqFw.useEffect)(()=>{
        if (filterId !== undefined && (0, $5as0a.isFilterId)(filterId)) {
            // Prevent race condition from multiple requests in progress
            // (ex. if user clicks quickly on different filters)
            inFlightRequest.current?.unsubscribe();
            const variables = {
                filterAri: (0, $huI7r.createAri)({
                    resourceOwner: 'jira',
                    cloudId: cloudId,
                    resourceType: 'filter',
                    resourceId: filterId,
                    activationId: activationId
                }),
                includeFilter: true
            };
            setFilterQueryIsFetching(true);
            setFilterQueryNetworkError(false);
            inFlightRequest.current = (0, $iWLL0.fetchQuery)(environment, query, variables, {
                fetchPolicy: 'store-or-network'
            }).subscribe({
                complete: ()=>{
                    refetch(variables, {
                        fetchPolicy: 'store-only'
                    });
                    setFilterQueryIsFetching(false);
                },
                error: ()=>{
                    setFilterQueryIsFetching(false);
                    setFilterQueryNetworkError(true);
                }
            });
        } else // Need to refetch when filter is undefined so it reset filterData to empty
        refetch({
            includeFilter: false,
            filterAri: ''
        }, {
            fetchPolicy: 'store-or-network'
        });
    }, [
        activationId,
        cloudId,
        environment,
        filterId,
        query,
        refetch,
        setFilterQueryIsFetching,
        setFilterQueryNetworkError
    ]);
    (0, $eUqFw.useEffect)(()=>{
        if (filterId !== undefined && (0, $5as0a.isFilterId)(filterId)) {
            const analyticsEvent = createAnalyticsEvent({});
            (0, $jpJd3.addFilterToRecent)(filterId, analyticsEvent);
        }
    }, [
        filterId,
        createAnalyticsEvent
    ]);
    const contextValue = (0, $eUqFw.useMemo)(()=>({
            filterQueryIsFetching: filterQueryIsFetching,
            filterQueryIsNetworkError: filterQueryIsNetworkError
        }), [
        filterQueryIsFetching,
        filterQueryIsNetworkError
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($99e32d8ca2cce6d8$var$FilterQueryContext.Provider, {
        value: contextValue
    }, children);
};

});
parcelRegister("jpJd3", function(module, exports) {

$parcel$export(module.exports, "addFilterToRecent", () => $2c8dfd154f8cdde8$export$1f166118234b128e);

var $guiFP = parcelRequire("guiFP");

var $lRmyA = parcelRequire("lRmyA");

const $2c8dfd154f8cdde8$export$1f166118234b128e = async (filterId, analyticsEvent)=>{
    try {
        await (0, $lRmyA.performPostRequest)((0, $2e7c19c8e80df97b$export$3fdeac1311ebf841) + filterId);
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        (0, $guiFP.default)({
            error: error,
            event: analyticsEvent,
            meta: {
                id: 'addFilterToRecent',
                packageName: 'jiraIssueNavigatorCustomFilters'
            }
        });
    }
};

});
const $2e7c19c8e80df97b$export$3fdeac1311ebf841 = '/rest/issueNav/1/history/saveFilter/';



parcelRegister("8CJEL", function(module, exports) {

$parcel$export(module.exports, "default", () => $16bee20b057014f4$export$2e2bcd8739ae039);

var $6a5PX = parcelRequire("6a5PX");

var $fIE7K = parcelRequire("fIE7K");

var $90nIr = parcelRequire("90nIr");

var $aVBi2 = parcelRequire("aVBi2");

var $ldWhx = parcelRequire("ldWhx");

var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $iWLL0 = parcelRequire("iWLL0");

var $hPdNw = parcelRequire("hPdNw");

var $1ybV0 = parcelRequire("1ybV0");

var $7byHA = parcelRequire("7byHA");

var $5JgJ2 = parcelRequire("5JgJ2");

var $5as0a = parcelRequire("5as0a");

var $cHJdq = parcelRequire("cHJdq");

var $hzcvF = parcelRequire("hzcvF");

var $d6f6c = parcelRequire("d6f6c");

var $jccNB = parcelRequire("jccNB");

var $3Lg4c = parcelRequire("3Lg4c");

var $cWCvn = parcelRequire("cWCvn");

var $g8nwX = parcelRequire("g8nwX");

var $1ydM0 = parcelRequire("1ydM0");

var $4RwIp = parcelRequire("4RwIp");

var $3mEVr = parcelRequire("3mEVr");

var $dCaOY = parcelRequire("dCaOY");

var $cQBUE = parcelRequire("cQBUE");

var $cXdDi = parcelRequire("cXdDi");

var $58gge = parcelRequire("58gge");

var $j6Pvv = parcelRequire("j6Pvv");

var $lY5rz = parcelRequire("lY5rz");

var $5nM3q = parcelRequire("5nM3q");

var $fWUVl = parcelRequire("fWUVl");

var $7QBK4 = parcelRequire("7QBK4");

var $jTcpY = parcelRequire("jTcpY");
const $16bee20b057014f4$export$397fa57fff06920f = ({ CustomHeader: CustomHeader, ActionMenu: ActionMenu, HeaderSkeletonImage: HeaderSkeletonImage, filter: filter, onPageDataLoad: onPageDataLoad, onChangeColumnConfiguration: onChangeColumnConfiguration, onChangeJql: onChangeJql, onChangeIssue: onChangeIssue, onChangeFilter: onChangeFilter, defaultJql: defaultJql, onRefinement: onRefinement, issueResults: issueResults, view: view, viewResult: viewResult, userPreferences: userPreferences, jqlBuilderProps: jqlBuilderProps, jqlBuilderWithAiKey: jqlBuilderWithAiKey, isFeedbackButtonDisabled: isFeedbackButtonDisabled, issueTableProps: issueTableProps })=>{
    (0, $cWCvn.markOnce)((0, $cWCvn.marks).ISSUE_NAVIGATOR_UI_START);
    (0, $eUqFw.useLayoutEffect)(()=>{
        (0, $cWCvn.markOnce)((0, $cWCvn.marks).ISSUE_NAVIGATOR_UI_END);
    }, []);
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const [caughtIssueSearchError, setCaughtIssueSearchError] = (0, $eUqFw.useState)();
    const { filterId: filterId } = (0, $3mEVr.useActiveJql)();
    const { filterQueryIsFetching: filterQueryIsFetching } = (0, $dCaOY.useFilterQuery)();
    const handleReset = (0, $eUqFw.useCallback)((isResetToFilter = false)=>{
        if (isResetToFilter) onChangeFilter && onChangeFilter();
        else onChangeJql && onChangeJql(defaultJql, true);
    }, [
        onChangeFilter,
        onChangeJql,
        defaultJql
    ]);
    const onChange = (0, $eUqFw.useCallback)((jql)=>{
        onRefinement && onRefinement();
        onChangeJql && onChangeJql(jql, !filterQueryIsFetching && filter === null && (0, $5as0a.isFilterId)(filterId));
    }, [
        filter,
        filterId,
        filterQueryIsFetching,
        onChangeJql,
        onRefinement
    ]);
    const { searchKey: searchKey } = (0, $cQBUE.useIssueSearchQuery)();
    const previousData = (0, $hzcvF.usePrevious)(searchKey);
    const hasSearchChanged = Boolean(searchKey && searchKey !== previousData);
    const [{ view: selectedView }] = (0, $4RwIp.useSelectedViewState)();
    const issueResultsData = (0, $iWLL0.useFragment)((0, $ldWhx.default), issueResults);
    const viewResultData = (0, $iWLL0.useFragment)((0, $aVBi2.default), viewResult);
    const viewResultError = (0, $1ybV0.ff)('handle-404-filter-errors-gracefully-in-the-ui-by-showing-filter-not-found-view_t3d2m') ? // eslint-disable-next-line react-hooks/rules-of-hooks
    (0, $eUqFw.useMemo)(()=>viewResultData?.__typename === 'QueryError' && viewResultData?.extensions?.[0]?.statusCode !== undefined && viewResultData?.extensions?.[0]?.statusCode !== null ? new (0, $7byHA.default)(viewResultData?.extensions?.[0]?.statusCode, viewResultData?.message ?? '') : undefined, [
        viewResultData
    ]) : undefined;
    const viewData = (0, $iWLL0.useFragment)((0, $90nIr.default), view);
    const userPreferencesData = (0, $iWLL0.useFragment)((0, $fIE7K.default), userPreferences);
    const jqlBuilderWithAiData = (0, $iWLL0.useFragment)((0, $6a5PX.default), jqlBuilderWithAiKey);
    const shouldAnnounceInfo = (0, $eUqFw.useMemo)(()=>issueResultsData !== null && hasSearchChanged && typeof issueResultsData.totalIssueSearchResultCount === 'number', [
        issueResultsData,
        hasSearchChanged
    ]);
    const [isAiEnabled, setIsAiEnabled] = (0, $eUqFw.useState)(false);
    const onToggleAi = (0, $eUqFw.useCallback)((isEnabled)=>{
        setIsAiEnabled(isEnabled);
    }, []);
    const noFilterReason = (0, $1ybV0.ff)('handle-404-filter-errors-gracefully-in-the-ui-by-showing-filter-not-found-view_t3d2m') ? // eslint-disable-next-line react-hooks/rules-of-hooks
    (0, $eUqFw.useMemo)(()=>{
        if (!filterQueryIsFetching && filter === null && (0, $5as0a.isFilterId)(filterId)) return 'Filter query mismatch';
        if (viewResultData?.__typename === 'QueryError' && viewResultData?.extensions?.[0]?.statusCode === 404) return 'Filter not found in view result';
        return undefined;
    }, [
        filter,
        filterId,
        filterQueryIsFetching,
        viewResultData?.__typename,
        viewResultData?.extensions
    ]) : undefined;
    const IssueNavigatorTopBar = (0, $eUqFw.useMemo)(()=>{
        const jqlBuilder = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $lY5rz.default), {
            onChangeJql: onChange,
            defaultJql: defaultJql,
            filter: filter,
            onReset: handleReset,
            onFilterSave: onChangeFilter,
            issueResults: issueResultsData,
            onToggleAi: onToggleAi,
            jqlBuilderWithAiKey: jqlBuilderWithAiData,
            jqlBuilderProps: jqlBuilderProps
        });
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, ActionMenu && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $jTcpY.default), {
            ActionMenu: ActionMenu,
            filter: filter,
            issueResults: issueResultsData,
            HeaderSkeletonImage: HeaderSkeletonImage,
            jqlBuilder: jqlBuilder
        }), CustomHeader && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $58gge.default), {
            CustomHeader: CustomHeader,
            filter: filter,
            issueResults: issueResultsData,
            HeaderSkeletonImage: HeaderSkeletonImage
        }), jqlBuilder));
    }, [
        defaultJql,
        filter,
        handleReset,
        issueResultsData,
        jqlBuilderProps,
        jqlBuilderWithAiData,
        onChange,
        onChangeFilter,
        onToggleAi,
        ActionMenu,
        CustomHeader,
        HeaderSkeletonImage
    ]);
    let IssueNavigatorContent = (0, $eUqFw.useMemo)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($16bee20b057014f4$var$IssueNavigatorContentContainer, {
            selectedView: selectedView
        }, IssueNavigatorTopBar, !filterQueryIsFetching && filter === null && (0, $5as0a.isFilterId)(filterId) || (0, $1ybV0.ff)('handle-404-filter-errors-gracefully-in-the-ui-by-showing-filter-not-found-view_t3d2m') && viewResultData?.__typename === 'QueryError' && viewResultData?.extensions?.[0]?.statusCode === 404 ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $3Lg4c.NoFilter), {
            reason: noFilterReason
        }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $hPdNw.AnnouncerV2), {
            message: formatMessage(issueResultsData?.isCappingIssueSearchResult ? (0, $5nM3q.default).screenReaderSearchResultMoreInfo : (0, $5nM3q.default).screenReaderSearchResultInfo, {
                total: issueResultsData?.totalIssueSearchResultCount
            }),
            shouldAnnounce: shouldAnnounceInfo,
            testId: "issue-navigator.ui.search-announcer"
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $j6Pvv.default), {
            onChangeColumnConfiguration: onChangeColumnConfiguration,
            onChangeJql: onChangeJql,
            onCaughtIssueSearchError: setCaughtIssueSearchError,
            issueResults: issueResultsData,
            view: viewData,
            viewResult: viewResultData,
            isFeedbackButtonDisabled: isFeedbackButtonDisabled,
            issueTableProps: issueTableProps,
            filter: filter
        })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7QBK4.default), {
            hasIssueResults: !!issueResultsData?.totalIssueSearchResultCount,
            userPreferences: userPreferencesData,
            isAiEnabled: isAiEnabled
        })), [
        IssueNavigatorTopBar,
        selectedView,
        filter,
        issueResultsData,
        filterQueryIsFetching,
        filterId,
        noFilterReason,
        formatMessage,
        shouldAnnounceInfo,
        onChangeColumnConfiguration,
        onChangeJql,
        viewData,
        viewResultData,
        isFeedbackButtonDisabled,
        issueTableProps,
        userPreferencesData,
        isAiEnabled
    ]);
    const [isFullPageIssueAppMode] = (0, $1ydM0.useIsFullPageIssueAppMode)();
    if (isFullPageIssueAppMode) IssueNavigatorContent = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $cXdDi.default), {
        onChangeIssue: onChangeIssue,
        issueResults: issueResultsData
    });
     // eslint-disable-next-line react-hooks/rules-of-hooks
    (0, $1ybV0.ff)('nin.global-scope_aqec8') && (0, $cHJdq.useGlobalScopeOptInFlag)();
    const isFailedIssueSearch = !issueResultsData || issueResultsData.issueSearchError?.__typename === 'JiraServerError' || caughtIssueSearchError !== undefined || ((0, $1ybV0.ff)('handle-404-filter-errors-gracefully-in-the-ui-by-showing-filter-not-found-view_t3d2m') ? !viewResultData || viewResultData?.__typename === 'QueryError' && viewResultData?.extensions?.[0]?.statusCode !== 404 : !viewData);
    return (0, $eUqFw.useMemo)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, IssueNavigatorContent, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $fWUVl.default), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $d6f6c.FireScreenAnalytics), null), isFailedIssueSearch ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $g8nwX.IssueSearchFail), {
            location: `${(0, $jccNB.PACKAGE_NAME)}.ui`,
            error: caughtIssueSearchError || (0, $1ybV0.ff)('handle-404-filter-errors-gracefully-in-the-ui-by-showing-filter-not-found-view_t3d2m') && viewResultError || new Error('There was an error searching for issues'),
            onPageDataLoad: onPageDataLoad,
            attributes: {
                isAiEnabled: isAiEnabled
            }
        }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $g8nwX.IssueSearchSuccess), {
            onPageDataLoad: onPageDataLoad,
            attributes: {
                isAiEnabled: isAiEnabled
            }
        })), [
        IssueNavigatorContent,
        isFailedIssueSearch,
        caughtIssueSearchError,
        viewResultError,
        onPageDataLoad,
        isAiEnabled
    ]);
};
// re-render regression detection
$16bee20b057014f4$export$397fa57fff06920f.whyDidYouRender = true;
var $16bee20b057014f4$export$2e2bcd8739ae039 // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
 = /*#__PURE__*/ (0, $eUqFw.memo)($16bee20b057014f4$export$397fa57fff06920f);
const $16bee20b057014f4$var$IssueNavigatorContentContainer = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { selectedView: selectedView, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _2lx21bp4 _4t3i1osq _18s8fkly",
            (0, $1ybV0.ff)('jsv-one-issue-table-spreadsheet-ui_ygrnf') && __cmplp.selectedView !== 'detail' && "_n3tdv47k _vchhusvi",
            __cmplp.className
        ])
    });
});

});
parcelRegister("6a5PX", function(module, exports) {

$parcel$export(module.exports, "default", () => $9714f471128517a8$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<b028ab22d769af59e1b92eab949e2221>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $9714f471128517a8$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "main_issueNavigator_IssueNavigatorUI_jqlBuilderWithAiKey",
    "selections": [
        {
            "kind": "FragmentSpread",
            "name": "jqlBuilder_issueNavigator_JQLBuilderWrapper_jqlBuilderWithAiKey"
        }
    ],
    "type": "JiraQuery"
};
$9714f471128517a8$var$node.hash = "e9088c921273ca13e8f1d0f476e2f2fb";
var $9714f471128517a8$export$2e2bcd8739ae039 = $9714f471128517a8$var$node;

});

parcelRegister("fIE7K", function(module, exports) {

$parcel$export(module.exports, "default", () => $129c0b1f02e8204b$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<1da52f0913815b9fe1e6847953ff7bea>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $129c0b1f02e8204b$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "main_issueNavigator_IssueNavigatorUI_userPreferences",
    "selections": [
        {
            "kind": "FragmentSpread",
            "name": "spotlight_issueNavigator_IssueNavigatorSpotlight"
        }
    ],
    "type": "JiraUserPreferences"
};
$129c0b1f02e8204b$var$node.hash = "aa84b2b1589fd8e695aa782c018fd60c";
var $129c0b1f02e8204b$export$2e2bcd8739ae039 = $129c0b1f02e8204b$var$node;

});

parcelRegister("90nIr", function(module, exports) {

$parcel$export(module.exports, "default", () => $b7c97e792043363c$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<bd1a202c59b76d20d2e6f59479005e11>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $b7c97e792043363c$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "main_issueNavigator_IssueNavigatorUI_view",
    "selections": [
        {
            "kind": "FragmentSpread",
            "name": "main_issueNavigator_IssueResults_view"
        }
    ],
    "type": "JiraIssueSearchView"
};
$b7c97e792043363c$var$node.hash = "e8840d03c4ef04a7162079f3724c9689";
var $b7c97e792043363c$export$2e2bcd8739ae039 = $b7c97e792043363c$var$node;

});

parcelRegister("aVBi2", function(module, exports) {

$parcel$export(module.exports, "default", () => $ffb20baea2ff018d$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<33e5bb206265992af6994be5778aec2d>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $ffb20baea2ff018d$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "main_issueNavigator_IssueNavigatorUI_viewResult",
    "selections": [
        {
            "kind": "FragmentSpread",
            "name": "main_issueNavigator_IssueResults_viewResult"
        },
        {
            "kind": "InlineFragment",
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "message"
                },
                {
                    "kind": "LinkedField",
                    "name": "extensions",
                    "plural": true,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "statusCode"
                        }
                    ]
                },
                {
                    "kind": "ScalarField",
                    "name": "__typename"
                }
            ],
            "type": "QueryError"
        }
    ],
    "type": "JiraIssueSearchViewResult",
    "abstractKey": "__isJiraIssueSearchViewResult"
};
$ffb20baea2ff018d$var$node.hash = "810362e5295b32593f863dd5a2c4e501";
var $ffb20baea2ff018d$export$2e2bcd8739ae039 = $ffb20baea2ff018d$var$node;

});

parcelRegister("ldWhx", function(module, exports) {

$parcel$export(module.exports, "default", () => $6942cd14536cc89d$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<ebb5efcd0a2ac44d95acc3957f7ff9a5>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $6942cd14536cc89d$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "main_issueNavigator_IssueNavigatorUI_issueResults",
    "selections": [
        {
            "kind": "FragmentSpread",
            "name": "topBar_issueNavigator_issueResults"
        },
        {
            "kind": "FragmentSpread",
            "name": "main_issueNavigator_Header_issueResults"
        },
        {
            "kind": "FragmentSpread",
            "name": "jqlBuilder_issueNavigator_JQLBuilderWrapper_issueResults"
        },
        {
            "kind": "FragmentSpread",
            "name": "main_issueNavigator_IssueResults_issueResults"
        },
        {
            "kind": "FragmentSpread",
            "name": "main_issueNavigator_FullPageIssueApp"
        },
        {
            "kind": "LinkedField",
            "name": "issueSearchError",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "__typename"
                }
            ]
        },
        {
            "kind": "ScalarField",
            "name": "totalIssueSearchResultCount"
        },
        {
            "kind": "ScalarField",
            "name": "isCappingIssueSearchResult"
        }
    ],
    "type": "JiraIssueConnection"
};
$6942cd14536cc89d$var$node.hash = "2badab2f4a91c7cb41cd705ebf77707f";
var $6942cd14536cc89d$export$2e2bcd8739ae039 = $6942cd14536cc89d$var$node;

});

parcelRegister("hPdNw", function(module, exports) {

$parcel$export(module.exports, "AnnouncerV2", () => $f3fdf175d37cb8cd$export$a43c8a2f4981e0e);

var $eUqFw = parcelRequire("eUqFw");

var $kjXsi = parcelRequire("kjXsi");
const $f3fdf175d37cb8cd$var$NON_BREAKING_SPACE = '\u00A0';
const $f3fdf175d37cb8cd$export$a43c8a2f4981e0e = /*#__PURE__*/ (0, $eUqFw.memo)(({ message: originalMessage, liveMode: liveMode = 'polite', shouldAnnounce: shouldAnnounce = true, testId: testId })=>{
    const previousMessage = (0, $eUqFw.useRef)('');
    const setAlternatePolite = (0, $eUqFw.useRef)(false);
    const addSuffix = (0, $eUqFw.useRef)(false);
    const [oldMessage, setOldMessage] = (0, $eUqFw.useState)('');
    const [newMessage, setNewMessage] = (0, $eUqFw.useState)('');
    (0, $eUqFw.useEffect)(()=>{
        let message = shouldAnnounce ? originalMessage : $f3fdf175d37cb8cd$var$NON_BREAKING_SPACE;
        if (previousMessage.current === message) {
            addSuffix.current = !addSuffix.current;
            if (addSuffix.current) message += $f3fdf175d37cb8cd$var$NON_BREAKING_SPACE;
        }
        setOldMessage(setAlternatePolite.current ? '' : message);
        setNewMessage(setAlternatePolite.current ? message : '');
        if (shouldAnnounce) setAlternatePolite.current = !setAlternatePolite.current;
        previousMessage.current = originalMessage;
    }, [
        originalMessage,
        shouldAnnounce
    ]);
    // 2 aria-live containers needed to prevent bugs in browsers that will stop
    // announcing updates to the same div if these are too repetitive.
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
        "data-testid": testId
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $kjXsi.ScreenReaderText), {
        role: "status",
        "aria-live": liveMode,
        "aria-relevant": "additions text",
        "aria-atomic": "true"
    }, oldMessage), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $kjXsi.ScreenReaderText), {
        role: "status",
        "aria-live": liveMode,
        "aria-relevant": "additions text",
        "aria-atomic": "true"
    }, newMessage));
});

});
parcelRegister("kjXsi", function(module, exports) {

$parcel$export(module.exports, "visuallyHiddenStyles", () => $cfcbcec828cf2e62$export$8dd524ceb40e3d16);
$parcel$export(module.exports, "ScreenReaderText", () => $cfcbcec828cf2e62$export$88fad6aa294f111c);
$parcel$export(module.exports, "ScreenReaderCaption", () => $cfcbcec828cf2e62$export$200c8e5d652aa9af);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ /**
 * Visible only to screenreaders. Use when there is a need
 * to provide more context to a non-sighted user.
 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");
const $cfcbcec828cf2e62$export$8dd524ceb40e3d16 = {
    clip: 'rect(1px, 1px, 1px, 1px)',
    clipPath: 'inset(50%)',
    height: '1px',
    width: '1px',
    margin: '-1px',
    overflow: 'hidden',
    padding: 0,
    position: 'absolute'
};
const $cfcbcec828cf2e62$export$88fad6aa294f111c = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $eUqFw.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_ogto7mnp _mkrz1wmp _4t3it94y _1bsbt94y _19pk1n1a _2hwx1n1a _otyr1n1a _18u01n1a _1reo15vq _18m915vq _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _kqswstnw",
            __cmplp.className
        ])
    });
});
const $cfcbcec828cf2e62$export$200c8e5d652aa9af = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "caption", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $eUqFw.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_ogto7mnp _mkrz1wmp _4t3it94y _1bsbt94y _19pk1n1a _2hwx1n1a _otyr1n1a _18u01n1a _1reo15vq _18m915vq _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _kqswstnw",
            __cmplp.className
        ])
    });
});

});


parcelRegister("cHJdq", function(module, exports) {

$parcel$export(module.exports, "NinChangeboardingContext", () => $12b6aa65edf761e5$export$b349f970aff316d8);
$parcel$export(module.exports, "EnableNinChangeboardingProvider", () => $12b6aa65edf761e5$export$dd1deacfc61c978a);
$parcel$export(module.exports, "NinChangeboardingTourTarget", () => $12b6aa65edf761e5$export$eb95770b90ecc1f3);
$parcel$export(module.exports, "NinChangeboardingTourCard", () => $12b6aa65edf761e5$export$7c27d65549066b5);
$parcel$export(module.exports, "useGlobalScopeOptInFlag", () => $12b6aa65edf761e5$export$9e9f507adee88e58);

var $eUqFw = parcelRequire("eUqFw");

var $1ybV0 = parcelRequire("1ybV0");

var $k8Qyf = parcelRequire("k8Qyf");

var $3QLcd = parcelRequire("3QLcd");

var $jSWn5 = parcelRequire("jSWn5");

var $geV2Y = parcelRequire("geV2Y");
var $4Qa4O = parcelRequire("4Qa4O");

var $bn9O6 = parcelRequire("bn9O6");
const $12b6aa65edf761e5$export$b349f970aff316d8 = /*#__PURE__*/ (0, $eUqFw.createContext)(false);
const $12b6aa65edf761e5$export$dd1deacfc61c978a = ({ children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($12b6aa65edf761e5$export$b349f970aff316d8.Provider, {
        value: true
    }, children);
const $12b6aa65edf761e5$export$eb95770b90ecc1f3 = ({ children: children, engagementId: engagementId })=>{
    const isTourEnabled = (0, $eUqFw.useContext)($12b6aa65edf761e5$export$b349f970aff316d8);
    if (!(0, $1ybV0.ff)('nin.global-scope_aqec8') || !isTourEnabled) // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    return children;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4Qa4O.default), {
        engagementId: engagementId
    }, children);
};
const $12b6aa65edf761e5$export$7c27d65549066b5 = ({ mode: mode, view: view, hasIssueResults: hasIssueResults, isAiEnabled: isAiEnabled })=>{
    const isTourEnabled = (0, $eUqFw.useContext)($12b6aa65edf761e5$export$b349f970aff316d8);
    if (!(0, $1ybV0.ff)('nin.global-scope_aqec8') || !isTourEnabled) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $geV2Y.AsyncSpotlightCard), {
        mode: mode,
        view: view,
        hasIssueResults: hasIssueResults,
        isAiEnabled: isAiEnabled
    });
};
const $12b6aa65edf761e5$export$9e9f507adee88e58 = ()=>{
    const isFlagEnabled = (0, $eUqFw.useContext)($12b6aa65edf761e5$export$b349f970aff316d8);
    const { showFlag: showFlag } = (0, $k8Qyf.useFlagsService)();
    const onOpenInProductHelpArticle = (0, $3QLcd.useHelpPanelLink)();
    const onLearnMore = (0, $eUqFw.useCallback)(()=>{
        if (onOpenInProductHelpArticle !== undefined) onOpenInProductHelpArticle?.((0, $jSWn5.LEARN_MORE_IPH_ARTICLE_ID));
        else window.open((0, $jSWn5.FALLBACK_SUPPORT_ARTICLE));
    }, [
        onOpenInProductHelpArticle
    ]);
    (0, $eUqFw.useEffect)(()=>{
        const shouldShowOptInFlag = sessionStorage.getItem('showNinOptInFlag');
        if ((0, $1ybV0.ff)('nin.global-scope_aqec8') && isFlagEnabled && shouldShowOptInFlag === 'true') {
            showFlag({
                type: 'success',
                title: (0, $bn9O6.default).successOptInTitle,
                description: (0, $bn9O6.default).successOptInDesc,
                actions: [
                    {
                        content: (0, $bn9O6.default).successActionLearnMoreLink,
                        onClick: onLearnMore
                    }
                ],
                isAutoDismiss: false,
                testId: 'issue-navigator-changeboarding.optin-success-flag'
            });
            sessionStorage.removeItem('showNinOptInFlag');
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
};

});
parcelRegister("3QLcd", function(module, exports) {

$parcel$export(module.exports, "useHelpPanelLink", () => $82adde900735644c$export$dc5c3cc39ce0d138);
$parcel$export(module.exports, "default", () => $82adde900735644c$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $7JEyt = parcelRequire("7JEyt");

var $eUqFw = parcelRequire("eUqFw");

var $7u4fN = parcelRequire("7u4fN");

var $cEaY5 = parcelRequire("cEaY5");

var $zcJ0y = parcelRequire("zcJ0y");

var $1ybV0 = parcelRequire("1ybV0");

var $f2Poq = parcelRequire("f2Poq");

var $1zRTT = parcelRequire("1zRTT");

var $bUi2Q = parcelRequire("bUi2Q");
const $82adde900735644c$export$dc5c3cc39ce0d138 = (resetHistory = false)=>{
    const { openRightSidebar: openRightSidebar } = (0, $bUi2Q.useRightSidebarController)();
    const [, { setNavigationData: setNavigationData }] = (0, $1zRTT.useHelpPanelActions)();
    const isIphEnabled = (0, $1ybV0.ff)('iph.enabled') && !(0, $zcJ0y.isIE11)();
    const handleOnClick = (id, type = 'HELP_ARTICLE')=>{
        openRightSidebar((0, $f2Poq.HELP_PANEL_ID), (0, $f2Poq.HELP_PANEL_WIDTH), false, true);
        if (resetHistory) setNavigationData({
            articleId: {
                id: id,
                type: (0, $cEaY5.ARTICLE_TYPE)[type]
            },
            history: []
        });
        else setNavigationData({
            articleId: {
                id: id,
                type: (0, $cEaY5.ARTICLE_TYPE)[type]
            }
        });
    };
    return isIphEnabled ? handleOnClick : undefined;
};
const $82adde900735644c$var$HelpPanelLink = ({ articleId: articleId = '', type: type = 'HELP_ARTICLE', children: children, fallbackComponent: fallbackComponent = null, onClick: onClick, ...props })=>{
    const onOpenInProductHelpArticle = $82adde900735644c$export$dc5c3cc39ce0d138();
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const handleOnClick = (event, analyticsEvent)=>{
        onClick?.(event, analyticsEvent);
        onOpenInProductHelpArticle?.(articleId, (0, $cEaY5.ARTICLE_TYPE)[type]);
    };
    return onOpenInProductHelpArticle ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7u4fN.default), {
        ...props,
        onClick: handleOnClick,
        // eslint-disable-next-line @atlaskit/design-system/no-unsafe-style-overrides
        className: (0, $7JEyt.default)([
            props.appearance === 'link' && "_4bfu18uv _1hms8stv _ajmmnqa1 _9oik18uv _1bnxglyw _jf4cnqa1"
        ])
    }, children) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, fallbackComponent);
};
var $82adde900735644c$export$2e2bcd8739ae039 = $82adde900735644c$var$HelpPanelLink;
const $82adde900735644c$var$buttonWrapperStyles = null;

});

parcelRegister("jSWn5", function(module, exports) {

$parcel$export(module.exports, "FALLBACK_SUPPORT_ARTICLE", () => $c905222c653b3744$export$ff66aa7a4971d979);
$parcel$export(module.exports, "LEARN_MORE_IPH_ARTICLE_ID", () => $c905222c653b3744$export$88d16e35389ab3c6);
$parcel$export(module.exports, "getEngagementPlatformlMessageId", () => $c905222c653b3744$export$91074f0ada4f4533);
$parcel$export(module.exports, "TOUR_MESSAGE_ID", () => $c905222c653b3744$export$4ac775bda929f47);
$parcel$export(module.exports, "views", () => $c905222c653b3744$export$d0079916fe6800ac);
const $c905222c653b3744$export$565b01733f42b193 = 'https://community.atlassian.com/t5/Jira-articles/We-re-bringing-updates-to-the-issue-navigator/ba-p/2096660';
const $c905222c653b3744$export$ff66aa7a4971d979 = 'https://support.atlassian.com/jira-software-cloud/docs/search-for-issues-in-jira/';
const $c905222c653b3744$export$88d16e35389ab3c6 = '3FGQv6n7fB93yWWTYqY0hq';
const $c905222c653b3744$export$91074f0ada4f4533 = (id)=>`${id}-march2024`;
const $c905222c653b3744$export$4ac775bda929f47 = 'nin-changeboarding-start';
const $c905222c653b3744$export$6c69c3d1b5f6fe55 = {
    basic: 'basic',
    advanced: 'advanced'
};
const $c905222c653b3744$export$d0079916fe6800ac = {
    list: 'list-view',
    detail: 'split-view'
};

});

parcelRegister("geV2Y", function(module, exports) {

$parcel$export(module.exports, "AsyncSpotlightCard", () => $1112eadbf801540c$export$40e85aa59c198f98);

var $eUqFw = parcelRequire("eUqFw");

var $7rh0R = parcelRequire("7rh0R");

var $0cdA8 = parcelRequire("0cdA8");

var $gGtKh = parcelRequire("gGtKh");

var $4Qa4O = parcelRequire("4Qa4O");

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $1112eadbf801540c$var$SpotlightCard = (0, $7rh0R.lazy)(// we want both these types of spotlights to be within the same webpack chunk
()=>(parcelRequire("fVqgS")), {
    ssr: false,
    moduleId: "./src/packages/issue-navigator/changeboarding/src/common/ui/spotlight/spotlight-card/index.tsx"
});
const $1112eadbf801540c$export$40e85aa59c198f98 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $0cdA8.JSErrorBoundary), {
        packageName: "jiraIssueNavigatorChangeboarding",
        id: "async-spotlight-card",
        sendToPrivacyUnsafeSplunk: true,
        fallback: "unmount"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gGtKh.default), {
        name: "async-spotlight-card",
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($1112eadbf801540c$var$SpotlightCard, props)));

});
parcelRegister("4Qa4O", function(module, exports) {

$parcel$export(module.exports, "default", () => $1828e5e0fe5f546b$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $7rh0R = parcelRequire("7rh0R");

var $ltfxy = parcelRequire("ltfxy");

var $0cdA8 = parcelRequire("0cdA8");

var $gGtKh = parcelRequire("gGtKh");

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $1828e5e0fe5f546b$var$EngagementSpotlightAsync = (0, $7rh0R.lazy)(()=>(parcelRequire("eqPjL")).then(({ EngagementSpotlight: EngagementSpotlight })=>EngagementSpotlight), {
    ssr: false,
    moduleId: "../platform/packages/personalization/engagekit-ts/src/index.ts"
});
const $1828e5e0fe5f546b$var$SpotlightTourTarget = ({ children: children, engagementId: engagementId })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $ltfxy.default), {
        name: engagementId
    }, children), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $0cdA8.JSErrorBoundary), {
        packageName: "jiraIssueNavigatorChangeboarding",
        id: "async-engagement-spotlight",
        sendToPrivacyUnsafeSplunk: true,
        fallback: "unmount"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gGtKh.default), {
        name: "async-engagement-spotlight"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($1828e5e0fe5f546b$var$EngagementSpotlightAsync, {
        engagementId: engagementId
    }))));
var $1828e5e0fe5f546b$export$2e2bcd8739ae039 = $1828e5e0fe5f546b$var$SpotlightTourTarget;

});
parcelRegister("eqPjL", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = Promise.all([
    $d1Cng("h2MrD"),
    $d1Cng("bYT2S"),
    $d1Cng("hPzOn"),
    $d1Cng("2hmUs"),
    $d1Cng("bCeK4"),
    $d1Cng("6EdQQ")
]).then(()=>parcelRequire('82zYL'));

});


parcelRegister("fVqgS", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = Promise.all([
    $d1Cng("2hmUs"),
    $d1Cng("bCeK4"),
    $d1Cng("cwy0j")
]).then(()=>parcelRequire('l56q4'));

});


parcelRegister("bn9O6", function(module, exports) {

$parcel$export(module.exports, "default", () => $7d3be14eb932981d$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
const $7d3be14eb932981d$var$messages = (0, $90IgZ.defineMessages)({
    successOptInTitle: {
        "id": "issue-navigator-changeboarding.controllers.enable-nin-changeboarding.success-opt-in-title",
        "defaultMessage": "You've switched to the new issue search"
    },
    successOptInDesc: {
        "id": "issue-navigator-changeboarding.controllers.enable-nin-changeboarding.success-opt-in-desc",
        "defaultMessage": "Say hello to a faster, cleaner, and more intuitive experience while searching for issues across Jira."
    },
    successActionLearnMoreLink: {
        "id": "issue-navigator-changeboarding.controllers.enable-nin-changeboarding.success-action-learn-more-link",
        "defaultMessage": "Learn more"
    }
});
var $7d3be14eb932981d$export$2e2bcd8739ae039 = $7d3be14eb932981d$var$messages;

});


parcelRegister("3Lg4c", function(module, exports) {

$parcel$export(module.exports, "NoFilter", () => $d207ffa811f2a7fb$export$fba2cdeecf4e314d);

var $eUqFw = parcelRequire("eUqFw");

var $7u4fN = parcelRequire("7u4fN");

var $220ac = parcelRequire("220ac");

var $b5IAe = parcelRequire("b5IAe");
var $1ZAYh = parcelRequire("1ZAYh");

var $1ybV0 = parcelRequire("1ybV0");

var $hgbp4 = parcelRequire("hgbp4");

var $5JgJ2 = parcelRequire("5JgJ2");

var $8WuJm = parcelRequire("8WuJm");
var $d6f6c = parcelRequire("d6f6c");

var $f5Nzv = parcelRequire("f5Nzv");
const $d207ffa811f2a7fb$var$ANOTHER_FILTER_LINK = '/jira/filters';
const $d207ffa811f2a7fb$export$fba2cdeecf4e314d = ({ reason: reason })=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    return (0, $1ybV0.ff)('handle-404-filter-errors-gracefully-in-the-ui-by-showing-filter-not-found-view_t3d2m') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8WuJm.ContextualAnalyticsData), {
        sourceName: "noFilter",
        sourceType: (0, $41ea3621645e2acc$export$f636b5b56f1d624a)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $d6f6c.FireScreenAnalytics), {
        attributes: reason ? {
            reason: reason
        } : undefined
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $220ac.default), {
        header: formatMessage((0, $f5Nzv.default).weCouldntFindThisFilter),
        description: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("p", null, formatMessage((0, $f5Nzv.default).filterNoExistOrNoPermissions)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("p", null, formatMessage((0, $f5Nzv.default).tryAnotherFilter))),
        secondaryAction: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7u4fN.default), {
            href: $d207ffa811f2a7fb$var$ANOTHER_FILTER_LINK
        }, formatMessage((0, $f5Nzv.default).viewFilters)),
        primaryAction: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7u4fN.default), {
            appearance: "primary",
            href: window.location.pathname
        }, formatMessage((0, $f5Nzv.default).searchIssues)),
        renderImage: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
                xcss: $d207ffa811f2a7fb$var$ImageWrapperStyles
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $hgbp4.default), {
                alt: ""
            }))
    })) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $220ac.default), {
        header: formatMessage((0, $f5Nzv.default).weCouldntFindThisFilter),
        description: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("p", null, formatMessage((0, $f5Nzv.default).filterNoExistOrNoPermissions)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("p", null, formatMessage((0, $f5Nzv.default).tryAnotherFilter))),
        secondaryAction: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7u4fN.default), {
            href: $d207ffa811f2a7fb$var$ANOTHER_FILTER_LINK
        }, formatMessage((0, $f5Nzv.default).viewFilters)),
        primaryAction: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7u4fN.default), {
            appearance: "primary",
            href: window.location.pathname
        }, formatMessage((0, $f5Nzv.default).searchIssues)),
        renderImage: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
                xcss: $d207ffa811f2a7fb$var$ImageWrapperStyles
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $hgbp4.default), {
                alt: ""
            }))
    });
};
var $d207ffa811f2a7fb$export$2e2bcd8739ae039 = $d207ffa811f2a7fb$export$fba2cdeecf4e314d;
const $d207ffa811f2a7fb$var$ImageWrapperStyles = (0, $1ZAYh.xcss)({
    maxHeight: '146px',
    maxWidth: '160px',
    margin: 'auto',
    marginBottom: 'space.300'
});

});
parcelRegister("hgbp4", function(module, exports) {

$parcel$export(module.exports, "default", () => $d2d2ebe01d4784a8$export$2e2bcd8739ae039);
$parcel$export(module.exports, "srcLight", () => (/*@__PURE__*/$parcel$interopDefault((parcelRequire("1lasE")))));
// THIS FILE WAS AUTO-GENERATED. MODIFY WITH CAUTION. See README.md
// brandfolder asset id = 748pv5qrn493bqk8kv9zvsnq
// brandfolder url = https://brandfolder.com/atlassian-brand-creative-library/atlassian-public-asset-library/#!asset/748pv5qrn493bqk8kv9zvsnq

var $9TZf5 = parcelRequire("9TZf5");

var $gMIRj = parcelRequire("gMIRj");

var $1lasE = parcelRequire("1lasE");
/** @deprecated cf. https://hello.atlassian.net/wiki/spaces/IMKT/pages/743859674/Empty+state+and+Error+state+guidelines */ const $d2d2ebe01d4784a8$var$Illustration = (0, $9TZf5.createIllustration)({
    srcLight: (/*@__PURE__*/$parcel$interopDefault($1lasE)),
    srcDark: (/*@__PURE__*/$parcel$interopDefault($gMIRj))
});
var $d2d2ebe01d4784a8$export$2e2bcd8739ae039 = $d2d2ebe01d4784a8$var$Illustration;
// for advanced use only
const $d2d2ebe01d4784a8$export$a179c88182cb9d56 = [
    0,
    0,
    208,
    190
];

});
parcelRegister("gMIRj", function(module, exports) {
module.exports = new URL("search-no-results-darkmode.41158025.svg", import.meta.url).toString();

});

parcelRegister("1lasE", function(module, exports) {
module.exports = new URL("search-no-results.10b14394.svg", import.meta.url).toString();

});


parcelRegister("f5Nzv", function(module, exports) {

$parcel$export(module.exports, "default", () => $7080d3169c338e73$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $7080d3169c338e73$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    weCouldntFindThisFilter: {
        "id": "issue-navigator.common.no-filter.we-couldnt-find-this-filter",
        "defaultMessage": "We couldn't find this filter"
    },
    filterNoExistOrNoPermissions: {
        "id": "issue-navigator.common.no-filter.filter-no-exist-or-no-permissions",
        "defaultMessage": "This filter may not exist, or you don\u2019t have permissions to view it."
    },
    tryAnotherFilter: {
        "id": "issue-navigator.common.no-filter.try-another-filter",
        "defaultMessage": "Try searching for another filter, or start a new issue search."
    },
    viewFilters: {
        "id": "issue-navigator.common.no-filter.view-filters",
        "defaultMessage": "View filters"
    },
    searchIssues: {
        "id": "issue-navigator.common.no-filter.search-issues",
        "defaultMessage": "Search issues"
    }
});

});


parcelRegister("g8nwX", function(module, exports) {

$parcel$export(module.exports, "IssueSearchSuccess", () => $6c2b80cae36e3261$export$3ee6d2830e5ead03);
$parcel$export(module.exports, "IssueSearchFail", () => $6c2b80cae36e3261$export$91886a55521e4fad);

var $eUqFw = parcelRequire("eUqFw");

var $hzcvF = parcelRequire("hzcvF");

var $fsuyl = parcelRequire("fsuyl");

var $cQBUE = parcelRequire("cQBUE");

var $4RwIp = parcelRequire("4RwIp");
const $6c2b80cae36e3261$export$3ee6d2830e5ead03 = ({ attributes: attributes, onPageDataLoad: onPageDataLoad })=>{
    const [{ view: view }] = (0, $4RwIp.useSelectedViewState)();
    const { onIssueSearchSuccess: onIssueSearchSuccess } = (0, $fsuyl.useExperienceAnalytics)(onPageDataLoad, view, attributes);
    const { isFetching: isFetching, isNetworkError: isNetworkError } = (0, $cQBUE.useIssueSearchQuery)();
    const prevIsFetching = (0, $hzcvF.usePrevious)(isFetching);
    (0, $eUqFw.useEffect)(()=>{
        if (prevIsFetching !== isFetching && !isFetching && !isNetworkError) onIssueSearchSuccess();
    }, [
        isFetching,
        isNetworkError,
        onIssueSearchSuccess,
        prevIsFetching
    ]);
    return null;
};
const $6c2b80cae36e3261$export$91886a55521e4fad = ({ attributes: attributes, location: location, error: error, onPageDataLoad: onPageDataLoad })=>{
    const [{ view: view }] = (0, $4RwIp.useSelectedViewState)();
    const { onIssueSearchFail: onIssueSearchFail } = (0, $fsuyl.useExperienceAnalytics)(onPageDataLoad, view, attributes);
    const { isFetching: isFetching } = (0, $cQBUE.useIssueSearchQuery)();
    const prevIsFetching = (0, $hzcvF.usePrevious)(isFetching);
    (0, $eUqFw.useEffect)(()=>{
        if (prevIsFetching !== isFetching && !isFetching) onIssueSearchFail(location, error);
    }, [
        error,
        isFetching,
        location,
        onIssueSearchFail,
        prevIsFetching
    ]);
    return null;
};

});

parcelRegister("cXdDi", function(module, exports) {

$parcel$export(module.exports, "default", () => $eb8468cf89444516$export$2e2bcd8739ae039);

var $4uDjy = parcelRequire("4uDjy");

var $eUqFw = parcelRequire("eUqFw");

var $iWLL0 = parcelRequire("iWLL0");

var $7u4fN = parcelRequire("7u4fN");

var $9aFSa = parcelRequire("9aFSa");

var $5JgJ2 = parcelRequire("5JgJ2");

var $8WuJm = parcelRequire("8WuJm");
var $jMP2a = parcelRequire("jMP2a");
var $bFzGY = parcelRequire("bFzGY");

var $6vrw7 = parcelRequire("6vrw7");

var $idiDE = parcelRequire("idiDE");

var $jccNB = parcelRequire("jccNB");

var $cIZjs = parcelRequire("cIZjs");

var $1ydM0 = parcelRequire("1ydM0");

var $cQBUE = parcelRequire("cQBUE");

var $21fwU = parcelRequire("21fwU");
const $eb8468cf89444516$var$FullPageIssueApp = ({ onChangeIssue: onChangeIssue, issueResults: issueResults })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bFzGY.useAnalyticsEvents)();
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const { isFetching: isFetching } = (0, $cQBUE.useIssueSearchQuery)();
    const [isForcedSelectionOnReset, { exitFullPageIssueAppMode: exitFullPageIssueAppMode, selectNextIssue: selectNextIssue, selectPreviousIssue: selectPreviousIssue }] = (0, $1ydM0.useIsForcedSelectionOnReset)();
    const onBackToSearch = (0, $eUqFw.useCallback)(()=>{
        // Clear the selected issue key from the URL and return to normal view mode
        onChangeIssue((0, $6vrw7.toIssueKey)(''), true);
        exitFullPageIssueAppMode();
    }, [
        exitFullPageIssueAppMode,
        onChangeIssue
    ]);
    const onBackToSearchByButton = (0, $eUqFw.useCallback)((e, analyticsEvent)=>{
        // @ts-expect-error - Argument of type 'UIAnalyticsEvent | null' is not assignable to parameter of type 'UIAnalyticsEvent'.
        (0, $jMP2a.fireUIAnalytics)(analyticsEvent.clone(), 'returnToSearch');
        onBackToSearch();
    }, [
        onBackToSearch
    ]);
    const onBackToSearchByKeyboardShortcut = (0, $eUqFw.useCallback)(()=>{
        (0, $jMP2a.fireUIAnalytics)(createAnalyticsEvent({
            action: 'toggled',
            actionSubject: 'issue'
        }), 'returnToSearch', {
            keyPressed: 'z',
            keyboardShortcut: true
        });
        onBackToSearch();
    }, [
        onBackToSearch,
        createAnalyticsEvent
    ]);
    const onNextIssue = (0, $eUqFw.useCallback)(()=>{
        if (selectNextIssue()) (0, $jMP2a.fireUIAnalytics)(createAnalyticsEvent({
            action: 'clicked',
            actionSubject: 'button'
        }), 'nextIssue', {
            keyboardShortcut: true
        });
    }, [
        createAnalyticsEvent,
        selectNextIssue
    ]);
    const onPreviousIssue = (0, $eUqFw.useCallback)(()=>{
        if (selectPreviousIssue()) (0, $jMP2a.fireUIAnalytics)(createAnalyticsEvent({
            action: 'clicked',
            actionSubject: 'button'
        }), 'previousIssue', {
            keyboardShortcut: true
        });
    }, [
        createAnalyticsEvent,
        selectPreviousIssue
    ]);
    // If a new search is being run and we do not have forced issue selection (i.e. issue app pagination) then return to
    // normal view mode. This can happen when a filter is clicked in the sidebar or browser history navigation.
    (0, $eUqFw.useEffect)(()=>{
        if (isFetching && !isForcedSelectionOnReset) exitFullPageIssueAppMode();
    }, [
        exitFullPageIssueAppMode,
        isFetching,
        isForcedSelectionOnReset
    ]);
    const backToSearch = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7u4fN.default), {
        testId: "issue-navigator.ui.full-page-issue-app.return-to-search",
        onClick: onBackToSearchByButton,
        interactionName: "issue-navigator-full-page-issue-app-return-to-search"
    }, formatMessage((0, $21fwU.default).returnText));
    const issueResultsData = (0, $iWLL0.useFragment)((0, $4uDjy.default), issueResults);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $idiDE.default), {
        name: "full-page-issue-app"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8WuJm.ContextualAnalyticsData), {
        sourceName: (0, $jccNB.ANALYTICS_LIST_VIEW_SOURCE_NAME),
        sourceType: (0, $41ea3621645e2acc$export$f636b5b56f1d624a)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $9aFSa.default), {
        keyMap: {
            z: {
                callback: onBackToSearchByKeyboardShortcut
            },
            j: {
                callback: onNextIssue
            },
            k: {
                callback: onPreviousIssue
            }
        }
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $cIZjs.default), {
        isEmbedView: false,
        extraHeaderActions: backToSearch,
        issueResults: issueResultsData
    })));
};
var $eb8468cf89444516$export$2e2bcd8739ae039 = $eb8468cf89444516$var$FullPageIssueApp;

});
parcelRegister("4uDjy", function(module, exports) {

$parcel$export(module.exports, "default", () => $90a43973e664a17f$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<355e9dd885145701d04f73ed32eadd92>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $90a43973e664a17f$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "main_issueNavigator_FullPageIssueApp",
    "selections": [
        {
            "kind": "FragmentSpread",
            "name": "main_issueNavigator_IssueAppWithData"
        }
    ],
    "type": "JiraIssueConnection"
};
$90a43973e664a17f$var$node.hash = "f4cc24bfb9dd3b8b33dee658cbe69429";
var $90a43973e664a17f$export$2e2bcd8739ae039 = $90a43973e664a17f$var$node;

});

parcelRegister("9aFSa", function(module, exports) {

$parcel$export(module.exports, "default", () => $80173688b586a9b5$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $7Q1yP = parcelRequire("7Q1yP");

var $cIhGE = parcelRequire("cIhGE");

var $haeC1 = parcelRequire("haeC1");

var $fVFUy = parcelRequire("fVFUy");

var $kGQen = parcelRequire("kGQen");

var $h80SI = parcelRequire("h80SI");
let $80173688b586a9b5$var$shortcutsCount = 0;
let $80173688b586a9b5$var$subscription = null;
const $80173688b586a9b5$var$ShortcutsSubscriber = false ? ()=>null : ({ keyMap: keyMap, label: label, location: location })=>{
    const parentRegistry = (0, $eUqFw.useContext)((0, $kGQen.ShortcutRegistryContext)) || (0, $fVFUy.rootRegistry);
    const addKeyMap = (0, $eUqFw.useCallback)(()=>parentRegistry.addKeyMap(()=>({
                keyMap: (0, $h80SI.bindKeyMapWithErrorHandling)(keyMap, location),
                label: label
            })), [
        label,
        parentRegistry,
        keyMap,
        location
    ]);
    (0, $eUqFw.useEffect)(()=>{
        $80173688b586a9b5$var$shortcutsCount += 1;
        const removeKeyMap = addKeyMap();
        return ()=>{
            removeKeyMap();
            $80173688b586a9b5$var$shortcutsCount -= 1;
            if ($80173688b586a9b5$var$subscription && $80173688b586a9b5$var$shortcutsCount === 0) {
                $80173688b586a9b5$var$subscription.unsubscribe();
                $80173688b586a9b5$var$subscription = null;
            }
        };
    }, [
        addKeyMap
    ]);
    (0, $eUqFw.useEffect)(()=>{
        $80173688b586a9b5$var$subscription = $80173688b586a9b5$var$subscription || // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        (0, $cIhGE.default)().subscribe((0, $haeC1.default));
    }, [
        parentRegistry,
        keyMap
    ]);
    return null;
};
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$80173688b586a9b5$export$2e2bcd8739ae039 = ({ useKeyboardShortcutsToggle: useKeyboardShortcutsToggle = (0, $7Q1yP.useKeyboardShortcutsToggle), ...props })=>{
    const [{ isEnabled: isEnabled }] = useKeyboardShortcutsToggle();
    return isEnabled && !false ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($80173688b586a9b5$var$ShortcutsSubscriber, props) : null;
};

});
parcelRegister("7Q1yP", function(module, exports) {

$parcel$export(module.exports, "useKeyboardShortcutsToggle", () => $e8e091cfd61e9197$export$a33a81f1fc5458ad);

var $guiFP = parcelRequire("guiFP");

var $lRmyA = parcelRequire("lRmyA");

var $6rW04 = parcelRequire("6rW04");

var $jMP2a = parcelRequire("jMP2a");

var $1yZQx = parcelRequire("1yZQx");
var $kEDjj = parcelRequire("kEDjj");
const $e8e091cfd61e9197$var$URL_FRAGMENT = '/rest/internal/latest/user/preferences/keyboardShortcuts?turn=';
const $e8e091cfd61e9197$export$b62f67be35e65859 = (analyticsEvent)=>async ({ setState: setState, getState: getState })=>{
        const currentState = getState().isEnabled;
        const status = currentState ? 'off' : 'on';
        const url = `${$e8e091cfd61e9197$var$URL_FRAGMENT}${status}`;
        try {
            await (0, $lRmyA.performPutRequest)(url);
            setState({
                isEnabled: !currentState,
                error: null
            });
            (0, $jMP2a.fireUIAnalytics)(analyticsEvent, 'keyboardShortcutsToggle', {
                isEnabled: !currentState
            });
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (err) {
            setState({
                error: err
            });
            (0, $guiFP.default)({
                meta: {
                    id: 'keyboardShortcutToggleFailure',
                    packageName: 'jiraCommonLegacyDoNotAddAnythingNew'
                },
                error: err
            });
        }
    };
const $e8e091cfd61e9197$var$Store = (0, $kEDjj.createStore)({
    initialState: {
        isEnabled: false ? false : !((0, $6rW04.default)('ajs-keyboard-shortcuts-enabled') === 'false'),
        error: null
    },
    actions: {
        // @ts-expect-error - TS2322 - Type '( analyticsEvent: UIAnalyticsEventInterface) => ({ setState, getState }: StoreActionApi<State>) => Promise<void>' is not assignable to type 'ActionThunk<{ isEnabled: boolean; error: null; }, { toggle: ( analyticsEvent: UIAnalyticsEventInterface) => ({ setState, getState }: StoreActionApi<State>) => Promise<void>; }>'.
        toggle: $e8e091cfd61e9197$export$b62f67be35e65859
    }
});
const $e8e091cfd61e9197$export$a33a81f1fc5458ad = (0, $1yZQx.createHook)($e8e091cfd61e9197$var$Store);

});

parcelRegister("cIhGE", function(module, exports) {

$parcel$export(module.exports, "default", () => $61e80b5974f2eb64$export$2e2bcd8739ae039);
$parcel$export(module.exports, "flush", () => $61e80b5974f2eb64$export$4909b86c8034bf73);
/**
 * An observable that emits key sequences as a string representation
 *
 * Examples:
 *
 * g i
 * shift+enter
 */ 
var $3JafE = parcelRequire("3JafE");

var $70s4u = parcelRequire("70s4u");
parcelRequire("fRdoC");
parcelRequire("5dKXv");
parcelRequire("8OtG5");
parcelRequire("fWv6o");
parcelRequire("flmol");
parcelRequire("7Rus6");
parcelRequire("azOPD");
parcelRequire("1d9Hc");

var $1YqdI = parcelRequire("1YqdI");
const $61e80b5974f2eb64$var$ignoredKeys = {
    Control: true,
    Meta: true,
    Shift: true,
    Alt: true,
    AltGraph: true,
    CapsLock: true,
    Fn: true,
    FnLock: true,
    Hyper: true,
    NumLock: true,
    OS: true,
    ScrollLock: true,
    Super: true,
    Symbol: true,
    SymbolLock: true
};
/**
 * Skipping few input types to allow keydown event propagation to it's parent element
 * inputMode - react-select or select or combo
 * type - skipping these inputtypes (checkbox, radio) to support shortcuts like
 *        e(EPIC panel) or v(VERSION panel) or n(board card selection) in board and backlog
 * This condition added as a part of https://a11y.atlassian.net/browse/JCA11Y-1317
 */ const $61e80b5974f2eb64$var$isNonTextInput = ({ inputMode: inputMode = '', type: type })=>inputMode === 'none' || type === 'checkbox';
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $61e80b5974f2eb64$var$isEditable = (node)=>node.nodeName === 'INPUT' && !$61e80b5974f2eb64$var$isNonTextInput(node) || node.nodeName === 'TEXTAREA' || node.isContentEditable === true;
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $61e80b5974f2eb64$var$isRelevantKeyEvent = (e)=>typeof e.key === 'string' && // @ts-expect-error - TS7053 - Element implicitly has an 'any' type because expression of type 'any' can't be used to index type '{ readonly Control: true; readonly Meta: true; readonly Shift: true; readonly Alt: true; readonly AltGraph: true; readonly CapsLock: true; readonly Fn: true; readonly FnLock: true; readonly Hyper: true; ... 5 more ...; readonly SymbolLock: true; }'.
    (e.key === 'Escape' || !$61e80b5974f2eb64$var$isEditable(e.target) && !$61e80b5974f2eb64$var$ignoredKeys[e.key]);
const $61e80b5974f2eb64$export$25d1b8252b4c49b7 = ()=>{
    const elBlankets = document.querySelectorAll('.aui-blanket');
    if (elBlankets.length === 0) // no aui-blanket in DOM, so it means it's closed
    return true;
    const isAllHidden = Array.from(elBlankets || []).every((el)=>{
        if (el.getAttribute('aria-hidden') === 'true' || // when `el.getAttribute('hidden')` returns an empty string, it means the element has the `hidden` attribute and it's invisible.
        el.getAttribute('hidden') !== null) return true;
        return false;
    });
    return isAllHidden;
};
let $61e80b5974f2eb64$var$key$;
const $61e80b5974f2eb64$var$flush$ = new (0, $70s4u.Subject)();
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$61e80b5974f2eb64$export$2e2bcd8739ae039 = ()=>{
    if (!$61e80b5974f2eb64$var$key$) {
        $61e80b5974f2eb64$var$key$ = false ? new (0, $70s4u.Subject)() : (0, $3JafE.Observable).fromEvent(document, 'keydown').filter($61e80b5974f2eb64$var$isRelevantKeyEvent).filter($61e80b5974f2eb64$export$25d1b8252b4c49b7).map((0, $1YqdI.toKeyWithModifiers));
        const sequence$ = $61e80b5974f2eb64$var$key$.scan((seq, key)=>{
            if (!key || !seq) return undefined;
            return {
                sequence: `${String(seq.sequence)} ${String(key.sequence)}`,
                e: key.e
            };
        });
        $61e80b5974f2eb64$var$key$ = $61e80b5974f2eb64$var$key$.debounceTime(1000).startWith(null).merge($61e80b5974f2eb64$var$flush$).switchMapTo(sequence$);
    }
    return $61e80b5974f2eb64$var$key$;
};
const $61e80b5974f2eb64$export$4909b86c8034bf73 = ()=>{
    $61e80b5974f2eb64$var$flush$.next();
};

});
parcelRegister("1YqdI", function(module, exports) {

$parcel$export(module.exports, "toKeyWithModifiers", () => $1b99fa3356e664b3$export$8cf0d2c3d060a0c2);
$parcel$export(module.exports, "isValidShortcut", () => $1b99fa3356e664b3$export$8e231506c5580162);
$parcel$export(module.exports, "isShortcutCollision", () => $1b99fa3356e664b3$export$4add9e50cb49d130);
/**
 * Converts a KeyboardEvent to a normalised string representation of
 * modifiers and key.
 *
 * Ordering of modifier keys is taken from Apple's guidelines:
 * https://developer.apple.com/macos/human-interface-guidelines/input-and-output/keyboard/
 *
 * Example representation of ArrowUp key with all modifiers present:
 * ctrl+shift+meta+arrowup
 *
 * Character keys never include the 'shift' modifier,.
 * as it changes the character itself.
 * Examples:
 *  - instead of 'shift+a' the normal form is 'A'
 *  - instead of 'shift+/' the normal form is '?'
 *
 * The 'alt' modifier is NOT supported at all due to inconsistent behaviour
 * across platforms. On Mac, it changes the character input, e.g.
 * 'alt+z' is 'Ω' - which becomes the `event.key`. To properly support
 * this, a reverse-mapping of all these characters needs to be added.
 * Alternatively, `String.fromCharCode(event.which)` can be used, but
 * 1. This is a deprecated property
 * 2. The char code is still for the modified character for some keys on Mac
 *    (e.g. The char code for 'alt+/' is '¿')
 */ // Special keys such as 'Escape', 'ArrowUp' or ' '
const $1b99fa3356e664b3$var$isNonCharacterKey = (e)=>e.key.length > 1 || e.key === ' ';
const $1b99fa3356e664b3$var$modifiers = [
    {
        name: 'ctrl',
        // @ts-expect-error - TS7006 - Parameter 'e' implicitly has an 'any' type.
        test: (e)=>e.ctrlKey
    },
    {
        name: 'shift',
        // @ts-expect-error - TS7006 - Parameter 'e' implicitly has an 'any' type.
        test: (e)=>e.shiftKey && $1b99fa3356e664b3$var$isNonCharacterKey(e)
    },
    {
        // Command key on MacOS, Windows key on Windows
        name: 'meta',
        // @ts-expect-error - TS7006 - Parameter 'e' implicitly has an 'any' type.
        test: (e)=>e.metaKey || e.getModifierState && e.getModifierState('OS')
    }
];
const $1b99fa3356e664b3$var$toKey = (e)=>{
    if ($1b99fa3356e664b3$var$isNonCharacterKey(e)) return e.key.toLowerCase();
    // Ignore accidental CapsLock
    return e.shiftKey ? e.key.toUpperCase() : e.key.toLowerCase();
};
const $1b99fa3356e664b3$export$8cf0d2c3d060a0c2 = (e)=>{
    if (!e || !e.key) // There are still browsers out there that do not support e.key;
    // Just today (Oct 2018) I have observed Chrome 47 in Sentry, but it started supporting e.key since 51.
    // So instead of crashing the page with TypeError let's not detect keyboard shortcuts.
    return {
        sequence: '',
        e: e
    };
    return {
        sequence: $1b99fa3356e664b3$var$modifiers.filter((modifier)=>modifier.test(e)).map((modifier)=>modifier.name).concat($1b99fa3356e664b3$var$toKey(e)).join('+'),
        e: e
    };
};
/*
 *  Selected special key values disjunction for regex. All lowercase, ordered alphabethically.
 *  See https://developer.mozilla.org/en-US/docs/Web/API/KeyboardEvent/key/Key_Values.
 */ const $1b99fa3356e664b3$var$orSpecialChars = ' |arrowdown|arrowleft|arrowright|arrowup|backspace|clear|delete|end|enter|escape|home|insert|pagedown|pageup|pause|printscreen|tab';
/*
 * This string when used as a regular expression:
 * 1. Allows lowercase only with a single exception (see 3)
 * 2. Allows optional ctrl, shift, meta followed by "+" in that specific order in the beginning
 * 3. Allows any printable character (may be uppercase letter) or a special key value
 * 4. If shift modifier is used it can only be followed by a special char
 * 5. Is based on toKeyWithModifiers, uses orSpecialChars whitelist for shift chars
 * 6. Does not capture redundant groups
 */ const $1b99fa3356e664b3$var$singleShortcutEntry = `(ctrl\\+)?(shift\\+(?=(?:(?:meta\\+)?(?:${$1b99fa3356e664b3$var$orSpecialChars}))))?(meta\\+)?(${$1b99fa3356e664b3$var$orSpecialChars}|[!-~])`;
/*
 * Any number of singleShortcutEntry separated by a single space
 * We are not specifying "g" flag, so it's fine to reuse the same regex object.
 */ const $1b99fa3356e664b3$var$shortcutRegex = RegExp(`^${$1b99fa3356e664b3$var$singleShortcutEntry}( ${$1b99fa3356e664b3$var$singleShortcutEntry})*$`);
const $1b99fa3356e664b3$export$8e231506c5580162 = (shortcut)=>$1b99fa3356e664b3$var$shortcutRegex.test(shortcut);
const $1b99fa3356e664b3$export$4add9e50cb49d130 = (leftShortcut, rightShortcut)=>{
    if (!leftShortcut || !rightShortcut) return leftShortcut === rightShortcut;
    if (rightShortcut === leftShortcut) return true;
    if (leftShortcut.indexOf(rightShortcut) === 0) return leftShortcut[rightShortcut.length] === ' ';
    if (rightShortcut.indexOf(leftShortcut) === 0) return rightShortcut[leftShortcut.length] === ' ';
    return false;
};

});


parcelRegister("haeC1", function(module, exports) {

$parcel$export(module.exports, "default", () => $44bf9c8ab51bd76c$export$2e2bcd8739ae039);

var $cIhGE = parcelRequire("cIhGE");

var $fVFUy = parcelRequire("fVFUy");
const $44bf9c8ab51bd76c$var$matches = (prefix)=>(definedSequence)=>definedSequence.startsWith(`${prefix} `);
var /**
 * Manages key sequence inputs to execute predefined actions or clear unmatched sequences. This function ensures efficient handling of user inputs by checking against existing sequences and preparing for potential future matches.
 */ // eslint-disable-next-line jira/import/no-anonymous-default-export
$44bf9c8ab51bd76c$export$2e2bcd8739ae039 = (keySequence)=>{
    const { sequence: sequence, e: e } = keySequence || {};
    const activeKeyMap = (0, $fVFUy.rootRegistry).getActiveKeyMap();
    if (sequence !== undefined && activeKeyMap[sequence]) {
        activeKeyMap[sequence].callback(e);
        (0, $cIhGE.flush)();
    } else {
        // Are there any sequences that might be activated with more key presses?
        const isFutureMatchPossible = sequence !== undefined && Object.keys(activeKeyMap).some($44bf9c8ab51bd76c$var$matches(sequence));
        if (!isFutureMatchPossible) (0, $cIhGE.flush)();
    }
};

});
parcelRegister("fVFUy", function(module, exports) {

$parcel$export(module.exports, "ShortcutRegistry", () => $3843ad0413ec519e$export$ca1c75b575abf5ff);
$parcel$export(module.exports, "rootRegistry", () => $3843ad0413ec519e$export$1dd4c61d1ce1fa15);
/* eslint-disable jira/js/no-reduce-accumulator-spread */ /**
 * A tree-like registry of shortcuts, with a default, root registry.
 */ 
var $fUTZC = parcelRequire("fUTZC");

var $6G5mG = parcelRequire("6G5mG");

var $ldoFd = parcelRequire("ldoFd");

var $bFXjh = parcelRequire("bFXjh");

var $1YqdI = parcelRequire("1YqdI");
const $3843ad0413ec519e$var$validateKeyMaps = (keyMaps)=>{
    (0, (/*@__PURE__*/$parcel$interopDefault($fUTZC)))(keyMaps, (keyMap, keyMapIndex)=>{
        const shortcuts = Object.keys(keyMap);
        (0, (/*@__PURE__*/$parcel$interopDefault($fUTZC)))(shortcuts, (shortcut, shortcutIndex)=>{
            if (!(0, $1YqdI.isValidShortcut)(shortcut)) // eslint-disable-next-line no-console
            console.error(`"${shortcut}" is an incorrect shortcut. Please, update it according to a playbook entry on shortcuts.`);
            for(let indexForOtherKeymaps = keyMapIndex + 1; indexForOtherKeymaps < keyMaps.length; indexForOtherKeymaps += 1){
                const anotherKeyMap = keyMaps[indexForOtherKeymaps];
                (0, (/*@__PURE__*/$parcel$interopDefault($fUTZC)))(anotherKeyMap, (anotherAction, anotherShortcut)=>{
                    if ((0, $1YqdI.isShortcutCollision)(anotherShortcut, shortcut)) // If neither shortcut has a priority we have a conflict.. You should ideally
                    // put a priority on one of these conflicting shortcut configs so you definitively
                    // know which one should be active when there is a conflict.
                    {
                        if ((0, (/*@__PURE__*/$parcel$interopDefault($ldoFd)))(keyMap[shortcut].priority) && (0, (/*@__PURE__*/$parcel$interopDefault($ldoFd)))(anotherKeyMap[anotherShortcut].priority) || keyMap[shortcut].priority === anotherKeyMap[anotherShortcut].priority) // DO NOT LET THIS HAPPEN. ADD A PRIORITY!!!
                        // eslint-disable-next-line no-console
                        console.error(`"${shortcut}" has a collision with "${anotherShortcut}" shortcut from another keyMap.`);
                    }
                });
            }
            for(let indexToCompareSelf = shortcutIndex + 1; indexToCompareSelf < shortcuts.length; indexToCompareSelf += 1)if ((0, $1YqdI.isShortcutCollision)(shortcut, shortcuts[indexToCompareSelf])) // eslint-disable-next-line no-console
            console.error(`"${shortcut}" has a collision with "${shortcuts[indexToCompareSelf]}" shortcut from the same keyMap.`);
        });
    });
};
const $3843ad0413ec519e$var$mergeKeyMaps = (keyMapsToMerge)=>// Instead of doing the standard Object.assign({}, ...keyMapsToMerge)
    // we want to have a bit more control over what we can and can't override
    // through the use of the priority
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    keyMapsToMerge.reduce((prev, keyMap)=>({
            ...prev,
            // Add the keys that can be overridden
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            ...Object.keys(keyMap).reduce((newAccumulator, newKey)=>{
                if (!(0, (/*@__PURE__*/$parcel$interopDefault($6G5mG)))(prev, newKey) || (prev[newKey].priority ?? 0) < (keyMap[newKey].priority ?? 1 // Default behaviour is override
                )) return {
                    ...newAccumulator,
                    [newKey]: keyMap[newKey]
                };
                return newAccumulator;
            }, {})
        }), {});
class $3843ad0413ec519e$export$ca1c75b575abf5ff {
    addChildRegistry(child) {
        this.children.push(child);
        return ()=>{
            (0, (/*@__PURE__*/$parcel$interopDefault($bFXjh)))(this.children, child);
        };
    }
    addKeyMap(getKeyMap) {
        this.keyMapRetrievers.push(getKeyMap);
        return ()=>{
            (0, (/*@__PURE__*/$parcel$interopDefault($bFXjh)))(this.keyMapRetrievers, getKeyMap);
        };
    }
    getActiveKeyMap() {
        const keyMaps = this.children.length ? this.children.map((child)=>child.getActiveKeyMap()) : this.keyMapRetrievers.map((getKeyMap)=>getKeyMap().keyMap);
        return {
            ...$3843ad0413ec519e$var$mergeKeyMaps(keyMaps)
        };
    }
    getKeyMapInfo() {
        const info = this.children.length ? this.children.map((child)=>child.getKeyMapInfo()) : this.keyMapRetrievers.map((getInfo)=>getInfo());
        // @ts-expect-error - TS2769 - No overload matches this call.
        const flattenedInfo = [].concat(...info);
        return flattenedInfo;
    }
    constructor(){
        // go/jfe-eslint
        this.children = [];
        this.keyMapRetrievers = [];
    }
}
const $3843ad0413ec519e$export$1dd4c61d1ce1fa15 = new $3843ad0413ec519e$export$ca1c75b575abf5ff();

});


parcelRegister("kGQen", function(module, exports) {

$parcel$export(module.exports, "ShortcutRegistryContext", () => $082205e2100625d8$export$ebbb59327adb551a);
$parcel$export(module.exports, "default", () => $082205e2100625d8$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $fVFUy = parcelRequire("fVFUy");
const $082205e2100625d8$export$ebbb59327adb551a = /*#__PURE__*/ (0, $eUqFw.createContext)((0, $fVFUy.rootRegistry));
const $082205e2100625d8$var$ShortcutScope = ({ children: children = null })=>{
    const registry = (0, $eUqFw.useMemo)(()=>new (0, $fVFUy.ShortcutRegistry)(), []);
    const parentRegistry = (0, $eUqFw.useContext)($082205e2100625d8$export$ebbb59327adb551a) || (0, $fVFUy.rootRegistry);
    (0, $eUqFw.useEffect)(()=>{
        // "This only happens ONCE.  But it happens AFTER the initial render."
        const removeRegistry = parentRegistry.addChildRegistry(registry);
        return removeRegistry;
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($082205e2100625d8$export$ebbb59327adb551a.Provider, {
        value: registry
    }, children);
};
var $082205e2100625d8$export$2e2bcd8739ae039 = false ? ({ children: children = null })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, children) : $082205e2100625d8$var$ShortcutScope;

});

parcelRegister("h80SI", function(module, exports) {

$parcel$export(module.exports, "bindKeyMapWithErrorHandling", () => $2297a6a3d8ab933d$export$77477772a9b904da);

var $gUUjF = parcelRequire("gUUjF");
const $2297a6a3d8ab933d$var$wrapCallbackWithErrorHandling = (key, callback, location = 'keyboard-shortcuts.common')=>(e)=>{
        try {
            callback(e);
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (error) {
            (0, $gUUjF.default).safeErrorWithoutCustomerData(location, `Error firing shortcut '${key}': ${error.message} (commandPaletteBlockNativeShortcutFF=true)`, error);
        }
    };
const $2297a6a3d8ab933d$export$77477772a9b904da = (keyMap, location)=>// eslint-disable-next-line @typescript-eslint/no-explicit-any
    Object.keys(keyMap).reduce((map, key)=>({
            // eslint-disable-next-line jira/js/no-reduce-accumulator-spread
            ...map,
            [key]: {
                ...keyMap[key],
                callback: $2297a6a3d8ab933d$var$wrapCallbackWithErrorHandling(key, keyMap[key].callback, location)
            }
        }), {});

});


parcelRegister("cIZjs", function(module, exports) {

$parcel$export(module.exports, "default", () => $21a48eadd1523c55$export$2e2bcd8739ae039);

var $dHTT1 = parcelRequire("dHTT1");

var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $7rh0R = parcelRequire("7rh0R");

var $iWLL0 = parcelRequire("iWLL0");

var $1ybV0 = parcelRequire("1ybV0");

var $iH6jq = parcelRequire("iH6jq");
var $cavjE = parcelRequire("cavjE");

var $fE3Ua = parcelRequire("fE3Ua");

var $gJYxu = parcelRequire("gJYxu");

var $9mxRp = parcelRequire("9mxRp");

var $48mPv = parcelRequire("48mPv");
var $d7Wfe = parcelRequire("d7Wfe");
var $bsdZ2 = parcelRequire("bsdZ2");

var $8WuJm = parcelRequire("8WuJm");
var $bFzGY = parcelRequire("bFzGY");

var $6vrw7 = parcelRequire("6vrw7");

var $iJHZm = parcelRequire("iJHZm");

var $kOOpn = parcelRequire("kOOpn");

var $1ydM0 = parcelRequire("1ydM0");

var $cQBUE = parcelRequire("cQBUE");

var $jccNB = parcelRequire("jccNB");

var $cWCvn = parcelRequire("cWCvn");

var $lCzk9 = parcelRequire("lCzk9");
const $21a48eadd1523c55$var$isEcClientEnabled = ()=>{
    const experiences = (0, $1ybV0.getFeatureFlagValue)('odin.ec.client.integration.issueview', '').split(',');
    return Array.isArray(experiences) && experiences.includes('nin-issue-view');
}; // eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences

const $21a48eadd1523c55$var$AsyncIssueAppComponent = (0, $7rh0R.lazyAfterPaint)(()=>(parcelRequire("geiGJ")), {
    ssr: false,
    moduleId: "./src/packages/issue/issue-view/src/views/issue-details/issue-app.tsx"
});
const $21a48eadd1523c55$var$AsyncIssueAppUsingLoadingPhases = ({ isEmbedView: isEmbedView, ...rest })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gJYxu.IssueBoundary), {
        packageName: "issue-navigator",
        isEmbedView: isEmbedView,
        render: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $cavjE.UnknownErrorView), null)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($21a48eadd1523c55$var$AsyncIssueAppComponent, rest));
const $21a48eadd1523c55$var$issueCardChangeExcludedEventTypes = [
    (0, $fE3Ua.ChangeEventTypes).FIELD_CHANGE_REQUESTED,
    (0, $fE3Ua.ChangeEventTypes).FIELD_CHANGE_FAILED,
    (0, $fE3Ua.ChangeEventTypes).CHILD_ISSUE_ADDED,
    (0, $fE3Ua.ChangeEventTypes).ISSUE_CHILDREN_ORDER_CHANGED
];
const $21a48eadd1523c55$var$IssueAppWithData = ({ IssueApp: IssueApp = $21a48eadd1523c55$var$AsyncIssueAppUsingLoadingPhases, extraHeaderActions: extraHeaderActions, isEmbedView: isEmbedView, issueResults: issueResults })=>{
    (0, $cWCvn.markOnce)((0, $cWCvn.marks).ISSUE_APP_START);
    (0, $eUqFw.useLayoutEffect)(()=>{
        (0, $cWCvn.markOnce)((0, $cWCvn.marks).ISSUE_APP_END);
    }, []);
    const [selectedIssueKey] = (0, $1ydM0.useSelectedIssueDebouncedState)();
    const [, { deselectIssue: deselectIssue, exitFullPageIssueAppMode: exitFullPageIssueAppMode, setSelectedIssueByKey: setSelectedIssueByKey }] = (0, $1ydM0.useSelectedIssueStateActions)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bFzGY.useAnalyticsEvents)(); // eslint-disable-next-line @typescript-eslint/no-explicit-any
    let saveIssueMutationToCache;
    if ($21a48eadd1523c55$var$isEcClientEnabled()) // eslint-disable-next-line react-hooks/rules-of-hooks
    saveIssueMutationToCache = (0, $bsdZ2.useEcClient)().saveIssueMutationToCache;
    const issueResultsData = (0, $iWLL0.useFragment)((0, $dHTT1.default), issueResults);
    const { onInteractive: onInteractive } = (0, $kOOpn.useStartNinIssueAppAnalytics)(selectedIssueKey);
    const issueAppMetrics = (0, $eUqFw.useMemo)(()=>({
            onInteractive: onInteractive
        }), [
        onInteractive
    ]);
    const { onDeleteIssue: onDeleteIssue, onIssueByFieldsRefetch: onIssueByFieldsRefetch } = (0, $cQBUE.useIssueSearchQuery)();
    const refetchCallback = (0, $eUqFw.useRef)(onIssueByFieldsRefetch);
    refetchCallback.current = onIssueByFieldsRefetch;
    const onIssueDeleteSuccess = (0, $eUqFw.useCallback)(({ issueKey: deletedIssueKey })=>{
        const issueKeyToSelect = onDeleteIssue(deletedIssueKey);
        if (!issueKeyToSelect.length) {
            deselectIssue(); // Return to list view if we were in full page mode
            exitFullPageIssueAppMode();
        } else setSelectedIssueByKey((0, $6vrw7.toIssueKey)(issueKeyToSelect));
    }, [
        deselectIssue,
        exitFullPageIssueAppMode,
        onDeleteIssue,
        setSelectedIssueByKey
    ]);
    const onIssueKeyChange = (0, $eUqFw.useCallback)((issueKeys)=>{
        setSelectedIssueByKey(issueKeys.toIssueKey);
    }, [
        setSelectedIssueByKey
    ]);
    const [issueSelection] = (0, $1ydM0.useIssueSelectionState)(); // When we're in non-embedded view (i.e. full page) we need to define a max width to ensure correct full page
    // styling within the issue app.
    const maxWidth = !isEmbedView ? (0, $9mxRp.getIssueContainerMaxWidth)() : undefined;
    if (issueSelection === (0, $1ydM0.selectionState).BLANK_ISSUE_SELECTED) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($21a48eadd1523c55$var$IssueAppContainer, {
        isEmbedView: isEmbedView
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $lCzk9.default), {
        issueResults: issueResultsData,
        extraHeaderActions: extraHeaderActions,
        isEmbedView: isEmbedView,
        maxWidth: maxWidth
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $iH6jq.PermissionErrorView), null));
    if (!selectedIssueKey) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $iJHZm.SpaStatePageErrorReady), null);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($21a48eadd1523c55$var$IssueAppContainer, {
        isEmbedView: isEmbedView
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $lCzk9.default), {
        issueResults: issueResultsData,
        extraHeaderActions: extraHeaderActions,
        isEmbedView: isEmbedView,
        maxWidth: maxWidth
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($21a48eadd1523c55$var$IssueAppHeightAdjustment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8WuJm.ContextualAnalyticsData), {
        sourceName: "issueNavigatorEmbeddedIssueView",
        sourceType: (0, $41ea3621645e2acc$export$f636b5b56f1d624a)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(IssueApp, {
        metrics: issueAppMetrics,
        key: selectedIssueKey,
        isEmbedView: isEmbedView,
        analyticsSource: (0, $jccNB.ANALYTICS_SOURCE),
        issueKey: (0, $6vrw7.toIssueKey)(selectedIssueKey),
        issueMaxWidth: maxWidth,
        onIssueKeyChange: onIssueKeyChange,
        onChange: (event)=>{
            if (event && !$21a48eadd1523c55$var$issueCardChangeExcludedEventTypes.includes(event.type)) refetchCallback.current(String(selectedIssueKey));
            if (event?.type === 'FIELD_CHANGED') {
                const analyticsEventObj = createAnalyticsEvent({});
                const analyticsDataKey = {
                    analyticsEventObj: analyticsEventObj,
                    analyticsMetadata: {
                        scenario: 'nin-issue-view'
                    }
                };
                if ($21a48eadd1523c55$var$isEcClientEnabled()) saveIssueMutationToCache(new (0, $48mPv.default)(event?.issueId, (0, $d7Wfe.MutationSource).UPDATE), analyticsDataKey, {
                    errorMsg: 'FAILED_NIN_ISSUEVIEW',
                    error: true
                });
            }
        },
        onIssueDeleteSuccess: onIssueDeleteSuccess,
        shouldSetInitialFocus: false
    }))));
};
var $21a48eadd1523c55$export$2e2bcd8739ae039 // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
 = $21a48eadd1523c55$var$IssueAppWithData;
const $21a48eadd1523c55$var$IssueAppContainer = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { isEmbedView: isEmbedView, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_kqswh2mm _16jlkb7n _4t3i1osq _1ul9idpf _1e0c1txw _2lx21bp4 _vchhusvi",
            !__cmplp.isEmbedView && "_ca0qxy5q",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $21a48eadd1523c55$var$IssueAppHeightAdjustment = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_4t3i1osq _1tkeidpf",
            __cmplp.className
        ])
    });
});

});
parcelRegister("dHTT1", function(module, exports) {

$parcel$export(module.exports, "default", () => $2cfcf10963774669$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<57be5be30230a7d7baac9f6c8f3cf1c8>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $2cfcf10963774669$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "main_issueNavigator_IssueAppWithData",
    "selections": [
        {
            "kind": "FragmentSpread",
            "name": "headerActions_issueNavigator"
        }
    ],
    "type": "JiraIssueConnection"
};
$2cfcf10963774669$var$node.hash = "ac9a92f45a0e344788b01afcbb4c01aa";
var $2cfcf10963774669$export$2e2bcd8739ae039 = $2cfcf10963774669$var$node;

});

parcelRegister("iH6jq", function(module, exports) {

$parcel$export(module.exports, "PermissionErrorView", () => $481adf0d32cb7785$export$1bd3db7a0a8884d3);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $eI5EY = parcelRequire("eI5EY");

var $02Brq = parcelRequire("02Brq");

var $5JgJ2 = parcelRequire("5JgJ2");

var $1HfVs = parcelRequire("1HfVs");

var $gAcfY = parcelRequire("gAcfY");

var $lXKjT = parcelRequire("lXKjT");
const $481adf0d32cb7785$var$ErrorImage = ()=>(0, $eI5EY.fg)('move_issue_view_assets_into_central_location') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $02Brq.default), {
        width: 90,
        height: 130,
        alt: ""
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($481adf0d32cb7785$var$Image, {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($1HfVs))),
        alt: ""
    });
const $481adf0d32cb7785$export$1bd3db7a0a8884d3 = ()=>{
    const intl = (0, $5JgJ2.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gAcfY.ErrorDisplay), {
        header: intl.formatMessage((0, $lXKjT.messages).permissionErrorHeader),
        description: intl.formatMessage((0, $lXKjT.messages).permissionErrorDescription),
        image: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($481adf0d32cb7785$var$ErrorImage, null)
    });
}; // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $481adf0d32cb7785$var$Image = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "img", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_4t3i53f4 _1bsb10bg",
            __cmplp.className
        ])
    });
});

});
parcelRegister("02Brq", function(module, exports) {

$parcel$export(module.exports, "default", () => $078460ec2710d3c8$export$2e2bcd8739ae039);
// THIS FILE WAS AUTO-GENERATED. MODIFY WITH CAUTION. See README.md
// brandfolder asset id = mmwr66tqxzps49fhmn4694w
// brandfolder url = https://brandfolder.com/atlassian-brand-creative-library/atlassian-public-asset-library/#!asset/mmwr66tqxzps49fhmn4694w

var $9TZf5 = parcelRequire("9TZf5");

var $be4cc = parcelRequire("be4cc");

var $adQm7 = parcelRequire("adQm7");
const $078460ec2710d3c8$var$Illustration = (0, $9TZf5.createIllustration)({
    srcLight: (/*@__PURE__*/$parcel$interopDefault($adQm7)),
    srcDark: (/*@__PURE__*/$parcel$interopDefault($be4cc))
});
var $078460ec2710d3c8$export$2e2bcd8739ae039 = $078460ec2710d3c8$var$Illustration;
// for advanced use only
const $078460ec2710d3c8$export$a179c88182cb9d56 = [
    0,
    0,
    191,
    222
];

});
parcelRegister("be4cc", function(module, exports) {
module.exports = new URL("lock-closed-darkmode.26d51607.svg", import.meta.url).toString();

});

parcelRegister("adQm7", function(module, exports) {
module.exports = new URL("lock-closed.22dbfd6e.svg", import.meta.url).toString();

});


parcelRegister("1HfVs", function(module, exports) {
module.exports = new URL("permission-error.da9ec123.svg", import.meta.url).toString();

});

parcelRegister("gAcfY", function(module, exports) {

$parcel$export(module.exports, "ErrorDisplay", () => $72830fdda25402b0$export$d56b0569bceb92ae);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ // eslint-disable-next-line jira/restricted/react-component-props

var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");
const $72830fdda25402b0$export$d56b0569bceb92ae = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($72830fdda25402b0$var$Container, {
        "data-testid": "issue-view-errors.common.ui.error-display.permission-error-display"
    }, props.image, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($72830fdda25402b0$var$Heading, null, props.header), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($72830fdda25402b0$var$Description, null, props.description), props.children);
$72830fdda25402b0$export$d56b0569bceb92ae.defaultProps = {
    description: undefined,
    children: null
};
/**
 * Duplicated from `src/packages/issue/issue-view/src/views/issue-details/issue-modal/styled.tsx`
 *
 * TODO: Derive properly on `src/packages/issue/issue-view/src/views/issue-details/error` cleanup
 */ const $72830fdda25402b0$var$modalDialogContainerSelectorName = 'jira.issue-view.issue-details.modal-dialog-container';
const $72830fdda25402b0$var$MODAL_DIALOG_CONTAINER_COMPONENT_SELECTOR = `[data-component-selector="${$72830fdda25402b0$var$modalDialogContainerSelectorName}"]`;
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $72830fdda25402b0$var$Container = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_y3gn1h6o _2lx21bp4 _syaz1fxt _1e0c1txw _1bah1h6o _4cvr1h6o _ca0qxncg _17ipxncg _1ksgidpf",
            __cmplp.className
        ])
    });
});
const $72830fdda25402b0$var$Heading = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "h2", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_11c8o0gd _19pkutpp _otyrutpp _p12f1osq",
            __cmplp.className
        ])
    });
});
const $72830fdda25402b0$var$Description = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "p", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_p12f1osq",
            __cmplp.className
        ])
    });
});

});

parcelRegister("lXKjT", function(module, exports) {

$parcel$export(module.exports, "messages", () => $44ae321cec7c5988$export$defe85febe8b728c);

var $90IgZ = parcelRequire("90IgZ");
const $44ae321cec7c5988$export$defe85febe8b728c = (0, $90IgZ.defineMessages)({
    permissionErrorHeader: {
        "id": "issue-view-errors.permission-error-view.permission-error-header",
        "defaultMessage": "You don't have access to this issue"
    },
    permissionErrorDescription: {
        "id": "issue-view-errors.permission-error-view.permission-error-description",
        "defaultMessage": "Make sure the issue exists in this project. If it does, ask a project admin for permission to see the project's issues."
    }
});

});


parcelRegister("cavjE", function(module, exports) {

$parcel$export(module.exports, "UnknownErrorView", () => $6c37277dc48ad946$export$f23f26771420affd);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $eI5EY = parcelRequire("eI5EY");

var $po38W = parcelRequire("po38W");

var $5JgJ2 = parcelRequire("5JgJ2");

var $c7ALH = parcelRequire("c7ALH");

var $gAcfY = parcelRequire("gAcfY");

var $iSa7H = parcelRequire("iSa7H");
const $6c37277dc48ad946$var$ErrorImage = ()=>(0, $eI5EY.fg)('move_issue_view_assets_into_central_location') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $po38W.default), {
        width: 90,
        height: 130,
        alt: ""
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($6c37277dc48ad946$var$Image, {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($c7ALH))),
        alt: ""
    });
const $6c37277dc48ad946$export$f23f26771420affd = ()=>{
    const intl = (0, $5JgJ2.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gAcfY.ErrorDisplay), {
        header: intl.formatMessage((0, $iSa7H.messages).unknownErrorHeader),
        description: intl.formatMessage((0, $iSa7H.messages).unknownErrorDescription),
        image: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($6c37277dc48ad946$var$ErrorImage, null)
    });
}; // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $6c37277dc48ad946$var$Image = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "img", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_4t3i1j4a _1bsb68cl",
            __cmplp.className
        ])
    });
});

});
parcelRegister("po38W", function(module, exports) {

$parcel$export(module.exports, "default", () => $9eb6273fce2cbf57$export$2e2bcd8739ae039);
// THIS FILE WAS AUTO-GENERATED. MODIFY WITH CAUTION. See README.md

var $9TZf5 = parcelRequire("9TZf5");

var $4ingX = parcelRequire("4ingX");
const $9eb6273fce2cbf57$var$Illustration = (0, $9TZf5.createIllustration)({
    srcLight: (/*@__PURE__*/$parcel$interopDefault($4ingX)),
    srcDark: (/*@__PURE__*/$parcel$interopDefault($4ingX))
});
var $9eb6273fce2cbf57$export$2e2bcd8739ae039 = $9eb6273fce2cbf57$var$Illustration;
// for advanced use only
const $9eb6273fce2cbf57$export$a179c88182cb9d56 = [
    0,
    0,
    104,
    140
];

});
parcelRegister("4ingX", function(module, exports) {
module.exports = new URL("empty-search-error-colour.f0aa9e5e.svg", import.meta.url).toString();

});


parcelRegister("c7ALH", function(module, exports) {
module.exports = new URL("unknown-error.af4eba12.svg", import.meta.url).toString();

});

parcelRegister("iSa7H", function(module, exports) {

$parcel$export(module.exports, "messages", () => $1416a448c428a41e$export$defe85febe8b728c);

var $90IgZ = parcelRequire("90IgZ");
const $1416a448c428a41e$export$defe85febe8b728c = (0, $90IgZ.defineMessages)({
    unknownErrorHeader: {
        "id": "issue-view-errors.unknown-error-view.unknown-error-header",
        "defaultMessage": "We couldn't connect to that issue"
    },
    unknownErrorDescription: {
        "id": "issue-view-errors.unknown-error-view.unknown-error-description",
        "defaultMessage": "Make sure that this issue actually exists in that project. If it does, try again in a few minutes. If you still can't link to the issue, contact your Jira admin."
    }
});

});


parcelRegister("fE3Ua", function(module, exports) {

$parcel$export(module.exports, "ChangeEventTypes", () => $407ab16d43881e85$export$8db21fc94823e1cc);
const $407ab16d43881e85$var$FIELD_CHANGE_REQUESTED = 'FIELD_CHANGE_REQUESTED';
const $407ab16d43881e85$var$FIELD_CHANGED = 'FIELD_CHANGED';
const $407ab16d43881e85$var$FIELD_CHANGE_FAILED = 'FIELD_CHANGE_FAILED';
const $407ab16d43881e85$var$ISSUE_TYPE_CHANGED = 'ISSUE_TYPE_CHANGED';
const $407ab16d43881e85$var$ISSUE_RELATIONSHIP_UPDATED = 'ISSUE_RELATIONSHIP_UPDATED';
const $407ab16d43881e85$var$ISSUE_LINKS_CREATED = 'ISSUE_LINKS_CREATED';
const $407ab16d43881e85$var$ISSUE_LINK_DELETED = 'ISSUE_LINK_DELETED';
const $407ab16d43881e85$var$CHILD_ISSUE_ADDED = 'CHILD_ISSUE_ADDED';
const $407ab16d43881e85$var$SUBTASK_ADDED = 'SUBTASK_ADDED';
const $407ab16d43881e85$var$ISSUE_CHILDREN_ORDER_CHANGED = 'ISSUE_CHILDREN_ORDER_CHANGED';
const $407ab16d43881e85$var$CHILD_ISSUE_FIELD_UPDATED = 'CHILD_ISSUE_FIELD_UPDATED';
const $407ab16d43881e85$var$CREATE_CONFLUENCE_PAGE_LINK_SUCCESS = 'CREATE_CONFLUENCE_PAGE_LINK_SUCCESS';
const $407ab16d43881e85$var$DELETE_CONFLUENCE_PAGE_LINK_SUCCESS = 'DELETE_CONFLUENCE_PAGE_LINK_SUCCESS';
const $407ab16d43881e85$export$8db21fc94823e1cc = {
    [$407ab16d43881e85$var$FIELD_CHANGE_REQUESTED]: $407ab16d43881e85$var$FIELD_CHANGE_REQUESTED,
    [$407ab16d43881e85$var$FIELD_CHANGE_FAILED]: $407ab16d43881e85$var$FIELD_CHANGE_FAILED,
    [$407ab16d43881e85$var$FIELD_CHANGED]: $407ab16d43881e85$var$FIELD_CHANGED,
    [$407ab16d43881e85$var$ISSUE_TYPE_CHANGED]: $407ab16d43881e85$var$ISSUE_TYPE_CHANGED,
    [$407ab16d43881e85$var$ISSUE_RELATIONSHIP_UPDATED]: $407ab16d43881e85$var$ISSUE_RELATIONSHIP_UPDATED,
    [$407ab16d43881e85$var$ISSUE_LINKS_CREATED]: $407ab16d43881e85$var$ISSUE_LINKS_CREATED,
    [$407ab16d43881e85$var$ISSUE_LINK_DELETED]: $407ab16d43881e85$var$ISSUE_LINK_DELETED,
    [$407ab16d43881e85$var$CHILD_ISSUE_ADDED]: $407ab16d43881e85$var$CHILD_ISSUE_ADDED,
    [$407ab16d43881e85$var$SUBTASK_ADDED]: $407ab16d43881e85$var$SUBTASK_ADDED,
    [$407ab16d43881e85$var$ISSUE_CHILDREN_ORDER_CHANGED]: $407ab16d43881e85$var$ISSUE_CHILDREN_ORDER_CHANGED,
    [$407ab16d43881e85$var$CHILD_ISSUE_FIELD_UPDATED]: $407ab16d43881e85$var$CHILD_ISSUE_FIELD_UPDATED,
    [$407ab16d43881e85$var$CREATE_CONFLUENCE_PAGE_LINK_SUCCESS]: $407ab16d43881e85$var$CREATE_CONFLUENCE_PAGE_LINK_SUCCESS,
    [$407ab16d43881e85$var$DELETE_CONFLUENCE_PAGE_LINK_SUCCESS]: $407ab16d43881e85$var$DELETE_CONFLUENCE_PAGE_LINK_SUCCESS
};

});

parcelRegister("gJYxu", function(module, exports) {

$parcel$export(module.exports, "IssueBoundary", () => $47dde6f657625382$export$fbf48ede0cf52b5a);
$parcel$export(module.exports, "IssueModalBoundary", () => $47dde6f657625382$export$74d408982642a541);
// eslint-disable-next-line jira/restricted/react-component-props

var $eUqFw = parcelRequire("eUqFw");

var $ciZ8Y = parcelRequire("ciZ8Y");

var $cyVXS = parcelRequire("cyVXS");

var $gGtKh = parcelRequire("gGtKh");

var $c4qEZ = parcelRequire("c4qEZ");
const $47dde6f657625382$export$fbf48ede0cf52b5a = ({ children: children, isEmbedView: isEmbedView = true, ...props })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $ciZ8Y.ErrorBoundary), {
        id: "issue",
        ...props
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gGtKh.default), {
        name: "issue-boundary",
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $c4qEZ.IssueViewSkeleton), {
            isEmbedView: isEmbedView
        })
    }, children));
const $47dde6f657625382$export$74d408982642a541 = ({ children: children, ...props })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $cyVXS.ModalBoundary), {
        id: "issue-modal",
        ...props
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gGtKh.default), {
        name: "issue-modal-boundary",
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $c4qEZ.IssueViewSkeleton), {
            isModalView: true
        })
    }, children));

});
parcelRegister("cyVXS", function(module, exports) {

$parcel$export(module.exports, "ModalBoundary", () => $f96d169c5da11246$export$c3f500e812fb1bb3);

var $eUqFw = parcelRequire("eUqFw");

var $h97Af = parcelRequire("h97Af");

var $fee69 = parcelRequire("fee69");

var $5GxEP = parcelRequire("5GxEP");

var $gGtKh = parcelRequire("gGtKh");
const $f96d169c5da11246$export$c3f500e812fb1bb3 = ({ children: children, id: id, metricKey: metricKey, packageName: packageName, onError: onError })=>{
    const ErrorState = (0, $eUqFw.useCallback)((args)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $fee69.ErrorFlagRenderer), {
            id: id,
            error: args.error
        }), [
        id
    ]);
    const fallback = typeof metricKey === 'string' && metricKey.length > 0 ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $h97Af.default), {
        metricKey: metricKey
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5GxEP.default), {
        id: id,
        packageName: packageName,
        render: ErrorState,
        onError: onError
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gGtKh.default), {
        name: id,
        fallback: fallback
    }, children));
};

});


parcelRegister("9mxRp", function(module, exports) {

$parcel$export(module.exports, "HEADER_BREADCRUMBS_BEGIN_MARK_KEY", () => $3849cfed910e9285$export$eb0ef5297b0cdc23);
$parcel$export(module.exports, "HEADER_BREADCRUMBS_END_MARK_KEY", () => $3849cfed910e9285$export$9c0a7052eb43d49c);
$parcel$export(module.exports, "HEADER_ACTIONS_BEGIN_MARK_KEY", () => $3849cfed910e9285$export$ff64d9f93169b1f0);
$parcel$export(module.exports, "HEADER_ACTIONS_END_MARK_KEY", () => $3849cfed910e9285$export$e696e07345d019c7);
$parcel$export(module.exports, "ISSUE_NAME_BEGIN_MARK_KEY", () => $3849cfed910e9285$export$39f2c7a88d6952c7);
$parcel$export(module.exports, "ISSUE_NAME_END_MARK_KEY", () => $3849cfed910e9285$export$6b38db117e6a59c3);
$parcel$export(module.exports, "QUICK_ADD_ITEMS_BEGIN_MARK_KEY", () => $3849cfed910e9285$export$e4ec603cd2ae64c3);
$parcel$export(module.exports, "QUICK_ADD_ITEMS_END_MARK_KEY", () => $3849cfed910e9285$export$485e8138df2fade3);
$parcel$export(module.exports, "CONTENT_ITEMS_BEGIN_MARK_KEY", () => $3849cfed910e9285$export$37c39403f63dfe50);
$parcel$export(module.exports, "CONTENT_ITEMS_END_MARK_KEY", () => $3849cfed910e9285$export$bcac34901554ce05);
$parcel$export(module.exports, "ACTIVITY_FEED_BEGIN_MARK_KEY", () => $3849cfed910e9285$export$cfd354167a2170f3);
$parcel$export(module.exports, "ACTIVITY_FEED_END_MARK_KEY", () => $3849cfed910e9285$export$e20857c483438d46);
$parcel$export(module.exports, "FOOTNOTE_BEGIN_MARK_KEY", () => $3849cfed910e9285$export$2f7e8d259a68175d);
$parcel$export(module.exports, "FOOTNOTE_END_MARK_KEY", () => $3849cfed910e9285$export$8c4857e697bb9a6b);
$parcel$export(module.exports, "ISSUE_STATUS_BEGIN_MARK_KEY", () => $3849cfed910e9285$export$6669013ba0004c0);
$parcel$export(module.exports, "ISSUE_STATUS_END_MARK_KEY", () => $3849cfed910e9285$export$ff2ebe781d7bd44e);
$parcel$export(module.exports, "defaultRatioRightColumn", () => $3849cfed910e9285$export$7fec582ac43ca9da);
$parcel$export(module.exports, "getIssueContainerMaxWidth", () => $3849cfed910e9285$export$c76181843186885);
const $3849cfed910e9285$export$eb0ef5297b0cdc23 = 'HEADER_BREADCRUMBS_BEGIN_MARK';
const $3849cfed910e9285$export$9c0a7052eb43d49c = 'HEADER_BREADCRUMBS_END_MARK';
const $3849cfed910e9285$export$ff64d9f93169b1f0 = 'HEADER_ACTIONS_BEGIN_MARK';
const $3849cfed910e9285$export$e696e07345d019c7 = 'HEADER_ACTIONS_END_MARK';
const $3849cfed910e9285$export$39f2c7a88d6952c7 = 'ISSUE_NAME_BEGIN_MARK';
const $3849cfed910e9285$export$6b38db117e6a59c3 = 'ISSUE_NAME_END_MARK';
const $3849cfed910e9285$export$e4ec603cd2ae64c3 = 'QUICK_ADD_ITEMS_BEGIN_MARK';
const $3849cfed910e9285$export$485e8138df2fade3 = 'QUICK_ADD_ITEMS_END_MARK';
const $3849cfed910e9285$export$37c39403f63dfe50 = 'CONTENT_ITEMS_BEGIN_MARK';
const $3849cfed910e9285$export$bcac34901554ce05 = 'CONTENT_ITEMS_END_MARK';
const $3849cfed910e9285$export$cfd354167a2170f3 = 'ACTIVITY_FEED_BEGIN_MARK';
const $3849cfed910e9285$export$e20857c483438d46 = 'ACTIVITY_FEED_END_MARK';
const $3849cfed910e9285$export$2f7e8d259a68175d = 'FOOTNOTE_BEGIN_MARK';
const $3849cfed910e9285$export$8c4857e697bb9a6b = 'FOOTNOTE_END_MARK';
const $3849cfed910e9285$export$6669013ba0004c0 = 'ISSUE_STATUS_BEGIN_MARK';
const $3849cfed910e9285$export$ff2ebe781d7bd44e = 'ISSUE_STATUS_END_MARK';
const $3849cfed910e9285$export$7fec582ac43ca9da = 0.35;
const $3849cfed910e9285$export$c76181843186885 = ()=>1680;

});

parcelRegister("48mPv", function(module, exports) {

$parcel$export(module.exports, "default", () => $ce578c493ad96d9e$export$2e2bcd8739ae039);
class $ce578c493ad96d9e$export$2e2bcd8739ae039 {
    constructor(issueId, mutationType, version = '1', matchStatus = [], // eslint-disable-next-line @typescript-eslint/no-unused-vars
    lastModified){
        this.issueId = issueId;
        this.mutationType = mutationType;
        this.version = version;
        this.matchStatus = matchStatus;
        // create a new timeStamp whenever an object is initialized
        this.lastModified = new Date().toISOString();
    }
}

});

parcelRegister("d7Wfe", function(module, exports) {

$parcel$export(module.exports, "MutationSource", () => $598bd411eca1df87$export$17f28c4c94a74282);
$parcel$export(module.exports, "CacheType", () => $598bd411eca1df87$export$ba193b555633db78);
const $598bd411eca1df87$export$17f28c4c94a74282 = {
    CREATE: 0,
    UPDATE: 1,
    DELETE: 2
};
const $598bd411eca1df87$export$ba193b555633db78 = {
    LOCAL: 'local',
    SESSION: 'session'
};

});

parcelRegister("bsdZ2", function(module, exports) {

$parcel$export(module.exports, "useEcClient", () => $b40c4387cd757cd5$export$9da409beb25e67da);

var $eUqFw = parcelRequire("eUqFw");

var $gUUjF = parcelRequire("gUUjF");

var $gd0Sp = parcelRequire("gd0Sp");

var $65uQX = parcelRequire("65uQX");
const $b40c4387cd757cd5$export$9da409beb25e67da = ()=>{
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    let tenantContext;
    try {
        // eslint-disable-next-line react-hooks/rules-of-hooks
        tenantContext = (0, $gd0Sp.useTenantContext)();
    } catch (e) {
        (0, $gUUjF.default).safeErrorWithoutCustomerData('jsis-ec-client', `tenant context : ${e?.toString() || ''}`);
    }
    (0, $eUqFw.useEffect)(()=>{
        (0, $65uQX.EcClient).setTenantDetails(tenantContext?.activationId, tenantContext?.cloudId, tenantContext?.atlassianAccountId);
    }, [
        tenantContext
    ]);
    const saveIssueMutationToCache = (0, $eUqFw.useCallback)((issueMutation, key = {
        analyticsMetadata: {
            scenario: 'unknown'
        }
    }, analyticsFailureEventObj = {})=>(0, $65uQX.default).saveIssueMutationToCache(issueMutation, key, analyticsFailureEventObj), []);
    const saveIssueMutationsToCache = (0, $eUqFw.useCallback)((issueMutations, key = {
        analyticsMetadata: {
            scenario: 'unknown'
        }
    }, analyticsFailureEventObj = {})=>(0, $65uQX.default).saveIssueMutationsToCache(issueMutations, key, analyticsFailureEventObj), []);
    const searchAndReconcile = (0, $eUqFw.useCallback)((matchApiUrl, jqlMatchingKey, search, // eslint-disable-next-line @typescript-eslint/no-explicit-any
    parseIssueData, capability)=>(0, $65uQX.default).searchAndReconcile(matchApiUrl, jqlMatchingKey, search, parseIssueData, capability), []);
    const getIssueMutationFromCache = (key)=>(0, $65uQX.default).getIssueMutationFromCache(key);
    return {
        saveIssueMutationToCache: saveIssueMutationToCache,
        saveIssueMutationsToCache: saveIssueMutationsToCache,
        searchAndReconcile: searchAndReconcile,
        getIssueMutationFromCache: getIssueMutationFromCache
    };
};

});
parcelRegister("65uQX", function(module, exports) {

$parcel$export(module.exports, "EcClient", () => $9d182d4720e39d79$export$a736992aaac2307a);
$parcel$export(module.exports, "getEcClient", () => $9d182d4720e39d79$export$c9342bd32f51406b);
$parcel$export(module.exports, "default", () => $9d182d4720e39d79$export$2e2bcd8739ae039);

var $gUUjF = parcelRequire("gUUjF");

var $1ybV0 = parcelRequire("1ybV0");

var $2OdyW = parcelRequire("2OdyW");

var $jMP2a = parcelRequire("jMP2a");

var $3FyZ4 = parcelRequire("3FyZ4");

var $fqqil = parcelRequire("fqqil");

var $7S3WE = parcelRequire("7S3WE");

var $d7Wfe = parcelRequire("d7Wfe");

var $4qvSX = parcelRequire("4qvSX");
class $9d182d4720e39d79$export$a736992aaac2307a {
    #issueCache;
    #config;
    constructor(){
        this.#issueCache = new (0, $7S3WE.default)('issue-cache-v1');
        this.#config = {};
    }
    /**
	 * A method to set tenant level details.
	 * These details include activation id, cloud id and user id
	 */ static setTenantDetails(activationID, cloudID, atlassianAccountId) {
        (0, $7S3WE.default).setTenantDetails(activationID, cloudID, atlassianAccountId);
    }
    /**
	 * A method to fire analytics events for both success and failure
	 */ static fireAnalyticsEvents(issueMutations, key = {
        analyticsMetadata: {
            scenario: 'unknown'
        }
    }, isSaved, analyticsFailureEventObj = {}) {
        try {
            // let mutationAnalyticsObj: any = [];
            let trackingId = '-1';
            if (Array.isArray(issueMutations)) //   mutationAnalyticsObj = issueMutations.map((item: IssueMutation) => item.issueId);
            trackingId = String(new Date(issueMutations[0]?.lastModified).valueOf()) + (0, $7S3WE.default).userID;
            else trackingId = String(new Date(issueMutations.lastModified).valueOf()) + (0, $7S3WE.default).userID;
            const payload = {
                action: 'mutated',
                actionSubject: 'issue',
                source: key?.analyticsMetadata?.scenario || 'unknown',
                attributes: {
                    ...key.analyticsMetadata,
                    trackingId: // issueMutationDetails: mutationAnalyticsObj,
                    trackingId
                }
            };
            // Error condition
            if (!isSaved) {
                if (!analyticsFailureEventObj) // eslint-disable-next-line no-param-reassign
                analyticsFailureEventObj = {
                    error: true,
                    errorMsg: payload.source
                };
                payload.attributes = {
                    ...payload.attributes,
                    ...analyticsFailureEventObj
                };
            }
            if (Object.prototype.hasOwnProperty.call(key, 'analyticsEventObj')) (0, $jMP2a.fireTrackAnalytics)(// @ts-expect-error - Argument of type 'Object' is not assignable to parameter of type 'UIAnalyticsEvent'.
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            key.analyticsEventObj, `${payload.actionSubject} ${payload.action}`, payload.attributes);
            else // if there is no UI component that triggers the event then we manually fire the event
            (0, $3FyZ4.getAnalyticsWebClientPromise)().then((client)=>{
                client.getInstance().sendTrackEvent(payload);
            });
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (e) {
            (0, $gUUjF.default).safeErrorWithoutCustomerData('jsis-ec-client', e);
        }
    }
    /**
	 * A method to save a single issue mutations in cache
	 */ async saveIssueMutationToCache(issueMutation, key = {
        analyticsMetadata: {
            scenario: 'unknown'
        }
    }, analyticsFailureEventObj = {}) {
        if ((0, $1ybV0.ff)('odin.enable.backend.cache.ec.client')) {
            const isSaved = (0, $7S3WE.default).setBackendCache(issueMutation);
            $9d182d4720e39d79$export$a736992aaac2307a.fireAnalyticsEvents(issueMutation, key, isSaved, analyticsFailureEventObj);
            return isSaved;
        }
        return this.#issueCache.isPresent(issueMutation.issueId).then(async (result)=>{
            let isSaved = false;
            if (issueMutation.mutationType === (0, $d7Wfe.MutationSource).DELETE) isSaved = await this.#issueCache.delete(issueMutation.issueId);
            else if (result || issueMutation.mutationType === (0, $d7Wfe.MutationSource).UPDATE) isSaved = await this.#issueCache.update(issueMutation.issueId);
            else isSaved = await this.#issueCache.create(issueMutation.issueId);
            $9d182d4720e39d79$export$a736992aaac2307a.fireAnalyticsEvents(issueMutation, key, isSaved, analyticsFailureEventObj);
            return new Promise((resolve)=>resolve(isSaved));
        });
    }
    /**
	 * A method to save multiple issue mutations in cache
	 */ async saveIssueMutationsToCache(issueMutations, key = {
        analyticsMetadata: {
            scenario: 'unknown'
        }
    }, analyticsFailureEventObj = {}) {
        const data = [];
        if ((0, $1ybV0.ff)('odin.enable.backend.cache.ec.client')) {
            const isSaved = (0, $7S3WE.default).setBackendCache(issueMutations);
            $9d182d4720e39d79$export$a736992aaac2307a.fireAnalyticsEvents(issueMutations, key, isSaved, analyticsFailureEventObj);
            return [
                isSaved
            ];
        }
        issueMutations.forEach(async (issueMutation)=>{
            this.#issueCache.isPresent(issueMutation.issueId).then(async (result)=>{
                let isSaved = false;
                if (issueMutation.mutationType === (0, $d7Wfe.MutationSource).DELETE) isSaved = await this.#issueCache.delete(issueMutation.issueId);
                else if (result || issueMutation.mutationType === (0, $d7Wfe.MutationSource).UPDATE) isSaved = await this.#issueCache.update(issueMutation.issueId);
                else isSaved = await this.#issueCache.create(issueMutation.issueId);
                data.push(isSaved);
                $9d182d4720e39d79$export$a736992aaac2307a.fireAnalyticsEvents(issueMutations, key, isSaved, analyticsFailureEventObj);
            });
        });
        return new Promise((resolve)=>resolve(data));
    }
    /**
	 * A method to get issue mutations in saved in cache
	 */ getIssueMutationFromCache(key) {
        return this.#issueCache.get(key);
    }
    /**
	 * A method to remove the deleted issues from the search API
	 */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
    async filterData(data) {
        const localStorageData = await this.getIssueMutationFromCache(null);
        const deletedData = new Set();
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        Object.values(localStorageData).forEach((element)=>{
            if (element.mutationType === (0, $d7Wfe.MutationSource).DELETE) deletedData.add(element.issueId);
        });
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const filteredData = [];
        let success = true;
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        Object.values(data).forEach((element)=>{
            if (!element.id || typeof element.id !== 'number') success = false;
            else if (!deletedData.has(element.id.toString())) filteredData.push(element);
        });
        return new Promise((// eslint-disable-next-line @typescript-eslint/no-explicit-any
        resolve, // eslint-disable-next-line @typescript-eslint/no-explicit-any
        reject)=>{
            if (success) resolve(filteredData);
            else reject(new Error());
        });
    }
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    async constructMatchRequest() {
        const issueData = {
            issues: [],
            hydrationMode: 0
        };
        const data = await this.getIssueMutationFromCache(null);
        Object.values(data).forEach((issueMutation)=>{
            const element = {
                issueId: issueMutation.issueId,
                version: issueMutation.version
            };
            issueData.issues.push(element);
        });
        const options = {
            method: 'POST',
            headers: {
                content_type: 'application/json',
                // @ts-expect-error - TS2339 - Property 'capability' does not exist on type 'object'.
                'x-atlassian-capability': (0, $fqqil.getEnhancedCapabilityHeader)(this.#config.capability)
            },
            body: JSON.stringify(issueData)
        };
        return new Promise((resolve)=>resolve(options));
    }
    /**
	 * A method to get the relevant search data from the parsing function that the user has provided
	 */ static getIssueDataFromSearch(data, // eslint-disable-next-line @typescript-eslint/no-explicit-any
    parseIssueData) {
        const result = parseIssueData(data);
        if (result == null) return [];
        return result;
    }
    /**
	 * A method to get the search data and reconcile it with the data present in cache
	 */ async searchAndReconcile(matchApiUrl, jqlMatchingKey, search, // eslint-disable-next-line @typescript-eslint/no-explicit-any
    parseIssueData, capability) {
        // @ts-expect-error - TS2339 - Property 'capability' does not exist on type 'object'.
        this.#config.capability = capability;
        const matchRequest = await this.constructMatchRequest();
        if (matchRequest && matchRequest.body && matchRequest.body.issues && matchRequest.body.issues.length === 0) return search.then((data)=>new Promise((resolve)=>resolve({
                    reconciledIssues: $9d182d4720e39d79$export$a736992aaac2307a.getIssueDataFromSearch(data, parseIssueData),
                    matchAPIResponse: {
                        response: {
                            resultsByIssueId: {}
                        },
                        issue: {
                            issuesResponse: {}
                        }
                    }
                })));
        const matchPromise = (0, $2OdyW.default)(matchApiUrl, matchRequest);
        return Promise.all([
            search,
            matchPromise
        ]).then(([data, response])=>{
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            const structuredData = $9d182d4720e39d79$export$a736992aaac2307a.getIssueDataFromSearch(data, parseIssueData);
            return this.filterData(structuredData) // eslint-disable-next-line @typescript-eslint/no-explicit-any
            .then((filteredSearchData)=>{
                if (response == null || response.response == null || response.response.resultsByIssueId == null) throw new Error('Match response is invalid!');
                const matchedIssueIds = response.response.resultsByIssueId;
                // eslint-disable-next-line @typescript-eslint/no-explicit-any
                const filteredMatchedIssueIdsData = [];
                Object.entries(matchedIssueIds).forEach(([key, value])=>{
                    if (value === 'RESULT_MATCH') filteredMatchedIssueIdsData.push({
                        id: parseInt(key, 10)
                    });
                });
                return new Promise((resolve)=>{
                    resolve({
                        reconciledIssues: (0, $4qvSX.mergeResponseData)(filteredSearchData, filteredMatchedIssueIdsData),
                        matchAPIResponse: response
                    });
                });
            }).catch(()=>new Promise((resolve)=>resolve({
                        reconciledIssues: structuredData,
                        matchAPIResponse: response
                    })));
        });
    }
}
const $9d182d4720e39d79$var$ecClient = new $9d182d4720e39d79$export$a736992aaac2307a();
function $9d182d4720e39d79$export$c9342bd32f51406b(tenantContext = {}) {
    $9d182d4720e39d79$export$a736992aaac2307a.setTenantDetails(tenantContext?.activationId, tenantContext?.cloudId, tenantContext?.atlassianAccountId);
    return $9d182d4720e39d79$var$ecClient;
}
var $9d182d4720e39d79$export$2e2bcd8739ae039 = $9d182d4720e39d79$var$ecClient;

});
parcelRegister("7S3WE", function(module, exports) {

$parcel$export(module.exports, "default", () => $ed861ad8bfcfb81a$export$2e2bcd8739ae039);
// Issue Cache API is an internal tool and this file should not be edited. Please contact Odin team for any modifications.

var $kBiqn = parcelRequire("kBiqn");

var $gUUjF = parcelRequire("gUUjF");

var $1ybV0 = parcelRequire("1ybV0");

var $2OdyW = parcelRequire("2OdyW");

var $48mPv = parcelRequire("48mPv");

var $d7Wfe = parcelRequire("d7Wfe");

var $4qvSX = parcelRequire("4qvSX");
const $ed861ad8bfcfb81a$var$MAX_AGE_MIN = 5;
const $ed861ad8bfcfb81a$var$MAX_AGE = $ed861ad8bfcfb81a$var$MAX_AGE_MIN * 60000;
const $ed861ad8bfcfb81a$var$CACHE_SIZE = 100;
const $ed861ad8bfcfb81a$var$CACHE_KEY_PREFIX = '__storejs';
const $ed861ad8bfcfb81a$var$BE_CACHE_SAVE_ISSUE_MUTATION = '/gateway/api/jira-jql-service/api/v1/issue-mutation';
class $ed861ad8bfcfb81a$export$2e2bcd8739ae039 {
    #localCache;
    #sessionCache;
    constructor(namespace, maxAge = $ed861ad8bfcfb81a$var$MAX_AGE){
        this.maxAge = maxAge;
        this.namespace = namespace;
        // @ts-expect-error - TS7009 - 'new' expression, whose target lacks a construct signature, implicitly has an 'any' type.
        this.#localCache = new (0, $kBiqn.Cache)({
            size: $ed861ad8bfcfb81a$var$CACHE_SIZE,
            storageType: (0, $d7Wfe.CacheType).LOCAL,
            cacheKey: namespace
        });
        // @ts-expect-error - TS7009 - 'new' expression, whose target lacks a construct signature, implicitly has an 'any' type.
        this.#sessionCache = new (0, $kBiqn.Cache)({
            size: $ed861ad8bfcfb81a$var$CACHE_SIZE,
            storageType: (0, $d7Wfe.CacheType).SESSION,
            cacheKey: namespace
        });
    }
    /**
	 * A method to set tenant level details.
	 * These details include activation id, cloud id and user id
	 */ static setTenantDetails(activationID, cloudID, userID) {
        if (activationID && activationID !== $ed861ad8bfcfb81a$export$2e2bcd8739ae039.activationID) $ed861ad8bfcfb81a$export$2e2bcd8739ae039.activationID = activationID;
        if (cloudID && cloudID !== $ed861ad8bfcfb81a$export$2e2bcd8739ae039.cloudID) $ed861ad8bfcfb81a$export$2e2bcd8739ae039.cloudID = cloudID;
        if (userID && userID !== $ed861ad8bfcfb81a$export$2e2bcd8739ae039.userID) $ed861ad8bfcfb81a$export$2e2bcd8739ae039.userID = userID;
    }
    /**
	 * A util method to decide whether an issue mutation in cache is stale or not
	 */ static isIssueMutationStale(issueMutation) {
        const lastModified = new Date(issueMutation.lastModified).getTime();
        return Date.now() - lastModified < $ed861ad8bfcfb81a$var$MAX_AGE;
    }
    /**
	 * A util method to generate partial key containing username for storing in cache
	 */ static generateKey() {
        let anonymousId = window.localStorage.getItem('ajs_anonymous_id');
        anonymousId = anonymousId ? `.${anonymousId}` : '';
        anonymousId = anonymousId.replace(/["]+/g, '');
        // TODO : Replace this with something more generic
        return `jsis.ecCache.data${anonymousId}.newIssuesMutationList`;
    }
    /**
	 * A method to generate key containing username as well as namespace for storing in cache
	 */ generateReadKey() {
        return `${$ed861ad8bfcfb81a$var$CACHE_KEY_PREFIX}_${this.namespace}_${$ed861ad8bfcfb81a$export$2e2bcd8739ae039.generateKey()}`;
    }
    /**
	 * A method to get the issue mutations stored in the cache
	 * Accepts issueIds or array of issuesIds and returns corresponding issue mutations
	 * Returns all the issue mutations when provided with null argument in form of an array
	 * Cleans the cache before accessing issue mutations in order to avoid stale data
	 */ async get(key) {
        return this.cleanCache().then(()=>this.getWithoutClean(key));
    }
    /**
	 * A method to get the issue mutations stored in the cache
	 * Accepts issueIds or array of issuesIds to return selective issue mutations
	 * Returns all the issue mutations when provided with null argument
	 */ async getWithoutClean(key) {
        if (key == null) return new Promise((resolve)=>{
            this.#localCache.get(this.generateReadKey()).then((data)=>data ? resolve(data) : resolve({}));
        });
        return new Promise(// eslint-disable-next-line @typescript-eslint/no-explicit-any
        (resolve)=>{
            this.#localCache.get(this.generateReadKey()).then((data)=>{
                if (!data) resolve({});
                else {
                    const iterableData = data;
                    // eslint-disable-next-line @typescript-eslint/no-explicit-any
                    const newData = {};
                    if (typeof key === 'string') newData[key] = iterableData[key];
                    else if (Array.isArray(key)) key.forEach((issueId)=>{
                        newData[issueId] = iterableData[issueId];
                    });
                    resolve(newData);
                }
            });
        });
    }
    /**
	 * A method to construct object to be stored in backend cache
	 * Can receive an issue mutation or an array of issue mutations to be saved in cache
	 */ static constructBackendCacheObject(value) {
        if (value instanceof (0, $48mPv.default)) return {
            issueId: value.issueId,
            mutationType: value.mutationType,
            mutationTimestamp: value.lastModified
        };
        const result = [];
        value.forEach((data)=>{
            result.push($ed861ad8bfcfb81a$export$2e2bcd8739ae039.constructBackendCacheObject(data));
        });
        return result;
    }
    /**
	 * A method to save the issue mutations in the backend cache
	 * Can receive an issue mutation or an array of issue mutations to be saved in cache
	 */ static setBackendCache(data) {
        try {
            let issueBody = $ed861ad8bfcfb81a$export$2e2bcd8739ae039.constructBackendCacheObject(data);
            let trackingId = '-1';
            if (data instanceof (0, $48mPv.default)) {
                trackingId = String(new Date(data.lastModified).valueOf()) + ($ed861ad8bfcfb81a$export$2e2bcd8739ae039.userID || '');
                issueBody = [
                    issueBody
                ];
            } else trackingId = String(new Date(data[0].lastModified).valueOf()) + ($ed861ad8bfcfb81a$export$2e2bcd8739ae039.userID || '');
            (0, $2OdyW.default)($ed861ad8bfcfb81a$var$BE_CACHE_SAVE_ISSUE_MUTATION, {
                method: 'PUT',
                headers: {
                    'Content-Type': 'application/json',
                    'ATL-activationId': $ed861ad8bfcfb81a$export$2e2bcd8739ae039.activationID || '',
                    'atl-CloudId': $ed861ad8bfcfb81a$export$2e2bcd8739ae039.cloudID || '',
                    trackingId: trackingId
                },
                body: JSON.stringify({
                    issueMutations: issueBody
                })
            });
            return true;
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (e) {
            (0, $gUUjF.default).safeErrorWithoutCustomerData('jsis-ec-client', `${e?.toString() || ''}mutationObj: ${data}`);
            return false;
        }
    }
    /**
	 * A method to save the issue mutations in the cache
	 * Can receive an issue mutation or an array of issue mutations to be saved in cache
	 */ async set(value) {
        return this.getWithoutClean().then(async (cacheData)=>{
            if (value instanceof (0, $48mPv.default)) {
                const storeValue = {
                    [value.issueId]: value
                };
                return new Promise((resolve)=>{
                    try {
                        this.#localCache.set(this.generateReadKey(), (0, $4qvSX.mergeData)(cacheData, storeValue));
                        resolve(true);
                    // eslint-disable-next-line @typescript-eslint/no-explicit-any
                    } catch (e) {
                        resolve(false);
                    }
                });
            }
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            const storeData = {};
            value.forEach((data)=>{
                storeData[data.issueId] = data;
            });
            return new Promise((resolve)=>{
                try {
                    this.#localCache.set(this.generateReadKey(), (0, $4qvSX.mergeData)(cacheData, storeData));
                    resolve(true);
                // eslint-disable-next-line @typescript-eslint/no-explicit-any
                } catch (e) {
                    resolve(false);
                }
            });
        });
    }
    /**
	 * A method to create a new issue mutation in cache
	 * Can receive an issue ids or an array of issue ids to be created in cache
	 */ async create(value) {
        return this.cleanCache().then(()=>{
            if (!Array.isArray(value)) return this.set(new (0, $48mPv.default)(value, (0, $d7Wfe.MutationSource).CREATE, '1', [], new Date().toISOString()));
            const storeData = value.map((data)=>new (0, $48mPv.default)(data, (0, $d7Wfe.MutationSource).CREATE, '1', [], new Date().toISOString()));
            return this.set(storeData);
        });
    }
    /**
	 * A method to update an already existing issue mutation in cache
	 * Can receive an issue ids or an array of issue ids to be updated in cache
	 */ async update(value) {
        if ((0, $1ybV0.ff)('odin.enable.backend.cache.ec.client')) {
            if (typeof value === 'string') return this.set(new (0, $48mPv.default)(value, (0, $d7Wfe.MutationSource).UPDATE, '1', []));
            return this.set(value.map((issueId)=>new (0, $48mPv.default)(issueId, (0, $d7Wfe.MutationSource).UPDATE, '1', [])));
        }
        return this.getWithoutClean(value).then((data)=>{
            const valueToUpdate = [];
            Object.entries(data).forEach(([issueId, issueMutationObj])=>{
                if (issueMutationObj instanceof (0, $48mPv.default)) {
                    if ($ed861ad8bfcfb81a$export$2e2bcd8739ae039.isIssueMutationStale(issueMutationObj)) valueToUpdate.push(new (0, $48mPv.default)(String(issueId), (0, $d7Wfe.MutationSource).UPDATE, issueMutationObj.version, issueMutationObj.matchStatus, new Date().toISOString()));
                    else valueToUpdate.push(new (0, $48mPv.default)(String(issueId), (0, $d7Wfe.MutationSource).CREATE, '1', issueMutationObj.matchStatus, new Date().toISOString()));
                } else valueToUpdate.push(new (0, $48mPv.default)(String(issueId), (0, $d7Wfe.MutationSource).UPDATE, // TODO: Incorporate the version and match status and change the update method signature
                '1', [], new Date().toISOString()));
            });
            return this.set(valueToUpdate);
        });
    }
    /**
	 * A method to delete an issue mutation in cache
	 */ async delete(key) {
        if (typeof key === 'string') return this.set(new (0, $48mPv.default)(key, (0, $d7Wfe.MutationSource).DELETE, '', [], new Date().toISOString()));
        const storeData = key.map((data)=>new (0, $48mPv.default)(data, (0, $d7Wfe.MutationSource).DELETE, '', [], new Date().toISOString()));
        return this.set(storeData);
    }
    /**
	 * A method to clear the cache
	 */ async clear() {
        return this.#localCache.clear();
    }
    /**
	 * A method that selectively deletes the stale cache entries
	 */ async cleanCache() {
        // We don't clean the backend cache
        if ((0, $1ybV0.ff)('odin.enable.backend.cache.ec.client')) return Promise.resolve(true);
        return this.getWithoutClean(null).then((data)=>{
            const issuesToKeep = [];
            if (data && Object.keys(data).length !== 0 && Object.getPrototypeOf(data) === Object.prototype) Object.keys(data).forEach((issueId)=>{
                const issueMutationObj = data[issueId];
                if ($ed861ad8bfcfb81a$export$2e2bcd8739ae039.isIssueMutationStale(issueMutationObj)) issuesToKeep.push(issueMutationObj);
            });
            return this.clear().then(()=>this.set(issuesToKeep));
        });
    }
    /**
	 * A method to check if an issue id is present in the cache
	 */ isPresent(issueId) {
        return this.get(issueId).then((data)=>!!data && !!Object.values(data)[0]);
    }
    /**
	 * A method to check if any mutation is present in the cache
	 */ isEmpty() {
        return this.get(null).then((data)=>Object.keys(data).length === 0);
    }
    /**
	 * A method to find the size of the local storage for any given key
	 */ static getLocalStorageSizeForGivenKey(key) {
        const value = localStorage.getItem(key);
        if (value != null) {
            const keySize = value.length;
            return keySize;
        }
        return 0;
    }
    /**
	 * A method to find the size of the local storage for any given key
	 * It returns size of all the keys when provided with no key
	 */ static getLocalStorageSize(key) {
        if (key != null) return $ed861ad8bfcfb81a$export$2e2bcd8739ae039.getLocalStorageSizeForGivenKey(key);
        let totalSize = 0;
        Object.keys(localStorage).forEach((keys)=>{
            totalSize += $ed861ad8bfcfb81a$export$2e2bcd8739ae039.getLocalStorageSizeForGivenKey(keys);
        });
        return totalSize;
    }
}

});
parcelRegister("kBiqn", function(module, exports) {

$parcel$export(module.exports, "Cache", () => $32f02625ea3a7ccc$export$94affb487e701bf2);
$parcel$export(module.exports, "default", () => $32f02625ea3a7ccc$export$2e2bcd8739ae039);

var $aZaPn = parcelRequire("aZaPn");
var $89bO2 = parcelRequire("89bO2");

var $gUUjF = parcelRequire("gUUjF");


var $48k9t = parcelRequire("48k9t");
const $32f02625ea3a7ccc$var$calculateEntryAge = (timestamp)=>Date.now() - timestamp;
function $32f02625ea3a7ccc$export$94affb487e701bf2(props) {
    const cache = new Map();
    const { size: size } = props;
    let storage;
    let hasSyncedFromStorage = false;
    const devTools = window && window.__REDUX_DEVTOOLS_EXTENSION__ ? window.__REDUX_DEVTOOLS_EXTENSION__.connect({
        name: `Cache ${props.cacheKey}`,
        serialize: true
    }) : null;
    const syncWithDevTools = (type, payload)=>{
        if ((0, $48k9t.default).devTools) devTools && devTools.send({
            type: type,
            payload: payload
        }, cache, {}, props.cacheKey);
    };
    const removeExpiredKeysFromStorage = async (store)=>{
        const updatedStore = {
            ...store
        };
        if (props.storageType === (0, $834cc2f16be60bc5$export$bf340b99118a1511)) return {};
        const { cacheKey: cacheKey, maxAge: maxAge } = props;
        if (maxAge !== undefined) {
            Object.keys(store).forEach((key)=>{
                // @ts-expect-error - TS7053 - Element implicitly has an 'any' type because expression of type 'string' can't be used to index type 'Partial<Record<K, Entry<V>>>'.
                const keyAge = $32f02625ea3a7ccc$var$calculateEntryAge(store[key].timestamp);
                if (keyAge > maxAge) {
                    // @ts-expect-error - TS2345 - Argument of type '{ [x: string]: any; }' is not assignable to parameter of type 'K | Entry<V> | Partial<Record<K, Entry<V>>> | [K, Entry<V>][]'. | TS7053 - Element implicitly has an 'any' type because expression of type 'string' can't be used to index type 'Partial<Record<K, Entry<V>>>'.
                    syncWithDevTools((0, $834cc2f16be60bc5$export$26d12233004a7a60), {
                        [String(key)]: updatedStore[key]
                    });
                    // @ts-expect-error - TS7053 - Element implicitly has an 'any' type because expression of type 'string' can't be used to index type 'Partial<Record<K, Entry<V>>>'.
                    delete updatedStore[key];
                    // @ts-expect-error - TS2345 - Argument of type 'string' is not assignable to parameter of type 'K'.
                    cache.delete(key);
                }
            });
            storage.set(cacheKey, updatedStore);
        }
        return updatedStore;
    };
    const removeExpiredEntry = (key, val)=>{
        if (props.storageType !== (0, $834cc2f16be60bc5$export$bf340b99118a1511)) {
            const { maxAge: maxAge } = props;
            if (maxAge !== undefined && $32f02625ea3a7ccc$var$calculateEntryAge(val.timestamp) > maxAge) {
                // @ts-expect-error - TS2345 - Argument of type '{ [x: string]: Entry<V>; }' is not assignable to parameter of type 'K | Entry<V> | Partial<Record<K, Entry<V>>> | [K, Entry<V>][]'.
                syncWithDevTools((0, $834cc2f16be60bc5$export$26d12233004a7a60), {
                    [String(key)]: val
                });
                cache.delete(key);
                return true;
            }
        }
        return false;
    };
    const createStore = ()=>{
        if (props.storageType === (0, $834cc2f16be60bc5$export$2670cb7d5d4f7184)) storage = (0, $aZaPn.createLocalStorageProvider)((0, $48k9t.CACHE_PREFIX));
        else storage = (0, $89bO2.createSessionStorageProvider)((0, $48k9t.CACHE_PREFIX));
        return storage;
    };
    const set = async (key, value)=>{
        await load();
        // @ts-expect-error - TS2345 - Argument of type 'string | K' is not assignable to parameter of type 'K'.
        cache.delete(key);
        const entry = {
            value: value,
            timestamp: Date.now()
        };
        let storedContent = {};
        if (props.storageType !== (0, $834cc2f16be60bc5$export$bf340b99118a1511)) {
            storedContent = storage.get(props.cacheKey) || {};
            // @ts-expect-error - TS2536 - Type 'string | K' cannot be used to index type 'Partial<Record<K, Entry<V>>>'.
            storedContent[key] = entry;
        }
        // @ts-expect-error - TS2345 - Argument of type 'string | K' is not assignable to parameter of type 'K'.
        cache.set(key, entry);
        // @ts-expect-error - TS2345 - Argument of type '{ [x: string]: Entry<V>; }' is not assignable to parameter of type 'K | Entry<V> | Partial<Record<K, Entry<V>>> | [K, Entry<V>][]'.
        syncWithDevTools((0, $834cc2f16be60bc5$export$5e8f180ef0142226), {
            [String(key)]: entry
        });
        if (cache.size > size) {
            const keys = cache.keys();
            const firstEntry = keys.next().value;
            if (firstEntry !== undefined) {
                cache.delete(firstEntry);
                syncWithDevTools((0, $834cc2f16be60bc5$export$a61768fefd33fcb1), firstEntry);
                if (props.storageType !== (0, $834cc2f16be60bc5$export$bf340b99118a1511)) // @ts-expect-error - TS7053 - Element implicitly has an 'any' type because expression of type 'any' can't be used to index type 'Partial<Record<K, Entry<V>>>'.
                delete storedContent[firstEntry];
            }
        }
        props.storageType !== (0, $834cc2f16be60bc5$export$bf340b99118a1511) && storage.set(props.cacheKey, storedContent);
    };
    const load = async ()=>{
        if (false || hasSyncedFromStorage) return;
        hasSyncedFromStorage = true;
        if (props.storageType === (0, $834cc2f16be60bc5$export$bf340b99118a1511)) return;
        const { cacheKey: cacheKey } = props;
        storage = createStore();
        try {
            let data = storage.get(cacheKey) || {};
            data = await removeExpiredKeysFromStorage(data);
            syncWithDevTools((0, $834cc2f16be60bc5$export$61f74127e2b53cbe), data);
            const orderedKeys = Object.keys(data).sort(// @ts-expect-error - TS7053 - Element implicitly has an 'any' type because expression of type 'string' can't be used to index type 'Partial<Record<K, Entry<V>>>'. | TS7053 - Element implicitly has an 'any' type because expression of type 'string' can't be used to index type 'Partial<Record<K, Entry<V>>>'.
            (key1, key2)=>data[key1].timestamp - data[key2].timestamp);
            await Promise.all(orderedKeys.map(async (key)=>{
                // @ts-expect-error - TS7053 - Element implicitly has an 'any' type because expression of type 'string' can't be used to index type 'Partial<Record<K, Entry<V>>>'.
                await set(key, data[key].value);
            }));
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (err) {
            (0, $gUUjF.default).safeWarnWithoutCustomerData((0, $834cc2f16be60bc5$export$7271276960377470), `There was an error syncing with storage - ${cacheKey}`, err);
            throw err;
        }
    };
    const clear = async ()=>{
        await load();
        cache.clear();
        if (props.storageType !== (0, $834cc2f16be60bc5$export$bf340b99118a1511)) {
            const { cacheKey: cacheKey } = props;
            storage.remove(cacheKey);
        }
        syncWithDevTools((0, $834cc2f16be60bc5$export$6c4d37c7f376a1de), {});
    };
    const get = async (key)=>{
        await load();
        let val = cache.get(key);
        if (val) {
            if (removeExpiredEntry(key, val)) val = undefined;
        }
        // @ts-expect-error - TS2345 - Argument of type '{ [x: string]: Entry<V> | undefined; }' is not assignable to parameter of type 'K | Entry<V> | Partial<Record<K, Entry<V>>> | [K, Entry<V>][]'.
        syncWithDevTools((0, $834cc2f16be60bc5$export$1bb358554aac31c1), {
            [String(key)]: val
        });
        return val && val.value;
    };
    const update = async (key, value)=>{
        await load();
        const previousValue = cache.get(key);
        if (!previousValue) return;
        const entry = {
            value: value,
            timestamp: previousValue.timestamp
        };
        let storedContent = {};
        if (props.storageType !== (0, $834cc2f16be60bc5$export$bf340b99118a1511)) {
            storedContent = storage.get(props.cacheKey) || {};
            storedContent[key] = entry;
        }
        cache.set(key, entry);
        // @ts-expect-error - TS2345 - Argument of type '{ [x: string]: Entry<V>; }' is not assignable to parameter of type 'K | Entry<V> | Partial<Record<K, Entry<V>>> | [K, Entry<V>][]'.
        syncWithDevTools((0, $834cc2f16be60bc5$export$e271b26eefe41db8), {
            [String(key)]: entry
        });
        props.storageType !== (0, $834cc2f16be60bc5$export$bf340b99118a1511) && storage.set(props.cacheKey, storedContent);
    };
    const getEntries = async ()=>{
        await load();
        const entries = Array.from(cache.entries()).filter(// eslint-disable-next-line @typescript-eslint/no-explicit-any
        ([key, value])=>!removeExpiredEntry(key, value));
        syncWithDevTools((0, $834cc2f16be60bc5$export$9eb68924983e00fb), entries);
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        return entries.map(([key, { value: value }])=>[
                key,
                value
            ]);
    };
    const deleteEntry = async (key)=>{
        await load();
        if (props.storageType !== (0, $834cc2f16be60bc5$export$bf340b99118a1511)) {
            const storedContent = storage.get(props.cacheKey) || {};
            delete storedContent[key];
            storage.set(props.cacheKey, storedContent);
        }
        cache.delete(key);
        // @ts-expect-error - TS2345 - Argument of type '{ [x: string]: Entry<V> | undefined; }' is not assignable to parameter of type 'K | Entry<V> | Partial<Record<K, Entry<V>>> | [K, Entry<V>][]'.
        syncWithDevTools((0, $834cc2f16be60bc5$export$4bd2facc4a3e6aa1), {
            [String(key)]: cache.get(key)
        });
    };
    const refresh = async ()=>{
        if (props.storageType === (0, $834cc2f16be60bc5$export$bf340b99118a1511)) return;
        cache.clear();
        hasSyncedFromStorage = false;
        await load();
    };
    if ((0, $48k9t.default).scopes.current !== (0, $48k9t.default).scopes.prev) clear();
    return {
        cache: cache,
        get: get,
        set: set,
        delete: deleteEntry,
        clear: clear,
        load: load,
        update: update,
        getEntries: // @ts-expect-error - TS2322 - Type '() => Promise<any[][]>' is not assignable to type '() => Promise<[K, V][]>'.
        getEntries,
        refresh: refresh
    };
}
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $32f02625ea3a7ccc$var$cacheMap = {};
const $32f02625ea3a7ccc$var$getCache = async (props)=>{
    await (0, $48k9t.scopeGuard)().catch((error)=>{
        (0, $gUUjF.default).safeErrorWithoutCustomerData('common.cache.scope', 'There was a failure within cache scopeGuard', error);
    });
    const { cacheKey: cacheKey } = props;
    // @ts-expect-error - TS7009 - 'new' expression, whose target lacks a construct signature, implicitly has an 'any' type.
    $32f02625ea3a7ccc$var$cacheMap[cacheKey] = $32f02625ea3a7ccc$var$cacheMap[cacheKey] || new $32f02625ea3a7ccc$export$94affb487e701bf2(props);
    return $32f02625ea3a7ccc$var$cacheMap[cacheKey];
};
const $32f02625ea3a7ccc$export$710d301bf26d9700 = ()=>{
    Object.values($32f02625ea3a7ccc$var$cacheMap).forEach((cache)=>cache.clear());
};
var $32f02625ea3a7ccc$export$2e2bcd8739ae039 = $32f02625ea3a7ccc$var$getCache;

});
const $834cc2f16be60bc5$export$7271276960377470 = 'common-cache';
const $834cc2f16be60bc5$export$a61768fefd33fcb1 = 'capacity exceeded';
const $834cc2f16be60bc5$export$6c4d37c7f376a1de = 'clear';
const $834cc2f16be60bc5$export$e271b26eefe41db8 = 'update';
const $834cc2f16be60bc5$export$4bd2facc4a3e6aa1 = 'delete';
const $834cc2f16be60bc5$export$26d12233004a7a60 = 'delete stale entry';
const $834cc2f16be60bc5$export$1bb358554aac31c1 = 'get';
const $834cc2f16be60bc5$export$61f74127e2b53cbe = 'hydrate';
const $834cc2f16be60bc5$export$5e8f180ef0142226 = 'set';
const $834cc2f16be60bc5$export$9eb68924983e00fb = 'get entries';
const $834cc2f16be60bc5$export$bf340b99118a1511 = 'memory';
const $834cc2f16be60bc5$export$2670cb7d5d4f7184 = 'local';
const $834cc2f16be60bc5$export$b796061ff0c82e1a = 'session';


parcelRegister("4qvSX", function(module, exports) {

$parcel$export(module.exports, "mergeData", () => $1b463beed4d472c8$export$696bf4df45a0ddde);
$parcel$export(module.exports, "mergeResponseData", () => $1b463beed4d472c8$export$71923bad28063cb1);
$parcel$export(module.exports, "createAnalyticsMetadata", () => $1b463beed4d472c8$export$eeaad9fa1f02ef4a);

var $6rW04 = parcelRequire("6rW04");
function $1b463beed4d472c8$export$696bf4df45a0ddde(oldData, newData) {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const result = {};
    Object.keys(oldData).forEach((issueId)=>{
        result[issueId] = oldData[issueId];
    });
    Object.keys(newData).forEach((issueId)=>{
        result[issueId] = newData[issueId];
    });
    return result;
}
function $1b463beed4d472c8$export$71923bad28063cb1(searchData, matchData) {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const mergedData = [];
    const issueData = new Map();
    if (matchData.length) // eslint-disable-next-line @typescript-eslint/no-explicit-any
    matchData.forEach((element)=>{
        issueData.set(element.id, element);
    });
    if (searchData.length) // eslint-disable-next-line @typescript-eslint/no-explicit-any
    searchData.forEach((element)=>{
        // TODO: if issueVersion in Match is less than Search, we should not be overwriting that issueID.
        if (issueData.has(element.id)) {
            mergedData.push(issueData.get(element.id));
            issueData.delete(element.id);
        } else mergedData.push(element);
    });
    if (issueData.size) issueData.forEach((value)=>{
        mergedData.push(value);
    });
    return mergedData;
}
function $1b463beed4d472c8$export$eeaad9fa1f02ef4a(customKeys) {
    return {
        shard: (0, $6rW04.default)('ajs-shard') || '',
        userId: (0, $6rW04.default)('ajs-atlassian-account-id') || '',
        projectId: (0, $6rW04.default)('ajs-project-key') || '',
        ...customKeys
    };
}

});




parcelRegister("kOOpn", function(module, exports) {

$parcel$export(module.exports, "useStartNinIssueAppAnalytics", () => $b4a559458c987e5d$export$39482b240f0b451f);

var $eUqFw = parcelRequire("eUqFw");

var $lNfG4 = parcelRequire("lNfG4");

var $hzcvF = parcelRequire("hzcvF");

var $4RwIp = parcelRequire("4RwIp");
const $b4a559458c987e5d$export$b9b395b52bdc3f4a = (0, $lNfG4.metrics).pageSegmentLoad({
    key: 'new-issue-navigator.issue-app'
});
const $b4a559458c987e5d$export$39482b240f0b451f = (issueKey)=>{
    const [{ view: view }] = (0, $4RwIp.useSelectedViewState)();
    const previousIssueKey = (0, $hzcvF.usePrevious)(issueKey);
    // We explicitly start during render instead of an effect hook as onInteractive can be fired before the effect hook
    // has run for cached issues.
    if (issueKey !== previousIssueKey) $b4a559458c987e5d$export$b9b395b52bdc3f4a.start();
    const onInteractive = (0, $eUqFw.useCallback)(()=>{
        $b4a559458c987e5d$export$b9b395b52bdc3f4a.stop({
            customData: {
                view: view
            }
        });
    }, [
        view
    ]);
    return {
        onInteractive: onInteractive
    };
};

});

parcelRegister("lCzk9", function(module, exports) {

$parcel$export(module.exports, "default", () => $159f546a51e6e323$export$2e2bcd8739ae039);

var $4Iv1W = parcelRequire("4Iv1W");

var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");
var $9t7rW = parcelRequire("9t7rW");

var $iWLL0 = parcelRequire("iWLL0");

var $3Hdmt = parcelRequire("3Hdmt");

var $1ydM0 = parcelRequire("1ydM0");

var $bt01S = parcelRequire("bt01S");
/**
 * Render extraHeaderActions if provided or otherwise return an empty render.
 */ const $159f546a51e6e323$var$HeaderActionsFallback = ({ extraHeaderActions: extraHeaderActions, isEmbedView: isEmbedView, maxWidth: maxWidth })=>extraHeaderActions ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($159f546a51e6e323$var$HeaderActionsContainer, {
        maxWidth: maxWidth,
        isEmbedView: isEmbedView
    }, extraHeaderActions) : null;
/**
 * Render issue pagination controls and extraHeaderActions if provided.
 */ const $159f546a51e6e323$var$HeaderActions = (props)=>{
    const { extraHeaderActions: extraHeaderActions, issueResults: issueResults, maxWidth: maxWidth, isEmbedView: isEmbedView } = props;
    const issueResultsData = (0, $iWLL0.useFragment)((0, $4Iv1W.default), issueResults);
    const [, { getSelectedIssuePosition: getSelectedIssuePosition }] = (0, $1ydM0.useSelectedIssueStateActions)();
    const selectedIssuePosition = getSelectedIssuePosition();
    // If selectedIssuePosition is not defined then our selected issue key does not exist in the result set, so there
    // are no pagination controls to show.
    if (selectedIssuePosition == null || issueResultsData == null) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($159f546a51e6e323$var$HeaderActionsFallback, props);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($159f546a51e6e323$var$HeaderActionsContainer, {
        maxWidth: maxWidth,
        isEmbedView: isEmbedView
    }, extraHeaderActions ?? null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $bt01S.default), {
        issueResults: issueResultsData,
        selectedIssuePosition: selectedIssuePosition
    }));
};
var $159f546a51e6e323$export$2e2bcd8739ae039 = (0, $3Hdmt.withRecoverableErrorBoundary)($159f546a51e6e323$var$HeaderActions, {
    recoveryProp: 'issueResults',
    Fallback: $159f546a51e6e323$var$HeaderActionsFallback
});
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $159f546a51e6e323$var$HeaderActionsContainer = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { isEmbedView: isEmbedView, maxWidth: maxWidth, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmpldp,
        style: {
            ...__cmpls,
            "--_1et2rhb": (0, $9t7rW.default)(__cmplp.maxWidth, "px")
        },
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_4cvr1h6o _1bahesu3 _19pkidpf _2hwx1wug _otyridpf _18u01wug _1e0c1txw _1bsb1osq _vchhusvi _10nju2gc _7zw6v47k",
            __cmplp.isEmbedView && "_n3tdu2gc",
            __cmplp.maxWidth && "_p12f1ayu",
            __cmplp.className
        ])
    });
});

});
parcelRegister("4Iv1W", function(module, exports) {

$parcel$export(module.exports, "default", () => $e05a0534779c0d07$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<0bc51f9494de5d6fa2940f677e3da0a2>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $e05a0534779c0d07$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "headerActions_issueNavigator",
    "selections": [
        {
            "kind": "FragmentSpread",
            "name": "issuePagination_issueNavigator"
        }
    ],
    "type": "JiraIssueConnection"
};
$e05a0534779c0d07$var$node.hash = "701bdde8a1a96783e68d573053dd8362";
var $e05a0534779c0d07$export$2e2bcd8739ae039 = $e05a0534779c0d07$var$node;

});

parcelRegister("3Hdmt", function(module, exports) {

$parcel$export(module.exports, "withRecoverableErrorBoundary", () => $1e0342b6d6628cc9$export$c25a1c850f00ce39);

var $eUqFw = parcelRequire("eUqFw");
function $1e0342b6d6628cc9$export$c25a1c850f00ce39(WrappedComponent, { recoveryProp: recoveryProp, Fallback: Fallback }) {
    class RecoverableErrorBoundary extends (0, $eUqFw.Component) {
        componentDidUpdate(prevProps) {
            if (this.state.errorProps && prevProps[recoveryProp] !== this.props[recoveryProp]) this.setState({
                errorProps: null
            });
        }
        componentDidCatch(error, errorInfo) {
            this.setState({
                errorProps: {
                    error: error,
                    errorInfo: errorInfo
                }
            });
        }
        render() {
            if (this.state.errorProps) return Fallback ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(Fallback, {
                ...this.props,
                ...this.state.errorProps
            }) : null;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(WrappedComponent, this.props);
        }
        constructor(...args){
            super(...args);
            this.state = {
                errorProps: null
            };
        }
    }
    return RecoverableErrorBoundary;
}

});

parcelRegister("bt01S", function(module, exports) {

$parcel$export(module.exports, "default", () => $f244c1c37c30a036$export$2e2bcd8739ae039);

var $dpAaW = parcelRequire("dpAaW");

var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $iWLL0 = parcelRequire("iWLL0");

var $bLFgh = parcelRequire("bLFgh");

var $g3uGD = parcelRequire("g3uGD");

var $6LS1L = parcelRequire("6LS1L");

var $53tMP = parcelRequire("53tMP");

var $2uQ5n = parcelRequire("2uQ5n");
const $f244c1c37c30a036$var$IssuePagination = ({ issueResults: issueResults, selectedIssuePosition: selectedIssuePosition })=>{
    const issueResultsData = (0, $iWLL0.useFragment)((0, $dpAaW.default), issueResults);
    const { totalIssueSearchResultCount: totalIssueSearchResultCount, isCappingIssueSearchResult: isCappingIssueSearchResult } = issueResultsData;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($f244c1c37c30a036$var$PaginationTextContainer, {
        "data-testid": "issue-pagination.pagination-text"
    }, totalIssueSearchResultCount <= 0 ? selectedIssuePosition : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $g3uGD.default), {
        prependMessage: (0, $6LS1L.default).issueIndexTotalKnown,
        prependMessageValues: {
            issueIndex: selectedIssuePosition
        },
        isCapped: isCappingIssueSearchResult ?? false,
        stableCount: totalIssueSearchResultCount
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $bLFgh.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $2uQ5n.default), {
        selectedIssuePosition: selectedIssuePosition
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $53tMP.default), {
        totalResultCount: totalIssueSearchResultCount,
        selectedIssuePosition: selectedIssuePosition,
        isCappingIssueSearchResult: isCappingIssueSearchResult ?? false
    })));
};
var $f244c1c37c30a036$export$2e2bcd8739ae039 // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
 = $f244c1c37c30a036$var$IssuePagination;
const $f244c1c37c30a036$var$PaginationTextContainer = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _4cvr1h6o",
            __cmplp.className
        ])
    });
});

});
parcelRegister("dpAaW", function(module, exports) {

$parcel$export(module.exports, "default", () => $55d0d5304740ceb0$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<cdeacb15335634351a83b6eeb614c997>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $55d0d5304740ceb0$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "issuePagination_issueNavigator",
    "selections": [
        {
            "kind": "RequiredField",
            "field": {
                "kind": "ScalarField",
                "name": "totalIssueSearchResultCount"
            },
            "action": "THROW",
            "path": "totalIssueSearchResultCount"
        },
        {
            "kind": "ScalarField",
            "name": "isCappingIssueSearchResult"
        }
    ],
    "type": "JiraIssueConnection"
};
$55d0d5304740ceb0$var$node.hash = "252cad0134e2ce14b78595c597895b8f";
var $55d0d5304740ceb0$export$2e2bcd8739ae039 = $55d0d5304740ceb0$var$node;

});

parcelRegister("g3uGD", function(module, exports) {

$parcel$export(module.exports, "default", () => $aa2aec0ba6ba3acd$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $0cdA8 = parcelRequire("0cdA8");

var $5JgJ2 = parcelRequire("5JgJ2");

var $3DZcj = parcelRequire("3DZcj");
/**
 * Display the total number of issues from a search with the ability to toggle from stable to unstable values.
 *
 * Stable vs Unstable
 *  - the **stable count** is returned from the issueSearchStable query. It will be capped at 1000 if
 *    there are more than 1000 results. This is the default count that is displayed
 *
 *  - the **unstable count** is returned from the totalIssueCountQuery query. It is the true number of results
 *    for a search and does not have a cap. This value must be requested by the user via button click.
 */ const $aa2aec0ba6ba3acd$var$TotalIssueCountWrapper = (props)=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $0cdA8.JSErrorBoundary), {
        id: "TotalIssueCount",
        packageName: "jiraIssueNavigator",
        render: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, formatMessage(props.prependMessage, {
                ...props.prependMessageValues,
                totalNumberIssues: props.isCapped ? `${props.stableCount}+` : props.stableCount
            })),
        sendToPrivacyUnsafeSplunk: true,
        teamName: "empanada"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $3DZcj.default), props));
};
var $aa2aec0ba6ba3acd$export$2e2bcd8739ae039 = $aa2aec0ba6ba3acd$var$TotalIssueCountWrapper;

});
parcelRegister("3DZcj", function(module, exports) {

$parcel$export(module.exports, "default", () => $8f770e002076665c$export$2e2bcd8739ae039);
/* main.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $96IgR = parcelRequire("96IgR");

var $b5IAe = parcelRequire("b5IAe");

var $4Bees = parcelRequire("4Bees");

var $8cU5f = parcelRequire("8cU5f");

var $5JgJ2 = parcelRequire("5JgJ2");

var $d6f6c = parcelRequire("d6f6c");

var $cQBUE = parcelRequire("cQBUE");

var $3QTv4 = parcelRequire("3QTv4");

var $cQUrR = parcelRequire("cQUrR");
const $8f770e002076665c$var$TotalIssueCount = ({ prependMessage: prependMessage, prependMessageValues: prependMessageValues, isCapped: isCapped, stableCount: stableCount })=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const { uncappedTotalIssueCount: uncappedTotalIssueCount, onFetchUncappedTotalIssueCount: onFetchUncappedTotalIssueCount } = (0, $cQBUE.useIssueSearchQuery)();
    const { count: unstableCount, isError: isError, isFetching: isFetching } = uncappedTotalIssueCount;
    if (isCapped) {
        if (isError) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
            as: "span"
        }, formatMessage(prependMessage, {
            ...prependMessageValues,
            totalNumberIssues: `${stableCount}+`
        })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8cU5f.default), {
            position: "top",
            content: formatMessage((0, $cQUrR.default).errorTooltipText)
        }, (tooltipProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($8f770e002076665c$var$ErrorIconContainer, {
                ...tooltipProps,
                "data-testid": "issue-navigator.common.ui.total-issue-count.error-icon"
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($96IgR))), {
                label: formatMessage((0, $cQUrR.default).errorIconLabel)
            }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $d6f6c.FireUiAnalytics), {
            action: "viewed",
            actionSubject: "errorIcon",
            actionSubjectId: "totalIssueCount"
        }));
        if (isFetching) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
            as: "span"
        }, formatMessage(prependMessage, {
            ...prependMessageValues,
            totalNumberIssues: ''
        })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($8f770e002076665c$var$SpinnerContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4Bees.default), {
            size: "small",
            testId: "issue-navigator.common.ui.total-issue-count.spinner"
        })));
        if (!unstableCount) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
            as: "span"
        }, formatMessage(prependMessage, {
            ...prependMessageValues,
            totalNumberIssues: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $3QTv4.default), {
                displayText: `${stableCount}+`,
                fetch: onFetchUncappedTotalIssueCount
            })
        }));
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
            as: "span"
        }, formatMessage(prependMessage, {
            ...prependMessageValues,
            totalNumberIssues: unstableCount
        }));
    }
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
        as: "span"
    }, formatMessage(prependMessage, {
        ...prependMessageValues,
        totalNumberIssues: stableCount
    }));
};
var $8f770e002076665c$export$2e2bcd8739ae039 // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
 = /*#__PURE__*/ (0, $eUqFw.memo)($8f770e002076665c$var$TotalIssueCount);
const $8f770e002076665c$var$ErrorIconContainer = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1o8l _4t3i1tcg _syaz1rc1",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $8f770e002076665c$var$SpinnerContainer = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1o8l _otyr1l7b _18u01y44",
            __cmplp.className
        ])
    });
});

});
parcelRegister("3QTv4", function(module, exports) {

$parcel$export(module.exports, "default", () => $089c35c277622008$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $7u4fN = parcelRequire("7u4fN");

var $8cU5f = parcelRequire("8cU5f");

var $5JgJ2 = parcelRequire("5JgJ2");

var $jMP2a = parcelRequire("jMP2a");

var $cQUrR = parcelRequire("cQUrR");
const $089c35c277622008$var$LoadUncappedCountButton = ({ fetch: fetch, displayText: displayText })=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const fetchCount = (0, $eUqFw.useCallback)((event, analyticsEvent)=>{
        fetch();
        (0, $jMP2a.fireUIAnalytics)(analyticsEvent, 'totalIssueCountButton');
    }, [
        fetch
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8cU5f.default), {
        content: formatMessage((0, $cQUrR.default).cappedCountTooltip),
        tag: "span"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7u4fN.default), {
        tabIndex: 0,
        appearance: "link",
        spacing: "none",
        onClick: fetchCount,
        "aria-label": formatMessage((0, $cQUrR.default).cappedCountTooltip),
        testId: "issue-navigator.common.ui.total-issue-count.load-uncapped-count-button.button"
    }, displayText));
};
var $089c35c277622008$export$2e2bcd8739ae039 = $089c35c277622008$var$LoadUncappedCountButton;

});
parcelRegister("cQUrR", function(module, exports) {

$parcel$export(module.exports, "default", () => $512543f6a1aec6d7$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $512543f6a1aec6d7$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    errorTooltipText: {
        "id": "issue-navigator.common.total-issue-count.error-tooltip-text",
        "defaultMessage": "We couldn\u2019t load the total number of issues. Refresh to try again."
    },
    errorIconLabel: {
        "id": "issue-navigator.common.total-issue-count.error-icon-label",
        "defaultMessage": "Error loading total issue count"
    },
    cappedCountTooltip: {
        "id": "issue-navigator.common.total-issue-count.capped-count-tooltip",
        "defaultMessage": "See the total number of issues."
    }
});

});




parcelRegister("6LS1L", function(module, exports) {

$parcel$export(module.exports, "default", () => $75951b7edeaf903c$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
const $75951b7edeaf903c$var$messages = (0, $90IgZ.defineMessages)({
    issueIndexTotalKnown: {
        "id": "issue-navigator.common.issue-app.header-actions.issue-pagination.issue-index-total-known",
        "defaultMessage": "{issueIndex} of {totalNumberIssues}"
    }
});
var $75951b7edeaf903c$export$2e2bcd8739ae039 = $75951b7edeaf903c$var$messages;

});

parcelRegister("53tMP", function(module, exports) {

$parcel$export(module.exports, "default", () => $528a37d41af402b3$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $7JEyt = parcelRequire("7JEyt");

var $eUqFw = parcelRequire("eUqFw");

var $7u4fN = parcelRequire("7u4fN");

var $j9fWg = parcelRequire("j9fWg");

var $86Ndv = parcelRequire("86Ndv");

var $e9T6i = parcelRequire("e9T6i");

var $8cU5f = parcelRequire("8cU5f");

var $7uIWw = parcelRequire("7uIWw");

var $eI5EY = parcelRequire("eI5EY");

var $5JgJ2 = parcelRequire("5JgJ2");

var $jMP2a = parcelRequire("jMP2a");

var $1ydM0 = parcelRequire("1ydM0");

var $ia9pY = parcelRequire("ia9pY");
const $528a37d41af402b3$var$TooltipTag = /*#__PURE__*/ (0, $eUqFw.forwardRef)((props, ref)=>// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($528a37d41af402b3$var$StyledTooltipTag, {
        ref: ref,
        ...props
    }));
const $528a37d41af402b3$var$IssuePaginationNextButton = ({ selectedIssuePosition: selectedIssuePosition, totalResultCount: totalResultCount, isCappingIssueSearchResult: isCappingIssueSearchResult })=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const isDisabled = selectedIssuePosition === totalResultCount;
    const [, { getNextIssue: getNextIssue, selectNextIssue: selectNextIssue }] = (0, $1ydM0.useSelectedIssueStateActions)();
    const { issueKey: issueKey } = getNextIssue();
    const nextIssueMessage = issueKey ? formatMessage((0, $ia9pY.default).nextIssueTooltip, {
        issueKey: issueKey
    }) : formatMessage((0, $ia9pY.default).nextIssueWithoutKeyTooltip);
    const onClick = (0, $eUqFw.useCallback)((_, analyticsEvent)=>{
        if (selectNextIssue()) (0, $jMP2a.fireUIAnalytics)(analyticsEvent, 'nextIssue');
    }, [
        selectNextIssue
    ]);
    if (isDisabled && isCappingIssueSearchResult) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8cU5f.default), {
        content: formatMessage((0, $ia9pY.default).disabledButtonTooltip),
        tag: $528a37d41af402b3$var$TooltipTag
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7uIWw.default), {
        tabIndex: 0,
        isDisabled: true,
        "aria-label": (0, $eI5EY.fg)('nin_critical_accessibility_issues') ? undefined : formatMessage((0, $ia9pY.default).disabledButtonTooltip),
        "data-testid": "issue-navigator.common.ui.issue-app.header-actions.issue-pagination.next-button.next-disabled-button"
    }, (0, $eI5EY.fg)('nin_critical_accessibility_issues') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $j9fWg.default), {
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($e9T6i))),
        label: formatMessage((0, $ia9pY.default).disabledButtonTooltip),
        onClick: onClick,
        appearance: "subtle",
        testId: "issue-navigator.common.ui.issue-app.header-actions.issue-pagination.next-button",
        isDisabled: isDisabled,
        spacing: "compact"
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7u4fN.default), {
        appearance: "subtle",
        testId: "issue-navigator.common.ui.issue-app.header-actions.issue-pagination.next-button",
        iconAfter: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($86Ndv))), {
            size: "medium",
            label: ""
        }),
        isDisabled: isDisabled,
        onClick: onClick,
        spacing: "none"
    })));
    if ((0, $eI5EY.fg)('nin_critical_accessibility_issues')) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $j9fWg.default), {
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($e9T6i))),
        label: isDisabled ? formatMessage((0, $ia9pY.default).disabledButtonLabel, {
            issueCount: totalResultCount
        }) : nextIssueMessage,
        onClick: onClick,
        appearance: "subtle",
        testId: "issue-navigator.common.ui.issue-app.header-actions.issue-pagination.next-button",
        isDisabled: isDisabled,
        spacing: "compact",
        isTooltipDisabled: isDisabled
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8cU5f.default), {
        content: isDisabled ? null : nextIssueMessage
    }, (tooltipProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7u4fN.default), {
            appearance: "subtle",
            ...tooltipProps,
            testId: "issue-navigator.common.ui.issue-app.header-actions.issue-pagination.next-button",
            iconAfter: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($86Ndv))), {
                size: "medium",
                label: ""
            }),
            isDisabled: isDisabled,
            onClick: onClick,
            spacing: "none"
        }));
};
var $528a37d41af402b3$export$2e2bcd8739ae039 // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
 = $528a37d41af402b3$var$IssuePaginationNextButton;
const $528a37d41af402b3$var$StyledTooltipTag = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c116y",
            __cmplp.className
        ])
    });
});

});
parcelRegister("e9T6i", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::ce299ea00421c5395af727ab457ee775>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $a4eca5cb70ed36ce$var$_react = $a4eca5cb70ed36ce$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $a4eca5cb70ed36ce$var$_chevronDown = $a4eca5cb70ed36ce$var$_interopRequireDefault((parcelRequire("c6CvK")));

var $a4eca5cb70ed36ce$var$_chevronDown2 = $a4eca5cb70ed36ce$var$_interopRequireDefault((parcelRequire("86Ndv")));
function $a4eca5cb70ed36ce$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 *
 * Migration Icon component for ChevronDownIcon.
 * This component is ChevronDownIcon, with `UNSAFE_fallbackIcon` set to "ChevronDownIcon".
 *
 * Category: utility
 * Location: @atlaskit/icon
 * Usage guidance: Reserved for dropdown menus, selects, accordions, and expands.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $a4eca5cb70ed36ce$var$ChevronDownIcon = (props)=>/*#__PURE__*/ $a4eca5cb70ed36ce$var$_react.default.createElement($a4eca5cb70ed36ce$var$_chevronDown.default, Object.assign({
        LEGACY_fallbackIcon: $a4eca5cb70ed36ce$var$_chevronDown2.default
    }, props));
$a4eca5cb70ed36ce$var$ChevronDownIcon.Name = 'ChevronDownIconMigration';
var $a4eca5cb70ed36ce$var$_default = module.exports.default = $a4eca5cb70ed36ce$var$ChevronDownIcon;

});

parcelRegister("7uIWw", function(module, exports) {

$parcel$export(module.exports, "default", () => $c23000ce719f2bef$export$2e2bcd8739ae039);

var $kwce8 = parcelRequire("kwce8");
/**
 * When the @atlaskit/button component is disabled it prevents mouse events being fired for the button, which prevents
 * tooltips showing https://atlassian.design/components/button/usage#disabled-buttons.
 * When you require a disabled button to show a tooltip on hover then the button should be wrapped in this element.
 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $c23000ce719f2bef$var$DisabledButtonWithTooltip = /*#__PURE__*/ (0, $kwce8.default).span.withConfig({
    componentId: "yhjexx-0"
})({
    display: 'inline-flex'
}, // eslint-disable-next-line @atlaskit/ui-styling-standard/no-dynamic-styles -- Ignored via go/DSP-18766
(props)=>props.isDisabled ? // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
    (0, $kwce8.css)({
        cursor: 'not-allowed',
        // Disable pointer events for the button element which means 'event.preventDefault()' will not be
        // called from AK. This allows pointer events to bubble from our wrapping span element.
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        '> button': {
            pointerEvents: 'none'
        }
    }) : '');
var // eslint-disable-next-line @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
$c23000ce719f2bef$export$2e2bcd8739ae039 = $c23000ce719f2bef$var$DisabledButtonWithTooltip;

});

parcelRegister("ia9pY", function(module, exports) {

$parcel$export(module.exports, "default", () => $56da645f7a9feeb7$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
const $56da645f7a9feeb7$var$messages = (0, $90IgZ.defineMessages)({
    nextIssueTooltip: {
        "id": "issue-navigator.common.issue-app.header-actions.issue-pagination.next-button.next-issue-tooltip",
        "defaultMessage": "Next issue ''{issueKey}'' (Type 'j')"
    },
    nextIssueWithoutKeyTooltip: {
        "id": "issue-navigator.common.issue-app.header-actions.issue-pagination.next-button.next-issue-without-key-tooltip",
        "defaultMessage": "Next issue (Type 'j')"
    },
    disabledButtonTooltip: {
        "id": "issue-navigator.common.issue-app.header-actions.issue-pagination.next-button.disabled-button-tooltip",
        "defaultMessage": "We can\u2019t load more pages. Refine your search criteria to see more issues."
    },
    disabledButtonLabel: {
        "id": "issue-navigator.common.issue-app.header-actions.issue-pagination.next-button.disabled-button-label",
        "defaultMessage": "{issueCount} of {issueCount} issues, select previous issues to go back"
    }
});
var $56da645f7a9feeb7$export$2e2bcd8739ae039 = $56da645f7a9feeb7$var$messages;

});


parcelRegister("2uQ5n", function(module, exports) {

$parcel$export(module.exports, "default", () => $512743b19bcac109$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $7u4fN = parcelRequire("7u4fN");

var $j9fWg = parcelRequire("j9fWg");

var $5xnoX = parcelRequire("5xnoX");

var $8cU5f = parcelRequire("8cU5f");

var $eI5EY = parcelRequire("eI5EY");

var $5JgJ2 = parcelRequire("5JgJ2");

var $jMP2a = parcelRequire("jMP2a");

var $1ydM0 = parcelRequire("1ydM0");

var $dr4QU = parcelRequire("dr4QU");
const $512743b19bcac109$var$IssuePaginationPreviousButton = ({ selectedIssuePosition: selectedIssuePosition })=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const [, { getPreviousIssue: getPreviousIssue, selectPreviousIssue: selectPreviousIssue }] = (0, $1ydM0.useSelectedIssueStateActions)();
    const { issueKey: issueKey } = getPreviousIssue();
    const previousIssueMessage = issueKey ? formatMessage((0, $dr4QU.default).previousIssueTooltip, {
        issueKey: issueKey
    }) : formatMessage((0, $dr4QU.default).previousIssueWithoutKeyTooltip);
    const onClick = (0, $eUqFw.useCallback)((_, analyticsEvent)=>{
        if (selectPreviousIssue()) (0, $jMP2a.fireUIAnalytics)(analyticsEvent, 'previousIssue');
    }, [
        selectPreviousIssue
    ]);
    const isDisabled = selectedIssuePosition === 1;
    if ((0, $eI5EY.fg)('nin_critical_accessibility_issues')) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $j9fWg.default), {
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($5xnoX))),
        label: isDisabled ? formatMessage((0, $dr4QU.default).disabledButtonLabel) : previousIssueMessage,
        onClick: onClick,
        appearance: "subtle",
        testId: "issue-navigator.common.ui.issue-app.header-actions.issue-pagination.previous-button",
        isDisabled: isDisabled,
        spacing: "compact",
        isTooltipDisabled: isDisabled
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8cU5f.default), {
        content: isDisabled ? null : previousIssueMessage
    }, (tooltipProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7u4fN.default), {
            appearance: "subtle",
            ...tooltipProps,
            testId: "issue-navigator.common.ui.issue-app.header-actions.issue-pagination.previous-button",
            iconAfter: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5xnoX))), {
                size: "medium",
                label: ""
            }),
            isDisabled: isDisabled,
            onClick: onClick,
            spacing: "none"
        }));
};
var $512743b19bcac109$export$2e2bcd8739ae039 = $512743b19bcac109$var$IssuePaginationPreviousButton;

});
parcelRegister("5xnoX", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $40822fe6f5908262$var$_react = $40822fe6f5908262$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $igPbh = parcelRequire("igPbh");

var $40822fe6f5908262$var$_chevronUp = $40822fe6f5908262$var$_interopRequireDefault((parcelRequire("ibyhG")));
function $40822fe6f5908262$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
const $40822fe6f5908262$var$ChevronUpIcon = (props)=>/*#__PURE__*/ $40822fe6f5908262$var$_react.default.createElement($igPbh.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="m11.221 9.322-2.929 2.955a1.01 1.01 0 0 0 0 1.419.986.986 0 0 0 1.405 0l2.298-2.317 2.307 2.327a.99.99 0 0 0 1.407 0 1.01 1.01 0 0 0 0-1.419l-2.94-2.965A1.1 1.1 0 0 0 11.991 9c-.279 0-.557.107-.77.322"/></svg>`
    }, props, {
        newIcon: $40822fe6f5908262$var$_chevronUp.default,
        iconType: "utility"
    }));
$40822fe6f5908262$var$ChevronUpIcon.displayName = 'ChevronUpIcon';
var $40822fe6f5908262$var$_default = module.exports.default = $40822fe6f5908262$var$ChevronUpIcon;

});

parcelRegister("dr4QU", function(module, exports) {

$parcel$export(module.exports, "default", () => $f7ba253ad3aa957c$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
const $f7ba253ad3aa957c$var$messages = (0, $90IgZ.defineMessages)({
    previousIssueTooltip: {
        "id": "issue-navigator.common.issue-app.header-actions.issue-pagination.previous-button.previous-issue-tooltip",
        "defaultMessage": "Previous issue ''{issueKey}'' (Type 'k')"
    },
    previousIssueWithoutKeyTooltip: {
        "id": "issue-navigator.common.issue-app.header-actions.issue-pagination.previous-button.previous-issue-without-key-tooltip",
        "defaultMessage": "Previous issue (Type 'k')"
    },
    disabledButtonLabel: {
        "id": "issue-navigator.common.issue-app.header-actions.issue-pagination.previous-button.disabled-button-label",
        "defaultMessage": "No previous issue, select next issue"
    }
});
var $f7ba253ad3aa957c$export$2e2bcd8739ae039 = $f7ba253ad3aa957c$var$messages;

});




parcelRegister("geiGJ", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = Promise.all([
    $d1Cng("kWrFZ"),
    $d1Cng("92sUi"),
    $d1Cng("i5RRW"),
    $d1Cng("dsiAd"),
    $d1Cng("eNmuD"),
    $d1Cng("2hmUs"),
    $d1Cng("bCeK4"),
    $d1Cng("hPzOn"),
    $d1Cng("h2MrD"),
    $d1Cng("bYT2S"),
    $d1Cng("kMAKK")
]).then(()=>parcelRequire('9zAkH'));

});


parcelRegister("21fwU", function(module, exports) {

$parcel$export(module.exports, "default", () => $63a751113e57fea4$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
const $63a751113e57fea4$var$messages = (0, $90IgZ.defineMessages)({
    returnText: {
        "id": "issue-navigator.full-page-issue-app.return-text",
        "defaultMessage": "Return to search"
    }
});
var $63a751113e57fea4$export$2e2bcd8739ae039 = $63a751113e57fea4$var$messages;

});


parcelRegister("58gge", function(module, exports) {

$parcel$export(module.exports, "default", () => $555333a428a60e6a$export$2e2bcd8739ae039);

var $4hVpa = parcelRequire("4hVpa");

var $KXsuD = parcelRequire("KXsuD");

var $eUqFw = parcelRequire("eUqFw");

var $iWLL0 = parcelRequire("iWLL0");

var $1lXFP = parcelRequire("1lXFP");

var $idiDE = parcelRequire("idiDE");

var $jccNB = parcelRequire("jccNB");

var $kmXw8 = parcelRequire("kmXw8");

var $3mEVr = parcelRequire("3mEVr");

var $dCaOY = parcelRequire("dCaOY");
const $555333a428a60e6a$var$getLastPage = (pageCursors)=>{
    if (pageCursors?.last) return pageCursors.last.pageNumber;
    if (pageCursors?.around?.length) return pageCursors.around[pageCursors.around.length - 1]?.pageNumber;
    return undefined;
};
const $555333a428a60e6a$var$Header = ({ CustomHeader: CustomHeader, filter: filter, issueResults: issueResults, HeaderSkeletonImage: HeaderSkeletonImage })=>{
    const issueResultsData = (0, $iWLL0.useFragment)((0, $KXsuD.default), issueResults);
    // Compute page data for our search results which is needed when requesting items for the legacy meatball menu
    const offset = (issueResultsData?.issueNavigatorPageInfo?.firstIssuePosition ?? 1) - 1; // offset is 0 based so subtract 1
    const pages = $555333a428a60e6a$var$getLastPage(issueResultsData?.pageCursors) ?? 0;
    const total = issueResultsData?.totalIssueSearchResultCount ?? 0;
    const searchResultPageData = (0, $eUqFw.useMemo)(()=>({
            offset: offset,
            pages: pages,
            total: total
        }), [
        offset,
        pages,
        total
    ]);
    const { filterId: filterId } = (0, $3mEVr.useActiveJql)();
    const jql = (0, $3mEVr.useResolvedJql)();
    const { filterQueryIsFetching: filterQueryIsFetching } = (0, $dCaOY.useFilterQuery)();
    const filterData = (0, $iWLL0.useFragment)((0, $4hVpa.default), filter);
    const filterDetails = (0, $eUqFw.useMemo)(()=>filterData ? {
            filterId: filterData.filterId,
            name: filterData.name,
            jql: filterData.jql,
            isFavourite: Boolean(filterData.isFavourite)
        } : undefined, [
        filterData
    ]);
    if (filterQueryIsFetching) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(HeaderSkeletonImage, null);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $idiDE.default), {
        name: "header"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(CustomHeader, {
        jql: jql,
        filterId: filterId,
        filterDetails: filterDetails,
        searchResultPageData: searchResultPageData
    }));
};
var $555333a428a60e6a$export$2e2bcd8739ae039 = (0, $kmXw8.withReportErrors)($555333a428a60e6a$var$Header, {
    id: 'ui.header.unhandled',
    packageName: (0, $jccNB.PACKAGE_NAME),
    teamName: (0, $jccNB.TEAM_NAME),
    sendToPrivacyUnsafeSplunk: true,
    attributes: (0, $1lXFP.isLoaderErrorAttributes)
});

});
parcelRegister("4hVpa", function(module, exports) {

$parcel$export(module.exports, "default", () => $45e9b43d50c1f1c7$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<a59decce3d17ede33536b0b36f9eb2f1>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $45e9b43d50c1f1c7$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "main_issueNavigator_Header_filter",
    "selections": [
        {
            "kind": "ScalarField",
            "name": "filterId"
        },
        {
            "kind": "ScalarField",
            "name": "name"
        },
        {
            "kind": "ScalarField",
            "name": "isFavourite"
        },
        {
            "kind": "ScalarField",
            "name": "jql"
        }
    ],
    "type": "JiraFilter",
    "abstractKey": "__isJiraFilter"
};
$45e9b43d50c1f1c7$var$node.hash = "49ae72938f954e62114776575c662bd8";
var $45e9b43d50c1f1c7$export$2e2bcd8739ae039 = $45e9b43d50c1f1c7$var$node;

});

parcelRegister("KXsuD", function(module, exports) {

$parcel$export(module.exports, "default", () => $0010939d46d22e40$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<904e0d39da2e4e2100f94fcd59ddca44>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $0010939d46d22e40$var$node = function() {
    var v0 = [
        {
            "kind": "ScalarField",
            "name": "pageNumber"
        }
    ];
    return {
        "argumentDefinitions": [],
        "kind": "Fragment",
        "name": "main_issueNavigator_Header_issueResults",
        "selections": [
            {
                "concreteType": "JiraIssueNavigatorPageInfo",
                "kind": "LinkedField",
                "name": "issueNavigatorPageInfo",
                "plural": false,
                "selections": [
                    {
                        "kind": "ScalarField",
                        "name": "firstIssuePosition"
                    }
                ]
            },
            {
                "args": [
                    {
                        "kind": "Literal",
                        "name": "maxCursors",
                        "value": 7
                    }
                ],
                "concreteType": "JiraPageCursors",
                "kind": "LinkedField",
                "name": "pageCursors",
                "plural": false,
                "selections": [
                    {
                        "concreteType": "JiraPageCursor",
                        "kind": "LinkedField",
                        "name": "around",
                        "plural": true,
                        "selections": v0 /*: any*/ 
                    },
                    {
                        "concreteType": "JiraPageCursor",
                        "kind": "LinkedField",
                        "name": "last",
                        "plural": false,
                        "selections": v0 /*: any*/ 
                    }
                ],
                "storageKey": "pageCursors(maxCursors:7)"
            },
            {
                "kind": "ScalarField",
                "name": "totalIssueSearchResultCount"
            }
        ],
        "type": "JiraIssueConnection"
    };
}();
$0010939d46d22e40$var$node.hash = "a6845643ea9e8dc218ebb8df7988c3f7";
var $0010939d46d22e40$export$2e2bcd8739ae039 = $0010939d46d22e40$var$node;

});

parcelRegister("kmXw8", function(module, exports) {

$parcel$export(module.exports, "withReportErrors", () => $1607c3a4dbba9548$export$89614e972c8b110);

var $eUqFw = parcelRequire("eUqFw");

var $aR8n6 = parcelRequire("aR8n6");
const $1607c3a4dbba9548$export$89614e972c8b110 = (WrappedComponent, config)=>(props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $aR8n6.default), config, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(WrappedComponent, props));

});


parcelRegister("j6Pvv", function(module, exports) {

$parcel$export(module.exports, "default", () => $685027018ced4552$export$2e2bcd8739ae039);

var $8eeq7 = parcelRequire("8eeq7");

var $i1TJz = parcelRequire("i1TJz");

var $112QR = parcelRequire("112QR");

var $eUqFw = parcelRequire("eUqFw");

var $iWLL0 = parcelRequire("iWLL0");

var $lgxha = parcelRequire("lgxha");

var $1lXFP = parcelRequire("1lXFP");

var $1ybV0 = parcelRequire("1ybV0");

var $7byHA = parcelRequire("7byHA");

var $8WuJm = parcelRequire("8WuJm");

var $lB25E = parcelRequire("lB25E");

var $idiDE = parcelRequire("idiDE");

var $jccNB = parcelRequire("jccNB");

var $bnzDM = parcelRequire("bnzDM");

var $kmXw8 = parcelRequire("kmXw8");

var $cWCvn = parcelRequire("cWCvn");

var $1ydM0 = parcelRequire("1ydM0");

var $4RwIp = parcelRequire("4RwIp");

var $2ycZm = parcelRequire("2ycZm");

var $3mEVr = parcelRequire("3mEVr");

var $cQBUE = parcelRequire("cQBUE");

var $9w10X = parcelRequire("9w10X");

var $clId8 = parcelRequire("clId8");

var $4OYZ7 = parcelRequire("4OYZ7");
const $685027018ced4552$var$IssueResults = ({ onChangeColumnConfiguration: onChangeColumnConfiguration, onChangeJql: onChangeJql, onCaughtIssueSearchError: onCaughtIssueSearchError, issueResults: issueResults, view: view, viewResult: viewResult, isFeedbackButtonDisabled: isFeedbackButtonDisabled, issueTableProps: issueTableProps, filter: filter })=>{
    (0, $cWCvn.markOnce)((0, $cWCvn.marks).ISSUE_RESULTS_START);
    const [, { setSelectedIssueByIndex: setSelectedIssueByIndex }] = (0, $1ydM0.useSelectedIssueIndex)();
    const [{ view: selectedView }] = (0, $4RwIp.useSelectedViewState)();
    const jql = (0, $3mEVr.useResolvedJql)();
    const { push: push } = (0, $lB25E.useRouterActions)();
    const onSelectedRowChange = (0, $eUqFw.useCallback)((rowIndex)=>{
        setSelectedIssueByIndex(rowIndex, false, false, true);
    }, [
        setSelectedIssueByIndex
    ]);
    const { isFetching: isFetching } = (0, $cQBUE.useIssueSearchQuery)();
    const issueResultsData = (0, $iWLL0.useFragment)((0, $112QR.default), issueResults);
    const viewData = (0, $iWLL0.useFragment)((0, $i1TJz.default), view);
    const viewResultData = (0, $iWLL0.useFragment)((0, $8eeq7.default), viewResult);
    const viewResultError = (0, $1ybV0.ff)('handle-404-filter-errors-gracefully-in-the-ui-by-showing-filter-not-found-view_t3d2m') ? // eslint-disable-next-line react-hooks/rules-of-hooks
    (0, $eUqFw.useMemo)(()=>viewResultData?.__typename === 'QueryError' && viewResultData?.extensions?.[0]?.statusCode !== undefined && viewResultData?.extensions?.[0]?.statusCode !== null ? new (0, $7byHA.default)(viewResultData?.extensions?.[0]?.statusCode, viewResultData?.message ?? '') : undefined, [
        viewResultData
    ]) : undefined;
    (0, $eUqFw.useLayoutEffect)(()=>{
        (0, $cWCvn.markOnce)((0, $cWCvn.marks).ISSUE_RESULTS_END);
    }, []);
    const onNavigateToIssue = (0, $eUqFw.useCallback)((issueKey)=>push(`/browse/${issueKey}`), [
        push
    ]);
    const sourceName = selectedView === 'detail' ? (0, $jccNB.ANALYTICS_DETAIL_VIEW_SOURCE_NAME) : (0, $jccNB.ANALYTICS_LIST_VIEW_SOURCE_NAME);
    let ListViewComponent;
    if ((0, $1ybV0.ff)('handle-404-filter-errors-gracefully-in-the-ui-by-showing-filter-not-found-view_t3d2m')) {
        if (!issueResultsData || issueResultsData.issueSearchError?.__typename === 'JiraServerError' || !viewResultData || viewResultData?.__typename === 'QueryError') return isFetching ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $bnzDM.ListViewSkeleton), null) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $clId8.default), {
            error: viewResultError
        });
        ListViewComponent = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4OYZ7.default), {
            loading: isFetching,
            onSelectedRowChange: onSelectedRowChange,
            issueResults: issueResultsData,
            view: viewResultData,
            onChangeColumnConfiguration: onChangeColumnConfiguration,
            isFeedbackButtonDisabled: isFeedbackButtonDisabled,
            issueTableProps: issueTableProps,
            filter: filter
        });
    } else {
        const isFailedIssueSearch = !issueResultsData || issueResultsData.issueSearchError?.__typename === 'JiraServerError' || !viewData;
        if (isFailedIssueSearch) return isFetching ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $bnzDM.ListViewSkeleton), null) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $clId8.default), {
            error: viewResultError
        });
        ListViewComponent = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4OYZ7.default), {
            loading: isFetching,
            onSelectedRowChange: onSelectedRowChange,
            issueResults: issueResultsData,
            view: viewData,
            onChangeColumnConfiguration: onChangeColumnConfiguration,
            isFeedbackButtonDisabled: isFeedbackButtonDisabled,
            issueTableProps: issueTableProps,
            filter: filter
        });
    }
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $idiDE.default), {
        name: "issue-results"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8WuJm.ContextualAnalyticsData), {
        sourceName: sourceName,
        sourceType: (0, $41ea3621645e2acc$export$f636b5b56f1d624a)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $clId8.RecoverableErrorViewBoundary), {
        recoveryProp: isFetching,
        onCaughtIssueSearchError: onCaughtIssueSearchError
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $2ycZm.SortContainer), {
        jql: jql,
        onChangeJql: onChangeJql
    }, selectedView !== 'detail' ? ListViewComponent : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $9w10X.default), {
        loading: isFetching,
        onNavigateToIssue: onNavigateToIssue,
        issueResults: issueResultsData,
        isFeedbackButtonDisabled: isFeedbackButtonDisabled
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $lgxha.default), {
        op: ()=>{
            onCaughtIssueSearchError && onCaughtIssueSearchError(undefined);
        }
    }))));
};
var $685027018ced4552$export$2e2bcd8739ae039 = (0, $kmXw8.withReportErrors)($685027018ced4552$var$IssueResults, {
    id: 'ui.issue-results.unhandled',
    packageName: (0, $jccNB.PACKAGE_NAME),
    teamName: (0, $jccNB.TEAM_NAME),
    sendToPrivacyUnsafeSplunk: true,
    attributes: (0, $1lXFP.isLoaderErrorAttributes)
});

});
parcelRegister("8eeq7", function(module, exports) {

$parcel$export(module.exports, "default", () => $a97ec8efb561a616$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<dd488192ca57a1c58d8c041d0f83e03a>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $a97ec8efb561a616$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "main_issueNavigator_IssueResults_viewResult",
    "selections": [
        {
            "kind": "InlineFragment",
            "selections": [
                {
                    "kind": "FragmentSpread",
                    "name": "main_issueNavigator_ListView_view"
                }
            ],
            "type": "JiraIssueSearchView"
        },
        {
            "kind": "InlineFragment",
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "message"
                },
                {
                    "kind": "LinkedField",
                    "name": "extensions",
                    "plural": true,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "statusCode"
                        }
                    ]
                },
                {
                    "kind": "ScalarField",
                    "name": "__typename"
                }
            ],
            "type": "QueryError"
        }
    ],
    "type": "JiraIssueSearchViewResult",
    "abstractKey": "__isJiraIssueSearchViewResult"
};
$a97ec8efb561a616$var$node.hash = "362ba93c6ea156e17c2f613c7a350a18";
var $a97ec8efb561a616$export$2e2bcd8739ae039 = $a97ec8efb561a616$var$node;

});

parcelRegister("i1TJz", function(module, exports) {

$parcel$export(module.exports, "default", () => $4e807e2553d72746$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<bd6f89d65d09d1c53243ea16d9b03f55>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $4e807e2553d72746$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "main_issueNavigator_IssueResults_view",
    "selections": [
        {
            "kind": "FragmentSpread",
            "name": "main_issueNavigator_ListView_view"
        }
    ],
    "type": "JiraIssueSearchView"
};
$4e807e2553d72746$var$node.hash = "6e530ce64251d4ecc796b64331bee0d5";
var $4e807e2553d72746$export$2e2bcd8739ae039 = $4e807e2553d72746$var$node;

});

parcelRegister("112QR", function(module, exports) {

$parcel$export(module.exports, "default", () => $d21245e866ce8637$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<ab81aec20e5f61a93f15d19e6809fd62>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $d21245e866ce8637$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "main_issueNavigator_IssueResults_issueResults",
    "selections": [
        {
            "kind": "FragmentSpread",
            "name": "main_issueNavigator_ListView_issueResults"
        },
        {
            "kind": "FragmentSpread",
            "name": "main_issueNavigator_DetailView"
        },
        {
            "kind": "LinkedField",
            "name": "issueSearchError",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "__typename"
                }
            ]
        }
    ],
    "type": "JiraIssueConnection"
};
$d21245e866ce8637$var$node.hash = "6f6b389b588e5588c2faec8fc0d850b8";
var $d21245e866ce8637$export$2e2bcd8739ae039 = $d21245e866ce8637$var$node;

});

parcelRegister("bnzDM", function(module, exports) {

$parcel$export(module.exports, "ListViewSkeleton", () => $529f2d925551424b$export$8465c21c33452ecb);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $29WMc = parcelRequire("29WMc");
const $529f2d925551424b$export$8465c21c33452ecb = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($529f2d925551424b$var$StyledListViewContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $29WMc.NativeIssueTableSkeleton), null));
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $529f2d925551424b$var$StyledListViewContainer = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1reo15vq _18m915vq",
            __cmplp.className
        ])
    });
});

});
parcelRegister("29WMc", function(module, exports) {

$parcel$export(module.exports, "NativeIssueTableSkeleton", () => $789c5663e6a91d78$export$309a6db85e3f2aaa);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $7JEyt = parcelRequire("7JEyt");

var $eUqFw = parcelRequire("eUqFw");

var $8ICxF = parcelRequire("8ICxF");

var $9ASBV = parcelRequire("9ASBV");
const $789c5663e6a91d78$var$customCssStyles = null;
const $789c5663e6a91d78$var$containerStyles = {
    height: '448px'
};
const $789c5663e6a91d78$export$309a6db85e3f2aaa = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8ICxF.AppSkeletonImage), {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($9ASBV))),
        containerStyles: $789c5663e6a91d78$var$containerStyles,
        className: (0, $7JEyt.default)([
            "_1wgmglyw"
        ])
    });

});
parcelRegister("9ASBV", function(module, exports) {
module.exports = new URL("native-issue-table-skeleton.tpl.e6209376.svg", import.meta.url).toString();

});



parcelRegister("2ycZm", function(module, exports) {

$parcel$export(module.exports, "SortContainer", () => $c9c41efbbe9f4892$export$f2d9f14f583efb1a);
$parcel$export(module.exports, "useSortFieldAndDirection", () => $c9c41efbbe9f4892$export$951ead8cec7da319);

var $eUqFw = parcelRequire("eUqFw");

var $96gVp = parcelRequire("96gVp");
var $1yZQx = parcelRequire("1yZQx");
var $kEDjj = parcelRequire("kEDjj");

var $gLzLS = parcelRequire("gLzLS");
const $c9c41efbbe9f4892$var$Store = (0, $kEDjj.createStore)({
    initialState: {
        field: 'created',
        direction: 'DESC'
    },
    actions: {
        setField: (field, aliases)=>({ getState: getState, setState: setState }, { onChangeJql: onChangeJql, jql: jql, JqlUtils: JqlUtils })=>{
                const { field: prevField } = getState();
                if (field !== prevField) {
                    setState({
                        field: field
                    });
                    const newJql = JqlUtils?.jql(jql).setPrimarySortField(field, undefined, aliases).toJql();
                    typeof newJql === 'string' && onChangeJql && onChangeJql(newJql);
                }
            },
        setFieldAndDirection: (field, direction, aliases)=>({ getState: getState, setState: setState }, { onChangeJql: onChangeJql, jql: jql, JqlUtils: JqlUtils })=>{
                const { field: prevField, direction: prevDirection } = getState();
                if (field !== prevField || direction !== prevDirection) {
                    setState({
                        field: field,
                        direction: direction
                    });
                    // TODO EM-4079 - remove this and update types once old issue table FF is cleaned up
                    if (direction !== 'NONE') {
                        const newJql = JqlUtils?.jql(jql).setPrimarySortField(field, direction, aliases).toJql();
                        typeof newJql === 'string' && onChangeJql && onChangeJql(newJql);
                    }
                }
            }
    },
    name: 'IssueNavigatorSelectedViewState'
});
const $c9c41efbbe9f4892$export$f4b3414b22b0750b = ()=>({ getState: getState, setState: setState }, { jql: jql, JqlUtils: JqlUtils })=>{
        const field = JqlUtils?.jql(jql).getPrimarySortField();
        const direction = JqlUtils?.jql(jql).getPrimarySortDirection();
        const { field: prevField, direction: prevDirection } = getState();
        if (field !== prevField || direction !== prevDirection) setState({
            field: field,
            direction: direction
        });
    };
const $c9c41efbbe9f4892$export$42a852a2b6b56249 = (0, $96gVp.createContainer)($c9c41efbbe9f4892$var$Store, {
    onInit: $c9c41efbbe9f4892$export$f4b3414b22b0750b,
    onUpdate: $c9c41efbbe9f4892$export$f4b3414b22b0750b
});
const $c9c41efbbe9f4892$export$f2d9f14f583efb1a = (props)=>{
    const Utils = (0, $gLzLS.useJqlUtils)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($c9c41efbbe9f4892$export$42a852a2b6b56249, {
        JqlUtils: Utils,
        ...props
    });
};
const $c9c41efbbe9f4892$export$951ead8cec7da319 = (0, $1yZQx.createHook)($c9c41efbbe9f4892$var$Store, {
    selector: ({ field: field, direction: direction })=>({
            field: field,
            direction: direction
        })
});

});
parcelRegister("gLzLS", function(module, exports) {

$parcel$export(module.exports, "useJqlUtils", () => $38a994a560642a71$export$c7c2706ff288264f);

var $eUqFw = parcelRequire("eUqFw");

const $38a994a560642a71$export$4a178a021cc96ab5 = async ()=>{
    const module = await (parcelRequire("kfGUS"));
    const { JqlUtils: JqlUtils } = module;
    return new JqlUtils();
};
const $38a994a560642a71$export$c7c2706ff288264f = ()=>{
    const [Utils, setUtils] = (0, $eUqFw.useState)();
    const asyncEffect = async ()=>{
        const ResolvedUtils = await $38a994a560642a71$export$4a178a021cc96ab5();
        setUtils(ResolvedUtils);
    };
    (0, $eUqFw.useEffect)(()=>{
        asyncEffect();
    }, []);
    return Utils;
};

});
parcelRegister("kfGUS", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = $d1Cng("ljkkb").then(()=>parcelRequire('36IDP'));

});



parcelRegister("9w10X", function(module, exports) {

$parcel$export(module.exports, "default", () => $b1d4197b9e8007c3$export$2e2bcd8739ae039);

var $c775f = parcelRequire("c775f");

var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $iWLL0 = parcelRequire("iWLL0");

var $b5IAe = parcelRequire("b5IAe");
var $1ZAYh = parcelRequire("1ZAYh");

var $1lXFP = parcelRequire("1lXFP");

var $7JTqr = parcelRequire("7JTqr");

var $d6f6c = parcelRequire("d6f6c");

var $idiDE = parcelRequire("idiDE");

var $jccNB = parcelRequire("jccNB");

var $cIZjs = parcelRequire("cIZjs");

var $kmXw8 = parcelRequire("kmXw8");

var $cWCvn = parcelRequire("cWCvn");

var $jP0l8 = parcelRequire("jP0l8");

var $3Jl0V = parcelRequire("3Jl0V");
const $b1d4197b9e8007c3$var$ConditionalContentContainer = ({ children: children })=>(0, $7JTqr.getWillShowNav4)() ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
        xcss: $b1d4197b9e8007c3$var$ContentContainerStyles
    }, children) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($b1d4197b9e8007c3$var$ContentStyledContainer, null, children);
const $b1d4197b9e8007c3$var$DetailView = ({ IssueApp: IssueApp = (0, $cIZjs.default), issueResults: issueResults, isFeedbackButtonDisabled: isFeedbackButtonDisabled, ...props })=>{
    (0, $cWCvn.markOnce)((0, $cWCvn.marks).ISSUE_RESULTS_DETAIL_VIEW_START);
    (0, $eUqFw.useLayoutEffect)(()=>{
        (0, $cWCvn.markOnce)((0, $cWCvn.marks).ISSUE_RESULTS_DETAIL_VIEW_END);
    }, []);
    const detailViewData = (0, $iWLL0.useFragment)((0, $c775f.default), issueResults);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $idiDE.default), {
        name: "detail-view"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($b1d4197b9e8007c3$var$ConditionalContentContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $jP0l8.default), {
        issueResults: detailViewData,
        isFeedbackButtonDisabled: isFeedbackButtonDisabled
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $3Jl0V.default), {
        fragment: detailViewData,
        ...props
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(IssueApp, {
        isEmbedView: true,
        issueResults: detailViewData
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $d6f6c.FireScreenAnalytics), null)));
};
// re-render regression detection
$b1d4197b9e8007c3$var$DetailView.whyDidYouRender = true;
var $b1d4197b9e8007c3$export$2e2bcd8739ae039 // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
 = (0, $kmXw8.withReportErrors)($b1d4197b9e8007c3$var$DetailView, {
    id: 'ui.issue-results.detail-view.unhandled',
    packageName: (0, $jccNB.PACKAGE_NAME),
    teamName: (0, $jccNB.TEAM_NAME),
    sendToPrivacyUnsafeSplunk: true,
    attributes: (0, $1lXFP.isLoaderErrorAttributes)
});
const $b1d4197b9e8007c3$var$ContentStyledContainer = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _4t3i1osq _16jlkb7n _1reo15vq _18m915vq",
            __cmplp.className
        ])
    });
});
const $b1d4197b9e8007c3$var$ContentContainerStyles = (0, $1ZAYh.xcss)({
    display: 'flex',
    height: '100%',
    flexGrow: 1,
    overflow: 'hidden',
    flexBasis: 0
});

});
parcelRegister("c775f", function(module, exports) {

$parcel$export(module.exports, "default", () => $845d90eaaaf7ceeb$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<11fe4bc47636ae9b25c10a6a88812a6f>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $845d90eaaaf7ceeb$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "main_issueNavigator_DetailView",
    "selections": [
        {
            "kind": "FragmentSpread",
            "name": "main_issueNavigator_CardList"
        },
        {
            "kind": "FragmentSpread",
            "name": "cardContainer_issueNavigator"
        },
        {
            "kind": "FragmentSpread",
            "name": "main_issueNavigator_IssueAppWithData"
        }
    ],
    "type": "JiraIssueConnection"
};
$845d90eaaaf7ceeb$var$node.hash = "da0812b0d182da0fa9208b1de105024f";
var $845d90eaaaf7ceeb$export$2e2bcd8739ae039 = $845d90eaaaf7ceeb$var$node;

});

parcelRegister("jP0l8", function(module, exports) {

$parcel$export(module.exports, "default", () => $7e206e729eacf0d8$export$2e2bcd8739ae039);

var $dCq8X = parcelRequire("dCq8X");

var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $iWLL0 = parcelRequire("iWLL0");

var $eI5EY = parcelRequire("eI5EY");

var $iWDmo = parcelRequire("iWDmo");

var $g6NWY = parcelRequire("g6NWY");

var $9DxNr = parcelRequire("9DxNr");

var $kxyTJ = parcelRequire("kxyTJ");

var $4bsMQ = parcelRequire("4bsMQ");
const $7e206e729eacf0d8$var$CardContainer = ({ OrderDropdown: OrderDropdown, SortButton: SortButton, children: children, issueResults: issueResults, isFeedbackButtonDisabled: isFeedbackButtonDisabled })=>{
    const data = (0, $iWLL0.useFragment)((0, $dCq8X.default), issueResults);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($7e206e729eacf0d8$var$StyledContainer, {
        "data-testid": "issue-navigator.ui.issue-results.detail-view.card-container.styled-container"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($7e206e729eacf0d8$var$HeaderStyledContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(OrderDropdown, null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(SortButton, null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $g6NWY.default), null)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($7e206e729eacf0d8$var$CardListStyledContainer, null, children), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($7e206e729eacf0d8$var$FooterStyledContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $kxyTJ.default), {
        issueResults: data
    })), !(0, $eI5EY.fg)('jira_spreadsheet_component_m1_api_updates') && !isFeedbackButtonDisabled && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($7e206e729eacf0d8$var$FeedbackWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $iWDmo.default), null))));
};
$7e206e729eacf0d8$var$CardContainer.defaultProps = {
    OrderDropdown: (0, $9DxNr.default),
    SortButton: (0, $4bsMQ.default)
};
var $7e206e729eacf0d8$export$2e2bcd8739ae039 // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
 = $7e206e729eacf0d8$var$CardContainer;
const $7e206e729eacf0d8$var$StyledContainer = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _2lx21bp4 _2rko1y44 _bfhk1s4m _1yt4v77o _otyru2gc _2hwxpxbi _1ul91k99 _p12f1k99",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $7e206e729eacf0d8$var$CardListStyledContainer = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1reo1wug _18m91wug _16jlkb7n _1o9zkb7n _i0dl1kxc",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $7e206e729eacf0d8$var$HeaderStyledContainer = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _16jlkb7n _1o9zidpf _4t3izwfg _n3tdv77o _zulp1b66",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $7e206e729eacf0d8$var$FooterStyledContainer = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _4cvr1h6o _1yt4sb0y _1bah1h6o",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $7e206e729eacf0d8$var$FeedbackWrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_bfhkvuon _1bsbu6a3 _ca0qpxbi _n3tdv77o _1e0c1txw _1bah1h6o _19pkidpf _otyrx0bf _18u0x0bf _2hwxx0bf",
            __cmplp.className
        ])
    });
});

});
parcelRegister("dCq8X", function(module, exports) {

$parcel$export(module.exports, "default", () => $b04e5009bd1e5050$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<39b9b6eadc1c9787774f142b4f7d9df9>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $b04e5009bd1e5050$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "cardContainer_issueNavigator",
    "selections": [
        {
            "kind": "FragmentSpread",
            "name": "main_issueNavigator_Paginator"
        }
    ],
    "type": "JiraIssueConnection"
};
$b04e5009bd1e5050$var$node.hash = "fca6b24420a589562ac27147066c1572";
var $b04e5009bd1e5050$export$2e2bcd8739ae039 = $b04e5009bd1e5050$var$node;

});

parcelRegister("iWDmo", function(module, exports) {

$parcel$export(module.exports, "default", () => $3b1a6fead981b646$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $b5IAe = parcelRequire("b5IAe");
var $1zbEq = parcelRequire("1zbEq");
var $1Yimi = parcelRequire("1Yimi");
var $1ZAYh = parcelRequire("1ZAYh");

var $1c02D = parcelRequire("1c02D");
var $bCwLs = parcelRequire("bCwLs");

var $5JgJ2 = parcelRequire("5JgJ2");

var $9Anw5 = parcelRequire("9Anw5");

var $hWc1w = parcelRequire("hWc1w");
const $3b1a6fead981b646$var$FEEDBACK_GROUP_ID = 'issue-navigator';
const $3b1a6fead981b646$var$FeedbackTitleDetails = ()=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
        xcss: $3b1a6fead981b646$var$feedbackTitleDetailsContainerStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1zbEq.default), {
        space: "space.150"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1Yimi.default), {
        as: "p"
    }, formatMessage((0, $hWc1w.default).feedbackTitleDetails)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1Yimi.default), {
        as: "p"
    }, formatMessage((0, $hWc1w.default).feedbackTitleDetailsContactSupport))));
};
const $3b1a6fead981b646$var$Feedback = ()=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const feedbackContext = [
        {
            id: (0, $1c02D.EntryKeys).LOCATION,
            value: (0, $9Anw5.default)(window?.location?.href ?? '')
        },
        {
            id: (0, $1c02D.EntryKeys).SCREEN_RESOLUTION,
            value: `${window?.screen?.width ?? 'unknown'} x ${window?.screen?.height ?? 'unknown'}`
        },
        {
            id: (0, $1c02D.EntryKeys).USER_AGENT,
            value: window?.navigator?.userAgent ?? 'unknown'
        }
    ];
    const feedbackGroupLabels = {
        // Custom dropdown placeholder
        empty: {
            selectOptionLabel: formatMessage((0, $hWc1w.default).feedbackTypePlaceholder)
        },
        // Use default labels for other options
        bug: {},
        comment: {},
        suggestion: {},
        question: {}
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $bCwLs.FeedbackCollectorButton), {
        testId: "issue-navigator.common.ui.feedback.feedback-button",
        entrypointId: (0, $1c02D.ENTRYPOINT_ID_JIRA_PLATFORM),
        feedbackGroupId: $3b1a6fead981b646$var$FEEDBACK_GROUP_ID,
        feedbackTitle: formatMessage((0, $hWc1w.default).feedbackTitle),
        feedbackTitleDetails: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($3b1a6fead981b646$var$FeedbackTitleDetails, null),
        feedbackContext: feedbackContext,
        feedbackGroupLabels: feedbackGroupLabels
    });
};
var $3b1a6fead981b646$export$2e2bcd8739ae039 = $3b1a6fead981b646$var$Feedback;
const $3b1a6fead981b646$var$feedbackTitleDetailsContainerStyles = (0, $1ZAYh.xcss)({
    marginBottom: 'space.300'
});

});
parcelRegister("bCwLs", function(module, exports) {

$parcel$export(module.exports, "FeedbackCollectorButton", () => $096795107747cbd5$export$b39479f42d974760);

var $eUqFw = parcelRequire("eUqFw");

var $c5IEJ = parcelRequire("c5IEJ");

var $8cU5f = parcelRequire("8cU5f");

var $bAQOb = parcelRequire("bAQOb");

var $5JgJ2 = parcelRequire("5JgJ2");

var $dWLk9 = parcelRequire("dWLk9");

var $1c02D = parcelRequire("1c02D");

var $irg9D = parcelRequire("irg9D");

var $k74dc = parcelRequire("k74dc");

var $3liet = parcelRequire("3liet");
const $096795107747cbd5$var$TooltipWrapper = ({ children: children, appearance: appearance, customLabel: customLabel })=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    if (appearance === 'icon') return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8cU5f.default), {
        content: customLabel || formatMessage((0, $k74dc.messages).leaveFeedback),
        position: "top"
    }, children);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, children);
};
const $096795107747cbd5$export$941c5fcac2e843ea = ({ buttonAppearance: buttonAppearance = 'normal', testId: testId, icon: Icon = (0, (/*@__PURE__*/$parcel$interopDefault($c5IEJ))), feedbackButtonCustomLabel: feedbackButtonCustomLabel, ...feedbackCollectorProps })=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const { openFeedbackCollector: openFeedbackCollector } = (0, $irg9D.useFeedbackCollectorActions)();
    const buttonRef = (0, $eUqFw.useRef)(null);
    const onOpen = (0, $eUqFw.useCallback)(()=>openFeedbackCollector({
            ...feedbackCollectorProps,
            triggerRef: buttonRef
        }), [
        feedbackCollectorProps,
        openFeedbackCollector
    ]);
    const displayAsLink = buttonAppearance === 'link';
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($096795107747cbd5$var$TooltipWrapper, {
        appearance: buttonAppearance,
        customLabel: feedbackButtonCustomLabel
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $3liet.StyledButton), {
        testId: testId,
        ref: buttonRef,
        appearance: displayAsLink ? 'link' : 'subtle',
        isHighlight: buttonAppearance === 'highlight',
        spacing: displayAsLink ? 'none' : 'default',
        onClick: onOpen,
        iconBefore: displayAsLink ? undefined : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(Icon, {
            // typesupression below can be removed once icon migration completes
            // @ts-expect-error Property 'color' does not exist on type 'IntrinsicAttributes & IconProps'.ts(2322)
            color: buttonAppearance === 'highlight' ? "var(--ds-text-discovery, #5E4DB2)" : "var(--ds-text, #172B4D)",
            label: ""
        }),
        "aria-label": feedbackButtonCustomLabel || formatMessage((0, $k74dc.messages).leaveFeedback)
    }, buttonAppearance !== 'icon' && (feedbackButtonCustomLabel || formatMessage((0, $k74dc.messages).leaveFeedback))));
};
const $096795107747cbd5$var$FeedbackCollectorButtonNew = ({ buttonAppearance: buttonAppearance = 'normal', testId: testId, icon: Icon = (0, (/*@__PURE__*/$parcel$interopDefault($c5IEJ))), feedbackButtonCustomLabel: feedbackButtonCustomLabel, ...feedbackCollectorProps })=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const cloudId = (0, $dWLk9.useCloudId)();
    const { openFeedbackCollector: openFeedbackCollector } = (0, $irg9D.useFeedbackCollectorActions)();
    const buttonRef = (0, $eUqFw.useRef)(null);
    const onOpen = (0, $eUqFw.useCallback)(()=>{
        // Check if feedbackContext already contains the cloud ID entry
        const hasCloudId = feedbackCollectorProps?.feedbackContext?.some((entry)=>entry.id === (0, $1c02D.EntryKeys).CLOUD_ID);
        // If not, add cloud id to feedback context
        const updatedFeedbackContext = hasCloudId ? feedbackCollectorProps.feedbackContext : [
            ...feedbackCollectorProps.feedbackContext || [],
            {
                id: (0, $1c02D.EntryKeys).CLOUD_ID,
                value: cloudId
            }
        ];
        openFeedbackCollector({
            ...feedbackCollectorProps,
            feedbackContext: updatedFeedbackContext,
            triggerRef: buttonRef
        });
    }, [
        cloudId,
        feedbackCollectorProps,
        openFeedbackCollector
    ]);
    const displayAsLink = buttonAppearance === 'link';
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($096795107747cbd5$var$TooltipWrapper, {
        appearance: buttonAppearance,
        customLabel: feedbackButtonCustomLabel
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $3liet.StyledButton), {
        testId: testId,
        ref: buttonRef,
        appearance: displayAsLink ? 'link' : 'subtle',
        isHighlight: buttonAppearance === 'highlight',
        spacing: displayAsLink ? 'none' : 'default',
        onClick: onOpen,
        iconBefore: displayAsLink ? undefined : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(Icon, {
            // typesupression below can be removed once icon migration completes
            // @ts-expect-error Property 'color' does not exist on type 'IntrinsicAttributes & IconProps'.ts(2322)
            color: buttonAppearance === 'highlight' ? "var(--ds-text-discovery, #5E4DB2)" : "var(--ds-text, #172B4D)",
            label: ""
        }),
        "aria-label": feedbackButtonCustomLabel || formatMessage((0, $k74dc.messages).leaveFeedback)
    }, buttonAppearance !== 'icon' && (feedbackButtonCustomLabel || formatMessage((0, $k74dc.messages).leaveFeedback))));
};
const $096795107747cbd5$export$b39479f42d974760 = (0, $bAQOb.componentWithFF)('jff.magma.passing-cloudid-in-feedback-button_hif5t', $096795107747cbd5$var$FeedbackCollectorButtonNew, $096795107747cbd5$export$941c5fcac2e843ea);

});
parcelRegister("c5IEJ", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::e7d055c0ed79a3d2d02defbb3dab01bd>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $8cd8976d9d4f34ae$var$_react = $8cd8976d9d4f34ae$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $8cd8976d9d4f34ae$var$_feedback = $8cd8976d9d4f34ae$var$_interopRequireDefault((parcelRequire("3kIcQ")));

var $8cd8976d9d4f34ae$var$_feedback2 = $8cd8976d9d4f34ae$var$_interopRequireDefault((parcelRequire("l2ZYW")));
function $8cd8976d9d4f34ae$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 *
 * Migration Icon component for FeedbackIcon.
 * This component is FeedbackIcon, with `UNSAFE_fallbackIcon` set to "FeedbackIcon".
 *
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Known uses: customer feedback.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $8cd8976d9d4f34ae$var$FeedbackIcon = (props)=>/*#__PURE__*/ $8cd8976d9d4f34ae$var$_react.default.createElement($8cd8976d9d4f34ae$var$_feedback.default, Object.assign({
        LEGACY_fallbackIcon: $8cd8976d9d4f34ae$var$_feedback2.default
    }, props));
$8cd8976d9d4f34ae$var$FeedbackIcon.Name = 'FeedbackIconMigration';
var $8cd8976d9d4f34ae$var$_default = module.exports.default = $8cd8976d9d4f34ae$var$FeedbackIcon;

});
parcelRegister("3kIcQ", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::2fdc79421e640da36581eab376b367cc>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $26d587cb75b7e288$var$_react = $26d587cb75b7e288$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $26d587cb75b7e288$var$_UNSAFE_baseNew = $26d587cb75b7e288$var$_interopRequireDefault((parcelRequire("gCIXy")));
function $26d587cb75b7e288$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 * Please reach out in #icon-contributions before using these in production.
 *
 * Icon: "Feedback".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Known uses: customer feedback.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $26d587cb75b7e288$var$FeedbackIcon = (props)=>/*#__PURE__*/ $26d587cb75b7e288$var$_react.default.createElement($26d587cb75b7e288$var$_UNSAFE_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path stroke="currentcolor" stroke-linejoin="round" stroke-width="1.5" d="M10.25 7H3c-.69 0-1.25-.56-1.25-1.25V3c0-.69.56-1.25 1.25-1.25h10c.69 0 1.25.56 1.25 1.25v8c0 .69-.56 1.25-1.25 1.25H6L1.75 15V9.5"/><path stroke="currentcolor" stroke-linejoin="round" stroke-width="1.5" d="m7.75 4.5 2.5 2.5-2.5 2.5"/>`
    }, props));
$26d587cb75b7e288$var$FeedbackIcon.displayName = 'FeedbackIcon';
var $26d587cb75b7e288$var$_default = module.exports.default = $26d587cb75b7e288$var$FeedbackIcon;

});

parcelRegister("l2ZYW", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $f529dd351378d429$var$_react = $f529dd351378d429$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $igPbh = parcelRequire("igPbh");

var $f529dd351378d429$var$_feedback = $f529dd351378d429$var$_interopRequireDefault((parcelRequire("3kIcQ")));
function $f529dd351378d429$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
const $f529dd351378d429$var$FeedbackIcon = (props)=>/*#__PURE__*/ $f529dd351378d429$var$_react.default.createElement($igPbh.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="m10.88 5.48-8.43 6.83c-.4.32-.58.96-.41 1.42l.1.27c.17.46.73.83 1.23.82l1.13-.02 6.06-.1 3.65-.06c.51-.01.79-.38.62-.86l-2.92-8.03c-.1-.29-.32-.44-.57-.44a.73.73 0 0 0-.46.18m-5.9 10.46 1.75 4.82a1 1 0 1 0 1.88-.68l-1.54-4.23zm13.71-9.11-2.82 1.03a1 1 0 1 0 .68 1.88l2.82-1.03a1 1 0 1 0-.68-1.88m-1.79 3.85a1 1 0 0 0-.64.77 1 1 0 0 0 .81 1.16l2.96.52a1 1 0 0 0 1.12-1.3l-.02-.05a1 1 0 0 0-.76-.62l-2.95-.52a.97.97 0 0 0-.51.05m-.56-7.65-1.93 2.3a1 1 0 0 0 1.53 1.29l1.93-2.3a1 1 0 0 0-.76-1.64 1 1 0 0 0-.77.36"/></svg>`
    }, props, {
        newIcon: $f529dd351378d429$var$_feedback.default
    }));
$f529dd351378d429$var$FeedbackIcon.displayName = 'FeedbackIcon';
var $f529dd351378d429$var$_default = module.exports.default = $f529dd351378d429$var$FeedbackIcon;

});


parcelRegister("k74dc", function(module, exports) {

$parcel$export(module.exports, "messages", () => $a622284001ff525a$export$defe85febe8b728c);

var $90IgZ = parcelRequire("90IgZ");
const $a622284001ff525a$export$defe85febe8b728c = (0, $90IgZ.defineMessages)({
    leaveFeedback: {
        "id": "platform.feedback.feedback-collector.button.leave-feedback",
        "defaultMessage": "Give feedback"
    }
});

});

parcelRegister("3liet", function(module, exports) {

$parcel$export(module.exports, "StyledButton", () => $37102939becff71f$export$2d5d2ba3c7c8c40b);
/* styled.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $7u4fN = parcelRequire("7u4fN");
const $37102939becff71f$export$2d5d2ba3c7c8c40b = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = (0, $7u4fN.default), style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $eUqFw.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "",
            __cmplp.isHighlight && "_1w901gqr _16hg1y1p _1fh11gqr _u1mb1hhp _1l5a1gfe _r7sm8kjj",
            __cmplp.className
        ])
    });
});

});


parcelRegister("hWc1w", function(module, exports) {

$parcel$export(module.exports, "default", () => $aefdab523271fd9d$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
const $aefdab523271fd9d$var$messages = (0, $90IgZ.defineMessages)({
    feedbackTitle: {
        "id": "issue-navigator.common.feedback.feedback-title",
        "defaultMessage": "Give feedback for issue search"
    },
    feedbackTitleDetails: {
        "id": "issue-navigator.common.feedback.feedback-title-details",
        "defaultMessage": "Let us know how we can improve this experience."
    },
    feedbackTitleDetailsContactSupport: {
        "id": "issue-navigator.common.feedback.feedback-title-details-contact-support",
        "defaultMessage": "If you\u2019re having technical issues, contact our support team."
    },
    feedbackTypePlaceholder: {
        "id": "issue-navigator.common.feedback.feedback-type-placeholder",
        "defaultMessage": "Select an option"
    }
});
var $aefdab523271fd9d$export$2e2bcd8739ae039 = $aefdab523271fd9d$var$messages;

});


parcelRegister("g6NWY", function(module, exports) {

$parcel$export(module.exports, "default", () => $e50e514201b34112$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $j9fWg = parcelRequire("j9fWg");

var $4saW1 = parcelRequire("4saW1");

var $5JgJ2 = parcelRequire("5JgJ2");

var $jMP2a = parcelRequire("jMP2a");

var $cQBUE = parcelRequire("cQBUE");

var $9ZmUP = parcelRequire("9ZmUP");
const $e50e514201b34112$var$RefreshButton = ()=>{
    const { isRefreshing: isRefreshing, onIssueSearchRefresh: onIssueSearchRefresh } = (0, $cQBUE.useIssueSearchQuery)();
    const handleClick = (0, $eUqFw.useCallback)((_, analyticsEvent)=>{
        (0, $jMP2a.fireUIAnalytics)(analyticsEvent, 'reloadIssueListButton');
        onIssueSearchRefresh();
    }, [
        onIssueSearchRefresh
    ]);
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $j9fWg.default), {
        appearance: "subtle",
        onClick: handleClick,
        testId: "issue-navigator.common.ui.refresh-button.refresh-button",
        label: formatMessage((0, $9ZmUP.default).tooltip),
        icon: (iconProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($4saW1))), {
                ...iconProps,
                color: "var(--ds-icon-subtle, #626F86)",
                LEGACY_size: "small",
                LEGACY_primaryColor: "color.icon.subtle"
            }),
        isLoading: isRefreshing
    });
};
var $e50e514201b34112$export$2e2bcd8739ae039 = $e50e514201b34112$var$RefreshButton;

});
parcelRegister("4saW1", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::b8e9594b07ce2b8f61029d47660b77d1>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $33e2425da66355e2$var$_react = $33e2425da66355e2$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $33e2425da66355e2$var$_refresh = $33e2425da66355e2$var$_interopRequireDefault((parcelRequire("h1qCH")));

var $33e2425da66355e2$var$_refresh2 = $33e2425da66355e2$var$_interopRequireDefault((parcelRequire("iPlKJ")));
function $33e2425da66355e2$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 *
 * Migration Icon component for RefreshIcon.
 * This component is RefreshIcon, with `UNSAFE_fallbackIcon` set to "RefreshIcon".
 *
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for expanding a object or panel.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $33e2425da66355e2$var$RefreshIcon = (props)=>/*#__PURE__*/ $33e2425da66355e2$var$_react.default.createElement($33e2425da66355e2$var$_refresh.default, Object.assign({
        LEGACY_fallbackIcon: $33e2425da66355e2$var$_refresh2.default
    }, props));
$33e2425da66355e2$var$RefreshIcon.Name = 'RefreshIconMigration';
var $33e2425da66355e2$var$_default = module.exports.default = $33e2425da66355e2$var$RefreshIcon;

});
parcelRegister("h1qCH", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::3f2ad7090034de3781bb0efd8604a739>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $c6472e7a17144be6$var$_react = $c6472e7a17144be6$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $c6472e7a17144be6$var$_UNSAFE_baseNew = $c6472e7a17144be6$var$_interopRequireDefault((parcelRequire("gCIXy")));
function $c6472e7a17144be6$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 * Please reach out in #icon-contributions before using these in production.
 *
 * Icon: "Refresh".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for expanding a object or panel.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $c6472e7a17144be6$var$RefreshIcon = (props)=>/*#__PURE__*/ $c6472e7a17144be6$var$_react.default.createElement($c6472e7a17144be6$var$_UNSAFE_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path stroke="currentcolor" stroke-linejoin="round" stroke-width="1.5" d="M6.25 1.75V6m0-4.25H2m4.25 0c-1.5 1.5-4.5 3-4.5 6.75 0 3.284 2.532 5.476 5.75 5.73m2.25 0V9.98m0 4.25H14m-4.25 0c1.5-1.5 4.5-3 4.5-6.75 0-3.283-2.532-5.475-5.75-5.73"/>`
    }, props));
$c6472e7a17144be6$var$RefreshIcon.displayName = 'RefreshIcon';
var $c6472e7a17144be6$var$_default = module.exports.default = $c6472e7a17144be6$var$RefreshIcon;

});

parcelRegister("iPlKJ", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $db4ddd0d819bf555$var$_react = $db4ddd0d819bf555$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $igPbh = parcelRequire("igPbh");

var $db4ddd0d819bf555$var$_refresh = $db4ddd0d819bf555$var$_interopRequireDefault((parcelRequire("h1qCH")));
function $db4ddd0d819bf555$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
const $db4ddd0d819bf555$var$RefreshIcon = (props)=>/*#__PURE__*/ $db4ddd0d819bf555$var$_react.default.createElement($igPbh.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill="currentcolor" fill-rule="evenodd"><path fill-rule="nonzero" d="M8 6.003v2.995a1 1 0 1 0 2 0V5.102C10 4.494 9.507 4 8.9 4H5a1 1 0 0 0 0 2.003z"/><path fill-rule="nonzero" d="M9.428 18.018C7.351 16.989 6 14.807 6 12.37c0-2.266 1.167-4.319 3.02-5.425.48-.286.646-.922.371-1.421a.98.98 0 0 0-1.364-.386C5.557 6.611 4 9.35 4 12.37c0 3.248 1.802 6.158 4.57 7.529.498.247 1.095.026 1.332-.493.237-.52.025-1.141-.474-1.388"/><path d="M14 15.002v3.896c0 .608.493 1.102 1.1 1.102H19a1 1 0 0 0 0-2.003h-3v-2.995a1 1 0 1 0-2 0"/><path d="M14.097 4.596c-.237.52-.025 1.14.474 1.387 2.077 1.029 3.428 3.21 3.428 5.647 0 2.266-1.167 4.32-3.021 5.425a1.063 1.063 0 0 0-.37 1.42c.274.5.885.673 1.364.387 2.47-1.473 4.027-4.212 4.027-7.232 0-3.248-1.802-6.158-4.57-7.528A.96.96 0 0 0 15.002 4a1 1 0 0 0-.905.596"/></g></svg>`
    }, props, {
        newIcon: $db4ddd0d819bf555$var$_refresh.default
    }));
$db4ddd0d819bf555$var$RefreshIcon.displayName = 'RefreshIcon';
var $db4ddd0d819bf555$var$_default = module.exports.default = $db4ddd0d819bf555$var$RefreshIcon;

});


parcelRegister("9ZmUP", function(module, exports) {

$parcel$export(module.exports, "default", () => $87bbaa605c3e53c3$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var /* eslint-disable jira/i18n/id-named-by-package */ // TODO - Port i18n string translations to new module ID keys
$87bbaa605c3e53c3$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    tooltip: {
        "id": "issue-navigator.refresh-button.tooltip",
        "defaultMessage": "Refresh"
    },
    loading: {
        "id": "issue-navigator.refresh-button.loading",
        "defaultMessage": "Loading"
    }
});

});


parcelRegister("9DxNr", function(module, exports) {

$parcel$export(module.exports, "default", () => $708e6757af50f17c$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $jG2Eu = parcelRequire("jG2Eu");

var $7u4fN = parcelRequire("7u4fN");

var $6OfWd = parcelRequire("6OfWd");
var $lmeyI = parcelRequire("lmeyI");
var $hIuJI = parcelRequire("hIuJI");

var $86Ndv = parcelRequire("86Ndv");

var $eGI9v = parcelRequire("eGI9v");

var $4ksts = parcelRequire("4ksts");

var $jMP2a = parcelRequire("jMP2a");
var $bFzGY = parcelRequire("bFzGY");

var $jccNB = parcelRequire("jccNB");

var $3wKQY = parcelRequire("3wKQY");

var $eNjET = parcelRequire("eNjET");

var $2ycZm = parcelRequire("2ycZm");

var $7aM56 = parcelRequire("7aM56");
const $708e6757af50f17c$export$e813e910f52c9aab = {
    appearance: 'subtle',
    'data-testid': 'issue-navigator.ui.issue-results.detail-view.card-container.order-dropdown.button'
};
const $708e6757af50f17c$var$customFieldIdPattern = /^cf\[\d+\]$/;
const $708e6757af50f17c$var$DropdownItemRadioWithAnalytics = (0, $eGI9v.default)('dropdownItemRadio', {
    onClick: 'clicked'
})((0, $lmeyI.default));
class $708e6757af50f17c$export$50f2c227513bcdb7 extends (0, $eUqFw.Component) {
    static{
        this.defaultProps = {
            onChange: (0, (/*@__PURE__*/$parcel$interopDefault($jG2Eu))),
            onFocus: (0, (/*@__PURE__*/$parcel$interopDefault($jG2Eu))),
            onBlur: (0, (/*@__PURE__*/$parcel$interopDefault($jG2Eu)))
        };
    }
    onItemClick(order, aliases) {
        const { onChange: onChange, onBlur: onBlur } = this.props;
        onChange(order, aliases);
        onBlur();
    }
    renderItems() {
        const { intl: { formatMessage: formatMessage }, orderField: orderField } = this.props;
        return Object.values((0, $jccNB.supportedOrderFields)).filter((0, $3wKQY.isNonNullish)).map(({ jqlTerm: jqlTerm, aliases: aliases })=>{
            const messageDescriptor = (0, $7aM56.messageLookup)[jqlTerm];
            const fieldName = messageDescriptor ? formatMessage(messageDescriptor) : jqlTerm;
            const props = {
                id: jqlTerm,
                onClick: ()=>{
                    this.onItemClick(jqlTerm, aliases);
                },
                isSelected: jqlTerm === orderField || orderField && aliases.includes(orderField)
            };
            return /* @ts-expect-error - Type '{ children: string; id: string; onClick: () => void; isSelected: boolean | "" | undefined; key: string; }' is not assignable to type 'Omit<{ children: ReactNode; description?: string | Element | undefined; isDisabled?: boolean | undefined; shouldTitleWrap?: boolean | undefined; shouldDescriptionWrap?: boolean | undefined; ... 5 more ...; testId?: string | undefined; }, keyof WithAnalyticsEventsProps>'. */ /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($708e6757af50f17c$var$DropdownItemRadioWithAnalytics, {
                key: jqlTerm,
                ...props
            }, fieldName);
        });
    }
    render() {
        const { intl: { formatMessage: formatMessage }, orderField: orderField, isOpen: isOpen, className: className } = this.props;
        let fallbackMessage = '';
        let fieldName = '';
        if (typeof orderField === 'string') {
            const isCustomFieldId = $708e6757af50f17c$var$customFieldIdPattern.test(orderField);
            const expectedOrderField = (0, $jccNB.supportedOrderFields)[(0, $jccNB.getSupportedFieldForAlias)(orderField) ?? orderField];
            const fallbackMessageDescriptor = expectedOrderField ? (0, $7aM56.messageLookup)[expectedOrderField.jqlTerm] : null;
            if (isCustomFieldId) fallbackMessage = formatMessage((0, $7aM56.default).customField);
            else if (expectedOrderField && fallbackMessageDescriptor) fallbackMessage = formatMessage(fallbackMessageDescriptor);
            else fieldName = orderField;
        } else fallbackMessage = formatMessage((0, $7aM56.default).defaultLabel);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($708e6757af50f17c$var$StyledContainer, {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
            className: className
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $6OfWd.default), {
            isOpen: isOpen,
            onOpenChange: this.onOpenChange,
            testId: "issue-navigator.ui.issue-results.detail-view.card-container.order-dropdown",
            trigger: ({ triggerRef: triggerRef, ...props })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($708e6757af50f17c$var$StyledButtonContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7u4fN.default), {
                    ...props,
                    appearance: "subtle",
                    ref: triggerRef,
                    iconAfter: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($86Ndv))), {
                        label: formatMessage((0, $7aM56.default).defaultLabel)
                    })
                }, fieldName || fallbackMessage)),
            shouldFlip: true,
            placement: "bottom-start"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($708e6757af50f17c$var$StyledDropdownMenuContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $hIuJI.default), {
            id: "sort-field-group",
            title: formatMessage((0, $7aM56.default).fieldGroup)
        }, this.renderItems()))));
    }
    constructor(...args){
        super(...args);
        this.onOpenChange = ({ isOpen: isOpen } = {
            isOpen: false
        })=>{
            if (isOpen) this.props.onFocus();
            else this.props.onBlur();
        };
    }
}
const $708e6757af50f17c$export$f6d8103ec9453c7f = ()=>{
    const [{ isOpen: isOpen }, { open: open, close: close }] = (0, $eNjET.useOrderByOpenState)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bFzGY.useAnalyticsEvents)();
    const intl = (0, $4ksts.useIntlV2)();
    const [{ field: field, direction: direction }, { setFieldAndDirection: setFieldAndDirection }] = (0, $2ycZm.useSortFieldAndDirection)();
    const handleOnChange = (0, $eUqFw.useCallback)((orderField, aliases)=>{
        setFieldAndDirection(orderField, direction, aliases);
        const analyticsEvent = createAnalyticsEvent({
            action: 'clicked',
            actionSubject: 'dropdownItemRadio'
        });
        const { fieldType: fieldType = null } = (0, $jccNB.supportedOrderFields)[(0, $jccNB.getSupportedFieldForAlias)(orderField) ?? orderField] ?? {};
        (0, $jMP2a.fireUIAnalytics)(analyticsEvent, 'sortFieldDropdownItemRadio', {
            fieldType: fieldType,
            order: direction
        });
    }, [
        createAnalyticsEvent,
        direction,
        setFieldAndDirection
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($708e6757af50f17c$export$50f2c227513bcdb7, {
        orderField: field,
        onChange: handleOnChange,
        isOpen: isOpen,
        onFocus: open,
        onBlur: close,
        intl: intl
    });
};
var $708e6757af50f17c$export$2e2bcd8739ae039 // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
 = $708e6757af50f17c$export$f6d8103ec9453c7f;
const $708e6757af50f17c$var$StyledButtonContainer = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1s3g12gs",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $708e6757af50f17c$var$StyledDropdownMenuContainer = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_4t3inklw",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $708e6757af50f17c$var$StyledContainer = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_16jlkb7n _1reo15vq _18m915vq",
            __cmplp.className
        ])
    });
});

});
parcelRegister("6OfWd", function(module, exports) {

$parcel$export(module.exports, "default", () => $cd131b446ad30d0e$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $74BVL = parcelRequire("74BVL");

var $6zOB7 = parcelRequire("6zOB7");


var $1lQG9 = parcelRequire("1lQG9");

var $5Q9wj = parcelRequire("5Q9wj");

var $2WwAS = parcelRequire("2WwAS");

var $7PTrT = parcelRequire("7PTrT");

var $86Ndv = parcelRequire("86Ndv");

var $3MV1G = parcelRequire("3MV1G");

var $lcnyw = parcelRequire("lcnyw");

var $dkYal = parcelRequire("dkYal");

var $jiH6M = parcelRequire("jiH6M");

var $epS3S = parcelRequire("epS3S");

var $7mYCs = parcelRequire("7mYCs");

var $h1Q9j = parcelRequire("h1Q9j");

var $8gwL5 = parcelRequire("8gwL5");
const $cd131b446ad30d0e$var$gridSize = (0, $lcnyw.gridSize)();
const $cd131b446ad30d0e$var$MAX_HEIGHT = `calc(100vh - ${$cd131b446ad30d0e$var$gridSize * 2}px)`;
const $cd131b446ad30d0e$var$opposites = {
    top: 'bottom',
    bottom: 'top',
    left: 'right',
    right: 'left',
    start: 'end',
    auto: 'auto',
    end: 'start'
};
const $cd131b446ad30d0e$var$getFallbackPlacements = (placement)=>{
    const placementPieces = placement.split('-');
    const mainAxis = placementPieces[0];
    // Left, right and auto placements can rely on standard popper sliding behaviour
    if (![
        'top',
        'bottom'
    ].includes(mainAxis)) return undefined;
    else if (placementPieces.length === 2 && [
        'start',
        'end'
    ].includes(placementPieces[1])) {
        const crossAxis = placementPieces[1];
        return [
            `${mainAxis}`,
            `${mainAxis}-${$cd131b446ad30d0e$var$opposites[crossAxis]}`,
            `${$cd131b446ad30d0e$var$opposites[mainAxis]}-${crossAxis}`,
            `${$cd131b446ad30d0e$var$opposites[mainAxis]}`,
            `${$cd131b446ad30d0e$var$opposites[mainAxis]}-${$cd131b446ad30d0e$var$opposites[crossAxis]}`,
            'auto'
        ];
    } else return [
        `${mainAxis}-start`,
        `${mainAxis}-end`,
        `${$cd131b446ad30d0e$var$opposites[mainAxis]}`,
        `${$cd131b446ad30d0e$var$opposites[mainAxis]}-start`,
        `${$cd131b446ad30d0e$var$opposites[mainAxis]}-end`,
        `auto`
    ];
};
/**
 * __Dropdown menu__
 *
 * A dropdown menu displays a list of actions or options to a user.
 *
 * - [Examples](https://atlassian.design/components/dropdown-menu/examples)
 * - [Code](https://atlassian.design/components/dropdown-menu/code)
 * - [Usage](https://atlassian.design/components/dropdown-menu/usage)
 */ const $cd131b446ad30d0e$var$DropdownMenu = ({ autoFocus: autoFocus = false, children: children, defaultOpen: defaultOpen = false, isLoading: isLoading = false, isOpen: isOpen, onOpenChange: onOpenChange = (0, $5Q9wj.default), placement: placement = 'bottom-start', shouldFitContainer: shouldFitContainer = false, shouldFlip: shouldFlip = true, shouldRenderToParent: shouldRenderToParent = false, returnFocusRef: returnFocusRef, spacing: spacing, statusLabel: statusLabel, testId: testId, trigger: trigger, zIndex: zIndex = (0, $lcnyw.layers).modal(), label: label })=>{
    const [isLocalOpen, setLocalIsOpen] = (0, $2WwAS.default)(isOpen, ()=>defaultOpen);
    const triggerRef = (0, $eUqFw.useRef)(null);
    const [isTriggeredUsingKeyboard, setTriggeredUsingKeyboard] = (0, $eUqFw.useState)(false);
    const id = (0, $8gwL5.default)();
    const itemRef = (0, $h1Q9j.default)();
    const fallbackPlacements = (0, $eUqFw.useMemo)(()=>$cd131b446ad30d0e$var$getFallbackPlacements(placement), [
        placement
    ]);
    const handleTriggerClicked = (0, $eUqFw.useCallback)(// TODO: event is an `any` and is being cast incorrectly
    // This means that the public type for `onOpenChange` is incorrect
    // current: (event: React.MouseEvent | React.KeyboardEvent) => void;
    // correct: (event: React.MouseEvent | KeyboardEvent) => void;
    // https://product-fabric.atlassian.net/browse/DSP-4692
    (event)=>{
        const newValue = !isLocalOpen;
        const { clientX: clientX, clientY: clientY, type: type, detail: detail } = event;
        if (type === 'keydown') setTriggeredUsingKeyboard(true);
        else if (clientX === 0 || clientY === 0) // Hitting enter/space is registered as a click
        // with both clientX and clientY === 0
        setTriggeredUsingKeyboard(true);
        else if (detail === 0) // Fix for Safari. clientX and clientY !== 0 in Safari
        setTriggeredUsingKeyboard(true);
        else {
            // The trigger element must be focused to avoid problems with an incorrectly focused element after closing DropdownMenu
            itemRef?.current?.focus();
            setTriggeredUsingKeyboard(false);
        }
        setLocalIsOpen(newValue);
        onOpenChange({
            isOpen: newValue,
            event: event
        });
    }, [
        itemRef,
        onOpenChange,
        isLocalOpen,
        setLocalIsOpen
    ]);
    const handleOnClose = (0, $eUqFw.useCallback)((event, currentLevel)=>{
        if (event.key !== 'Escape' && event.key !== 'Tab' && event.target?.closest?.(`[id^=${(0, $8gwL5.PREFIX)}] [aria-haspopup]`)) {
            // Check if it is within dropdown and it is a trigger button
            // if it is a nested dropdown, clicking trigger won't close the dropdown
            // Dropdown can be closed by pressing Escape, Tab or Shift + Tab
            if (!currentLevel) return;
            // if currentLevel is provided, we will compare with the given item's level
            // when it is available and larger than currentLevel, we will proceed the close behavior
            const toCloseLevel = itemRef.current?.dataset['ds-Level'];
            if (toCloseLevel && Number(toCloseLevel) < currentLevel) return;
        }
        // transfer focus to the element specified by ref
        // if ref is not provided, use old behavior:
        // focus on trigger when <Esc> or <Shift+Tab> is pressed
        if (returnFocusRef) requestAnimationFrame(()=>{
            returnFocusRef.current?.focus();
        });
        else if (event.key === 'Tab' && event.shiftKey || event.key === 'Escape') requestAnimationFrame(()=>{
            itemRef.current?.focus();
        });
        else if (triggerRef.current) requestAnimationFrame(()=>{
            triggerRef.current?.focus();
        });
        const newValue = false;
        setLocalIsOpen(newValue);
        onOpenChange({
            isOpen: newValue,
            event: event
        });
    }, [
        itemRef,
        onOpenChange,
        returnFocusRef,
        setLocalIsOpen
    ]);
    const { isFocused: isFocused, bindFocus: bindFocus } = (0, $7PTrT.default)();
    // When a trigger is focused, we want to open the dropdown if
    // the user presses the DownArrow
    (0, $eUqFw.useEffect)(()=>{
        // Only need to listen for keydown when focused
        if (!isFocused) return 0, $5Q9wj.default;
        // Being safe: we don't want to open the dropdown if it is already open
        // Note: This shouldn't happen as the trigger should not be able to get focus
        if (isLocalOpen) return 0, $5Q9wj.default;
        return (0, $74BVL.bind)(window, {
            type: 'keydown',
            listener: function openOnKeyDown(e) {
                let isNestedTriggerButton;
                if (e.target instanceof HTMLElement) isNestedTriggerButton = e.target.closest(`[id^=${(0, $8gwL5.PREFIX)}] [aria-haspopup]`);
                if (e.key === (0, $54717ce5fa2c74b1$export$a80636c6f41931fe) && !isNestedTriggerButton) {
                    // prevent page scroll
                    e.preventDefault();
                    handleTriggerClicked(e);
                } else if ((e.code === (0, $54717ce5fa2c74b1$export$e51a3576c045c8d5) || e.key === (0, $54717ce5fa2c74b1$export$8152f929a25a0ff4)) && e.detail === 0) // This allows us to focus on the first element if the dropdown was triggered by a custom trigger with a custom onClick
                setTriggeredUsingKeyboard(true);
                else if (e.key === (0, $54717ce5fa2c74b1$export$10f6869ed0a7d75b) && isNestedTriggerButton) // This closes dropdown if it is a nested dropdown
                handleOnClose(e);
            }
        });
    }, [
        isFocused,
        isLocalOpen,
        handleTriggerClicked,
        handleOnClose
    ]);
    /*
	 * The Popup component requires either:
	 * - shouldFitContainer={true} and shouldRenderToParent={true | undefined}
	 * or
	 * - shouldFitContainer={false | undefined} and shouldRenderToParent={true | false | undefined}
	 *
	 * But not:
	 * - shouldFitContainer={true} and shouldRenderToParent={false}
	 *
	 * By only including either shouldFitContainer or shouldRenderToParent, we can ensure that the Popup component
	 * types are satisfied.
	 */ const conditionalProps = shouldFitContainer ? {
        shouldFitContainer: shouldFitContainer
    } : {
        shouldRenderToParent: shouldRenderToParent
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7mYCs.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $epS3S.DropdownMenuProvider), {
        value: {
            returnFocusRef: triggerRef
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $3MV1G.default), {
        id: isLocalOpen ? id : undefined,
        shouldFlip: shouldFlip,
        isOpen: isLocalOpen,
        onClose: handleOnClose,
        zIndex: zIndex,
        placement: placement,
        fallbackPlacements: fallbackPlacements,
        testId: testId && `${testId}--content`,
        shouldUseCaptureOnOutsideClick: true,
        ...conditionalProps,
        shouldDisableFocusLock: true,
        trigger: ({ ref: ref, 'aria-controls': ariaControls, 'aria-expanded': ariaExpanded, 'aria-haspopup': ariaHasPopup, // DSP-13312 TODO: remove spread props in future major release
        ...rest })=>{
            if (typeof trigger === 'function') return trigger({
                'aria-controls': ariaControls,
                'aria-expanded': ariaExpanded,
                'aria-haspopup': ariaHasPopup,
                ...rest,
                ...bindFocus,
                triggerRef: (0, $1lQG9.default)([
                    ref,
                    triggerRef,
                    itemRef
                ]),
                isSelected: isLocalOpen,
                onClick: handleTriggerClicked,
                testId: testId && `${testId}--trigger`
            });
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $6zOB7.default), {
                ...bindFocus,
                ref: (0, $1lQG9.default)([
                    ref,
                    triggerRef,
                    itemRef
                ]),
                "aria-controls": ariaControls,
                "aria-expanded": ariaExpanded,
                "aria-haspopup": ariaHasPopup,
                isSelected: isLocalOpen,
                iconAfter: (0, (/*@__PURE__*/$parcel$interopDefault($86Ndv))),
                onClick: handleTriggerClicked,
                testId: testId && `${testId}--trigger`,
                "aria-label": label
            }, trigger);
        },
        content: ({ setInitialFocusRef: setInitialFocusRef, update: update })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $dkYal.default), {
                onClose: handleOnClose
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $jiH6M.default), {
                spacing: spacing,
                maxHeight: $cd131b446ad30d0e$var$MAX_HEIGHT,
                maxWidth: shouldFitContainer ? undefined : 800,
                onClose: handleOnClose,
                onUpdate: update,
                isLoading: isLoading,
                statusLabel: statusLabel,
                setInitialFocusRef: isTriggeredUsingKeyboard || autoFocus ? setInitialFocusRef : undefined,
                shouldRenderToParent: shouldRenderToParent || shouldFitContainer,
                isTriggeredUsingKeyboard: isTriggeredUsingKeyboard,
                autoFocus: autoFocus,
                testId: testId && `${testId}--menu-wrapper`
            }, children))
    })));
};
var $cd131b446ad30d0e$export$2e2bcd8739ae039 = $cd131b446ad30d0e$var$DropdownMenu;

});
/**
 * Character key codes which can be used in keyboard events.
 */ const $54717ce5fa2c74b1$export$390330c10ff2b9a1 = 'ArrowUp';
const $54717ce5fa2c74b1$export$a80636c6f41931fe = 'ArrowDown';
const $54717ce5fa2c74b1$export$4af703091671bc = 'Home';
const $54717ce5fa2c74b1$export$e2bc30913faa5db7 = 'End';
const $54717ce5fa2c74b1$export$10f6869ed0a7d75b = 'Tab';
const $54717ce5fa2c74b1$export$8152f929a25a0ff4 = 'Enter';
const $54717ce5fa2c74b1$export$e51a3576c045c8d5 = 'Space';
const $54717ce5fa2c74b1$export$2bb790b9008907b4 = 'Escape';

parcelRegister("2WwAS", function(module, exports) {

$parcel$export(module.exports, "default", () => $fc974ed9b9ba7adb$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");
function $fc974ed9b9ba7adb$export$2e2bcd8739ae039(propValue, getDefaultPropValue = ()=>propValue) {
    const isControlled = propValue !== undefined;
    const [valueState, setValue] = (0, $eUqFw.useState)(getDefaultPropValue);
    const isControlledRef = (0, $eUqFw.useRef)(isControlled);
    (0, $eUqFw.useEffect)(()=>{
        isControlledRef.current = isControlled;
    }, [
        isControlled
    ]);
    const value = isControlled ? propValue : valueState;
    const setValueIfUncontrolled = (0, $eUqFw.useCallback)((newValue)=>{
        if (!isControlledRef.current) setValue(newValue);
    }, []);
    return [
        value,
        setValueIfUncontrolled
    ];
}

});

parcelRegister("7PTrT", function(module, exports) {

$parcel$export(module.exports, "default", () => $2cf74c53325012fd$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");
function $2cf74c53325012fd$export$2e2bcd8739ae039() {
    const [isFocused, setIsFocused] = (0, $eUqFw.useState)(false);
    // ensure bindFocus has a stable ref
    const bindFocus = (0, $eUqFw.useRef)({
        onFocus: ()=>setIsFocused(true),
        onBlur: ()=>setIsFocused(false)
    });
    (0, $eUqFw.useEffect)(()=>{
        // handle the case where a component might
        // unmount while being focused.
        return ()=>setIsFocused(false);
    }, []);
    return {
        isFocused: isFocused,
        bindFocus: bindFocus.current
    };
}

});

parcelRegister("dkYal", function(module, exports) {

$parcel$export(module.exports, "FocusManagerContext", () => $cf3cae93cc4408b7$export$f18c1d4fc7326096);
$parcel$export(module.exports, "default", () => $cf3cae93cc4408b7$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $74BVL = parcelRequire("74BVL");

var $5Q9wj = parcelRequire("5Q9wj");

var $eN43R = parcelRequire("eN43R");

var $9wjz6 = parcelRequire("9wjz6");
const $cf3cae93cc4408b7$export$f18c1d4fc7326096 = /*#__PURE__*/ (0, $eUqFw.createContext)({
    menuItemRefs: [],
    registerRef: (0, $5Q9wj.default)
});
/**
 * Focus manager logic.
 */ const $cf3cae93cc4408b7$var$FocusManager = ({ children: children, onClose: onClose })=>{
    const menuItemRefs = (0, $eUqFw.useRef)([]);
    const registerRef = (0, $eUqFw.useCallback)((ref)=>{
        if (ref && !menuItemRefs.current.includes(ref)) menuItemRefs.current.push(ref);
    }, []);
    const { isLayerDisabled: isLayerDisabled } = (0, $eN43R.UNSAFE_useLayering)();
    // Intentionally rebinding on each render
    (0, $eUqFw.useEffect)(()=>{
        return (0, $74BVL.bind)(window, {
            type: 'keydown',
            listener: (0, $9wjz6.default)(menuItemRefs.current, isLayerDisabled, onClose)
        });
    });
    const contextValue = {
        menuItemRefs: menuItemRefs.current,
        registerRef: registerRef
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($cf3cae93cc4408b7$export$f18c1d4fc7326096.Provider, {
        value: contextValue
    }, children);
};
var $cf3cae93cc4408b7$export$2e2bcd8739ae039 = $cf3cae93cc4408b7$var$FocusManager;

});
parcelRegister("9wjz6", function(module, exports) {

$parcel$export(module.exports, "default", () => $66539497081f56cc$export$2e2bcd8739ae039);


var $XHGTv = parcelRequire("XHGTv");

var $8gwL5 = parcelRequire("8gwL5");
const $66539497081f56cc$var$actionMap = {
    [(0, $54717ce5fa2c74b1$export$a80636c6f41931fe)]: 'next',
    [(0, $54717ce5fa2c74b1$export$390330c10ff2b9a1)]: 'prev',
    [(0, $54717ce5fa2c74b1$export$4af703091671bc)]: 'first',
    [(0, $54717ce5fa2c74b1$export$e2bc30913faa5db7)]: 'last'
};
/**
 * `currentFocusedIdx + 1` will not work if the next focusable element
 * is disabled. So, we need to iterate through the following menu items
 * to find one that isn't disabled. If all following elements are disabled,
 * return undefined.
 */ const $66539497081f56cc$var$getNextFocusableElement = (refs, currentFocusedIdx)=>{
    while(currentFocusedIdx + 1 < refs.length){
        const isDisabled = refs[currentFocusedIdx + 1].hasAttribute('disabled');
        if (!isDisabled) return refs[currentFocusedIdx + 1];
        currentFocusedIdx++;
    }
};
/**
 * `currentFocusedIdx - 1` will not work if the prev focusable element
 * is disabled. So, we need to iterate through the previous menu items
 * to find one that isn't disabled. If all previous elements are disabled,
 * return undefined.
 */ const $66539497081f56cc$var$getPrevFocusableElement = (refs, currentFocusedIdx)=>{
    while(currentFocusedIdx > 0){
        const isDisabled = refs[currentFocusedIdx - 1].hasAttribute('disabled');
        if (!isDisabled) return refs[currentFocusedIdx - 1];
        currentFocusedIdx--;
    }
};
function $66539497081f56cc$export$2e2bcd8739ae039(refs, isLayerDisabled, onClose) {
    return (e)=>{
        const currentFocusedIdx = refs.findIndex((el)=>document.activeElement?.isSameNode(el));
        if ((0, $XHGTv.fg)('platform_dst_popup-disable-focuslock')) {
            // if we use a popup as a nested dropdown, we must prevent the dropdown from closing.
            const isNestedDropdown = !!document.activeElement?.closest(`[id^=${(0, $8gwL5.PREFIX)}]`);
            if (isLayerDisabled() && isNestedDropdown) {
                if (e.key === (0, $54717ce5fa2c74b1$export$10f6869ed0a7d75b) && !e.shiftKey) onClose(e);
                // if it is a nested dropdown and the level of the given dropdown is not the current level,
                // we don't need to have focus on it
                return;
            }
        } else if (isLayerDisabled()) {
            if (e.key === (0, $54717ce5fa2c74b1$export$10f6869ed0a7d75b) && !e.shiftKey) onClose(e);
            // if it is a nested dropdown and the level of the given dropdown is not the current level,
            // we don't need to have focus on it
            return;
        }
        const action = $66539497081f56cc$var$actionMap[e.key];
        switch(action){
            case 'next':
                // Always cancelling the event to prevent scrolling
                e.preventDefault();
                if (currentFocusedIdx < refs.length - 1) {
                    const nextFocusableElement = $66539497081f56cc$var$getNextFocusableElement(refs, currentFocusedIdx);
                    nextFocusableElement?.focus();
                } else {
                    const firstFocusableElement = $66539497081f56cc$var$getNextFocusableElement(refs, -1);
                    firstFocusableElement?.focus();
                }
                break;
            case 'prev':
                // Always cancelling the event to prevent scrolling
                e.preventDefault();
                if (currentFocusedIdx > 0) {
                    const prevFocusableElement = $66539497081f56cc$var$getPrevFocusableElement(refs, currentFocusedIdx);
                    prevFocusableElement?.focus();
                } else {
                    const lastFocusableElement = $66539497081f56cc$var$getPrevFocusableElement(refs, refs.length);
                    lastFocusableElement?.focus();
                }
                break;
            case 'first':
                e.preventDefault();
                // Search for first non-disabled element if first element is disabled
                const nextFocusableElement = $66539497081f56cc$var$getNextFocusableElement(refs, -1);
                nextFocusableElement?.focus();
                break;
            case 'last':
                e.preventDefault();
                // Search for last non-disabled element if last element is disabled
                const prevFocusableElement = $66539497081f56cc$var$getPrevFocusableElement(refs, refs.length);
                prevFocusableElement?.focus();
                break;
            default:
                return;
        }
    };
}

});
parcelRegister("8gwL5", function(module, exports) {

$parcel$export(module.exports, "PREFIX", () => $bbafb6080e6e0b27$export$8a682ae47622dbb9);
$parcel$export(module.exports, "default", () => $bbafb6080e6e0b27$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");
const $bbafb6080e6e0b27$export$8a682ae47622dbb9 = 'ds--dropdown--';
const $bbafb6080e6e0b27$var$generateRandomString = ()=>// This string is used only on client side usually triggered after a user interaction.
    // Therefore, so there is no risk of mismatch
    // between server and client generated markup.
    // eslint-disable-next-line @repo/internal/react/disallow-unstable-values
    `${$bbafb6080e6e0b27$export$8a682ae47622dbb9}${Math.random().toString(16).substr(2, 8)}`;
function $bbafb6080e6e0b27$export$2e2bcd8739ae039() {
    const cachedId = (0, $eUqFw.useRef)($bbafb6080e6e0b27$var$generateRandomString());
    return cachedId.current;
}

});



parcelRegister("jiH6M", function(module, exports) {

$parcel$export(module.exports, "default", () => $964014f36228d6e8$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $eUqFw = parcelRequire("eUqFw");

var $byn9U = parcelRequire("byn9U");

var $8PFhw = parcelRequire("8PFhw");

var $b5IAe = parcelRequire("b5IAe");
var $1ZAYh = parcelRequire("1ZAYh");

var $4Bees = parcelRequire("4Bees");

var $dkYal = parcelRequire("dkYal");

var $fccfd = parcelRequire("fccfd");

var $1g0c9 = parcelRequire("1g0c9");
const $964014f36228d6e8$var$spinnerContainerStyles = (0, $1ZAYh.xcss)({
    display: 'flex',
    minWidth: '160px',
    padding: 'space.250',
    justifyContent: 'center'
});
const $964014f36228d6e8$var$LoadingIndicator = ({ statusLabel: statusLabel = 'Loading', testId: testId })=>/*#__PURE__*/ (0, $byn9U.jsx)((0, $b5IAe.default), {
        xcss: $964014f36228d6e8$var$spinnerContainerStyles
    }, /*#__PURE__*/ (0, $byn9U.jsx)((0, $4Bees.default), {
        size: "small",
        label: statusLabel,
        testId: testId
    }));
/**
 *
 * MenuWrapper wraps all the menu items.
 * It handles the logic to close the menu when a MenuItem is clicked, but leaves it open
 * if a CheckboxItem or RadioItem is clicked.
 * It also sets focus to the first menu item when opened.
 */ const $964014f36228d6e8$var$MenuWrapper = ({ children: children, isLoading: isLoading, maxHeight: maxHeight, maxWidth: maxWidth, onClose: onClose, onUpdate: onUpdate, statusLabel: statusLabel, setInitialFocusRef: setInitialFocusRef, shouldRenderToParent: shouldRenderToParent, spacing: spacing, testId: testId, isTriggeredUsingKeyboard: isTriggeredUsingKeyboard, autoFocus: autoFocus })=>{
    const { menuItemRefs: menuItemRefs } = (0, $eUqFw.useContext)((0, $dkYal.FocusManagerContext));
    const closeOnMenuItemClick = (e)=>{
        const isTargetMenuItemOrDecendant = menuItemRefs.some((menuItem)=>{
            const isCheckboxOrRadio = (0, $fccfd.default)(menuItem) || (0, $1g0c9.default)(menuItem);
            return menuItem.contains(e.target) && !isCheckboxOrRadio;
        });
        // Close menu if the click is triggered from a MenuItem or
        // its descendant. Don't close the menu if the click is triggered
        // from a MenuItemRadio or MenuItemCheckbox so that the user can
        // select multiple items.
        if (isTargetMenuItemOrDecendant && onClose) onClose(e);
    };
    // Using useEffect here causes a flicker.
    // useLayoutEffect ensures that the update and render happen in the same
    // rAF tick.
    (0, $eUqFw.useLayoutEffect)(()=>{
        onUpdate();
    }, [
        isLoading,
        onUpdate
    ]);
    (0, $eUqFw.useEffect)(()=>{
        const firstFocusableRef = menuItemRefs.find((ref)=>!ref.hasAttribute('disabled')) ?? null;
        if (shouldRenderToParent && (isTriggeredUsingKeyboard || autoFocus)) firstFocusableRef?.focus();
        setInitialFocusRef?.(firstFocusableRef);
    }, [
        menuItemRefs,
        setInitialFocusRef,
        autoFocus,
        shouldRenderToParent,
        isTriggeredUsingKeyboard
    ]);
    return /*#__PURE__*/ (0, $byn9U.jsx)((0, $8PFhw.default), {
        isLoading: isLoading,
        maxHeight: maxHeight,
        maxWidth: maxWidth,
        onClick: closeOnMenuItemClick,
        role: "menu",
        spacing: spacing,
        testId: testId && `${testId}--menu-group`
    }, isLoading ? /*#__PURE__*/ (0, $byn9U.jsx)($964014f36228d6e8$var$LoadingIndicator, {
        statusLabel: statusLabel,
        testId: testId && `${testId}--loading-indicator`
    }) : children);
};
var $964014f36228d6e8$export$2e2bcd8739ae039 = $964014f36228d6e8$var$MenuWrapper;

});
parcelRegister("fccfd", function(module, exports) {

$parcel$export(module.exports, "default", () => $2cc914649461e3b8$export$2e2bcd8739ae039);
function $2cc914649461e3b8$export$2e2bcd8739ae039(element) {
    const role = element.getAttribute('role');
    return role === 'checkbox' || role === 'menuitemcheckbox';
}

});

parcelRegister("1g0c9", function(module, exports) {

$parcel$export(module.exports, "default", () => $3727e20ee9b5acb1$export$2e2bcd8739ae039);
function $3727e20ee9b5acb1$export$2e2bcd8739ae039(element) {
    const role = element.getAttribute('role');
    return role === 'radio' || role === 'menuitemradio';
}

});


parcelRegister("epS3S", function(module, exports) {

$parcel$export(module.exports, "DropdownMenuProvider", () => $ee1dc8dd27dd916a$export$9357e33608f1035a);

var $eUqFw = parcelRequire("eUqFw");
const $ee1dc8dd27dd916a$var$DropdownMenuContext = /*#__PURE__*/ (0, $eUqFw.createContext)(undefined);
const $ee1dc8dd27dd916a$export$9357e33608f1035a = $ee1dc8dd27dd916a$var$DropdownMenuContext.Provider;

});

parcelRegister("7mYCs", function(module, exports) {

$parcel$export(module.exports, "SelectionStoreContext", () => $9b55d88a204a2c6b$export$756f795847463ebd);
$parcel$export(module.exports, "default", () => $9b55d88a204a2c6b$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $5Q9wj = parcelRequire("5Q9wj");
const $9b55d88a204a2c6b$export$756f795847463ebd = /*#__PURE__*/ (0, $eUqFw.createContext)({
    setItemState: (0, $5Q9wj.default),
    getItemState: ()=>undefined,
    setGroupState: (0, $5Q9wj.default),
    getGroupState: ()=>({})
});
/**
 * Selection store will persist data as long as it remains mounted.
 * It handles the uncontrolled story for dropdown menu when the menu
 * items can be mounted/unmounted depending if the menu is open or closed.
 */ const $9b55d88a204a2c6b$var$SelectionStore = (props)=>{
    const { children: children } = props;
    const store = (0, $eUqFw.useRef)({});
    const context = (0, $eUqFw.useMemo)(()=>({
            setItemState: (group, id, value)=>{
                if (!store.current[group]) store.current[group] = {};
                store.current[group][id] = value;
            },
            getItemState: (group, id)=>{
                if (!store.current[group]) return undefined;
                return store.current[group][id];
            },
            setGroupState: (group, value)=>{
                store.current[group] = value;
            },
            getGroupState: (group)=>{
                return store.current[group] || {};
            }
        }), []);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($9b55d88a204a2c6b$export$756f795847463ebd.Provider, {
        value: context
    }, children);
};
var $9b55d88a204a2c6b$export$2e2bcd8739ae039 = $9b55d88a204a2c6b$var$SelectionStore;

});

parcelRegister("h1Q9j", function(module, exports) {

$parcel$export(module.exports, "default", () => $6def866028b8c887$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $dkYal = parcelRequire("dkYal");
// This function is called whenever a MenuItem mounts.
// The refs stored in the context are used to programatically
// control focus on a user navigates using the keyboard.
function $6def866028b8c887$var$useRegisterItemWithFocusManager() {
    const { registerRef: registerRef } = (0, $eUqFw.useContext)((0, $dkYal.FocusManagerContext));
    const itemRef = (0, $eUqFw.useRef)(null);
    (0, $eUqFw.useEffect)(()=>{
        if (itemRef.current !== null) registerRef(itemRef.current);
    }, [
        registerRef
    ]);
    return itemRef;
}
var $6def866028b8c887$export$2e2bcd8739ae039 = $6def866028b8c887$var$useRegisterItemWithFocusManager;

});


parcelRegister("lmeyI", function(module, exports) {

$parcel$export(module.exports, "default", () => $ed394ec493e143b5$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $5Q9wj = parcelRequire("5Q9wj");

var $8jcoK = parcelRequire("8jcoK");

var $bULPy = parcelRequire("bULPy");

var $iP9LU = parcelRequire("iP9LU");

var $brxwV = parcelRequire("brxwV");

var $h1Q9j = parcelRequire("h1Q9j");

var $efWFe = parcelRequire("efWFe");

var $2fFJv = parcelRequire("2fFJv");
/**
 * __Dropdown item radio__
 *
 * A dropdown item radio displays groups that have a single selection.
 *
 * - [Examples](https://atlassian.design/components/dropdown-menu/dropdown-item-radio/examples)
 * - [Code](https://atlassian.design/components/dropdown-menu/dropdown-item-radio/code)
 * - [Usage](https://atlassian.design/components/dropdown-menu/dropdown-item-radio/usage)
 */ const $ed394ec493e143b5$var$DropdownItemRadio = ({ children: children, defaultSelected: defaultSelected, testId: testId, id: id, title: title, description: description, isDisabled: isDisabled, isSelected: isSelected, onClick: providedOnClick = (0, $5Q9wj.default), shouldDescriptionWrap: shouldDescriptionWrap = true, shouldTitleWrap: shouldTitleWrap = true, // DSP-13312 TODO: remove spread props in future major release
...rest })=>{
    typeof $2fFJv;
    const [selected, setSelected] = (0, $brxwV.default)({
        id: id,
        isSelected: isSelected,
        defaultSelected: defaultSelected
    });
    const onClickHandler = (0, $eUqFw.useCallback)((event)=>{
        setSelected((selected)=>!selected);
        providedOnClick(event);
    }, [
        providedOnClick,
        setSelected
    ]);
    const itemRef = (0, $h1Q9j.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8jcoK.SELECTION_STYLE_CONTEXT_DO_NOT_USE).Provider, {
        value: "none"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $bULPy.default), {
        "aria-checked": selected,
        description: description,
        iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $iP9LU.default), {
            checked: selected
        }),
        id: id,
        isDisabled: isDisabled,
        isSelected: selected,
        onClick: onClickHandler,
        ref: itemRef,
        role: (0, $efWFe.default)() ? 'radio' : 'menuitemradio',
        shouldDescriptionWrap: shouldDescriptionWrap,
        shouldTitleWrap: shouldTitleWrap,
        testId: testId,
        // Thanks to spread props, this attribute are passed to ButtonItem, even though
        // it's not in the component's prop types.
        // @ts-expect-error
        title: title,
        ...rest
    }, children));
};
var $ed394ec493e143b5$export$2e2bcd8739ae039 = $ed394ec493e143b5$var$DropdownItemRadio;

});
parcelRegister("iP9LU", function(module, exports) {

$parcel$export(module.exports, "default", () => $5d086ff5ea2ed155$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $ce8OV = parcelRequire("ce8OV");

/**
 * __Radio icon__
 *
 * Used to visually represent the selected state in DropdownItemRadio
 *
 * @internal
 */ const $5d086ff5ea2ed155$var$RadioIcon = ({ checked: checked })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $ce8OV.default), {
        label: "",
        size: "medium",
        primaryColor: checked ? `var(--ds-background-selected-bold, ${0, $73a5c9d720aa66e1$export$b3de0ae08da2ce64})` : `var(--ds-background-input, ${0, $73a5c9d720aa66e1$export$e655ef011c4aa1a2})`,
        secondaryColor: checked ? `var(--ds-icon-inverse, ${0, $73a5c9d720aa66e1$export$e655ef011c4aa1a2})` : 'transparent'
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("g", {
        fillRule: "evenodd"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("circle", {
        fill: "currentColor",
        cx: "12",
        cy: "12",
        r: "6",
        stroke: checked ? `var(--ds-border-selected, ${0, $73a5c9d720aa66e1$export$b3de0ae08da2ce64})` : `var(--ds-border-input, ${0, $73a5c9d720aa66e1$export$d6447c357493214f})`,
        strokeWidth: 1
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("circle", {
        fill: "inherit",
        cx: "12",
        cy: "12",
        r: "2"
    })));
};
var $5d086ff5ea2ed155$export$2e2bcd8739ae039 = $5d086ff5ea2ed155$var$RadioIcon;

});
var $73a5c9d720aa66e1$exports = {};

$parcel$export($73a5c9d720aa66e1$exports, "R50", () => $73a5c9d720aa66e1$export$4b84fd0e2c617bd);
$parcel$export($73a5c9d720aa66e1$exports, "R75", () => $73a5c9d720aa66e1$export$b34b069eff244586);
$parcel$export($73a5c9d720aa66e1$exports, "R100", () => $73a5c9d720aa66e1$export$be802dd0d8b57f35);
$parcel$export($73a5c9d720aa66e1$exports, "R200", () => $73a5c9d720aa66e1$export$60847d42f9da92a6);
$parcel$export($73a5c9d720aa66e1$exports, "R300", () => $73a5c9d720aa66e1$export$4a7404f376229999);
$parcel$export($73a5c9d720aa66e1$exports, "R400", () => $73a5c9d720aa66e1$export$2010d0fb4295b346);
$parcel$export($73a5c9d720aa66e1$exports, "R500", () => $73a5c9d720aa66e1$export$2837b5a1a71d5c02);
$parcel$export($73a5c9d720aa66e1$exports, "Y50", () => $73a5c9d720aa66e1$export$8d9596b529bbb9cf);
$parcel$export($73a5c9d720aa66e1$exports, "Y75", () => $73a5c9d720aa66e1$export$41060a744ab0b7ae);
$parcel$export($73a5c9d720aa66e1$exports, "Y100", () => $73a5c9d720aa66e1$export$1cc05bbbf340e559);
$parcel$export($73a5c9d720aa66e1$exports, "Y200", () => $73a5c9d720aa66e1$export$5aae31392d72caaa);
$parcel$export($73a5c9d720aa66e1$exports, "Y300", () => $73a5c9d720aa66e1$export$c6930421db9fa514);
$parcel$export($73a5c9d720aa66e1$exports, "Y400", () => $73a5c9d720aa66e1$export$59619663aa6500fb);
$parcel$export($73a5c9d720aa66e1$exports, "Y500", () => $73a5c9d720aa66e1$export$874739ea9e379ab6);
$parcel$export($73a5c9d720aa66e1$exports, "G50", () => $73a5c9d720aa66e1$export$8a6341c32b6a3ee6);
$parcel$export($73a5c9d720aa66e1$exports, "G75", () => $73a5c9d720aa66e1$export$69a3bf21b9686c2b);
$parcel$export($73a5c9d720aa66e1$exports, "G100", () => $73a5c9d720aa66e1$export$afbce1382ec95f73);
$parcel$export($73a5c9d720aa66e1$exports, "G200", () => $73a5c9d720aa66e1$export$747d86715d4175de);
$parcel$export($73a5c9d720aa66e1$exports, "G300", () => $73a5c9d720aa66e1$export$940e1f69e873f202);
$parcel$export($73a5c9d720aa66e1$exports, "G400", () => $73a5c9d720aa66e1$export$a49394138f7b8e85);
$parcel$export($73a5c9d720aa66e1$exports, "G500", () => $73a5c9d720aa66e1$export$6fa04827ac68a4fb);
$parcel$export($73a5c9d720aa66e1$exports, "B50", () => $73a5c9d720aa66e1$export$226de0355ed012f8);
$parcel$export($73a5c9d720aa66e1$exports, "B75", () => $73a5c9d720aa66e1$export$8c13c2ee36917869);
$parcel$export($73a5c9d720aa66e1$exports, "B100", () => $73a5c9d720aa66e1$export$ecfc1dff386a3e7a);
$parcel$export($73a5c9d720aa66e1$exports, "B200", () => $73a5c9d720aa66e1$export$215b7063051591f1);
$parcel$export($73a5c9d720aa66e1$exports, "B300", () => $73a5c9d720aa66e1$export$e62e8919cca44969);
$parcel$export($73a5c9d720aa66e1$exports, "B400", () => $73a5c9d720aa66e1$export$b3de0ae08da2ce64);
$parcel$export($73a5c9d720aa66e1$exports, "B500", () => $73a5c9d720aa66e1$export$a6ee3d71bc067634);
$parcel$export($73a5c9d720aa66e1$exports, "P50", () => $73a5c9d720aa66e1$export$363e4475840015bb);
$parcel$export($73a5c9d720aa66e1$exports, "P75", () => $73a5c9d720aa66e1$export$4b0a4417ed59760f);
$parcel$export($73a5c9d720aa66e1$exports, "P100", () => $73a5c9d720aa66e1$export$6011520a64d9a187);
$parcel$export($73a5c9d720aa66e1$exports, "P200", () => $73a5c9d720aa66e1$export$a7175d4e9206bc80);
$parcel$export($73a5c9d720aa66e1$exports, "P300", () => $73a5c9d720aa66e1$export$b48405b95304b5a1);
$parcel$export($73a5c9d720aa66e1$exports, "P400", () => $73a5c9d720aa66e1$export$c71e4279dd54a18d);
$parcel$export($73a5c9d720aa66e1$exports, "P500", () => $73a5c9d720aa66e1$export$147899de772240ec);
$parcel$export($73a5c9d720aa66e1$exports, "T50", () => $73a5c9d720aa66e1$export$2cf711fe14c66f06);
$parcel$export($73a5c9d720aa66e1$exports, "T75", () => $73a5c9d720aa66e1$export$7a8f4d33f6f9772c);
$parcel$export($73a5c9d720aa66e1$exports, "T100", () => $73a5c9d720aa66e1$export$776c9c497ef08533);
$parcel$export($73a5c9d720aa66e1$exports, "T200", () => $73a5c9d720aa66e1$export$69cb3ca10c1e330e);
$parcel$export($73a5c9d720aa66e1$exports, "T300", () => $73a5c9d720aa66e1$export$9dc1ef0f3f48059b);
$parcel$export($73a5c9d720aa66e1$exports, "T400", () => $73a5c9d720aa66e1$export$7c835c78b6fcdef8);
$parcel$export($73a5c9d720aa66e1$exports, "T500", () => $73a5c9d720aa66e1$export$6036577f95c3877e);
$parcel$export($73a5c9d720aa66e1$exports, "N0", () => $73a5c9d720aa66e1$export$29a4f05edc054374);
$parcel$export($73a5c9d720aa66e1$exports, "N10", () => $73a5c9d720aa66e1$export$e655ef011c4aa1a2);
$parcel$export($73a5c9d720aa66e1$exports, "N20", () => $73a5c9d720aa66e1$export$9fdfb749e33cdf97);
$parcel$export($73a5c9d720aa66e1$exports, "N30", () => $73a5c9d720aa66e1$export$3e51e8f1440314ba);
$parcel$export($73a5c9d720aa66e1$exports, "N40", () => $73a5c9d720aa66e1$export$1ce2d1575d444ceb);
$parcel$export($73a5c9d720aa66e1$exports, "N50", () => $73a5c9d720aa66e1$export$8754fc7e6d8b3000);
$parcel$export($73a5c9d720aa66e1$exports, "N60", () => $73a5c9d720aa66e1$export$c2e91cbeada39b8b);
$parcel$export($73a5c9d720aa66e1$exports, "N70", () => $73a5c9d720aa66e1$export$5f71e19f3a7ad9de);
$parcel$export($73a5c9d720aa66e1$exports, "N80", () => $73a5c9d720aa66e1$export$eaa8c8a70ac22806);
$parcel$export($73a5c9d720aa66e1$exports, "N90", () => $73a5c9d720aa66e1$export$7c87d337fb91a97d);
$parcel$export($73a5c9d720aa66e1$exports, "N100", () => $73a5c9d720aa66e1$export$d6447c357493214f);
$parcel$export($73a5c9d720aa66e1$exports, "N200", () => $73a5c9d720aa66e1$export$f563ee71e9ee74cd);
$parcel$export($73a5c9d720aa66e1$exports, "N300", () => $73a5c9d720aa66e1$export$e2ef2124cf4024b1);
$parcel$export($73a5c9d720aa66e1$exports, "N400", () => $73a5c9d720aa66e1$export$eece5f492e429f08);
$parcel$export($73a5c9d720aa66e1$exports, "N500", () => $73a5c9d720aa66e1$export$c39c0fe0f26207ae);
$parcel$export($73a5c9d720aa66e1$exports, "N600", () => $73a5c9d720aa66e1$export$7090862dc3038a9f);
$parcel$export($73a5c9d720aa66e1$exports, "N700", () => $73a5c9d720aa66e1$export$ad0bacf983b7ddaa);
$parcel$export($73a5c9d720aa66e1$exports, "N800", () => $73a5c9d720aa66e1$export$7d61b15e0da132af);
$parcel$export($73a5c9d720aa66e1$exports, "N900", () => $73a5c9d720aa66e1$export$fbda843f0a27fe96);
$parcel$export($73a5c9d720aa66e1$exports, "N10A", () => $73a5c9d720aa66e1$export$791e57b27ca738ef);
$parcel$export($73a5c9d720aa66e1$exports, "N20A", () => $73a5c9d720aa66e1$export$8d43898f60b96a82);
$parcel$export($73a5c9d720aa66e1$exports, "N30A", () => $73a5c9d720aa66e1$export$920c0d5c49070351);
$parcel$export($73a5c9d720aa66e1$exports, "N40A", () => $73a5c9d720aa66e1$export$46987b49aab6d1a8);
$parcel$export($73a5c9d720aa66e1$exports, "N50A", () => $73a5c9d720aa66e1$export$7d3359664e8bb0e5);
$parcel$export($73a5c9d720aa66e1$exports, "N60A", () => $73a5c9d720aa66e1$export$d2d3bedfb276cac0);
$parcel$export($73a5c9d720aa66e1$exports, "N70A", () => $73a5c9d720aa66e1$export$6e5e7499ff054f6d);
$parcel$export($73a5c9d720aa66e1$exports, "N80A", () => $73a5c9d720aa66e1$export$59264b346c877fa7);
$parcel$export($73a5c9d720aa66e1$exports, "N90A", () => $73a5c9d720aa66e1$export$d092757d7c64925c);
$parcel$export($73a5c9d720aa66e1$exports, "N100A", () => $73a5c9d720aa66e1$export$486ab785e4bac3c6);
$parcel$export($73a5c9d720aa66e1$exports, "N200A", () => $73a5c9d720aa66e1$export$fba592bbc6419fea);
$parcel$export($73a5c9d720aa66e1$exports, "N300A", () => $73a5c9d720aa66e1$export$13609db0e6812ab8);
$parcel$export($73a5c9d720aa66e1$exports, "N400A", () => $73a5c9d720aa66e1$export$fbae4efaa892d883);
$parcel$export($73a5c9d720aa66e1$exports, "N500A", () => $73a5c9d720aa66e1$export$f13946d26f440ce6);
$parcel$export($73a5c9d720aa66e1$exports, "N600A", () => $73a5c9d720aa66e1$export$19f58225ac52a306);
$parcel$export($73a5c9d720aa66e1$exports, "N700A", () => $73a5c9d720aa66e1$export$6384f09da70e7b62);
$parcel$export($73a5c9d720aa66e1$exports, "N800A", () => $73a5c9d720aa66e1$export$d0dccc730683edc2);
$parcel$export($73a5c9d720aa66e1$exports, "DN900", () => $73a5c9d720aa66e1$export$2f6319cf7d736c2a);
$parcel$export($73a5c9d720aa66e1$exports, "DN800", () => $73a5c9d720aa66e1$export$95126bc8884d6634);
$parcel$export($73a5c9d720aa66e1$exports, "DN700", () => $73a5c9d720aa66e1$export$8338d8c35d44ff1);
$parcel$export($73a5c9d720aa66e1$exports, "DN600", () => $73a5c9d720aa66e1$export$5368d76ae4fbbda7);
$parcel$export($73a5c9d720aa66e1$exports, "DN500", () => $73a5c9d720aa66e1$export$9f0a771d16ec8d36);
$parcel$export($73a5c9d720aa66e1$exports, "DN400", () => $73a5c9d720aa66e1$export$abcf8c38338b4aa5);
$parcel$export($73a5c9d720aa66e1$exports, "DN300", () => $73a5c9d720aa66e1$export$97e81faa16a182c7);
$parcel$export($73a5c9d720aa66e1$exports, "DN200", () => $73a5c9d720aa66e1$export$bfe21c59123ecf33);
$parcel$export($73a5c9d720aa66e1$exports, "DN100", () => $73a5c9d720aa66e1$export$ee82aa2ea6a1558);
$parcel$export($73a5c9d720aa66e1$exports, "DN90", () => $73a5c9d720aa66e1$export$682927c6ed76be02);
$parcel$export($73a5c9d720aa66e1$exports, "DN80", () => $73a5c9d720aa66e1$export$91fd9994c5be9757);
$parcel$export($73a5c9d720aa66e1$exports, "DN70", () => $73a5c9d720aa66e1$export$d281fbfe3cff2df6);
$parcel$export($73a5c9d720aa66e1$exports, "DN60", () => $73a5c9d720aa66e1$export$3902c91d8b98a753);
$parcel$export($73a5c9d720aa66e1$exports, "DN50", () => $73a5c9d720aa66e1$export$8e8133c1ba5845b5);
$parcel$export($73a5c9d720aa66e1$exports, "DN40", () => $73a5c9d720aa66e1$export$33ff357f6620b39);
$parcel$export($73a5c9d720aa66e1$exports, "DN30", () => $73a5c9d720aa66e1$export$633847cf062b69e0);
$parcel$export($73a5c9d720aa66e1$exports, "DN20", () => $73a5c9d720aa66e1$export$9776a6e503bdbf76);
$parcel$export($73a5c9d720aa66e1$exports, "DN10", () => $73a5c9d720aa66e1$export$6c813d5160dff5db);
$parcel$export($73a5c9d720aa66e1$exports, "DN0", () => $73a5c9d720aa66e1$export$3d4f271a500072a);
$parcel$export($73a5c9d720aa66e1$exports, "DN800A", () => $73a5c9d720aa66e1$export$fe151285c22759ec);
$parcel$export($73a5c9d720aa66e1$exports, "DN700A", () => $73a5c9d720aa66e1$export$a101c6190d0da34);
$parcel$export($73a5c9d720aa66e1$exports, "DN600A", () => $73a5c9d720aa66e1$export$4b16f52932fda51);
$parcel$export($73a5c9d720aa66e1$exports, "DN500A", () => $73a5c9d720aa66e1$export$a74bcd7b9845b0d8);
$parcel$export($73a5c9d720aa66e1$exports, "DN400A", () => $73a5c9d720aa66e1$export$9209c179316d1751);
$parcel$export($73a5c9d720aa66e1$exports, "DN300A", () => $73a5c9d720aa66e1$export$88f55133f636c8dd);
$parcel$export($73a5c9d720aa66e1$exports, "DN200A", () => $73a5c9d720aa66e1$export$51126f85d1009512);
$parcel$export($73a5c9d720aa66e1$exports, "DN100A", () => $73a5c9d720aa66e1$export$a069b547bd23af78);
$parcel$export($73a5c9d720aa66e1$exports, "DN90A", () => $73a5c9d720aa66e1$export$40cce05af3b2600a);
$parcel$export($73a5c9d720aa66e1$exports, "DN80A", () => $73a5c9d720aa66e1$export$b78942185925a0d);
$parcel$export($73a5c9d720aa66e1$exports, "DN70A", () => $73a5c9d720aa66e1$export$e058fb44b8eaafca);
$parcel$export($73a5c9d720aa66e1$exports, "DN60A", () => $73a5c9d720aa66e1$export$92b0b8de26920c18);
$parcel$export($73a5c9d720aa66e1$exports, "DN50A", () => $73a5c9d720aa66e1$export$67564f7459d3fc9e);
$parcel$export($73a5c9d720aa66e1$exports, "DN40A", () => $73a5c9d720aa66e1$export$77868e1ca884ffa3);
$parcel$export($73a5c9d720aa66e1$exports, "DN30A", () => $73a5c9d720aa66e1$export$2afd71d7d3ea2cd5);
$parcel$export($73a5c9d720aa66e1$exports, "DN20A", () => $73a5c9d720aa66e1$export$f2a0acaab9972c70);
$parcel$export($73a5c9d720aa66e1$exports, "DN10A", () => $73a5c9d720aa66e1$export$9ab70e67d6475361);
/* eslint-disable @atlaskit/design-system/ensure-design-token-usage */ // Reds
const $73a5c9d720aa66e1$export$4b84fd0e2c617bd = '#FFEBE6';
const $73a5c9d720aa66e1$export$b34b069eff244586 = '#FFBDAD';
const $73a5c9d720aa66e1$export$be802dd0d8b57f35 = '#FF8F73';
const $73a5c9d720aa66e1$export$60847d42f9da92a6 = '#FF7452';
const $73a5c9d720aa66e1$export$4a7404f376229999 = '#FF5630';
const $73a5c9d720aa66e1$export$2010d0fb4295b346 = '#DE350B';
const $73a5c9d720aa66e1$export$2837b5a1a71d5c02 = '#BF2600';
const $73a5c9d720aa66e1$export$8d9596b529bbb9cf = '#FFFAE6';
const $73a5c9d720aa66e1$export$41060a744ab0b7ae = '#FFF0B3';
const $73a5c9d720aa66e1$export$1cc05bbbf340e559 = '#FFE380';
const $73a5c9d720aa66e1$export$5aae31392d72caaa = '#FFC400';
const $73a5c9d720aa66e1$export$c6930421db9fa514 = '#FFAB00';
const $73a5c9d720aa66e1$export$59619663aa6500fb = '#FF991F';
const $73a5c9d720aa66e1$export$874739ea9e379ab6 = '#FF8B00';
const $73a5c9d720aa66e1$export$8a6341c32b6a3ee6 = '#E3FCEF';
const $73a5c9d720aa66e1$export$69a3bf21b9686c2b = '#ABF5D1';
const $73a5c9d720aa66e1$export$afbce1382ec95f73 = '#79F2C0';
const $73a5c9d720aa66e1$export$747d86715d4175de = '#57D9A3';
const $73a5c9d720aa66e1$export$940e1f69e873f202 = '#36B37E';
const $73a5c9d720aa66e1$export$a49394138f7b8e85 = '#00875A';
const $73a5c9d720aa66e1$export$6fa04827ac68a4fb = '#006644';
const $73a5c9d720aa66e1$export$226de0355ed012f8 = '#DEEBFF';
const $73a5c9d720aa66e1$export$8c13c2ee36917869 = '#B3D4FF';
const $73a5c9d720aa66e1$export$ecfc1dff386a3e7a = '#4C9AFF';
const $73a5c9d720aa66e1$export$215b7063051591f1 = '#2684FF';
const $73a5c9d720aa66e1$export$e62e8919cca44969 = '#0065FF';
const $73a5c9d720aa66e1$export$b3de0ae08da2ce64 = '#0052CC';
const $73a5c9d720aa66e1$export$a6ee3d71bc067634 = '#0747A6';
const $73a5c9d720aa66e1$export$363e4475840015bb = '#EAE6FF';
const $73a5c9d720aa66e1$export$4b0a4417ed59760f = '#C0B6F2';
const $73a5c9d720aa66e1$export$6011520a64d9a187 = '#998DD9';
const $73a5c9d720aa66e1$export$a7175d4e9206bc80 = '#8777D9';
const $73a5c9d720aa66e1$export$b48405b95304b5a1 = '#6554C0';
const $73a5c9d720aa66e1$export$c71e4279dd54a18d = '#5243AA';
const $73a5c9d720aa66e1$export$147899de772240ec = '#403294';
const $73a5c9d720aa66e1$export$2cf711fe14c66f06 = '#E6FCFF';
const $73a5c9d720aa66e1$export$7a8f4d33f6f9772c = '#B3F5FF';
const $73a5c9d720aa66e1$export$776c9c497ef08533 = '#79E2F2';
const $73a5c9d720aa66e1$export$69cb3ca10c1e330e = '#00C7E6';
const $73a5c9d720aa66e1$export$9dc1ef0f3f48059b = '#00B8D9';
const $73a5c9d720aa66e1$export$7c835c78b6fcdef8 = '#00A3BF';
const $73a5c9d720aa66e1$export$6036577f95c3877e = '#008DA6';
const $73a5c9d720aa66e1$export$29a4f05edc054374 = '#FFFFFF';
const $73a5c9d720aa66e1$export$e655ef011c4aa1a2 = '#FAFBFC';
const $73a5c9d720aa66e1$export$9fdfb749e33cdf97 = '#F4F5F7';
const $73a5c9d720aa66e1$export$3e51e8f1440314ba = '#EBECF0';
const $73a5c9d720aa66e1$export$1ce2d1575d444ceb = '#DFE1E6';
const $73a5c9d720aa66e1$export$8754fc7e6d8b3000 = '#C1C7D0';
const $73a5c9d720aa66e1$export$c2e91cbeada39b8b = '#B3BAC5';
const $73a5c9d720aa66e1$export$5f71e19f3a7ad9de = '#A5ADBA';
const $73a5c9d720aa66e1$export$eaa8c8a70ac22806 = '#97A0AF';
const $73a5c9d720aa66e1$export$7c87d337fb91a97d = '#8993A4';
const $73a5c9d720aa66e1$export$d6447c357493214f = '#7A869A';
const $73a5c9d720aa66e1$export$f563ee71e9ee74cd = '#6B778C';
const $73a5c9d720aa66e1$export$e2ef2124cf4024b1 = '#5E6C84';
const $73a5c9d720aa66e1$export$eece5f492e429f08 = '#505F79';
const $73a5c9d720aa66e1$export$c39c0fe0f26207ae = '#42526E';
const $73a5c9d720aa66e1$export$7090862dc3038a9f = '#344563';
const $73a5c9d720aa66e1$export$ad0bacf983b7ddaa = '#253858';
const $73a5c9d720aa66e1$export$7d61b15e0da132af = '#172B4D';
const $73a5c9d720aa66e1$export$fbda843f0a27fe96 = '#091E42';
const $73a5c9d720aa66e1$export$791e57b27ca738ef = 'rgba(9, 30, 66, 0.02)';
const $73a5c9d720aa66e1$export$8d43898f60b96a82 = 'rgba(9, 30, 66, 0.04)';
const $73a5c9d720aa66e1$export$920c0d5c49070351 = 'rgba(9, 30, 66, 0.08)';
const $73a5c9d720aa66e1$export$46987b49aab6d1a8 = 'rgba(9, 30, 66, 0.13)';
const $73a5c9d720aa66e1$export$7d3359664e8bb0e5 = 'rgba(9, 30, 66, 0.25)';
const $73a5c9d720aa66e1$export$d2d3bedfb276cac0 = 'rgba(9, 30, 66, 0.31)';
const $73a5c9d720aa66e1$export$6e5e7499ff054f6d = 'rgba(9, 30, 66, 0.36)';
const $73a5c9d720aa66e1$export$59264b346c877fa7 = 'rgba(9, 30, 66, 0.42)';
const $73a5c9d720aa66e1$export$d092757d7c64925c = 'rgba(9, 30, 66, 0.48)';
const $73a5c9d720aa66e1$export$486ab785e4bac3c6 = 'rgba(9, 30, 66, 0.54)';
const $73a5c9d720aa66e1$export$fba592bbc6419fea = 'rgba(9, 30, 66, 0.60)';
const $73a5c9d720aa66e1$export$13609db0e6812ab8 = 'rgba(9, 30, 66, 0.66)';
const $73a5c9d720aa66e1$export$fbae4efaa892d883 = 'rgba(9, 30, 66, 0.71)';
const $73a5c9d720aa66e1$export$f13946d26f440ce6 = 'rgba(9, 30, 66, 0.77)';
const $73a5c9d720aa66e1$export$19f58225ac52a306 = 'rgba(9, 30, 66, 0.82)';
const $73a5c9d720aa66e1$export$6384f09da70e7b62 = 'rgba(9, 30, 66, 0.89)';
const $73a5c9d720aa66e1$export$d0dccc730683edc2 = 'rgba(9, 30, 66, 0.95)';
const $73a5c9d720aa66e1$export$2f6319cf7d736c2a = '#E6EDFA';
const $73a5c9d720aa66e1$export$95126bc8884d6634 = '#DCE5F5';
const $73a5c9d720aa66e1$export$8338d8c35d44ff1 = '#CED9EB';
const $73a5c9d720aa66e1$export$5368d76ae4fbbda7 = '#B8C7E0';
const $73a5c9d720aa66e1$export$9f0a771d16ec8d36 = '#ABBBD6';
const $73a5c9d720aa66e1$export$abcf8c38338b4aa5 = '#9FB0CC';
const $73a5c9d720aa66e1$export$97e81faa16a182c7 = '#8C9CB8';
const $73a5c9d720aa66e1$export$bfe21c59123ecf33 = '#7988A3';
const $73a5c9d720aa66e1$export$ee82aa2ea6a1558 = '#67758F';
const $73a5c9d720aa66e1$export$682927c6ed76be02 = '#56637A';
const $73a5c9d720aa66e1$export$91fd9994c5be9757 = '#455166';
const $73a5c9d720aa66e1$export$d281fbfe3cff2df6 = '#3B475C';
const $73a5c9d720aa66e1$export$3902c91d8b98a753 = '#313D52';
const $73a5c9d720aa66e1$export$8e8133c1ba5845b5 = '#283447';
const $73a5c9d720aa66e1$export$33ff357f6620b39 = '#202B3D';
const $73a5c9d720aa66e1$export$633847cf062b69e0 = '#1B2638';
const $73a5c9d720aa66e1$export$9776a6e503bdbf76 = '#121A29';
const $73a5c9d720aa66e1$export$6c813d5160dff5db = '#0E1624';
const $73a5c9d720aa66e1$export$3d4f271a500072a = '#0D1424';
const $73a5c9d720aa66e1$export$fe151285c22759ec = 'rgba(13, 20, 36, 0.06)';
const $73a5c9d720aa66e1$export$a101c6190d0da34 = 'rgba(13, 20, 36, 0.14)';
const $73a5c9d720aa66e1$export$4b16f52932fda51 = 'rgba(13, 20, 36, 0.18)';
const $73a5c9d720aa66e1$export$a74bcd7b9845b0d8 = 'rgba(13, 20, 36, 0.29)';
const $73a5c9d720aa66e1$export$9209c179316d1751 = 'rgba(13, 20, 36, 0.36)';
const $73a5c9d720aa66e1$export$88f55133f636c8dd = 'rgba(13, 20, 36, 0.40)';
const $73a5c9d720aa66e1$export$51126f85d1009512 = 'rgba(13, 20, 36, 0.47)';
const $73a5c9d720aa66e1$export$a069b547bd23af78 = 'rgba(13, 20, 36, 0.53)';
const $73a5c9d720aa66e1$export$40cce05af3b2600a = 'rgba(13, 20, 36, 0.63)';
const $73a5c9d720aa66e1$export$b78942185925a0d = 'rgba(13, 20, 36, 0.73)';
const $73a5c9d720aa66e1$export$e058fb44b8eaafca = 'rgba(13, 20, 36, 0.78)';
const $73a5c9d720aa66e1$export$92b0b8de26920c18 = 'rgba(13, 20, 36, 0.81)';
const $73a5c9d720aa66e1$export$67564f7459d3fc9e = 'rgba(13, 20, 36, 0.85)';
const $73a5c9d720aa66e1$export$77868e1ca884ffa3 = 'rgba(13, 20, 36, 0.89)';
const $73a5c9d720aa66e1$export$2afd71d7d3ea2cd5 = 'rgba(13, 20, 36, 0.92)';
const $73a5c9d720aa66e1$export$f2a0acaab9972c70 = 'rgba(13, 20, 36, 0.95)';
const $73a5c9d720aa66e1$export$9ab70e67d6475361 = 'rgba(13, 20, 36, 0.97)';


parcelRegister("brxwV", function(module, exports) {

$parcel$export(module.exports, "default", () => $8ac57de6175be933$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $hIuJI = parcelRequire("hIuJI");

var $7mYCs = parcelRequire("7mYCs");

var $89aMM = parcelRequire("89aMM");
function $8ac57de6175be933$var$useRadioState({ id: id, isSelected: isSelected, defaultSelected: defaultSelected }) {
    const { setGroupState: setGroupState, getGroupState: getGroupState } = (0, $eUqFw.useContext)((0, $7mYCs.SelectionStoreContext));
    const { id: group, radioGroupState: radioGroupState, selectRadioItem: selectRadioItem } = (0, $eUqFw.useContext)((0, $hIuJI.RadioGroupContext));
    const persistedIsSelected = radioGroupState[id];
    const [localIsSelected, setLocalIsSelected] = (0, $eUqFw.useState)(()=>persistedIsSelected !== undefined ? persistedIsSelected : defaultSelected || false);
    const setLocalState = (0, $eUqFw.useCallback)((newValue)=>{
        if (!persistedIsSelected) {
            const nextValue = newValue(persistedIsSelected);
            selectRadioItem(id, nextValue);
            setLocalIsSelected(nextValue);
        }
    }, [
        persistedIsSelected,
        id,
        selectRadioItem
    ]);
    /**
	 * - radio state changes any time a radio child is changed
	 * - when it changes we want all radio buttons to update their local state
	 * - it takes the value from radio group state and applies it locally if it exists which it will only exist, if it is selected
	 */ (0, $eUqFw.useEffect)(()=>{
        setLocalIsSelected(()=>{
            const existing = radioGroupState[id];
            return existing !== undefined ? existing : defaultSelected || false;
        });
    }, [
        radioGroupState,
        group,
        id,
        defaultSelected
    ]);
    if (typeof isSelected === 'boolean') return [
        isSelected,
        ()=>false
    ];
    if (persistedIsSelected === undefined) {
        const existing = getGroupState(group);
        setGroupState(group, {
            ...(0, $89aMM.default)(existing || {}),
            [id]: defaultSelected || false
        });
    }
    return [
        localIsSelected,
        setLocalState
    ];
}
var $8ac57de6175be933$export$2e2bcd8739ae039 = $8ac57de6175be933$var$useRadioState;

});
parcelRegister("hIuJI", function(module, exports) {

$parcel$export(module.exports, "RadioGroupContext", () => $4bf10c112f2f0cf0$export$a79eda4ff50e30b6);
$parcel$export(module.exports, "default", () => $4bf10c112f2f0cf0$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $5Q9wj = parcelRequire("5Q9wj");

var $ki32l = parcelRequire("ki32l");

var $8BKky = parcelRequire("8BKky");

var $lmkW0 = parcelRequire("lmkW0");

var $7mYCs = parcelRequire("7mYCs");

var $89aMM = parcelRequire("89aMM");
const $4bf10c112f2f0cf0$export$a79eda4ff50e30b6 = /*#__PURE__*/ (0, $eUqFw.createContext)({
    id: '',
    radioGroupState: {},
    selectRadioItem: (0, $5Q9wj.default)
});
/**
 * __Dropdown item radio group__
 *  Store which manages the selection state for each DropdownItemRadio
 *  across mount and unmounts.
 *
 */ const $4bf10c112f2f0cf0$var$DropdownItemRadioGroup = ({ children: children, hasSeparator: hasSeparator, id: id, isList: isList, isScrollable: isScrollable, overrides: overrides, testId: testId, title: title, // DSP-13312 TODO: remove spread props in future major release
...rest })=>{
    const { setGroupState: setGroupState, getGroupState: getGroupState } = (0, $eUqFw.useContext)((0, $7mYCs.SelectionStoreContext));
    const uid = (0, $ki32l.useId)();
    const titleId = `dropdown-menu-item-radio-group-title-${uid}`;
    /**
	 *  - initially `radioGroupState` is from selection store, so it's safe to update without re-rendering
	 *  - we flush a render by updating this local radio group state
	 */ const [radioGroupState, setRadioGroupState] = (0, $eUqFw.useState)(()=>getGroupState(id));
    const selectRadioItem = (childId, value)=>{
        const newValue = {
            ...(0, $89aMM.default)(getGroupState(id)),
            [childId]: value
        };
        setRadioGroupState(newValue);
        setGroupState(id, newValue);
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($4bf10c112f2f0cf0$export$a79eda4ff50e30b6.Provider, {
        value: {
            id: id,
            radioGroupState: radioGroupState,
            selectRadioItem: selectRadioItem
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8BKky.default), {
        hasSeparator: hasSeparator,
        id: id,
        isList: isList,
        isScrollable: isScrollable,
        // eslint-disable-next-line @repo/internal/react/no-unsafe-overrides, @atlaskit/design-system/no-deprecated-apis
        overrides: overrides,
        testId: testId,
        titleId: title ? titleId : undefined,
        ...rest
    }, title && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $lmkW0.default), {
        id: titleId,
        title: title
    }), children));
};
var $4bf10c112f2f0cf0$export$2e2bcd8739ae039 = $4bf10c112f2f0cf0$var$DropdownItemRadioGroup;

});
parcelRegister("lmkW0", function(module, exports) {

$parcel$export(module.exports, "default", () => $4c8b6b0ed3e98f7b$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $byn9U = parcelRequire("byn9U");


var $4lTFP = parcelRequire("4lTFP");
const $4c8b6b0ed3e98f7b$var$itemHeadingContentHeight = (0, $4lTFP.headingSizes).h100.lineHeight;
const $4c8b6b0ed3e98f7b$var$itemHeadingFontSize = (0, $4lTFP.headingSizes).h100.size;
const $4c8b6b0ed3e98f7b$var$headingStyles = /*#__PURE__*/ (0, $byn9U.css)({
    color: `var(--ds-text-subtle, ${(0, $73a5c9d720aa66e1$export$e2ef2124cf4024b1)})`,
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    fontSize: $4c8b6b0ed3e98f7b$var$itemHeadingFontSize,
    fontWeight: "var(--ds-font-weight-bold, 700)",
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    lineHeight: $4c8b6b0ed3e98f7b$var$itemHeadingContentHeight / $4c8b6b0ed3e98f7b$var$itemHeadingFontSize,
    paddingBlock: "var(--ds-space-0, 0px)",
    paddingInline: "var(--ds-space-200, 16px)",
    textTransform: 'uppercase'
});
/**
 * __Group title__
 *
 * Used to visually represent the title for DropdownMenu groups
 *
 * @internal
 */ const $4c8b6b0ed3e98f7b$var$GroupTitle = ({ id: id, title: title })=>/*#__PURE__*/ (0, $byn9U.jsx)("div", {
        "data-ds--menu--heading-item": true,
        role: "menuitem",
        id: id,
        "aria-hidden": "true",
        css: $4c8b6b0ed3e98f7b$var$headingStyles
    }, title);
var $4c8b6b0ed3e98f7b$export$2e2bcd8739ae039 = $4c8b6b0ed3e98f7b$var$GroupTitle;

});

parcelRegister("89aMM", function(module, exports) {

$parcel$export(module.exports, "default", () => $669f816b2109040a$export$2e2bcd8739ae039);
const $669f816b2109040a$var$resetOptionsInGroup = (group)=>{
    return Object.keys(group || {}).reduce((accumulator, current)=>({
            ...accumulator,
            [current]: typeof group[current] === 'undefined' ? undefined : false
        }), {});
};
var $669f816b2109040a$export$2e2bcd8739ae039 = $669f816b2109040a$var$resetOptionsInGroup;

});



parcelRegister("efWFe", function(module, exports) {

$parcel$export(module.exports, "default", () => $040ecfdbbd3bc304$export$2e2bcd8739ae039);
const $040ecfdbbd3bc304$var$canUseDOM = ()=>Boolean(typeof window !== 'undefined' && window.document && window.document.createElement);
/*
 * Making sure we can fallback to browsers doesn't support voice over -
 * we would using menuitemcheckbox / menuitemradio for these that supports voice over, and
 * will fallback to checkbox / radio for these doesn't
 */ const $040ecfdbbd3bc304$var$isVoiceOverSupported = ()=>/Mac OS X/.test($040ecfdbbd3bc304$var$canUseDOM() ? navigator.userAgent : '');
var $040ecfdbbd3bc304$export$2e2bcd8739ae039 = $040ecfdbbd3bc304$var$isVoiceOverSupported;

});


parcelRegister("eNjET", function(module, exports) {

$parcel$export(module.exports, "useOrderByOpenState", () => $fa07b5eb711ba6fd$export$32869ae0582ab3ff);

var $1yZQx = parcelRequire("1yZQx");
var $kEDjj = parcelRequire("kEDjj");
var $2HpOy = parcelRequire("2HpOy");
const $fa07b5eb711ba6fd$var$Store = (0, $kEDjj.createStore)({
    initialState: {
        isOpen: false
    },
    actions: {
        open: ()=>({ setState: setState })=>{
                setState({
                    isOpen: true
                });
            },
        close: ()=>({ setState: setState })=>{
                setState({
                    isOpen: false
                });
            }
    },
    name: 'IssueNavigatorOrderByOpenState'
});
const $fa07b5eb711ba6fd$export$2ba8216bf1290828 = (0, $2HpOy.createSubscriber)($fa07b5eb711ba6fd$var$Store);
const $fa07b5eb711ba6fd$export$32869ae0582ab3ff = (0, $1yZQx.createHook)($fa07b5eb711ba6fd$var$Store);

});

parcelRegister("7aM56", function(module, exports) {

$parcel$export(module.exports, "default", () => $2c750902a6922dd7$export$2e2bcd8739ae039);
$parcel$export(module.exports, "messageLookup", () => $2c750902a6922dd7$export$3a16bd55b6aaaf91);

var $90IgZ = parcelRequire("90IgZ");
/* eslint-disable jira/i18n/id-named-by-package */ const $2c750902a6922dd7$var$messages = (0, $90IgZ.defineMessages)({
    loading: {
        "id": "issue-navigator.card-container.order-dropdown.loading",
        "defaultMessage": "Loading"
    },
    fieldGroup: {
        "id": "issue-navigator.card-container.order-dropdown.field-group",
        "defaultMessage": "Order issues by"
    },
    created: {
        "id": "issue-navigator.card-container.order-dropdown.created",
        "defaultMessage": "Created"
    },
    updated: {
        "id": "issue-navigator.card-container.order-dropdown.updated",
        "defaultMessage": "Updated"
    },
    lastviewed: {
        "id": "issue-navigator.card-container.order-dropdown.lastviewed",
        "defaultMessage": "Last viewed"
    },
    status: {
        "id": "issue-navigator.card-container.order-dropdown.status",
        "defaultMessage": "Status"
    },
    priority: {
        "id": "issue-navigator.card-container.order-dropdown.priority",
        "defaultMessage": "Priority"
    },
    assignee: {
        "id": "issue-navigator.card-container.order-dropdown.assignee",
        "defaultMessage": "Assignee"
    },
    resolved: {
        "id": "issue-navigator.card-container.order-dropdown.resolved",
        "defaultMessage": "Resolved"
    },
    issuekey: {
        "id": "issue-navigator.card-container.order-dropdown.issuekey",
        "defaultMessage": "Key"
    },
    key: {
        "id": "issue-navigator.card-container.order-dropdown.key",
        "defaultMessage": "Key"
    },
    issuetype: {
        "id": "issue-navigator.card-container.order-dropdown.issuetype",
        "defaultMessage": "Issue Type"
    },
    duedate: {
        "id": "issue-navigator.card-container.order-dropdown.duedate",
        "defaultMessage": "Due date"
    },
    summary: {
        "id": "issue-navigator.card-container.order-dropdown.summary",
        "defaultMessage": "Summary"
    },
    reporter: {
        "id": "issue-navigator.card-container.order-dropdown.reporter",
        "defaultMessage": "Reporter"
    },
    customField: {
        "id": "issue-navigator.card-container.order-dropdown.custom-field",
        "defaultMessage": "Custom field"
    },
    defaultLabel: {
        "id": "issue-navigator.card-container.order-dropdown.default-label",
        "defaultMessage": "Order by"
    }
});
var $2c750902a6922dd7$export$2e2bcd8739ae039 = $2c750902a6922dd7$var$messages;
const $2c750902a6922dd7$export$3a16bd55b6aaaf91 = $2c750902a6922dd7$var$messages;

});


parcelRegister("kxyTJ", function(module, exports) {

$parcel$export(module.exports, "default", () => $9421a0b368682070$export$2e2bcd8739ae039);

var $dQEQi = parcelRequire("dQEQi");

var $7JEyt = parcelRequire("7JEyt");

var $eUqFw = parcelRequire("eUqFw");

var $iWLL0 = parcelRequire("iWLL0");

var $7u4fN = parcelRequire("7u4fN");

var $dXKde = parcelRequire("dXKde");

var $dwj4T = parcelRequire("dwj4T");

var $8cU5f = parcelRequire("8cU5f");

var $9aFSa = parcelRequire("9aFSa");

var $7uIWw = parcelRequire("7uIWw");

var $5JgJ2 = parcelRequire("5JgJ2");

var $jMP2a = parcelRequire("jMP2a");
var $bFzGY = parcelRequire("bFzGY");

var $a1tkg = parcelRequire("a1tkg");

var $cQBUE = parcelRequire("cQBUE");

var $4LIKY = parcelRequire("4LIKY");
const $9421a0b368682070$var$getLastPage = (pageCursors)=>{
    if (pageCursors?.last) return pageCursors.last.pageNumber;
    if (pageCursors?.around?.length) return pageCursors.around[pageCursors.around.length - 1]?.pageNumber;
    return undefined;
};
const $9421a0b368682070$var$getPageCursor = (pageCursors, page)=>{
    const { first: first, last: last, around: around } = pageCursors ?? {};
    if (page === first?.pageNumber) return first?.cursor ?? undefined;
    if (page === last?.pageNumber) return last?.cursor ?? undefined;
    return around?.find((pageCursor)=>page === pageCursor?.pageNumber)?.cursor ?? undefined;
};
const $9421a0b368682070$var$TooltipTag = /*#__PURE__*/ (0, $eUqFw.forwardRef)((props, ref)=>// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($9421a0b368682070$var$StyledTooltipTag, {
        ref: ref,
        ...props
    }));
const $9421a0b368682070$var$Paginator = ({ issueResults: issueResults })=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const data = (0, $iWLL0.useFragment)((0, $dQEQi.default), issueResults);
    const currentPage = data.pageCursors?.around?.find((pageCursor)=>pageCursor?.isCurrent)?.pageNumber ?? 1;
    const lastPage = $9421a0b368682070$var$getLastPage(data.pageCursors) ?? 1;
    const { isFetching: isFetching, isStalePage: isStalePage, onIssueSearchForPage: onIssueSearchForPage } = (0, $cQBUE.useIssueSearchQuery)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bFzGY.useAnalyticsEvents)();
    const onChange = (0, $eUqFw.useCallback)((pageNumber)=>{
        // @ts-expect-error - Argument of type '{ readonly around: readonly ({ readonly cursor: string | null | undefined; readonly isCurrent: boolean | null | undefined; readonly pageNumber: number | null | undefined; } | null | undefined)[] | null | undefined; readonly first: { ...; } | ... 1 more ... | undefined; readonly last: { ...; } | ... 1 more ... | unde...' is not assignable to parameter of type '{ readonly around: readonly ({ readonly cursor: string | null | undefined; readonly isCurrent: boolean | null | undefined; readonly pageNumber: number | null | undefined; } | null | undefined)[] | null | undefined; readonly first: { ...; } | ... 1 more ... | undefined; readonly last: { ...; } | ... 1 more ... | unde...'.
        const pageCursor = $9421a0b368682070$var$getPageCursor(data.pageCursors, pageNumber);
        if (pageCursor == null) return;
        onIssueSearchForPage(pageCursor);
        (0, $jMP2a.fireUIAnalytics)(createAnalyticsEvent({
            action: 'changed',
            actionSubject: 'pageNumber'
        }), 'issueListPagination', {
            currentPage: currentPage,
            nextPage: pageNumber
        });
    }, [
        data.pageCursors,
        onIssueSearchForPage,
        createAnalyticsEvent,
        currentPage
    ]);
    const onChangePrevious = (0, $eUqFw.useCallback)(()=>onChange(currentPage - 1), [
        currentPage,
        onChange
    ]);
    const onChangeNext = (0, $eUqFw.useCallback)(()=>onChange(currentPage + 1), [
        currentPage,
        onChange
    ]);
    const keyMap = (0, $eUqFw.useMemo)(()=>({
            arrowleft: {
                callback: onChangePrevious,
                label: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", null, formatMessage((0, $4LIKY.default).nextPageShortcutLabel))
            },
            arrowright: {
                callback: onChangeNext,
                label: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", null, formatMessage((0, $4LIKY.default).prevPageShortcutLabel))
            }
        }), [
        formatMessage,
        onChangeNext,
        onChangePrevious
    ]);
    const totalIssues = data.totalIssueSearchResultCount ?? 0;
    if (totalIssues === 0 || isFetching || isStalePage) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($9421a0b368682070$var$StyledContainer, {
        "data-testid": "issue-navigator.ui.issue-results.detail-view.card-container.paginator"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $9aFSa.default), {
        keyMap: keyMap
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7u4fN.default), {
        iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($dXKde))), {
            label: formatMessage((0, $4LIKY.default).prevPageButton)
        }),
        appearance: "subtle",
        onClick: onChangePrevious,
        isDisabled: currentPage === 1,
        testId: "issue-navigator.ui.issue-results.detail-view.card-container.paginator.prev-button"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($9421a0b368682070$var$PageAndCountContainer, {
        "data-testid": "issue-navigator.ui.issue-results.detail-view.card-container.paginator.div"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $a1tkg.default), {
        startIssueRange: data.issueNavigatorPageInfo?.firstIssuePosition ?? 0,
        endIssueRange: data.issueNavigatorPageInfo?.lastIssuePosition ?? 0,
        total: totalIssues,
        countExceedsMaxResults: !!data.isCappingIssueSearchResult
    })), currentPage === lastPage && data?.isCappingIssueSearchResult ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8cU5f.default), {
        content: formatMessage((0, $4LIKY.default).disabledButtonTooltip),
        tag: $9421a0b368682070$var$TooltipTag
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7uIWw.default), {
        tabIndex: 0,
        isDisabled: true,
        "aria-label": formatMessage((0, $4LIKY.default).disabledButtonTooltip),
        "data-testid": "issue-navigator.ui.issue-results.detail-view.card-container.paginator.next-disabled-button"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7u4fN.default), {
        iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($dwj4T))), {
            label: formatMessage((0, $4LIKY.default).nextPageButton)
        }),
        appearance: "subtle",
        isDisabled: true,
        onClick: onChangeNext,
        testId: "issue-navigator.ui.issue-results.detail-view.card-container.paginator.next-button"
    }))) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7u4fN.default), {
        iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($dwj4T))), {
            label: formatMessage((0, $4LIKY.default).nextPageButton)
        }),
        appearance: "subtle",
        isDisabled: currentPage === lastPage,
        onClick: onChangeNext,
        testId: "issue-navigator.ui.issue-results.detail-view.card-container.paginator.next-button"
    }));
};
var $9421a0b368682070$export$2e2bcd8739ae039 // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
 = $9421a0b368682070$var$Paginator;
const $9421a0b368682070$var$StyledContainer = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_16jlkb7n _1o9zkb7n _i0dlf1ug _1e0c1txw _4cvr1h6o _1bah1yb4 _syaz1rc1",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $9421a0b368682070$var$PageAndCountContainer = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _4cvr1h6o _1bah1h6o",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $9421a0b368682070$var$StyledTooltipTag = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c116y",
            __cmplp.className
        ])
    });
});

});
parcelRegister("dQEQi", function(module, exports) {

$parcel$export(module.exports, "default", () => $e4bba3bd0a5e13ba$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<eac20d88dcaa529e2cd27fff9885a4df>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $e4bba3bd0a5e13ba$var$node = function() {
    var v0 = [
        {
            "kind": "ScalarField",
            "name": "cursor"
        },
        {
            "kind": "ScalarField",
            "name": "pageNumber"
        },
        {
            "kind": "ScalarField",
            "name": "isCurrent"
        }
    ];
    return {
        "argumentDefinitions": [],
        "kind": "Fragment",
        "name": "main_issueNavigator_Paginator",
        "selections": [
            {
                "kind": "ScalarField",
                "name": "totalIssueSearchResultCount"
            },
            {
                "kind": "ScalarField",
                "name": "isCappingIssueSearchResult"
            },
            {
                "concreteType": "JiraIssueNavigatorPageInfo",
                "kind": "LinkedField",
                "name": "issueNavigatorPageInfo",
                "plural": false,
                "selections": [
                    {
                        "kind": "ScalarField",
                        "name": "firstIssuePosition"
                    },
                    {
                        "kind": "ScalarField",
                        "name": "lastIssuePosition"
                    }
                ]
            },
            {
                "args": [
                    {
                        "kind": "Literal",
                        "name": "maxCursors",
                        "value": 7
                    }
                ],
                "concreteType": "JiraPageCursors",
                "kind": "LinkedField",
                "name": "pageCursors",
                "plural": false,
                "selections": [
                    {
                        "concreteType": "JiraPageCursor",
                        "kind": "LinkedField",
                        "name": "first",
                        "plural": false,
                        "selections": v0 /*: any*/ 
                    },
                    {
                        "concreteType": "JiraPageCursor",
                        "kind": "LinkedField",
                        "name": "around",
                        "plural": true,
                        "selections": v0 /*: any*/ 
                    },
                    {
                        "concreteType": "JiraPageCursor",
                        "kind": "LinkedField",
                        "name": "last",
                        "plural": false,
                        "selections": v0 /*: any*/ 
                    }
                ],
                "storageKey": "pageCursors(maxCursors:7)"
            }
        ],
        "type": "JiraIssueConnection"
    };
}();
$e4bba3bd0a5e13ba$var$node.hash = "a148b81aa698fb69850df944c78ece55";
var $e4bba3bd0a5e13ba$export$2e2bcd8739ae039 = $e4bba3bd0a5e13ba$var$node;

});

parcelRegister("dXKde", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $a2a4a1e4b9148f86$var$_react = $a2a4a1e4b9148f86$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $igPbh = parcelRequire("igPbh");

var $a2a4a1e4b9148f86$var$_chevronLeft = $a2a4a1e4b9148f86$var$_interopRequireDefault((parcelRequire("a4cVy")));
function $a2a4a1e4b9148f86$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
const $a2a4a1e4b9148f86$var$ChevronLeftLargeIcon = (props)=>/*#__PURE__*/ $a2a4a1e4b9148f86$var$_react.default.createElement($igPbh.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="m9.005 10.995 4.593-4.593a.99.99 0 1 1 1.4 1.4l-3.9 3.9 3.9 3.9a.99.99 0 0 1-1.4 1.4L9.005 12.41a1 1 0 0 1 0-1.414"/></svg>`
    }, props, {
        newIcon: $a2a4a1e4b9148f86$var$_chevronLeft.default,
        iconType: "utility"
    }));
$a2a4a1e4b9148f86$var$ChevronLeftLargeIcon.displayName = 'ChevronLeftLargeIcon';
var $a2a4a1e4b9148f86$var$_default = module.exports.default = $a2a4a1e4b9148f86$var$ChevronLeftLargeIcon;

});
parcelRegister("a4cVy", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::db781ab5297a2cc1540c99d75921a718>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $75444e382f2d4220$var$_react = $75444e382f2d4220$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $75444e382f2d4220$var$_UNSAFE_baseNew = $75444e382f2d4220$var$_interopRequireDefault((parcelRequire("gCIXy")));
function $75444e382f2d4220$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 * Please reach out in #icon-contributions before using these in production.
 *
 * Icon: "ChevronLeft".
 * Category: utility
 * Location: @atlaskit/icon
 * Usage guidance: Reserved for collapse side nav and to indicate previous in dates.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $75444e382f2d4220$var$ChevronLeftIcon = (props)=>/*#__PURE__*/ $75444e382f2d4220$var$_react.default.createElement($75444e382f2d4220$var$_UNSAFE_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path stroke="currentcolor" stroke-linejoin="round" stroke-width="1.5" d="M7.5 10.5 3 6l4.5-4.5"/>`,
        type: 'utility'
    }, props));
$75444e382f2d4220$var$ChevronLeftIcon.displayName = 'ChevronLeftIcon';
var $75444e382f2d4220$var$_default = module.exports.default = $75444e382f2d4220$var$ChevronLeftIcon;

});


parcelRegister("dwj4T", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $9d7d0ffff46f5f00$var$_react = $9d7d0ffff46f5f00$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $igPbh = parcelRequire("igPbh");

var $9d7d0ffff46f5f00$var$_chevronRight = $9d7d0ffff46f5f00$var$_interopRequireDefault((parcelRequire("fCmfi")));
function $9d7d0ffff46f5f00$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
const $9d7d0ffff46f5f00$var$ChevronRightLargeIcon = (props)=>/*#__PURE__*/ $9d7d0ffff46f5f00$var$_react.default.createElement($igPbh.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="M14.995 10.995a1 1 0 0 1 0 1.414l-4.593 4.593a.99.99 0 0 1-1.4-1.4l3.9-3.9-3.9-3.9a.99.99 0 0 1 1.4-1.4z"/></svg>`
    }, props, {
        newIcon: $9d7d0ffff46f5f00$var$_chevronRight.default,
        iconType: "utility"
    }));
$9d7d0ffff46f5f00$var$ChevronRightLargeIcon.displayName = 'ChevronRightLargeIcon';
var $9d7d0ffff46f5f00$var$_default = module.exports.default = $9d7d0ffff46f5f00$var$ChevronRightLargeIcon;

});

parcelRegister("a1tkg", function(module, exports) {

$parcel$export(module.exports, "default", () => $2786d7d96d357760$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $5JgJ2 = parcelRequire("5JgJ2");

var $g3uGD = parcelRequire("g3uGD");

var $jBPYs = parcelRequire("jBPYs");
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$2786d7d96d357760$export$2e2bcd8739ae039 = ({ startIssueRange: startIssueRange, endIssueRange: endIssueRange, total: total, countExceedsMaxResults: countExceedsMaxResults })=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    if (total <= 0) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, formatMessage((0, $jBPYs.default).issueRangeUnknown, {
        startIssueRange: startIssueRange,
        endIssueRange: endIssueRange
    }));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $g3uGD.default), {
        prependMessage: (0, $jBPYs.default).issueRangeKnown,
        prependMessageValues: {
            startIssueRange: startIssueRange,
            endIssueRange: endIssueRange
        },
        stableCount: total,
        isCapped: countExceedsMaxResults
    });
};

});
parcelRegister("jBPYs", function(module, exports) {

$parcel$export(module.exports, "default", () => $692125d6ec524a42$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $692125d6ec524a42$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    issueRangeKnown: {
        "id": "issue-navigator.card-container.paginator.issue-range-known",
        "defaultMessage": "{startIssueRange}-{endIssueRange} of {totalNumberIssues}"
    },
    issueRangeUnknown: {
        "id": "issue-navigator.card-container.paginator.issue-range-unknown",
        "defaultMessage": "{startIssueRange}-{endIssueRange}"
    }
});

});


parcelRegister("4LIKY", function(module, exports) {

$parcel$export(module.exports, "default", () => $85d1ebcc01df7186$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $85d1ebcc01df7186$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    nextPageShortcutLabel: {
        "id": "issue-navigator.issue-results.detail-view.card-container.paginator.next-page-shortcut-label",
        "defaultMessage": "Next page"
    },
    prevPageShortcutLabel: {
        "id": "issue-navigator.issue-results.detail-view.card-container.paginator.prev-page-shortcut-label",
        "defaultMessage": "Previous page"
    },
    prevPageButton: {
        "id": "issue-navigator.issue-results.detail-view.card-container.paginator.prev-page-button",
        "defaultMessage": "Previous page"
    },
    nextPageButton: {
        "id": "issue-navigator.issue-results.detail-view.card-container.paginator.next-page-button",
        "defaultMessage": "Next page"
    },
    disabledButtonTooltip: {
        "id": "issue-navigator.issue-results.detail-view.card-container.paginator.disabled-button-tooltip",
        "defaultMessage": "We can\u2019t load more pages. Refine your search criteria to see more issues."
    }
});

});


parcelRegister("4bsMQ", function(module, exports) {

$parcel$export(module.exports, "default", () => $567b73d4957820de$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $jG2Eu = parcelRequire("jG2Eu");

var $j9fWg = parcelRequire("j9fWg");

var $2ziLQ = parcelRequire("2ziLQ");

var $8cU5f = parcelRequire("8cU5f");

var $5JgJ2 = parcelRequire("5JgJ2");

var $jMP2a = parcelRequire("jMP2a");
var $bFzGY = parcelRequire("bFzGY");

var $jccNB = parcelRequire("jccNB");

var $2ycZm = parcelRequire("2ycZm");

var $l4Fde = parcelRequire("l4Fde");

var $bYbFf = parcelRequire("bYbFf");

var $dDisy = parcelRequire("dDisy");
class $567b73d4957820de$export$e464399b18ba2124 extends (0, $eUqFw.Component) {
    static{
        this.defaultProps = {
            onSort: (0, (/*@__PURE__*/$parcel$interopDefault($jG2Eu)))
        };
    }
    shouldComponentUpdate(nextProps) {
        return this.props.sortDirection !== nextProps.sortDirection || this.props.isDisabled !== nextProps.isDisabled;
    }
    render() {
        const { intl: { formatMessage: formatMessage }, sortDirection: sortDirection, isDisabled: isDisabled } = this.props;
        const tooltipText = sortDirection === (0, $jccNB.sortDirections).ASC ? formatMessage((0, $dDisy.default).tooltipAsc) : formatMessage((0, $dDisy.default).tooltipDesc);
        const glyph = sortDirection === (0, $jccNB.sortDirections).ASC ? (0, $bYbFf.ArrowUpIcon) : (0, $l4Fde.ArrowDownIcon);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8cU5f.default), {
            content: tooltipText
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $j9fWg.default), {
            appearance: "subtle",
            onClick: this.onClick,
            testId: "issue-navigator.ui.issue-results.detail-view.card-container.sort-button.sort-button",
            isDisabled: isDisabled,
            icon: (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $2ziLQ.default), {
                    ...props,
                    size: "small",
                    glyph: glyph
                }),
            label: tooltipText
        }));
    }
    constructor(...args){
        super(...args);
        this.onClick = ()=>{
            const { onSort: onSort, sortDirection: sortDirection } = this.props;
            const newSortDirection = sortDirection === (0, $jccNB.sortDirections).ASC ? (0, $jccNB.sortDirections).DESC : (0, $jccNB.sortDirections).ASC;
            onSort(newSortDirection);
        };
    }
}
const $567b73d4957820de$export$86b24d49f595c6f2 = (props)=>{
    const intl = (0, $5JgJ2.default)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bFzGY.useAnalyticsEvents)();
    const [{ field: field, direction: direction }, { setFieldAndDirection: setFieldAndDirection }] = (0, $2ycZm.useSortFieldAndDirection)();
    const handleOnSort = (0, $eUqFw.useCallback)((newSortDirection)=>{
        typeof field === 'string' && setFieldAndDirection(field, newSortDirection, []);
        const analyticsEvent = createAnalyticsEvent({
            action: 'clicked',
            actionSubject: 'button'
        });
        const orderField = field ? (0, $jccNB.supportedOrderFields)[(0, $jccNB.getSupportedFieldForAlias)(field) ?? field] : undefined;
        (0, $jMP2a.fireUIAnalytics)(analyticsEvent, 'sortOrderChangeButton', {
            fieldType: orderField?.fieldType ?? null,
            sortOrder: newSortDirection
        });
        return true;
    }, [
        createAnalyticsEvent,
        field,
        setFieldAndDirection
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($567b73d4957820de$export$e464399b18ba2124, {
        isDisabled: typeof field !== 'string',
        sortDirection: direction,
        onSort: handleOnSort,
        ...props,
        intl: intl
    });
};
var $567b73d4957820de$export$2e2bcd8739ae039 = $567b73d4957820de$export$86b24d49f595c6f2;

});
parcelRegister("l4Fde", function(module, exports) {

$parcel$export(module.exports, "ArrowDownIcon", () => $4fc098f2b37ee2c6$export$1c939d3c9b6931b);

var $eUqFw = parcelRequire("eUqFw");
const $4fc098f2b37ee2c6$export$1c939d3c9b6931b = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("svg", {
        ...props,
        width: "24px",
        height: "24px",
        viewBox: "0 0 24 24",
        version: "1.1",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("g", {
        stroke: "none",
        strokeWidth: "1",
        fill: "none",
        fillRule: "evenodd"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M6.8,4.3 C6.6,4.1 6.3,4 6,4 C5.7,4 5.4,4.1 5.2,4.3 L2.3,7.2 C1.9,7.6 1.9,8.3 2.3,8.7 C2.7,9.1 3.3,9.1 3.7,8.7 L5,7.4 L5,19.1 C5,19.6 5.4,20 6,20 C6.6,20 7,19.6 7,19.1 L7,7.4 L8.3,8.7 C8.7,9.1 9.3,9.1 9.7,8.7 C10.1,8.3 10.1,7.6 9.7,7.2 C9.04754611,6.54754611 8.5582057,6.0582057 8.23197876,5.73197876 C7.91376126,5.41376126 7.436435,4.936435 6.8,4.3 Z",
        id: "Path",
        fill: "currentColor",
        fillRule: "nonzero",
        transform: "translate(6.000000, 12.000000) rotate(180.000000) translate(-6.000000, -12.000000) "
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M21,5 L13,5 C12.4,5 12,5.4 12,6 C12,6.6 12.4,7 13,7 L21,7 C21.6,7 22,6.6 22,6 C22,5.4 21.6,5 21,5 Z",
        id: "Path",
        fill: "currentColor",
        fillRule: "nonzero"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M13,13 L18,13 C18.6,13 19,12.6 19,12 C19,11.4 18.6,11 18,11 L13,11 C12.4,11 12,11.4 12,12 C12,12.6 12.4,13 13,13 Z",
        id: "Path",
        fill: "currentColor",
        fillRule: "nonzero"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M13,19 L16,19 C16.6,19 17,18.6 17,18 C17,17.4 16.6,17 16,17 L13,17 C12.4,17 12,17.4 12,18 C12,18.6 12.4,19 13,19 Z",
        id: "Path",
        fill: "currentColor",
        fillRule: "nonzero"
    })));

});

parcelRegister("bYbFf", function(module, exports) {

$parcel$export(module.exports, "ArrowUpIcon", () => $0df80519a043ecad$export$f1a507b991affc46);

var $eUqFw = parcelRequire("eUqFw");
const $0df80519a043ecad$export$f1a507b991affc46 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("svg", {
        ...props,
        width: "24px",
        height: "24px",
        viewBox: "0 0 24 24",
        version: "1.1",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("g", {
        stroke: "none",
        strokeWidth: "1",
        fill: "none",
        fillRule: "evenodd"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M7.8,4.3 C7.6,4.1 7.3,4 7,4 C6.7,4 6.4,4.1 6.2,4.3 L3.3,7.2 C2.9,7.6 2.9,8.3 3.3,8.7 C3.7,9.1 4.3,9.1 4.7,8.7 L6,7.4 L6,19.1 C6,19.6 6.4,20 7,20 C7.6,20 8,19.6 8,19.1 L8,7.4 L9.3,8.7 C9.7,9.1 10.3,9.1 10.7,8.7 C11.1,8.3 11.1,7.6 10.7,7.2 C10.0475461,6.54754611 9.5582057,6.0582057 9.23197876,5.73197876 C8.91376126,5.41376126 8.436435,4.936435 7.8,4.3 Z",
        id: "Path",
        fill: "currentColor",
        fillRule: "nonzero"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M21,17 L13,17 C12.4,17 12,17.4 12,18 C12,18.6 12.4,19 13,19 L21,19 C21.6,19 22,18.6 22,18 C22,17.4 21.6,17 21,17 Z",
        id: "Path",
        fill: "currentColor",
        fillRule: "nonzero"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M13,13 L18,13 C18.6,13 19,12.6 19,12 C19,11.4 18.6,11 18,11 L13,11 C12.4,11 12,11.4 12,12 C12,12.6 12.4,13 13,13 Z",
        id: "Path",
        fill: "currentColor",
        fillRule: "nonzero"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M13,7 L16,7 C16.6,7 17,6.6 17,6 C17,5.4 16.6,5 16,5 L13,5 C12.4,5 12,5.4 12,6 C12,6.6 12.4,7 13,7 Z",
        id: "Path",
        fill: "currentColor",
        fillRule: "nonzero"
    })));

});

parcelRegister("dDisy", function(module, exports) {

$parcel$export(module.exports, "default", () => $41fa97ba4f41941a$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var /* eslint-disable jira/i18n/id-named-by-package */ $41fa97ba4f41941a$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    tooltipAsc: {
        "id": "issue-navigator.card-container.sort-button.tooltip-asc",
        "defaultMessage": "Sort ascending"
    },
    tooltipDesc: {
        "id": "issue-navigator.card-container.sort-button.tooltip-desc",
        "defaultMessage": "Sort descending"
    }
});

});



parcelRegister("3Jl0V", function(module, exports) {

$parcel$export(module.exports, "default", () => $f21a8ed6276ba002$export$2e2bcd8739ae039);

var $9gGa1 = parcelRequire("9gGa1");

var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $iWLL0 = parcelRequire("iWLL0");

var $eI5EY = parcelRequire("eI5EY");

var $5JgJ2 = parcelRequire("5JgJ2");

var $jMP2a = parcelRequire("jMP2a");
var $bFzGY = parcelRequire("bFzGY");

var $jccNB = parcelRequire("jccNB");

var $3wKQY = parcelRequire("3wKQY");

var $cWCvn = parcelRequire("cWCvn");

var $1ydM0 = parcelRequire("1ydM0");

var $3wPFH = parcelRequire("3wPFH");
var $fNFQe = parcelRequire("fNFQe");

var $1EVUo = parcelRequire("1EVUo");

var $fluRZ = parcelRequire("fluRZ");

var $hrpGF = parcelRequire("hrpGF");

var $h75Xv = parcelRequire("h75Xv");
const $f21a8ed6276ba002$var$BLANK_CARD_ANALYTICS_ID = 'blankIssueCard';
const $f21a8ed6276ba002$var$ISSUE_CARD_ANALYTICS_ID = 'issueCard';
const $f21a8ed6276ba002$var$CardWithAnalytics = ({ index: index, fragment: fragment })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bFzGY.useAnalyticsEvents)();
    const [selectedIssueIndex, { setSelectedIssueByIndex: setSelectedIssueByIndex }] = (0, $1ydM0.useSelectedIssueIndex)();
    const [focusedIssueIndex, { setFocusedIssueByIndex: setFocusedIssueByIndex }] = (0, $1ydM0.useFocusedIssueIndex)();
    const isSelected = selectedIssueIndex === index;
    const isFocused = focusedIssueIndex === index;
    const cardRef = (0, $eUqFw.useRef)(null);
    (0, $eUqFw.useLayoutEffect)(()=>{
        if (isSelected) {
            // Scroll to the card whenever it is selected and focus on it
            cardRef.current?.scrollIntoView && cardRef.current?.scrollIntoView({
                block: 'nearest'
            });
            isFocused && cardRef.current?.focus();
        }
    }, [
        isSelected,
        isFocused
    ]);
    const onClickWithAnalytics = (0, $eUqFw.useCallback)((event)=>{
        const id = fragment ? $f21a8ed6276ba002$var$ISSUE_CARD_ANALYTICS_ID : $f21a8ed6276ba002$var$BLANK_CARD_ANALYTICS_ID;
        const attributes = {
            keyboardShortcut: false,
            issueIndex: index + 1
        };
        if ((0, $3wKQY.isNormalClick)(event)) {
            event.preventDefault();
            const analyticsEvent = createAnalyticsEvent({
                action: 'selected',
                actionSubject: 'card'
            });
            (0, $jMP2a.fireUIAnalytics)(analyticsEvent, id, attributes);
        } else if ((0, $eI5EY.fg)('nin_critical_accessibility_issues')) {
            const analyticsEvent = createAnalyticsEvent({
                action: 'clicked',
                actionSubject: 'card'
            });
            (0, $jMP2a.fireUIAnalytics)(analyticsEvent, id, attributes);
        }
    }, [
        createAnalyticsEvent,
        fragment,
        index
    ]);
    const onCardFocus = (0, $eUqFw.useCallback)(()=>{
        setFocusedIssueByIndex(index);
        setSelectedIssueByIndex(index, true);
    }, [
        index,
        setFocusedIssueByIndex,
        setSelectedIssueByIndex
    ]);
    const onContextMenuHandler = (0, $eUqFw.useCallback)(()=>{
        const analyticsEvent = createAnalyticsEvent({
            action: 'contextMenu clicked',
            actionSubject: 'card'
        });
        (0, $jMP2a.fireUIAnalytics)(analyticsEvent, $f21a8ed6276ba002$var$ISSUE_CARD_ANALYTICS_ID, {
            keyboardShortcut: false,
            issueIndex: index + 1
        });
    }, [
        createAnalyticsEvent,
        index
    ]);
    return fragment == null ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $fNFQe.default), {
        ref: cardRef,
        isSelected: isSelected,
        onClick: onClickWithAnalytics
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $3wPFH.default), {
        ref: cardRef,
        fragment: fragment,
        onClick: onClickWithAnalytics,
        onFocus: onCardFocus,
        isSelected: isSelected,
        onContextMenu: onContextMenuHandler
    });
};
const $f21a8ed6276ba002$var$CardList = ({ fragment: fragment, loading: loading, onNavigateToIssue: onNavigateToIssue })=>{
    (0, $cWCvn.markOnce)((0, $cWCvn.marks).ISSUE_RESULTS_DETAIL_VIEW_CARD_LIST_START); // Analytics
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bFzGY.useAnalyticsEvents)(); // Main
    const [focusedIssueIndex, { setFocusedIssueByIndex: setFocusedIssueByIndex }] = (0, $1ydM0.useFocusedIssueIndex)();
    const maxIssuesPerPage = (0, $jccNB.getMaxIssuesPerPage)();
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    (0, $eUqFw.useLayoutEffect)(()=>{
        (0, $cWCvn.markOnce)((0, $cWCvn.marks).ISSUE_RESULTS_DETAIL_VIEW_CARD_LIST_END);
    }, []);
    const fragmentData = (0, $iWLL0.useFragment)((0, $9gGa1.default), fragment);
    const onIssueChangeEvent = (0, $eUqFw.useCallback)((issueKey, issueIndex)=>{
        if (issueIndex !== null) setFocusedIssueByIndex(issueIndex);
        const id = issueKey ? $f21a8ed6276ba002$var$ISSUE_CARD_ANALYTICS_ID : $f21a8ed6276ba002$var$BLANK_CARD_ANALYTICS_ID;
        const analyticsEvent = createAnalyticsEvent({
            action: 'selected',
            actionSubject: 'card'
        });
        (0, $jMP2a.fireUIAnalytics)(analyticsEvent, id, {
            keyboardShortcut: true,
            issueIndex: issueIndex === null ? null : issueIndex + 1
        });
    }, [
        createAnalyticsEvent,
        setFocusedIssueByIndex
    ]);
    if (loading) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, [
        ...Array(maxIssuesPerPage)
    ].map((__, index)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $fluRZ.default), {
            key: index,
            issueIndex: index,
            issueCount: maxIssuesPerPage
        })));
    const cards = fragmentData?.edges?.filter((0, $3wKQY.isNonNullish)).map((edge, index)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($f21a8ed6276ba002$var$CardWithAnalytics, {
            key: index,
            index: index,
            fragment: edge.node ?? undefined
        })) ?? [];
    if (cards.length === 0) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1EVUo.default), null);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $hrpGF.default), {
        focusedIssueIndex: focusedIssueIndex,
        onIssueChangeEvent: onIssueChangeEvent,
        onNavigateToIssue: onNavigateToIssue,
        disableListControls: loading
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($f21a8ed6276ba002$export$22a81bdd3a723b46, {
        role: "listbox",
        "aria-label": formatMessage((0, $h75Xv.default).issues)
    }, cards));
};
var $f21a8ed6276ba002$export$2e2bcd8739ae039 // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
 = $f21a8ed6276ba002$var$CardList;
const $f21a8ed6276ba002$export$22a81bdd3a723b46 = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "ul", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_qtt8glyw _19bvidpf",
            __cmplp.className
        ])
    });
});

});
parcelRegister("9gGa1", function(module, exports) {

$parcel$export(module.exports, "default", () => $ad4c04343240a220$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<82a0bbdfb49e3e57e7b008772adacdee>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $ad4c04343240a220$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "main_issueNavigator_CardList",
    "selections": [
        {
            "concreteType": "JiraIssueEdge",
            "kind": "LinkedField",
            "name": "edges",
            "plural": true,
            "selections": [
                {
                    "concreteType": "JiraIssue",
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "FragmentSpread",
                            "name": "main_issueNavigator_Card_fragment"
                        }
                    ]
                }
            ]
        }
    ],
    "type": "JiraIssueConnection"
};
$ad4c04343240a220$var$node.hash = "8ff286c4c7d319d2f77b839644584988";
var $ad4c04343240a220$export$2e2bcd8739ae039 = $ad4c04343240a220$var$node;

});

parcelRegister("3wPFH", function(module, exports) {

$parcel$export(module.exports, "default", () => $b29c279ff2e19f03$export$2e2bcd8739ae039);

var $2g6fS = parcelRequire("2g6fS");

var $5NHsh = parcelRequire("5NHsh");

var $7JEyt = parcelRequire("7JEyt");
var $9t7rW = parcelRequire("9t7rW");

var $eUqFw = parcelRequire("eUqFw");

var $iWLL0 = parcelRequire("iWLL0");


var $eI5EY = parcelRequire("eI5EY");

var $6vrw7 = parcelRequire("6vrw7");

var $12tYT = parcelRequire("12tYT");

var $3wKQY = parcelRequire("3wKQY");

var $1ydM0 = parcelRequire("1ydM0");

var $2tLOO = parcelRequire("2tLOO");
const $b29c279ff2e19f03$var$backgroundColorSelected = `var(--ds-background-selected, ${(0, $73a5c9d720aa66e1$exports).B50})`;
const $b29c279ff2e19f03$var$backgroundColorHovered = `var(--ds-background-neutral-subtle-hovered, ${(0, $73a5c9d720aa66e1$exports).N10})`; // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $b29c279ff2e19f03$var$StyledListElement = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "li", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_19pkidpf",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
const $b29c279ff2e19f03$export$1d41361302b577a1 = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = (0, $12tYT.CardBaseStyle), style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: {
            ...__cmpls,
            "--_1hwiu8a": (0, $9t7rW.default)($b29c279ff2e19f03$var$backgroundColorSelected),
            "--_1xad3ln": (0, $9t7rW.default)($b29c279ff2e19f03$var$backgroundColorHovered)
        },
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_f8pj1kw7 _30l31kw7",
            __cmplp.isSelected ? "_syaz1ldt" : "_syaz1kw7",
            __cmplp.isSelected ? "_irr312tn" : "_irr31iq0",
            __cmplp.className
        ])
    });
});
const $b29c279ff2e19f03$export$c3fc4c88db352deb = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_slp31hna _1i4q1hna _1nmz1hna _otyr1b66",
            __cmplp.className
        ])
    });
});
const $b29c279ff2e19f03$var$byFieldId = (edges, fieldId, mapperFn)=>edges?.map((edge)=>edge?.node?.fields?.edges?.[0]).filter((edge)=>edge?.node?.fieldId === fieldId).filter((0, $3wKQY.isNonNullish)).map(mapperFn)[0];
const $b29c279ff2e19f03$var$Card = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ style: style, Footer: Footer = (0, $2tLOO.default), onMounted: onMounted, onClick: onClick, onFocus: onFocus, fragment: fragment, isSelected: isSelected, onContextMenu: onContextMenu }, ref)=>{
    const fragmentData = (0, $iWLL0.useFragment)((0, $5NHsh.default), fragment);
    const fieldSetsForIssueSearchViewData = (0, $iWLL0.useFragment)((0, $2g6fS.default), fragmentData.fieldSetsForIssueSearchView);
    const issueKey = fragmentData.key;
    (0, $eUqFw.useEffect)(()=>{
        onMounted && onMounted();
    }, [
        onMounted
    ]);
    const fieldEdges = fieldSetsForIssueSearchViewData?.edges ?? null;
    const summary = $b29c279ff2e19f03$var$byFieldId(fieldEdges, 'summary', (summaryEdge)=>summaryEdge?.node?.text);
    const avatarUser = $b29c279ff2e19f03$var$byFieldId(fieldEdges, 'assignee', (assigneeEdge)=>assigneeEdge?.node?.user);
    const avatarSrc = avatarUser?.picture || '';
    const avatarDisplayName = avatarUser?.name || '';
    const type = $b29c279ff2e19f03$var$byFieldId(fieldEdges, 'issuetype', (issueTypeEdge)=>issueTypeEdge?.node?.issueType);
    const issueType = {
        iconSrc: type?.avatar?.small || '',
        name: type?.name || ''
    };
    const statusCategoryId = $b29c279ff2e19f03$var$byFieldId(fieldEdges, 'statusCategory', (statusCategoryEdge)=>statusCategoryEdge?.node?.statusCategory?.statusCategoryId) ?? -1;
    const [, { resetFocusedIssue: resetFocusedIssue }] = (0, $1ydM0.useFocusedIssueIndex)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($b29c279ff2e19f03$var$StyledListElement, {
        ...(0, $eI5EY.fg)('nin_critical_accessibility_issues') ? {
            role: 'option',
            'aria-selected': isSelected
        } : {
            'aria-current': isSelected,
            'aria-label': issueType.name
        },
        "data-testid": "issue-navigator.ui.issue-results.detail-view.card-list.card.list-item"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($b29c279ff2e19f03$export$1d41361302b577a1 // @ts-expect-error incorrect ref type
    , {
        ref: ref ?? undefined,
        onContextMenu: onContextMenu,
        isSelected: isSelected,
        onBlur: resetFocusedIssue,
        tabIndex: isSelected ? 0 : -1,
        onClick: onClick,
        onFocus: onFocus,
        style: style,
        "data-testid": "issue-navigator.ui.issue-results.detail-view.card-list.card",
        href: `/browse/${issueKey}`
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($b29c279ff2e19f03$export$c3fc4c88db352deb, {
        "data-testid": "issue-navigator.ui.issue-results.detail-view.card-list.card.summary"
    }, summary), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(Footer, {
        issueKey: (0, $6vrw7.toIssueKey)(issueKey),
        isSelected: isSelected,
        statusCategoryId: Number(statusCategoryId),
        avatarSrc: avatarSrc,
        avatarDisplayName: avatarDisplayName,
        issueType: issueType
    })));
});
var $b29c279ff2e19f03$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, $eUqFw.memo)($b29c279ff2e19f03$var$Card);

});
parcelRegister("2g6fS", function(module, exports) {

$parcel$export(module.exports, "default", () => $f95b82dcd53e2334$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<7ad648efe21a523fb11d7116e02353b5>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $f95b82dcd53e2334$var$node = function() {
    var v0 = {
        "kind": "ScalarField",
        "name": "fieldId"
    }, v1 = {
        "kind": "ScalarField",
        "name": "name"
    };
    return {
        "argumentDefinitions": [],
        "kind": "Fragment",
        "name": "main_issueNavigator_Card_fieldSetsForIssueSearchView",
        "selections": [
            {
                "concreteType": "JiraIssueFieldSetEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                    {
                        "concreteType": "JiraIssueFieldSet",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                            {
                                "concreteType": "JiraIssueFieldConnection",
                                "kind": "LinkedField",
                                "name": "fields",
                                "plural": false,
                                "selections": [
                                    {
                                        "concreteType": "JiraIssueFieldEdge",
                                        "kind": "LinkedField",
                                        "name": "edges",
                                        "plural": true,
                                        "selections": [
                                            {
                                                "kind": "LinkedField",
                                                "name": "node",
                                                "plural": false,
                                                "selections": [
                                                    {
                                                        "kind": "InlineFragment",
                                                        "selections": [
                                                            v0 /*: any*/ ,
                                                            v1 /*: any*/ ,
                                                            {
                                                                "kind": "ScalarField",
                                                                "name": "text"
                                                            }
                                                        ],
                                                        "type": "JiraSingleLineTextField"
                                                    },
                                                    {
                                                        "kind": "InlineFragment",
                                                        "selections": [
                                                            v0 /*: any*/ ,
                                                            v1 /*: any*/ ,
                                                            {
                                                                "kind": "LinkedField",
                                                                "name": "user",
                                                                "plural": false,
                                                                "selections": [
                                                                    v1 /*: any*/ ,
                                                                    {
                                                                        "kind": "ScalarField",
                                                                        "name": "picture"
                                                                    }
                                                                ]
                                                            }
                                                        ],
                                                        "type": "JiraSingleSelectUserPickerField"
                                                    },
                                                    {
                                                        "kind": "InlineFragment",
                                                        "selections": [
                                                            v0 /*: any*/ ,
                                                            {
                                                                "concreteType": "JiraIssueType",
                                                                "kind": "LinkedField",
                                                                "name": "issueType",
                                                                "plural": false,
                                                                "selections": [
                                                                    v1 /*: any*/ ,
                                                                    {
                                                                        "concreteType": "JiraAvatar",
                                                                        "kind": "LinkedField",
                                                                        "name": "avatar",
                                                                        "plural": false,
                                                                        "selections": [
                                                                            {
                                                                                "kind": "ScalarField",
                                                                                "name": "small"
                                                                            }
                                                                        ]
                                                                    }
                                                                ]
                                                            }
                                                        ],
                                                        "type": "JiraIssueTypeField"
                                                    },
                                                    {
                                                        "kind": "InlineFragment",
                                                        "selections": [
                                                            v0 /*: any*/ ,
                                                            {
                                                                "concreteType": "JiraStatusCategory",
                                                                "kind": "LinkedField",
                                                                "name": "statusCategory",
                                                                "plural": false,
                                                                "selections": [
                                                                    {
                                                                        "kind": "ScalarField",
                                                                        "name": "statusCategoryId"
                                                                    }
                                                                ]
                                                            }
                                                        ],
                                                        "type": "JiraStatusCategoryField"
                                                    }
                                                ]
                                            }
                                        ]
                                    }
                                ]
                            }
                        ]
                    }
                ]
            }
        ],
        "type": "JiraIssueFieldSetConnection"
    };
}();
$f95b82dcd53e2334$var$node.hash = "4b5a5fcdeceffe2ed348ebd86689df52";
var $f95b82dcd53e2334$export$2e2bcd8739ae039 = $f95b82dcd53e2334$var$node;

});

parcelRegister("5NHsh", function(module, exports) {

$parcel$export(module.exports, "default", () => $81722ca8123a1fd6$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<799ba38a75f146ef55bef017268bb473>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $81722ca8123a1fd6$var$node = {
    "argumentDefinitions": [
        {
            "kind": "RootArgument",
            "name": "amountOfColumns"
        },
        {
            "kind": "RootArgument",
            "name": "filterId"
        },
        {
            "kind": "RootArgument",
            "name": "namespace"
        },
        {
            "kind": "RootArgument",
            "name": "viewId"
        }
    ],
    "kind": "Fragment",
    "name": "main_issueNavigator_Card_fragment",
    "selections": [
        {
            "kind": "RequiredField",
            "field": {
                "kind": "ScalarField",
                "name": "key"
            },
            "action": "THROW",
            "path": "key"
        },
        {
            "kind": "RequiredField",
            "field": {
                "args": [
                    {
                        "kind": "Variable",
                        "name": "filterId",
                        "variableName": "filterId"
                    },
                    {
                        "kind": "Variable",
                        "name": "first",
                        "variableName": "amountOfColumns"
                    },
                    {
                        "kind": "Variable",
                        "name": "namespace",
                        "variableName": "namespace"
                    },
                    {
                        "kind": "Variable",
                        "name": "viewId",
                        "variableName": "viewId"
                    }
                ],
                "concreteType": "JiraIssueFieldSetConnection",
                "kind": "LinkedField",
                "name": "fieldSetsForIssueSearchView",
                "plural": false,
                "selections": [
                    {
                        "kind": "FragmentSpread",
                        "name": "main_issueNavigator_Card_fieldSetsForIssueSearchView"
                    }
                ]
            },
            "action": "THROW",
            "path": "fieldSetsForIssueSearchView"
        }
    ],
    "type": "JiraIssue"
};
$81722ca8123a1fd6$var$node.hash = "74c85821f3ec64a36da871208deee94f";
var $81722ca8123a1fd6$export$2e2bcd8739ae039 = $81722ca8123a1fd6$var$node;

});

parcelRegister("12tYT", function(module, exports) {

$parcel$export(module.exports, "CardBaseStyle", () => $bb7771c5d12bb102$export$d10d52f6c0613cc3);
/* styled.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");
var $9t7rW = parcelRequire("9t7rW");


var $7uIWw = parcelRequire("7uIWw");
const $bb7771c5d12bb102$var$backgroundColorSelected = `var(--ds-background-selected, ${(0, $73a5c9d720aa66e1$exports).B50})`;
const $bb7771c5d12bb102$var$backgroundColor = `var(--ds-surface-raised, ${(0, $73a5c9d720aa66e1$exports).N0})`;
const $bb7771c5d12bb102$var$borderColor = `var(--ds-border, ${(0, $73a5c9d720aa66e1$exports).N30})`;
const $bb7771c5d12bb102$var$boxShadowColor = `1px 0px ${`var(--ds-shadow-raised, ${(0, $73a5c9d720aa66e1$exports).N40})`}`;
const $bb7771c5d12bb102$export$d10d52f6c0613cc3 = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "a", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { isSelected: isSelected, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ $eUqFw.createElement(C, {
        ...__cmpldp,
        style: {
            ...__cmpls,
            "--_ykidgo": (0, $9t7rW.default)($bb7771c5d12bb102$var$boxShadowColor),
            "--_37cwmb": (0, $9t7rW.default)($bb7771c5d12bb102$var$borderColor),
            "--_1hwiu8a": (0, $9t7rW.default)($bb7771c5d12bb102$var$backgroundColorSelected),
            "--_1ly4823": (0, $9t7rW.default)($bb7771c5d12bb102$var$backgroundColor)
        },
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1ule _1yt4u2gc _vchhusvi _x3doidpf _16qsycq2 _n7zl1jb4 _1kl71jb4 _14t01jb4 _1jc11j8p _13jw1lq3 _e6md1se7 _1tzh1y44 _7ehihmda _1a3b18uv _4fprglyw _5goinqa1 _nt751r31 _49pcglyw _1hvw1o36 _9oik18uv _1bnxglyw _jf4cnqa1",
            __cmplp.isSelected ? "_bfhk12tn" : "_bfhkaxbu",
            __cmplp.className
        ])
    });
});
const $bb7771c5d12bb102$export$b15a6cf2987e4b39 = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = (0, $7uIWw.default), style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $eUqFw.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_4t3i1osq",
            __cmplp.className
        ])
    });
});

});

parcelRegister("2tLOO", function(module, exports) {

$parcel$export(module.exports, "default", () => $c043bf85e70e757c$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ // eslint-disable-next-line jira/restricted/react-component-props

var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $iJlfe = parcelRequire("iJlfe");

var $8cU5f = parcelRequire("8cU5f");

var $8Qd0L = parcelRequire("8Qd0L");

var $5JgJ2 = parcelRequire("5JgJ2");

var $lNcD8 = parcelRequire("lNcD8");
const $c043bf85e70e757c$var$Footer = ({ issueKey: issueKey, isSelected: isSelected, statusCategoryId: statusCategoryId, avatarSrc: avatarSrc, avatarDisplayName: avatarDisplayName, issueType: issueType })=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const isDone = statusCategoryId === (0, $8Qd0L.categoryIdForStatusCategory)((0, $8Qd0L.DONE));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($c043bf85e70e757c$var$StyledContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($c043bf85e70e757c$var$TypeIcon, {
        src: issueType?.iconSrc,
        alt: issueType?.name
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($c043bf85e70e757c$export$263c092b561e7355, {
        "aria-label": isDone ? formatMessage((0, $lNcD8.default).screenReaderFooterKeyDone, {
            issueKey: issueKey
        }) : undefined,
        isSelected: isSelected,
        isDone: isDone
    }, issueKey), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($c043bf85e70e757c$var$AvatarStyledContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8cU5f.default), {
        content: avatarDisplayName
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $iJlfe.default), {
        src: avatarSrc,
        name: avatarDisplayName,
        size: "small"
    }))));
};
var $c043bf85e70e757c$export$2e2bcd8739ae039 // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
 = /*#__PURE__*/ (0, $eUqFw.memo)($c043bf85e70e757c$var$Footer);
const $c043bf85e70e757c$var$StyledContainer = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _4cvr1h6o",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $c043bf85e70e757c$var$TypeIcon = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "img", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1bsb7vkz _4t3i7vkz _2hwx1b66 _2rkoyh40",
            __cmplp.className
        ])
    });
});
const $c043bf85e70e757c$var$AvatarStyledContainer = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_4t3i1f4h _19bvu2gc _18u01wug _80omtlke",
            __cmplp.className
        ])
    });
});
const $c043bf85e70e757c$export$263c092b561e7355 = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { isSelected: isSelected, isDone: isDone, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_11c8qk37 _k48pmoej",
            __cmplp.isSelected ? "_syaz1ldt" : "_syazloe7",
            __cmplp.isDone ? "_4bfu18uv _1hms1911 _ajmmnqa1" : "_4bfu18uv _1hmsglyw _ajmmnqa1",
            __cmplp.className
        ])
    });
});

});
parcelRegister("lNcD8", function(module, exports) {

$parcel$export(module.exports, "default", () => $5f279c702485213f$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $5f279c702485213f$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    screenReaderFooterKeyDone: {
        "id": "issue-navigator.issue-results.detail-view.card-list.card.footer.screen-reader-footer-key-done",
        "defaultMessage": "Done issue: {issueKey}"
    }
});

});



parcelRegister("fNFQe", function(module, exports) {

$parcel$export(module.exports, "default", () => $3a7237c5bd5b482c$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $7JEyt = parcelRequire("7JEyt");
var $9t7rW = parcelRequire("9t7rW");

var $eUqFw = parcelRequire("eUqFw");

var $b5IAe = parcelRequire("b5IAe");
var $1ZAYh = parcelRequire("1ZAYh");


var $eI5EY = parcelRequire("eI5EY");

var $5JgJ2 = parcelRequire("5JgJ2");

var $d6f6c = parcelRequire("d6f6c");

var $12tYT = parcelRequire("12tYT");

var $ld07P = parcelRequire("ld07P");
const $3a7237c5bd5b482c$var$ContainerFG = ({ children: children, isSelected: isSelected })=>(0, $eI5EY.fg)('nin_critical_accessibility_issues') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
        as: "li",
        role: "option",
        "aria-selected": isSelected,
        xcss: $3a7237c5bd5b482c$var$ListItemStyle,
        tabIndex: isSelected ? 0 : -1
    }, children) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, children);
const $3a7237c5bd5b482c$var$EmptyCard = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ isSelected: isSelected = false, onClick: onClick }, ref)=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($3a7237c5bd5b482c$var$ContainerFG, {
        isSelected: isSelected
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($3a7237c5bd5b482c$var$EmptyCardContainer, {
        ref: ref ?? undefined,
        isSelected: isSelected,
        onClick: onClick,
        href: "#"
    }, formatMessage((0, $ld07P.default).emptyCardText), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $d6f6c.FireUiAnalytics), {
        action: "viewed",
        actionSubject: "blankIssue"
    })));
});
var $3a7237c5bd5b482c$export$2e2bcd8739ae039 = $3a7237c5bd5b482c$var$EmptyCard;
const $3a7237c5bd5b482c$var$textColorActiveState = `var(--ds-text-selected, ${(0, $73a5c9d720aa66e1$exports).N600})`;
const $3a7237c5bd5b482c$var$textColor = `var(--ds-text, ${(0, $73a5c9d720aa66e1$exports).N200})`; // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $3a7237c5bd5b482c$var$EmptyCardContainer = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = (0, $12tYT.CardBaseStyle), style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: {
            ...__cmpls,
            "--_1ebr96o": (0, $9t7rW.default)($3a7237c5bd5b482c$var$textColorActiveState),
            "--_srel9g": (0, $9t7rW.default)($3a7237c5bd5b482c$var$textColor)
        },
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1wyb1skh _80omtlke",
            __cmplp.isSelected ? "_syaz1c3g" : "_syaz1u00",
            __cmplp.isSelected ? "_f8pj1c3g _30l31c3g" : "_f8pj1u00 _30l31u00",
            __cmplp.className
        ])
    });
});
const $3a7237c5bd5b482c$var$ListItemStyle = (0, $1ZAYh.xcss)({
    marginBlockStart: 'space.0'
});

});
parcelRegister("ld07P", function(module, exports) {

$parcel$export(module.exports, "default", () => $d0f2dfe01a69c34b$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $d0f2dfe01a69c34b$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    blankText: {
        "id": "issue-navigator.issue-results.detail-view.card-list.card.empty-card.blank-text",
        "defaultMessage": "We can't display this issue"
    },
    emptyCardText: {
        "id": "issue-navigator.issue-results.detail-view.card-list.card.empty-card.empty-card-text",
        "defaultMessage": "This issue cannot be opened because it may have been deleted or you do not have access to it"
    },
    tooltip: {
        "id": "issue-navigator.issue-results.detail-view.card-list.card.empty-card.tooltip",
        "defaultMessage": "Either this issue has been deleted, or you don\u2019t have access to it."
    }
});

});


parcelRegister("1EVUo", function(module, exports) {

$parcel$export(module.exports, "default", () => $02ef5e672c009785$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $cslVd = parcelRequire("cslVd");
const $02ef5e672c009785$export$36d139f95680ab4e = ()=>// eslint-disable-next-line jira/integration/test-id-by-folder-structure
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($02ef5e672c009785$var$StyledContainer, {
        "data-testid": "issue-navigator.issue-results.detail-view.card-list.card-empty-list"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $cslVd.default), null));
var $02ef5e672c009785$export$2e2bcd8739ae039 = $02ef5e672c009785$export$36d139f95680ab4e;
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $02ef5e672c009785$var$StyledContainer = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _2lx21bp4 _4cvr1h6o _y3gn1h6o _4t3i1osq _1bah1h6o",
            __cmplp.className
        ])
    });
});

});
parcelRegister("cslVd", function(module, exports) {

$parcel$export(module.exports, "default", () => $f72adb8f08035046$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $b5IAe = parcelRequire("b5IAe");
var $1ZAYh = parcelRequire("1ZAYh");

var $hgbp4 = parcelRequire("hgbp4");

var $giAhk = parcelRequire("giAhk");

var $2YNcp = parcelRequire("2YNcp");
const $f72adb8f08035046$export$f3f2e7ed2b6256b1 = ({ intl: { formatMessage: formatMessage } })=>{
    const noIssues = formatMessage((0, $2YNcp.default).noIssues);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
        xcss: $f72adb8f08035046$var$ImageWrapperStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $hgbp4.default), {
        alt: ""
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("p", null, noIssues));
};
var /* eslint-disable-next-line jira/js/no-inject-intl-if-functional-component */ $f72adb8f08035046$export$2e2bcd8739ae039 = (0, $giAhk.injectIntlV2)($f72adb8f08035046$export$f3f2e7ed2b6256b1);
const $f72adb8f08035046$var$ImageWrapperStyles = (0, $1ZAYh.xcss)({
    height: '146px',
    width: '160px'
});

});
parcelRegister("2YNcp", function(module, exports) {

$parcel$export(module.exports, "default", () => $37741942ebd390b0$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $37741942ebd390b0$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    noIssues: {
        "id": "issue-navigator.common.empty-list-icon.no-issues",
        "defaultMessage": "No issues were found matching your search"
    }
});

});



parcelRegister("fluRZ", function(module, exports) {

$parcel$export(module.exports, "default", () => $262b322093dcab08$export$2e2bcd8739ae039);
// eslint-disable-next-line jira/restricted/react

var $eUqFw = parcelRequire("eUqFw");

var $jG2Eu = parcelRequire("jG2Eu");

var $96IgR = parcelRequire("96IgR");


var $dnJL9 = parcelRequire("dnJL9");

var $5JgJ2 = parcelRequire("5JgJ2");

var $lfCsT = parcelRequire("lfCsT");

var $9Ms52 = parcelRequire("9Ms52");

var $jeAfN = parcelRequire("jeAfN");
const $262b322093dcab08$var$IssueCardSkeletonNew = ({ hasError: hasError = false, issueIndex: issueIndex, issueCount: issueCount })=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $jeAfN.Wrapper), {
        role: "option",
        "aria-selected": false,
        "aria-label": formatMessage((0, $9Ms52.default).issueLoadingLabel, {
            number: issueIndex
        }),
        isFirstCard: issueIndex === 0,
        isLastCard: issueIndex + 1 === issueCount,
        hasError: hasError
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $jeAfN.SkeletonContainer), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $jeAfN.SkeletonBackground), {
        hasError: hasError,
        "data-component-selector": (0, $jeAfN.skeletonBackgroundSelector)
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $jeAfN.ColumnMask), {
        "data-component-selector": (0, $jeAfN.columnMaskSelector)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $jeAfN.SummaryMask), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $jeAfN.TextLineMask), {
        fontSize: 20,
        lineHeight: 24,
        intrusion: 20
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $jeAfN.TextLineMask), {
        fontSize: 20,
        lineHeight: 24,
        intrusion: 60
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $jeAfN.FooterMask), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $jeAfN.TypeMask), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $jeAfN.SeparatorMask), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $jeAfN.IssueKeyMask), null), hasError ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $jeAfN.ErrorIconContainer), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($96IgR))), {
        primaryColor: `var(--ds-icon-danger, ${(0, $73a5c9d720aa66e1$exports).R400})`,
        label: ""
    })) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $jeAfN.BlankMask), null))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $jeAfN.ErrorWrapper), {
        "data-component-selector": (0, $jeAfN.errorWrapperSelector)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $lfCsT.default), null))));
};
// eslint-disable-next-line jira/react/no-class-components
class $262b322093dcab08$var$IssueCardSkeletonOld extends (0, $eUqFw.PureComponent) {
    static{
        this.defaultProps = {
            hasError: false,
            onReady: (0, (/*@__PURE__*/$parcel$interopDefault($jG2Eu)))
        };
    }
    componentDidMount() {
        this.props.onReady && this.props.onReady();
    }
    render() {
        const { hasError: hasError, issueIndex: issueIndex, issueCount: issueCount } = this.props;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $jeAfN.Wrapper), {
            isFirstCard: issueIndex === 0,
            isLastCard: issueIndex + 1 === issueCount,
            role: "listitem",
            hasError: hasError
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $jeAfN.SkeletonContainer), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $jeAfN.SkeletonBackground), {
            hasError: hasError ?? false,
            "data-component-selector": (0, $jeAfN.skeletonBackgroundSelector)
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $jeAfN.ColumnMask), {
            "data-component-selector": (0, $jeAfN.columnMaskSelector)
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $jeAfN.SummaryMask), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $jeAfN.TextLineMask), {
            fontSize: 20,
            lineHeight: 24,
            intrusion: 20
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $jeAfN.TextLineMask), {
            fontSize: 20,
            lineHeight: 24,
            intrusion: 60
        })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $jeAfN.FooterMask), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $jeAfN.TypeMask), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $jeAfN.SeparatorMask), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $jeAfN.IssueKeyMask), null), hasError ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $jeAfN.ErrorIconContainer), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($96IgR))), {
            primaryColor: `var(--ds-icon-danger, ${(0, $73a5c9d720aa66e1$exports).R400})`,
            label: ""
        })) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $jeAfN.BlankMask), null))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $jeAfN.ErrorWrapper), {
            "data-component-selector": (0, $jeAfN.errorWrapperSelector)
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $lfCsT.default), null))));
    }
}
const $262b322093dcab08$var$IssueCardSkeleton = (0, $dnJL9.componentWithFG)('nin_critical_accessibility_issues', $262b322093dcab08$var$IssueCardSkeletonNew, $262b322093dcab08$var$IssueCardSkeletonOld);
var $262b322093dcab08$export$2e2bcd8739ae039 = $262b322093dcab08$var$IssueCardSkeleton;

});
parcelRegister("lfCsT", function(module, exports) {

$parcel$export(module.exports, "default", () => $35274886020d1e04$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $jG2Eu = parcelRequire("jG2Eu");

var $7u4fN = parcelRequire("7u4fN");

var $giAhk = parcelRequire("giAhk");

var $gHMhg = parcelRequire("gHMhg");

var $lxN7X = parcelRequire("lxN7X");
class $35274886020d1e04$export$e8132eb38e030ec6 extends (0, $eUqFw.Component) {
    static{
        this.defaultProps = {
            onResetErrors: (0, (/*@__PURE__*/$parcel$interopDefault($jG2Eu)))
        };
    }
    render() {
        const { intl: { formatMessage: formatMessage } } = this.props;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $lxN7X.Container), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $lxN7X.InfoMessage), null, formatMessage((0, $gHMhg.default).infoText)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7u4fN.default), {
            appearance: "link",
            onClick: this.onReloadIssueClick,
            spacing: "none"
        }, formatMessage((0, $gHMhg.default).reloadIssue)));
    }
    constructor(...args){
        super(...args);
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        this.onReloadIssueClick = (...attrs)=>{
            const analyticsEvent = attrs.pop();
            this.props.onResetErrors(analyticsEvent);
        };
    }
}
var $35274886020d1e04$export$2e2bcd8739ae039 = (0, $giAhk.injectIntlV2)($35274886020d1e04$export$e8132eb38e030ec6);

});
parcelRegister("gHMhg", function(module, exports) {

$parcel$export(module.exports, "default", () => $ac0dee8c93103479$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var /* eslint-disable jira/i18n/id-named-by-package */ $ac0dee8c93103479$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    infoText: {
        "id": "issue-navigator.navigator.content.issue-list.issue-card-skeleton.error-info.info-text",
        "defaultMessage": "We couldn't load this issue."
    },
    reloadIssue: {
        "id": "issue-navigator.navigator.content.issue-list.issue-card-skeleton.error-info.reload-issue",
        "defaultMessage": "Reload issue"
    }
});

});

parcelRegister("lxN7X", function(module, exports) {

$parcel$export(module.exports, "Container", () => $f04b9ffc218e2fdd$export$42a852a2b6b56249);
$parcel$export(module.exports, "InfoMessage", () => $f04b9ffc218e2fdd$export$4bf8682ab34d3383);
/* styled.tsx generated by @compiled/babel-plugin v0.29.1 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766

var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");
const $f04b9ffc218e2fdd$export$42a852a2b6b56249 = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $eUqFw.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_syaz1kw7 _1e0c1txw _2lx21bp4",
            __cmplp.className
        ])
    });
});
const $f04b9ffc218e2fdd$export$4bf8682ab34d3383 = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $eUqFw.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "",
            __cmplp.className
        ])
    });
});

});


parcelRegister("9Ms52", function(module, exports) {

$parcel$export(module.exports, "default", () => $9b391a2e35d91f50$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $9b391a2e35d91f50$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    issueLoadingLabel: {
        "id": "issue-navigator.issue-results.detail-view.card-list.card-skeleton.issue-loading-label",
        "defaultMessage": "Issue card {number} loading"
    }
});

});

parcelRegister("jeAfN", function(module, exports) {

$parcel$export(module.exports, "SkeletonContainer", () => $909f5a6ffeec6b52$export$66b8cea0c448285);
$parcel$export(module.exports, "SkeletonBackground", () => $909f5a6ffeec6b52$export$c3b0ebed856b8b1a);
$parcel$export(module.exports, "ColumnMask", () => $909f5a6ffeec6b52$export$439b7c87164a9b43);
$parcel$export(module.exports, "SummaryMask", () => $909f5a6ffeec6b52$export$792e72b41c80f830);
$parcel$export(module.exports, "FooterMask", () => $909f5a6ffeec6b52$export$ab3fe3ddc5c7354f);
$parcel$export(module.exports, "TextLineMask", () => $909f5a6ffeec6b52$export$f3e0fd2d5209f88b);
$parcel$export(module.exports, "TypeMask", () => $909f5a6ffeec6b52$export$59d16c2cd3bc3a2);
$parcel$export(module.exports, "IssueKeyMask", () => $909f5a6ffeec6b52$export$ca1c048394ed3dbb);
$parcel$export(module.exports, "SeparatorMask", () => $909f5a6ffeec6b52$export$bdc7d72765b181c3);
$parcel$export(module.exports, "BlankMask", () => $909f5a6ffeec6b52$export$a1b9063b4cbc0844);
$parcel$export(module.exports, "ErrorIconContainer", () => $909f5a6ffeec6b52$export$90993d2d9550d725);
$parcel$export(module.exports, "ErrorWrapper", () => $909f5a6ffeec6b52$export$bb27b7e39840238f);
$parcel$export(module.exports, "errorWrapperSelector", () => $909f5a6ffeec6b52$export$a03455d77d6a4ea);
$parcel$export(module.exports, "skeletonBackgroundSelector", () => $909f5a6ffeec6b52$export$85fe8f1edff78b98);
$parcel$export(module.exports, "columnMaskSelector", () => $909f5a6ffeec6b52$export$67b279fb398d016e);
$parcel$export(module.exports, "Wrapper", () => $909f5a6ffeec6b52$export$e6dfd72ab29f8598);
/* styled.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");
var $9t7rW = parcelRequire("9t7rW");

var $c9TLT = parcelRequire("c9TLT");
const $909f5a6ffeec6b52$var$defaultIssueCardHeight = 97;
const $909f5a6ffeec6b52$export$66b8cea0c448285 = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $eUqFw.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_4t3i1rbs _1e0c1txw _kqswh2mm",
            __cmplp.className
        ])
    });
});
const $909f5a6ffeec6b52$var$shimmer = null;
const $909f5a6ffeec6b52$export$c3b0ebed856b8b1a = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { hasError: hasError, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ $eUqFw.createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_5sag126j _1o51q7pw _j7hq1en8 _1pglp3kn _bfhk1u4r _1itkxsyt _12vemgnk _kqswstnw _1ltvidpf _1xi2idpf _154iidpf _94n5idpf",
            __cmplp.hasError ? "_tip8idpf" : "_tip812c5",
            __cmplp.className
        ])
    });
});
const $909f5a6ffeec6b52$export$439b7c87164a9b43 = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $eUqFw.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_kqswh2mm _1bsb1osq _19pkidpf _2hwxidpf _otyridpf _18u0idpf _1kl715mc _1s7z15mc",
            __cmplp.className
        ])
    });
});
const $909f5a6ffeec6b52$export$792e72b41c80f830 = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $eUqFw.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_n7zl15mc",
            __cmplp.className
        ])
    });
});
const $909f5a6ffeec6b52$export$ab3fe3ddc5c7354f = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $eUqFw.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _2lx2vrvc _kqswh2mm _n7zlv4vr _x3do16sd",
            __cmplp.className
        ])
    });
});
const $909f5a6ffeec6b52$export$f3e0fd2d5209f88b = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { intrusion: intrusion, lineHeight: lineHeight, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ $eUqFw.createElement(C, {
        ...__cmpldp,
        style: {
            ...__cmpls,
            "--_rjhebn": (0, $9t7rW.default)(__cmplp.fontSize, "px"),
            "--_1oqupad": (0, $9t7rW.default)(__cmplp.intrusion, "px"),
            "--_ppkzip": (0, $9t7rW.default)(// eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            (__cmplp.lineHeight - __cmplp.fontSize) / 2, "px")
        },
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_kqswh2mm _4t3i3gti _1s7z87mc _x3do1age _n7zl1age",
            __cmplp.className
        ])
    });
});
const $909f5a6ffeec6b52$export$59d16c2cd3bc3a2 = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $eUqFw.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_kqswh2mm _4t3i1tcg _1bsb1tcg _2hwxu2gc",
            __cmplp.className
        ])
    });
});
const $909f5a6ffeec6b52$export$ca1c048394ed3dbb = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $eUqFw.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_kqswh2mm _4t3i1tcg _1bsb16xz",
            __cmplp.className
        ])
    });
});
const $909f5a6ffeec6b52$export$bdc7d72765b181c3 = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $eUqFw.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1bsbftgi _bfhkvuon",
            __cmplp.className
        ])
    });
});
const $909f5a6ffeec6b52$export$a1b9063b4cbc0844 = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $eUqFw.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_16jlkb7n _bfhkvuon _1e0c1txw _1bahesu3",
            __cmplp.className
        ])
    });
});
const $909f5a6ffeec6b52$export$90993d2d9550d725 = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $eUqFw.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_bfhkvuon _16jlkb7n _1e0c1txw _1bahesu3",
            __cmplp.className
        ])
    });
});
const $909f5a6ffeec6b52$export$bb27b7e39840238f = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $eUqFw.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0cglyw _1bsb1osq _19pkidpf _2hwxidpf _otyridpf _18u0idpf _4cvr1h6o _18u0u2gc _2hwxu2gc",
            __cmplp.className
        ])
    });
});
const $909f5a6ffeec6b52$var$getBorderRadius = (isFirstCard, isLastCard)=>{
    if (isFirstCard && isLastCard) // rounded corners on top and bottom
    return `${(0, $c9TLT.gridSize) * 0.5}px`;
    if (isFirstCard) // rounded corners on top
    return `${(0, $c9TLT.gridSize) * 0.5}px ${(0, $c9TLT.gridSize) * 0.5}px 0 0`;
    if (isLastCard) // rounded corners on bottom
    return `0 0 ${(0, $c9TLT.gridSize) * 0.5}px ${(0, $c9TLT.gridSize) * 0.5}px`;
    // no border radius for other cards
    return '0';
};
const $909f5a6ffeec6b52$export$a03455d77d6a4ea = 'jira-issue-navigator-card-skeleton-error-wrapper';
const $909f5a6ffeec6b52$export$85fe8f1edff78b98 = 'jira-issue-navigator-card-skeleton-skeleton-background';
const $909f5a6ffeec6b52$export$67b279fb398d016e = 'jira-issue-navigator-card-skeleton-column-mask';
const $909f5a6ffeec6b52$export$e6dfd72ab29f8598 = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { isFirstCard: isFirstCard, isLastCard: isLastCard, hasError: hasError, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ $eUqFw.createElement(C, {
        ...__cmpldp,
        style: {
            ...__cmpls,
            "--_63r7hy": (0, $9t7rW.default)($909f5a6ffeec6b52$var$getBorderRadius(__cmplp.isFirstCard, __cmplp.isLastCard))
        },
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _2lx21bp4 _1yt4f522 _vchhusvi _1kl71l7n _1s7z1l7n _bfhkvuon _2rko1nxs _syaz1kw7 _7ehihmda _1a3b18uv _4fprglyw _5goinqa1 _nt751r31 _49pcglyw _1hvw1o36 _irr31nz6 _9oik18uv _1bnxglyw _jf4cnqa1",
            __cmplp.isFirstCard ? "_x3do1l7n" : "_x3doidpf",
            __cmplp.isLastCard ? "_n7zlh6cr" : "_n7zl1l7n",
            __cmplp.hasError ? "_1s2q1txw" : "_1s2qglyw",
            __cmplp.hasError && "_czo0glyw",
            __cmplp.hasError && "_1y4vglyw",
            __cmplp.className
        ])
    });
});

});


parcelRegister("hrpGF", function(module, exports) {

$parcel$export(module.exports, "default", () => $e8ffd42531b464cf$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $9aFSa = parcelRequire("9aFSa");

var $5JgJ2 = parcelRequire("5JgJ2");

var $eNjET = parcelRequire("eNjET");

var $1ydM0 = parcelRequire("1ydM0");

var $ei0RD = parcelRequire("ei0RD");
const $e8ffd42531b464cf$var$useUpdatingRef = (value)=>{
    const ref = (0, $eUqFw.useRef)(value);
    ref.current = value;
    return ref;
};
const $e8ffd42531b464cf$var$KeyboardShortcuts = (props)=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const propsRef = $e8ffd42531b464cf$var$useUpdatingRef(props);
    const openStateRef = $e8ffd42531b464cf$var$useUpdatingRef((0, $eNjET.useOrderByOpenState)());
    const [selectedIssueKey, { getNextIssue: getNextIssue, selectNextIssue: selectNextIssue, getPreviousIssue: getPreviousIssue, selectPreviousIssue: selectPreviousIssue }] = (0, $1ydM0.useSelectedIssueKey)();
    const [selectedIssueIndex] = (0, $1ydM0.useSelectedIssueIndex)();
    const selectedIssueKeyRef = $e8ffd42531b464cf$var$useUpdatingRef(selectedIssueKey);
    const selectedIssueIndexRef = $e8ffd42531b464cf$var$useUpdatingRef(selectedIssueIndex);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $9aFSa.default), {
        keyMap: (0, $eUqFw.useMemo)(()=>({
                j: {
                    callback: ()=>{
                        const { disableListControls: disableListControls, onIssueChangeEvent: onIssueChangeEvent } = propsRef.current;
                        if (disableListControls === true) return;
                        // getNextIssue and selectNextIssue need to be stable function references as
                        // useMemo has an empty dependencies array
                        const { issueKey: issueKey, issueIndex: issueIndex } = getNextIssue();
                        if (selectNextIssue(true)) onIssueChangeEvent && onIssueChangeEvent(issueKey, issueIndex);
                    },
                    label: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", null, formatMessage((0, $ei0RD.default).nextIssue))
                },
                k: {
                    callback: ()=>{
                        const { disableListControls: disableListControls, onIssueChangeEvent: onIssueChangeEvent } = propsRef.current;
                        if (disableListControls === true) return;
                        // getPreviousIssue and selectPreviousIssue need to be stable function references as
                        // useMemo has an empty dependencies array
                        const { issueKey: issueKey, issueIndex: issueIndex } = getPreviousIssue();
                        if (selectPreviousIssue(true)) onIssueChangeEvent && onIssueChangeEvent(issueKey, issueIndex);
                    },
                    label: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", null, formatMessage((0, $ei0RD.default).previousIssue))
                },
                y: {
                    callback: ()=>{
                        const [{ isOpen: isOpen }, { open: open, close: close }] = openStateRef.current;
                        isOpen ? close() : open();
                    },
                    label: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", null, formatMessage((0, $ei0RD.default).displaySortFields))
                },
                z: {
                    callback: ()=>{
                        if (selectedIssueKeyRef.current) propsRef.current.onNavigateToIssue(selectedIssueKeyRef.current);
                    },
                    label: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", null, formatMessage((0, $ei0RD.default).openIssueFullScreen))
                },
                arrowup: {
                    callback: ()=>{
                        const { disableListControls: disableListControls, onIssueChangeEvent: onIssueChangeEvent, focusedIssueIndex: focusedIssueIndex } = propsRef.current;
                        if (disableListControls === true) return;
                        const { issueKey: issueKey, issueIndex: issueIndex } = getPreviousIssue();
                        if (focusedIssueIndex !== null && focusedIssueIndex === selectedIssueIndexRef.current) {
                            if (selectPreviousIssue(true)) onIssueChangeEvent && onIssueChangeEvent(issueKey, issueIndex);
                        }
                    },
                    label: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", null, formatMessage((0, $ei0RD.default).previousIssue))
                },
                arrowdown: {
                    callback: ()=>{
                        const { disableListControls: disableListControls, onIssueChangeEvent: onIssueChangeEvent, focusedIssueIndex: focusedIssueIndex } = propsRef.current;
                        if (disableListControls === true) return;
                        const { issueKey: issueKey, issueIndex: issueIndex } = getNextIssue();
                        if (focusedIssueIndex !== null && focusedIssueIndex === selectedIssueIndexRef.current) {
                            if (selectNextIssue(true)) onIssueChangeEvent && onIssueChangeEvent(issueKey, issueIndex);
                        }
                    },
                    label: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", null, formatMessage((0, $ei0RD.default).nextIssue))
                }
            }), [] // eslint-disable-line react-hooks/exhaustive-deps
        )
    });
};
$e8ffd42531b464cf$var$KeyboardShortcuts.defaultProps = {
    disableListControls: false
};
var $e8ffd42531b464cf$export$2e2bcd8739ae039 = $e8ffd42531b464cf$var$KeyboardShortcuts;

});
parcelRegister("ei0RD", function(module, exports) {

$parcel$export(module.exports, "default", () => $0b77679a90380738$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var /* eslint-disable jira/i18n/id-named-by-package */ $0b77679a90380738$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    nextIssue: {
        "id": "issue-navigator.card-list.keyboard-shortcuts.next-issue",
        "defaultMessage": "Next issue"
    },
    previousIssue: {
        "id": "issue-navigator.card-list.keyboard-shortcuts.previous-issue",
        "defaultMessage": "Previous issue"
    },
    displaySortFields: {
        "id": "issue-navigator.card-list.keyboard-shortcuts.display-sort-fields",
        "defaultMessage": "Detail view order by"
    },
    openIssueFullScreen: {
        "id": "issue-navigator.card-list.keyboard-shortcuts.open-issue-full-screen",
        "defaultMessage": "Open issue fullscreen"
    }
});

});


parcelRegister("h75Xv", function(module, exports) {

$parcel$export(module.exports, "default", () => $7480e1a99482c29a$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $7480e1a99482c29a$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    issues: {
        "id": "issue-navigator.issue-results.detail-view.card-list.issues",
        "defaultMessage": "Issues"
    }
});

});



parcelRegister("clId8", function(module, exports) {

$parcel$export(module.exports, "default", () => $1bc630eeca29da2f$export$2e2bcd8739ae039);
$parcel$export(module.exports, "RecoverableErrorViewBoundary", () => $1bc630eeca29da2f$export$d42c1f6e3e564ee9);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $7u4fN = parcelRequire("7u4fN");

var $220ac = parcelRequire("220ac");

var $b5IAe = parcelRequire("b5IAe");
var $1ZAYh = parcelRequire("1ZAYh");

var $3Hdmt = parcelRequire("3Hdmt");

var $hgbp4 = parcelRequire("hgbp4");

var $5JgJ2 = parcelRequire("5JgJ2");

var $jMP2a = parcelRequire("jMP2a");
var $d6f6c = parcelRequire("d6f6c");

var $cQBUE = parcelRequire("cQBUE");

var $8lVKl = parcelRequire("8lVKl");
const $1bc630eeca29da2f$var$ErrorView = ({ onCaughtIssueSearchError: onCaughtIssueSearchError, error: errorProp })=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const { onIssueSearchRefresh: onIssueSearchRefresh } = (0, $cQBUE.useIssueSearchQuery)();
    const onClick = (0, $eUqFw.useCallback)((e, analyticsEvent)=>{
        // @ts-expect-error - Argument of type 'UIAnalyticsEvent | null' is not assignable to parameter of type 'UIAnalyticsEvent'.
        (0, $jMP2a.fireUIAnalytics)(analyticsEvent.clone(), 'refreshFromError');
        onIssueSearchRefresh();
    }, [
        onIssueSearchRefresh
    ]);
    const error = (0, $eUqFw.useMemo)(()=>errorProp || new Error('There was an error searching for issues'), [
        errorProp
    ]);
    (0, $eUqFw.useLayoutEffect)(()=>{
        onCaughtIssueSearchError && onCaughtIssueSearchError(error);
    }, [
        onCaughtIssueSearchError,
        error
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($1bc630eeca29da2f$var$Container, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $220ac.default), {
        header: formatMessage((0, $8lVKl.default).emptyStateErrorHeader),
        description: formatMessage((0, $8lVKl.default).emptyStateErrorDescription),
        testId: "issue-navigator.ui.issue-results.error-view.error-message",
        primaryAction: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7u4fN.default), {
            appearance: "primary",
            onClick: onClick
        }, formatMessage((0, $8lVKl.default).emptyStateErrorAction)),
        renderImage: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
                xcss: $1bc630eeca29da2f$var$ImageWrapperStyles
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $hgbp4.default), {
                alt: ""
            }))
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $d6f6c.FireUiAnalytics), {
        action: "viewed",
        actionSubject: "screen",
        actionSubjectId: "issueSearchError"
    }));
};
var $1bc630eeca29da2f$export$2e2bcd8739ae039 = $1bc630eeca29da2f$var$ErrorView;
const $1bc630eeca29da2f$export$d42c1f6e3e564ee9 = (0, $3Hdmt.withRecoverableErrorBoundary)(({ children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, children), {
    recoveryProp: 'recoveryProp',
    Fallback: $1bc630eeca29da2f$var$ErrorView
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $1bc630eeca29da2f$var$Container = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _16jlkb7n _4cvr1h6o",
            __cmplp.className
        ])
    });
});
const $1bc630eeca29da2f$var$ImageWrapperStyles = (0, $1ZAYh.xcss)({
    maxHeight: '146px',
    maxWidth: '160px',
    margin: 'auto',
    marginBottom: 'space.300'
});

});
parcelRegister("8lVKl", function(module, exports) {

$parcel$export(module.exports, "default", () => $6774220360df31ef$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $6774220360df31ef$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    emptyStateErrorHeader: {
        "id": "issue-navigator.issue-results.error-view.empty-state-error-header",
        "defaultMessage": "We couldn\u2019t load your search results"
    },
    emptyStateErrorDescription: {
        "id": "issue-navigator.issue-results.error-view.empty-state-error-description",
        "defaultMessage": "Refresh to try again."
    },
    emptyStateErrorAction: {
        "id": "issue-navigator.issue-results.error-view.empty-state-error-action",
        "defaultMessage": "Refresh"
    }
});

});


parcelRegister("4OYZ7", function(module, exports) {

$parcel$export(module.exports, "default", () => $d5d39cf8a057e809$export$2e2bcd8739ae039);

var $6coCb = parcelRequire("6coCb");

var $cWger = parcelRequire("cWger");

var $jrg0f = parcelRequire("jrg0f");

var $6aI4i = parcelRequire("6aI4i");

var $b7C4R = parcelRequire("b7C4R");

var $eUqFw = parcelRequire("eUqFw");

var $lEfVV = parcelRequire("lEfVV");

var $jG2Eu = parcelRequire("jG2Eu");

var $iWLL0 = parcelRequire("iWLL0");

var $b5IAe = parcelRequire("b5IAe");
var $1ZAYh = parcelRequire("1ZAYh");

var $guiFP = parcelRequire("guiFP");
var $1lXFP = parcelRequire("1lXFP");

var $1ybV0 = parcelRequire("1ybV0");

var $eI5EY = parcelRequire("eI5EY");

var $k8Qyf = parcelRequire("k8Qyf");

var $kZhcJ = parcelRequire("kZhcJ");

var $gsqQn = parcelRequire("gsqQn");

var $jLtGz = parcelRequire("jLtGz");
var $a4IeB = parcelRequire("a4IeB");

var $7JTqr = parcelRequire("7JTqr");

var $8WuJm = parcelRequire("8WuJm");
var $d6f6c = parcelRequire("d6f6c");

var $dWLk9 = parcelRequire("dWLk9");
var $6yplV = parcelRequire("6yplV");

var $idiDE = parcelRequire("idiDE");

var $jccNB = parcelRequire("jccNB");

var $kmXw8 = parcelRequire("kmXw8");

var $3wKQY = parcelRequire("3wKQY");

var $cWCvn = parcelRequire("cWCvn");

var $9PZPM = parcelRequire("9PZPM");

var $1ydM0 = parcelRequire("1ydM0");

var $4RwIp = parcelRequire("4RwIp");

var $2ycZm = parcelRequire("2ycZm");

var $3mEVr = parcelRequire("3mEVr");

var $dil2Z = parcelRequire("dil2Z");

var $cQBUE = parcelRequire("cQBUE");

var $aZxZH = parcelRequire("aZxZH");

var $1LgE9 = parcelRequire("1LgE9");

var $hps0t = parcelRequire("hps0t");

var $lJD7j = parcelRequire("lJD7j");

var $9flur = parcelRequire("9flur");

var $iNqNA = parcelRequire("iNqNA");

var $2SicN = parcelRequire("2SicN");

var $50IaJ = parcelRequire("50IaJ");

var $6Nns0 = parcelRequire("6Nns0");

var $1kw3p = parcelRequire("1kw3p");

var $8umcI = parcelRequire("8umcI");
const $d5d39cf8a057e809$var$reorderColumnsErrorFlag = {
    type: 'error',
    title: (0, $9flur.default).reorderColumnsErrorTitle,
    description: (0, $9flur.default).columnConfigMutationErrorDescription,
    isAutoDismiss: true
};
const $d5d39cf8a057e809$var$resetColumnsErrorFlag = {
    type: 'error',
    title: (0, $9flur.default).resetColumnsErrorTitle,
    description: (0, $9flur.default).columnConfigMutationErrorDescription,
    isAutoDismiss: true
};
const $d5d39cf8a057e809$var$TableContainer = ({ children: children })=>(0, $7JTqr.getWillShowNav4)() ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
        xcss: $d5d39cf8a057e809$var$TableContainerStyles
    }, children) : children;
const $d5d39cf8a057e809$export$bec6bbce63eee986 = ()=>{
    const [isRestoringDefaultColumns, setIsRestoringDefaultColumns] = (0, $eUqFw.useState)(false);
    return {
        isRestoringDefaultColumns: isRestoringDefaultColumns,
        setIsRestoringDefaultColumns: setIsRestoringDefaultColumns
    };
};
const $d5d39cf8a057e809$export$b4f6a715a9e57e85 = ()=>{
    const isAnonymous = (0, $6yplV.useIsAnonymous)();
    const { isFilterEditable: isFilterEditable } = (0, $3mEVr.useActiveJql)();
    const [{ view: view }] = (0, $4RwIp.useSelectedViewState)();
    const { hasViewIdChanged: hasViewIdChanged, isRefreshing: isRefreshing, isFetching: isFetching } = (0, $cQBUE.useIssueSearchQuery)();
    const { isRestoringDefaultColumns: isRestoringDefaultColumns } = $d5d39cf8a057e809$export$bec6bbce63eee986();
    return !isAnonymous && (!(0, $3wKQY.isFilterViewId)(view) || isFilterEditable === true) && !(isFetching && hasViewIdChanged) && !isRefreshing && !isRestoringDefaultColumns;
};
const $d5d39cf8a057e809$export$539ae4acd804b244 = (onRestoreDefaultColumns, viewData)=>{
    const { isFilterEditable: isFilterEditable } = (0, $3mEVr.useActiveJql)();
    const [{ view: selectedView }] = (0, $4RwIp.useSelectedViewState)();
    return !((0, $3wKQY.isFilterViewId)(selectedView) && isFilterEditable === false) && viewData?.hasDefaultFieldSets === false ? onRestoreDefaultColumns : undefined;
};
const $d5d39cf8a057e809$export$3e7a75a1659bbaae = (onColumnsChange)=>{
    const canEditColumns = $d5d39cf8a057e809$export$b4f6a715a9e57e85();
    return canEditColumns ? onColumnsChange : undefined;
};
const $d5d39cf8a057e809$export$d7623a323994e4cc = (selectedColumns)=>{
    const [{ view: selectedView }] = (0, $4RwIp.useSelectedViewState)();
    const canEditColumns = $d5d39cf8a057e809$export$b4f6a715a9e57e85();
    return (0, $dil2Z.useColumnLoader)(selectedView, canEditColumns, selectedColumns);
};
const $d5d39cf8a057e809$export$90b784197d8a906f = ()=>{
    const isAnonymous = (0, $6yplV.useIsAnonymous)();
    return !isAnonymous ? $d5d39cf8a057e809$export$d7623a323994e4cc : undefined;
};
const $d5d39cf8a057e809$export$6a2cc3745a117f8 = ()=>{
    const { hasViewIdChanged: hasViewIdChanged, isFetching: isFetching } = (0, $cQBUE.useIssueSearchQuery)();
    const { isRestoringDefaultColumns: isRestoringDefaultColumns } = $d5d39cf8a057e809$export$bec6bbce63eee986();
    return {
        isColumnPickerLoading: isRestoringDefaultColumns || isFetching && hasViewIdChanged
    };
};
const $d5d39cf8a057e809$var$ListView = ({ loading: loading, onChangeColumnConfiguration: onChangeColumnConfiguration, onSelectedRowChange: onSelectedRowChange, issueResults: issueResults, view: view, isFeedbackButtonDisabled: isFeedbackButtonDisabled, issueTableProps: issueTableProps, filter: filter })=>{
    (0, $cWCvn.markOnce)((0, $cWCvn.marks).ISSUE_RESULTS_LIST_VIEW_START);
    (0, $eUqFw.useLayoutEffect)(()=>{
        (0, $cWCvn.markOnce)((0, $cWCvn.marks).ISSUE_RESULTS_LIST_VIEW_END);
    }, []);
    /* eslint-disable @atlassian/relay/must-colocate-fragment-spreads */ const issueResultsData = (0, $iWLL0.useFragment)((0, $b7C4R.default), issueResults);
    const viewData = (0, $iWLL0.useFragment)((0, $6aI4i.default), view);
    const filterData = (0, $iWLL0.useFragment)((0, $jrg0f.default), filter);
    const [selectedIssueIndex, { selectIssueOnPage: selectIssueOnPage }] = (0, $1ydM0.useSelectedIssueIndex)();
    const currentPage = issueResultsData.pageCursors?.around?.find((cursor)=>cursor?.isCurrent)?.pageNumber ?? 1;
    const eventHandlers = (0, $8umcI.useEventHandlers)();
    const [{ field: field, direction: direction }, { setFieldAndDirection: setFieldAndDirection }] = (0, $2ycZm.useSortFieldAndDirection)();
    const { onIssueSearchForCurrentPage: onIssueSearchForCurrentPage } = (0, $cQBUE.useIssueSearchQuery)();
    const { isRestoringDefaultColumns: isRestoringDefaultColumns, setIsRestoringDefaultColumns: setIsRestoringDefaultColumns } = $d5d39cf8a057e809$export$bec6bbce63eee986();
    const onModifyColumns = (0, $eUqFw.useCallback)(()=>{
        onChangeColumnConfiguration && onChangeColumnConfiguration();
        onIssueSearchForCurrentPage();
    }, [
        onChangeColumnConfiguration,
        onIssueSearchForCurrentPage
    ]);
    const onPageChange = (0, $eUqFw.useCallback)((cursor, shouldSelectLastIssue)=>{
        selectIssueOnPage(cursor, shouldSelectLastIssue);
    }, [
        selectIssueOnPage
    ]);
    const onSortOrderChange = (0, $eUqFw.useCallback)((sortField, sortDirection)=>setFieldAndDirection(sortField, sortDirection, []), [
        setFieldAndDirection
    ]);
    const overriddenTableComponents = issueTableProps?.components;
    const issueCreateProjectKey = issueTableProps?.issueCreateProjectKey;
    const hasMaxSelectedColumns = viewData?.fieldSets?.totalCount ? viewData?.fieldSets?.totalCount >= (0, $a4IeB.MAX_COLUMNS) : false;
    const isAnonymous = (0, $6yplV.useIsAnonymous)();
    const { showFlag: showFlag } = (0, $k8Qyf.useFlagService)();
    const Footer = (0, $eI5EY.fg)('jira_spreadsheet_component_m1_api_updates') ? (0, $hps0t.Footer) : // eslint-disable-next-line react-hooks/rules-of-hooks
    (0, $hps0t.useFooterOverride)(isFeedbackButtonDisabled);
    const tableComponents = (0, $eUqFw.useMemo)(// We shallow merge these objects to make it easier for issue-navigator consumers to revert custom column
    // picker components, which are very NIN specific. This decision can be reconsidered if we need to introduce
    // additional nested custom components in the issue table and make those available to all consumers.
    ()=>({
            columnPicker: {
                Container: ({ children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $aZxZH.ColumnPickerContainer), {
                        viewIdFromResponse: (0, $3wKQY.parseIssueNavigatorViewIdOrDefault)(viewData.viewId),
                        isRestoringDefaults: isRestoringDefaultColumns
                    }, children),
                PopupComponent: (0, $1LgE9.default)
            },
            Footer: Footer,
            IssueCount: $lJD7j.IssueCount,
            NoColumns: $iNqNA.NoColumns,
            NoIssues: $2SicN.NoIssues,
            ...overriddenTableComponents
        }), [
        Footer,
        isRestoringDefaultColumns,
        overriddenTableComponents,
        viewData.viewId
    ]);
    const [replaceListViewFieldSets] = (0, $iWLL0.useMutation)((0, $cWger.default));
    const onColumnsChange = (0, $eUqFw.useCallback)((columnIds, changeType, optimisticFieldSets)=>{
        // This handler can be called from a native event listener hence React does not batch state updates.
        // We manually batch this update for better rendering performance and more accurate measurement of
        // drag-and-drop interaction performance. We can remove this with React 18's automatic batching.
        (0, (/*@__PURE__*/$parcel$interopDefault($lEfVV))).unstable_batchedUpdates(()=>{
            if (changeType === (0, $a4IeB.REORDER_COLUMNS)) (0, $6Nns0.dragAndDropExperience).start();
            replaceListViewFieldSets({
                variables: {
                    id: viewData.id,
                    amountOfColumns: (0, $a4IeB.MAX_COLUMNS),
                    fieldSetsInput: {
                        replaceFieldSetsInput: {
                            nodes: columnIds
                        }
                    },
                    includeView: changeType === (0, $a4IeB.REORDER_COLUMNS)
                },
                optimisticResponse: changeType === (0, $a4IeB.REORDER_COLUMNS) && optimisticFieldSets ? {
                    jira: {
                        replaceIssueSearchViewFieldSets: {
                            success: true,
                            view: {
                                id: viewData.id,
                                viewId: viewData.viewId,
                                hasDefaultFieldSets: viewData.hasDefaultFieldSets,
                                fieldSets: {
                                    ...optimisticFieldSets
                                }
                            }
                        }
                    }
                } : undefined,
                onCompleted (data) {
                    if (data.jira?.replaceIssueSearchViewFieldSets?.success) {
                        if (changeType === (0, $a4IeB.MODIFY_COLUMNS)) onModifyColumns();
                        else if (changeType === (0, $a4IeB.REORDER_COLUMNS)) (0, $6Nns0.dragAndDropExperience).success();
                    } else {
                        showFlag($d5d39cf8a057e809$var$reorderColumnsErrorFlag);
                        (0, $guiFP.default)({
                            meta: {
                                id: 'commitReplaceListViewFieldSetsMutationUnsuccessful',
                                packageName: (0, $jccNB.PACKAGE_NAME),
                                teamName: (0, $jccNB.TEAM_NAME)
                            },
                            sendToPrivacyUnsafeSplunk: true,
                            attributes: {
                                changeType: changeType
                            }
                        });
                        if (changeType === (0, $a4IeB.REORDER_COLUMNS)) (0, $6Nns0.dragAndDropExperience).failure();
                    }
                },
                onError (error) {
                    showFlag($d5d39cf8a057e809$var$reorderColumnsErrorFlag);
                    (0, $guiFP.default)({
                        meta: {
                            id: 'commitReplaceListViewFieldSetsMutationError',
                            packageName: (0, $jccNB.PACKAGE_NAME),
                            teamName: (0, $jccNB.TEAM_NAME)
                        },
                        error: error,
                        sendToPrivacyUnsafeSplunk: true,
                        attributes: {
                            changeType: changeType
                        }
                    });
                    if (changeType === (0, $a4IeB.REORDER_COLUMNS)) (0, $6Nns0.dragAndDropExperience).failure();
                }
            });
        });
    }, [
        replaceListViewFieldSets,
        onModifyColumns,
        showFlag,
        viewData.hasDefaultFieldSets,
        viewData.id,
        viewData.viewId
    ]);
    const [updateFieldSetPreferences] = (0, $iWLL0.useMutation)((0, $6coCb.default));
    const cloudId = (0, $dWLk9.useCloudId)();
    const updateColumnWidth = (0, $1ybV0.ff)('nin-resizable-columns_8z4eo') ? // eslint-disable-next-line react-hooks/rules-of-hooks
    (0, $1kw3p.useColumnWidthUpdater)(viewData.fieldSets.__id) : (0, (/*@__PURE__*/$parcel$interopDefault($jG2Eu)));
    const onColumnResize = (0, $eUqFw.useCallback)((columnId, width)=>{
        // skip mutation for anonymous users as they don't have access to user preferences
        if (!isAnonymous) // we intentionally don't optimistically update the store to avoid rolling back column widths
        // in case of a mutation error, which would be very jarring for the user
        updateFieldSetPreferences({
            variables: {
                cloudId: cloudId,
                input: {
                    nodes: [
                        {
                            fieldSetId: columnId,
                            width: width ?? null
                        }
                    ]
                }
            },
            onCompleted (data) {
                if (!data.jira?.updateUserFieldSetPreferences?.success) // silently fail as column will remain at the desired width until the next page load
                (0, $guiFP.default)({
                    meta: {
                        id: 'commitUpdateFieldSetPreferencesMutationUnsuccessful',
                        packageName: (0, $jccNB.PACKAGE_NAME),
                        teamName: (0, $jccNB.TEAM_NAME)
                    },
                    sendToPrivacyUnsafeSplunk: true
                });
            },
            onError (error) {
                // silently fail as column will remain at the desired width until the next page load
                (0, $guiFP.default)({
                    meta: {
                        id: 'commitUpdateFieldSetPreferencesMutationError',
                        packageName: (0, $jccNB.PACKAGE_NAME),
                        teamName: (0, $jccNB.TEAM_NAME)
                    },
                    error: error,
                    sendToPrivacyUnsafeSplunk: true
                });
            }
        });
        // commit local update to the store independently of the mutation result to preserve user's desired width
        updateColumnWidth(columnId, width);
    }, [
        cloudId,
        isAnonymous,
        updateColumnWidth,
        updateFieldSetPreferences
    ]);
    (0, $eUqFw.useLayoutEffect)(()=>{
        (0, $6Nns0.dragAndDropExperience).markInlineResponse();
    });
    const contextValue = (0, $eUqFw.useMemo)(()=>({
            hasMaxSelectedColumns: hasMaxSelectedColumns,
            filterName: filterData?.name
        }), [
        filterData?.name,
        hasMaxSelectedColumns
    ]);
    const { onIssueSearchRefresh: onIssueSearchRefresh } = (0, $cQBUE.useIssueSearchQuery)();
    const onRestoreDefaultColumns = (0, $eUqFw.useCallback)(()=>{
        setIsRestoringDefaultColumns(true);
        replaceListViewFieldSets({
            variables: {
                id: viewData.id,
                amountOfColumns: (0, $a4IeB.MAX_COLUMNS),
                includeView: true,
                fieldSetsInput: {
                    resetToDefaultFieldSets: true
                }
            },
            onCompleted (data) {
                setIsRestoringDefaultColumns(false);
                if (data.jira?.replaceIssueSearchViewFieldSets?.success) onIssueSearchRefresh();
                else {
                    showFlag($d5d39cf8a057e809$var$resetColumnsErrorFlag);
                    (0, $guiFP.default)({
                        meta: {
                            id: 'commitReplaceListViewUsingResetFieldSetsMutationUnsuccessful',
                            packageName: (0, $jccNB.PACKAGE_NAME),
                            teamName: (0, $jccNB.TEAM_NAME)
                        },
                        sendToPrivacyUnsafeSplunk: true
                    });
                }
            },
            onError (error) {
                setIsRestoringDefaultColumns(false);
                showFlag($d5d39cf8a057e809$var$resetColumnsErrorFlag);
                (0, $guiFP.default)({
                    meta: {
                        id: 'commitReplaceListViewUsingResetFieldSetsMutationError',
                        packageName: (0, $jccNB.PACKAGE_NAME),
                        teamName: (0, $jccNB.TEAM_NAME)
                    },
                    error: error,
                    sendToPrivacyUnsafeSplunk: true
                });
            }
        });
    }, [
        replaceListViewFieldSets,
        onIssueSearchRefresh,
        setIsRestoringDefaultColumns,
        showFlag,
        viewData.id
    ]);
    /**
   * returns undefined if there are default field sets
   * returns undefined if the user is on filter tab but cannot edit filter
   */ const conditionalOnRestoreDefaults = $d5d39cf8a057e809$export$539ae4acd804b244(onRestoreDefaultColumns, viewData);
    const conditionalOnChange = $d5d39cf8a057e809$export$3e7a75a1659bbaae(onColumnsChange);
    const { isColumnPickerLoading: isColumnPickerLoading } = $d5d39cf8a057e809$export$6a2cc3745a117f8();
    const conditionalColumnLoader = $d5d39cf8a057e809$export$90b784197d8a906f();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $idiDE.default), {
        name: "list-view"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gsqQn.DialogContextContainer), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8WuJm.ContextualAnalyticsData), {
        attributes: {
            currentPage: currentPage,
            isAnonymous: isAnonymous
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $50IaJ.AsyncRegisterShortcutDialogActions), {
        issues: issueResultsData,
        selectedIssueIndex: selectedIssueIndex,
        eventHandlers: eventHandlers
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $9PZPM.ColumnPickerMessageContext).Provider, {
        value: contextValue
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($d5d39cf8a057e809$var$TableContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $jLtGz.default), {
        issues: issueResultsData,
        columns: viewData.fieldSets,
        onColumnsChange: conditionalOnChange,
        onRestoreDefaultColumns: conditionalOnRestoreDefaults,
        useColumnLoader: conditionalColumnLoader,
        loading: loading,
        eventHandlers: eventHandlers,
        onSelectedRowChange: onSelectedRowChange,
        onPageChange: onPageChange,
        selectedRow: selectedIssueIndex,
        sortField: field,
        sortDirection: direction,
        onSortChange: onSortOrderChange,
        components: tableComponents,
        issueSearchBaseUrl: "" // Relative to current route rendering the issue navigator
        ,
        isColumnPickerLoading: isColumnPickerLoading,
        issueCreateProjectKey: issueCreateProjectKey,
        onColumnResize: (0, $1ybV0.ff)('nin-resizable-columns_8z4eo') ? onColumnResize : undefined
    })))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $kZhcJ.default), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $d6f6c.FireScreenAnalytics), null)));
};
// re-render regression detection
$d5d39cf8a057e809$var$ListView.whyDidYouRender = true;
var $d5d39cf8a057e809$export$2e2bcd8739ae039 = (0, $kmXw8.withReportErrors)($d5d39cf8a057e809$var$ListView, {
    id: 'ui.issue-results.list-view.unhandled',
    packageName: (0, $jccNB.PACKAGE_NAME),
    teamName: (0, $jccNB.TEAM_NAME),
    sendToPrivacyUnsafeSplunk: true,
    attributes: (0, $1lXFP.isLoaderErrorAttributes)
});
const $d5d39cf8a057e809$var$TableContainerStyles = (0, $1ZAYh.xcss)({
    flexGrow: 1,
    flexBasis: 0,
    display: 'flex',
    height: '100%',
    overflow: 'hidden',
    flexDirection: 'column'
});

});
parcelRegister("6coCb", function(module, exports) {

$parcel$export(module.exports, "default", () => $38e594bde34f16e5$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<f869b29cb2bead806de4a76c098662d6>>
 * @relayHash 49c7fff6a0e7619f946ea6858ac070f4
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID aa78c7137d4bf2c426f358e5e8e25a3d05afb5062d08ddd15fa808b550e9004e
const $38e594bde34f16e5$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "cloudId"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "input"
        }
    ], v1 = [
        {
            "concreteType": "JiraMutation",
            "kind": "LinkedField",
            "name": "jira",
            "plural": false,
            "selections": [
                {
                    "args": [
                        {
                            "kind": "Variable",
                            "name": "cloudId",
                            "variableName": "cloudId"
                        },
                        {
                            "kind": "Variable",
                            "name": "fieldSetPreferencesInput",
                            "variableName": "input"
                        }
                    ],
                    "concreteType": "JiraFieldSetPreferencesUpdatePayload",
                    "kind": "LinkedField",
                    "name": "updateUserFieldSetPreferences",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "success"
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "main_updateFieldSetPreferencesMutation",
            "selections": v1 /*: any*/ ,
            "type": "Mutation"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "main_updateFieldSetPreferencesMutation",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "id": "aa78c7137d4bf2c426f358e5e8e25a3d05afb5062d08ddd15fa808b550e9004e",
            "metadata": {},
            "name": "main_updateFieldSetPreferencesMutation",
            "operationKind": "mutation",
            "text": null
        }
    };
}();
$38e594bde34f16e5$var$node.hash = "5e33dd509f20cf3d934020e4f1ce2386";
var $38e594bde34f16e5$export$2e2bcd8739ae039 = $38e594bde34f16e5$var$node;

});

parcelRegister("cWger", function(module, exports) {

$parcel$export(module.exports, "default", () => $9ebdaf70bae45743$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<d46729d7cff5f993e598f846a3ab4da2>>
 * @relayHash 7e601286fa25ec0e4456f5f3e2cd3a59
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 60755061ca9cb2443e03eb26399f3feb58104487ff5964d24b831a7b022283ad

var $lWCGp = parcelRequire("lWCGp");
const $9ebdaf70bae45743$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "amountOfColumns"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "fieldSetsInput"
    }, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "id"
    }, v3 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "includeView"
    }, v4 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "input"
    }, v5 = [
        {
            "kind": "Variable",
            "name": "fieldSetsInput",
            "variableName": "fieldSetsInput"
        },
        {
            "kind": "Variable",
            "name": "id",
            "variableName": "id"
        },
        {
            "kind": "Variable",
            "name": "input",
            "variableName": "input"
        }
    ], v6 = {
        "kind": "ScalarField",
        "name": "success"
    }, v7 = {
        "kind": "ScalarField",
        "name": "viewId"
    }, v8 = {
        "kind": "ScalarField",
        "name": "displayName"
    };
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v3 /*: any*/ ,
                v4 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "main_replaceListViewFieldSetsMutation",
            "selections": [
                {
                    "concreteType": "JiraMutation",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "args": v5 /*: any*/ ,
                            "concreteType": "JiraIssueSearchViewPayload",
                            "kind": "LinkedField",
                            "name": "replaceIssueSearchViewFieldSets",
                            "plural": false,
                            "selections": [
                                v6 /*: any*/ ,
                                {
                                    "condition": "includeView",
                                    "kind": "Condition",
                                    "passingValue": true,
                                    "selections": [
                                        {
                                            "concreteType": "JiraIssueSearchView",
                                            "kind": "LinkedField",
                                            "name": "view",
                                            "plural": false,
                                            "selections": [
                                                v7 /*: any*/ ,
                                                {
                                                    "kind": "FragmentSpread",
                                                    "name": "main_issueNavigator_ListView_view"
                                                }
                                            ]
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ],
            "type": "Mutation"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v2 /*: any*/ ,
                v4 /*: any*/ ,
                v1 /*: any*/ ,
                v0 /*: any*/ ,
                v3 /*: any*/ ,
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcninresizablecolumnsrelayprovider"
                }
            ],
            "kind": "Operation",
            "name": "main_replaceListViewFieldSetsMutation",
            "selections": [
                {
                    "concreteType": "JiraMutation",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "args": v5 /*: any*/ ,
                            "concreteType": "JiraIssueSearchViewPayload",
                            "kind": "LinkedField",
                            "name": "replaceIssueSearchViewFieldSets",
                            "plural": false,
                            "selections": [
                                v6 /*: any*/ ,
                                {
                                    "condition": "includeView",
                                    "kind": "Condition",
                                    "passingValue": true,
                                    "selections": [
                                        {
                                            "concreteType": "JiraIssueSearchView",
                                            "kind": "LinkedField",
                                            "name": "view",
                                            "plural": false,
                                            "selections": [
                                                v7 /*: any*/ ,
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "id"
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "hasDefaultFieldSets"
                                                },
                                                {
                                                    "args": [
                                                        {
                                                            "kind": "Literal",
                                                            "name": "filter",
                                                            "value": {
                                                                "fieldSetSelectedState": "SELECTED"
                                                            }
                                                        },
                                                        {
                                                            "kind": "Variable",
                                                            "name": "first",
                                                            "variableName": "amountOfColumns"
                                                        }
                                                    ],
                                                    "concreteType": "JiraIssueSearchFieldSetConnection",
                                                    "kind": "LinkedField",
                                                    "name": "fieldSets",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "totalCount"
                                                        },
                                                        {
                                                            "concreteType": "JiraIssueSearchFieldSetEdge",
                                                            "kind": "LinkedField",
                                                            "name": "edges",
                                                            "plural": true,
                                                            "selections": [
                                                                {
                                                                    "concreteType": "JiraIssueSearchFieldSet",
                                                                    "kind": "LinkedField",
                                                                    "name": "node",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        {
                                                                            "kind": "ScalarField",
                                                                            "name": "fieldSetId"
                                                                        },
                                                                        {
                                                                            "kind": "ScalarField",
                                                                            "name": "type"
                                                                        },
                                                                        v8 /*: any*/ ,
                                                                        {
                                                                            "kind": "ScalarField",
                                                                            "name": "jqlTerm"
                                                                        },
                                                                        {
                                                                            "kind": "ScalarField",
                                                                            "name": "isSortable"
                                                                        },
                                                                        {
                                                                            "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcninresizablecolumnsrelayprovider",
                                                                            "kind": "Condition",
                                                                            "passingValue": true,
                                                                            "selections": [
                                                                                {
                                                                                    "concreteType": "JiraFieldSetPreferences",
                                                                                    "kind": "LinkedField",
                                                                                    "name": "fieldSetPreferences",
                                                                                    "plural": false,
                                                                                    "selections": [
                                                                                        {
                                                                                            "kind": "ScalarField",
                                                                                            "name": "width"
                                                                                        }
                                                                                    ]
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "concreteType": "JiraFieldType",
                                                                            "kind": "LinkedField",
                                                                            "name": "fieldType",
                                                                            "plural": false,
                                                                            "selections": [
                                                                                v8 /*: any*/ 
                                                                            ]
                                                                        }
                                                                    ]
                                                                }
                                                            ]
                                                        },
                                                        {
                                                            "kind": "ClientExtension",
                                                            "selections": [
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "name": "__id"
                                                                }
                                                            ]
                                                        }
                                                    ]
                                                }
                                            ]
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "60755061ca9cb2443e03eb26399f3feb58104487ff5964d24b831a7b022283ad",
            "metadata": {},
            "name": "main_replaceListViewFieldSetsMutation",
            "operationKind": "mutation",
            "text": null,
            "providedVariables": {
                "__relay_internal__pv__atlassianjirarelayprovidersrcninresizablecolumnsrelayprovider": (0, $lWCGp.default)
            }
        }
    };
}();
$9ebdaf70bae45743$var$node.hash = "9be997dbbfbbbdee8b96e0b00eeacd80";
var $9ebdaf70bae45743$export$2e2bcd8739ae039 = $9ebdaf70bae45743$var$node;

});

parcelRegister("jrg0f", function(module, exports) {

$parcel$export(module.exports, "default", () => $c7b70283925939a2$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<b1ac4ee09aa06d0c162ef3bdadd8c445>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $c7b70283925939a2$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "main_issueNavigator_ListView_filter",
    "selections": [
        {
            "kind": "ScalarField",
            "name": "name"
        }
    ],
    "type": "JiraFilter",
    "abstractKey": "__isJiraFilter"
};
$c7b70283925939a2$var$node.hash = "42fd583d4b19e59270b0aa45271f2d67";
var $c7b70283925939a2$export$2e2bcd8739ae039 = $c7b70283925939a2$var$node;

});

parcelRegister("6aI4i", function(module, exports) {

$parcel$export(module.exports, "default", () => $d8947169e59ecfe8$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<33bcb3d331e273f82c777a2a3114ae5c>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $d8947169e59ecfe8$var$node = {
    "argumentDefinitions": [
        {
            "kind": "RootArgument",
            "name": "__relay_internal__pv__atlassianjirarelayprovidersrcninresizablecolumnsrelayprovider"
        },
        {
            "kind": "RootArgument",
            "name": "amountOfColumns"
        }
    ],
    "kind": "Fragment",
    "name": "main_issueNavigator_ListView_view",
    "selections": [
        {
            "kind": "RequiredField",
            "field": {
                "kind": "ScalarField",
                "name": "id"
            },
            "action": "THROW",
            "path": "id"
        },
        {
            "kind": "RequiredField",
            "field": {
                "kind": "ScalarField",
                "name": "viewId"
            },
            "action": "THROW",
            "path": "viewId"
        },
        {
            "kind": "ScalarField",
            "name": "hasDefaultFieldSets"
        },
        {
            "kind": "RequiredField",
            "field": {
                "args": [
                    {
                        "kind": "Literal",
                        "name": "filter",
                        "value": {
                            "fieldSetSelectedState": "SELECTED"
                        }
                    },
                    {
                        "kind": "Variable",
                        "name": "first",
                        "variableName": "amountOfColumns"
                    }
                ],
                "concreteType": "JiraIssueSearchFieldSetConnection",
                "kind": "LinkedField",
                "name": "fieldSets",
                "plural": false,
                "selections": [
                    {
                        "kind": "ScalarField",
                        "name": "totalCount"
                    },
                    {
                        "args": [
                            {
                                "kind": "Variable",
                                "name": "fetchColumnWidths",
                                "variableName": "__relay_internal__pv__atlassianjirarelayprovidersrcninresizablecolumnsrelayprovider"
                            }
                        ],
                        "kind": "FragmentSpread",
                        "name": "ui_nativeIssueTable_NativeIssueTable_columns"
                    },
                    {
                        "kind": "ClientExtension",
                        "selections": [
                            {
                                "kind": "ScalarField",
                                "name": "__id"
                            }
                        ]
                    }
                ]
            },
            "action": "THROW",
            "path": "fieldSets"
        }
    ],
    "type": "JiraIssueSearchView"
};
$d8947169e59ecfe8$var$node.hash = "6ca3f23cd7cf7a69a494b3691fb80460";
var $d8947169e59ecfe8$export$2e2bcd8739ae039 = $d8947169e59ecfe8$var$node;

});

parcelRegister("b7C4R", function(module, exports) {

$parcel$export(module.exports, "default", () => $c93a083c91eea26f$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<ca61d3b897a40059fb5af2393e57b6e8>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $c93a083c91eea26f$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "main_issueNavigator_ListView_issueResults",
    "selections": [
        {
            "kind": "FragmentSpread",
            "name": "registerShortcutDialogActions_issueNavigator_RegisterShortcutsDialogActions"
        },
        {
            "kind": "FragmentSpread",
            "name": "ui_nativeIssueTable_NativeIssueTable_issues"
        },
        {
            "args": [
                {
                    "kind": "Literal",
                    "name": "maxCursors",
                    "value": 7
                }
            ],
            "concreteType": "JiraPageCursors",
            "kind": "LinkedField",
            "name": "pageCursors",
            "plural": false,
            "selections": [
                {
                    "concreteType": "JiraPageCursor",
                    "kind": "LinkedField",
                    "name": "around",
                    "plural": true,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "pageNumber"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "isCurrent"
                        }
                    ]
                }
            ],
            "storageKey": "pageCursors(maxCursors:7)"
        }
    ],
    "type": "JiraIssueConnection"
};
$c93a083c91eea26f$var$node.hash = "8bb2bf1cb83c6f30e26da9256de8d566";
var $c93a083c91eea26f$export$2e2bcd8739ae039 = $c93a083c91eea26f$var$node;

});

parcelRegister("kZhcJ", function(module, exports) {

$parcel$export(module.exports, "default", () => $f41c1a8886a2b716$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $7rh0R = parcelRequire("7rh0R");

var $cyVXS = parcelRequire("cyVXS");

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $f41c1a8886a2b716$var$AsyncAttachFileModal = (0, $7rh0R.lazy)(()=>(parcelRequire("c6CeD")), {
    moduleId: "./src/packages/issue-navigator/issue-operations/dialogs/attach-file-dialog/src/ui/index.tsx"
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$f41c1a8886a2b716$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $cyVXS.ModalBoundary), {
        id: "attach-file-dialog",
        packageName: "native-issue-table"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($f41c1a8886a2b716$var$AsyncAttachFileModal, null));

});
parcelRegister("c6CeD", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = Promise.all([
    $d1Cng("2hmUs"),
    $d1Cng("bCeK4"),
    $d1Cng("h2MrD"),
    $d1Cng("bYT2S"),
    $d1Cng("bHFwf")
]).then(()=>parcelRequire('3ae2d'));

});


parcelRegister("gsqQn", function(module, exports) {

$parcel$export(module.exports, "DialogContextContainer", () => $a8f0ee5e4e8c0872$export$8e9ef3fae6d51d86);
$parcel$export(module.exports, "useIssueOperationsDialogContext", () => $a8f0ee5e4e8c0872$export$a2a00ec2da7337e);

var $96gVp = parcelRequire("96gVp");
var $1yZQx = parcelRequire("1yZQx");
var $kEDjj = parcelRequire("kEDjj");
const $a8f0ee5e4e8c0872$var$initialState = {
    openDialog: null,
    issueKey: null,
    issueId: null,
    mediaUploadContext: null
};
const $a8f0ee5e4e8c0872$var$actions = {
    setDialogContext: (openDialog, issueId, issueKey, mediaUploadContext)=>({ setState: setState })=>{
            setState({
                openDialog: openDialog,
                issueId: issueId,
                issueKey: issueKey,
                mediaUploadContext: mediaUploadContext
            });
        }
};
const $a8f0ee5e4e8c0872$var$Store = (0, $kEDjj.createStore)({
    initialState: $a8f0ee5e4e8c0872$var$initialState,
    actions: $a8f0ee5e4e8c0872$var$actions,
    name: 'IssueNavigatorIssueOperationsDialogContext'
});
const $a8f0ee5e4e8c0872$export$8e9ef3fae6d51d86 = (0, $96gVp.createContainer)($a8f0ee5e4e8c0872$var$Store);
const $a8f0ee5e4e8c0872$export$a2a00ec2da7337e = (0, $1yZQx.createHook)($a8f0ee5e4e8c0872$var$Store);

});

parcelRegister("jLtGz", function(module, exports) {

$parcel$export(module.exports, "default", () => $627054f58fabcc4b$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $7rh0R = parcelRequire("7rh0R");

var $gGtKh = parcelRequire("gGtKh");

var $hlomJ = parcelRequire("hlomJ");

const $627054f58fabcc4b$var$AsyncNativeIssueTable = (0, $7rh0R.lazyForPaint)(()=>(parcelRequire("5mXDo")), {
    moduleId: "./src/packages/platform/ui/issue-table/issue-table/src/ui/index.tsx"
});
const $627054f58fabcc4b$var$AsyncNativeIssueTableWithWrapper = /*#__PURE__*/ (0, $eUqFw.memo)((props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gGtKh.default), {
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $hlomJ.IssueTableSkeleton), null),
        name: "async-native-issue-table"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($627054f58fabcc4b$var$AsyncNativeIssueTable, props)));
var $627054f58fabcc4b$export$2e2bcd8739ae039 = $627054f58fabcc4b$var$AsyncNativeIssueTableWithWrapper;

});
parcelRegister("hlomJ", function(module, exports) {

$parcel$export(module.exports, "IssueTableSkeleton", () => $9b0846c29dcc68be$export$32020b6a5557f03e);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $29WMc = parcelRequire("29WMc");
const $9b0846c29dcc68be$export$32020b6a5557f03e = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($9b0846c29dcc68be$var$SkeletonContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $29WMc.NativeIssueTableSkeleton), null));
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $9b0846c29dcc68be$var$SkeletonContainer = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_16jlkb7n _1reo15vq _18m915vq",
            __cmplp.className
        ])
    });
});

});

parcelRegister("5mXDo", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = Promise.all([
    $d1Cng("hPzOn"),
    $d1Cng("4yBIX")
]).then(()=>parcelRequire('8iViP'));

});


parcelRegister("9PZPM", function(module, exports) {

$parcel$export(module.exports, "ColumnPickerMessageContext", () => $d76ac61a9eba46fd$export$2f14e8286acf4660);

var $eUqFw = parcelRequire("eUqFw");
const $d76ac61a9eba46fd$var$defaultMessageContext = {
    hasMaxSelectedColumns: false
};
const $d76ac61a9eba46fd$export$2f14e8286acf4660 = /*#__PURE__*/ (0, $eUqFw.createContext)($d76ac61a9eba46fd$var$defaultMessageContext);

});

parcelRegister("dil2Z", function(module, exports) {

$parcel$export(module.exports, "useColumnLoader", () => $87ff64cc8e13943b$export$6dc2ac601f90aafc);

var $eoc2T = parcelRequire("eoc2T");

var $eUqFw = parcelRequire("eUqFw");

var $iWLL0 = parcelRequire("iWLL0");

var $1Yimi = parcelRequire("1Yimi");

var $guiFP = parcelRequire("guiFP");

var $5JgJ2 = parcelRequire("5JgJ2");

var $aIxxL = parcelRequire("aIxxL");
var $3jzIw = parcelRequire("3jzIw");

var $d7cju = parcelRequire("d7cju");

var $dWLk9 = parcelRequire("dWLk9");

var $jccNB = parcelRequire("jccNB");

var $3wKQY = parcelRequire("3wKQY");

var $4h281 = parcelRequire("4h281");

var $5cwmS = parcelRequire("5cwmS");
const $87ff64cc8e13943b$var$mapColumnPickerOptions = (data, search, intl, selectedColumns, canEditColumns)=>{
    let totalCount = 0;
    let edges;
    let endCursor;
    if (data?.jira.issueSearchViewByNamespaceAndViewId.fieldSets) {
        totalCount = data?.jira.issueSearchViewByNamespaceAndViewId.fieldSets.totalCount;
        edges = data?.jira.issueSearchViewByNamespaceAndViewId.fieldSets.edges;
        endCursor = data?.jira.issueSearchViewByNamespaceAndViewId.fieldSets.pageInfo?.endCursor ? data?.jira.issueSearchViewByNamespaceAndViewId.fieldSets.pageInfo.endCursor : undefined;
    }
    // @ts-expect-error - Argument of type '(edge: Node) => { secondaryLabel?: JSX.Element | undefined; isDisabled?: true | undefined; disabledMessage?: React.ReactNode; optionType: "option"; cursor: string; value: string; label: string; }' is not assignable to parameter of type '(value: { readonly cursor: string; readonly node: { readonly displayName: string; readonly fieldSetId: string; readonly fieldType?: { readonly displayName: string | null | undefined; } | null | undefined; readonly type: string; }; }, index: number, array: { ...; }[]) => { ...; }'.
    const options = edges?.filter((0, $3wKQY.isNonNullish)).map((edge)=>{
        const fieldTypeDisplayName = edge.node.fieldType?.displayName;
        const icon = edge.node.type ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $d7cju.FieldTypeIcon), {
            type: edge.node.type,
            size: "small"
        }) : undefined;
        const isOnlyUnselectable = (0, $5cwmS.isOnlyUnselectableField)(edge.node.type, canEditColumns);
        return {
            optionType: 'option',
            cursor: edge.cursor,
            value: edge.node.fieldSetId,
            label: edge.node.displayName,
            secondaryLabel: fieldTypeDisplayName && icon ? (0, $3jzIw.getSecondaryLabelWithIcon)(icon, fieldTypeDisplayName) : undefined,
            ...isOnlyUnselectable && {
                isOnlyUnselectable: isOnlyUnselectable,
                disabledMessage: intl.formatMessage((0, $4h281.default).deprecatedParentyLinkMessage, {
                    field: edge.node.displayName,
                    strong: (chunks)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1Yimi.default), {
                            as: "strong",
                            color: "inherit",
                            size: "UNSAFE_small"
                        }, chunks)
                })
            }
        };
    });
    if (!options?.length) return {
        options: [],
        totalCount: 0
    };
    if (search.length) return {
        options: options,
        totalCount: totalCount,
        endCursor: endCursor
    };
    // total count is the count of unselected options for non-search queries
    totalCount += selectedColumns.length;
    return {
        options: [
            {
                label: intl.formatMessage((0, $4h281.default).columnGroupHeader),
                optionType: 'group',
                options: options
            }
        ],
        totalCount: totalCount,
        endCursor: endCursor
    };
};
const $87ff64cc8e13943b$export$6dc2ac601f90aafc = (viewId, canEditColumns, selectedColumns)=>{
    const intl = (0, $5JgJ2.default)();
    const cloudId = (0, $dWLk9.useCloudId)();
    const environment = (0, $iWLL0.useRelayEnvironment)();
    // refs for selectedColumns, endCursor and search prevent outdated data in the relay store from being used
    // in cases when selected options changes & picker is paginated
    const columnsRef = (0, $eUqFw.useRef)(selectedColumns);
    const endCursorRef = (0, $eUqFw.useRef)();
    const searchRef = (0, $eUqFw.useRef)();
    const loadedOptionsRef = (0, $eUqFw.useRef)();
    return (0, $eUqFw.useMemo)(()=>(0, $aIxxL.createDebouncedColumnLoader)(async (search, renderInitialValues, endCursor)=>{
            let cursor = endCursor;
            if (!canEditColumns) {
                const options = selectedColumns ? selectedColumns.filter((col)=>col.optionType === 'option' && (search ? col.label.toLocaleLowerCase().includes(search.toLocaleLowerCase()) : true)) : [];
                return Promise.resolve({
                    options: options,
                    totalCount: options.length
                });
            }
            // calculate cursor from edges, since endCursor might not be valid anymore when last option was selected
            if (endCursor !== undefined && loadedOptionsRef.current && selectedColumns) cursor = (0, $5cwmS.getCursorOfLastUnselectedOption)(loadedOptionsRef.current, selectedColumns, search, endCursor);
            try {
                const result = await (0, $iWLL0.fetchQuery)(environment, (0, $eoc2T.default), {
                    cloudId: cloudId,
                    namespace: (0, $jccNB.ISSUE_SEARCH_NAMESPACE),
                    viewId: viewId,
                    first: 25,
                    after: cursor,
                    filter: {
                        searchString: search,
                        fieldSetSelectedState: !search ? 'NON_SELECTED' : 'ALL'
                    }
                }, {
                    fetchPolicy: columnsRef.current !== selectedColumns || endCursorRef.current !== cursor || searchRef.current !== search ? 'network-only' : 'store-or-network'
                }).toPromise();
                columnsRef.current = selectedColumns;
                endCursorRef.current = cursor;
                searchRef.current = search;
                const pickerOptions = $87ff64cc8e13943b$var$mapColumnPickerOptions(result, search, intl, selectedColumns, canEditColumns);
                loadedOptionsRef.current = pickerOptions.options || undefined;
                return pickerOptions;
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            } catch (error) {
                (0, $guiFP.default)({
                    meta: {
                        id: 'fetchColumnPickerOptions',
                        packageName: (0, $jccNB.PACKAGE_NAME),
                        teamName: (0, $jccNB.TEAM_NAME)
                    },
                    error: error,
                    sendToPrivacyUnsafeSplunk: true
                });
                loadedOptionsRef.current = undefined;
                return {
                    options: [
                        {
                            optionType: 'error',
                            error: error,
                            onRetry: ()=>undefined
                        }
                    ],
                    totalCount: 0
                };
            }
        }), [
        canEditColumns,
        cloudId,
        environment,
        intl,
        selectedColumns,
        viewId
    ]);
};

});
parcelRegister("eoc2T", function(module, exports) {

$parcel$export(module.exports, "default", () => $e7c77884534ed2ad$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<140068a82225ca3e6b3fc9a32209f60e>>
 * @relayHash e7018d1ccf85dde8ada50bb8f93d8d96
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 2fc2bdb7e99242c748d59a003f006e50b4a56a963e6ef08e6ffb31bdfa8c511d
const $e7c77884534ed2ad$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "after"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "cloudId"
    }, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "filter"
    }, v3 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "first"
    }, v4 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "namespace"
    }, v5 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "viewId"
    }, v6 = [
        {
            "kind": "Variable",
            "name": "cloudId",
            "variableName": "cloudId"
        },
        {
            "kind": "Variable",
            "name": "namespace",
            "variableName": "namespace"
        },
        {
            "kind": "Variable",
            "name": "viewId",
            "variableName": "viewId"
        }
    ], v7 = [
        {
            "kind": "Variable",
            "name": "after",
            "variableName": "after"
        },
        {
            "kind": "Variable",
            "name": "filter",
            "variableName": "filter"
        },
        {
            "kind": "Variable",
            "name": "first",
            "variableName": "first"
        }
    ], v8 = {
        "kind": "ScalarField",
        "name": "totalCount"
    }, v9 = {
        "concreteType": "PageInfo",
        "kind": "LinkedField",
        "name": "pageInfo",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "endCursor"
            }
        ]
    }, v10 = {
        "kind": "ScalarField",
        "name": "cursor"
    }, v11 = {
        "kind": "ScalarField",
        "name": "fieldSetId"
    }, v12 = {
        "kind": "ScalarField",
        "name": "displayName"
    }, v13 = {
        "kind": "ScalarField",
        "name": "type"
    }, v14 = {
        "concreteType": "JiraFieldType",
        "kind": "LinkedField",
        "name": "fieldType",
        "plural": false,
        "selections": [
            v12 /*: any*/ 
        ]
    };
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v3 /*: any*/ ,
                v4 /*: any*/ ,
                v5 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "fetchColumnPickerOptionsQuery",
            "selections": [
                {
                    "kind": "RequiredField",
                    "field": {
                        "concreteType": "JiraQuery",
                        "kind": "LinkedField",
                        "name": "jira",
                        "plural": false,
                        "selections": [
                            {
                                "kind": "RequiredField",
                                "field": {
                                    "args": v6 /*: any*/ ,
                                    "concreteType": "JiraIssueSearchView",
                                    "kind": "LinkedField",
                                    "name": "issueSearchViewByNamespaceAndViewId",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "RequiredField",
                                            "field": {
                                                "args": v7 /*: any*/ ,
                                                "concreteType": "JiraIssueSearchFieldSetConnection",
                                                "kind": "LinkedField",
                                                "name": "fieldSets",
                                                "plural": false,
                                                "selections": [
                                                    {
                                                        "kind": "RequiredField",
                                                        "field": v8 /*: any*/ ,
                                                        "action": "THROW",
                                                        "path": "jira.issueSearchViewByNamespaceAndViewId.fieldSets.totalCount"
                                                    },
                                                    v9 /*: any*/ ,
                                                    {
                                                        "kind": "RequiredField",
                                                        "field": {
                                                            "concreteType": "JiraIssueSearchFieldSetEdge",
                                                            "kind": "LinkedField",
                                                            "name": "edges",
                                                            "plural": true,
                                                            "selections": [
                                                                v10 /*: any*/ ,
                                                                {
                                                                    "kind": "RequiredField",
                                                                    "field": {
                                                                        "concreteType": "JiraIssueSearchFieldSet",
                                                                        "kind": "LinkedField",
                                                                        "name": "node",
                                                                        "plural": false,
                                                                        "selections": [
                                                                            {
                                                                                "kind": "RequiredField",
                                                                                "field": v11 /*: any*/ ,
                                                                                "action": "THROW",
                                                                                "path": "jira.issueSearchViewByNamespaceAndViewId.fieldSets.edges.node.fieldSetId"
                                                                            },
                                                                            {
                                                                                "kind": "RequiredField",
                                                                                "field": v12 /*: any*/ ,
                                                                                "action": "THROW",
                                                                                "path": "jira.issueSearchViewByNamespaceAndViewId.fieldSets.edges.node.displayName"
                                                                            },
                                                                            {
                                                                                "kind": "RequiredField",
                                                                                "field": v13 /*: any*/ ,
                                                                                "action": "THROW",
                                                                                "path": "jira.issueSearchViewByNamespaceAndViewId.fieldSets.edges.node.type"
                                                                            },
                                                                            v14 /*: any*/ 
                                                                        ]
                                                                    },
                                                                    "action": "THROW",
                                                                    "path": "jira.issueSearchViewByNamespaceAndViewId.fieldSets.edges.node"
                                                                }
                                                            ]
                                                        },
                                                        "action": "THROW",
                                                        "path": "jira.issueSearchViewByNamespaceAndViewId.fieldSets.edges"
                                                    }
                                                ]
                                            },
                                            "action": "THROW",
                                            "path": "jira.issueSearchViewByNamespaceAndViewId.fieldSets"
                                        }
                                    ]
                                },
                                "action": "THROW",
                                "path": "jira.issueSearchViewByNamespaceAndViewId"
                            }
                        ]
                    },
                    "action": "THROW",
                    "path": "jira"
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v1 /*: any*/ ,
                v4 /*: any*/ ,
                v5 /*: any*/ ,
                v3 /*: any*/ ,
                v0 /*: any*/ ,
                v2 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "fetchColumnPickerOptionsQuery",
            "selections": [
                {
                    "concreteType": "JiraQuery",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "args": v6 /*: any*/ ,
                            "concreteType": "JiraIssueSearchView",
                            "kind": "LinkedField",
                            "name": "issueSearchViewByNamespaceAndViewId",
                            "plural": false,
                            "selections": [
                                {
                                    "args": v7 /*: any*/ ,
                                    "concreteType": "JiraIssueSearchFieldSetConnection",
                                    "kind": "LinkedField",
                                    "name": "fieldSets",
                                    "plural": false,
                                    "selections": [
                                        v8 /*: any*/ ,
                                        v9 /*: any*/ ,
                                        {
                                            "concreteType": "JiraIssueSearchFieldSetEdge",
                                            "kind": "LinkedField",
                                            "name": "edges",
                                            "plural": true,
                                            "selections": [
                                                v10 /*: any*/ ,
                                                {
                                                    "concreteType": "JiraIssueSearchFieldSet",
                                                    "kind": "LinkedField",
                                                    "name": "node",
                                                    "plural": false,
                                                    "selections": [
                                                        v11 /*: any*/ ,
                                                        v12 /*: any*/ ,
                                                        v13 /*: any*/ ,
                                                        v14 /*: any*/ 
                                                    ]
                                                }
                                            ]
                                        }
                                    ]
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "id"
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "2fc2bdb7e99242c748d59a003f006e50b4a56a963e6ef08e6ffb31bdfa8c511d",
            "metadata": {},
            "name": "fetchColumnPickerOptionsQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$e7c77884534ed2ad$var$node.hash = "374080c39c08d2cf25a28460ad1b6425";
var $e7c77884534ed2ad$export$2e2bcd8739ae039 = $e7c77884534ed2ad$var$node;

});

parcelRegister("aIxxL", function(module, exports) {

$parcel$export(module.exports, "MAX_COLUMNS", () => $b078fb111bae5b9f$export$7ec4af037f372df4);
$parcel$export(module.exports, "createDebouncedColumnLoader", () => $b078fb111bae5b9f$export$a6cff24b97727de1);

var $5oamh = parcelRequire("5oamh");

var $PACdv = parcelRequire("PACdv");
const $b078fb111bae5b9f$export$b8b9d90f9e5bd72b = 'jiraIssueTableColumnHeader';
const $b078fb111bae5b9f$export$d57b6b390e78d90f = 'empanada';
const $b078fb111bae5b9f$export$7ec4af037f372df4 = 500;
const $b078fb111bae5b9f$export$a6cff24b97727de1 = (0, $5oamh.createGenericDebouncableDataLoader);

});
parcelRegister("5oamh", function(module, exports) {

$parcel$export(module.exports, "createGenericDebouncableDataLoader", () => $44c3b46c69e4d46d$export$ea63a11564958c9e);

var $dxIU5 = parcelRequire("dxIU5");
const $44c3b46c69e4d46d$export$ea63a11564958c9e = (dataLoader)=>{
    const debouncedDataLoader = (0, (/*@__PURE__*/$parcel$interopDefault($dxIU5)))((search, enableFullList, endCursor, cb)=>dataLoader(search, enableFullList, endCursor).then((data)=>{
            cb(data);
            return data;
        }), 500);
    return (search, enableFullList, endCursor, cb)=>{
        // No need to debounce When no search string is provided.
        // We want the initial list displaying as quickly as possible when a user reopens the dropdown.
        // It will be cached by the GraphQL client and debouncing will show an unneccessary spinner.
        if (!search) {
            debouncedDataLoader.cancel();
            return dataLoader(search, enableFullList, endCursor).then((data)=>{
                cb(data);
                return data;
            });
        }
        return debouncedDataLoader(search, enableFullList, endCursor, cb);
    };
};
var $44c3b46c69e4d46d$export$2e2bcd8739ae039 = $44c3b46c69e4d46d$export$ea63a11564958c9e;

});

parcelRegister("PACdv", function(module, exports) {

$parcel$export(module.exports, "components", () => $7fc1301f004ca79d$export$9b5ac10f59f76296);

var $eNBUj = parcelRequire("eNBUj");
const $7fc1301f004ca79d$export$9b5ac10f59f76296 = {
    NoOptionsMessage: $eNBUj.default
};

});
parcelRegister("eNBUj", function(module, exports) {

$parcel$export(module.exports, "default", () => $666689ae855bc618$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $96IgR = parcelRequire("96IgR");

var $5JgJ2 = parcelRequire("5JgJ2");

var $d6f6c = parcelRequire("d6f6c");

var $4EqNx = parcelRequire("4EqNx");
/**
 * Custom message to show when no options are visible in the column picker. This allows additional help text/content to
 * be rendered using the children prop.
 */ const $666689ae855bc618$var$NoOptionsMessage = ({ children: children })=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($666689ae855bc618$var$Container, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($666689ae855bc618$var$IconContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($96IgR))), {
        label: ""
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($666689ae855bc618$var$StyledTitle, null, formatMessage((0, $4EqNx.default).title)), children, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $d6f6c.FireUiAnalytics), {
        actionSubject: "emptyState",
        action: "viewed",
        actionSubjectId: "columnPicker"
    }));
};
var $666689ae855bc618$export$2e2bcd8739ae039 = $666689ae855bc618$var$NoOptionsMessage;
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $666689ae855bc618$var$Container = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_syaz1wmz _1e0c1txw _2lx21bp4 _4cvr1h6o _18s81gzt",
            __cmplp.className
        ])
    });
});
const $666689ae855bc618$var$IconContainer = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_otyru2gc _w8l5t9kd _1752t9kd",
            __cmplp.className
        ])
    });
});
const $666689ae855bc618$var$StyledTitle = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_syaz1fxt _otyru2gc",
            __cmplp.className
        ])
    });
});

});
parcelRegister("4EqNx", function(module, exports) {

$parcel$export(module.exports, "default", () => $3788bf9c7aa987cf$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $3788bf9c7aa987cf$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    title: {
        "id": "issue-table-column-picker.column-picker.no-options-message.title",
        "defaultMessage": "We couldn\u2019t find the field you\u2019re looking for."
    }
});

});




parcelRegister("3jzIw", function(module, exports) {

$parcel$export(module.exports, "getSecondaryLabelWithIcon", () => $65199b03f9eafe7f$export$de24d837eb50c435);

var $eUqFw = parcelRequire("eUqFw");
const $65199b03f9eafe7f$export$de24d837eb50c435 = (icon, fieldTypeDisplayName)=>({
        label: fieldTypeDisplayName,
        element: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, icon, fieldTypeDisplayName)
    });

});

parcelRegister("d7cju", function(module, exports) {

$parcel$export(module.exports, "fieldTypesIcons", () => $64116c3db17e9766$export$67f993f3bbfb364d);
$parcel$export(module.exports, "panelIcons", () => $64116c3db17e9766$export$4641b622f6c36f58);
$parcel$export(module.exports, "FieldTypeIcon", () => $64116c3db17e9766$export$87c5289d8835f589);
$parcel$export(module.exports, "default", () => $64116c3db17e9766$export$2e2bcd8739ae039);
// eslint-disable-next-line jira/restricted/react-component-props

var $eUqFw = parcelRequire("eUqFw");

var $2ziLQ = parcelRequire("2ziLQ");

var $iY7zv = parcelRequire("iY7zv");

var $gojax = parcelRequire("gojax");

var $4nce6 = parcelRequire("4nce6");

var $cglEj = parcelRequire("cglEj");

var $eI5EY = parcelRequire("eI5EY");

var $lO4Or = parcelRequire("lO4Or");
var $6bYiA = parcelRequire("6bYiA");

var $fiSip = parcelRequire("fiSip");
// @ts-expect-error - TS2322 - Type '(props: { [key: string]: string; }) => ReactElement<any, string | JSXElementConstructor<any>>' is not assignable to type 'ComponentType<CustomGlyphProps> | undefined'.
const $64116c3db17e9766$var$ResizedIcon = ({ glyph: glyph })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $2ziLQ.default), {
        label: "",
        glyph: glyph,
        size: "medium"
    });
const $64116c3db17e9766$var$checkedFieldTypesIcons = {
    [(0, $lO4Or.NUMBER_CF_TYPE)]: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($64116c3db17e9766$var$ResizedIcon, {
        glyph: (0, $fiSip.numberGlyph)
    }),
    [(0, $lO4Or.STORY_POINT_ESTIMATE_CF_TYPE)]: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($64116c3db17e9766$var$ResizedIcon, {
        glyph: (0, $fiSip.numberGlyph)
    }),
    [(0, $lO4Or.LABELS_CF_TYPE)]: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($64116c3db17e9766$var$ResizedIcon, {
        glyph: (0, $fiSip.labelGlyph)
    }),
    [(0, $lO4Or.DATE_CF_TYPE)]: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($64116c3db17e9766$var$ResizedIcon, {
        glyph: (0, $fiSip.dateGlyph)
    }),
    [(0, $lO4Or.DATETIME_CF_TYPE)]: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($64116c3db17e9766$var$ResizedIcon, {
        glyph: (0, $fiSip.timeStampGlyph)
    }),
    [(0, $lO4Or.RADIO_BUTTONS_CF_TYPE)]: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($64116c3db17e9766$var$ResizedIcon, {
        glyph: (0, $fiSip.radioGlyph)
    }),
    [(0, $lO4Or.SELECT_CF_TYPE)]: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($64116c3db17e9766$var$ResizedIcon, {
        glyph: (0, $fiSip.dropdownGlyph)
    }),
    [(0, $lO4Or.MULTI_SELECT_CF_TYPE)]: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($64116c3db17e9766$var$ResizedIcon, {
        glyph: (0, $fiSip.dropdownGlyph)
    }),
    [(0, $lO4Or.CASCADING_SELECT_CF_TYPE)]: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($64116c3db17e9766$var$ResizedIcon, {
        glyph: (0, $fiSip.doubleDropdownGlyph)
    }),
    [(0, $lO4Or.MULTI_VERSION_CF_TYPE)]: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($64116c3db17e9766$var$ResizedIcon, {
        glyph: (0, $fiSip.dropdownGlyph)
    }),
    [(0, $lO4Or.VERSION_CF_TYPE)]: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($64116c3db17e9766$var$ResizedIcon, {
        glyph: (0, $fiSip.dropdownGlyph)
    }),
    [(0, $lO4Or.GROUP_CF_TYPE)]: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($64116c3db17e9766$var$ResizedIcon, {
        glyph: (0, $fiSip.dropdownGlyph)
    }),
    [(0, $lO4Or.MULTI_GROUP_CF_TYPE)]: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($64116c3db17e9766$var$ResizedIcon, {
        glyph: (0, $fiSip.dropdownGlyph)
    }),
    [(0, $lO4Or.USER_CF_TYPE)]: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($64116c3db17e9766$var$ResizedIcon, {
        glyph: (0, $fiSip.peopleGlyph)
    }),
    [(0, $6bYiA.USERPICKER_FIELD_TYPE)]: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($64116c3db17e9766$var$ResizedIcon, {
        glyph: (0, $fiSip.peopleGlyph)
    }),
    [(0, $lO4Or.MULTI_USER_CF_TYPE)]: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($64116c3db17e9766$var$ResizedIcon, {
        glyph: (0, $fiSip.peopleGlyph)
    }),
    [(0, $6bYiA.MULTIUSERPICKER_FIELD_TYPE)]: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($64116c3db17e9766$var$ResizedIcon, {
        glyph: (0, $fiSip.peopleGlyph)
    }),
    [(0, $lO4Or.PEOPLE_CF_TYPE)]: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($64116c3db17e9766$var$ResizedIcon, {
        glyph: (0, $fiSip.peopleGlyph)
    }),
    [(0, $lO4Or.FLAGGED_CF_TYPE)]: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($64116c3db17e9766$var$ResizedIcon, {
        glyph: (0, $fiSip.timeStampGlyph)
    }),
    [(0, $lO4Or.URL_CF_TYPE)]: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($64116c3db17e9766$var$ResizedIcon, {
        glyph: (0, $fiSip.customFieldGlyph)
    }),
    [(0, $lO4Or.TEAM_CF_TYPE)]: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($64116c3db17e9766$var$ResizedIcon, {
        glyph: (0, $fiSip.customFieldGlyph)
    }),
    // <ResizedIcon /> was introduced when SWIFT had a limited number of supported field types,
    // but it's no longer a scalable option. We should be using icons directly provided by @atlaskit,
    // and if it does not match our design constraints, then we'll need to investigate contributing to a new @atlaskit icon set.
    [(0, $lO4Or.TEAMS_PLATFORM_CF_TYPE)]: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($4nce6))), {
        label: ""
    }),
    [(0, $lO4Or.PARENT_CF_TYPE)]: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($64116c3db17e9766$var$ResizedIcon, {
        glyph: (0, $fiSip.customFieldGlyph)
    }),
    [(0, $lO4Or.BASELINE_START_CF_TYPE)]: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($64116c3db17e9766$var$ResizedIcon, {
        glyph: (0, $fiSip.dateGlyph)
    }),
    [(0, $lO4Or.BASELINE_END_CF_TYPE)]: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($64116c3db17e9766$var$ResizedIcon, {
        glyph: (0, $fiSip.dateGlyph)
    }),
    [(0, $lO4Or.SPRINT_TYPE)]: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($64116c3db17e9766$var$ResizedIcon, {
        glyph: (0, $fiSip.shipGlyph)
    }),
    [(0, $lO4Or.REQUEST_PARTICIPANTS_CF_TYPE)]: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($64116c3db17e9766$var$ResizedIcon, {
        glyph: (0, $fiSip.peopleGroupGlyph)
    }),
    [(0, $lO4Or.ORGANIZATIONS_CF_TYPE)]: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($64116c3db17e9766$var$ResizedIcon, {
        glyph: (0, $fiSip.officeBuildingGlyph)
    }),
    [(0, $lO4Or.REPORTER_TYPE)]: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($64116c3db17e9766$var$ResizedIcon, {
        glyph: (0, $fiSip.peopleGlyph)
    }),
    [(0, $lO4Or.ATTACHMENT_TYPE)]: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($64116c3db17e9766$var$ResizedIcon, {
        glyph: (0, $fiSip.attachmentGlyph)
    }),
    [(0, $lO4Or.ASSIGNEE_TYPE)]: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($64116c3db17e9766$var$ResizedIcon, {
        glyph: (0, $fiSip.peopleGlyph)
    }),
    [(0, $lO4Or.LABELS_TYPE)]: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($64116c3db17e9766$var$ResizedIcon, {
        glyph: (0, $fiSip.labelGlyph)
    }),
    [(0, $lO4Or.PRIORITY_TYPE)]: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($64116c3db17e9766$var$ResizedIcon, {
        glyph: (0, $fiSip.priorityGlyph)
    }),
    [(0, $lO4Or.DUE_DATE_TYPE)]: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($64116c3db17e9766$var$ResizedIcon, {
        glyph: (0, $fiSip.dateGlyph)
    }),
    [(0, $lO4Or.TIME_ESTIMATE_CONFIG_TYPE)]: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($64116c3db17e9766$var$ResizedIcon, {
        glyph: (0, $fiSip.timeStampGlyph)
    }),
    [(0, $lO4Or.TIME_TRACKING_TYPE)]: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($64116c3db17e9766$var$ResizedIcon, {
        glyph: (0, $fiSip.timeTrackingGlyph)
    }),
    [(0, $lO4Or.TIME_ESTIMATE_TYPE)]: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($64116c3db17e9766$var$ResizedIcon, {
        glyph: (0, $fiSip.originalTimeEstimateGlyph)
    }),
    [(0, $lO4Or.ASSETS_CF_TYPE)]: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($64116c3db17e9766$var$ResizedIcon, {
        glyph: (0, $fiSip.screenGlyph)
    }),
    [(0, $lO4Or.SERVICE_ENTITY_CF_TYPE)]: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($64116c3db17e9766$var$ResizedIcon, {
        glyph: (0, $fiSip.labelGlyph)
    }),
    [(0, $lO4Or.STATUS_TYPE)]: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($64116c3db17e9766$var$ResizedIcon, {
        glyph: (0, $fiSip.arrowRightGlyph)
    }),
    [(0, $lO4Or.SUMMARY_TYPE)]: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($64116c3db17e9766$var$ResizedIcon, {
        glyph: (0, $fiSip.shortTextGlyph)
    }),
    [(0, $6bYiA.DESCRIPTION_FIELD_TYPE)]: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($64116c3db17e9766$var$ResizedIcon, {
        glyph: (0, $fiSip.paragraphGlyph)
    }),
    [(0, $lO4Or.TEXT_CF_TYPE)]: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($64116c3db17e9766$var$ResizedIcon, {
        glyph: (0, $fiSip.shortTextGlyph)
    }),
    [(0, $6bYiA.TEXT_AREA_CF_TYPE)]: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($64116c3db17e9766$var$ResizedIcon, {
        glyph: (0, $fiSip.paragraphGlyph)
    }),
    [(0, $lO4Or.MULTI_CHECKBOXES_CF_TYPE)]: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($64116c3db17e9766$var$ResizedIcon, {
        glyph: (0, $fiSip.checkboxGlyph)
    }),
    [(0, $lO4Or.ISSUE_LINKS_TYPE)]: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($64116c3db17e9766$var$ResizedIcon, {
        glyph: (0, $fiSip.customFieldGlyph)
    }),
    [(0, $6bYiA.ENVIRONMENT_FIELD_TYPE)]: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($64116c3db17e9766$var$ResizedIcon, {
        glyph: (0, $fiSip.paragraphGlyph)
    }),
    [(0, $lO4Or.FIX_VERSIONS_TYPE)]: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($64116c3db17e9766$var$ResizedIcon, {
        glyph: (0, $fiSip.dropdownGlyph)
    }),
    [(0, $lO4Or.COMMENT_TYPE)]: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($64116c3db17e9766$var$ResizedIcon, {
        glyph: (0, $fiSip.commentGlyph)
    }),
    [(0, $lO4Or.APPROVERS_LIST_CF_TYPE)]: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($64116c3db17e9766$var$ResizedIcon, {
        glyph: (0, $fiSip.appAccessGlyph)
    }),
    [(0, $lO4Or.APPROVALS_CF_TYPE)]: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($64116c3db17e9766$var$ResizedIcon, {
        glyph: (0, $fiSip.appAccessGlyph)
    }),
    [(0, $lO4Or.PROJECT_PICKER_CF_TYPE)]: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($64116c3db17e9766$var$ResizedIcon, {
        glyph: (0, $fiSip.folderGlyph)
    }),
    [(0, $lO4Or.MESSAGE_EDIT_CF_TYPE)]: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($64116c3db17e9766$var$ResizedIcon, {
        glyph: (0, $fiSip.paragraphGlyph)
    }),
    [(0, $lO4Or.MESSAGE_VIEW_CF_TYPE)]: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($64116c3db17e9766$var$ResizedIcon, {
        glyph: (0, $fiSip.paragraphGlyph)
    }),
    [(0, $lO4Or.CATEGORY_TYPE)]: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($64116c3db17e9766$var$ResizedIcon, {
        glyph: (0, $fiSip.jwmCategoryGlyph)
    }),
    [(0, $lO4Or.ENTITLEMENT_CF_TYPE)]: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($64116c3db17e9766$var$ResizedIcon, {
        glyph: (0, $fiSip.dropdownGlyph)
    }),
    [(0, $lO4Or.SENTIMENT_CF_TYPE)]: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($64116c3db17e9766$var$ResizedIcon, {
        glyph: (0, $fiSip.customFieldGlyph)
    }),
    [(0, $lO4Or.GOALS_CF_TYPE)]: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($iY7zv))), {
        label: "",
        spacing: "spacious",
        color: "var(--ds-icon, #44546F)"
    })
};
// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
({
    ...$64116c3db17e9766$var$checkedFieldTypesIcons
});
const $64116c3db17e9766$export$67f993f3bbfb364d = $64116c3db17e9766$var$checkedFieldTypesIcons;
const $64116c3db17e9766$export$4641b622f6c36f58 = {
    development: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($gojax))), {
        label: "",
        size: "medium"
    }),
    devSummary: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($gojax))), {
        label: "",
        size: "medium"
    }),
    timetracking: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cglEj))), {
        label: "",
        size: "medium"
    })
};
/**
 * @deprecated - consider using allFieldTypeGlyphs or FieldTypeIcon instead
 */ const $64116c3db17e9766$var$allIcons = {
    ...$64116c3db17e9766$export$67f993f3bbfb364d,
    text: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($64116c3db17e9766$var$ResizedIcon, {
        glyph: (0, $fiSip.paragraphGlyph)
    }),
    number: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($64116c3db17e9766$var$ResizedIcon, {
        glyph: (0, $fiSip.numberGlyph)
    }),
    date: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($64116c3db17e9766$var$ResizedIcon, {
        glyph: (0, $fiSip.dateGlyph)
    }),
    datetime: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($64116c3db17e9766$var$ResizedIcon, {
        glyph: (0, $fiSip.timeStampGlyph)
    }),
    dropdown: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($64116c3db17e9766$var$ResizedIcon, {
        glyph: (0, $fiSip.dropdownGlyph)
    }),
    addon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($64116c3db17e9766$var$ResizedIcon, {
        glyph: (0, $fiSip.addonGlyph)
    }),
    checkbox: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($64116c3db17e9766$var$ResizedIcon, {
        glyph: (0, $fiSip.checkboxGlyph)
    }),
    user: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($64116c3db17e9766$var$ResizedIcon, {
        glyph: (0, $fiSip.peopleGlyph)
    }),
    radio: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($64116c3db17e9766$var$ResizedIcon, {
        glyph: (0, $fiSip.radioGlyph)
    }),
    time: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($64116c3db17e9766$var$ResizedIcon, {
        glyph: (0, $fiSip.timeStampGlyph)
    }),
    message: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($64116c3db17e9766$var$ResizedIcon, {
        glyph: (0, $fiSip.commentGlyph)
    }),
    bulletList: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($64116c3db17e9766$var$ResizedIcon, {
        glyph: (0, $fiSip.bulletListGlyph)
    }),
    label: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($64116c3db17e9766$var$ResizedIcon, {
        glyph: (0, $fiSip.labelGlyph)
    }),
    labelpicker: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($64116c3db17e9766$var$ResizedIcon, {
        glyph: (0, $fiSip.labelGlyph)
    }),
    close: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($64116c3db17e9766$var$ResizedIcon, {
        glyph: (0, $fiSip.closeGlyph)
    }),
    assetspicker: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($64116c3db17e9766$var$ResizedIcon, {
        glyph: (0, $fiSip.screenGlyph)
    }),
    select: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($64116c3db17e9766$var$ResizedIcon, {
        glyph: (0, $fiSip.dropdownGlyph)
    }),
    multiselect: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($64116c3db17e9766$var$ResizedIcon, {
        glyph: (0, $fiSip.dropdownGlyph)
    }),
    cascadingselect: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($64116c3db17e9766$var$ResizedIcon, {
        glyph: (0, $fiSip.doubleDropdownGlyph)
    }),
    multigrouppicker: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($64116c3db17e9766$var$ResizedIcon, {
        glyph: (0, $fiSip.dropdownGlyph)
    }),
    grouppicker: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($64116c3db17e9766$var$ResizedIcon, {
        glyph: (0, $fiSip.dropdownGlyph)
    }),
    multiversion: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($64116c3db17e9766$var$ResizedIcon, {
        glyph: (0, $fiSip.dropdownGlyph)
    }),
    version: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($64116c3db17e9766$var$ResizedIcon, {
        glyph: (0, $fiSip.dropdownGlyph)
    }),
    projectpicker: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($64116c3db17e9766$var$ResizedIcon, {
        glyph: (0, $fiSip.dropdownGlyph)
    }),
    customField: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($64116c3db17e9766$var$ResizedIcon, {
        glyph: (0, $fiSip.customFieldGlyph)
    })
};
const $64116c3db17e9766$var$checkedFieldTypesGlyphs = {
    [(0, $lO4Or.NUMBER_CF_TYPE)]: (0, $fiSip.numberGlyph),
    [(0, $lO4Or.STORY_POINT_ESTIMATE_CF_TYPE)]: (0, $fiSip.numberGlyph),
    [(0, $lO4Or.LABELS_CF_TYPE)]: (0, $fiSip.labelGlyph),
    [(0, $lO4Or.DATE_CF_TYPE)]: (0, $fiSip.dateGlyph),
    [(0, $lO4Or.DATETIME_CF_TYPE)]: (0, $fiSip.timeStampGlyph),
    [(0, $lO4Or.RADIO_BUTTONS_CF_TYPE)]: (0, $fiSip.radioGlyph),
    [(0, $lO4Or.SELECT_CF_TYPE)]: (0, $fiSip.dropdownGlyph),
    [(0, $lO4Or.MULTI_SELECT_CF_TYPE)]: (0, $fiSip.dropdownGlyph),
    [(0, $lO4Or.CASCADING_SELECT_CF_TYPE)]: (0, $fiSip.doubleDropdownGlyph),
    [(0, $lO4Or.MULTI_VERSION_CF_TYPE)]: (0, $fiSip.dropdownGlyph),
    [(0, $lO4Or.VERSION_CF_TYPE)]: (0, $fiSip.dropdownGlyph),
    [(0, $lO4Or.GROUP_CF_TYPE)]: (0, $fiSip.dropdownGlyph),
    [(0, $lO4Or.MULTI_GROUP_CF_TYPE)]: (0, $fiSip.dropdownGlyph),
    [(0, $lO4Or.USER_CF_TYPE)]: (0, $fiSip.peopleGlyph),
    [(0, $6bYiA.USERPICKER_FIELD_TYPE)]: (0, $fiSip.peopleGlyph),
    [(0, $lO4Or.MULTI_USER_CF_TYPE)]: (0, $fiSip.peopleGlyph),
    [(0, $6bYiA.MULTIUSERPICKER_FIELD_TYPE)]: (0, $fiSip.peopleGlyph),
    [(0, $lO4Or.PEOPLE_CF_TYPE)]: (0, $fiSip.peopleGlyph),
    [(0, $lO4Or.FLAGGED_CF_TYPE)]: (0, $fiSip.timeStampGlyph),
    [(0, $lO4Or.URL_CF_TYPE)]: (0, $fiSip.customFieldGlyph),
    [(0, $lO4Or.TEAM_CF_TYPE)]: (0, $fiSip.customFieldGlyph),
    [(0, $lO4Or.PARENT_CF_TYPE)]: (0, $fiSip.customFieldGlyph),
    [(0, $lO4Or.BASELINE_START_CF_TYPE)]: (0, $fiSip.dateGlyph),
    [(0, $lO4Or.BASELINE_END_CF_TYPE)]: (0, $fiSip.dateGlyph),
    [(0, $lO4Or.SPRINT_TYPE)]: (0, $fiSip.shipGlyph),
    [(0, $lO4Or.REQUEST_PARTICIPANTS_CF_TYPE)]: (0, $fiSip.peopleGroupGlyph),
    [(0, $lO4Or.ORGANIZATIONS_CF_TYPE)]: (0, $fiSip.officeBuildingGlyph),
    [(0, $lO4Or.REPORTER_TYPE)]: (0, $fiSip.peopleGlyph),
    [(0, $lO4Or.ATTACHMENT_TYPE)]: (0, $fiSip.attachmentGlyph),
    [(0, $lO4Or.ASSIGNEE_TYPE)]: (0, $fiSip.peopleGlyph),
    [(0, $lO4Or.LABELS_TYPE)]: (0, $fiSip.labelGlyph),
    [(0, $lO4Or.PRIORITY_TYPE)]: (0, $fiSip.priorityGlyph),
    [(0, $lO4Or.DUE_DATE_TYPE)]: (0, $fiSip.dateGlyph),
    [(0, $lO4Or.TIME_ESTIMATE_CONFIG_TYPE)]: (0, $fiSip.timeStampGlyph),
    [(0, $lO4Or.TIME_TRACKING_TYPE)]: (0, $fiSip.timeTrackingGlyph),
    [(0, $lO4Or.TIME_ESTIMATE_TYPE)]: (0, $fiSip.originalTimeEstimateGlyph),
    [(0, $lO4Or.ASSETS_CF_TYPE)]: (0, $fiSip.screenGlyph),
    [(0, $lO4Or.SERVICE_ENTITY_CF_TYPE)]: (0, $fiSip.labelGlyph),
    [(0, $lO4Or.STATUS_TYPE)]: (0, $fiSip.arrowRightGlyph),
    [(0, $lO4Or.SUMMARY_TYPE)]: (0, $fiSip.shortTextGlyph),
    [(0, $6bYiA.DESCRIPTION_FIELD_TYPE)]: (0, $fiSip.paragraphGlyph),
    [(0, $lO4Or.TEXT_CF_TYPE)]: (0, $fiSip.shortTextGlyph),
    [(0, $6bYiA.TEXT_AREA_CF_TYPE)]: (0, $fiSip.paragraphGlyph),
    [(0, $lO4Or.MULTI_CHECKBOXES_CF_TYPE)]: (0, $fiSip.checkboxGlyph),
    [(0, $lO4Or.ISSUE_LINKS_TYPE)]: (0, $fiSip.customFieldGlyph),
    [(0, $6bYiA.ENVIRONMENT_FIELD_TYPE)]: (0, $fiSip.paragraphGlyph),
    [(0, $lO4Or.FIX_VERSIONS_TYPE)]: (0, $fiSip.dropdownGlyph),
    [(0, $lO4Or.COMMENT_TYPE)]: (0, $fiSip.commentGlyph),
    [(0, $lO4Or.APPROVERS_LIST_CF_TYPE)]: (0, $fiSip.appAccessGlyph),
    [(0, $lO4Or.APPROVALS_CF_TYPE)]: (0, $fiSip.appAccessGlyph),
    [(0, $lO4Or.PROJECT_PICKER_CF_TYPE)]: (0, $fiSip.folderGlyph),
    [(0, $lO4Or.MESSAGE_EDIT_CF_TYPE)]: (0, $fiSip.paragraphGlyph),
    [(0, $lO4Or.MESSAGE_VIEW_CF_TYPE)]: (0, $fiSip.paragraphGlyph),
    [(0, $lO4Or.CATEGORY_TYPE)]: (0, $fiSip.jwmCategoryGlyph),
    [(0, $lO4Or.ENTITLEMENT_CF_TYPE)]: (0, $fiSip.dropdownGlyph),
    [(0, $lO4Or.SENTIMENT_CF_TYPE)]: (0, $fiSip.customFieldGlyph)
};
const $64116c3db17e9766$export$14355977bfae6aaa = {
    ...$64116c3db17e9766$var$checkedFieldTypesGlyphs,
    text: (0, $fiSip.paragraphGlyph),
    number: (0, $fiSip.numberGlyph),
    date: (0, $fiSip.dateGlyph),
    datetime: (0, $fiSip.timeStampGlyph),
    dropdown: (0, $fiSip.dropdownGlyph),
    addon: (0, $fiSip.addonGlyph),
    checkbox: (0, $fiSip.checkboxGlyph),
    user: (0, $fiSip.peopleGlyph),
    radio: (0, $fiSip.radioGlyph),
    time: (0, $fiSip.timeStampGlyph),
    message: (0, $fiSip.commentGlyph),
    bulletList: (0, $fiSip.bulletListGlyph),
    label: (0, $fiSip.labelGlyph),
    labelpicker: (0, $fiSip.labelGlyph),
    close: (0, $fiSip.closeGlyph),
    assetspicker: (0, $fiSip.screenGlyph),
    select: (0, $fiSip.dropdownGlyph),
    multiselect: (0, $fiSip.dropdownGlyph),
    cascadingselect: (0, $fiSip.doubleDropdownGlyph),
    multigrouppicker: (0, $fiSip.dropdownGlyph),
    grouppicker: (0, $fiSip.dropdownGlyph),
    multiversion: (0, $fiSip.dropdownGlyph),
    version: (0, $fiSip.dropdownGlyph),
    projectpicker: (0, $fiSip.dropdownGlyph),
    customField: (0, $fiSip.customFieldGlyph)
};
const $64116c3db17e9766$export$aaac7dbe01e6025d = /*#__PURE__*/ (0, $eUqFw.memo)(({ type: type, size: size = 'medium', testId: testId })=>{
    if (type === (0, $lO4Or.TEAMS_PLATFORM_CF_TYPE)) // eslint-disable-next-line @atlaskit/design-system/no-legacy-icons
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($4nce6))), {
        label: "",
        size: size,
        testId: testId
    });
    if (type === (0, $lO4Or.GOALS_CF_TYPE) && (0, $eI5EY.fg)('native_goals_integration_on_list_view')) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($iY7zv))), {
        label: "",
        spacing: "spacious",
        testId: testId,
        color: "var(--ds-icon, #44546F)"
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $2ziLQ.default), {
        label: "",
        glyph: $64116c3db17e9766$var$checkedFieldTypesGlyphs[type] || $64116c3db17e9766$var$checkedFieldTypesGlyphs.customField,
        size: size,
        testId: testId
    });
});
const $64116c3db17e9766$export$87c5289d8835f589 = /*#__PURE__*/ (0, $eUqFw.memo)(({ type: type, size: size = 'medium', testId: testId })=>{
    if (type === (0, $lO4Or.TEAMS_PLATFORM_CF_TYPE)) // eslint-disable-next-line @atlaskit/design-system/no-legacy-icons
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($4nce6))), {
        label: "",
        size: size,
        testId: testId
    });
    if (type === (0, $lO4Or.GOALS_CF_TYPE) && (0, $eI5EY.fg)('native_goals_integration_on_list_view')) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($iY7zv))), {
        label: "",
        spacing: "spacious",
        testId: testId,
        color: "var(--ds-icon, #44546F)"
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $2ziLQ.default), {
        label: "",
        glyph: $64116c3db17e9766$export$14355977bfae6aaa[type] || $64116c3db17e9766$export$14355977bfae6aaa.customField,
        size: size,
        testId: testId
    });
});
var /**
 * @deprecated - Use allFieldTypeGlyphs or FieldTypeIcon instead.
 */ $64116c3db17e9766$export$2e2bcd8739ae039 = $64116c3db17e9766$var$allIcons;

});
parcelRegister("gojax", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $beedc1cceb482b08$var$_react = $beedc1cceb482b08$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $igPbh = parcelRequire("igPbh");

var $beedc1cceb482b08$var$_branch = $beedc1cceb482b08$var$_interopRequireDefault((parcelRequire("1210e")));
function $beedc1cceb482b08$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
const $beedc1cceb482b08$var$BitbucketBranchesIcon = (props)=>/*#__PURE__*/ $beedc1cceb482b08$var$_react.default.createElement($igPbh.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="M19 11c0 1.3-.8 2.4-2 2.8V15c0 2.2-1.8 4-4 4h-2.2c-.4 1.2-1.5 2-2.8 2-1.7 0-3-1.3-3-3 0-1.3.8-2.4 2-2.8V8.8C5.9 8.4 5 7.3 5 6c0-1.7 1.3-3 3-3s3 1.3 3 3c0 1.3-.8 2.4-2.1 2.8v6.4c.9.3 1.6.9 1.9 1.8H13c1.1 0 2-.9 2-2v-1.2c-1.2-.4-2-1.5-2-2.8 0-1.7 1.3-3 3-3s3 1.3 3 3M8 5c-.5 0-1 .4-1 1s.4 1 1 1 1-.4 1-1-.4-1-1-1m8 7c.6 0 1-.4 1-1s-.4-1-1-1-1 .4-1 1 .4 1 1 1m-8 7c.6 0 1-.4 1-1s-.4-1-1-1-1 .4-1 1 .4 1 1 1"/></svg>`
    }, props, {
        newIcon: $beedc1cceb482b08$var$_branch.default
    }));
$beedc1cceb482b08$var$BitbucketBranchesIcon.displayName = 'BitbucketBranchesIcon';
var $beedc1cceb482b08$var$_default = module.exports.default = $beedc1cceb482b08$var$BitbucketBranchesIcon;

});
parcelRegister("1210e", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::8d5333b3016191eb34ab8245e965a2ad>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $0c06c178a8a70140$var$_react = $0c06c178a8a70140$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $0c06c178a8a70140$var$_UNSAFE_baseNew = $0c06c178a8a70140$var$_interopRequireDefault((parcelRequire("gCIXy")));
function $0c06c178a8a70140$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 * Please reach out in #icon-contributions before using these in production.
 *
 * Icon: "Branch".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for branches in Bitbucket and Jira.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $0c06c178a8a70140$var$BranchIcon = (props)=>/*#__PURE__*/ $0c06c178a8a70140$var$_react.default.createElement($0c06c178a8a70140$var$_UNSAFE_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path stroke="currentcolor" stroke-width="1.5" d="M4.25 4.75a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3Zm0 0V9m1.5 3.75a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0Zm0 0h3.5a2.5 2.5 0 0 0 2.5-2.5v-5.5m0 0a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3Z"/>`
    }, props));
$0c06c178a8a70140$var$BranchIcon.displayName = 'BranchIcon';
var $0c06c178a8a70140$var$_default = module.exports.default = $0c06c178a8a70140$var$BranchIcon;

});


parcelRegister("4nce6", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $32f2cb577afb3a41$var$_react = $32f2cb577afb3a41$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $igPbh = parcelRequire("igPbh");

var $32f2cb577afb3a41$var$_peopleGroup = $32f2cb577afb3a41$var$_interopRequireDefault((parcelRequire("dd6Uq")));
function $32f2cb577afb3a41$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
const $32f2cb577afb3a41$var$PeopleIcon = (props)=>/*#__PURE__*/ $32f2cb577afb3a41$var$_react.default.createElement($igPbh.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill="currentcolor" fill-rule="evenodd"><circle cx="16" cy="9" r="3"/><circle cx="8" cy="6" r="3"/><path d="M11 15c0-1.105.887-2 2-2h6c1.105 0 2 .885 2 2v3.73c0 3.027-10 3.027-10 0z"/><path d="M13 12a1.997 1.997 0 0 0-2-2H5c-1.113 0-2 .897-2 2.003v3.826c0 1.921 4.054 2.518 7 1.984v-2.807A3 3 0 0 1 12.997 12z"/></g></svg>`
    }, props, {
        newIcon: $32f2cb577afb3a41$var$_peopleGroup.default
    }));
$32f2cb577afb3a41$var$PeopleIcon.displayName = 'PeopleIcon';
var $32f2cb577afb3a41$var$_default = module.exports.default = $32f2cb577afb3a41$var$PeopleIcon;

});

parcelRegister("cglEj", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $8ed7c5ba5e4768aa$var$_react = $8ed7c5ba5e4768aa$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $igPbh = parcelRequire("igPbh");

var $8ed7c5ba5e4768aa$var$_stopwatch = $8ed7c5ba5e4768aa$var$_interopRequireDefault((parcelRequire("lwB7l")));
function $8ed7c5ba5e4768aa$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
const $8ed7c5ba5e4768aa$var$StopwatchIcon = (props)=>/*#__PURE__*/ $8ed7c5ba5e4768aa$var$_react.default.createElement($igPbh.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="m15.587 6.988.626-.664c.203-.215.481-.324.76-.324.247 0 .496.086.694.262a.98.98 0 0 1 .063 1.414l-.565.6a7 7 0 1 1-10.33 0l-.564-.6a.98.98 0 0 1 .062-1.414A1.04 1.04 0 0 1 7.03 6c.278 0 .556.109.76.324l.624.664a7 7 0 0 1 2.582-.916L10.998 5H10.5a.5.5 0 0 1-.5-.5v-1a.5.5 0 0 1 .5-.5h3a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-.5.5h-.498l.001 1.071a7 7 0 0 1 2.584.917M12 18a5 5 0 1 0 0-10 5 5 0 0 0 0 10m.368-4.232a.796.796 0 0 1-1.14-.018.834.834 0 0 1 .018-1.163l2.386-2.355a.796.796 0 0 1 1.14.018.834.834 0 0 1-.018 1.163z"/></svg>`
    }, props, {
        newIcon: $8ed7c5ba5e4768aa$var$_stopwatch.default
    }));
$8ed7c5ba5e4768aa$var$StopwatchIcon.displayName = 'StopwatchIcon';
var $8ed7c5ba5e4768aa$var$_default = module.exports.default = $8ed7c5ba5e4768aa$var$StopwatchIcon;

});
parcelRegister("lwB7l", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::7738f2c14b1d5a31c72b1066ab8e43ac>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $fab960e4665ea086$var$_react = $fab960e4665ea086$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $fab960e4665ea086$var$_UNSAFE_baseNew = $fab960e4665ea086$var$_interopRequireDefault((parcelRequire("gCIXy")));
function $fab960e4665ea086$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 * Please reach out in #icon-contributions before using these in production.
 *
 * Icon: "Stopwatch".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: timer in Confluence Whiteboards.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $fab960e4665ea086$var$StopwatchIcon = (props)=>/*#__PURE__*/ $fab960e4665ea086$var$_react.default.createElement($fab960e4665ea086$var$_UNSAFE_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path stroke="currentcolor" stroke-linejoin="round" stroke-width="1.5" d="M8 3.75v-3m0 3a5.73 5.73 0 0 1 3.885 1.511M8 3.75a5.73 5.73 0 0 0-3.885 1.511M8 .75h3m-3 0H5m8.5 2.75-1.615 1.761M2.5 3.5l1.615 1.761m7.77 0a5.75 5.75 0 1 1-7.77 0M7.75 9.75 10.292 7"/>`
    }, props));
$fab960e4665ea086$var$StopwatchIcon.displayName = 'StopwatchIcon';
var $fab960e4665ea086$var$_default = module.exports.default = $fab960e4665ea086$var$StopwatchIcon;

});


parcelRegister("fiSip", function(module, exports) {

$parcel$export(module.exports, "numberGlyph", () => $032123c5fd7d43cf$export$b368272069fe93ea);
$parcel$export(module.exports, "checkboxGlyph", () => $032123c5fd7d43cf$export$747056db840f2e62);
$parcel$export(module.exports, "folderGlyph", () => $032123c5fd7d43cf$export$fc939f15c0ac57d8);
$parcel$export(module.exports, "dateGlyph", () => $032123c5fd7d43cf$export$54ae6633cc16eed1);
$parcel$export(module.exports, "dropdownGlyph", () => $032123c5fd7d43cf$export$d298f123ec74117c);
$parcel$export(module.exports, "doubleDropdownGlyph", () => $032123c5fd7d43cf$export$b3ea0fc10228ca3e);
$parcel$export(module.exports, "labelGlyph", () => $032123c5fd7d43cf$export$fc64eea29ed0831d);
$parcel$export(module.exports, "paragraphGlyph", () => $032123c5fd7d43cf$export$cbee9ded46569696);
$parcel$export(module.exports, "peopleGlyph", () => $032123c5fd7d43cf$export$2ade78849d2113ea);
$parcel$export(module.exports, "shortTextGlyph", () => $032123c5fd7d43cf$export$1c6cf19eb34bcc14);
$parcel$export(module.exports, "timeStampGlyph", () => $032123c5fd7d43cf$export$98a4a461fe316fce);
$parcel$export(module.exports, "timeTrackingGlyph", () => $032123c5fd7d43cf$export$637d50811e2b7176);
$parcel$export(module.exports, "originalTimeEstimateGlyph", () => $032123c5fd7d43cf$export$bc2bb299bed9df91);
$parcel$export(module.exports, "arrowRightGlyph", () => $032123c5fd7d43cf$export$3a9d3f1c52f4dab9);
$parcel$export(module.exports, "addonGlyph", () => $032123c5fd7d43cf$export$a4cdad58220c405a);
$parcel$export(module.exports, "attachmentGlyph", () => $032123c5fd7d43cf$export$e6e85f1bc2e23bd4);
$parcel$export(module.exports, "bulletListGlyph", () => $032123c5fd7d43cf$export$a6a7f7b7c0399a2a);
$parcel$export(module.exports, "commentGlyph", () => $032123c5fd7d43cf$export$835d228e2a9d6a93);
$parcel$export(module.exports, "officeBuildingGlyph", () => $032123c5fd7d43cf$export$fdad804cb16a6544);
$parcel$export(module.exports, "peopleGroupGlyph", () => $032123c5fd7d43cf$export$a20644de4b67f161);
$parcel$export(module.exports, "radioGlyph", () => $032123c5fd7d43cf$export$ce87e45dceec205d);
$parcel$export(module.exports, "shipGlyph", () => $032123c5fd7d43cf$export$d95e2215202c8556);
$parcel$export(module.exports, "priorityGlyph", () => $032123c5fd7d43cf$export$3062e49c5521698d);
$parcel$export(module.exports, "screenGlyph", () => $032123c5fd7d43cf$export$17d48fc8b753df77);
$parcel$export(module.exports, "closeGlyph", () => $032123c5fd7d43cf$export$cbbe21ca62a58ed6);
$parcel$export(module.exports, "appAccessGlyph", () => $032123c5fd7d43cf$export$8fd991b9da3a43e5);
$parcel$export(module.exports, "jwmCategoryGlyph", () => $032123c5fd7d43cf$export$f21213fb7b480582);
$parcel$export(module.exports, "customFieldGlyph", () => $032123c5fd7d43cf$export$88453606d7da6ff7);
// eslint-disable-next-line jira/restricted/react-component-props

var $eUqFw = parcelRequire("eUqFw");
const $032123c5fd7d43cf$export$b368272069fe93ea = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("svg", {
        ...props,
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        focusable: false
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M7 4h10a3 3 0 0 1 3 3v10a3 3 0 0 1-3 3H7a3 3 0 0 1-3-3V7a3 3 0 0 1 3-3zm.417 10.636h1.15V9.141H7.42L6 10.12v1.07l1.348-.93h.069v4.376zm1.923-3.85v.02h1.067v-.024c0-.506.365-.857.898-.857.503 0 .861.313.861.755 0 .357-.194.643-.967 1.397l-1.794 1.756v.803h3.964v-.955h-2.406v-.069l1.05-1.002c.953-.895 1.277-1.409 1.277-2.007 0-.944-.8-1.603-1.947-1.603-1.188 0-2.003.724-2.003 1.786zm5.811 1.466h.682c.617 0 .994.297.994.777 0 .469-.4.792-.975.792-.59 0-.983-.293-1.017-.757h-1.1c.05 1.035.88 1.713 2.106 1.713 1.253 0 2.159-.697 2.159-1.66 0-.724-.472-1.226-1.226-1.31v-.069c.613-.125 1.013-.62 1.013-1.257 0-.864-.811-1.481-1.939-1.481-1.2 0-1.972.655-2.01 1.695H14.9c.03-.476.385-.777.918-.777.537 0 .88.282.88.723 0 .45-.355.754-.876.754h-.67v.857z",
        fill: "currentColor",
        fillRule: "evenodd"
    }));
const $032123c5fd7d43cf$export$747056db840f2e62 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("svg", {
        ...props,
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        focusable: false
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M4 5.994C4 4.893 4.895 4 5.994 4h12.012C19.107 4 20 4.895 20 5.994v12.012A1.995 1.995 0 0 1 18.006 20H5.994A1.995 1.995 0 0 1 4 18.006V5.994zm5.707 5.299a1 1 0 1 0-1.414 1.414l2 2a1 1 0 0 0 1.414 0l4-4a1 1 0 1 0-1.414-1.414L11 12.586l-1.293-1.293z",
        fill: "currentColor",
        fillRule: "evenodd"
    }));
const $032123c5fd7d43cf$export$fc939f15c0ac57d8 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("svg", {
        ...props,
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        focusable: false
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M20 19V8h-9.154l-.503-1.258-.455-1.136C9.778 5.33 9.291 5 9.003 5H3.997C4.002 5 4 19 4 19h16zM12.2 6h7.809C21.109 6 22 6.893 22 7.992v11.016c0 1.1-.898 1.992-1.991 1.992H3.991C2.891 21 2 20.107 2 19.008V5.006C2 3.898 2.896 3 3.997 3h5.006c1.103 0 2.327.826 2.742 1.862L12.2 6z",
        fill: "currentColor",
        fillRule: "evenodd"
    }));
const $032123c5fd7d43cf$export$54ae6633cc16eed1 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("svg", {
        ...props,
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        focusable: false
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M8.667 6.167V7A.834.834 0 0 1 7 7V5.333a.834.834 0 0 1 1.667 0v.834zm6.666 0v-.834a.834.834 0 0 1 1.667 0V7a.834.834 0 0 1-1.667 0v-.833zm2.5 0h.005c.918 0 1.662.745 1.662 1.661v10.01c0 .918-.743 1.662-1.662 1.662H6.161A1.663 1.663 0 0 1 4.5 17.838V7.828c0-.917.743-1.661 1.662-1.661h.005V7c0 .927.746 1.667 1.666 1.667C8.76 8.667 9.5 7.92 9.5 7v-.833h5V7c0 .927.746 1.667 1.667 1.667.927 0 1.666-.747 1.666-1.667v-.833zm-10 6.667H9.5v-1.667H7.833v1.667zm0 3.334H9.5V14.5H7.833v1.668zm3.334-3.334h1.666v-1.667h-1.666v1.667zm0 3.334h1.666V14.5h-1.666v1.668zm3.333-3.334h1.667v-1.667H14.5v1.667zm0 3.334h1.667V14.5H14.5v1.668z",
        fill: "currentColor",
        fillRule: "evenodd"
    }));
const $032123c5fd7d43cf$export$d298f123ec74117c = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("svg", {
        ...props,
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        focusable: false
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M21 12C21 16.9706 16.9706 21 12 21C7.02944 21 3 16.9706 3 12C3 7.02944 7.02944 3 12 3C16.9706 3 21 7.02944 21 12ZM15.708 11.723L12.779 14.678C12.566 14.893 12.288 15 12.009 15C11.73 15 11.449 14.893 11.231 14.678L8.291 11.713C7.903 11.321 7.903 10.686 8.291 10.294C8.679 9.902 9.309 9.902 9.698 10.294L12.005 12.621L14.303 10.304C14.69 9.912 15.32 9.912 15.708 10.304C16.097 10.696 16.097 11.331 15.708 11.723Z",
        fill: "currentColor"
    }));
const $032123c5fd7d43cf$export$b3ea0fc10228ca3e = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("svg", {
        ...props,
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        focusable: false
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M21 12C21 16.9706 16.9706 21 12 21C7.02944 21 3 16.9706 3 12C3 7.02944 7.02944 3 12 3C16.9706 3 21 7.02944 21 12ZM10.0543 7.95865C9.72121 7.63948 9.17412 7.63199 8.83238 7.94192C8.49064 8.25184 8.48365 8.76182 8.81678 9.08099L11.3658 11.5232C11.5389 11.689 11.7698 11.7707 11.9997 11.7675C12.2295 11.7707 12.4604 11.689 12.6335 11.5232L15.1825 9.08099C15.5156 8.76182 15.5087 8.25184 15.1669 7.94192C14.8252 7.63199 14.2781 7.63948 13.945 7.95865L11.9997 9.82242L10.0543 7.95865ZM8.83238 12.3333C9.17412 12.0234 9.72121 12.0309 10.0543 12.35L11.9997 14.2138L13.945 12.35C14.2781 12.0309 14.8252 12.0234 15.1669 12.3333C15.5087 12.6432 15.5156 13.1532 15.1825 13.4724L12.6335 15.9146C12.4604 16.0804 12.2295 16.1621 11.9997 16.1588C11.7698 16.1621 11.5389 16.0804 11.3658 15.9146L8.81678 13.4724C8.48365 13.1532 8.49064 12.6432 8.83238 12.3333Z",
        fill: "currentColor"
    }));
const $032123c5fd7d43cf$export$fc64eea29ed0831d = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("svg", {
        ...props,
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        focusable: false
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M11.433 5.428l-4.207.6a2 2 0 0 0-1.697 1.698l-.601 4.207a1 1 0 0 0 .283.849l6.894 6.894a1 1 0 0 0 1.414 0l5.657-5.657a1 1 0 0 0 0-1.414L12.282 5.71a1 1 0 0 0-.849-.283zm-.647 5.858a1.667 1.667 0 1 1-2.357-2.357 1.667 1.667 0 0 1 2.357 2.357z",
        fill: "currentColor",
        fillRule: "evenodd"
    }));
const $032123c5fd7d43cf$export$cbee9ded46569696 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("svg", {
        ...props,
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        focusable: false
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M7 7h11a1 1 0 0 1 0 2H7a1 1 0 1 1 0-2zm0 4h11a1 1 0 0 1 0 2H7a1 1 0 0 1 0-2zm0 4h6a1 1 0 0 1 0 2H7a1 1 0 0 1 0-2z",
        fill: "currentColor",
        fillRule: "evenodd"
    }));
const $032123c5fd7d43cf$export$2ade78849d2113ea = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("svg", {
        ...props,
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        focusable: false
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M12.12 20.249a8.398 8.398 0 0 1-.39-.003A8.25 8.25 0 0 1 3.75 12 8.25 8.25 0 0 1 12 3.75 8.25 8.25 0 0 1 20.25 12a8.25 8.25 0 0 1-8.13 8.25v-.001zm4.463-3.762A6.396 6.396 0 0 0 18.417 12 6.424 6.424 0 0 0 12 5.583 6.424 6.424 0 0 0 5.583 12c0 1.745.7 3.33 1.834 4.487v-1.27a2.291 2.291 0 0 1 2.292-2.292h4.582a2.292 2.292 0 0 1 2.292 2.291v1.27zM12 12a2.75 2.75 0 1 1 0-5.5 2.75 2.75 0 0 1 0 5.5z",
        fill: "currentColor",
        fillRule: "evenodd"
    }));
const $032123c5fd7d43cf$export$1c6cf19eb34bcc14 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("svg", {
        ...props,
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        focusable: false
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M6.72 7.178l-2.93 8.627a.5.5 0 0 0 .473.661h.842a.75.75 0 0 0 .716-.53l.581-1.887h3.425l.58 1.887a.75.75 0 0 0 .717.53h.916a.5.5 0 0 0 .473-.66L9.578 7.177a1 1 0 0 0-.946-.678h-.966a1 1 0 0 0-.947.678zm1.37 1.228h.047l1.25 4.082H6.841l1.25-4.082zm10.187 1.872v-.23a.986.986 0 1 1 1.972 0v5.433a.986.986 0 0 1-1.972 0v-.217h-.08c-.36.802-1.13 1.32-2.217 1.32-1.81 0-2.952-1.479-2.952-3.834 0-2.334 1.149-3.805 2.952-3.805 1.075 0 1.858.546 2.216 1.333h.08zm-.04 2.486c0-1.347-.63-2.203-1.61-2.203-.978 0-1.58.843-1.58 2.203 0 1.368.602 2.196 1.58 2.196.988 0 1.61-.836 1.61-2.196z",
        fill: "currentColor"
    }));
const $032123c5fd7d43cf$export$98a4a461fe316fce = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("svg", {
        ...props,
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        focusable: false
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M12 20a8 8 0 1 1 0-16 8 8 0 0 1 0 16zm.787-7.674V8.944c0-.52-.402-.944-.893-.944-.492 0-.894.425-.894.944v3.777c0 .263.104.5.269.672l2.207 2.332a.862.862 0 0 0 1.263 0 .985.985 0 0 0 0-1.336l-1.952-2.063z",
        fill: "currentColor",
        fillRule: "evenodd"
    }));
const $032123c5fd7d43cf$export$637d50811e2b7176 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("svg", {
        ...props,
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        focusable: false
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M17.476 9.067A6.552 6.552 0 0 1 19 13.263C19 16.983 15.866 20 12 20s-7-3.016-7-6.737c0-1.587.57-3.045 1.524-4.196l-.383-.402a.82.82 0 0 1 .054-1.19.9.9 0 0 1 1.237.052l.345.363a7.116 7.116 0 0 1 3.348-1.312v-.894h-.438a.43.43 0 0 1-.437-.42V4.42a.43.43 0 0 1 .438-.42h2.624a.43.43 0 0 1 .438.421v.842a.43.43 0 0 1-.438.421h-.437v.894a7.116 7.116 0 0 1 3.348 1.312l.345-.363a.9.9 0 0 1 1.237-.052.82.82 0 0 1 .054 1.19l-.383.402zM12 18.316c2.9 0 5.25-2.262 5.25-5.053 0-2.79-2.35-5.052-5.25-5.052s-5.25 2.262-5.25 5.052c0 2.79 2.35 5.053 5.25 5.053zm.645-4.562a.9.9 0 0 1-1.237-.02.82.82 0 0 1 .02-1.19l2.588-2.412a.9.9 0 0 1 1.238.02.82.82 0 0 1-.02 1.19l-2.589 2.412z",
        fill: "currentColor"
    }));
const $032123c5fd7d43cf$export$bc2bb299bed9df91 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("svg", {
        ...props,
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        focusable: false
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M12 4c-4.412 0-8 3.588-8 8s3.588 8 8 8 8-3.588 8-8-3.588-8-8-8zm0 14.222A6.23 6.23 0 015.778 12 6.23 6.23 0 0112 5.778 6.23 6.23 0 0118.222 12 6.23 6.23 0 0112 18.222zm.889-6.59V8.448c0-.489-.4-.889-.889-.889s-.889.4-.889.89v3.555c0 .248.103.471.268.633l2.195 2.194a.891.891 0 001.257 0 .891.891 0 000-1.256l-1.942-1.943z",
        fill: "currentColor",
        fillRule: "evenodd"
    }));
const $032123c5fd7d43cf$export$3a9d3f1c52f4dab9 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("svg", {
        ...props,
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        focusable: false
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M12.268 4.934a.919.919 0 0 0 0 1.296l4.852 4.853H4.668A.92.92 0 0 0 3.75 12a.92.92 0 0 0 .917.917H17.12l-4.856 4.855a.917.917 0 0 0 1.296 1.296l6.416-6.415c.002 0 .003-.003.006-.004a.914.914 0 0 0 .267-.65.915.915 0 0 0-.274-.653l-6.412-6.412a.915.915 0 0 0-.648-.267.915.915 0 0 0-.648.267z",
        fill: "currentColor",
        fillRule: "evenodd"
    }));
const $032123c5fd7d43cf$export$a4cdad58220c405a = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("svg", {
        ...props,
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        focusable: false
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M5.928 6.917l4.81-2.846c.727-.429 1.8-.427 2.523 0l4.811 2.846c.726.43 1.261 1.382 1.261 2.238v5.69c0 .859-.537 1.81-1.26 2.238L13.26 19.93c-.726.429-1.799.427-2.522 0l-4.811-2.846c-.726-.43-1.261-1.382-1.261-2.238v-5.69c0-.859.537-1.81 1.26-2.238zm6.408-1.204c-.152-.09-.52-.09-.672 0L6.853 8.558c-.152.09-.336.416-.336.597v5.69c0 .18.183.507.336.597l4.81 2.845c.153.09.52.09.673 0l4.811-2.845c.152-.09.336-.416.336-.597v-5.69c0-.18-.183-.507-.336-.597l-4.81-2.845zM12 15.667a3.667 3.667 0 1 1 0-7.334 3.667 3.667 0 0 1 0 7.334zm0-1.834a1.833 1.833 0 1 0 0-3.666 1.833 1.833 0 0 0 0 3.666z",
        fill: "currentColor",
        fillRule: "evenodd"
    }));
const $032123c5fd7d43cf$export$e6e85f1bc2e23bd4 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("svg", {
        ...props,
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        focusable: false
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M12.672 17.468c-1.402 1.37-3.68 1.37-5.08.004a3.458 3.458 0 0 1 .002-4.962l6.552-6.402a2.123 2.123 0 0 1 2.964-.003c.818.8.82 2.092.003 2.89L10.968 15a.599.599 0 0 1-.838-.008.568.568 0 0 1 0-.827l5.71-5.58a.863.863 0 0 0 0-1.24.912.912 0 0 0-1.268 0l-5.71 5.58a2.294 2.294 0 0 0 0 3.307 2.423 2.423 0 0 0 3.375.008l6.145-6.005a3.735 3.735 0 0 0-.003-5.37 3.947 3.947 0 0 0-5.502.003L6.325 11.27a5.184 5.184 0 0 0-.001 7.442c2.1 2.052 5.514 2.051 7.617-.004l6.13-5.99a.863.863 0 0 0 0-1.24.912.912 0 0 0-1.27 0l-6.129 5.99z",
        fill: "currentColor",
        fillRule: "evenodd"
    }));
const $032123c5fd7d43cf$export$a6a7f7b7c0399a2a = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("svg", {
        ...props,
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        focusable: false
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M5.5 7.59a1 1 0 0 1 1.007-1.007h.152a1 1 0 0 1 1.008 1.008v.152A1 1 0 0 1 6.659 8.75h-.152A1 1 0 0 1 5.5 7.743V7.59zm4.333 8.667a.999.999 0 0 1 .995-1.007h6.678c.549 0 .994.438.994 1.007v.152a.999.999 0 0 1-.994 1.008h-6.678a.993.993 0 0 1-.995-1.008v-.152zm-4.333 0a1 1 0 0 1 1.007-1.007h.152a1 1 0 0 1 1.008 1.007v.152a1 1 0 0 1-1.008 1.008h-.152A1 1 0 0 1 5.5 16.409v-.152zm4.333-4.333a.999.999 0 0 1 .995-1.007h6.678c.549 0 .994.438.994 1.007v.152a.999.999 0 0 1-.994 1.007h-6.678a.993.993 0 0 1-.995-1.007v-.152zm-4.333 0a1 1 0 0 1 1.007-1.007h.152a1 1 0 0 1 1.008 1.007v.152a1 1 0 0 1-1.008 1.007h-.152A1 1 0 0 1 5.5 12.076v-.152zM9.833 7.59a.999.999 0 0 1 .995-1.008h6.678c.549 0 .994.439.994 1.008v.152a.999.999 0 0 1-.994 1.007h-6.678a.993.993 0 0 1-.995-1.007V7.59z",
        fill: "currentColor",
        fillRule: "evenodd"
    }));
const $032123c5fd7d43cf$export$835d228e2a9d6a93 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("svg", {
        ...props,
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        focusable: false
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M4.998 11.513c0-3.038 3.141-5.51 7.002-5.51 3.861 0 7.002 2.472 7.002 5.51 0 3.039-3.141 5.51-7.002 5.51-3.861 0-7.002-2.471-7.002-5.51zm14.84 7.771v-.002s-1.564-2.26-.767-3.116l-.037.02C20.261 14.902 21 13.279 21 11.513 21 7.371 16.963 4 12 4s-9 3.37-9 7.513 4.037 7.514 9 7.514c1.42 0 2.76-.285 3.957-.776 1.003 1.022 2.287 1.572 3.24 1.719l.002-.003a.524.524 0 0 0 .164.033.515.515 0 0 0 .474-.716zM7 10c0-.552.456-1 .995-1h8.01c.55 0 .995.444.995 1 0 .552-.456 1-.995 1h-8.01A.995.995 0 0 1 7 10zm0 3c0-.552.444-1 1-1h3c.552 0 1 .444 1 1 0 .552-.444 1-1 1H8c-.552 0-1-.444-1-1z",
        fill: "currentColor",
        fillRule: "evenodd"
    }));
const $032123c5fd7d43cf$export$fdad804cb16a6544 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("svg", {
        ...props,
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        focusable: false
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M8.444 14.667V20H5.785C4.8 20 4 19.146 4 18.09V8.577c0-1.055.802-1.91 1.785-1.91h2.66v3.556H6.666V12h1.777v.889H6.667v1.778h1.777zm.89-8.894A1.78 1.78 0 0 1 11.119 4h7.096A1.78 1.78 0 0 1 20 5.773v12.454c0 .979-.802 1.773-1.785 1.773H9.333V5.773zM12 7.556v1.777h1.778V7.556H12zm0 2.666V12h1.778v-1.778H12zm0 2.667v1.778h1.778v-1.778H12zm1.778 2.667v2.666h1.778v-2.666h-1.778zm1.778-8v1.777h1.777V7.556h-1.777zm0 2.666V12h1.777v-1.778h-1.777zm0 2.667v1.778h1.777v-1.778h-1.777z",
        fill: "currentColor"
    }));
const $032123c5fd7d43cf$export$a20644de4b67f161 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("svg", {
        ...props,
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        focusable: false
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M12 12a2.5 2.5 0 1 1 0-5 2.5 2.5 0 0 1 0 5zm-3.228-1.667A3.333 3.333 0 0 0 9.795 12H9.5A2.501 2.501 0 0 0 7 14.497v2.469c-1.771-.147-3.333-.766-3.333-1.858V12c0-.92.74-1.667 1.666-1.667h3.439zm6.456 0h3.439c.92 0 1.666.738 1.666 1.667v3.108c0 1.092-1.562 1.711-3.333 1.858v-2.47A2.5 2.5 0 0 0 14.5 12h-.295a3.333 3.333 0 0 0 1.023-1.667zM10.306 6.63A3.332 3.332 0 0 0 8.67 9.357a2.5 2.5 0 1 1 1.636-2.728zm5.024 2.728a3.328 3.328 0 0 0-1.636-2.73 2.5 2.5 0 1 1 1.636 2.73zm-7.497 5.456c0-1.093.892-1.98 1.996-1.98h4.342a2 2 0 0 1 1.996 1.994v2.781c0 2.523-8.334 2.523-8.334 0v-2.795z",
        fill: "currentColor",
        fillRule: "evenodd"
    }));
const $032123c5fd7d43cf$export$ce87e45dceec205d = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("svg", {
        ...props,
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        focusable: false
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M12 20a8 8 0 1 1 0-16 8 8 0 0 1 0 16zm0-6a2 2 0 1 0 0-4 2 2 0 0 0 0 4z",
        fill: "currentColor",
        fillRule: "evenodd"
    }));
const $032123c5fd7d43cf$export$d95e2215202c8556 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("svg", {
        ...props,
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        focusable: false
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M6.5 12h7.333v-1.833H6.5V12zM4.667 9.242c0-.502.417-.909.919-.909h9.162c.507 0 .919.414.919.909v4.591h-11V9.242zm.458 7.341h12.828l.919-2.75H4.795l.33 2.75zm-2.287-3.677A.79.79 0 0 1 3.643 12h16.86c.504 0 .786.382.625.865l-1.565 4.686c-.16.478-.695.866-1.205.866H4.415c-.506 0-.964-.402-1.025-.906l-.552-4.605zM6.5 7.42c0-1.015.823-1.838 1.831-1.838h1.838c1.011 0 1.831.82 1.831 1.838v2.746H6.5V7.42zm3.667 0v-.004H8.331c.005 0 .002.002.002.004v.912h1.834V7.42z",
        fill: "currentColor"
    }));
const $032123c5fd7d43cf$export$3062e49c5521698d = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("svg", {
        ...props,
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        focusable: false
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M7.959 15.833V8.474l-2.868 2.868a.541.541 0 1 1-.766-.766l3.79-3.789.001-.004a.544.544 0 0 1 .77.003l3.791 3.792a.543.543 0 0 1 0 .766.543.543 0 0 1-.765 0l-2.87-2.87v7.36a.543.543 0 0 1-.541.541.543.543 0 0 1-.542-.542zm7-6.666v7.359l-2.868-2.868a.541.541 0 1 0-.766.766l3.79 3.789.001.004a.544.544 0 0 0 .77-.003l3.791-3.792a.543.543 0 0 0 0-.766.543.543 0 0 0-.765 0l-2.87 2.87v-7.36a.543.543 0 0 0-.541-.541.543.543 0 0 0-.542.542z",
        fill: "currentColor",
        stroke: "currentColor",
        strokeWidth: ".5",
        fillRule: "evenodd"
    }));
const $032123c5fd7d43cf$export$17d48fc8b753df77 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("svg", {
        ...props,
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        focusable: false
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M4 6.772C4 5.793 4.793 5 5.773 5h12.454C19.206 5 20 5.796 20 6.772v7.044c0 .979-.793 1.772-1.773 1.772H5.773A1.774 1.774 0 0 1 4 13.816V6.772zm1.778 7.052h12.444v-7.06H5.778v7.06zm8 5.294h.452c.241 0 .437.204.437.44V20H9.333v-.441c0-.244.203-.441.437-.441h.452V16.47h3.556v2.647z",
        fill: "currentColor"
    }));
const $032123c5fd7d43cf$export$cbbe21ca62a58ed6 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("svg", {
        ...props,
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        focusable: false
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M16.244 6.244a.833.833 0 1 1 1.179 1.179l-4.412 4.41 4.412 4.411a.834.834 0 0 1 .074 1.093l-.074.086a.833.833 0 0 1-1.179 0l-4.411-4.412-4.41 4.412a.834.834 0 0 1-1.094.074l-.085-.074a.833.833 0 0 1 0-1.179l4.411-4.411-4.41-4.41a.834.834 0 0 1-.076-1.094l.075-.085a.833.833 0 0 1 1.179 0l4.41 4.411z",
        fill: "currentColor"
    }));
const $032123c5fd7d43cf$export$8fd991b9da3a43e5 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("svg", {
        ...props,
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        focusable: false
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("g", {
        fillRule: "evenodd"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M12.682 12H5.01A2.006 2.006 0 0 0 3 14v4.446c0 2.162 4.836 2.951 8.368 2.368A5.975 5.975 0 0 1 10 17a5.994 5.994 0 0 1 2.682-5z",
        fill: "currentColor"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("circle", {
        fill: "currentColor",
        cx: "9",
        cy: "7",
        r: "4"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("circle", {
        fill: "currentColor",
        cx: "16",
        cy: "17",
        r: "5"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M14.674 19.331c.36.36.941.36 1.3 0l2.758-2.763a.92.92 0 0 0-1.301-1.298l-2.108 2.11-.755-.754a.92.92 0 0 0-1.3 1.3l1.406 1.405z",
        fill: "inherit"
    })));
const $032123c5fd7d43cf$export$f21213fb7b480582 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("svg", {
        ...props,
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        focusable: false
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M6 12c0-.552.456-1 1.002-1h9.996a.999.999 0 110 2H7.002A.999.999 0 016 12zm0 4c0-.552.456-1 1.002-1h9.996a.999.999 0 110 2H7.002A.999.999 0 016 16zm0-8c0-.552.456-1 1.002-1h9.996a.999.999 0 110 2H7.002A.999.999 0 016 8z",
        fill: "currentColor"
    }));
const $032123c5fd7d43cf$export$88453606d7da6ff7 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("svg", {
        ...props,
        width: "24",
        height: "24",
        role: "presentation",
        focusable: "false",
        viewBox: "0 0 24 24",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("g", {
        fillRule: "evenodd"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M3 6C2.44772 6 2 6.44772 2 7C2 7.55228 2.44772 8 3 8H11C11.5523 8 12 7.55228 12 7C12 6.44772 11.5523 6 11 6H3ZM4 16V12H20V16H4ZM2 12C2 10.8954 2.89543 10 4 10H20C21.1046 10 22 10.8954 22 12V16C22 17.1046 21.1046 18 20 18H4C2.89543 18 2 17.1046 2 16V12Z",
        fill: "currentColor"
    })));

});


parcelRegister("4h281", function(module, exports) {

$parcel$export(module.exports, "default", () => $f16e240582606b3c$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $f16e240582606b3c$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    columnGroupHeader: {
        "id": "issue-table-column-picker.common.column-group-header",
        "defaultMessage": "All columns"
    },
    deprecatedParentyLinkMessage: {
        "id": "issue-navigator.services.fetch-column-picker-options.deprecated-parenty-link-message",
        "defaultMessage": "<strong>{field}</strong> is replaced by <strong>Parent</strong>. Use the <strong>Parent</strong> field instead."
    }
});

});

parcelRegister("5cwmS", function(module, exports) {

$parcel$export(module.exports, "getCursorOfLastUnselectedOption", () => $0233ce4f9175c609$export$5918fea5c056698b);
$parcel$export(module.exports, "isOnlyUnselectableField", () => $0233ce4f9175c609$export$bf5bbd6344a5f1aa);

var $bCHHi = parcelRequire("bCHHi");

var $1ybV0 = parcelRequire("1ybV0");

var $iwfPv = parcelRequire("iwfPv");

var $jccNB = parcelRequire("jccNB");
const $0233ce4f9175c609$var$isNotinSelectedList = (selectedOptions, option)=>{
    const optionFound = selectedOptions.find((select)=>(0, $iwfPv.isSingleValueOption)(select) && (0, $iwfPv.isSingleValueOption)(option) && select.cursor === option.cursor);
    return optionFound === undefined;
};
const $0233ce4f9175c609$export$5918fea5c056698b = (options, selectedOptions, search, endCursor)=>{
    const flatten = options.flatMap((option)=>option.optionType === 'group' ? option.options : option);
    const lastUnselectedOption = (0, (/*@__PURE__*/$parcel$interopDefault($bCHHi)))(flatten, (option)=>(0, $iwfPv.isSingleValueOption)(option) && !!option.cursor && $0233ce4f9175c609$var$isNotinSelectedList(selectedOptions, option));
    let cursor = lastUnselectedOption && (0, $iwfPv.isSingleValueOption)(lastUnselectedOption) ? lastUnselectedOption?.cursor : undefined;
    // with a given search input, don't set cursor to undefined when there are only selected options in the list, because we query with 'ALL' options
    if (search && cursor === undefined && endCursor) cursor = endCursor;
    return cursor;
};
const $0233ce4f9175c609$export$bf5bbd6344a5f1aa = (fieldType, canEditColumns)=>{
    if ((0, $1ybV0.ff)('nin-show-field-options-as-only-unselectable_0s1y2')) {
        if (fieldType === (0, $jccNB.COLUMN_TYPE_EPIC_LINK)) return canEditColumns;
        if (fieldType === (0, $jccNB.COLUMN_TYPE_PARENT_LINK)) return canEditColumns;
    }
    return false;
};

});
parcelRegister("bCHHi", function(module, exports) {

var $e5OGm = parcelRequire("e5OGm");

var $gJXdx = parcelRequire("gJXdx");
/**
 * This method is like `_.find` except that it iterates over elements of
 * `collection` from right to left.
 *
 * @static
 * @memberOf _
 * @since 2.0.0
 * @category Collection
 * @param {Array|Object} collection The collection to inspect.
 * @param {Function} [predicate=_.identity] The function invoked per iteration.
 * @param {number} [fromIndex=collection.length-1] The index to search from.
 * @returns {*} Returns the matched element, else `undefined`.
 * @example
 *
 * _.findLast([1, 2, 3, 4], function(n) {
 *   return n % 2 == 1;
 * });
 * // => 3
 */ var $876523ae23ec930f$var$findLast = $e5OGm($gJXdx);
module.exports = $876523ae23ec930f$var$findLast;

});
parcelRegister("e5OGm", function(module, exports) {

var $7qARj = parcelRequire("7qARj");

var $jxg5X = parcelRequire("jxg5X");

var $8nrDO = parcelRequire("8nrDO");
/**
 * Creates a `_.find` or `_.findLast` function.
 *
 * @private
 * @param {Function} findIndexFunc The function to find the collection index.
 * @returns {Function} Returns the new find function.
 */ function $a428d8bbecbff7a6$var$createFind(findIndexFunc) {
    return function(collection, predicate, fromIndex) {
        var iterable = Object(collection);
        if (!$jxg5X(collection)) {
            var iteratee = $7qARj(predicate, 3);
            collection = $8nrDO(collection);
            predicate = function(key) {
                return iteratee(iterable[key], key, iterable);
            };
        }
        var index = findIndexFunc(collection, predicate, fromIndex);
        return index > -1 ? iterable[iteratee ? collection[index] : index] : undefined;
    };
}
module.exports = $a428d8bbecbff7a6$var$createFind;

});

parcelRegister("gJXdx", function(module, exports) {

var $9mB9u = parcelRequire("9mB9u");

var $7qARj = parcelRequire("7qARj");

var $hNahz = parcelRequire("hNahz");
/* Built-in method references for those with the same name as other `lodash` methods. */ var $c2fec8a2b4cc30dc$var$nativeMax = Math.max, $c2fec8a2b4cc30dc$var$nativeMin = Math.min;
/**
 * This method is like `_.findIndex` except that it iterates over elements
 * of `collection` from right to left.
 *
 * @static
 * @memberOf _
 * @since 2.0.0
 * @category Array
 * @param {Array} array The array to inspect.
 * @param {Function} [predicate=_.identity] The function invoked per iteration.
 * @param {number} [fromIndex=array.length-1] The index to search from.
 * @returns {number} Returns the index of the found element, else `-1`.
 * @example
 *
 * var users = [
 *   { 'user': 'barney',  'active': true },
 *   { 'user': 'fred',    'active': false },
 *   { 'user': 'pebbles', 'active': false }
 * ];
 *
 * _.findLastIndex(users, function(o) { return o.user == 'pebbles'; });
 * // => 2
 *
 * // The `_.matches` iteratee shorthand.
 * _.findLastIndex(users, { 'user': 'barney', 'active': true });
 * // => 0
 *
 * // The `_.matchesProperty` iteratee shorthand.
 * _.findLastIndex(users, ['active', false]);
 * // => 2
 *
 * // The `_.property` iteratee shorthand.
 * _.findLastIndex(users, 'active');
 * // => 0
 */ function $c2fec8a2b4cc30dc$var$findLastIndex(array, predicate, fromIndex) {
    var length = array == null ? 0 : array.length;
    if (!length) return -1;
    var index = length - 1;
    if (fromIndex !== undefined) {
        index = $hNahz(fromIndex);
        index = fromIndex < 0 ? $c2fec8a2b4cc30dc$var$nativeMax(length + index, 0) : $c2fec8a2b4cc30dc$var$nativeMin(index, length - 1);
    }
    return $9mB9u(array, $7qARj(predicate, 3), index, true);
}
module.exports = $c2fec8a2b4cc30dc$var$findLastIndex;

});


parcelRegister("iwfPv", function(module, exports) {

$parcel$export(module.exports, "isSingleValueOption", () => $9fd9b9682c9a75f2$export$35faed52a6bc243e);
const $9fd9b9682c9a75f2$export$35faed52a6bc243e = (option)=>option.optionType === 'option' || option.optionType === 'avatar' || option.optionType === 'lozenge' || option.optionType === 'field';

});



parcelRegister("aZxZH", function(module, exports) {

$parcel$export(module.exports, "ColumnPickerContainer", () => $71bb256a733956fb$export$e1286e1cb3fa0dec);

var $eUqFw = parcelRequire("eUqFw");

var $4RwIp = parcelRequire("4RwIp");
const $71bb256a733956fb$export$e1286e1cb3fa0dec = ({ children: children, viewIdFromResponse: viewIdFromResponse, isRestoringDefaults: isRestoringDefaults })=>{
    const [{ view: optimisticViewId }] = (0, $4RwIp.useSelectedViewState)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
        key: isRestoringDefaults ? 'loading' : optimisticViewId + viewIdFromResponse
    }, children);
};

});

parcelRegister("1LgE9", function(module, exports) {

$parcel$export(module.exports, "default", () => $96325f416cc3ac7e$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $7JEyt = parcelRequire("7JEyt");

var $eUqFw = parcelRequire("eUqFw");

var $5OdZ3 = parcelRequire("5OdZ3");

var $8uD7Y = parcelRequire("8uD7Y");

var $9PZPM = parcelRequire("9PZPM");

var $4RwIp = parcelRequire("4RwIp");

var $3mEVr = parcelRequire("3mEVr");

var $eobVZ = parcelRequire("eobVZ");

var $dC0v6 = parcelRequire("dC0v6");

var $ctGRP = parcelRequire("ctGRP");

var $5hr6J = parcelRequire("5hr6J");
const $96325f416cc3ac7e$var$ColumnPickerPopupComponent = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ children: children, ...props }, ref)=>{
    const { filterId: filterId, isFilterEditable: isFilterEditable } = (0, $3mEVr.useActiveJql)();
    const [{ view: view }] = (0, $4RwIp.useSelectedViewState)();
    const { hasMaxSelectedColumns: hasMaxSelectedColumns, filterName: filterName } = (0, $eUqFw.useContext)((0, $9PZPM.ColumnPickerMessageContext));
    let bannerMessage = null;
    if (hasMaxSelectedColumns) bannerMessage = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $dC0v6.ColumnPickerMaxSelectedColumns), null);
    else if (view === 'list_system') bannerMessage = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $eobVZ.ColumnPickerBannerMessage), {
        bannerMessage: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8uD7Y.default), (0, $5hr6J.default).listSystemWarningMessage),
        type: "warning"
    });
    else if (view === `list_filter_${filterId}`) {
        if (isFilterEditable === false) bannerMessage = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $eobVZ.ColumnPickerBannerMessage), {
            type: "info",
            bannerMessage: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8uD7Y.default), {
                ...(0, $5hr6J.default).listNonEditableFilterInfoMessage,
                values: {
                    // To remove @ts-expect-error below we need to upgrade intl to v6
                    // https://stackoverflow.com/questions/67884173/formattedmessage-values-chunks-using-typescript
                    // @ts-expect-error TS2322: Type '(chunks: ReactNode[]) => JSX.Element' is not assignable to type 'ReactNode'.
                    link: (chunks)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5OdZ3.default), {
                            href: `/jira/filters${filterName ? `?name="${encodeURIComponent(filterName)}"` : ''}`,
                            target: "_blank"
                        }, chunks)
                }
            })
        });
        else bannerMessage = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $eobVZ.ColumnPickerBannerMessage), {
            bannerMessage: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8uD7Y.default), (0, $5hr6J.default).listFilterWarningMessage),
            type: "warning"
        });
    }
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($96325f416cc3ac7e$var$PopupComponentContainer, {
        ...props,
        ref: ref
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $ctGRP.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($96325f416cc3ac7e$var$TabsContentContainer, null, bannerMessage, children)));
});
var $96325f416cc3ac7e$export$2e2bcd8739ae039 // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
 = $96325f416cc3ac7e$var$ColumnPickerPopupComponent;
const $96325f416cc3ac7e$var$PopupComponentContainer = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1bsb1mjv _bfhk1bhr _2rko1l7b _16qs1mxi _1pby1nn1 _ca0q1b66 _nt751r31 _49pcglyw _1hvw1o36",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $96325f416cc3ac7e$var$TabsContentContainer = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _2lx21bp4 _1bsb1osq",
            __cmplp.className
        ])
    });
});

});
parcelRegister("eobVZ", function(module, exports) {

$parcel$export(module.exports, "ColumnPickerBannerMessage", () => $d16e423e8d97de57$export$3ccab74b576df308);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $ek6sP = parcelRequire("ek6sP");

var $1Qu2i = parcelRequire("1Qu2i");
const $d16e423e8d97de57$export$3ccab74b576df308 = ({ bannerMessage: bannerMessage, type: type })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($d16e423e8d97de57$var$BannerContent, {
        type: type
    }, type === 'warning' ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($1Qu2i))), {
        spacing: "spacious",
        label: "",
        color: "currentColor"
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($ek6sP))), {
        spacing: "spacious",
        label: "",
        color: "currentColor"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($d16e423e8d97de57$var$BannerMessage, null, bannerMessage));
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $d16e423e8d97de57$var$BannerContent = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _1yt41uce _syazjjyb",
            __cmplp.type === 'warning' ? "_bfhk1bai" : "_bfhk1fpu",
            __cmplp.className
        ])
    });
});
const $d16e423e8d97de57$var$BannerMessage = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "p", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_18s8171m _11c81vlj",
            __cmplp.className
        ])
    });
});

});
parcelRegister("ek6sP", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::b478a4dfe0bf6ab262246b2cea3eb20f>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $a6d7f28dcbf6a858$var$_react = $a6d7f28dcbf6a858$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $a6d7f28dcbf6a858$var$_information = $a6d7f28dcbf6a858$var$_interopRequireDefault((parcelRequire("h6FFs")));

var $a6d7f28dcbf6a858$var$_info = $a6d7f28dcbf6a858$var$_interopRequireDefault((parcelRequire("2bv8J")));
function $a6d7f28dcbf6a858$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 *
 * Migration Icon component for InformationIcon.
 * This component is InformationIcon, with `UNSAFE_fallbackIcon` set to "InfoIcon".
 *
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Known uses: information state in section messages or inline messages.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $a6d7f28dcbf6a858$var$InformationIcon = (props)=>/*#__PURE__*/ $a6d7f28dcbf6a858$var$_react.default.createElement($a6d7f28dcbf6a858$var$_information.default, Object.assign({
        LEGACY_fallbackIcon: $a6d7f28dcbf6a858$var$_info.default
    }, props));
$a6d7f28dcbf6a858$var$InformationIcon.Name = 'InformationIconMigration';
var $a6d7f28dcbf6a858$var$_default = module.exports.default = $a6d7f28dcbf6a858$var$InformationIcon;

});
parcelRegister("h6FFs", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::cfc592cc61140d99cb4eaed527408acf>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $c743518dce4b322a$var$_react = $c743518dce4b322a$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $c743518dce4b322a$var$_UNSAFE_baseNew = $c743518dce4b322a$var$_interopRequireDefault((parcelRequire("gCIXy")));
function $c743518dce4b322a$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 * Please reach out in #icon-contributions before using these in production.
 *
 * Icon: "Information".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Known uses: information state in section messages or inline messages.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $c743518dce4b322a$var$InformationIcon = (props)=>/*#__PURE__*/ $c743518dce4b322a$var$_react.default.createElement($c743518dce4b322a$var$_UNSAFE_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M0 8a8 8 0 1 1 16 0A8 8 0 0 1 0 8m6.5-1.25H8a.75.75 0 0 1 .75.75v5h-1.5V8.25H6.5zM8 5.5a1 1 0 1 0 0-2 1 1 0 0 0 0 2" clip-rule="evenodd"/>`
    }, props));
$c743518dce4b322a$var$InformationIcon.displayName = 'InformationIcon';
var $c743518dce4b322a$var$_default = module.exports.default = $c743518dce4b322a$var$InformationIcon;

});



parcelRegister("dC0v6", function(module, exports) {

$parcel$export(module.exports, "ColumnPickerMaxSelectedColumns", () => $df275368a5d4fd75$export$3ec21851fe32329c);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $aUqTb = parcelRequire("aUqTb");

var $5JgJ2 = parcelRequire("5JgJ2");

var $a4IeB = parcelRequire("a4IeB");

var $d6f6c = parcelRequire("d6f6c");

var $kU57W = parcelRequire("kU57W");
const $df275368a5d4fd75$export$3ec21851fe32329c = ()=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($df275368a5d4fd75$var$MessageContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($aUqTb))), {
        label: ""
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($df275368a5d4fd75$var$Message, null, formatMessage((0, $kU57W.default).maxSelectedColumns, {
        maxColumns: (0, $a4IeB.MAX_COLUMNS)
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $d6f6c.FireUiAnalytics), {
        actionSubject: "maxSelectedFieldsMessage",
        action: "viewed",
        actionSubjectId: "columnPicker"
    }));
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $df275368a5d4fd75$var$MessageContainer = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _bfhk1s4m _1yt41uce _syazjjyb _19pku2gc",
            __cmplp.className
        ])
    });
});
const $df275368a5d4fd75$var$Message = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "p", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_18s8171m _11c81vlj",
            __cmplp.className
        ])
    });
});

});
parcelRegister("aUqTb", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $7f13fdf9f823d771$var$_react = $7f13fdf9f823d771$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $igPbh = parcelRequire("igPbh");

var $7f13fdf9f823d771$var$_information = $7f13fdf9f823d771$var$_interopRequireDefault((parcelRequire("h6FFs")));
function $7f13fdf9f823d771$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
const $7f13fdf9f823d771$var$EditorPanelIcon = (props)=>/*#__PURE__*/ $7f13fdf9f823d771$var$_react.default.createElement($igPbh.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="M12 19a7 7 0 1 1 0-14 7 7 0 0 1 0 14m0-1.5a5.5 5.5 0 1 0 0-11 5.5 5.5 0 0 0 0 11m0-6a1 1 0 0 1 1 1v2a1 1 0 0 1-2 0v-2a1 1 0 0 1 1-1m0-3a1 1 0 1 1 0 2 1 1 0 0 1 0-2"/></svg>`
    }, props, {
        newIcon: $7f13fdf9f823d771$var$_information.default
    }));
$7f13fdf9f823d771$var$EditorPanelIcon.displayName = 'EditorPanelIcon';
var $7f13fdf9f823d771$var$_default = module.exports.default = $7f13fdf9f823d771$var$EditorPanelIcon;

});

parcelRegister("kU57W", function(module, exports) {

$parcel$export(module.exports, "default", () => $06bfa33a30d99569$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $06bfa33a30d99569$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    maxSelectedColumns: {
        "id": "issue-navigator.issue-results.list-view.column-picker-max-selected-columns.max-selected-columns",
        "defaultMessage": "The column limit is {maxColumns, number}. Remove and add the most important ones to your view."
    }
});

});


parcelRegister("ctGRP", function(module, exports) {

$parcel$export(module.exports, "default", () => $40560f7893704d25$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $b5IAe = parcelRequire("b5IAe");

var $5dpJB = parcelRequire("5dpJB");
var $6xBtK = parcelRequire("6xBtK");
var $kgCsd = parcelRequire("kgCsd");

var $5JgJ2 = parcelRequire("5JgJ2");

var $5as0a = parcelRequire("5as0a");

var $jMP2a = parcelRequire("jMP2a");

var $6vrw7 = parcelRequire("6vrw7");

var $c7H0g = parcelRequire("c7H0g");

var $3wKQY = parcelRequire("3wKQY");

var $4RwIp = parcelRequire("4RwIp");

var $3mEVr = parcelRequire("3mEVr");

var $5EX8F = parcelRequire("5EX8F");

var $31uzl = parcelRequire("31uzl");
const $40560f7893704d25$var$CustomTabPanel = ({ children: children })=>{
    /**
   * We can omit the tab index as our panel always contains a focusable input as the first element https://www.w3.org/WAI/ARIA/apg/example-index/tabs/tabs-automatic#accessibilityfeatures.
   * > It is recommended that all tabpanel elements in a tab set are focusable if there are any panels in the set that
   * > contain content where the first element in the panel is not focusable.
   */ const { tabIndex: tabIndex, ...tabPanelAttributes } = (0, $kgCsd.useTabPanel)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", tabPanelAttributes, children);
};
const $40560f7893704d25$var$ColumnPickerTabs = ({ children: children })=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const { filterId: filterId } = (0, $3mEVr.useActiveJql)();
    const isAdmin = (0, $c7H0g.useIsAdmin)();
    const [{ view: view }, { setView: setView }] = (0, $4RwIp.useSelectedViewState)();
    const isFilterTabEnabled = filterId != null && (0, $5as0a.isCustomFilter)(filterId);
    const tabsMetaData = (0, $eUqFw.useMemo)(()=>{
        const resultTabs = [
            {
                key: 'Default',
                label: formatMessage((0, $5EX8F.default).pickerTabTextDefault),
                view: 'list_default'
            }
        ];
        if (isFilterTabEnabled) {
            const filterViewId = (0, $3wKQY.convertFilterIdToIssueNavigatorId)(filterId);
            if (filterViewId != null) resultTabs.push({
                key: 'Filter',
                label: formatMessage((0, $5EX8F.default).pickerTabTextFilter),
                view: filterViewId
            });
        }
        if (isAdmin) resultTabs.push({
            key: 'System',
            label: formatMessage((0, $5EX8F.default).pickerTabTextSystem),
            view: 'list_system'
        });
        return resultTabs;
    }, [
        formatMessage,
        isFilterTabEnabled,
        filterId,
        isAdmin
    ]);
    const handleUpdate = (0, $eUqFw.useCallback)((index, event)=>{
        if (view !== tabsMetaData[index].view) {
            (0, $jMP2a.fireUIAnalytics)(event, 'columnPickerTabs', {
                tab: tabsMetaData[index].view
            });
            setView(tabsMetaData[index].view, (0, $6vrw7.toIssueKey)(''));
        }
    }, [
        setView,
        tabsMetaData,
        view
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5dpJB.default), {
        id: "issue-table-column-picker.ui.column-picker.picker-tabs",
        onChange: handleUpdate,
        selected: tabsMetaData.findIndex((tab)=>tab.view === view),
        shouldUnmountTabPanelOnChange: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
        paddingInline: "space.100"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $6xBtK.default), null, tabsMetaData.map((tab)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $31uzl.default), {
            key: tab.key,
            label: tab.label,
            maxWidth: `${Math.floor(100 / (tabsMetaData.length || 1))}%`
        })))), tabsMetaData.map((tab)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($40560f7893704d25$var$CustomTabPanel, {
            key: tab.key
        }, children)));
};
var $40560f7893704d25$export$2e2bcd8739ae039 = $40560f7893704d25$var$ColumnPickerTabs;

});
parcelRegister("5dpJB", function(module, exports) {

$parcel$export(module.exports, "default", () => $86fff1fa4f16d75d$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $eUqFw = parcelRequire("eUqFw");

var $byn9U = parcelRequire("byn9U");

var $lUFyV = parcelRequire("lUFyV");

var $hcuCm = parcelRequire("hcuCm");

var $9qnib = parcelRequire("9qnib");
function $86fff1fa4f16d75d$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $86fff1fa4f16d75d$var$baseStyles = {
    name: "7i0hsw",
    styles: "display:flex;max-width:100%;min-height:0%;flex-basis:100%;flex-direction:column;flex-grow:1"
};
// eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage
const $86fff1fa4f16d75d$var$tabsStyles = (0, $9qnib.getTabsStyles)();
const $86fff1fa4f16d75d$var$analyticsAttributes = {
    componentName: 'tabs',
    packageName: "platform-pkg",
    packageVersion: "0.0.0-use.local"
};
const $86fff1fa4f16d75d$var$getTabPanelWithContext = ({ tabPanel: tabPanel, index: index, isSelected: isSelected, tabsId: tabsId })=>// Ensure tabPanel exists in case it has been removed
    tabPanel && /*#__PURE__*/ (0, $byn9U.jsx)((0, $hcuCm.TabPanelContext).Provider, {
        value: {
            role: 'tabpanel',
            id: `${tabsId}-${index}-tab`,
            hidden: isSelected ? undefined : true,
            'aria-labelledby': `${tabsId}-${index}`,
            tabIndex: isSelected ? 0 : -1
        },
        key: index
    }, tabPanel);
/**
 * __Tabs__
 *
 * Tabs acts as a container for all Tab components.
 *
 * - [Examples](https://atlassian.design/components/tabs/examples)
 * - [Code](https://atlassian.design/components/tabs/code)
 * - [Usage](https://atlassian.design/components/tabs/usage)
 */ const $86fff1fa4f16d75d$var$Tabs = (props)=>{
    const { shouldUnmountTabPanelOnChange: shouldUnmountTabPanelOnChange = false, selected: SelectedType, defaultSelected: defaultSelected, onChange: onChangeProp, id: id, analyticsContext: analyticsContext, children: children, testId: testId } = props;
    const [selectedState, setSelected] = (0, $eUqFw.useState)(SelectedType || defaultSelected || 0);
    const selected = SelectedType === undefined ? selectedState : SelectedType;
    const childrenArray = (0, $eUqFw.Children).toArray(children)// Don't include any conditional children
    .filter((child)=>Boolean(child));
    // First child should be a tabList followed by tab panels
    const [tabList, ...tabPanels] = childrenArray;
    // Keep track of visited and add to a set
    const visited = (0, $eUqFw.useRef)(new Set([
        selected
    ]));
    if (!visited.current.has(selected)) visited.current.add(selected);
    const onChange = (0, $eUqFw.useCallback)((index, analyticsEvent)=>{
        if (onChangeProp) onChangeProp(index, analyticsEvent);
        setSelected(index);
    }, [
        onChangeProp
    ]);
    const onChangeAnalytics = (0, $lUFyV.usePlatformLeafEventHandler)({
        fn: onChange,
        action: 'clicked',
        analyticsData: analyticsContext,
        ...$86fff1fa4f16d75d$var$analyticsAttributes
    });
    const tabPanelsWithContext = shouldUnmountTabPanelOnChange ? $86fff1fa4f16d75d$var$getTabPanelWithContext({
        tabPanel: tabPanels[selected],
        index: selected,
        isSelected: true,
        tabsId: id
    }) : // If a panel has already been visited, don't unmount it
    Array.from(visited.current).map((tabIndex)=>$86fff1fa4f16d75d$var$getTabPanelWithContext({
            tabPanel: tabPanels[tabIndex],
            index: tabIndex,
            isSelected: tabIndex === selected,
            tabsId: id
        }));
    return(// Only styles that affect the Tabs container itself have been applied via primitives.
    // The other styles applied through the CSS prop are there for styling children
    // through inheritance. This is important for custom cases that use the useTabPanel(),
    // which applies accessibility attributes that we use as a styling hook.
    /*#__PURE__*/ (0, $byn9U.jsx)("div", {
        "data-testid": testId,
        // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage
        css: [
            $86fff1fa4f16d75d$var$baseStyles,
            $86fff1fa4f16d75d$var$tabsStyles
        ]
    }, /*#__PURE__*/ (0, $byn9U.jsx)((0, $hcuCm.TabListContext).Provider, {
        value: {
            selected: selected,
            onChange: onChangeAnalytics,
            tabsId: id
        }
    }, tabList), /*#__PURE__*/ (0, $byn9U.jsx)((0, $eUqFw.Fragment), null, tabPanelsWithContext)));
};
var $86fff1fa4f16d75d$export$2e2bcd8739ae039 = $86fff1fa4f16d75d$var$Tabs;

});
parcelRegister("hcuCm", function(module, exports) {

$parcel$export(module.exports, "TabContext", () => $3a21d9894028b7fb$export$5a5d356ca5f10a0a);
$parcel$export(module.exports, "TabListContext", () => $3a21d9894028b7fb$export$aa6907f9fd69e93b);
$parcel$export(module.exports, "TabPanelContext", () => $3a21d9894028b7fb$export$2054129d247c3102);
/* eslint-disable @repo/internal/react/require-jsdoc */ 
var $eUqFw = parcelRequire("eUqFw");
const $3a21d9894028b7fb$export$5a5d356ca5f10a0a = /*#__PURE__*/ (0, $eUqFw.createContext)(null);
const $3a21d9894028b7fb$export$aa6907f9fd69e93b = /*#__PURE__*/ (0, $eUqFw.createContext)(null);
const $3a21d9894028b7fb$export$2054129d247c3102 = /*#__PURE__*/ (0, $eUqFw.createContext)(null);

});

parcelRegister("9qnib", function(module, exports) {

$parcel$export(module.exports, "getTabsStyles", () => $f50084288d7b85a1$export$dd5afd2190fb792c);
$parcel$export(module.exports, "getTabListStyles", () => $f50084288d7b85a1$export$42a3c683c377bcb2);
$parcel$export(module.exports, "getTabListStylesOld", () => $f50084288d7b85a1$export$f208f8acf591dbc2);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $byn9U = parcelRequire("byn9U");

var $4xRua = parcelRequire("4xRua");
const $f50084288d7b85a1$var$tabInlinePadding = "var(--ds-space-100, 8px)";
const $f50084288d7b85a1$var$tabBlockPadding = "var(--ds-space-075, 6px)";
const $f50084288d7b85a1$var$tabInlineMargin = "var(--ds-space-negative-100, -8px)";
// TODO this should probably be `border.width.indicator`
const $f50084288d7b85a1$var$underlineHeight = "var(--ds-border-width-outline, 2px)";
const $f50084288d7b85a1$var$getTabPanelStyles = ()=>({
        flexGrow: 1,
        /*
     NOTE min-height set to 0% because of Firefox bug
     FF http://stackoverflow.com/questions/28636832/firefox-overflow-y-not-working-with-nested-flexbox
   */ minHeight: '0%',
        display: 'flex'
    });
const $f50084288d7b85a1$export$dd5afd2190fb792c = ()=>/*#__PURE__*/ // eslint-disable-next-line @repo/internal/styles/no-exported-styles
    (0, $byn9U.css)({
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        '& [role="tabpanel"]': $f50084288d7b85a1$var$getTabPanelStyles(),
        // The hidden attribute doesn't work on flex elements
        // Change display to be none
        // eslint-disable-next-line @atlaskit/design-system/no-nested-styles, @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
        '& > [hidden]': {
            display: 'none'
        }
    });
const $f50084288d7b85a1$var$tabLineStyles = {
    content: '""',
    bottom: 0,
    margin: 0,
    position: 'absolute',
    width: 'inherit',
    insetInlineStart: $f50084288d7b85a1$var$tabInlinePadding,
    insetInlineEnd: 0
};
const $f50084288d7b85a1$export$42a3c683c377bcb2 = ()=>/*#__PURE__*/ // eslint-disable-next-line @repo/internal/styles/no-exported-styles
    (0, $byn9U.css)({
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        '& [role="tab"]': $f50084288d7b85a1$export$916c8b0fccbb37d2(),
        fontWeight: "var(--ds-font-weight-medium, 500)",
        marginInlineStart: $f50084288d7b85a1$var$tabInlineMargin,
        '&::before': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            ...$f50084288d7b85a1$var$tabLineStyles,
            height: "var(--ds-border-width, 1px)",
            // This line is not a border so the selected line is visible in high contrast mode
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            backgroundColor: (0, $4xRua.tabLineColors).lineColor
        }
    });
const $f50084288d7b85a1$export$916c8b0fccbb37d2 = ()=>{
    const colors = (0, $4xRua.tabColors);
    return {
        color: colors.labelColor,
        cursor: 'pointer',
        margin: 0,
        padding: `${$f50084288d7b85a1$var$tabBlockPadding} ${$f50084288d7b85a1$var$tabInlinePadding}`,
        position: 'relative',
        whiteSpace: 'nowrap',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        '&:hover': {
            // TODO: interaction states will be reviewed in DSP-1438
            color: colors.hoverLabelColor,
            '&::after': {
                ...$f50084288d7b85a1$var$tabLineStyles,
                insetInlineEnd: $f50084288d7b85a1$var$tabInlinePadding,
                borderBottom: `${"var(--ds-border-width-indicator, 3px)"} solid ${(0, $4xRua.tabLineColors).hoveredColor}`,
                height: 0
            }
        },
        '&:active': {
            // TODO: interaction states will be reviewed in DSP-1438
            color: colors.activeLabelColor,
            '&::after': {
                ...$f50084288d7b85a1$var$tabLineStyles,
                insetInlineEnd: $f50084288d7b85a1$var$tabInlinePadding,
                borderBottom: `${"var(--ds-border-width-indicator, 3px)"} solid ${(0, $4xRua.tabLineColors).activeColor}`,
                height: 0
            }
        },
        '&[aria-selected="true"]': {
            color: colors.selectedColor,
            '&::after': {
                ...$f50084288d7b85a1$var$tabLineStyles,
                insetInlineEnd: $f50084288d7b85a1$var$tabInlinePadding,
                // This line is a border so it is visible in high contrast mode
                borderBottom: `${"var(--ds-border-width-indicator, 3px)"} solid ${(0, $4xRua.tabLineColors).selectedColor}`,
                height: 0
            }
        }
    };
};
const $f50084288d7b85a1$var$tabLineStylesOld = {
    content: '""',
    borderRadius: "var(--ds-border-radius-050, 2px)",
    bottom: 0,
    margin: 0,
    position: 'absolute',
    width: 'inherit',
    insetInlineStart: $f50084288d7b85a1$var$tabInlinePadding,
    insetInlineEnd: 0
};
const $f50084288d7b85a1$export$f208f8acf591dbc2 = ()=>/*#__PURE__*/ // eslint-disable-next-line @repo/internal/styles/no-exported-styles
    (0, $byn9U.css)({
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        '& [role="tab"]': $f50084288d7b85a1$export$442d081208938078(),
        fontWeight: "var(--ds-font-weight-medium, 500)",
        marginInlineStart: $f50084288d7b85a1$var$tabInlineMargin,
        '&::before': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            ...$f50084288d7b85a1$var$tabLineStylesOld,
            height: $f50084288d7b85a1$var$underlineHeight,
            // This line is not a border so the selected line is visible in high contrast mode
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            backgroundColor: (0, $4xRua.tabLineColors).lineColor
        }
    });
const $f50084288d7b85a1$export$442d081208938078 = ()=>{
    const colors = (0, $4xRua.tabColors);
    return {
        color: colors.labelColor,
        cursor: 'pointer',
        margin: 0,
        padding: `${$f50084288d7b85a1$var$tabBlockPadding} ${$f50084288d7b85a1$var$tabInlinePadding}`,
        position: 'relative',
        whiteSpace: 'nowrap',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        '&:hover': {
            // TODO: interaction states will be reviewed in DSP-1438
            color: colors.hoverLabelColor,
            '&::after': {
                ...$f50084288d7b85a1$var$tabLineStylesOld,
                insetInlineEnd: $f50084288d7b85a1$var$tabInlinePadding,
                borderBottom: `${$f50084288d7b85a1$var$underlineHeight} solid ${(0, $4xRua.tabLineColors).hoveredColor}`,
                height: 0
            }
        },
        '&:active': {
            // TODO: interaction states will be reviewed in DSP-1438
            color: colors.activeLabelColor,
            '&::after': {
                ...$f50084288d7b85a1$var$tabLineStylesOld,
                insetInlineEnd: $f50084288d7b85a1$var$tabInlinePadding,
                borderBottom: `${$f50084288d7b85a1$var$underlineHeight} solid ${(0, $4xRua.tabLineColors).activeColor}`,
                height: 0
            }
        },
        '&[aria-selected="true"]': {
            color: colors.selectedColor,
            '&::after': {
                ...$f50084288d7b85a1$var$tabLineStylesOld,
                insetInlineEnd: $f50084288d7b85a1$var$tabInlinePadding,
                // This line is a border so it is visible in high contrast mode
                borderBottom: `${$f50084288d7b85a1$var$underlineHeight} solid ${(0, $4xRua.tabLineColors).selectedColor}`,
                height: 0
            }
        }
    };
};

});
parcelRegister("4xRua", function(module, exports) {

$parcel$export(module.exports, "tabColors", () => $d893d977d51d4780$export$5159a1ad8efe50bc);
$parcel$export(module.exports, "tabLineColors", () => $d893d977d51d4780$export$6be6fa4649b31472);

const $d893d977d51d4780$export$5159a1ad8efe50bc = {
    labelColor: `var(--ds-text-subtle, ${(0, $73a5c9d720aa66e1$export$c39c0fe0f26207ae)})`,
    activeLabelColor: `var(--ds-text, ${(0, $73a5c9d720aa66e1$export$a6ee3d71bc067634)})`,
    hoverLabelColor: `var(--ds-text-subtle, ${(0, $73a5c9d720aa66e1$export$b3de0ae08da2ce64)})`,
    selectedColor: `var(--ds-text-selected, ${(0, $73a5c9d720aa66e1$export$b3de0ae08da2ce64)})`,
    focusBorderColor: `var(--ds-border-focused, ${(0, $73a5c9d720aa66e1$export$ecfc1dff386a3e7a)})`
};
const $d893d977d51d4780$export$6be6fa4649b31472 = {
    lineColor: `var(--ds-border, ${(0, $73a5c9d720aa66e1$export$3e51e8f1440314ba)})`,
    hoveredColor: "var(--ds-border, transparent)",
    activeColor: "var(--ds-border, transparent)",
    selectedColor: `var(--ds-border-selected, ${(0, $73a5c9d720aa66e1$export$b3de0ae08da2ce64)})`
};

});



parcelRegister("6xBtK", function(module, exports) {

$parcel$export(module.exports, "default", () => $b552637a2f5925a8$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $eUqFw = parcelRequire("eUqFw");

var $byn9U = parcelRequire("byn9U");

var $XHGTv = parcelRequire("XHGTv");

var $kgCsd = parcelRequire("kgCsd");

var $hcuCm = parcelRequire("hcuCm");

var $9qnib = parcelRequire("9qnib");
function $b552637a2f5925a8$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $b552637a2f5925a8$var$baseStyles = {
    name: "g0wsdz",
    styles: "display:flex;padding:var(--ds-space-0, 0px);position:relative"
};
// eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage
const $b552637a2f5925a8$var$tabListStyles = (0, $9qnib.getTabListStyles)();
// eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage
const $b552637a2f5925a8$var$tabListStylesOld = (0, $9qnib.getTabListStylesOld)();
/**
 * __TabList__
 *
 * A TabList groups `Tab` components together.
 *
 * - [Examples](https://atlassian.design/components/tabs/examples)
 * - [Code](https://atlassian.design/components/tabs/code)
 * - [Usage](https://atlassian.design/components/tabs/usage)
 */ const $b552637a2f5925a8$var$TabList = ({ children: children })=>{
    const { tabsId: tabsId, selected: selected, onChange: onChange } = (0, $kgCsd.useTabList)();
    const ref = /*#__PURE__*/ (0, $eUqFw.createRef)();
    // Don't include any conditional children
    const childrenArray = (0, $eUqFw.Children).toArray(children).filter(Boolean);
    const length = childrenArray.length;
    const selectTabByIndex = (0, $eUqFw.useCallback)((index)=>{
        const newSelectedNode = ref.current?.querySelector(`[id='${tabsId}-${index}']`);
        if (newSelectedNode) newSelectedNode.focus();
        onChange(index);
    }, [
        tabsId,
        ref,
        onChange
    ]);
    const onKeyDown = (0, $eUqFw.useCallback)((e)=>{
        if (![
            'ArrowRight',
            'ArrowLeft',
            'Home',
            'End'
        ].includes(e.key)) return;
        // preventing horizontal or vertical scroll
        e.preventDefault();
        const lastTabIndex = length - 1;
        if ([
            'Home',
            'End'
        ].includes(e.key)) {
            const newSelected = e.key === 'Home' ? 0 : lastTabIndex;
            selectTabByIndex(newSelected);
            return;
        }
        // We use aria-posinset so we don't rely on the selected variable
        // If we used the selected variable this would regenerate each time
        // and create an unstable reference
        const selectedIndex = parseInt(e.currentTarget.getAttribute('aria-posinset') || '0') - 1;
        const modifier = e.key === 'ArrowRight' ? 1 : -1;
        let newSelected = selectedIndex + modifier;
        if (newSelected < 0 || newSelected >= length) // Cycling focus to move from last to first and from first to last
        newSelected = newSelected < 0 ? lastTabIndex : 0;
        selectTabByIndex(newSelected);
    }, [
        length,
        selectTabByIndex
    ]);
    // Memoized so the function isn't recreated each time
    const getTabWithContext = (0, $eUqFw.useCallback)(({ tab: tab, isSelected: isSelected, index: index })=>/*#__PURE__*/ (0, $byn9U.jsx)((0, $hcuCm.TabContext).Provider, {
            value: {
                onClick: ()=>onChange(index),
                onKeyDown: onKeyDown,
                'aria-setsize': length,
                role: 'tab',
                id: `${tabsId}-${index}`,
                'aria-posinset': index + 1,
                'aria-selected': isSelected,
                'aria-controls': `${tabsId}-${index}-tab`,
                tabIndex: isSelected ? 0 : -1
            },
            key: index
        }, tab), [
        length,
        onKeyDown,
        onChange,
        tabsId
    ]);
    return(// Only styles that affect the TabList itself have been applied via primitives.
    // The other styles applied through the CSS prop are there for styling children
    // through inheritance. This is important for custom cases that use the useTab(),
    // which applies accessibility atributes that we use as a styling hook.
    /*#__PURE__*/ (0, $byn9U.jsx)("div", {
        role: "tablist",
        ref: ref,
        // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage
        css: [
            $b552637a2f5925a8$var$baseStyles,
            (0, $XHGTv.fg)('platform-component-visual-refresh') ? $b552637a2f5925a8$var$tabListStyles : $b552637a2f5925a8$var$tabListStylesOld
        ]
    }, childrenArray.map((child, index)=>getTabWithContext({
            tab: child,
            index: index,
            isSelected: index === selected
        }))));
};
var $b552637a2f5925a8$export$2e2bcd8739ae039 = $b552637a2f5925a8$var$TabList;

});
parcelRegister("kgCsd", function(module, exports) {

$parcel$export(module.exports, "useTab", () => $87f26a44f88daafa$export$fdf4756d5b8ef90a);
$parcel$export(module.exports, "useTabList", () => $87f26a44f88daafa$export$773e389e644c5874);
$parcel$export(module.exports, "useTabPanel", () => $87f26a44f88daafa$export$fae0121b5afe572d);

var $eUqFw = parcelRequire("eUqFw");

var $hcuCm = parcelRequire("hcuCm");
const $87f26a44f88daafa$export$fdf4756d5b8ef90a = ()=>{
    const tabData = (0, $eUqFw.useContext)((0, $hcuCm.TabContext));
    if (tabData == null || typeof tabData === 'undefined') throw Error('@atlaskit/tabs: A Tab must have a TabList parent.');
    return tabData;
};
const $87f26a44f88daafa$export$773e389e644c5874 = ()=>{
    const tabListData = (0, $eUqFw.useContext)((0, $hcuCm.TabListContext));
    if (tabListData === null || typeof tabListData === 'undefined') throw Error('@atlaskit/tabs: A TabList must have a Tabs parent.');
    return tabListData;
};
const $87f26a44f88daafa$export$fae0121b5afe572d = ()=>{
    const tabPanelData = (0, $eUqFw.useContext)((0, $hcuCm.TabPanelContext));
    if (tabPanelData === null || typeof tabPanelData === 'undefined') throw Error('@atlaskit/tabs:  A TabPanel must have a Tabs parent.');
    return tabPanelData;
};

});


parcelRegister("5EX8F", function(module, exports) {

$parcel$export(module.exports, "default", () => $283c5e8ea41dd7c8$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $283c5e8ea41dd7c8$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    pickerTabTextDefault: {
        "id": "issue-navigator.issue-results.list-view.column-picker-popup-component.column-picker-tabs.picker-tab-text-default",
        "defaultMessage": "My defaults"
    },
    pickerTabTextFilter: {
        "id": "issue-navigator.issue-results.list-view.column-picker-popup-component.column-picker-tabs.picker-tab-text-filter",
        "defaultMessage": "Filter"
    },
    pickerTabTextSystem: {
        "id": "issue-navigator.issue-results.list-view.column-picker-popup-component.column-picker-tabs.picker-tab-text-system",
        "defaultMessage": "System"
    }
});

});

parcelRegister("31uzl", function(module, exports) {

$parcel$export(module.exports, "default", () => $8091a14fe4b03ba7$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");
var $9t7rW = parcelRequire("9t7rW");

var $b5IAe = parcelRequire("b5IAe");
var $1ZAYh = parcelRequire("1ZAYh");

var $kgCsd = parcelRequire("kgCsd");

var $8jv9r = parcelRequire("8jv9r");
const $8091a14fe4b03ba7$var$Tab = ({ label: label, maxWidth: maxWidth = '100%' })=>{
    const [labelOverflows, setLabelOverflows] = (0, $eUqFw.useState)(false);
    const tabAttributes = (0, $kgCsd.useTab)();
    const onLabelRef = (0, $eUqFw.useCallback)((node)=>{
        if (node != null) {
            const isOverflow = Boolean(node.offsetWidth < node.scrollWidth);
            isOverflow !== labelOverflows && setLabelOverflows(isOverflow);
        }
    }, [
        labelOverflows
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($8091a14fe4b03ba7$var$TabStyled, {
        maxWidthValue: maxWidth,
        ...tabAttributes
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8jv9r.ConditionalTooltip), {
        condition: labelOverflows,
        content: label,
        position: "top"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
        ref: onLabelRef,
        xcss: $8091a14fe4b03ba7$var$textStyles
    }, label)));
};
const $8091a14fe4b03ba7$var$textStyles = (0, $1ZAYh.xcss)({
    textOverflow: 'ellipsis',
    overflow: 'hidden'
});
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $8091a14fe4b03ba7$var$TabStyled = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { maxWidthValue: maxWidthValue, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmpldp,
        style: {
            ...__cmpls,
            "--_1ocvhpw": (0, $9t7rW.default)(__cmplp.maxWidthValue)
        },
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_p12fd0nw _vchhusvi",
            __cmplp.className
        ])
    });
});
var $8091a14fe4b03ba7$export$2e2bcd8739ae039 = $8091a14fe4b03ba7$var$Tab;

});
parcelRegister("8jv9r", function(module, exports) {

$parcel$export(module.exports, "ConditionalTooltip", () => $e6120ff78736b217$export$d8abb7a1cfbd4b6b);

var $eUqFw = parcelRequire("eUqFw");

var $8cU5f = parcelRequire("8cU5f");
const $e6120ff78736b217$export$d8abb7a1cfbd4b6b = ({ condition: condition, children: children, ...rest })=>condition ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8cU5f.default), rest, children) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, children);

});



parcelRegister("5hr6J", function(module, exports) {

$parcel$export(module.exports, "default", () => $341a7b6c7d5fdcc5$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $341a7b6c7d5fdcc5$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    listSystemWarningMessage: {
        "id": "issue-navigator.issue-results.list-view.column-picker-popup-component.list-system-warning-message",
        "defaultMessage": "Any changes here will modify columns for all users."
    },
    listFilterWarningMessage: {
        "id": "issue-navigator.issue-results.list-view.column-picker-popup-component.list-filter-warning-message",
        "defaultMessage": "Any changes here will affect all users of this filter."
    },
    listNonEditableFilterInfoMessage: {
        "id": "issue-navigator.issue-results.list-view.column-picker-popup-component.list-non-editable-filter-info-message",
        "defaultMessage": "You can\u2019t modify this filter. Contact the owner using the <link>Filters directory</link> for edit permission."
    }
});

});


parcelRegister("hps0t", function(module, exports) {

$parcel$export(module.exports, "useFooterOverride", () => $8c3066532dc30771$export$d8b42fa25d3fad8c);
$parcel$export(module.exports, "Footer", () => $8c3066532dc30771$export$a06f1c675e846f6f);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $79xbN = parcelRequire("79xbN");

var $jt8Db = parcelRequire("jt8Db");

var $iWDmo = parcelRequire("iWDmo");

var $cQBUE = parcelRequire("cQBUE");
const $8c3066532dc30771$export$d8b42fa25d3fad8c = (isFeedbackButtonDisabled)=>{
    const { isStalePage: isStalePage } = (0, $cQBUE.useIssueSearchQuery)();
    return (0, $eUqFw.useMemo)(()=>({ end: end, ...props })=>{
            let start;
            // TODO EM-7315 Relocate feedback button
            if ((0, $79xbN.expVal)('jira_spreadsheet_component_m1', 'isInlineIssueCreateEnabled', false)) start = props.start;
            else if (!isFeedbackButtonDisabled) start = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($8c3066532dc30771$var$FeedbackContainer, {
                "data-testid": "issue-navigator.ui.issue-results.list-view.footer.feedback-wrapper"
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $iWDmo.default), null));
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $jt8Db.components).Footer, {
                ...props,
                start: start,
                // Do not show pagination controls while issue data is stale as page cursor information will be inaccurate
                end: isStalePage ? undefined : end
            });
        }, [
        isFeedbackButtonDisabled,
        isStalePage
    ]);
};
const $8c3066532dc30771$export$a06f1c675e846f6f = ({ end: end, ...props })=>{
    const { isStalePage: isStalePage } = (0, $cQBUE.useIssueSearchQuery)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $jt8Db.components).Footer, {
        ...props,
        // Do not show pagination controls while issue data is stale as page cursor information will be inaccurate
        end: isStalePage ? undefined : end
    });
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $8c3066532dc30771$var$FeedbackContainer = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _16jlkb7n _1o9zkb7n _i0dlf1ug",
            __cmplp.className
        ])
    });
});

});
parcelRegister("jt8Db", function(module, exports) {

$parcel$export(module.exports, "components", () => $e1ef31792b343138$export$9b5ac10f59f76296);

var $PACdv = parcelRequire("PACdv");

var $5og2Q = parcelRequire("5og2Q");

var $6baW2 = parcelRequire("6baW2");
const $e1ef31792b343138$export$9b5ac10f59f76296 = {
    columnPicker: $PACdv.components,
    Footer: $5og2Q.Footer,
    NoColumns: $6baW2.NoColumns
};

});
parcelRegister("5og2Q", function(module, exports) {

$parcel$export(module.exports, "Footer", () => $99d3214e2e1df43d$export$a06f1c675e846f6f);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $1ybV0 = parcelRequire("1ybV0");

var $eI5EY = parcelRequire("eI5EY");

var $2U8YO = parcelRequire("2U8YO");

var $aNqep = parcelRequire("aNqep");

var $lyeLC = parcelRequire("lyeLC");
const $99d3214e2e1df43d$export$a06f1c675e846f6f = (props)=>{
    const { start: start = $99d3214e2e1df43d$var$SpacerElement, center: center = $99d3214e2e1df43d$var$SpacerElement, end: end = $99d3214e2e1df43d$var$SpacerElement } = props;
    let hasShadow = false;
    let isInlineIssueCreateEnabled = false;
    if ((0, $eI5EY.fg)('jira_spreadsheet_component_m1_api_updates')) // eslint-disable-next-line react-hooks/rules-of-hooks
    isInlineIssueCreateEnabled = (0, $aNqep.useIsIssueCreateEnabled)();
    if ((0, $1ybV0.ff)('jsv-one-issue-table-spreadsheet-ui_ygrnf')) {
        // eslint-disable-next-line react-hooks/rules-of-hooks
        const { height: containerHeight, scrollTop: scrollTop } = (0, $2U8YO.useScrollState)();
        // eslint-disable-next-line react-hooks/rules-of-hooks
        const { height: tableHeight } = (0, $lyeLC.useTableSize)();
        // Scroll measurements are fractional, while height measurements are integer, so we need to round before comparing
        hasShadow = containerHeight < tableHeight && Math.round(scrollTop) < tableHeight - containerHeight;
    }
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($99d3214e2e1df43d$var$FooterContainer, {
        "data-testid": "native-issue-table.common.ui.components.footer.footer-container",
        hasShadow: hasShadow,
        isInlineIssueCreateEnabled: isInlineIssueCreateEnabled
    }, start, center, end);
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $99d3214e2e1df43d$var$FooterContainer = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { hasShadow: hasShadow, isInlineIssueCreateEnabled: isInlineIssueCreateEnabled, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _2lx2vrvc _1n261q9c _kqsw1if8 _1ltvidpf _94n5idpf _bfhkvuon _1yt4xtwq",
            (0, $1ybV0.ff)('jsv-one-issue-table-spreadsheet-ui_ygrnf') ? "_x3doi319 _1yt41b66" : "_x3do1on0",
            (0, $1ybV0.ff)('jsv-one-issue-table-spreadsheet-ui_ygrnf') && __cmplp.hasShadow && "_16qsahas",
            __cmplp.isInlineIssueCreateEnabled && "_1tke1ylp",
            __cmplp.className
        ])
    });
});
const $99d3214e2e1df43d$export$d7a54cba636a8cd6 = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _16jlkb7n _1o9zkb7n _i0dlf1ug",
            __cmplp.className
        ])
    });
});
const $99d3214e2e1df43d$var$SpacerElement = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($99d3214e2e1df43d$export$d7a54cba636a8cd6, null);

});
parcelRegister("2U8YO", function(module, exports) {

$parcel$export(module.exports, "useScrollState", () => $93b1ae720a2f9e16$export$98084ad349e2edae);
$parcel$export(module.exports, "ScrollStateContextProvider", () => $93b1ae720a2f9e16$export$7cc0055278d35041);
/*!
 * Adding too many scroll listeners adds overhead to both the initial
 * "bootstrap" phase, when the listeners are added, and all scroll events.
 *
 * Some virtualisation use-cases such as boards may have a large number of
 * virtual lists instances. Sharing a scroll element through context avoids
 * attaching one listener per list.
 */ 
var $eUqFw = parcelRequire("eUqFw");
const $93b1ae720a2f9e16$export$50b6b7783d156e1b = 200;
const $93b1ae720a2f9e16$var$INITIAL_SCROLL_STATE = {
    height: 0,
    width: 0,
    scrollHeight: 0,
    scrollWidth: 0,
    scrollTop: 0,
    scrollLeft: 0,
    isScrolling: false,
    scrollElement: null
};
const $93b1ae720a2f9e16$var$ScrollStateContext = /*#__PURE__*/ (0, $eUqFw.createContext)($93b1ae720a2f9e16$var$INITIAL_SCROLL_STATE);
const $93b1ae720a2f9e16$export$98084ad349e2edae = ()=>(0, $eUqFw.useContext)($93b1ae720a2f9e16$var$ScrollStateContext);
const $93b1ae720a2f9e16$var$attachResizeObserver = (callback, targetEl)=>{
    // Replace with lodash/noop
    // eslint-disable-next-line @typescript-eslint/no-empty-function
    if (!targetEl) return ()=>{};
    let resizeObserver = null;
    // SSR fix. Do not instantiate for SSR
    if (typeof ResizeObserver !== 'undefined') resizeObserver = new ResizeObserver(()=>callback());
    // When mounting our listener, if its the Window object, treat it as such.
    // This can happen in Storybook but not in any other scenario
    if (targetEl instanceof Window) targetEl.addEventListener('resize', callback);
    else resizeObserver?.observe(targetEl);
    return ()=>{
        // Cleanup the resize callback we have attached
        if (targetEl instanceof Window) targetEl.removeEventListener('resize', callback);
        else resizeObserver?.disconnect();
    };
};
/**
 * Listens for scroll events on the `HTMLElement` `scrollRef.current` and updates a state
 * variable with the scroll state, which is returned.
 */ const $93b1ae720a2f9e16$var$useElementScrollState = (scrollRef)=>{
    const [scrollState, setScrollState] = (0, $eUqFw.useState)($93b1ae720a2f9e16$var$INITIAL_SCROLL_STATE);
    (0, $eUqFw.useEffect)(()=>{
        const targetEl = scrollRef.current;
        if (!targetEl) return undefined;
        let clearScrollingTimeoutId;
        const onScroll = ()=>{
            setScrollState((state)=>({
                    ...state,
                    scrollTop: targetEl.scrollTop,
                    scrollLeft: targetEl.scrollLeft,
                    isScrolling: true
                }));
            clearTimeout(clearScrollingTimeoutId);
            clearScrollingTimeoutId = setTimeout(()=>{
                setScrollState((state)=>({
                        ...state,
                        scrollTop: targetEl.scrollTop,
                        scrollLeft: targetEl.scrollLeft,
                        isScrolling: false
                    }));
            }, $93b1ae720a2f9e16$export$50b6b7783d156e1b);
        };
        const onResize = ()=>{
            setScrollState((state)=>({
                    ...state,
                    scrollTop: targetEl.scrollTop,
                    scrollLeft: targetEl.scrollLeft,
                    height: targetEl.clientHeight,
                    width: targetEl.clientWidth,
                    scrollHeight: targetEl.scrollHeight,
                    scrollWidth: targetEl.scrollWidth,
                    isScrolling: true
                }));
            clearTimeout(clearScrollingTimeoutId);
            clearScrollingTimeoutId = setTimeout(()=>{
                setScrollState((state)=>({
                        ...state,
                        scrollTop: targetEl.scrollTop,
                        scrollLeft: targetEl.scrollLeft,
                        isScrolling: false
                    }));
            }, $93b1ae720a2f9e16$export$50b6b7783d156e1b);
        };
        // We want to know when the scroll element/container itself resizes as this impacts
        // the number of rows we show
        const cleanupResizeObserver = $93b1ae720a2f9e16$var$attachResizeObserver(onResize, targetEl);
        targetEl.addEventListener('scroll', onScroll);
        setScrollState({
            height: targetEl.clientHeight,
            width: targetEl.clientWidth,
            scrollHeight: targetEl.scrollHeight,
            scrollWidth: targetEl.scrollWidth,
            scrollTop: targetEl.scrollTop,
            scrollLeft: targetEl.scrollLeft,
            isScrolling: false,
            scrollElement: targetEl
        });
        return ()=>{
            targetEl.removeEventListener('scroll', onScroll);
            cleanupResizeObserver();
            clearTimeout(clearScrollingTimeoutId);
        };
    }, [
        scrollRef
    ]);
    return scrollState;
};
const $93b1ae720a2f9e16$export$7cc0055278d35041 = ({ scrollRef: scrollRef, children: children })=>{
    const scrollState = $93b1ae720a2f9e16$var$useElementScrollState(scrollRef);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($93b1ae720a2f9e16$var$ScrollStateContext.Provider, {
        value: scrollState
    }, children);
};

});

parcelRegister("aNqep", function(module, exports) {

$parcel$export(module.exports, "useIsDensityFull", () => $e1609128185d6301$export$f031d973e8f9ebd1);
$parcel$export(module.exports, "useIsColumnResizingEnabled", () => $e1609128185d6301$export$928fba01e945632a);
$parcel$export(module.exports, "useIsFixedTableLayoutEnabled", () => $e1609128185d6301$export$bce4f421d3fcab1b);
$parcel$export(module.exports, "useIsInlineEditingEnabled", () => $e1609128185d6301$export$3e66c03eddc15634);
$parcel$export(module.exports, "useIsIssueCreateEnabled", () => $e1609128185d6301$export$543273904a8063c6);
$parcel$export(module.exports, "useIsInfiniteScrollingEnabled", () => $e1609128185d6301$export$ffaeab57bb7094ff);
$parcel$export(module.exports, "useIsSiblingIssueCreateEnabled", () => $e1609128185d6301$export$f1842b07a822e21a);
$parcel$export(module.exports, "useIsIssueRankingEnabled", () => $e1609128185d6301$export$7fa8121781f45255);
$parcel$export(module.exports, "useIsIssueHierarchyEnabled", () => $e1609128185d6301$export$4f04f80fe2006454);
$parcel$export(module.exports, "useIssueCreateProjectKey", () => $e1609128185d6301$export$e91172ade15056bb);

var $1ybV0 = parcelRequire("1ybV0");

var $1yZQx = parcelRequire("1yZQx");

var $a4IeB = parcelRequire("a4IeB");

var $jmqrD = parcelRequire("jmqrD");
const $e1609128185d6301$export$f031d973e8f9ebd1 = (0, $1yZQx.createStateHook)((0, $jmqrD.FeaturesStore), {
    selector: (state)=>state.density === (0, $a4IeB.DENSITY_FULL)
});
const $e1609128185d6301$export$928fba01e945632a = (0, $1yZQx.createStateHook)((0, $jmqrD.FeaturesStore), {
    selector: (state)=>state.isColumnResizingEnabled
});
const $e1609128185d6301$export$bce4f421d3fcab1b = (0, $1yZQx.createStateHook)((0, $jmqrD.FeaturesStore), {
    selector: (state)=>state.isFixedTableLayoutEnabled
});
const $e1609128185d6301$export$3e66c03eddc15634 = (0, $1yZQx.createStateHook)((0, $jmqrD.FeaturesStore), {
    selector: (state)=>state.isInlineEditingEnabled
});
const $e1609128185d6301$export$543273904a8063c6 = (0, $1yZQx.createStateHook)((0, $jmqrD.FeaturesStore), {
    selector: (state)=>state.isIssueCreateEnabled
});
const $e1609128185d6301$export$ffaeab57bb7094ff = (0, $1yZQx.createStateHook)((0, $jmqrD.FeaturesStore), {
    selector: (state)=>state.isInfiniteScrollingEnabled
});
const $e1609128185d6301$export$f1842b07a822e21a = (0, $1yZQx.createStateHook)((0, $jmqrD.FeaturesStore), {
    selector: (state)=>state.isIssueCreateEnabled && state.isIssueRankingEnabled
});
const $e1609128185d6301$export$7fa8121781f45255 = (0, $1yZQx.createStateHook)((0, $jmqrD.FeaturesStore), {
    selector: (state)=>(0, $1ybV0.ff)('jsw.enable-nin-rank-dnd') && state.isIssueRankingEnabled
});
const $e1609128185d6301$export$4f04f80fe2006454 = (0, $1yZQx.createStateHook)((0, $jmqrD.FeaturesStore), {
    selector: (state)=>state.isIssueHierarchyEnabled
});
const $e1609128185d6301$export$e91172ade15056bb = (0, $1yZQx.createStateHook)((0, $jmqrD.FeaturesStore), {
    selector: (state)=>state.issueCreateProjectKey
});

});
parcelRegister("jmqrD", function(module, exports) {

$parcel$export(module.exports, "FeaturesContainer", () => $92b4ecc532970ab9$export$449fd4f36db88f87);
$parcel$export(module.exports, "FeaturesStore", () => $92b4ecc532970ab9$export$b78abb146634afd0);

var $96gVp = parcelRequire("96gVp");
var $kEDjj = parcelRequire("kEDjj");

var $a4IeB = parcelRequire("a4IeB");
const $92b4ecc532970ab9$var$initialState = {
    density: (0, $a4IeB.DENSITY_COMPACT),
    isColumnResizingEnabled: true,
    isFixedTableLayoutEnabled: true,
    isInlineEditingEnabled: true,
    isIssueCreateEnabled: false,
    issueCreateProjectKey: null,
    isInfiniteScrollingEnabled: false,
    isIssueRankingEnabled: false,
    isIssueRankDescending: false,
    isIssueHierarchyEnabled: false
};
const $92b4ecc532970ab9$export$449fd4f36db88f87 = (0, $96gVp.createContainer)();
const $92b4ecc532970ab9$var$updateStore = ({ setState: setState }, { density: density, isColumnResizingEnabled: isColumnResizingEnabled, isInlineEditingEnabled: isInlineEditingEnabled, isIssueCreateEnabled: isIssueCreateEnabled, issueCreateProjectKey: issueCreateProjectKey, isInfiniteScrollingEnabled: isInfiniteScrollingEnabled, isOrderedByRank: isOrderedByRank, sortDirection: sortDirection, isIssueHierarchyEnabled: isIssueHierarchyEnabled })=>{
    setState({
        density: density,
        isColumnResizingEnabled: isColumnResizingEnabled,
        isFixedTableLayoutEnabled: isColumnResizingEnabled,
        isInlineEditingEnabled: isInlineEditingEnabled,
        isIssueCreateEnabled: isIssueCreateEnabled && Boolean(issueCreateProjectKey),
        issueCreateProjectKey: issueCreateProjectKey ?? null,
        isInfiniteScrollingEnabled: isInfiniteScrollingEnabled,
        isIssueHierarchyEnabled: isIssueHierarchyEnabled,
        isIssueRankingEnabled: isOrderedByRank,
        isIssueRankDescending: sortDirection === (0, $a4IeB.SORT_DESC)
    });
};
const $92b4ecc532970ab9$export$b78abb146634afd0 = (0, $kEDjj.createStore)({
    initialState: $92b4ecc532970ab9$var$initialState,
    actions: {},
    containedBy: $92b4ecc532970ab9$export$449fd4f36db88f87,
    handlers: {
        onInit: ()=>$92b4ecc532970ab9$var$updateStore,
        onContainerUpdate: ()=>$92b4ecc532970ab9$var$updateStore
    }
});

});


parcelRegister("lyeLC", function(module, exports) {

$parcel$export(module.exports, "TableSizeProvider", () => $cd30c94ec98433e0$export$d5a5e307b6cc4da8);
$parcel$export(module.exports, "useTableSize", () => $cd30c94ec98433e0$export$95b939e430a260c);

var $eUqFw = parcelRequire("eUqFw");

var $3NMXU = parcelRequire("3NMXU");
const $cd30c94ec98433e0$var$TableSizeContext = /*#__PURE__*/ (0, $eUqFw.createContext)((0, $3NMXU.DEFAULT_SIZE));
const $cd30c94ec98433e0$export$d5a5e307b6cc4da8 = ({ children: children, tableRef: tableRef })=>{
    const tableSize = (0, $3NMXU.useElementSize)(tableRef);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($cd30c94ec98433e0$var$TableSizeContext.Provider, {
        value: tableSize
    }, children);
};
const $cd30c94ec98433e0$export$95b939e430a260c = ()=>(0, $eUqFw.useContext)($cd30c94ec98433e0$var$TableSizeContext);

});
parcelRegister("3NMXU", function(module, exports) {

$parcel$export(module.exports, "DEFAULT_SIZE", () => $e207dd03dc715dfb$export$e4c0458e30711294);
$parcel$export(module.exports, "useElementSize", () => $e207dd03dc715dfb$export$2b86bedf890eab8);

var $eUqFw = parcelRequire("eUqFw");
const $e207dd03dc715dfb$export$e4c0458e30711294 = {
    height: 0,
    width: 0,
    scrollHeight: 0,
    scrollWidth: 0
};
const $e207dd03dc715dfb$export$2b86bedf890eab8 = (elementRef)=>{
    const [size, setSize] = (0, $eUqFw.useState)($e207dd03dc715dfb$export$e4c0458e30711294);
    (0, $eUqFw.useEffect)(()=>{
        const element = elementRef.current;
        if (element) {
            const resizeObserver = new ResizeObserver(()=>{
                setSize({
                    height: element.clientHeight,
                    width: element.clientWidth,
                    scrollHeight: element.scrollHeight,
                    scrollWidth: element.scrollWidth
                });
            });
            resizeObserver.observe(element);
            return ()=>{
                resizeObserver.disconnect();
            };
        }
    }, [
        elementRef
    ]);
    return size;
};

});



parcelRegister("6baW2", function(module, exports) {

$parcel$export(module.exports, "NoColumns", () => $8db98c71e6dd45e0$export$a0e9f6d02eee4aa4);

var $eUqFw = parcelRequire("eUqFw");

var $7u4fN = parcelRequire("7u4fN");

var $220ac = parcelRequire("220ac");

var $b5IAe = parcelRequire("b5IAe");

var $5JgJ2 = parcelRequire("5JgJ2");

var $532yW = parcelRequire("532yW");

var $jMP2a = parcelRequire("jMP2a");

var $kIdhg = parcelRequire("kIdhg");
const $8db98c71e6dd45e0$export$a0e9f6d02eee4aa4 = ({ defaultNoColumnsGlyph: defaultNoColumnsGlyph, hasColumnConfiguration: hasColumnConfiguration })=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const [{ isOpen: isOpen }, actions] = (0, $532yW.useColumnPickerOpenState)();
    const onOpenColumnPicker = (0, $eUqFw.useCallback)((event, analyticsEvent)=>{
        (0, $jMP2a.fireUIAnalytics)(analyticsEvent, 'button clicked', 'noColumnsButton');
        if (!isOpen) actions.open();
    }, [
        isOpen,
        actions
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
        paddingBlock: "space.800"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $220ac.default), {
        header: formatMessage((0, $kIdhg.default).noColumnsHeaderText),
        description: formatMessage((0, $kIdhg.default).noColumnsDescriptionText),
        testId: "native-issue-table.common.ui.components.no-columns.no-columns",
        primaryAction: hasColumnConfiguration ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7u4fN.default), {
            appearance: "primary",
            onClick: onOpenColumnPicker
        }, formatMessage((0, $kIdhg.default).configureColumns)) : undefined,
        renderImage: ()=>defaultNoColumnsGlyph
    }));
};

});
parcelRegister("532yW", function(module, exports) {

$parcel$export(module.exports, "ColumnPickerContainer", () => $80222f4587dd1d1e$export$e1286e1cb3fa0dec);
$parcel$export(module.exports, "useColumnPickerOpenState", () => $80222f4587dd1d1e$export$81588ffe8d9d4add);

var $96gVp = parcelRequire("96gVp");
var $1yZQx = parcelRequire("1yZQx");
var $kEDjj = parcelRequire("kEDjj");
const $80222f4587dd1d1e$export$e1286e1cb3fa0dec = (0, $96gVp.createContainer)();
const $80222f4587dd1d1e$var$Store = (0, $kEDjj.createStore)({
    initialState: {
        isOpen: false
    },
    actions: {
        open: ()=>({ setState: setState })=>{
                setState({
                    isOpen: true
                });
            },
        close: ()=>({ setState: setState })=>{
                setState({
                    isOpen: false
                });
            }
    },
    name: 'ColumnPickerOpenState',
    containedBy: $80222f4587dd1d1e$export$e1286e1cb3fa0dec
});
const $80222f4587dd1d1e$export$81588ffe8d9d4add = (0, $1yZQx.createHook)($80222f4587dd1d1e$var$Store);

});

parcelRegister("kIdhg", function(module, exports) {

$parcel$export(module.exports, "default", () => $50d96196bc902630$export$2e2bcd8739ae039);
/* eslint-disable jira/i18n/id-named-by-package */ 
var $90IgZ = parcelRequire("90IgZ");
var $50d96196bc902630$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    noColumnsHeaderText: {
        "id": "native-issue-table.issue-table.no-columns.no-columns-header-text",
        "defaultMessage": "Configure your columns"
    },
    noColumnsDescriptionText: {
        "id": "native-issue-table.issue-table.no-columns.no-columns-description-text",
        "defaultMessage": "You haven't configured any columns yet. Add fields as columns to see search results and their information."
    },
    configureColumns: {
        "id": "native-issue-table.issue-table.no-columns.configure-columns",
        "defaultMessage": "Configure columns"
    }
});

});




parcelRegister("lJD7j", function(module, exports) {

$parcel$export(module.exports, "IssueCount", () => $1af2b6094fb0a475$export$542fba90cc9c1bd1);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $a1tkg = parcelRequire("a1tkg");

var $g6NWY = parcelRequire("g6NWY");

var $cQBUE = parcelRequire("cQBUE");
const $1af2b6094fb0a475$export$542fba90cc9c1bd1 = ({ startIssueRange: startIssueRange, endIssueRange: endIssueRange, total: total, countExceedsMaxResults: countExceedsMaxResults })=>{
    const { isStalePage: isStalePage } = (0, $cQBUE.useIssueSearchQuery)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($1af2b6094fb0a475$var$IssueCountContainer, {
        "data-testid": "issue-navigator.ui.issue-results.list-view.issue-count"
    }, !isStalePage && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("span", {
        "data-testid": "issue-navigator.ui.issue-results.list-view.issue-count.text"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $a1tkg.default), {
        startIssueRange: startIssueRange,
        endIssueRange: endIssueRange,
        total: total,
        countExceedsMaxResults: countExceedsMaxResults
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $g6NWY.default), null));
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $1af2b6094fb0a475$var$IssueCountContainer = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _16jlkb7n _1o9zkb7n _i0dlf1ug _4cvr1h6o _1bah1h6o _k48pni7l _zulp1b66",
            __cmplp.className
        ])
    });
});

});

parcelRegister("9flur", function(module, exports) {

$parcel$export(module.exports, "default", () => $2a2f8ef25d7837c6$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $2a2f8ef25d7837c6$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    reorderColumnsErrorTitle: {
        "id": "issue-navigator.issue-results.list-view.reorder-columns-error-title",
        "defaultMessage": "We couldn't reorder your columns"
    },
    resetColumnsErrorTitle: {
        "id": "issue-navigator.issue-results.list-view.reset-columns-error-title",
        "defaultMessage": "We couldn't restore your default columns"
    },
    columnConfigMutationErrorDescription: {
        "id": "issue-navigator.issue-results.list-view.column-config-mutation-error-description",
        "defaultMessage": "Refresh and try again."
    }
});

});

parcelRegister("iNqNA", function(module, exports) {

$parcel$export(module.exports, "NoColumns", () => $b1056760b5970830$export$a0e9f6d02eee4aa4);

var $eUqFw = parcelRequire("eUqFw");

var $7u4fN = parcelRequire("7u4fN");

var $220ac = parcelRequire("220ac");

var $b5IAe = parcelRequire("b5IAe");

var $3x4sL = parcelRequire("3x4sL");

var $5JgJ2 = parcelRequire("5JgJ2");

var $jt8Db = parcelRequire("jt8Db");

var $jMP2a = parcelRequire("jMP2a");

var $6vrw7 = parcelRequire("6vrw7");

var $6yplV = parcelRequire("6yplV");

var $4RwIp = parcelRequire("4RwIp");

var $c4vwn = parcelRequire("c4vwn");
const $b1056760b5970830$var$Bold = ({ children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("b", null, children);
const $b1056760b5970830$var$NoColumnsAnonymous = ({ defaultNoColumnsGlyph: defaultNoColumnsGlyph })=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const [, { setView: setView }] = (0, $4RwIp.useSelectedViewState)();
    const onClick = (0, $eUqFw.useCallback)((event, analyticsEvent)=>{
        (0, $jMP2a.fireUIAnalytics)(analyticsEvent, 'button clicked', 'noColumnsButton', {
            isAnon: true
        });
        setView('detail', (0, $6vrw7.toIssueKey)(''));
    }, [
        setView
    ]);
    const component = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $220ac.default), {
        header: formatMessage((0, $c4vwn.default).noColumnsHeaderAnonymous),
        description: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $3x4sL.FormattedI18nMessage), {
            componentsMapping: {
                bold: $b1056760b5970830$var$Bold
            },
            message: formatMessage((0, $c4vwn.default).noColumnsDescriptionAnonymous, {
                boldStart: '{boldStart}',
                boldEnd: '{boldEnd}'
            })
        }),
        testId: "issue-navigator.ui.issue-results.list-view.no-columns.no-columns-anonymous",
        primaryAction: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7u4fN.default), {
            appearance: "primary",
            onClick: onClick
        }, formatMessage((0, $c4vwn.default).switchView)),
        renderImage: ()=>defaultNoColumnsGlyph
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
        paddingBlock: "space.800"
    }, component);
};
const $b1056760b5970830$export$a0e9f6d02eee4aa4 = ({ defaultNoColumnsGlyph: defaultNoColumnsGlyph, hasColumnConfiguration: hasColumnConfiguration })=>{
    const isAnonymous = (0, $6yplV.useIsAnonymous)();
    return isAnonymous ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($b1056760b5970830$var$NoColumnsAnonymous, {
        defaultNoColumnsGlyph: defaultNoColumnsGlyph
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $jt8Db.components).NoColumns, {
        defaultNoColumnsGlyph: defaultNoColumnsGlyph,
        hasColumnConfiguration: hasColumnConfiguration
    });
};

});
parcelRegister("3x4sL", function(module, exports) {

$parcel$export(module.exports, "FormattedI18nMessage", () => $88ddecd12f0773cd$export$200d7bd7633253ce);

var $eUqFw = parcelRequire("eUqFw");

var $dO2kc = parcelRequire("dO2kc");

var $6nVYw = parcelRequire("6nVYw");
const $88ddecd12f0773cd$export$200d7bd7633253ce = (props)=>{
    const { message: message, packageName: packageName, componentsMapping: componentsMapping } = props;
    const messageParts = (0, $eUqFw.useMemo)(()=>{
        const { tags: tags, openTags: openTags, closeTags: closeTags } = (0, $6nVYw.getTags)(componentsMapping);
        try {
            const parts = [];
            let token = '';
            let TagComponent;
            let closeTagLookup;
            for(let i = 0; i < message.length; i += 1){
                const letter = message[i];
                token += letter;
                if ((0, $6nVYw.isCloseTagDelimiter)(letter)) {
                    const firstTagFound = (0, $6nVYw.findTag)(token, {
                        tags: openTags
                    });
                    if (firstTagFound !== null && firstTagFound !== undefined) {
                        // if we have a tag already means it is a malformed message since it is 2 subsequent open tags
                        if (TagComponent) throw new (0, $dO2kc.MalformedMessageError)();
                        const text = token.replace(firstTagFound, '');
                        parts.push(text);
                        // @ts-expect-error - TS7053 - Element implicitly has an 'any' type because expression of type 'string' can't be used to index type '{}'.
                        const tagInfo = tags[firstTagFound];
                        TagComponent = tagInfo.component;
                        closeTagLookup = tagInfo.close;
                        token = '';
                    }
                }
                if (closeTagLookup !== null && closeTagLookup !== undefined && (0, $6nVYw.isCloseTagDelimiter)(letter) && (0, $6nVYw.isAnyTag)(token, {
                    tags: [
                        closeTagLookup
                    ]
                })) {
                    // this mean that we do not have an open tag for this closing tag
                    if (!TagComponent) throw new (0, $dO2kc.MalformedMessageError)();
                    const text = token.replace(closeTagLookup, '');
                    parts.push(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(TagComponent, null, text));
                    TagComponent = undefined;
                    token = '';
                    closeTagLookup = undefined;
                }
                if ((0, $6nVYw.isCloseTagDelimiter)(letter) && (0, $6nVYw.isAnyTag)(token, {
                    tags: closeTags
                })) {
                    // if we do not have an open tag mean we are closing a tag that is not open
                    if (!TagComponent) throw new (0, $dO2kc.MalformedMessageError)();
                }
            }
            // if we reached the end and we have an open tag, mean this message is malformed
            if (TagComponent || closeTagLookup) throw new (0, $dO2kc.MalformedMessageError)();
            // flush anything we keep in the current token
            if (token.length > 0) parts.push(token);
            return parts;
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (e) {
            if (e instanceof (0, $dO2kc.MalformedMessageError)) {
                (0, $dO2kc.logMalformedMessageError)({
                    message: message,
                    packageName: packageName
                });
                return [
                    (0, $dO2kc.getMalformedMessage)({
                        message: message,
                        closeTags: closeTags,
                        openTags: openTags
                    })
                ];
            }
            throw e;
        }
    }, [
        message,
        packageName,
        componentsMapping
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, messageParts.map((item, index)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $eUqFw.Fragment), {
            key: index
        }, item)));
};

});
parcelRegister("dO2kc", function(module, exports) {

$parcel$export(module.exports, "getMalformedMessage", () => $1a42e2705665fc85$export$f085cf20ec1f69ab);
$parcel$export(module.exports, "logMalformedMessageError", () => $1a42e2705665fc85$export$954c3e6aad1c9429);
$parcel$export(module.exports, "MalformedMessageError", () => $1a42e2705665fc85$export$40d900e818b9630e);

var $gUUjF = parcelRequire("gUUjF");

var $guiFP = parcelRequire("guiFP");

const $1a42e2705665fc85$export$f085cf20ec1f69ab = ({ message: message, openTags: openTags, closeTags: closeTags })=>[
        ...openTags,
        ...closeTags
    ].reduce((acc, tag)=>acc.replace(new RegExp(tag, 'g'), ''), message);
const $1a42e2705665fc85$export$954c3e6aad1c9429 = ({ message: message, packageName: packageName })=>{
    if (packageName !== null && packageName !== undefined) {
        const errorMessage = `Malformed message: ${message}`;
        // Send error log to analytics pipeline (i.e. SFX) and Sentry
        (0, $guiFP.default)({
            meta: {
                packageName: packageName,
                id: (0, $376af31d5cd90f0d$export$f3390a0e172fee41)
            },
            attributes: {
                message: errorMessage
            }
        });
        // Send error log to Splunk
        const location = `${packageName}.${(0, $376af31d5cd90f0d$export$f3390a0e172fee41)}`;
        (0, $gUUjF.default).unsafeErrorWithCustomerData(location, errorMessage);
    }
};
class $1a42e2705665fc85$export$40d900e818b9630e extends Error {
    constructor(){
        super('Malformed i18n message');
    }
}

});
const $376af31d5cd90f0d$export$f3390a0e172fee41 = 'formattedI18NMessage';


parcelRegister("6nVYw", function(module, exports) {

$parcel$export(module.exports, "getTags", () => $ec16d76793463e9e$export$af63d7414243dad3);
$parcel$export(module.exports, "isAnyTag", () => $ec16d76793463e9e$export$38ffa64fc639355f);
$parcel$export(module.exports, "findTag", () => $ec16d76793463e9e$export$dfca0f74034f8657);
$parcel$export(module.exports, "isCloseTagDelimiter", () => $ec16d76793463e9e$export$d5170904651e91b1);

const $ec16d76793463e9e$export$af63d7414243dad3 = (componentsMapping)=>Object.entries(componentsMapping).reduce(// eslint-disable-next-line @typescript-eslint/no-explicit-any
    (acc, [key, value])=>{
        const open = `{${key}Start}`;
        const close = `{${key}End}`;
        // @ts-expect-error - TS7053 - Element implicitly has an 'any' type because expression of type 'string' can't be used to index type '{}'.
        acc.tags[open] = {
            close: close,
            component: value
        };
        // @ts-expect-error - TS2345 - Argument of type 'string' is not assignable to parameter of type 'never'.
        acc.openTags.push(open);
        // @ts-expect-error - TS2345 - Argument of type 'string' is not assignable to parameter of type 'never'.
        acc.closeTags.push(close);
        return acc;
    }, {
        tags: {},
        openTags: [],
        closeTags: []
    });
const $ec16d76793463e9e$export$38ffa64fc639355f = (text, { tags: tags })=>tags.some((tag)=>text.includes(tag));
const $ec16d76793463e9e$export$dfca0f74034f8657 = (text, { tags: tags })=>tags.find((tag)=>text.includes(tag));
const $ec16d76793463e9e$export$d5170904651e91b1 = (letter)=>letter === (0, $a86f32165c278403$export$a10c567c3288a6b4);

});
const $a86f32165c278403$export$a10c567c3288a6b4 = '}';



parcelRegister("c4vwn", function(module, exports) {

$parcel$export(module.exports, "default", () => $fc4704c705741385$export$2e2bcd8739ae039);
/* eslint-disable jira/i18n/id-named-by-package */ 
var $90IgZ = parcelRequire("90IgZ");
var $fc4704c705741385$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    noColumnsHeaderAnonymous: {
        "id": "issue-navigator.issue-results.list-view.issue-table-no-columns-anonymous.no-columns-header-anonymous",
        "defaultMessage": "The admin hasn't configured any columns"
    },
    noColumnsDescriptionAnonymous: {
        "id": "issue-navigator.issue-results.list-view.issue-table-no-columns-anonymous.no-columns-description-anonymous",
        "defaultMessage": "Switch to {boldStart}Detail view{boldEnd} to see issues and their information."
    },
    switchView: {
        "id": "issue-navigator.issue-results.list-view.issue-table-no-columns-anonymous.switch-view",
        "defaultMessage": "Switch to detail view"
    }
});

});


parcelRegister("2SicN", function(module, exports) {

$parcel$export(module.exports, "NoIssues", () => $82e601460e1cf4fb$export$a7a61a727a1d891b);

var $eUqFw = parcelRequire("eUqFw");

var $220ac = parcelRequire("220ac");

var $b5IAe = parcelRequire("b5IAe");

var $5JgJ2 = parcelRequire("5JgJ2");

var $7FQZS = parcelRequire("7FQZS");
const $82e601460e1cf4fb$export$a7a61a727a1d891b = ({ defaultNoIssuesGlyph: defaultNoIssuesGlyph })=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
        paddingBlock: "space.800"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $220ac.default), {
        header: formatMessage((0, $7FQZS.default).noIssues),
        renderImage: ()=>defaultNoIssuesGlyph,
        testId: "issue-navigator.ui.issue-results.list-view.no-issues.empty-state"
    }));
};

});
parcelRegister("7FQZS", function(module, exports) {

$parcel$export(module.exports, "default", () => $0ae6434e3c0ef779$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $0ae6434e3c0ef779$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    noIssues: {
        "id": "issue-navigator.common.empty-list-icon.no-issues",
        "defaultMessage": "No issues were found matching your search"
    }
});

});


parcelRegister("50IaJ", function(module, exports) {

$parcel$export(module.exports, "AsyncRegisterShortcutDialogActions", () => $8d8fb817492edc15$export$53d5920188b673b6);

var $eUqFw = parcelRequire("eUqFw");

var $7rh0R = parcelRequire("7rh0R");

var $0cdA8 = parcelRequire("0cdA8");

var $gGtKh = parcelRequire("gGtKh");

var $7uVYl = parcelRequire("7uVYl");

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $8d8fb817492edc15$var$LazyRegisterShortcutDialogActions = (0, $7rh0R.lazy)(()=>(parcelRequire("ahvBI")), {
    moduleId: "./src/packages/issue-navigator/issue-navigator/src/ui/issue-results/list-view/register-shortcut-dialog-actions/index.tsx"
});
const $8d8fb817492edc15$export$53d5920188b673b6 = (props)=>{
    const [{ isShortcutsDialogVisible: isShortcutsDialogVisible }] = (0, $7uVYl.useShortcuts)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $0cdA8.JSErrorBoundary), {
        packageName: "jiraIssueNavigator",
        id: "register-issue-actions-worklflow-shortcuts-dialog",
        fallback: "flag"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7rh0R.LazyWait), {
        until: isShortcutsDialogVisible
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gGtKh.default), {
        name: "register-shortcut-dialog-actions",
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($8d8fb817492edc15$var$LazyRegisterShortcutDialogActions, props))));
};

});
parcelRegister("7uVYl", function(module, exports) {

$parcel$export(module.exports, "useShortcuts", () => $76686ee3e3d6a06c$export$a1ca853c6e4bb6fb);
$parcel$export(module.exports, "useShortcutsActions", () => $76686ee3e3d6a06c$export$b331ee6e87b9104c);

var $fvC6Z = parcelRequire("fvC6Z");
const $76686ee3e3d6a06c$export$a1ca853c6e4bb6fb = ()=>(0, $fvC6Z.useShortcutsStore)();
const $76686ee3e3d6a06c$export$b331ee6e87b9104c = ()=>{
    const [, actions] = (0, $fvC6Z.useShortcutsActionsStore)();
    return [
        undefined,
        actions
    ];
};

});
parcelRegister("fvC6Z", function(module, exports) {

$parcel$export(module.exports, "useShortcutsStore", () => $896347e3151ace81$export$a14646bfc7ba8d81);
$parcel$export(module.exports, "useShortcutsActionsStore", () => $896347e3151ace81$export$1a29bfef7fa09838);

var $1yZQx = parcelRequire("1yZQx");
var $kEDjj = parcelRequire("kEDjj");

var $4Dsz6 = parcelRequire("4Dsz6");
const $896347e3151ace81$export$d4c72bab9d6cc13a = {
    shortcuts: {
        admin: {
            key: 'admin',
            label: 'ADMIN',
            options: [],
            isLoaded: false
        }
    },
    isShortcutsDialogVisible: false,
    isShortcutsLoading: false,
    hasError: false,
    isAdminLoading: false,
    selectedItemKey: null,
    header: null,
    title: undefined
};
const $896347e3151ace81$export$6f57813fe9f31bf9 = (0, $kEDjj.createStore)({
    name: 'shortcuts',
    initialState: // @ts-expect-error - TS2322 - Type '{ readonly shortcuts: { readonly admin: { readonly key: "admin"; readonly label: "ADMIN"; readonly options: readonly []; readonly isLoaded: false; }; }; readonly isShortcutsDialogVisible: false; readonly isShortcutsLoading: false; ... 4 more ...; readonly title: undefined; }' is not assignable to type 'State'.
    $896347e3151ace81$export$d4c72bab9d6cc13a,
    actions: $4Dsz6
});
const $896347e3151ace81$export$a14646bfc7ba8d81 = (0, $1yZQx.createHook)($896347e3151ace81$export$6f57813fe9f31bf9);
const $896347e3151ace81$export$1a29bfef7fa09838 = (0, $1yZQx.createHook)($896347e3151ace81$export$6f57813fe9f31bf9, {
    selector: null
});

});
parcelRegister("4Dsz6", function(module, exports) {

$parcel$export(module.exports, "registerShortcuts", () => $9eb9f475a5856f0f$export$598ec0e6047cbdca);
$parcel$export(module.exports, "setShortcutsDialogVisibility", () => $9eb9f475a5856f0f$export$80ab1e79e32c3021);
$parcel$export(module.exports, "setShortcutsLoading", () => $9eb9f475a5856f0f$export$7ed2ac8328423043);
$parcel$export(module.exports, "setHasError", () => $9eb9f475a5856f0f$export$645a7c7453685186);
$parcel$export(module.exports, "setHeader", () => $9eb9f475a5856f0f$export$604ed74fb893f0e2);
$parcel$export(module.exports, "fetchAdminSections", () => $9eb9f475a5856f0f$export$aec87c8c9bde62e6);
$parcel$export(module.exports, "setSelectedItemKey", () => $9eb9f475a5856f0f$export$249c9d5b49cd9712);
$parcel$export(module.exports, "dropShortcutsByKeys", () => $9eb9f475a5856f0f$export$9cf39adf0dec984);

var $iVIEg = parcelRequire("iVIEg");

var $6QsdI = parcelRequire("6QsdI");

var $kh3b8 = parcelRequire("kh3b8");
const $9eb9f475a5856f0f$export$598ec0e6047cbdca = (shortcuts)=>({ getState: getState, setState: setState })=>{
        const currentState = getState();
        const newShortcuts = shortcuts.reduce((acc, current)=>{
            acc[current.key] = current;
            return acc;
        }, {
            ...currentState.shortcuts
        });
        setState({
            ...currentState,
            shortcuts: newShortcuts,
            isShortcutsLoading: false
        });
    };
const $9eb9f475a5856f0f$export$80ab1e79e32c3021 = (isVisible)=>({ getState: getState, setState: setState })=>{
        setState({
            ...getState(),
            isShortcutsDialogVisible: isVisible
        });
    };
const $9eb9f475a5856f0f$export$7ed2ac8328423043 = (isLoading)=>({ getState: getState, setState: setState })=>{
        setState({
            ...getState(),
            isShortcutsLoading: isLoading
        });
    };
const $9eb9f475a5856f0f$export$645a7c7453685186 = (hasError)=>({ getState: getState, setState: setState })=>{
        const currentState = getState();
        setState({
            ...currentState,
            hasError: hasError
        });
    };
const $9eb9f475a5856f0f$export$604ed74fb893f0e2 = (header, title)=>({ getState: getState, setState: setState })=>{
        const currentState = getState();
        setState({
            ...currentState,
            header: header,
            title: title
        });
    };
const $9eb9f475a5856f0f$export$aec87c8c9bde62e6 = ()=>async ({ setState: setState, getState: getState })=>{
        const currentState = getState();
        setState({
            ...currentState,
            isAdminLoading: true
        });
        const result = await (0, $6QsdI.default)();
        const shortcuts = result ? (0, $kh3b8.buildAdminSections)(result) : [];
        const newState = getState();
        setState({
            ...newState,
            shortcuts: {
                ...newState.shortcuts,
                admin: {
                    ...newState.shortcuts.admin,
                    key: 'admin',
                    options: shortcuts,
                    isLoaded: true
                }
            },
            hasError: currentState.hasError || !result,
            isAdminLoading: false
        });
    };
const $9eb9f475a5856f0f$export$249c9d5b49cd9712 = (item)=>({ setState: setState, getState: getState })=>{
        setState({
            ...getState(),
            selectedItemKey: item
        });
    };
const $9eb9f475a5856f0f$export$9cf39adf0dec984 = (keys)=>({ getState: getState, setState: setState })=>{
        if (!keys.length) return;
        const { shortcuts: shortcuts, ...rest } = getState();
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const newShortcuts = (0, (/*@__PURE__*/$parcel$interopDefault($iVIEg)))(Object.keys(shortcuts), keys).reduce((acc, key)=>{
            acc[key] = shortcuts[key];
            return acc;
        }, {});
        setState({
            ...rest,
            shortcuts: newShortcuts,
            isShortcutsLoading: false
        });
    };

});
parcelRegister("6QsdI", function(module, exports) {

$parcel$export(module.exports, "default", () => $dd5b36ae9a64aed1$export$2e2bcd8739ae039);

var $gUUjF = parcelRequire("gUUjF");

var $2OdyW = parcelRequire("2OdyW");
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$dd5b36ae9a64aed1$export$2e2bcd8739ae039 = async ()=>{
    try {
        return await (0, $2OdyW.default)('/rest/adminquicksearch/latest/links/default');
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        (0, $gUUjF.default).safeErrorWithoutCustomerData('shortcuts-dialog.fetch-admin-links', error.toString());
        return null;
    }
};

});

parcelRegister("kh3b8", function(module, exports) {

$parcel$export(module.exports, "buildAdminSections", () => $978ed85a7f52065b$export$5f8c94ecd4c9eb76);
const $978ed85a7f52065b$export$5f8c94ecd4c9eb76 = (parent, result = [])=>{
    if (parent.sections && parent.sections.length) parent.sections.forEach((s)=>$978ed85a7f52065b$export$5f8c94ecd4c9eb76(s, result));
    if (parent.items && parent.items.length) parent.items.forEach((i)=>result.push({
            key: i.key,
            label: i.label,
            // @ts-expect-error - TS2322 - Type '() => void' is not assignable to type '(event?: Event | undefined) => Promise<undefined> | undefined'.
            onClick: ()=>{
                window.location.href = i.linkUrl;
            }
        }));
    return result;
};

});




parcelRegister("ahvBI", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = $d1Cng("5Y6rG").then(()=>parcelRequire('a8WBO'));

});


parcelRegister("6Nns0", function(module, exports) {

$parcel$export(module.exports, "dragAndDropExperience", () => $30d1a995291bebbc$export$c1eb53e51d4d0ab3);

var $12kyE = parcelRequire("12kyE");
var $kDfSL = parcelRequire("kDfSL");
const $30d1a995291bebbc$export$c1eb53e51d4d0ab3 = new (0, $kDfSL.UFOExperience)('jira-issue-navigator.list-view.drag-and-drop', {
    type: (0, $12kyE.ExperienceTypes).Experience,
    performanceType: (0, $12kyE.ExperiencePerformanceTypes).InlineResult
});

});

parcelRegister("1kw3p", function(module, exports) {

$parcel$export(module.exports, "useColumnWidthUpdater", () => $2f707ceb19c76471$export$e54397ae25183faf);

var $eUqFw = parcelRequire("eUqFw");

var $iWLL0 = parcelRequire("iWLL0");

var $cNy9K = parcelRequire("cNy9K");
const $2f707ceb19c76471$export$e54397ae25183faf = (connectionId)=>{
    const environment = (0, $iWLL0.useRelayEnvironment)();
    return (0, $eUqFw.useCallback)((columnId, width)=>{
        (0, $cNy9K.commitLocalUpdate)(environment, (store)=>{
            const connection = store.get(connectionId);
            const fieldSetEdges = connection?.getLinkedRecords('edges') ?? [];
            const fieldSetEdge = fieldSetEdges.find((edge)=>{
                const fieldSetId = edge?.getLinkedRecord('node')?.getValue('fieldSetId');
                return columnId === fieldSetId;
            });
            if (!fieldSetEdge) return;
            const fieldSetNode = fieldSetEdge.getLinkedRecord('node');
            if (!fieldSetNode) return;
            if (width == null) {
                fieldSetNode.setValue(null, 'fieldSetPreferences');
                return;
            }
            const fieldSetPreferences = fieldSetNode.getOrCreateLinkedRecord('fieldSetPreferences', 'JiraFieldSetPreferences');
            fieldSetPreferences.setValue(width, 'width');
        });
    }, [
        connectionId,
        environment
    ]);
};

});

parcelRegister("8umcI", function(module, exports) {

$parcel$export(module.exports, "useEventHandlers", () => $e8aaff74e3dd72e6$export$8ce912bc34d0dbea);

var $eUqFw = parcelRequire("eUqFw");

var $6vrw7 = parcelRequire("6vrw7");

var $1ydM0 = parcelRequire("1ydM0");

var $cQBUE = parcelRequire("cQBUE");
const $e8aaff74e3dd72e6$export$8ce912bc34d0dbea = ()=>{
    const [, { setSelectedIssueByKey: setSelectedIssueByKey, deselectIssue: deselectIssue }] = (0, $1ydM0.useSelectedIssueDebouncedState)();
    const { onDeleteIssue: onDeleteIssue, onIssueByFieldsRefetch: onIssueByFieldsRefetch } = (0, $cQBUE.useIssueSearchQuery)();
    const onIssueRefetch = onIssueByFieldsRefetch;
    // While we don't have a mutation setup for inline editing, use issue refetch as a substitute
    const onUpdateCache = onIssueByFieldsRefetch;
    const onIssueDelete = (0, $eUqFw.useCallback)((deletedIssueKey)=>{
        const issueKeyToSelect = onDeleteIssue(deletedIssueKey);
        if (!issueKeyToSelect.length) {
            deselectIssue(false, false, false);
            return;
        }
        setSelectedIssueByKey((0, $6vrw7.toIssueKey)(issueKeyToSelect), false, false, false);
    }, [
        onDeleteIssue,
        setSelectedIssueByKey,
        deselectIssue
    ]);
    const onIssueLinkSelected = (0, $eUqFw.useCallback)((issueKey)=>{
        setSelectedIssueByKey((0, $6vrw7.toIssueKey)(issueKey));
        return true;
    }, [
        setSelectedIssueByKey
    ]);
    return (0, $eUqFw.useMemo)(()=>({
            onIssueRefetch: onIssueRefetch,
            onUpdateCache: onUpdateCache,
            onIssueDelete: onIssueDelete,
            onIssueLinkSelected: onIssueLinkSelected
        }), [
        onIssueRefetch,
        onUpdateCache,
        onIssueDelete,
        onIssueLinkSelected
    ]);
};

});



parcelRegister("lY5rz", function(module, exports) {

$parcel$export(module.exports, "default", () => $6f65bd1394a82c77$export$2e2bcd8739ae039);

var $hGnEz = parcelRequire("hGnEz");

var $jo4uT = parcelRequire("jo4uT");

var $jp8dr = parcelRequire("jp8dr");

var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $iWLL0 = parcelRequire("iWLL0");

var $b5IAe = parcelRequire("b5IAe");
var $1ZAYh = parcelRequire("1ZAYh");

var $0cdA8 = parcelRequire("0cdA8");

var $1lXFP = parcelRequire("1lXFP");

var $5JgJ2 = parcelRequire("5JgJ2");

var $dnIAN = parcelRequire("dnIAN");

var $1NJeM = parcelRequire("1NJeM");

var $4YE75 = parcelRequire("4YE75");

var $9nyrN = parcelRequire("9nyrN");

var $bmfQK = parcelRequire("bmfQK");

var $koU5J = parcelRequire("koU5J");

var $6yplV = parcelRequire("6yplV");

var $jK1pm = parcelRequire("jK1pm");

var $jccNB = parcelRequire("jccNB");

var $3wKQY = parcelRequire("3wKQY");

var $cWCvn = parcelRequire("cWCvn");

var $651im = parcelRequire("651im");

var $jhYi6 = parcelRequire("jhYi6");

var $1iCRE = parcelRequire("1iCRE");

var $3mEVr = parcelRequire("3mEVr");

var $cQBUE = parcelRequire("cQBUE");

var $lvtWa = parcelRequire("lvtWa");

var $ky48h = parcelRequire("ky48h");

var $lxqp4 = parcelRequire("lxqp4");

var $fIVib = parcelRequire("fIVib");

var $9Vqzg = parcelRequire("9Vqzg");
const $6f65bd1394a82c77$var$JQLBuilderWrapper = ({ defaultJql: defaultJql, onFilterSave: onFilterSave, onReset: onReset, onChangeJql: onChangeJql, onToggleAi: onToggleAi, issueResults: issueResults, filter: filter, jqlBuilderProps: jqlBuilderProps, jqlBuilderWithAiKey: jqlBuilderWithAiKey })=>{
    const { startJqlBuilderMetric: startJqlBuilderMetric, stopJqlBuilderMetric: stopJqlBuilderMetric, markJqlBuilderMetric: markJqlBuilderMetric } = (0, $fIVib.useJqlBuilderInstrumentation)();
    (0, $eUqFw.useLayoutEffect)(()=>{
        startJqlBuilderMetric();
        markJqlBuilderMetric((0, $cWCvn.marks).JQL_BUILDER_START);
    }, [
        startJqlBuilderMetric,
        markJqlBuilderMetric
    ]);
    const { query: query, onSearch: onSearch } = (0, $jhYi6.useJqlSearch)(onChangeJql);
    const { jql: jql, filterJql: filterJql, filterId: filterId } = (0, $3mEVr.useActiveJql)();
    const isAnonymous = (0, $6yplV.useIsAnonymous)();
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    let jqlErrors;
    const { isFetching: isFetching } = (0, $cQBUE.useIssueSearchQuery)();
    const issueResultsData = (0, $iWLL0.useFragment)((0, $jp8dr.default), issueResults);
    const issueSearchError = issueResultsData?.issueSearchError ?? null;
    if (issueSearchError && !isFetching) {
        if (issueSearchError.__typename === 'JiraInvalidJqlError') jqlErrors = issueSearchError.messages?.filter((0, $3wKQY.isNonNullish)).map((message)=>({
                type: 'error',
                message: message
            })) ?? [];
        else if (issueSearchError.__typename === 'JiraInvalidSyntaxError' && issueSearchError.message != null) jqlErrors = [
            {
                type: 'error',
                message: issueSearchError.message,
                errorType: issueSearchError.errorType ?? undefined
            }
        ];
    }
    const filterData = (0, $iWLL0.useFragment)((0, $jo4uT.default), filter);
    const ResetButtonControl = (0, $eUqFw.useCallback)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $lxqp4.default), {
            onReset: onReset
        }), [
        onReset
    ]);
    const GoBackToFilterButtonControl = (0, $eUqFw.useCallback)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $lxqp4.default), {
            onReset: onReset,
            isResetToFilter: true
        }), [
        onReset
    ]);
    const SaveFilterControl = (0, $eUqFw.useCallback)(({ searchMode: searchMode })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($6f65bd1394a82c77$var$SaveFilterWrapper, {
            "data-testid": "issue-navigator.ui.jql-builder.save-filter-control"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $koU5J.AsyncSaveFilterDialog), {
            jql: query,
            attributes: {
                isAdvancedModeEnabled: searchMode === (0, $1NJeM.SEARCH_MODE_ADVANCED)
            },
            onFilterSave: onFilterSave,
            buttonText: formatMessage((0, $lvtWa.default).saveFilterButton),
            title: formatMessage((0, $lvtWa.default).saveFilterDialogTitle)
        })), [
        onFilterSave,
        query,
        formatMessage
    ]);
    const SaveFilterDropdownControl = (0, $eUqFw.useCallback)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($6f65bd1394a82c77$var$SaveFilterWrapper, {
            "data-testid": "issue-navigator.ui.jql-builder.save-filter-dropdown-control"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $dnIAN.SaveFilterDropdown), {
            query: query,
            filterId: filterId,
            onFilterSave: onFilterSave
        })), [
        filterId,
        query,
        onFilterSave
    ]);
    const CopyFilterControl = (0, $eUqFw.useCallback)(({ searchMode: searchMode })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($6f65bd1394a82c77$var$SaveFilterWrapper, {
            "data-testid": "issue-navigator.ui.jql-builder.copy-filter-control"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $koU5J.AsyncSaveFilterDialog), {
            jql: query,
            filterId: filterId,
            attributes: {
                isAdvancedModeEnabled: searchMode === (0, $1NJeM.SEARCH_MODE_ADVANCED)
            },
            onFilterSave: onFilterSave,
            buttonText: formatMessage((0, $lvtWa.default).copyFilterButton),
            title: formatMessage((0, $lvtWa.default).copyFilterDialogTitle)
        })), [
        onFilterSave,
        query,
        filterId,
        formatMessage
    ]);
    const renderFilterControls = (0, $eUqFw.useCallback)(()=>{
        const extraControls = []; // Button nor dropdown should be shown when user is anonymous
        if (!isAnonymous) {
            if (filterData) {
                const { isEditable: isEditable } = filterData; // Should not show neither the button nor the dropdown if jql errors
                if (!jqlErrors || jqlErrors.length === 0) {
                    if ((0, $9Vqzg.isFilterJqlModified)({
                        filterJql: filterJql,
                        query: query
                    })) {
                        if (isEditable === true) extraControls.push(SaveFilterDropdownControl);
                        else extraControls.push(SaveFilterControl);
                    } else extraControls.push(CopyFilterControl);
                }
            } else extraControls.push(SaveFilterControl);
        }
        return extraControls;
    }, [
        CopyFilterControl,
        SaveFilterControl,
        SaveFilterDropdownControl,
        filterData,
        filterJql,
        isAnonymous,
        jqlErrors,
        query
    ]);
    const renderExtraControls = (0, $eUqFw.useCallback)(()=>{
        const extraControls = [];
        const showResetButton = (0, $9Vqzg.isOnlyJqlAndDifferentToDefault)(jql, defaultJql, filterJql) || (0, $9Vqzg.isOnlyFilterAndDifferentToDefault)(jql, defaultJql, filterJql) || (0, $9Vqzg.filterAndJqlIsTheSameAndDifferentToDefault)(jql, defaultJql, filterJql);
        const showGoBackToFilterButton = (0, $9Vqzg.jqlIsDifferentToFilter)(jql, filterJql);
        const addResetButton = ()=>showGoBackToFilterButton || showResetButton;
        if (addResetButton()) extraControls.push(showResetButton ? ResetButtonControl : GoBackToFilterButtonControl);
        extraControls.push(...renderFilterControls());
        return extraControls;
    }, [
        renderFilterControls,
        jql,
        defaultJql,
        filterJql,
        ResetButtonControl,
        GoBackToFilterButtonControl
    ]);
    let jqlMessages = (0, $eUqFw.useMemo)(()=>[
            ...jqlErrors || []
        ], [
        jqlErrors
    ]);
    const { messages: jqlInfos } = (0, $1iCRE.useJqlSearchStatus)({
        query: query,
        isSearching: isFetching
    });
    jqlMessages = (0, $eUqFw.useMemo)(()=>[
            ...jqlErrors || [],
            ...jqlInfos || []
        ], [
        jqlErrors,
        jqlInfos
    ]);
    const onLoad = (0, $eUqFw.useCallback)((mode)=>{
        if (mode === (0, $1NJeM.SEARCH_MODE_BASIC)) markJqlBuilderMetric((0, $cWCvn.marks).JQL_BUILDER_BASIC_START);
        else markJqlBuilderMetric((0, $cWCvn.marks).JQL_BUILDER_ADVANCED_START);
    }, [
        markJqlBuilderMetric
    ]);
    const onReady = (0, $eUqFw.useCallback)((mode)=>{
        if (mode === (0, $1NJeM.SEARCH_MODE_BASIC)) {
            markJqlBuilderMetric((0, $cWCvn.marks).JQL_BUILDER_BASIC_END);
            markJqlBuilderMetric((0, $cWCvn.marks).JQL_BUILDER_END);
        } else {
            markJqlBuilderMetric((0, $cWCvn.marks).JQL_BUILDER_ADVANCED_END);
            markJqlBuilderMetric((0, $cWCvn.marks).JQL_BUILDER_END);
        }
        stopJqlBuilderMetric();
    }, [
        stopJqlBuilderMetric,
        markJqlBuilderMetric
    ]);
    const aiBuilderOverrides = (0, $eUqFw.useMemo)(()=>({
            // Only render filter controls (no reset action) for the AI embedded JQL builder
            renderExtraControls: renderFilterControls
        }), [
        renderFilterControls
    ]); /* eslint-disable @atlassian/relay/must-colocate-fragment-spreads */ 
    const jqlBuilderWithAiData = (0, $iWLL0.useFragment)((0, $hGnEz.default), jqlBuilderWithAiKey); /* eslint-enable @atlassian/relay/must-colocate-fragment-spreads */ 
    const { onJourneyStart: onJourneyStart } = (0, $651im.useAppContextualAnalyticsActions)();
    const handlePerformanceMark = (0, $eUqFw.useCallback)(({ mark: mark })=>{
        markJqlBuilderMetric(mark);
    }, [
        markJqlBuilderMetric
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
        xcss: $6f65bd1394a82c77$var$wrapperStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4YE75.ShortcutsDialogIntegrationProvider), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $bmfQK.default), {
        analyticsSource: (0, $jccNB.ANALYTICS_SOURCE),
        query: query,
        onSearch: onSearch,
        renderExtraControls: renderExtraControls,
        jqlMessages: jqlMessages,
        isSearching: isFetching,
        onReady: onReady,
        onLoad: onLoad,
        onJourneyStart: onJourneyStart,
        NoOptionComponent: (0, $ky48h.NoOptionsMessage),
        aiBuilderOverrides: aiBuilderOverrides,
        onToggleAi: onToggleAi,
        fragmentKey: jqlBuilderWithAiData,
        onPerformanceMark: handlePerformanceMark,
        ...jqlBuilderProps
    })));
};
const $6f65bd1394a82c77$var$JQLBuilderWrapperWithErrorBoundary = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $jK1pm.default), {
        name: "issue-navigator-jql-builder"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $0cdA8.JSErrorBoundary), {
        id: "ui.jql-builder.error-boundary",
        packageName: (0, $jccNB.PACKAGE_NAME),
        teamName: (0, $jccNB.TEAM_NAME),
        sendToPrivacyUnsafeSplunk: true,
        attributes: (0, $1lXFP.isLoaderErrorAttributes),
        fallback: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $9nyrN.JQLBuilderErrorBoundryFallback), null)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($6f65bd1394a82c77$var$JQLBuilderWrapper, props)));
var $6f65bd1394a82c77$export$2e2bcd8739ae039 = $6f65bd1394a82c77$var$JQLBuilderWrapperWithErrorBoundary;
const $6f65bd1394a82c77$var$wrapperStyles = (0, $1ZAYh.xcss)({
    marginTop: 'space.negative.025',
    marginBottom: 'space.0'
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $6f65bd1394a82c77$var$SaveFilterWrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_19pk1b66",
            __cmplp.className
        ])
    });
});

});
parcelRegister("hGnEz", function(module, exports) {

$parcel$export(module.exports, "default", () => $6f52c5f65b4554ea$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<96f197ee49bffef91f88aabc89058cb4>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $6f52c5f65b4554ea$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "jqlBuilder_issueNavigator_JQLBuilderWrapper_jqlBuilderWithAiKey",
    "selections": [
        {
            "kind": "FragmentSpread",
            "name": "ui_jqlBuilderWithAi_JQLBuilderWithAI"
        }
    ],
    "type": "JiraQuery"
};
$6f52c5f65b4554ea$var$node.hash = "dd0aae667d7d92a8112c28d2dcff0ac8";
var $6f52c5f65b4554ea$export$2e2bcd8739ae039 = $6f52c5f65b4554ea$var$node;

});

parcelRegister("jo4uT", function(module, exports) {

$parcel$export(module.exports, "default", () => $514d6e5abaa080b6$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<a76e30faae7fd3f790cc395215820217>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $514d6e5abaa080b6$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "jqlBuilder_issueNavigator_JQLBuilderWrapper_filter",
    "selections": [
        {
            "kind": "ScalarField",
            "name": "isEditable"
        }
    ],
    "type": "JiraCustomFilter"
};
$514d6e5abaa080b6$var$node.hash = "46b543f50c73d7423957a8ecbe71b627";
var $514d6e5abaa080b6$export$2e2bcd8739ae039 = $514d6e5abaa080b6$var$node;

});

parcelRegister("jp8dr", function(module, exports) {

$parcel$export(module.exports, "default", () => $949dba300a9ed3b9$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<a3182e66785e68d12090ebb9bf08695e>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $949dba300a9ed3b9$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "jqlBuilder_issueNavigator_JQLBuilderWrapper_issueResults",
    "selections": [
        {
            "kind": "LinkedField",
            "name": "issueSearchError",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "__typename"
                },
                {
                    "kind": "InlineFragment",
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "messages"
                        }
                    ],
                    "type": "JiraInvalidJqlError"
                },
                {
                    "kind": "InlineFragment",
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "message"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "errorType"
                        }
                    ],
                    "type": "JiraInvalidSyntaxError"
                }
            ]
        }
    ],
    "type": "JiraIssueConnection"
};
$949dba300a9ed3b9$var$node.hash = "eeb59c3a307dc75263f7e39b4f314c7c";
var $949dba300a9ed3b9$export$2e2bcd8739ae039 = $949dba300a9ed3b9$var$node;

});

parcelRegister("dnIAN", function(module, exports) {

$parcel$export(module.exports, "SaveFilterDropdown", () => $82ed147ba143086e$export$4aae2fedc7924eed);

var $ZJZN4 = parcelRequire("ZJZN4");

var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $iWLL0 = parcelRequire("iWLL0");

var $7u4fN = parcelRequire("7u4fN");

var $6OfWd = parcelRequire("6OfWd");
var $hD6GJ = parcelRequire("hD6GJ");
var $fEubG = parcelRequire("fEubG");

var $86Ndv = parcelRequire("86Ndv");

var $guiFP = parcelRequire("guiFP");

var $eo17r = parcelRequire("eo17r");
var $k8Qyf = parcelRequire("k8Qyf");

var $5JgJ2 = parcelRequire("5JgJ2");

var $6JZkO = parcelRequire("6JZkO");
var $hZPqL = parcelRequire("hZPqL");

var $huI7r = parcelRequire("huI7r");

var $jMP2a = parcelRequire("jMP2a");
var $bFzGY = parcelRequire("bFzGY");

var $iqKE7 = parcelRequire("iqKE7");

var $gd0Sp = parcelRequire("gd0Sp");

var $30zCP = parcelRequire("30zCP");

var $15Iby = parcelRequire("15Iby");
const $82ed147ba143086e$export$a3ca021e3e6c7315 = (0, $eo17r.toFlagId)('issue-navigator-save-filter-success-flag');
const $82ed147ba143086e$export$f5e4c120ac01b615 = (0, $eo17r.toFlagId)('issue-navigator-save-filter-error-flag');
const $82ed147ba143086e$export$4aae2fedc7924eed = ({ defaultOpen: defaultOpen = false, filterId: filterId, query: query, onFilterSave: onFilterSave })=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const { showFlag: showFlag } = (0, $k8Qyf.useFlagService)();
    const [updateJiraCustomFilterJqlMutation] = (0, $iWLL0.useMutation)((0, $ZJZN4.default));
    const { activationId: activationId, cloudId: cloudId } = (0, $gd0Sp.useTenantContext)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bFzGY.useAnalyticsEvents)();
    const analyticsEvent = createAnalyticsEvent({});
    const onSaveChanges = (0, $eUqFw.useCallback)(()=>{
        (0, $jMP2a.fireUIAnalytics)(createAnalyticsEvent({
            action: 'clicked',
            actionSubject: 'dropdownItem'
        }), 'saveFilterChanges');
        filterId !== undefined && updateJiraCustomFilterJqlMutation({
            variables: {
                id: (0, $huI7r.createAri)({
                    resourceOwner: 'jira',
                    cloudId: cloudId,
                    resourceType: 'filter',
                    resourceId: filterId,
                    activationId: activationId
                }),
                jql: query
            },
            onCompleted: ({ jira: jira })=>{
                if (jira?.jiraFilterMutation?.updateJiraCustomFilterJql) {
                    const { success: success, filter: filter, errors: jiraErrors } = jira?.jiraFilterMutation?.updateJiraCustomFilterJql;
                    if (success && filter) {
                        const { name: name } = filter;
                        (0, $jMP2a.fireTrackAnalytics)(createAnalyticsEvent({
                            actionSubject: 'issueFilterJql',
                            action: 'updated'
                        }), 'issueFilterJql updated');
                        showFlag({
                            id: $82ed147ba143086e$export$a3ca021e3e6c7315,
                            render: (renderProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $hZPqL.SuccessFlag), {
                                    id: $82ed147ba143086e$export$a3ca021e3e6c7315,
                                    filterName: name,
                                    viewUrl: `${window.location.origin}/issues/?filter=${filterId}`,
                                    analyticsEvent: createAnalyticsEvent({
                                        actionSubject: 'button',
                                        action: 'clicked'
                                    }),
                                    ...renderProps
                                })
                        });
                    } else {
                        const errors = jiraErrors ? jiraErrors.map((error)=>error.message || '') : [];
                        showFlag({
                            id: $82ed147ba143086e$export$f5e4c120ac01b615,
                            render: (renderProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $6JZkO.ErrorFlag), {
                                    id: $82ed147ba143086e$export$f5e4c120ac01b615,
                                    errors: errors,
                                    ...renderProps
                                })
                        });
                        (0, $guiFP.default)({
                            event: analyticsEvent,
                            error: new Error(errors[0]),
                            meta: {
                                id: 'updateFilterJqlMutation',
                                packageName: 'jiraIssueNavigatorCustomFilters',
                                teamName: 'empanada'
                            }
                        });
                    }
                }
            },
            onError: (error)=>{
                showFlag({
                    id: $82ed147ba143086e$export$f5e4c120ac01b615,
                    render: (renderProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $6JZkO.ErrorFlag), {
                            id: $82ed147ba143086e$export$f5e4c120ac01b615,
                            ...renderProps,
                            errors: [
                                ''
                            ]
                        })
                });
                (0, $guiFP.default)({
                    event: analyticsEvent,
                    error: error,
                    meta: {
                        id: 'updateFilterJqlMutation',
                        packageName: 'jiraIssueNavigatorCustomFilters',
                        teamName: 'empanada'
                    }
                });
                return undefined;
            }
        });
    }, [
        activationId,
        cloudId,
        createAnalyticsEvent,
        filterId,
        query,
        showFlag,
        updateJiraCustomFilterJqlMutation,
        analyticsEvent
    ]);
    const [isModalOpen, setIsModalOpen] = (0, $eUqFw.useState)(false);
    const [isDropdownOpen, setIsDropdownOpen] = (0, $eUqFw.useState)(defaultOpen);
    const [shouldShowThirdPartyNudge, setShouldShowThirdPartyNudge] = (0, $eUqFw.useState)(false);
    const onOpenSaveFilterModal = (0, $eUqFw.useCallback)(()=>{
        (0, $jMP2a.fireUIAnalytics)(createAnalyticsEvent({
            action: 'clicked',
            actionSubject: 'dropdownItem'
        }), 'saveFilterCopy');
        setIsModalOpen(true);
    }, [
        createAnalyticsEvent,
        setIsModalOpen
    ]);
    const onCloseSaveFilterModal = (0, $eUqFw.useCallback)(()=>{
        setIsModalOpen(false);
    }, [
        setIsModalOpen
    ]);
    const onTriggerClick = (0, $eUqFw.useCallback)(()=>{
        (0, $jMP2a.fireUIAnalytics)(createAnalyticsEvent({
            action: 'toggled',
            actionSubject: 'dropdownMenu'
        }), 'filterOptions');
    }, [
        createAnalyticsEvent
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, shouldShowThirdPartyNudge && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $30zCP.default), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($82ed147ba143086e$var$DropdownMenuWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $6OfWd.default), {
        isOpen: isDropdownOpen,
        onOpenChange: (attrs)=>{
            setIsDropdownOpen(attrs.isOpen);
            if (attrs.isOpen) {
                setShouldShowThirdPartyNudge(true);
                onTriggerClick();
            }
        },
        trigger: ({ triggerRef: triggerRef, ...props })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7u4fN.default), {
                ...props,
                appearance: "link",
                ref: triggerRef,
                iconAfter: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($86Ndv))), {
                    label: formatMessage((0, $15Iby.default).saveFilter)
                })
            }, formatMessage((0, $15Iby.default).saveFilter))
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $fEubG.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $hD6GJ.default), {
        onClick: onSaveChanges
    }, formatMessage((0, $15Iby.default).saveChanges)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $hD6GJ.default), {
        onClick: onOpenSaveFilterModal
    }, formatMessage((0, $15Iby.default).saveAsACopy))))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $iqKE7.AsyncSaveFilterDialogContent), {
        isOpen: isModalOpen,
        jql: query,
        filterId: filterId,
        onCloseModal: onCloseSaveFilterModal,
        onFilterSave: onFilterSave,
        title: formatMessage((0, $15Iby.default).copyFilterDialogTitle)
    }));
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $82ed147ba143086e$var$DropdownMenuWrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_k4hekqvv",
            __cmplp.className
        ])
    });
});

});
parcelRegister("ZJZN4", function(module, exports) {

$parcel$export(module.exports, "default", () => $72ef22570a00bb6d$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<bfa68958cffd28f839eb1cc1261ee729>>
 * @relayHash a8b99d4e5148c557424db90f1be8215c
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 33abce877d8ddf36bd3fdb295b2e91c467ceff0b718872d73a32845f7130d8d5
const $72ef22570a00bb6d$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "id"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "jql"
        }
    ], v1 = [
        {
            "concreteType": "JiraMutation",
            "kind": "LinkedField",
            "name": "jira",
            "plural": false,
            "selections": [
                {
                    "concreteType": "JiraFilterMutation",
                    "kind": "LinkedField",
                    "name": "jiraFilterMutation",
                    "plural": false,
                    "selections": [
                        {
                            "args": [
                                {
                                    "fields": [
                                        {
                                            "kind": "Variable",
                                            "name": "id",
                                            "variableName": "id"
                                        },
                                        {
                                            "kind": "Variable",
                                            "name": "jql",
                                            "variableName": "jql"
                                        }
                                    ],
                                    "kind": "ObjectValue",
                                    "name": "input"
                                }
                            ],
                            "concreteType": "JiraUpdateCustomFilterJqlPayload",
                            "kind": "LinkedField",
                            "name": "updateJiraCustomFilterJql",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "success"
                                },
                                {
                                    "concreteType": "MutationError",
                                    "kind": "LinkedField",
                                    "name": "errors",
                                    "plural": true,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "message"
                                        }
                                    ]
                                },
                                {
                                    "concreteType": "JiraCustomFilter",
                                    "kind": "LinkedField",
                                    "name": "filter",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "id"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "name"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "jql"
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "mainUpdateFilterJqlMutation",
            "selections": v1 /*: any*/ ,
            "type": "Mutation"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "mainUpdateFilterJqlMutation",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "id": "33abce877d8ddf36bd3fdb295b2e91c467ceff0b718872d73a32845f7130d8d5",
            "metadata": {},
            "name": "mainUpdateFilterJqlMutation",
            "operationKind": "mutation",
            "text": null
        }
    };
}();
$72ef22570a00bb6d$var$node.hash = "6807efed6a00f60f9cf95df455e467fd";
var $72ef22570a00bb6d$export$2e2bcd8739ae039 = $72ef22570a00bb6d$var$node;

});

parcelRegister("hD6GJ", function(module, exports) {

$parcel$export(module.exports, "default", () => $67738981858b3f25$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $1lQG9 = parcelRequire("1lQG9");

var $bULPy = parcelRequire("bULPy");

var $e7PSD = parcelRequire("e7PSD");

var $bo4OB = parcelRequire("bo4OB");

var $h1Q9j = parcelRequire("h1Q9j");
/**
 * __Dropdown menu item__
 *
 * A dropdown item populates the dropdown menu with items. Every item should be inside a dropdown item group.
 *
 * - [Examples](https://atlassian.design/components/dropdown-item/examples)
 * - [Code](https://atlassian.design/components/dropdown-item/code)
 * - [Usage](https://atlassian.design/components/dropdown-item/usage)
 */ const $67738981858b3f25$var$DropdownMenuItem = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ children: children, component: component, description: description, elemAfter: elemAfter, elemBefore: elemBefore, href: href, isDisabled: isDisabled, isSelected: isSelected, onClick: onClick, rel: rel, shouldDescriptionWrap: shouldDescriptionWrap = true, shouldTitleWrap: shouldTitleWrap = true, target: target, testId: testId, UNSAFE_shouldDisableRouterLink: UNSAFE_shouldDisableRouterLink, returnFocusRef: returnFocusRef, ...rest }, ref)=>{
    const itemRef = (0, $h1Q9j.default)();
    const handleItemClick = (0, $eUqFw.useCallback)((event)=>{
        if (returnFocusRef?.current) returnFocusRef.current.focus();
        if (onClick) onClick(event);
    }, [
        onClick,
        returnFocusRef
    ]);
    if (component) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $e7PSD.default), {
        component: component,
        description: description,
        iconAfter: elemAfter,
        iconBefore: elemBefore,
        isDisabled: isDisabled,
        isSelected: isSelected,
        onClick: handleItemClick,
        ref: (0, $1lQG9.default)([
            ref,
            itemRef
        ]),
        shouldDescriptionWrap: shouldDescriptionWrap,
        shouldTitleWrap: shouldTitleWrap,
        testId: testId,
        href: href,
        // Thanks to spread props, these attributes are passed to CustomItem, even though
        // it's not in the component's prop types.
        // @ts-expect-error
        target: target,
        rel: rel,
        ...rest
    }, children);
    else if (href) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $bo4OB.default), {
        description: description,
        href: href,
        iconAfter: elemAfter,
        iconBefore: elemBefore,
        isDisabled: isDisabled,
        isSelected: isSelected,
        onClick: handleItemClick,
        ref: (0, $1lQG9.default)([
            ref,
            itemRef
        ]),
        rel: rel,
        role: "menuitem",
        shouldDescriptionWrap: shouldDescriptionWrap,
        shouldTitleWrap: shouldTitleWrap,
        target: target,
        testId: testId,
        UNSAFE_shouldDisableRouterLink: UNSAFE_shouldDisableRouterLink,
        ...rest
    }, children);
    else return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $bULPy.default), {
        description: description,
        iconAfter: elemAfter,
        iconBefore: elemBefore,
        isDisabled: isDisabled,
        isSelected: isSelected,
        onClick: handleItemClick,
        ref: (0, $1lQG9.default)([
            ref,
            itemRef
        ]),
        role: "menuitem",
        shouldDescriptionWrap: shouldDescriptionWrap,
        shouldTitleWrap: shouldTitleWrap,
        testId: testId,
        // Thanks to spread props, these attributes are passed to CustomItem, even though
        // it's not in the component's prop types.
        // @ts-expect-error
        target: target,
        rel: rel,
        ...rest
    }, children);
});
var $67738981858b3f25$export$2e2bcd8739ae039 = $67738981858b3f25$var$DropdownMenuItem;

});

parcelRegister("fEubG", function(module, exports) {

$parcel$export(module.exports, "default", () => $920365f1041780e0$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $ki32l = parcelRequire("ki32l");

var $8BKky = parcelRequire("8BKky");

var $lmkW0 = parcelRequire("lmkW0");
/**
 * __Dropdown item checkbox group__
 *
 * A wrapping element for dropdown menu items.
 *
 */ const $920365f1041780e0$var$DropdownMenuItemGroup = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ children: children, id: id, isList: isList, isScrollable: isScrollable, title: title, testId: testId, hasSeparator: hasSeparator, overrides: overrides, ...rest }, ref)=>{
    const uid = (0, $ki32l.useId)();
    const titleId = `dropdown-menu-item-group-title-${uid}`;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8BKky.default), {
        id: id,
        ref: ref,
        isList: isList,
        isScrollable: isScrollable,
        hasSeparator: hasSeparator,
        testId: testId,
        titleId: title ? titleId : undefined,
        // eslint-disable-next-line @repo/internal/react/no-unsafe-overrides, @atlaskit/design-system/no-deprecated-apis
        overrides: overrides,
        ...rest
    }, title && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $lmkW0.default), {
        id: titleId,
        title: title
    }), children);
});
var $920365f1041780e0$export$2e2bcd8739ae039 = $920365f1041780e0$var$DropdownMenuItemGroup;

});

parcelRegister("6JZkO", function(module, exports) {

$parcel$export(module.exports, "ErrorFlag", () => $c338baed813df983$export$518ba8e0e60f145f);

var $eUqFw = parcelRequire("eUqFw");

var $eo17r = parcelRequire("eo17r");
var $k8Qyf = parcelRequire("k8Qyf");

var $3Y2Y8 = parcelRequire("3Y2Y8");

var $5JgJ2 = parcelRequire("5JgJ2");

var $aCt1E = parcelRequire("aCt1E");
const $c338baed813df983$export$518ba8e0e60f145f = ({ id: id, errors: errors })=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const { dismissFlag: dismissFlag } = (0, $k8Qyf.useFlagsService)();
    const onDismissed = (0, $eUqFw.useCallback)(()=>dismissFlag(id), [
        dismissFlag,
        id
    ]);
    const description = (0, $eUqFw.useMemo)(()=>errors.reduce((desc, error)=>`${desc}\n${error}`), [
        errors
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $3Y2Y8.default), {
        id: (0, $eo17r.fromFlagId)(id),
        onDismissed: onDismissed,
        title: formatMessage((0, $aCt1E.default).flagTitle),
        description: description
    });
};

});
parcelRegister("3Y2Y8", function(module, exports) {

$parcel$export(module.exports, "default", () => $23cb4ade2efc0679$export$2e2bcd8739ae039);

var $kQ0RL = parcelRequire("kQ0RL");
var $23cb4ade2efc0679$export$2e2bcd8739ae039 = (0, $kQ0RL.ErrorFlag);

});

parcelRegister("aCt1E", function(module, exports) {

$parcel$export(module.exports, "default", () => $0995f9c4fca26c6a$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $0995f9c4fca26c6a$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    flagTitle: {
        "id": "issue-navigator-actions-common.error-flag.flag-title",
        "defaultMessage": "Filter couldn't be saved"
    }
});

});


parcelRegister("hZPqL", function(module, exports) {

$parcel$export(module.exports, "SuccessFlag", () => $eb5b20020abc7bb0$export$93bd4963a1d00fd5);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $guiFP = parcelRequire("guiFP");

var $eo17r = parcelRequire("eo17r");
var $k8Qyf = parcelRequire("k8Qyf");

var $Gz4Lz = parcelRequire("Gz4Lz");

var $5JgJ2 = parcelRequire("5JgJ2");

var $jMP2a = parcelRequire("jMP2a");

var $iUwiu = parcelRequire("iUwiu");
const $eb5b20020abc7bb0$export$93bd4963a1d00fd5 = ({ id: id, filterName: filterName, viewUrl: viewUrl, analyticsEvent: analyticsEvent })=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const { dismissFlag: dismissFlag } = (0, $k8Qyf.useFlagsService)();
    const [isCopied, setCopied] = (0, $eUqFw.useState)(false);
    (0, $eUqFw.useEffect)(()=>{
        let timeoutId;
        if (isCopied) timeoutId = setTimeout(()=>{
            setCopied(false);
        }, 2000);
        return ()=>{
            timeoutId && clearTimeout(timeoutId);
        };
    }, [
        isCopied
    ]);
    const copyToClipboard = (0, $eUqFw.useCallback)(()=>{
        try {
            navigator.clipboard.writeText(viewUrl);
            setCopied(true);
            (0, $jMP2a.fireUIAnalytics)(analyticsEvent, 'copyLink');
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (error) {
            (0, $guiFP.default)({
                error: error,
                meta: {
                    id: 'copyToClipboard',
                    packageName: 'jiraIssueNavigatorActionsCommon'
                }
            });
        }
    }, [
        analyticsEvent,
        viewUrl
    ]);
    const actions = (0, $eUqFw.useMemo)(()=>{
        const flagActions = [];
        flagActions.push({
            content: isCopied ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($eb5b20020abc7bb0$var$CopySuccess, null, formatMessage((0, $iUwiu.default).copyActionCopied)) : formatMessage((0, $iUwiu.default).copyAction),
            onClick: copyToClipboard
        });
        return flagActions;
    }, [
        copyToClipboard,
        formatMessage,
        isCopied
    ]);
    const onDismissed = (0, $eUqFw.useCallback)(()=>dismissFlag(id), [
        dismissFlag,
        id
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $Gz4Lz.default), {
        id: (0, $eo17r.fromFlagId)(id),
        onDismissed: onDismissed,
        title: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($eb5b20020abc7bb0$var$WordBreakSpan, null, formatMessage((0, $iUwiu.default).flagTitle, {
            name: filterName
        })),
        description: formatMessage((0, $iUwiu.default).flagDescription),
        actions: actions
    });
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $eb5b20020abc7bb0$var$CopySuccess = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_syazocqs",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $eb5b20020abc7bb0$var$WordBreakSpan = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1nmz1hna",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
const $eb5b20020abc7bb0$export$7ed12d2a5241e393 = {
    WordBreakSpan: $eb5b20020abc7bb0$var$WordBreakSpan
};

});
parcelRegister("Gz4Lz", function(module, exports) {

$parcel$export(module.exports, "default", () => $1273ecbdbcfe24cd$export$2e2bcd8739ae039);

var $kQ0RL = parcelRequire("kQ0RL");
var $1273ecbdbcfe24cd$export$2e2bcd8739ae039 = (0, $kQ0RL.SuccessFlag);

});

parcelRegister("iUwiu", function(module, exports) {

$parcel$export(module.exports, "default", () => $a18514a929def759$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $a18514a929def759$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    flagTitle: {
        "id": "issue-navigator-actions-common.success-flag.flag-title",
        "defaultMessage": "\"{name}\" filter saved"
    },
    flagDescription: {
        "id": "issue-navigator-actions-common.success-flag.flag-description",
        "defaultMessage": "We\u2019ve saved this filter successfully."
    },
    viewAction: {
        "id": "issue-navigator-actions-common.success-flag.view-action",
        "defaultMessage": "View filter"
    },
    copyAction: {
        "id": "issue-navigator-actions-common.success-flag.copy-action",
        "defaultMessage": "Copy link"
    },
    copyActionCopied: {
        "id": "issue-navigator-actions-common.success-flag.copy-action-copied",
        "defaultMessage": "Copied"
    }
});

});


parcelRegister("iqKE7", function(module, exports) {

$parcel$export(module.exports, "AsyncSaveFilterDialogContent", () => $5e58e676a807fa79$export$e0d40cb0f88fa57d);

var $eUqFw = parcelRequire("eUqFw");

var $7rh0R = parcelRequire("7rh0R");

var $gGtKh = parcelRequire("gGtKh");

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $5e58e676a807fa79$var$SaveFilterDialogContent = (0, $7rh0R.lazyAfterPaint)(()=>(parcelRequire("8codH")), {
    ssr: false,
    moduleId: "./src/packages/issue-navigator/save-filter-dialog/src/ui/save-filter-dialog/save-filter-dialog-content/index.tsx"
});
const $5e58e676a807fa79$export$e0d40cb0f88fa57d = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gGtKh.default), {
        name: "async-save-filters-dialog-content",
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($5e58e676a807fa79$var$SaveFilterDialogContent, props));

});
parcelRegister("8codH", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = Promise.all([
    $d1Cng("hPzOn"),
    $d1Cng("h2MrD"),
    $d1Cng("bYT2S"),
    $d1Cng("95k46")
]).then(()=>parcelRequire('7Vs69'));

});


parcelRegister("30zCP", function(module, exports) {

$parcel$export(module.exports, "default", () => $e168f88652a1d6a7$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $1HzcR = parcelRequire("1HzcR");

var $6j4bv = parcelRequire("6j4bv");

var $jVAsY = parcelRequire("jVAsY");
const $e168f88652a1d6a7$var$runtimeProps = {};
const $e168f88652a1d6a7$var$entryPointParams = {};
const $e168f88652a1d6a7$var$AsyncThirdPartyNudge = ()=>{
    const { entryPointActions: entryPointActions, entryPointReferenceSubject: entryPointReferenceSubject } = (0, $6j4bv.useEntryPoint)((0, $jVAsY.thirdPartyNudgeEntryPoint), $e168f88652a1d6a7$var$entryPointParams);
    // eslint-disable-next-line @atlassian/react-entrypoint/no-load-in-hooks
    (0, $eUqFw.useEffect)(()=>{
        entryPointActions.load();
    }, [
        entryPointActions
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1HzcR.JiraEntryPointContainer), {
        id: "third-party-nudge-spotlight",
        packageName: "third-party-nudge",
        entryPointReferenceSubject: entryPointReferenceSubject,
        runtimeProps: $e168f88652a1d6a7$var$runtimeProps,
        errorFallback: "unmount"
    });
};
var $e168f88652a1d6a7$export$2e2bcd8739ae039 = $e168f88652a1d6a7$var$AsyncThirdPartyNudge;

});
parcelRegister("jVAsY", function(module, exports) {

$parcel$export(module.exports, "thirdPartyNudgeEntryPoint", () => $c2947bce8d5fa853$export$b751b31b276f613a);

var $53Hxw = parcelRequire("53Hxw");

var $artI2 = parcelRequire("artI2");

const $c2947bce8d5fa853$export$b751b31b276f613a = (0, $artI2.createEntryPoint)({
    root: (0, $53Hxw.JSResourceForInteraction)(()=>(parcelRequire("2kcJA")), {
        moduleId: "3cb7fd8f"
    }),
    getPreloadProps: ()=>({})
});

});
parcelRegister("2kcJA", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = Promise.all([
    $d1Cng("2hmUs"),
    $d1Cng("bCeK4"),
    $d1Cng("h2MrD"),
    $d1Cng("bYT2S"),
    $d1Cng("hPzOn"),
    $d1Cng("hpb4o")
]).then(()=>parcelRequire('eslmU'));

});



parcelRegister("15Iby", function(module, exports) {

$parcel$export(module.exports, "default", () => $d2566ce00f75555f$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $d2566ce00f75555f$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    saveFilter: {
        "id": "issue-navigator-custom-filters.save-filter-dropdown.save-filter",
        "defaultMessage": "Save filter"
    },
    saveChanges: {
        "id": "issue-navigator-custom-filters.save-filter-dropdown.save-changes",
        "defaultMessage": "Save changes"
    },
    saveAsACopy: {
        "id": "issue-navigator-custom-filters.save-filter-dropdown.save-as-a-copy",
        "defaultMessage": "Save as a copy"
    },
    copyFilterDialogTitle: {
        "id": "issue-navigator-custom-filters.save-filter-dropdown.copy-filter-dialog-title",
        "defaultMessage": "Copy filter"
    }
});

});


parcelRegister("4YE75", function(module, exports) {

$parcel$export(module.exports, "useIntegrateDotDialogContext", () => $83eabdb2c34080b3$export$705d46354f301b1c);
$parcel$export(module.exports, "ShortcutsDialogIntegrationProvider", () => $83eabdb2c34080b3$export$97e3ca22c7078b46);

var $eUqFw = parcelRequire("eUqFw");
const $83eabdb2c34080b3$var$PRESET_VALUE = {
    DEFAULT: {
        isShortcutsDialogIntegrationAvailable: false
    },
    INTEGRATED: {
        isShortcutsDialogIntegrationAvailable: true
    }
};
const $83eabdb2c34080b3$var$IntegrateDotDialogContext = /*#__PURE__*/ (0, $eUqFw.createContext)($83eabdb2c34080b3$var$PRESET_VALUE.DEFAULT);
const $83eabdb2c34080b3$export$705d46354f301b1c = ()=>(0, $eUqFw.useContext)($83eabdb2c34080b3$var$IntegrateDotDialogContext);
const $83eabdb2c34080b3$export$97e3ca22c7078b46 = ({ children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($83eabdb2c34080b3$var$IntegrateDotDialogContext.Provider, {
        value: $83eabdb2c34080b3$var$PRESET_VALUE.INTEGRATED
    }, children);

});

parcelRegister("9nyrN", function(module, exports) {

$parcel$export(module.exports, "JQLBuilderErrorBoundryFallback", () => $315a69b85d231334$export$4c766016a5659721);

var $eUqFw = parcelRequire("eUqFw");

var $7u4fN = parcelRequire("7u4fN");

var $lRvnl = parcelRequire("lRvnl");

var $5JgJ2 = parcelRequire("5JgJ2");

var $ca8j6 = parcelRequire("ca8j6");
const $315a69b85d231334$var$onRefresh = ()=>{
    if (typeof window !== 'undefined') window.location.reload();
};
const $315a69b85d231334$export$4c766016a5659721 = ()=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $lRvnl.default), {
        appearance: "error",
        testId: "jql-builder-common.ui.error-boundry-fallback.section-message"
    }, formatMessage((0, $ca8j6.default).errorMessage, {
        link: (linkText)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7u4fN.default), {
                appearance: "link",
                spacing: "none",
                onClick: $315a69b85d231334$var$onRefresh
            }, linkText)
    }));
};

});
parcelRegister("ca8j6", function(module, exports) {

$parcel$export(module.exports, "default", () => $23d3bbe30a896926$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $23d3bbe30a896926$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    errorMessage: {
        "id": "jql-builder-common.error-boundry-fallback.error-message",
        "defaultMessage": "We couldn't load your search criteria. <link>Refresh the page</link> to try again."
    }
});

});


parcelRegister("bmfQK", function(module, exports) {

$parcel$export(module.exports, "default", () => $125fdf7977b70517$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $7rh0R = parcelRequire("7rh0R");

var $gGtKh = parcelRequire("gGtKh");

var $9Yk2t = parcelRequire("9Yk2t");

const $125fdf7977b70517$var$JQLBuilderWithAIAsync = (0, $7rh0R.lazyForPaint)(()=>(parcelRequire("l0wc8")), {
    moduleId: "./src/packages/jql-builder/with-ai/src/index.tsx"
});
const $125fdf7977b70517$var$JQLBuilderWithAI = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gGtKh.default), {
        name: "async-jql-builder-with-ai",
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $9Yk2t.IssueNavigatorJQLBuilderSkeleton), null)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($125fdf7977b70517$var$JQLBuilderWithAIAsync, props));
var $125fdf7977b70517$export$2e2bcd8739ae039 = $125fdf7977b70517$var$JQLBuilderWithAI;

});
parcelRegister("9Yk2t", function(module, exports) {

$parcel$export(module.exports, "IssueNavigatorJQLBuilderSkeleton", () => $2f16dd0eb8999180$export$5be82223ddc28851);
/* jql-builder.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $7JEyt = parcelRequire("7JEyt");

var $eUqFw = parcelRequire("eUqFw");

var $8ICxF = parcelRequire("8ICxF");

var $gk7BR = parcelRequire("gk7BR");
const $2f16dd0eb8999180$var$customCssStyles = null;
const $2f16dd0eb8999180$var$containerStyles = {
    height: '52px'
};
const $2f16dd0eb8999180$export$5be82223ddc28851 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8ICxF.AppSkeletonImage), {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($gk7BR))),
        containerStyles: $2f16dd0eb8999180$var$containerStyles,
        className: (0, $7JEyt.default)([
            "_1wgmglyw"
        ])
    });

});
parcelRegister("gk7BR", function(module, exports) {
module.exports = new URL("issue-navigator-jql-builder-skeleton.tpl.20beba3c.svg", import.meta.url).toString();

});


parcelRegister("l0wc8", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = Promise.all([
    $d1Cng("h2MrD"),
    $d1Cng("bYT2S"),
    $d1Cng("2hmUs"),
    $d1Cng("bCeK4"),
    $d1Cng("hPzOn"),
    $d1Cng("1PcxX")
]).then(()=>parcelRequire('4jxSo'));

});


parcelRegister("koU5J", function(module, exports) {

$parcel$export(module.exports, "AsyncSaveFilterDialog", () => $d84a4fd590a13eb3$export$2213da0eee0aa8f);

var $eUqFw = parcelRequire("eUqFw");

var $7rh0R = parcelRequire("7rh0R");

var $7u4fN = parcelRequire("7u4fN");

var $gGtKh = parcelRequire("gGtKh");

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $d84a4fd590a13eb3$var$SaveFilterDialog = (0, $7rh0R.lazyAfterPaint)(()=>(parcelRequire("9w70D")), {
    ssr: false,
    moduleId: "./src/packages/issue-navigator/save-filter-dialog/src/ui/save-filter-dialog/main.tsx"
});
const $d84a4fd590a13eb3$export$2213da0eee0aa8f = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gGtKh.default), {
        name: "save-filters-dialog",
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7u4fN.default), {
            appearance: "link",
            isDisabled: true
        }, props.buttonText)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($d84a4fd590a13eb3$var$SaveFilterDialog, props));

});
parcelRegister("9w70D", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = $d1Cng("hv5Q6").then(()=>parcelRequire('1IGnv'));

});


parcelRegister("jhYi6", function(module, exports) {

$parcel$export(module.exports, "useJqlSearch", () => $66794e0241f9da0f$export$e69d0de2e354a2cb);

var $eUqFw = parcelRequire("eUqFw");

var $3mEVr = parcelRequire("3mEVr");

var $cQBUE = parcelRequire("cQBUE");
const $66794e0241f9da0f$export$e69d0de2e354a2cb = (changeJql)=>{
    const query = (0, $3mEVr.useResolvedJql)();
    const { onIssueSearch: onIssueSearch } = (0, $cQBUE.useIssueSearchQuery)();
    const onSearch = (0, $eUqFw.useCallback)((jql)=>{
        if (jql === query) // This will execute a new search against the network with current JQL input arguments
        onIssueSearch();
        else changeJql && changeJql(jql);
    }, [
        query,
        onIssueSearch,
        changeJql
    ]);
    return {
        onSearch: onSearch,
        query: query
    };
};

});

parcelRegister("1iCRE", function(module, exports) {

$parcel$export(module.exports, "useJqlSearchStatus", () => $9cfafdf73b327933$export$6d36bd77a6aeafd9);

var $1oZFL = parcelRequire("1oZFL");

var $eUqFw = parcelRequire("eUqFw");

var $iWLL0 = parcelRequire("iWLL0");

var $guiFP = parcelRequire("guiFP");

var $bBGpO = parcelRequire("bBGpO");

var $5JgJ2 = parcelRequire("5JgJ2");

var $jMP2a = parcelRequire("jMP2a");
var $bFzGY = parcelRequire("bFzGY");

var $dWLk9 = parcelRequire("dWLk9");

var $eUeMJ = parcelRequire("eUeMJ");
const $9cfafdf73b327933$export$529d2e9d8e9d3cad = 2000; // wait 2s before making the request
const $9cfafdf73b327933$export$bbec15ef0a4926b6 = 7000; // wait 7s before retrying after the previous request
const $9cfafdf73b327933$export$cf31b3fd6a57249f = 5; // Check the status no more than 5 times for the same JQL search
const $9cfafdf73b327933$export$2b91517d6d5b4365 = (0, $1oZFL.default);
const $9cfafdf73b327933$var$statusToMessages = (status, formatMessage)=>{
    if (status == null || !('functions' in status) || !Array.isArray(status?.functions)) return [];
    const processing = status.functions.filter((fn)=>fn.app && fn.function && fn.status === 'PROCESSING');
    const functions = Array.from(new Set(processing.map((fn)=>fn.function)));
    const apps = Array.from(new Set(processing.map((fn)=>fn.app)));
    switch(functions.length){
        case 0:
            return [];
        case 1:
            {
                const message = formatMessage((0, $eUeMJ.default).singleSlowForgeFunction, {
                    functionName: functions[0],
                    appName: apps[0]
                });
                return [
                    {
                        type: 'info',
                        message: message
                    }
                ];
            }
        default:
            {
                let message;
                switch(apps.length){
                    case 1:
                        message = formatMessage((0, $eUeMJ.default).multipleSlowForgeFunctionsFromTheSameApp, {
                            appName: apps[0]
                        });
                        break;
                    case 2:
                        message = formatMessage((0, $eUeMJ.default).multipleSlowForgeFunctionsTwoApps, {
                            appName1: apps[0],
                            appName2: apps[1]
                        });
                        break;
                    default:
                        message = formatMessage((0, $eUeMJ.default).multipleSlowForgeFunctionsThreeApps, {
                            appName1: apps[0],
                            appName2: apps[1],
                            appName3: apps[2]
                        });
                }
                return [
                    {
                        type: 'info',
                        message: message
                    }
                ];
            }
    }
};
const $9cfafdf73b327933$var$analyticsMeta = {
    id: 'jqlSearchStatus',
    packageName: 'jiraIssueNavigator',
    teamName: 'empanada'
};
const $9cfafdf73b327933$export$6d36bd77a6aeafd9 = ({ query: query, isSearching: isSearching })=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const [statusMessages, setStatusMessages] = (0, $eUqFw.useState)([]);
    const isSearchingRef = (0, $eUqFw.useRef)(isSearching);
    const timeoutRef = (0, $eUqFw.useRef)(null);
    const fetchCountRef = (0, $eUqFw.useRef)(0);
    const environment = (0, $iWLL0.useRelayEnvironment)();
    const cloudId = (0, $dWLk9.useCloudId)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bFzGY.useAnalyticsEvents)();
    const fireOperationalEvent = (0, $eUqFw.useCallback)((action, attributes)=>(0, $jMP2a.fireOperationalAnalytics)(createAnalyticsEvent({}), `${$9cfafdf73b327933$var$analyticsMeta.packageName}.${$9cfafdf73b327933$var$analyticsMeta.id} ${action}`, attributes), [
        createAnalyticsEvent
    ]);
    const cancelPendingOperations = (0, $eUqFw.useCallback)(()=>{
        timeoutRef.current && clearTimeout(timeoutRef.current);
        timeoutRef.current = null;
        fetchCountRef.current = 0;
    }, []);
    const scheduleSearchStatusFetch = (0, $eUqFw.useCallback)((delay)=>{
        const isRetry = delay === $9cfafdf73b327933$export$bbec15ef0a4926b6;
        const defaultAnalyticsAttributes = (0, $bBGpO.createAttributes)({
            isRetry: isRetry
        });
        const timeout = setTimeout(()=>{
            if (fetchCountRef.current >= $9cfafdf73b327933$export$cf31b3fd6a57249f) {
                fireOperationalEvent('interrupted', {
                    ...defaultAnalyticsAttributes,
                    reason: 'MAX_ATTEMPTS_REACHED'
                });
                return;
            }
            fireOperationalEvent('attempt', defaultAnalyticsAttributes);
            fetchCountRef.current += 1;
            (0, $iWLL0.fetchQuery)(environment, $9cfafdf73b327933$export$2b91517d6d5b4365, {
                cloudId: cloudId,
                jql: query
            }, {
                fetchPolicy: 'network-only'
            }).toPromise().then((data)=>{
                let hasPendingFn = false;
                const status = data?.jira?.issueSearchStatus ?? null;
                if (isSearchingRef.current && timeoutRef.current === timeout) {
                    const infos = $9cfafdf73b327933$var$statusToMessages(status, formatMessage);
                    setStatusMessages(infos);
                    if (infos.length) {
                        hasPendingFn = true;
                        scheduleSearchStatusFetch($9cfafdf73b327933$export$bbec15ef0a4926b6);
                    }
                }
                fireOperationalEvent('finished', {
                    ...defaultAnalyticsAttributes,
                    hasPendingFn: hasPendingFn
                });
            }).catch((error)=>{
                (0, $guiFP.default)({
                    meta: $9cfafdf73b327933$var$analyticsMeta,
                    attributes: (0, $bBGpO.createAttributes)({
                        error: error,
                        isRetry: isRetry
                    })
                });
                if (isSearchingRef.current && timeoutRef.current === timeout) scheduleSearchStatusFetch($9cfafdf73b327933$export$bbec15ef0a4926b6);
            });
        }, delay);
        timeoutRef.current = timeout;
    }, [
        cloudId,
        environment,
        fireOperationalEvent,
        formatMessage,
        query
    ]);
    (0, $eUqFw.useEffect)(()=>{
        isSearchingRef.current = isSearching;
    }, [
        isSearching
    ]);
    (0, $eUqFw.useEffect)(()=>{
        setStatusMessages([]);
        cancelPendingOperations();
        if (isSearching) scheduleSearchStatusFetch($9cfafdf73b327933$export$529d2e9d8e9d3cad);
    }, [
        isSearching,
        query,
        cancelPendingOperations,
        scheduleSearchStatusFetch
    ]);
    return (0, $eUqFw.useMemo)(()=>({
            messages: statusMessages
        }), [
        statusMessages
    ]);
};

});
parcelRegister("1oZFL", function(module, exports) {

$parcel$export(module.exports, "default", () => $4af6e61027191353$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<06f329a4787d481a42a4c55f0b801953>>
 * @relayHash 7d47bdaa4d5aeb847704c6e13c25fd58
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 8e680ef9e6d909ed43bf02677fe95ccafcad565518b3a659febcd16aa4f5bbd8
const $4af6e61027191353$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "cloudId"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "jql"
        }
    ], v1 = [
        {
            "concreteType": "JiraQuery",
            "kind": "LinkedField",
            "name": "jira",
            "plural": false,
            "selections": [
                {
                    "args": [
                        {
                            "kind": "Variable",
                            "name": "cloudId",
                            "variableName": "cloudId"
                        },
                        {
                            "kind": "Variable",
                            "name": "jql",
                            "variableName": "jql"
                        }
                    ],
                    "concreteType": "JiraIssueSearchStatus",
                    "kind": "LinkedField",
                    "name": "issueSearchStatus",
                    "plural": false,
                    "selections": [
                        {
                            "concreteType": "JiraJqlFunctionProcessingStatus",
                            "kind": "LinkedField",
                            "name": "functions",
                            "plural": true,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "status"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "function"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "app"
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "jqlSearchStatus_Query",
            "selections": v1 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "jqlSearchStatus_Query",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "id": "8e680ef9e6d909ed43bf02677fe95ccafcad565518b3a659febcd16aa4f5bbd8",
            "metadata": {},
            "name": "jqlSearchStatus_Query",
            "operationKind": "query",
            "text": null
        }
    };
}();
$4af6e61027191353$var$node.hash = "9dd1bed08ceb0d25df132f36097ae6d1";
var $4af6e61027191353$export$2e2bcd8739ae039 = $4af6e61027191353$var$node;

});

parcelRegister("eUeMJ", function(module, exports) {

$parcel$export(module.exports, "default", () => $9e3bc230e6b13e32$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $9e3bc230e6b13e32$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    singleSlowForgeFunction: {
        "id": "issue-navigator.controllers.jql-search-status.single-slow-forge-function",
        "defaultMessage": "{appName} is still executing the {functionName} JQL function."
    },
    multipleSlowForgeFunctionsFromTheSameApp: {
        "id": "issue-navigator.controllers.jql-search-status.multiple-slow-forge-functions-from-the-same-app",
        "defaultMessage": "{appName} is still executing multiple JQL functions."
    },
    multipleSlowForgeFunctionsTwoApps: {
        "id": "issue-navigator.controllers.jql-search-status.multiple-slow-forge-functions-two-apps",
        "defaultMessage": "{appName1} and {appName2} are still executing multiple JQL functions."
    },
    multipleSlowForgeFunctionsThreeApps: {
        "id": "issue-navigator.controllers.jql-search-status.multiple-slow-forge-functions-three-apps",
        "defaultMessage": "{appName1}, {appName2}, and {appName3} are still executing multiple JQL functions."
    }
});

});


parcelRegister("lvtWa", function(module, exports) {

$parcel$export(module.exports, "default", () => $c0bec88e3bc2ce5b$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $c0bec88e3bc2ce5b$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    saveFilterButton: {
        "id": "issue-navigator.jql-builder.save-filter-button",
        "defaultMessage": "Save filter"
    },
    saveFilterDialogTitle: {
        "id": "issue-navigator.jql-builder.save-filter-dialog-title",
        "defaultMessage": "Save filter"
    },
    copyFilterButton: {
        "id": "issue-navigator.jql-builder.copy-filter-button",
        "defaultMessage": "Copy filter"
    },
    copyFilterDialogTitle: {
        "id": "issue-navigator.jql-builder.copy-filter-dialog-title",
        "defaultMessage": "Copy filter"
    }
});

});

parcelRegister("ky48h", function(module, exports) {

$parcel$export(module.exports, "NoOptionsMessage", () => $0d80a3e896d1d6ab$export$d58b72b7d3c4072c);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $7JEyt = parcelRequire("7JEyt");

var $eUqFw = parcelRequire("eUqFw");

var $96IgR = parcelRequire("96IgR");

var $b5IAe = parcelRequire("b5IAe");
var $1ZAYh = parcelRequire("1ZAYh");


var $5JgJ2 = parcelRequire("5JgJ2");

var $l6liB = parcelRequire("l6liB");
const $0d80a3e896d1d6ab$export$d58b72b7d3c4072c = ()=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
        xcss: $0d80a3e896d1d6ab$var$boxStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
        className: (0, $7JEyt.default)([
            "_otyru2gc _w8l5t9kd _1752t9kd"
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($96IgR))), {
        primaryColor: `var(--ds-icon-subtle, ${(0, $73a5c9d720aa66e1$export$f563ee71e9ee74cd)})`,
        label: ""
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("p", {
        className: (0, $7JEyt.default)([
            "_18s861nu _1i4qfg65"
        ])
    }, formatMessage((0, $l6liB.default).fieldNotFoundMessage)));
};
const $0d80a3e896d1d6ab$var$boxStyles = (0, $1ZAYh.xcss)({
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    paddingTop: 'space.100',
    paddingLeft: 'space.250',
    paddingRight: 'space.250',
    paddingBottom: 'space.100',
    color: 'color.text.subtle',
    textAlign: 'center'
});
const $0d80a3e896d1d6ab$var$titleStyles = null;
const $0d80a3e896d1d6ab$var$iconContainerStyles = null;

});
parcelRegister("l6liB", function(module, exports) {

$parcel$export(module.exports, "default", () => $786821dc27223105$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $786821dc27223105$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    fieldNotFoundMessage: {
        "id": "issue-navigator.jql-builder.no-options-message.field-not-found-message",
        "defaultMessage": "We couldn't find the field you are looking for."
    }
});

});


parcelRegister("lxqp4", function(module, exports) {

$parcel$export(module.exports, "default", () => $24e7033b9949a5f8$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $7u4fN = parcelRequire("7u4fN");

var $5JgJ2 = parcelRequire("5JgJ2");

var $jMP2a = parcelRequire("jMP2a");

var $9szUL = parcelRequire("9szUL");
const $24e7033b9949a5f8$export$2491f201e3dd9acf = ({ onReset: onReset, isResetToFilter: isResetToFilter = false })=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const handleOnReset = (0, $eUqFw.useCallback)((mouseEvent, analyticsEvent)=>{
        (0, $jMP2a.fireUIAnalytics)(analyticsEvent, isResetToFilter ? 'goBackToFilterButton' : 'resetButton', {
            // If number of clicks is 0, button was actioned using the keyboard
            keyboard: mouseEvent.detail === 0
        });
        onReset && onReset(isResetToFilter);
    }, [
        onReset,
        isResetToFilter
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($24e7033b9949a5f8$var$ResetButtonContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7u4fN.default), {
        testId: "issue-navigator.ui.jql-builder.reset-button",
        appearance: "subtle-link",
        onClick: handleOnReset
    }, formatMessage(isResetToFilter ? (0, $9szUL.default).goBackToFilterButtonText : (0, $9szUL.default).resetButtonText)));
};
var $24e7033b9949a5f8$export$2e2bcd8739ae039 // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
 = $24e7033b9949a5f8$export$2491f201e3dd9acf;
const $24e7033b9949a5f8$var$ResetButtonContainer = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _16jlidpf _1o9zkb7n _i0dlf1ug _p12fuuw1 _4cvr1h6o _4t3izwfg _19pk1b66",
            __cmplp.className
        ])
    });
});

});
parcelRegister("9szUL", function(module, exports) {

$parcel$export(module.exports, "default", () => $79b1f16661332645$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $79b1f16661332645$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    resetButtonText: {
        "id": "issue-navigator.jql-builder.reset-button.reset-button-text",
        "defaultMessage": "Reset"
    },
    goBackToFilterButtonText: {
        "id": "issue-navigator.jql-builder.reset-button.go-back-to-filter-button-text",
        "defaultMessage": "Go back to filter"
    }
});

});


parcelRegister("fIVib", function(module, exports) {

$parcel$export(module.exports, "useJqlBuilderInstrumentation", () => $d3279b7fae25be36$export$42691712ca1334f9);

var $eUqFw = parcelRequire("eUqFw");

var $jBY8A = parcelRequire("jBY8A");

var $cWCvn = parcelRequire("cWCvn");
const $d3279b7fae25be36$export$42691712ca1334f9 = ()=>{
    const [finished, setFinished] = (0, $eUqFw.useState)(false);
    return (0, $eUqFw.useMemo)(()=>({
            startJqlBuilderMetric: ()=>{
                if (finished) return;
                (0, $cWCvn.NINJqlBuilderAsyncLoad).start();
            },
            stopJqlBuilderMetric: ()=>{
                setFinished(true);
                (0, $cWCvn.NINJqlBuilderAsyncLoad).stop({
                    customData: {
                        ...(0, $jBY8A.getIssueNavigatorFFAndFG)()
                    }
                });
            },
            markJqlBuilderMetric: (mark)=>{
                if (finished) return;
                (0, $cWCvn.markOnce)(mark);
            }
        }), [
        finished
    ]);
};

});
parcelRegister("jBY8A", function(module, exports) {

$parcel$export(module.exports, "getIssueNavigatorFFAndFG", () => $46fac0cd0242a9cb$export$f94cc81069819a21);

var $1ybV0 = parcelRequire("1ybV0");

var $eI5EY = parcelRequire("eI5EY");

var $9175S = parcelRequire("9175S");
const $46fac0cd0242a9cb$export$f94cc81069819a21 = ()=>({
        isCohorted: (0, $1ybV0.ff)('nin.global-scope_aqec8'),
        isTableRedesignEnabled: (0, $1ybV0.ff)('jsv-one-issue-table-spreadsheet-ui_ygrnf'),
        isNinExposeTextOption: (0, $1ybV0.ff)('nin_expose_text_option_jql_builder_4kwzo'),
        isNinIssueLinksFieldNativeCellEnabled: (0, $1ybV0.ff)('extend-popup-cell-with-custom-override-content-and-parameters_obikd'),
        isNinShowFieldOptionsAsOnlyUnselectableEnabled: (0, $1ybV0.ff)('nin-show-field-options-as-only-unselectable_0s1y2'),
        isNinShowOutOfContextFieldsAsOnlyUnselectableEnabled: (0, $1ybV0.ff)('nin-enable-show-out-of-context-fields-as-only-unselectable_lmsy7'),
        isJqlBuilderTextSearchInputConcurrencyFix: (0, $9175S.isJqlBuilderTextSearchInputConcurrencyFix)(),
        isJqlBuilderLoadBasicSync: (0, $eI5EY.fg)('jql-builder-load-basic-sync'),
        isJscM1ApiUpdatesEnabled: (0, $eI5EY.fg)('jira_spreadsheet_component_m1_api_updates'),
        isNinIssueSearchSwitchToJsisEnabled: (0, $eI5EY.fg)('nin_issue_search_switch_to_jsis_fg')
    });

});
parcelRegister("9175S", function(module, exports) {

$parcel$export(module.exports, "isJqlBuilderTextSearchInputConcurrencyFix", () => $83e2106daafc35b3$export$319ce6ab927c317f);

var $1ybV0 = parcelRequire("1ybV0");

var $eI5EY = parcelRequire("eI5EY");
const $83e2106daafc35b3$export$319ce6ab927c317f = ()=>(0, $1ybV0.ff)('nin_expose_text_option_jql_builder_4kwzo') && (0, $eI5EY.fg)('jql-builder-text-search-input-concurrency-fix');

});



parcelRegister("9Vqzg", function(module, exports) {

$parcel$export(module.exports, "isOnlyJqlAndDifferentToDefault", () => $b7aa2d396541c474$export$3cfc4f52186efe7d);
$parcel$export(module.exports, "isOnlyFilterAndDifferentToDefault", () => $b7aa2d396541c474$export$933470cfeba275aa);
$parcel$export(module.exports, "filterAndJqlIsTheSameAndDifferentToDefault", () => $b7aa2d396541c474$export$a25fc74cc3fc7015);
$parcel$export(module.exports, "jqlIsDifferentToFilter", () => $b7aa2d396541c474$export$7dfcf59726e2b396);
$parcel$export(module.exports, "isFilterJqlModified", () => $b7aa2d396541c474$export$d3d543997ba807);
const $b7aa2d396541c474$export$3cfc4f52186efe7d = (jqlParam, defaultJqlTerm, filterParam)=>filterParam === undefined && jqlParam !== undefined && jqlParam.toLowerCase() !== defaultJqlTerm.toLowerCase();
const $b7aa2d396541c474$export$933470cfeba275aa = (jqlParam, defaultJqlTerm, filterJqlTerm)=>filterJqlTerm !== undefined && jqlParam === undefined && filterJqlTerm.toLowerCase() !== defaultJqlTerm.toLowerCase();
const $b7aa2d396541c474$export$a25fc74cc3fc7015 = (jqlParam, defaultJqlTerm, filterJqlTerm)=>jqlParam !== undefined && filterJqlTerm !== undefined && jqlParam.toLowerCase() === filterJqlTerm.toLowerCase() && filterJqlTerm.toLowerCase() !== defaultJqlTerm.toLowerCase();
const $b7aa2d396541c474$export$7dfcf59726e2b396 = (jqlParam, filterJqlTerm)=>jqlParam !== undefined && filterJqlTerm !== undefined && filterJqlTerm.toLowerCase() !== jqlParam.toLowerCase();
const $b7aa2d396541c474$export$d3d543997ba807 = ({ query: query, filterJql: filterJql })=>filterJql !== undefined && query.toLowerCase().trim() !== filterJql.toLowerCase().trim();

});


parcelRegister("5nM3q", function(module, exports) {

$parcel$export(module.exports, "default", () => $8036252460072f62$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $8036252460072f62$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    screenReaderSearchResultInfo: {
        "id": "issue-navigator.screen-reader-search-result-info",
        "defaultMessage": "{total, plural, one {One issue matches your search.} other {{total} issues match your search.}}"
    },
    screenReaderSearchResultMoreInfo: {
        "id": "issue-navigator.screen-reader-search-result-more-info",
        "defaultMessage": "{total, plural, one {{total} or more issues found} other {{total} or more issues found}}."
    }
});

});

parcelRegister("fWUVl", function(module, exports) {

$parcel$export(module.exports, "default", () => $ab509f176aabbb45$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $gCtL7 = parcelRequire("gCtL7");

var $9aFSa = parcelRequire("9aFSa");

var $1ybV0 = parcelRequire("1ybV0");

var $jMP2a = parcelRequire("jMP2a");
var $bFzGY = parcelRequire("bFzGY");

var $7uVYl = parcelRequire("7uVYl");
const $ab509f176aabbb45$var$RegisterDotShortcut = ()=>{
    const [, { setShortcutsDialogVisibility: setShortcutsDialogVisibility }] = (0, $7uVYl.useShortcutsActions)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bFzGY.useAnalyticsEvents)();
    const { open: open } = (0, $gCtL7.useActionsCommandPalette)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $9aFSa.default), {
        keyMap: {
            '.': {
                callback: ()=>{
                    (0, $jMP2a.fireUIAnalytics)(createAnalyticsEvent({
                        action: 'pressed',
                        actionSubject: 'keyboardShortcut'
                    }), 'dotDialogKeyboardShortcut', {
                        keyPressed: '.',
                        keyboardShortcut: true
                    });
                    if ((0, $1ybV0.ff)('compal-dot-menu-shortcut-integration_dvvg2') && (0, $1ybV0.ff)('compal-sunset-and-remove-dot-menu_66j8q')) open();
                    else requestAnimationFrame(()=>setShortcutsDialogVisibility(true));
                }
            }
        }
    });
};
var $ab509f176aabbb45$export$2e2bcd8739ae039 = $ab509f176aabbb45$var$RegisterDotShortcut;

});
parcelRegister("gCtL7", function(module, exports) {

$parcel$export(module.exports, "useCommandPalette", () => $9139bfe8dcd2ea64$export$6b58f9610017fbb7);
$parcel$export(module.exports, "useActionsCommandPalette", () => $9139bfe8dcd2ea64$export$72aa7bc7c6a83c36);
$parcel$export(module.exports, "useCommandPaletteAnalyticsAttributes", () => $9139bfe8dcd2ea64$export$1f90c8f89f98110e);
$parcel$export(module.exports, "useCommandPaletteIsOpen", () => $9139bfe8dcd2ea64$export$cc979be9b69236df);
$parcel$export(module.exports, "useCommandPaletteHasChildPopup", () => $9139bfe8dcd2ea64$export$a18633b655403b12);
$parcel$export(module.exports, "useCommandPaletteIsLoaded", () => $9139bfe8dcd2ea64$export$af8fd8cd4b048315);
$parcel$export(module.exports, "useCommandPaletteSessionId", () => $9139bfe8dcd2ea64$export$7422170a403e909);
$parcel$export(module.exports, "useCommandPaletteExpandedCommand", () => $9139bfe8dcd2ea64$export$282aa48e4a3afada);
$parcel$export(module.exports, "useCommandPaletteSearch", () => $9139bfe8dcd2ea64$export$96819dfb22ad05d3);
$parcel$export(module.exports, "useCommandPaletteRegistryCurrentAttribution", () => $9139bfe8dcd2ea64$export$f893891deedab3c6);
$parcel$export(module.exports, "useCommandPaletteUsePerformModeState", () => $9139bfe8dcd2ea64$export$bbc05723eb144e03);

var $eUqFw = parcelRequire("eUqFw");

var $1yZQx = parcelRequire("1yZQx");
var $1jo4G = parcelRequire("1jo4G");
var $kEDjj = parcelRequire("kEDjj");

var $8FbYY = parcelRequire("8FbYY");

var $li0m0 = parcelRequire("li0m0");
const $9139bfe8dcd2ea64$var$initialState = {
    commandPaletteSessionId: '',
    isOpen: false,
    isLoaded: false,
    search: '',
    activeIndex: 0,
    isSearchFieldFocused: false,
    commands: [],
    parentCommand: [],
    sections: [],
    isDisabled: false,
    registry: {},
    activeRegistry: {
        commandRegistry: {},
        registryIds: []
    },
    onClosePendingCommandAction: undefined,
    isLoadChildrenError: false
};
const $9139bfe8dcd2ea64$var$store = (0, $kEDjj.createStore)({
    initialState: $9139bfe8dcd2ea64$var$initialState,
    actions: $li0m0.actions,
    name: 'commandPalette'
});
const $9139bfe8dcd2ea64$export$6b58f9610017fbb7 = (0, $1yZQx.createHook)($9139bfe8dcd2ea64$var$store);
const $9139bfe8dcd2ea64$export$72aa7bc7c6a83c36 = (0, $1yZQx.createActionsHook)($9139bfe8dcd2ea64$var$store);
const $9139bfe8dcd2ea64$export$e144a44b650635f4 = (ComponentToRender)=>(props)=>{
        const commandPalette = $9139bfe8dcd2ea64$export$6b58f9610017fbb7();
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(ComponentToRender, {
            ...props,
            commandPalette: commandPalette
        });
    };
const $9139bfe8dcd2ea64$export$56f06313122d0aac = ({ search: search, commandPaletteSessionId: commandPaletteSessionId, expandedCommand: expandedCommand, registry: registry, activeRegistry: activeRegistry })=>({
        wordCount: (0, $8FbYY.getWordCount)(search),
        queryLength: search.length,
        queryHash: (0, $8FbYY.getQueryHash)(search),
        commandPaletteSessionId: commandPaletteSessionId,
        cpMenu: expandedCommand?.id || 'rootMenu',
        ...(0, $8FbYY.getExpandedCommandRegistryAnalytics)(registry, activeRegistry, expandedCommand?.id) || {},
        activeRegistryIds: activeRegistry.registryIds,
        activeRegistryIdsLength: activeRegistry.registryIds.length,
        activeRegistryCommandsLength: Object.keys(activeRegistry.commandRegistry).length,
        relevancyModel: 'v2-string-similarity'
    });
const $9139bfe8dcd2ea64$export$1f90c8f89f98110e = (0, $1yZQx.createHook)($9139bfe8dcd2ea64$var$store, {
    selector: $9139bfe8dcd2ea64$export$56f06313122d0aac
});
const $9139bfe8dcd2ea64$export$cc979be9b69236df = (0, $1yZQx.createHook)($9139bfe8dcd2ea64$var$store, {
    selector: ({ isOpen: isOpen })=>({
            isOpen: isOpen
        })
});
const $9139bfe8dcd2ea64$export$a18633b655403b12 = (0, $1yZQx.createStateHook)($9139bfe8dcd2ea64$var$store, {
    selector: (state)=>state.hasPopupOverlay
});
const $9139bfe8dcd2ea64$export$af8fd8cd4b048315 = (0, $1yZQx.createHook)($9139bfe8dcd2ea64$var$store, {
    selector: ({ isLoaded: isLoaded })=>({
            isLoaded: isLoaded
        })
});
const $9139bfe8dcd2ea64$export$4372697329bd9cbe = (0, $1yZQx.createHook)($9139bfe8dcd2ea64$var$store, {
    selector: ({ isDisabled: isDisabled })=>({
            isDisabled: isDisabled
        })
});
const $9139bfe8dcd2ea64$export$7422170a403e909 = (0, $1yZQx.createHook)($9139bfe8dcd2ea64$var$store, {
    selector: ({ commandPaletteSessionId: commandPaletteSessionId })=>({
            commandPaletteSessionId: commandPaletteSessionId
        })
});
const $9139bfe8dcd2ea64$export$282aa48e4a3afada = (0, $1yZQx.createHook)($9139bfe8dcd2ea64$var$store, {
    selector: ({ expandedCommand: expandedCommand, isOpen: isOpen })=>({
            expandedCommand: expandedCommand,
            isOpen: isOpen
        })
});
const $9139bfe8dcd2ea64$export$96819dfb22ad05d3 = (0, $1yZQx.createHook)($9139bfe8dcd2ea64$var$store, {
    selector: ({ search: search })=>({
            search: search
        })
});
const $9139bfe8dcd2ea64$export$a40e8ae3e53feab0 = (0, $1jo4G.createSelector)(({ registry: registry, activeRegistry: activeRegistry, expandedCommand: expandedCommand })=>({
        registry: registry,
        activeRegistry: activeRegistry,
        expandedCommand: expandedCommand
    }), ()=>undefined, ({ registry: registry, activeRegistry: activeRegistry, expandedCommand: expandedCommand })=>{
    if (!expandedCommand) return undefined;
    const registryData = (0, $8FbYY.getRegistryData)(registry, activeRegistry, expandedCommand.id);
    return {
        registryData: registryData,
        analyticsAttributes: registryData
    };
});
const $9139bfe8dcd2ea64$export$f893891deedab3c6 = (0, $1yZQx.createHook)($9139bfe8dcd2ea64$var$store, {
    selector: $9139bfe8dcd2ea64$export$a40e8ae3e53feab0
});
const $9139bfe8dcd2ea64$export$bbc05723eb144e03 = (0, $1yZQx.createHook)($9139bfe8dcd2ea64$var$store, {
    selector: ({ commands: commands, search: search, expandedCommand: expandedCommand, childResult: childResult, registry: registry, activeRegistry: activeRegistry })=>({
            commands: commands,
            search: search,
            expandedCommand: expandedCommand,
            childResult: childResult,
            registry: registry,
            activeRegistry: activeRegistry
        })
});

});
parcelRegister("8FbYY", function(module, exports) {

$parcel$export(module.exports, "getRegistryData", () => $faf99007a5829b26$export$6a1ed481c04a3ae6);
$parcel$export(module.exports, "getExpandedCommandRegistryAnalytics", () => $faf99007a5829b26$export$eb055284806da6e5);
$parcel$export(module.exports, "getShortcutSpecialCharacters", () => $faf99007a5829b26$export$e6994b845b967732);
$parcel$export(module.exports, "removeShortcutSpecialCharacters", () => $faf99007a5829b26$export$cd2a5827eae5f4cf);
$parcel$export(module.exports, "mergeSections", () => $faf99007a5829b26$export$389b0273703d5c48);
$parcel$export(module.exports, "mergeChildResults", () => $faf99007a5829b26$export$60a91e1b94ab4fef);
$parcel$export(module.exports, "getAnalyticsAttributesFromState", () => $faf99007a5829b26$export$4023cd53e5e5fcb8);
$parcel$export(module.exports, "isSecondaryTrigger", () => $faf99007a5829b26$export$daa5beabdf8d9fc3);
$parcel$export(module.exports, "hasChildren", () => $faf99007a5829b26$export$bd5ff50f0e53d41c);
$parcel$export(module.exports, "getAnalyticsAttributesFromResult", () => $faf99007a5829b26$export$bc9cd28438b3ea4b);
$parcel$export(module.exports, "getQueryHash", () => $faf99007a5829b26$export$fa1c95a5ffa92036);
$parcel$export(module.exports, "getWordCount", () => $faf99007a5829b26$export$dba3e2bcdbd49da4);
$parcel$export(module.exports, "getCommandAction", () => $faf99007a5829b26$export$fb6dafa07e60c21a);
$parcel$export(module.exports, "hasAction", () => $faf99007a5829b26$export$e217e69099d082f5);
$parcel$export(module.exports, "useSetTimeoutAutoClear", () => $faf99007a5829b26$export$c3d20e8c1e93a572);

var $eUqFw = parcelRequire("eUqFw");

var $3IRl5 = parcelRequire("3IRl5");

var $igOBb = parcelRequire("igOBb");

var $ftpwV = parcelRequire("ftpwV");

var $6jiFZ = parcelRequire("6jiFZ");
const $faf99007a5829b26$export$6a1ed481c04a3ae6 = (registry, activeRegistry, commandId)=>{
    if (!commandId) return undefined;
    const activeCommandRegistryData = activeRegistry?.commandRegistry?.[commandId];
    const registryData = activeCommandRegistryData?.registryId ? registry[activeCommandRegistryData?.registryId] : undefined;
    return registryData;
};
const $faf99007a5829b26$export$eb055284806da6e5 = (registry, activeRegistry, commandId)=>$faf99007a5829b26$export$6a1ed481c04a3ae6(registry, activeRegistry, commandId);
const $faf99007a5829b26$export$8af60a6897157f84 = (registry, activeRegistry, parentCommands)=>{
    const parentCommandIds = parentCommands?.map((command)=>command.id);
    while(parentCommandIds?.length){
        const nextParentCommandId = parentCommandIds?.pop();
        const registryData = $faf99007a5829b26$export$6a1ed481c04a3ae6(registry, activeRegistry, nextParentCommandId);
        if (registryData) return registryData;
    }
    return undefined;
};
const $faf99007a5829b26$export$e6994b845b967732 = ()=>[
        {
            char: ' ',
            replacement: (0, $ftpwV.SHORTCUT_ELEMENT_TYPES).THEN
        },
        {
            char: '+',
            replacement: (0, $ftpwV.SHORTCUT_ELEMENT_TYPES).PLUS
        },
        {
            char: '|',
            replacement: (0, $ftpwV.SHORTCUT_ELEMENT_TYPES).OR
        }
    ];
const $faf99007a5829b26$export$cd2a5827eae5f4cf = (shortcut)=>{
    const specialChars = $faf99007a5829b26$export$e6994b845b967732();
    let strippedShortcut = shortcut;
    specialChars.forEach(({ char: char })=>{
        strippedShortcut = strippedShortcut.split(char).join('');
    });
    return strippedShortcut.toLowerCase();
};
const $faf99007a5829b26$export$389b0273703d5c48 = (sections)=>sections.reduce((acc, curr)=>{
        Object.entries(curr).forEach(([key, entry])=>{
            acc[key] = entry;
        });
        return acc;
    }, {});
const $faf99007a5829b26$export$60a91e1b94ab4fef = (childResults)=>{
    const commands = [];
    const sections = [];
    childResults.forEach((childResult)=>{
        commands.push(...childResult.commands);
        if (childResult.sections) sections.push(childResult.sections);
    });
    return {
        commands: commands,
        sections: $faf99007a5829b26$export$389b0273703d5c48(sections)
    };
};
const $faf99007a5829b26$export$ae8f55d2b67cb8d6 = (text, commonWordsToBeRemoved)=>{
    const commonWords = commonWordsToBeRemoved.toLowerCase().replace(/\s{2,}/g, ' ').trim().split(' ');
    const regexString = commonWords.map((word)=>`\\b${word}\\b`).join('|');
    const regex = new RegExp(regexString, 'g');
    return text.replace(/[.,]/g, '') // remove dot and comma
    .replace(regex, '') // remove common words
    .replace(/\s{2,}/g, ' ') // remove double spaces
    .trim();
};
const $faf99007a5829b26$export$4023cd53e5e5fcb8 = (state, command, method = 'undefined', wasSecondaryTriggered, attributes)=>{
    const analyticsAttributes = {
        commandPaletteId: command.id,
        commandPaletteSessionId: state.commandPaletteSessionId,
        searchTaken: !!state.search,
        method: method,
        cpMenu: 'rootMenu',
        action: command.id,
        actionCategory: 'none',
        wasSecondaryTriggered: wasSecondaryTriggered,
        ...$faf99007a5829b26$export$8af60a6897157f84(state.registry, state.activeRegistry, command.parentCommands) || {},
        ...$faf99007a5829b26$export$6a1ed481c04a3ae6(state.registry, state.activeRegistry, command.id) || {},
        ...$faf99007a5829b26$export$eb055284806da6e5(state.registry, state.activeRegistry, state.expandedCommand?.id) || {},
        ...attributes,
        ...!!command.analytics && command.analytics
    };
    if (state.expandedCommand?.analytics) analyticsAttributes.cpMenu = state.expandedCommand.analytics.action;
    else if (state.expandedCommand?.id) analyticsAttributes.cpMenu = state.expandedCommand.id;
    const sections = state.expandedCommand && state.childResult?.sections ? $faf99007a5829b26$export$389b0273703d5c48([
        ...state.sections,
        state.childResult?.sections
    ]) : $faf99007a5829b26$export$389b0273703d5c48(state.sections);
    const rootCommand = state.parentCommand?.[0] || state.expandedCommand || command;
    const rootSection = rootCommand.section ? sections?.[rootCommand.section] : undefined;
    analyticsAttributes.actionCategory = rootSection?.actionCategory || rootCommand?.section || rootCommand?.analytics?.actionCategory || // Fallback to the original command section
    (command?.section ? sections?.[command?.section]?.actionCategory || command?.section : undefined) || analyticsAttributes.actionCategory;
    return analyticsAttributes;
};
const $faf99007a5829b26$export$daa5beabdf8d9fc3 = (event)=>(0, $igOBb.isMacOs)() ? event.metaKey : event.ctrlKey;
const $faf99007a5829b26$export$bd5ff50f0e53d41c = (command)=>{
    if (command?.wasSecondaryTriggered) {
        if (command?.secondaryAction?.type) {
            const hasSecondaryChildren = (0, $6jiFZ.COMMAND_WITH_CHILDREN).some((commandType)=>commandType === command?.secondaryAction?.type);
            return hasSecondaryChildren;
        }
        // secondary action not defined - fallback to primary
        return (0, $6jiFZ.COMMAND_WITH_CHILDREN).some((commandType)=>commandType === command?.primaryAction?.type);
    }
    return (0, $6jiFZ.COMMAND_WITH_CHILDREN).some((commandType)=>commandType === command?.primaryAction?.type);
};
const $faf99007a5829b26$export$bc9cd28438b3ea4b = (result)=>{
    if (result) return {
        globalIndex: result.index,
        sectionIndex: result.sectionIndex,
        indexWithinSection: result.indexWithinSection,
        sectionId: result.sectionId
    };
    return {};
};
const $faf99007a5829b26$export$fa1c95a5ffa92036 = (str)=>(0, $3IRl5.createHash)().update(str).digest('hex');
const $faf99007a5829b26$export$dba3e2bcdbd49da4 = (str)=>str.length > 0 ? str.split(/\s+/).length : 0;
const $faf99007a5829b26$export$fb6dafa07e60c21a = (command, wasSecondaryTriggered)=>{
    if (!command) return null;
    const { secondaryAction: secondaryAction, primaryAction: primaryAction } = command;
    if (!primaryAction) return null;
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    const commandAction = wasSecondaryTriggered && secondaryAction ? secondaryAction : primaryAction;
    return {
        ...commandAction
    };
};
const $faf99007a5829b26$export$e217e69099d082f5 = (command)=>Boolean(command.primaryAction || command.secondaryAction);
const $faf99007a5829b26$export$c3d20e8c1e93a572 = ()=>{
    const timeoutRef = (0, $eUqFw.useRef)();
    (0, $eUqFw.useEffect)(()=>()=>{
            if (timeoutRef.current) clearTimeout(timeoutRef.current);
        }, []);
    const setTimeoutAutoClear = (...args)=>{
        if (timeoutRef.current) clearTimeout(timeoutRef.current);
        timeoutRef.current = setTimeout(...args);
    };
    return {
        setTimeoutAutoClear: setTimeoutAutoClear
    };
};

});
parcelRegister("igOBb", function(module, exports) {

$parcel$export(module.exports, "isMacOs", () => $a127768fd887ea5b$export$c5e71f489eb3970b);
$parcel$export(module.exports, "getShortcutModifierKey", () => $a127768fd887ea5b$export$fe66dae91c68619b);
const $a127768fd887ea5b$export$c5e71f489eb3970b = ()=>/Mac/i.test(window?.navigator?.platform);
const $a127768fd887ea5b$export$fe66dae91c68619b = ()=>$a127768fd887ea5b$export$c5e71f489eb3970b() ? 'meta' : 'ctrl';

});

parcelRegister("ftpwV", function(module, exports) {

$parcel$export(module.exports, "UI_EVENT_TYPE", () => $48b165edb54974f4$export$a1562d08625f5d7e);
$parcel$export(module.exports, "TRACK_EVENT_TYPE", () => $48b165edb54974f4$export$947dac6c72b26f81);
$parcel$export(module.exports, "SHORTCUT_ELEMENT_TYPES", () => $48b165edb54974f4$export$1ee9d153576afd13);
// EVENT TYPES
const $48b165edb54974f4$export$a1562d08625f5d7e = 'UI';
const $48b165edb54974f4$export$947dac6c72b26f81 = 'TRACK';
const $48b165edb54974f4$export$f1d537d508d2945a = 'SCREEN';
const $48b165edb54974f4$export$12346a674644c156 = 'OPERATIONAL';
var $48b165edb54974f4$export$1ee9d153576afd13;
(function(SHORTCUT_ELEMENT_TYPES) {
    SHORTCUT_ELEMENT_TYPES["THEN"] = "then";
    SHORTCUT_ELEMENT_TYPES["OR"] = "or";
    SHORTCUT_ELEMENT_TYPES["PLUS"] = "plus";
    SHORTCUT_ELEMENT_TYPES["KEY"] = "key";
})($48b165edb54974f4$export$1ee9d153576afd13 || ($48b165edb54974f4$export$1ee9d153576afd13 = {}));

});

parcelRegister("6jiFZ", function(module, exports) {

$parcel$export(module.exports, "CommandActionType", () => $5c36304d2fa4b1a2$export$f041b1b117ab382f);
$parcel$export(module.exports, "COMMAND_WITH_CHILDREN", () => $5c36304d2fa4b1a2$export$904b2a0e38a1bef3);
var $5c36304d2fa4b1a2$export$f041b1b117ab382f;
(function(CommandActionType) {
    /** Performs action when user clicks or presses Enter in the command. Command Palette closes while performing the action */ CommandActionType["PERFORM"] = "perform";
    /** Loads a sub list of commands  */ CommandActionType["COMMAND_LIST"] = "command-list";
})($5c36304d2fa4b1a2$export$f041b1b117ab382f || ($5c36304d2fa4b1a2$export$f041b1b117ab382f = {}));
const $5c36304d2fa4b1a2$export$3e448fd53031e13c = Object.values($5c36304d2fa4b1a2$export$f041b1b117ab382f);
const $5c36304d2fa4b1a2$export$904b2a0e38a1bef3 = [
    "command-list"
];

});


parcelRegister("li0m0", function(module, exports) {

$parcel$export(module.exports, "actions", () => $476b965ceb7c28b6$export$e324594224ef24da);

var $MdoH4 = parcelRequire("MdoH4");

var $hompL = parcelRequire("hompL");

var $igOBb = parcelRequire("igOBb");

var $guiFP = parcelRequire("guiFP");

var $1ybV0 = parcelRequire("1ybV0");

var $8PVSz = parcelRequire("8PVSz");

var $75e8i = parcelRequire("75e8i");

var $ftpwV = parcelRequire("ftpwV");

var $6jiFZ = parcelRequire("6jiFZ");

var $8FbYY = parcelRequire("8FbYY");

var $gklnd = parcelRequire("gklnd");

var $2fkzb = parcelRequire("2fkzb");
const $476b965ceb7c28b6$var$rootCommands = {
    parentCommand: [],
    expandedCommand: undefined,
    childCommands: undefined,
    childResult: undefined
};
const $476b965ceb7c28b6$var$open = ()=>({ setState: setState, getState: getState })=>{
        if (getState().isDisabled) return;
        setState({
            commandPaletteSessionId: (0, (/*@__PURE__*/$parcel$interopDefault($hompL))).v4(),
            isOpen: true,
            activeIndex: 0,
            search: ''
        });
    };
const $476b965ceb7c28b6$var$close = ()=>({ setState: setState })=>{
        setState({
            isOpen: false,
            commandPaletteSessionId: '',
            search: '',
            ...$476b965ceb7c28b6$var$rootCommands
        });
    };
const $476b965ceb7c28b6$var$toggle = ()=>({ setState: setState, getState: getState })=>{
        const isOpen = !getState().isOpen;
        setState({
            isOpen: isOpen,
            activeIndex: 0,
            search: '',
            commandPaletteSessionId: isOpen ? (0, (/*@__PURE__*/$parcel$interopDefault($hompL))).v4() : '',
            ...!isOpen ? $476b965ceb7c28b6$var$rootCommands : {}
        });
    };
const $476b965ceb7c28b6$var$addCommands = (commands)=>({ setState: setState, getState: getState })=>{
        const currentState = getState();
        const newCommands = currentState.commands.concat(commands);
        const newState = {
            commands: newCommands
        };
        if (currentState.expandedCommand) {
            const matchedExpandedCommand = commands.filter((command)=>command.id === currentState.expandedCommand?.id);
            if (matchedExpandedCommand.length === 1) {
                const [updatedExpandedCommand] = matchedExpandedCommand;
                newState.expandedCommand = updatedExpandedCommand;
            }
        }
        setState(newState);
    };
const $476b965ceb7c28b6$var$removeCommands = (commands)=>({ setState: setState, getState: getState })=>{
        const newCommands = getState().commands.filter((command)=>!commands.includes(command));
        setState({
            commands: newCommands
        });
    };
const $476b965ceb7c28b6$var$removeCommandsById = (commandIds)=>({ setState: setState, getState: getState })=>{
        const newCommands = getState().commands.filter((command)=>!commandIds.includes(command.id));
        setState({
            commands: newCommands
        });
    };
const $476b965ceb7c28b6$var$handleSearch = (search)=>({ setState: setState })=>{
        setState({
            search: search,
            activeIndex: 0
        });
    };
const $476b965ceb7c28b6$var$forceSearchValue = (search)=>({ setState: setState })=>{
        setState({
            search: search,
            shouldForceSearchValue: true
        });
    };
const $476b965ceb7c28b6$var$resetShouldForceSearchValue = ()=>({ setState: setState })=>{
        setState({
            shouldForceSearchValue: false
        });
    };
const $476b965ceb7c28b6$var$goBackLevel = (goToRoot, analytics)=>({ setState: setState, getState: getState })=>{
        const currentState = getState();
        if (!currentState.expandedCommand) return;
        const newState = {
            search: '',
            activeIndex: 0,
            childResult: undefined,
            forceSearchFocus: true
        };
        if (currentState.parentCommand.length && !goToRoot) {
            newState.expandedCommand = currentState.parentCommand[currentState.parentCommand.length - 1];
            newState.parentCommand = currentState.parentCommand.slice(0, currentState.parentCommand.length - 1);
            if (newState.expandedCommand?.primaryAction?.type === (0, $6jiFZ.CommandActionType).COMMAND_LIST && newState.expandedCommand?.primaryAction?.commands) newState.childResult = {
                commands: newState.expandedCommand?.primaryAction?.commands,
                sections: newState.expandedCommand?.primaryAction?.sections
            };
        } else {
            newState.loadingList = false;
            newState.parentCommand = [];
            newState.expandedCommand = undefined;
            newState.childResult = undefined;
        }
        if (currentState?.onAnalytics && analytics?.createAnalyticsEvent) currentState.onAnalytics(analytics.createAnalyticsEvent({
            action: 'navigation',
            actionSubject: 'commandPalette'
        }), (0, $ftpwV.TRACK_EVENT_TYPE), {
            attributes: {
                cpMenu: currentState.expandedCommand?.id || 'rootMenu',
                searchSessionId: currentState.commandPaletteSessionId,
                action: goToRoot ? 'backToRoot' : 'backToParent',
                actionCategory: 'back',
                method: analytics?.method
            }
        });
        setState(newState);
    };
// Once search input is focused, forceSearchFocus can go back to false
const $476b965ceb7c28b6$var$forceFocusSearch = (forceSearchFocus = false)=>({ setState: setState })=>{
        setState({
            forceSearchFocus: forceSearchFocus
        });
    };
const $476b965ceb7c28b6$var$setActiveIndex = (index)=>({ setState: setState, getState: getState })=>{
        const { isSearchFieldFocused: isSearchFieldFocused } = getState();
        setState({
            activeIndex: index,
            ...!isSearchFieldFocused ? {
                forceSearchFocus: true
            } : {}
        });
    };
const $476b965ceb7c28b6$var$getAnalyticsAttributes = (command, method, wasSecondaryTriggered = false, attributes = {})=>({ getState: getState })=>(0, $8FbYY.getAnalyticsAttributesFromState)(getState(), command, method, wasSecondaryTriggered, attributes);
const $476b965ceb7c28b6$var$performDialogCloseCommand = ()=>({ setState: setState, getState: getState })=>{
        // Timeout applied to ensure that this happens after react-focus-lock is shut down
        // react-focus-lock also has a timeout before it stops listening for focus events
        // tl;dr If you don't add this timeout, cypress gets sad (and probably some actual users too but I've never repro'd it manually)
        setTimeout(()=>{
            const { onClosePendingCommandAction: onClosePendingCommandAction, onAnalytics: onAnalytics } = getState();
            if (onClosePendingCommandAction !== undefined) {
                try {
                    (0, $75e8i.default)('command-palette-executed');
                    onClosePendingCommandAction.perform();
                    if (onAnalytics && onClosePendingCommandAction?.createAnalyticsEvent) {
                        const performAnalyticsEvent = onClosePendingCommandAction?.createAnalyticsEvent({
                            action: 'taskSucceeded',
                            actionSubject: 'commandPalette'
                        });
                        onAnalytics(performAnalyticsEvent, (0, $ftpwV.TRACK_EVENT_TYPE), {
                            attributes: onClosePendingCommandAction?.analyticsArgs
                        });
                    }
                } catch (err) {
                    const error = err instanceof Error ? err : new Error('Command palette perform error');
                    (0, $guiFP.default)({
                        error: error,
                        meta: {
                            id: 'compal.performDialogCloseCommand',
                            packageName: 'jiraCommandPalette',
                            teamName: typeof onClosePendingCommandAction?.analyticsArgs?.teamName === 'string' ? onClosePendingCommandAction?.analyticsArgs.teamName : 'deliveroo'
                        },
                        attributes: onClosePendingCommandAction.analyticsArgs
                    });
                    (0, $8PVSz.setInteractionError)('command-palette-executed', {
                        errorMessage: error.message,
                        name: 'performDialogCloseCommandPerformError'
                    });
                }
                setState({
                    onClosePendingCommandAction: undefined
                });
            }
        }, 0);
    };
const $476b965ceb7c28b6$var$executeCommand = (command, analytics, wasSecondaryTriggered = false)=>({ setState: setState, getState: getState })=>{
        const currentState = getState();
        const newState = {
            ...!(0, $gklnd.getActiveCommandList)(command, wasSecondaryTriggered)?.keepSearch && {
                search: ''
            },
            activeIndex: 0
        };
        const analyticsAttributes = (0, $8FbYY.getAnalyticsAttributesFromState)(currentState, command, analytics?.method || 'undefined', wasSecondaryTriggered, analytics?.attributes);
        const currentCommandAction = (0, $8FbYY.getCommandAction)(command, wasSecondaryTriggered);
        if (!currentCommandAction) return;
        if (currentState?.onAnalytics && analytics?.createAnalyticsEvent) {
            const analyticsEvent = analytics.createAnalyticsEvent({
                action: 'navigation',
                actionSubject: 'commandPalette'
            });
            currentState.onAnalytics(analyticsEvent, (0, $ftpwV.TRACK_EVENT_TYPE), {
                attributes: analyticsAttributes
            });
        }
        const shouldLoadChildren = (0, $8FbYY.hasChildren)({
            ...command,
            wasSecondaryTriggered: wasSecondaryTriggered
        });
        const shouldExecutePerform = currentCommandAction?.type === (0, $6jiFZ.CommandActionType).PERFORM;
        if (shouldLoadChildren) {
            (0, $75e8i.default)('command-palette-load-child-command-list');
            if (currentState.expandedCommand) newState.parentCommand = [
                ...currentState.parentCommand,
                currentState.expandedCommand
            ];
            newState.expandedCommand = {
                ...command,
                wasSecondaryTriggered: wasSecondaryTriggered
            };
            newState.childResult = undefined;
            newState.forceSearchFocus = true;
            if ((0, $2fkzb.isSearchableChildrenAction)(currentCommandAction)) {
                newState.childResult = {
                    commands: currentCommandAction.commands,
                    sections: currentCommandAction.sections
                };
                if (command.parentCommands?.length) newState.parentCommand = [
                    ...newState.parentCommand || [],
                    ...command.parentCommands
                ];
            } else newState.childResult = undefined;
            setState(newState);
            if ((0, $1ybV0.ff)('compal-issue-actions-very-high-priority_f5w5r')) {
                if (currentCommandAction.type === (0, $6jiFZ.CommandActionType).COMMAND_LIST && currentCommandAction.onClick) currentCommandAction.onClick();
            }
        } else if (shouldExecutePerform) {
            if (!currentCommandAction.preventModalClose) {
                newState.commandPaletteSessionId = '';
                newState.isOpen = false;
                newState.expandedCommand = undefined;
                newState.parentCommand = [];
                newState.childResult = undefined;
                setState(newState);
                if (currentState.onAnalytics && analytics?.createAnalyticsEvent) {
                    const closeAnalyticsEvent = analytics.createAnalyticsEvent({
                        action: 'closed',
                        actionSubject: 'commandPalette'
                    });
                    currentState.onAnalytics(closeAnalyticsEvent, (0, $ftpwV.UI_EVENT_TYPE), {
                        attributes: analyticsAttributes
                    });
                }
            }
            if (wasSecondaryTriggered && currentState.onAnalytics && analytics?.createAnalyticsEvent) {
                const closeAnalyticsEvent = analytics.createAnalyticsEvent({
                    action: 'secondaryAction',
                    actionSubject: 'commandPalette'
                });
                currentState.onAnalytics(closeAnalyticsEvent, (0, $ftpwV.TRACK_EVENT_TYPE), {
                    attributes: {
                        ...analyticsAttributes,
                        keyPressed: (0, $igOBb.isMacOs)() ? 'cmdEnter' : 'ctrlEnter',
                        ...currentCommandAction.analyticsArgs
                    }
                });
            }
            // If not closing dialog, execute immediately, otherwise cue for after dialog is closed
            if (currentCommandAction.preventModalClose) try {
                (0, $75e8i.default)('command-palette-executed');
                currentCommandAction.perform();
                if (currentState.onAnalytics && analytics?.createAnalyticsEvent) {
                    const performAnalyticsEvent = analytics.createAnalyticsEvent({
                        action: 'taskSucceeded',
                        actionSubject: 'commandPalette'
                    });
                    currentState.onAnalytics(performAnalyticsEvent, (0, $ftpwV.TRACK_EVENT_TYPE), {
                        attributes: analyticsAttributes
                    });
                }
            } catch (err) {
                const error = err instanceof Error ? err : new Error('Command palette perform error');
                (0, $guiFP.default)({
                    error: error,
                    meta: {
                        id: 'compal.executeCommand',
                        packageName: 'jiraCommandPalette',
                        teamName: typeof analytics?.attributes?.teamName === 'string' ? analytics?.attributes.teamName : 'deliveroo'
                    },
                    attributes: analytics?.attributes
                });
                (0, $8PVSz.setInteractionError)('command-palette-executed', {
                    errorMessage: error.message,
                    name: 'executeCommandPerformError'
                });
            }
            else setState({
                onClosePendingCommandAction: {
                    ...currentCommandAction,
                    analyticsArgs: analyticsAttributes,
                    createAnalyticsEvent: analytics?.createAnalyticsEvent
                }
            });
        }
    };
const $476b965ceb7c28b6$var$setChildCommands = (childResult)=>({ setState: setState })=>{
        setState({
            childResult: childResult
        });
    };
const $476b965ceb7c28b6$var$setLoadingList = (loadingList)=>({ setState: setState })=>{
        setState({
            loadingList: loadingList
        });
    };
const $476b965ceb7c28b6$var$setFocusInput = (isSearchFieldFocused)=>({ setState: setState })=>setState({
            isSearchFieldFocused: isSearchFieldFocused
        });
const $476b965ceb7c28b6$var$registerSections = (newSections)=>({ setState: setState, getState: getState })=>{
        const currentState = getState();
        const sections = currentState.sections.slice(0);
        sections.push(newSections);
        setState({
            sections: sections
        });
    };
const $476b965ceb7c28b6$var$unregisterSections = (newSections)=>({ setState: setState, getState: getState })=>{
        const currentState = getState();
        const sections = currentState.sections.filter((section)=>section !== newSections);
        setState({
            sections: sections
        });
    };
const $476b965ceb7c28b6$var$markAsLoaded = ()=>({ setState: setState })=>{
        setState({
            isLoaded: true
        });
    };
const $476b965ceb7c28b6$var$setIsDisabled = (isDisabled)=>({ setState: setState })=>{
        setState({
            isDisabled: isDisabled,
            ...isDisabled ? {
                isOpen: false
            } : {}
        });
    };
const $476b965ceb7c28b6$var$setRegistry = (registry)=>({ setState: setState })=>{
        setState({
            registry: registry
        });
    };
const $476b965ceb7c28b6$var$updateActiveRegistry = (registryId, commands)=>({ setState: setState, getState: getState })=>{
        const currentActiveRegistry = getState().activeRegistry;
        const activeRegistry = {
            commandRegistry: {
                ...currentActiveRegistry.commandRegistry,
                ...commands.reduce((acc, command)=>{
                    acc[command.id] = {
                        registryId: registryId
                    };
                    return acc;
                }, // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                {})
            },
            registryIds: (0, (/*@__PURE__*/$parcel$interopDefault($MdoH4)))([
                ...currentActiveRegistry.registryIds,
                registryId
            ])
        };
        setState({
            activeRegistry: activeRegistry
        });
    };
const $476b965ceb7c28b6$var$removeFromActiveRegistry = (registryId, commands)=>({ setState: setState, getState: getState })=>{
        const currentActiveRegistry = getState().activeRegistry;
        const commandRegistry = {
            ...currentActiveRegistry.commandRegistry
        };
        commands.forEach((command)=>{
            delete commandRegistry[command.id];
        });
        setState({
            activeRegistry: {
                commandRegistry: commandRegistry,
                registryIds: currentActiveRegistry.registryIds.filter((id)=>id !== registryId)
            }
        });
    };
const $476b965ceb7c28b6$var$setAnalytics = (onAnalytics, onErrorAnalytics)=>({ setState: setState })=>{
        setState({
            onAnalytics: onAnalytics,
            onErrorAnalytics: onErrorAnalytics
        });
    };
const $476b965ceb7c28b6$var$setFallbackOverride = (fallbackOverride)=>({ setState: setState })=>{
        setState({
            fallbackOverride: fallbackOverride
        });
    };
const $476b965ceb7c28b6$var$setHasPopupOverlay = (hasPopupOverlay)=>({ setState: setState })=>{
        setState({
            hasPopupOverlay: hasPopupOverlay
        });
    };
const $476b965ceb7c28b6$export$e324594224ef24da = {
    open: $476b965ceb7c28b6$var$open,
    toggle: $476b965ceb7c28b6$var$toggle,
    close: $476b965ceb7c28b6$var$close,
    addCommands: $476b965ceb7c28b6$var$addCommands,
    removeCommands: $476b965ceb7c28b6$var$removeCommands,
    handleSearch: $476b965ceb7c28b6$var$handleSearch,
    forceFocusSearch: $476b965ceb7c28b6$var$forceFocusSearch,
    setActiveIndex: $476b965ceb7c28b6$var$setActiveIndex,
    executeCommand: $476b965ceb7c28b6$var$executeCommand,
    goBackLevel: $476b965ceb7c28b6$var$goBackLevel,
    setChildCommands: $476b965ceb7c28b6$var$setChildCommands,
    setLoadingList: $476b965ceb7c28b6$var$setLoadingList,
    setFocusInput: $476b965ceb7c28b6$var$setFocusInput,
    registerSections: $476b965ceb7c28b6$var$registerSections,
    unregisterSections: $476b965ceb7c28b6$var$unregisterSections,
    markAsLoaded: $476b965ceb7c28b6$var$markAsLoaded,
    getAnalyticsAttributes: $476b965ceb7c28b6$var$getAnalyticsAttributes,
    setIsDisabled: $476b965ceb7c28b6$var$setIsDisabled,
    setRegistry: $476b965ceb7c28b6$var$setRegistry,
    updateActiveRegistry: $476b965ceb7c28b6$var$updateActiveRegistry,
    removeCommandsById: $476b965ceb7c28b6$var$removeCommandsById,
    removeFromActiveRegistry: $476b965ceb7c28b6$var$removeFromActiveRegistry,
    performDialogCloseCommand: $476b965ceb7c28b6$var$performDialogCloseCommand,
    setAnalytics: $476b965ceb7c28b6$var$setAnalytics,
    setFallbackOverride: $476b965ceb7c28b6$var$setFallbackOverride,
    setHasPopupOverlay: $476b965ceb7c28b6$var$setHasPopupOverlay,
    forceSearchValue: $476b965ceb7c28b6$var$forceSearchValue,
    resetShouldForceSearchValue: $476b965ceb7c28b6$var$resetShouldForceSearchValue
};

});
parcelRegister("gklnd", function(module, exports) {

$parcel$export(module.exports, "getActiveCommandList", () => $b93b5138b1f374a6$export$639b7f41b0b47a01);

var $6jiFZ = parcelRequire("6jiFZ");
const $b93b5138b1f374a6$export$639b7f41b0b47a01 = (expandedCommand, wasSecondaryTriggered)=>{
    if (wasSecondaryTriggered && expandedCommand?.secondaryAction?.type === (0, $6jiFZ.CommandActionType).COMMAND_LIST) return expandedCommand.secondaryAction;
    if (!wasSecondaryTriggered && expandedCommand?.primaryAction?.type === (0, $6jiFZ.CommandActionType).COMMAND_LIST) return expandedCommand.primaryAction;
    return null;
};

});

parcelRegister("2fkzb", function(module, exports) {

$parcel$export(module.exports, "isSearchableChildrenAction", () => $20c016b992336e05$export$d75616d77443fe4e);

var $6jiFZ = parcelRequire("6jiFZ");
const $20c016b992336e05$export$d75616d77443fe4e = (action)=>action?.type === (0, $6jiFZ.CommandActionType).COMMAND_LIST && action.commands !== undefined;

});




parcelRegister("7QBK4", function(module, exports) {

$parcel$export(module.exports, "default", () => $41f70f312155455f$export$2e2bcd8739ae039);

var $aA57L = parcelRequire("aA57L");

var $eUqFw = parcelRequire("eUqFw");

var $iWLL0 = parcelRequire("iWLL0");

var $cHJdq = parcelRequire("cHJdq");

var $6qOIw = parcelRequire("6qOIw");

var $3wKQY = parcelRequire("3wKQY");

var $4RwIp = parcelRequire("4RwIp");
const $41f70f312155455f$var$IssueNavigatorSpotlight = ({ hasIssueResults: hasIssueResults, userPreferences: userPreferences, isAiEnabled: isAiEnabled })=>{
    const [{ view: view }] = (0, $4RwIp.useSelectedViewState)();
    const searchModeResponse = (0, $iWLL0.useFragment)((0, $aA57L.default), userPreferences);
    const selectedSearchMode = (0, $6qOIw.toSearchModeWithBasicModeFallback)(searchModeResponse?.jqlBuilderSearchMode);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $cHJdq.NinChangeboardingTourCard), {
        mode: selectedSearchMode,
        view: (0, $3wKQY.convertToView)(view),
        hasIssueResults: hasIssueResults,
        isAiEnabled: isAiEnabled
    });
};
var $41f70f312155455f$export$2e2bcd8739ae039 = $41f70f312155455f$var$IssueNavigatorSpotlight;

});
parcelRegister("aA57L", function(module, exports) {

$parcel$export(module.exports, "default", () => $0407ea6c48c420f0$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<30a8994404dfcae5d894d268d148ffe9>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $0407ea6c48c420f0$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "spotlight_issueNavigator_IssueNavigatorSpotlight",
    "selections": [
        {
            "kind": "ScalarField",
            "name": "jqlBuilderSearchMode"
        }
    ],
    "type": "JiraUserPreferences"
};
$0407ea6c48c420f0$var$node.hash = "3c8e72948beb901cccd7a6650610b18e";
var $0407ea6c48c420f0$export$2e2bcd8739ae039 = $0407ea6c48c420f0$var$node;

});

parcelRegister("6qOIw", function(module, exports) {

$parcel$export(module.exports, "toSearchModeWithBasicModeFallback", () => $696ac313915d0aeb$export$7c0f55a4bd3730ea);
$parcel$export(module.exports, "toServerSearchMode", () => $696ac313915d0aeb$export$32a166cc1b3e6927);

var $1NJeM = parcelRequire("1NJeM");
function $696ac313915d0aeb$export$7c0f55a4bd3730ea(value) {
    switch(value){
        case 0, $1NJeM.SERVER_SEARCH_MODE_ADVANCED:
            return 0, $1NJeM.SEARCH_MODE_ADVANCED;
        default:
            return 0, $1NJeM.DEFAULT_SEARCH_MODE;
    }
}
function $696ac313915d0aeb$export$32a166cc1b3e6927(mode) {
    switch(mode){
        case 0, $1NJeM.SEARCH_MODE_ADVANCED:
            return 0, $1NJeM.SERVER_SEARCH_MODE_ADVANCED;
        default:
            return 0, $1NJeM.SERVER_SEARCH_MODE_BASIC;
    }
}

});


parcelRegister("jTcpY", function(module, exports) {

$parcel$export(module.exports, "default", () => $7376c7651fab5b35$export$2e2bcd8739ae039);

var $bZ8IY = parcelRequire("bZ8IY");

var $5Mqjb = parcelRequire("5Mqjb");

var $eUqFw = parcelRequire("eUqFw");

var $iWLL0 = parcelRequire("iWLL0");

var $1lXFP = parcelRequire("1lXFP");

var $4ACoF = parcelRequire("4ACoF");

var $idiDE = parcelRequire("idiDE");

var $jccNB = parcelRequire("jccNB");

var $kmXw8 = parcelRequire("kmXw8");

var $3mEVr = parcelRequire("3mEVr");

var $dCaOY = parcelRequire("dCaOY");
const $7376c7651fab5b35$var$getLastPage = (pageCursors)=>{
    if (pageCursors?.last) return pageCursors.last.pageNumber;
    if (pageCursors?.around?.length) return pageCursors.around[pageCursors.around.length - 1]?.pageNumber;
    return undefined;
};
const $7376c7651fab5b35$var$TopBar = ({ ActionMenu: ActionMenu, filter: filter, issueResults: issueResults, HeaderSkeletonImage: HeaderSkeletonImage, jqlBuilder: jqlBuilder })=>{
    const issueResultsData = (0, $iWLL0.useFragment)((0, $5Mqjb.default), issueResults);
    // Compute page data for our search results which is needed when requesting items for the legacy meatball menu
    const offset = (issueResultsData?.issueNavigatorPageInfo?.firstIssuePosition ?? 1) - 1; // offset is 0 based so subtract 1
    const pages = $7376c7651fab5b35$var$getLastPage(issueResultsData?.pageCursors) ?? 0;
    const total = issueResultsData?.totalIssueSearchResultCount ?? 0;
    const searchResultPageData = (0, $eUqFw.useMemo)(()=>({
            offset: offset,
            pages: pages,
            total: total
        }), [
        offset,
        pages,
        total
    ]);
    const { filterId: filterId } = (0, $3mEVr.useActiveJql)();
    const jql = (0, $3mEVr.useResolvedJql)();
    const { filterQueryIsFetching: filterQueryIsFetching } = (0, $dCaOY.useFilterQuery)();
    const filterData = (0, $iWLL0.useFragment)((0, $bZ8IY.default), filter);
    const filterDetails = (0, $eUqFw.useMemo)(()=>filterData ? {
            filterId: filterData.filterId,
            name: filterData.name,
            jql: filterData.jql,
            isFavourite: Boolean(filterData.isFavourite)
        } : undefined, [
        filterData
    ]);
    if (filterQueryIsFetching) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(HeaderSkeletonImage, null);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $idiDE.default), {
        name: "top-bar"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4ACoF.PageTopBar), {
        actions: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(ActionMenu, {
            jql: jql,
            filterId: filterId,
            filterDetails: filterDetails,
            searchResultPageData: searchResultPageData
        }),
        bottomBar: jqlBuilder
    }));
};
var $7376c7651fab5b35$export$2e2bcd8739ae039 = (0, $kmXw8.withReportErrors)($7376c7651fab5b35$var$TopBar, {
    id: 'ui.topbar.unhandled',
    packageName: (0, $jccNB.PACKAGE_NAME),
    teamName: (0, $jccNB.TEAM_NAME),
    sendToPrivacyUnsafeSplunk: true,
    attributes: (0, $1lXFP.isLoaderErrorAttributes)
});

});
parcelRegister("bZ8IY", function(module, exports) {

$parcel$export(module.exports, "default", () => $4b8bec0b9cf48557$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<6ab7c2a8b5f9d7e53e2eda0626fb3cbe>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $4b8bec0b9cf48557$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "topBar_issueNavigator_filter",
    "selections": [
        {
            "kind": "ScalarField",
            "name": "filterId"
        },
        {
            "kind": "ScalarField",
            "name": "name"
        },
        {
            "kind": "ScalarField",
            "name": "isFavourite"
        },
        {
            "kind": "ScalarField",
            "name": "jql"
        }
    ],
    "type": "JiraFilter",
    "abstractKey": "__isJiraFilter"
};
$4b8bec0b9cf48557$var$node.hash = "d1fd34a229f9cb2668ab6793af284885";
var $4b8bec0b9cf48557$export$2e2bcd8739ae039 = $4b8bec0b9cf48557$var$node;

});

parcelRegister("5Mqjb", function(module, exports) {

$parcel$export(module.exports, "default", () => $d1e7b544c29aaa08$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<222e07e55baf5ff3dcc37bb6cbd7a80e>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $d1e7b544c29aaa08$var$node = function() {
    var v0 = [
        {
            "kind": "ScalarField",
            "name": "pageNumber"
        }
    ];
    return {
        "argumentDefinitions": [],
        "kind": "Fragment",
        "name": "topBar_issueNavigator_issueResults",
        "selections": [
            {
                "concreteType": "JiraIssueNavigatorPageInfo",
                "kind": "LinkedField",
                "name": "issueNavigatorPageInfo",
                "plural": false,
                "selections": [
                    {
                        "kind": "ScalarField",
                        "name": "firstIssuePosition"
                    }
                ]
            },
            {
                "args": [
                    {
                        "kind": "Literal",
                        "name": "maxCursors",
                        "value": 7
                    }
                ],
                "concreteType": "JiraPageCursors",
                "kind": "LinkedField",
                "name": "pageCursors",
                "plural": false,
                "selections": [
                    {
                        "concreteType": "JiraPageCursor",
                        "kind": "LinkedField",
                        "name": "around",
                        "plural": true,
                        "selections": v0 /*: any*/ 
                    },
                    {
                        "concreteType": "JiraPageCursor",
                        "kind": "LinkedField",
                        "name": "last",
                        "plural": false,
                        "selections": v0 /*: any*/ 
                    }
                ],
                "storageKey": "pageCursors(maxCursors:7)"
            },
            {
                "kind": "ScalarField",
                "name": "totalIssueSearchResultCount"
            }
        ],
        "type": "JiraIssueConnection"
    };
}();
$d1e7b544c29aaa08$var$node.hash = "52b4c743e436bc90ea0831559f2c3e48";
var $d1e7b544c29aaa08$export$2e2bcd8739ae039 = $d1e7b544c29aaa08$var$node;

});

parcelRegister("4ACoF", function(module, exports) {

$parcel$export(module.exports, "PageTopBar", () => $d74ce2d0cb0e9587$export$7e5801dc91bf1819);

var $eUqFw = parcelRequire("eUqFw");

var $b5IAe = parcelRequire("b5IAe");
var $4Ywu9 = parcelRequire("4Ywu9");
var $1ZAYh = parcelRequire("1ZAYh");

var $3a8wJ = parcelRequire("3a8wJ");

var $7JTqr = parcelRequire("7JTqr");

const $d74ce2d0cb0e9587$var$SporkPageTopBar = ({ bottomBar: bottomBar, actions: actions, wrapAtMd: wrapAtMd = false })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
        testId: (0, $0b51e3566777dd51$export$90c4434a1e138106),
        xcss: [
            $d74ce2d0cb0e9587$var$wrapperStyles,
            wrapAtMd ? $d74ce2d0cb0e9587$var$wrapAtMdStyle : $d74ce2d0cb0e9587$var$noWrapStyle
        ]
    }, bottomBar, actions && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
        testId: (0, $0b51e3566777dd51$export$1742330ac6a668f0),
        xcss: [
            $d74ce2d0cb0e9587$var$actionsBoxStyles,
            wrapAtMd && $d74ce2d0cb0e9587$var$actionsBoxAtMdStyles
        ]
    }, actions));
const $d74ce2d0cb0e9587$export$7e5801dc91bf1819 = (props)=>(0, $7JTqr.getWillShowNav4)() ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($d74ce2d0cb0e9587$var$SporkPageTopBar, {
        bottomBar: props.bottomBar,
        actions: props.actions,
        wrapAtMd: props.wrapAtMd
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $3a8wJ.default), props);
const $d74ce2d0cb0e9587$var$noWrapStyle = (0, $1ZAYh.xcss)({
    flexWrap: 'nowrap'
});
const $d74ce2d0cb0e9587$var$wrapAtMdStyle = (0, $1ZAYh.xcss)({
    flexWrap: 'wrap-reverse',
    [(0, $4Ywu9.media).above.md]: {
        flexWrap: 'nowrap'
    }
});
const $d74ce2d0cb0e9587$var$wrapperStyles = (0, $1ZAYh.xcss)({
    display: 'flex',
    paddingTop: 'space.150',
    paddingBottom: 'space.150',
    justifyContent: 'space-between',
    gap: 'space.100',
    [(0, $4Ywu9.media).above.md]: {
        gap: 'space.300'
    }
});
const $d74ce2d0cb0e9587$var$actionsBoxAtMdStyles = (0, $1ZAYh.xcss)({
    flex: '1 1 auto',
    [(0, $4Ywu9.media).above.md]: {
        flex: '0 1 auto'
    }
});
const $d74ce2d0cb0e9587$var$actionsBoxStyles = (0, $1ZAYh.xcss)({
    marginLeft: 'auto',
    display: 'flex',
    justifyContent: 'flex-end',
    flex: '0 0 auto'
});

});
parcelRegister("3a8wJ", function(module, exports) {

$parcel$export(module.exports, "default", () => $2992b0d4d3fe9569$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ /* This is a wrapper around @atlaskit/page-header to patch a bug where text alignment
 in actions is incorrect. This common component is no longer necessary when
 https://ecosystem.atlassian.net/browse/AK-6385 is resolved.
 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $hFGUl = parcelRequire("hFGUl");
const $2992b0d4d3fe9569$var$PageHeader = ({ actions: actions, ...props })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $hFGUl.default), {
        ...props,
        // @ts-expect-error - TS2322 - Type 'Element | null' is not assignable to type 'ReactElement<any, string | JSXElementConstructor<any>> | undefined'.
        actions: actions ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($2992b0d4d3fe9569$var$ActionsWrapper, null, actions) : null
    });
var $2992b0d4d3fe9569$export$2e2bcd8739ae039 = $2992b0d4d3fe9569$var$PageHeader;
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $2992b0d4d3fe9569$var$ActionsWrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_y3gn1e5h",
            __cmplp.className
        ])
    });
});

});
parcelRegister("hFGUl", function(module, exports) {

$parcel$export(module.exports, "default", () => $f0ce2fac4b2f156d$export$2e2bcd8739ae039);
// TODO: Remove this eslint-disable when prop names have been renamed.
// This rule is here as prop name changes are a major as they are used
// by our consumers. This can be done in the next lite-mode conversion.
/* eslint-disable @repo/internal/react/boolean-prop-naming-convention */ 
var $eUqFw = parcelRequire("eUqFw");

var $5ubTM = parcelRequire("5ubTM");
/**
 * __Page header__
 *
 * A page header defines the top of a page. It contains a title and can be optionally combined with
 * breadcrumbs buttons, search, and filters.
 *
 * - [Examples](https://atlassian.design/components/page-header/examples)
 * - [Code](https://atlassian.design/components/page-header/code)
 * - [Usage](https://atlassian.design/components/page-header/usage)
 */ const $f0ce2fac4b2f156d$var$PageHeader = ({ innerRef: innerRef, breadcrumbs: breadcrumbs, actions: actions, bottomBar: bottomBar, children: children, id: id, disableTitleStyles: disableTitleStyles = false, truncateTitle: truncateTitle = false })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5ubTM.OuterWrapper), null, breadcrumbs, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5ubTM.TitleWrapper), {
        truncateTitle: truncateTitle
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5ubTM.TitleContainer), {
        truncateTitle: truncateTitle
    }, disableTitleStyles ? children : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5ubTM.StyledTitleWrapper), {
        ref: innerRef,
        truncateTitle: truncateTitle,
        id: id
    }, children)), actions && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5ubTM.ActionsWrapper), null, actions)), bottomBar && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5ubTM.BottomBarWrapper), null, " ", bottomBar, " "));
};
var $f0ce2fac4b2f156d$export$2e2bcd8739ae039 = $f0ce2fac4b2f156d$var$PageHeader;

});
parcelRegister("5ubTM", function(module, exports) {

$parcel$export(module.exports, "OuterWrapper", () => $fce98fdc5842132f$export$edaaad985a878983);
$parcel$export(module.exports, "StyledTitleWrapper", () => $fce98fdc5842132f$export$284be1ee64a3465c);
$parcel$export(module.exports, "TitleWrapper", () => $fce98fdc5842132f$export$585a3b23e887288b);
$parcel$export(module.exports, "TitleContainer", () => $fce98fdc5842132f$export$35e09ba17cc51c69);
$parcel$export(module.exports, "ActionsWrapper", () => $fce98fdc5842132f$export$c8223871eecc8f3a);
$parcel$export(module.exports, "BottomBarWrapper", () => $fce98fdc5842132f$export$6330225854c30dc);
// TODO: Remove this eslint-disable when prop names have been renamed.
// This rule is here as prop name changes are a major as they are used
// by our consumers. The prop name concerned here is truncateTitle.
// This can be done in the next lite-mode conversion.
/* eslint-disable @repo/internal/react/boolean-prop-naming-convention */ /**
                                                                          * @jsxRuntime classic
                                                                          * @jsx jsx
                                                                          */ 
var $eUqFw = parcelRequire("eUqFw");

var $byn9U = parcelRequire("byn9U");

var $b5IAe = parcelRequire("b5IAe");
var $1ZAYh = parcelRequire("1ZAYh");
function $fce98fdc5842132f$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $fce98fdc5842132f$var$truncateStyles = {
    name: "n3ut7m",
    styles: "overflow-x:hidden;text-overflow:ellipsis;white-space:nowrap"
};
const $fce98fdc5842132f$var$outerStyles = /*#__PURE__*/ (0, $byn9U.css)({
    margin: `${"var(--ds-space-300, 24px)"} 0 ${"var(--ds-space-200, 16px)"} 0`
});
const $fce98fdc5842132f$var$titleStyles = {
    name: "1o56te0",
    styles: "color:var(--ds-text, #172B4D);font:var(--ds-font-heading-large, normal 500 24px/28px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif);letter-spacing:normal;margin-block-start:0;outline:none"
};
const $fce98fdc5842132f$var$titleWrapperStyles = {
    name: "1wb76vg",
    styles: "display:flex;align-items:flex-start;flex-wrap:wrap"
};
const $fce98fdc5842132f$var$titleWrapperTruncateStyles = {
    name: "14gl6v0",
    styles: "flex-wrap:nowrap"
};
const $fce98fdc5842132f$var$titleContainerStyles = /*#__PURE__*/ (0, $byn9U.css)({
    minWidth: 0,
    maxWidth: '100%',
    flex: '1 0 auto',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    flexShrink: undefined,
    marginBlockEnd: "var(--ds-space-100, 8px)"
});
const $fce98fdc5842132f$var$actionStyles = {
    name: "1ianfu6",
    styles: "max-width:100%;flex:0 0 auto;margin-block-end:var(--ds-space-100, 8px);margin-inline-start:auto;padding-inline-start:var(--ds-space-400, 32px);white-space:nowrap;>{text-align:right;}"
};
const $fce98fdc5842132f$var$titleContainerTruncateStyles = {
    name: "s2a4s9",
    styles: "flex-shrink:1"
};
const $fce98fdc5842132f$var$bottomBarStyles = (0, $1ZAYh.xcss)({
    marginBlockStart: 'space.200'
});
const $fce98fdc5842132f$export$edaaad985a878983 = ({ children: children })=>{
    return /*#__PURE__*/ (0, $byn9U.jsx)("div", {
        css: $fce98fdc5842132f$var$outerStyles
    }, children);
};
const $fce98fdc5842132f$export$284be1ee64a3465c = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).forwardRef(({ children: children, id: id, truncateTitle: truncateTitle }, ref)=>{
    return /*#__PURE__*/ (0, $byn9U.jsx)("h1", {
        css: [
            $fce98fdc5842132f$var$titleStyles,
            truncateTitle && $fce98fdc5842132f$var$truncateStyles
        ],
        ref: ref,
        tabIndex: -1,
        id: id
    }, children);
});
const $fce98fdc5842132f$export$585a3b23e887288b = ({ children: children, truncateTitle: truncateTitle })=>{
    return /*#__PURE__*/ (0, $byn9U.jsx)("div", {
        css: [
            $fce98fdc5842132f$var$titleWrapperStyles,
            truncateTitle && $fce98fdc5842132f$var$titleWrapperTruncateStyles
        ]
    }, children);
};
const $fce98fdc5842132f$export$35e09ba17cc51c69 = ({ children: children, truncateTitle: truncateTitle })=>{
    return /*#__PURE__*/ (0, $byn9U.jsx)("div", {
        css: [
            $fce98fdc5842132f$var$titleContainerStyles,
            truncateTitle && $fce98fdc5842132f$var$titleContainerTruncateStyles
        ]
    }, children);
};
const $fce98fdc5842132f$export$c8223871eecc8f3a = ({ children: children })=>{
    return /*#__PURE__*/ (0, $byn9U.jsx)("div", {
        css: $fce98fdc5842132f$var$actionStyles
    }, children);
};
const $fce98fdc5842132f$export$6330225854c30dc = ({ children: children })=>{
    return /*#__PURE__*/ (0, $byn9U.jsx)((0, $b5IAe.default), {
        xcss: $fce98fdc5842132f$var$bottomBarStyles
    }, children);
};

});



const $0b51e3566777dd51$export$90c4434a1e138106 = 'horizontal-nav-page-topbar.ui.horizontal-nav-page-topbar';
const $0b51e3566777dd51$export$1742330ac6a668f0 = 'horizontal-nav-page-topbar.ui.horizontal-nav-page-topbar.actions';




parcelRegister("jtc88", function(module, exports) {

$parcel$export(module.exports, "SelectedViewContainer", () => $d826fbbe01eb4d3f$export$6e497a97feb37da2);

var $11JEn = parcelRequire("11JEn");

var $eUqFw = parcelRequire("eUqFw");

var $iWLL0 = parcelRequire("iWLL0");

var $jccNB = parcelRequire("jccNB");

var $3wKQY = parcelRequire("3wKQY");

var $4RwIp = parcelRequire("4RwIp");

var $cQBUE = parcelRequire("cQBUE");
const $d826fbbe01eb4d3f$export$6e497a97feb37da2 = ({ children: children, onSetView: onSetView, fragment: fragment })=>{
    const { onIssueSearchForView: onIssueSearchForView } = (0, $cQBUE.useIssueSearchQuery)();
    const data = (0, $iWLL0.useFragment)((0, $11JEn.default), fragment);
    const view = (0, $3wKQY.parseIssueNavigatorViewIdOrDefault)(data?.viewId, (0, $jccNB.DEFAULT_VIEW_ID));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4RwIp.Container), {
        view: view,
        onSetView: onSetView,
        onIssueSearchForView: onIssueSearchForView
    }, children);
};

});
parcelRegister("11JEn", function(module, exports) {

$parcel$export(module.exports, "default", () => $3caf38b095a9e5ea$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<499d1dce901e38fe101d2fe7b923ec33>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $3caf38b095a9e5ea$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "selectedView_issueNavigator_SelectedViewContainer",
    "selections": [
        {
            "kind": "ScalarField",
            "name": "viewId"
        }
    ],
    "type": "JiraIssueSearchView"
};
$3caf38b095a9e5ea$var$node.hash = "7715cf1d3aecd1efc3d771f2f7af4bf4";
var $3caf38b095a9e5ea$export$2e2bcd8739ae039 = $3caf38b095a9e5ea$var$node;

});



parcelRegister("5INU9", function(module, exports) {

$parcel$export(module.exports, "GlobalIssueNavigatorHeaderSkeleton", () => $8f00015a211f2507$export$51e99114949d3e8f);
/* global-header.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $7JEyt = parcelRequire("7JEyt");

var $eUqFw = parcelRequire("eUqFw");

var $8ICxF = parcelRequire("8ICxF");

var $hkRpG = parcelRequire("hkRpG");
const $8f00015a211f2507$var$customCssStyles = null;
const $8f00015a211f2507$var$containerStyles = {
    height: '80px'
};
const $8f00015a211f2507$export$51e99114949d3e8f = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8ICxF.AppSkeletonImage), {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($hkRpG))),
        containerStyles: $8f00015a211f2507$var$containerStyles,
        className: (0, $7JEyt.default)([
            "_1wgmglyw"
        ])
    });

});
parcelRegister("hkRpG", function(module, exports) {
module.exports = new URL("global-issue-navigator-header-skeleton.tpl.f1ae7ec6.svg", import.meta.url).toString();

});


parcelRegister("51WJq", function(module, exports) {

$parcel$export(module.exports, "default", () => $ec9b06b6c475b4da$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ // eslint-disable-next-line @typescript-eslint/no-unused-vars

var $7JEyt = parcelRequire("7JEyt");

var $eUqFw = parcelRequire("eUqFw");

var $8cU5f = parcelRequire("8cU5f");

var $3a8wJ = parcelRequire("3a8wJ");

var $heNSb = parcelRequire("heNSb");

var $5JgJ2 = parcelRequire("5JgJ2");

var $5as0a = parcelRequire("5as0a");

var $5qdh2 = parcelRequire("5qdh2");

var $5lWFW = parcelRequire("5lWFW");

var $euIkl = parcelRequire("euIkl");

var $6yplV = parcelRequire("6yplV");

var $iIz2S = parcelRequire("iIz2S");

var $28XQo = parcelRequire("28XQo");
const $ec9b06b6c475b4da$export$49640514ca453805 = /*#__PURE__*/ (0, $eUqFw.forwardRef)((props, ref)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($ec9b06b6c475b4da$export$acedcd153f648084, {
        ref: ref,
        ...props
    }));
const $ec9b06b6c475b4da$export$8b251419efc915eb = ({ jql: jql, filterId: filterId, filterDetails: filterDetails, searchResultPageData: searchResultPageData })=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const isAnonymous = (0, $6yplV.useIsAnonymous)();
    const titleMessage = filterId !== undefined && filterDetails ? formatMessage((0, $iIz2S.default).filterWindowTitle, {
        filterName: filterDetails.name
    }) : formatMessage((0, $iIz2S.default).windowTitle);
    const heading = formatMessage((0, $iIz2S.default).heading);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $3a8wJ.default), {
        actions: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $28XQo.default), {
            jql: jql,
            filterId: filterId,
            isModifiedFilter: filterDetails?.jql !== jql,
            searchResultPageData: searchResultPageData,
            filterName: filterDetails?.name
        })
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $heNSb.DocumentTitle), {
        title: titleMessage
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($ec9b06b6c475b4da$export$6d0d24718f298af7, null, filterId !== undefined && filterDetails ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8cU5f.default), {
        content: filterDetails.name,
        tag: $ec9b06b6c475b4da$export$49640514ca453805,
        position: "mouse"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($ec9b06b6c475b4da$export$d337e02ad938bc27, null, filterDetails.name)), !isAnonymous && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $euIkl.FavoriteButtonHeaderWrapper), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $euIkl.FavoriteButton), {
        filterId: filterDetails.filterId,
        isFavoriteInitial: filterDetails.isFavourite,
        favoriteItemName: filterDetails.name
    })), (0, $5as0a.isCustomFilter)(filterDetails.filterId) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5lWFW.DetailsButtonHeaderWrapper), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5qdh2.DetailsPopup), {
        filterId: filterId
    }))) : heading));
};
var $ec9b06b6c475b4da$export$2e2bcd8739ae039 // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
 = $ec9b06b6c475b4da$export$8b251419efc915eb;
const $ec9b06b6c475b4da$export$acedcd153f648084 = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _1reo15vq _18m915vq",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
const $ec9b06b6c475b4da$export$d337e02ad938bc27 = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1reo15vq _18m915vq _1bto1l2s _o5721q9c",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
const $ec9b06b6c475b4da$export$6d0d24718f298af7 = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c116y _4cvr1y6m _1dyz1kw7 _4t3izwfg _11c81p5s _vwz4zwfg _p12f1osq",
            __cmplp.className
        ])
    });
});

});
parcelRegister("heNSb", function(module, exports) {

$parcel$export(module.exports, "DocumentTitle", () => $44af95caa6ad02db$export$dd5ad0b65cf665da);

var $eUqFw = parcelRequire("eUqFw");

var $1TtYL = parcelRequire("1TtYL");

var $3fq1f = parcelRequire("3fq1f");
class $44af95caa6ad02db$export$dd5ad0b65cf665da extends (0, $eUqFw.Component) {
    static{
        this.defaultProps = {
            TitleSubscriber: (0, $1TtYL.DocumentTitleSubscriber)
        };
    }
    shouldComponentUpdate(nextProps) {
        return nextProps.title !== this.props.title;
    }
    render() {
        const { title: title, TitleSubscriber: TitleSubscriber } = this.props;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(TitleSubscriber, null, ({ contextArray: contextArray }, { setTitle: setTitle, addDocumentTitle: addDocumentTitle, removeDocumentTitle: removeDocumentTitle })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1TtYL.DocumentTitleHelper), {
                title: title,
                setTitle: setTitle,
                addDocumentTitle: addDocumentTitle,
                contextArray: contextArray,
                removeDocumentTitle: removeDocumentTitle,
                TitleSubscriber: TitleSubscriber
            }));
    }
}

});

parcelRegister("5qdh2", function(module, exports) {

$parcel$export(module.exports, "DetailsPopup", () => $dd9f51978c814b26$export$b61797ace80c3d8);

var $eUqFw = parcelRequire("eUqFw");

var $7u4fN = parcelRequire("7u4fN");

var $3MV1G = parcelRequire("3MV1G");

var $5JgJ2 = parcelRequire("5JgJ2");

var $jMP2a = parcelRequire("jMP2a");

var $hZHX2 = parcelRequire("hZHX2");

var $48xaL = parcelRequire("48xaL");

var $daaJ8 = parcelRequire("daaJ8");

var $5lWFW = parcelRequire("5lWFW");
const $dd9f51978c814b26$export$b61797ace80c3d8 = ({ filterId: filterId, defaultOpen: defaultOpen = false })=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const [isOpen, setIsOpen] = (0, $eUqFw.useState)(defaultOpen);
    const onClose = (0, $eUqFw.useCallback)(()=>setIsOpen(false), [
        setIsOpen
    ]);
    const onTriggerClick = (0, $eUqFw.useCallback)((_, analyticsEvent)=>{
        setIsOpen(!isOpen);
        (0, $jMP2a.fireUIAnalytics)(analyticsEvent, 'filterDetailsButton');
    }, [
        isOpen,
        setIsOpen
    ]);
    const [isEditFilterModalOpen, setIsEditFilterModalOpen] = (0, $eUqFw.useState)(false);
    const onOpenEditFilterModal = (0, $eUqFw.useCallback)(()=>{
        setIsEditFilterModalOpen(true);
        onClose();
    }, [
        onClose
    ]);
    const onCloseEditFilterModal = (0, $eUqFw.useCallback)(()=>{
        setIsEditFilterModalOpen(false);
    }, []);
    const Content = (0, $eUqFw.useCallback)((props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $daaJ8.PopupContent), {
            ...props,
            onOpenEditFilterModal: onOpenEditFilterModal,
            onOpenNewSubscriptionModal: onClose,
            filterId: filterId
        }), [
        filterId,
        onClose,
        onOpenEditFilterModal
    ]);
    const Trigger = (0, $eUqFw.useCallback)((props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7u4fN.default), {
            ...props,
            appearance: "link",
            onClick: onTriggerClick,
            isSelected: isOpen,
            onMouseOver: (0, $daaJ8.preloadPopupContentComponent),
            testId: "issue-navigator-custom-filters.ui.details-popup.button"
        }, formatMessage((0, $48xaL.default).filterDetails)), [
        isOpen,
        onTriggerClick,
        formatMessage
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $hZHX2.AsyncUpdateFilterDialog), {
        filterId: filterId,
        onCloseModal: onCloseEditFilterModal,
        isOpen: isEditFilterModalOpen
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $3MV1G.default), {
        isOpen: isOpen,
        onClose: onClose,
        placement: "bottom-start",
        content: Content,
        trigger: Trigger,
        testId: "issue-navigator-custom-filters.ui.details-popup.popup"
    }));
};

});
parcelRegister("hZHX2", function(module, exports) {

$parcel$export(module.exports, "AsyncUpdateFilterDialog", () => $b7de3f9465739c07$export$8692e2751472dade);

var $eUqFw = parcelRequire("eUqFw");

var $7rh0R = parcelRequire("7rh0R");

var $gGtKh = parcelRequire("gGtKh");

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $b7de3f9465739c07$var$UpdateFilterDialog = (0, $7rh0R.lazyAfterPaint)(()=>(parcelRequire("c5tap")), {
    ssr: false,
    moduleId: "./src/packages/issue-navigator/save-filter-dialog/src/ui/update-filter-dialog/index.tsx"
});
const $b7de3f9465739c07$export$8692e2751472dade = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gGtKh.default), {
        name: "async-update-filter-dialog",
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($b7de3f9465739c07$var$UpdateFilterDialog, props));

});
parcelRegister("c5tap", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = Promise.all([
    $d1Cng("hPzOn"),
    $d1Cng("h2MrD"),
    $d1Cng("bYT2S"),
    $d1Cng("hYbSO")
]).then(()=>parcelRequire('2CYNQ'));

});


parcelRegister("48xaL", function(module, exports) {

$parcel$export(module.exports, "default", () => $1a662e9a3c30efdb$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $1a662e9a3c30efdb$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    filterDetails: {
        "id": "issue-navigator-custom-filters.details-popup.filter-details",
        "defaultMessage": "Filter details"
    }
});

});

parcelRegister("daaJ8", function(module, exports) {

$parcel$export(module.exports, "preloadPopupContentComponent", () => $5d8df9b2f1f656ce$export$c115357d632001d1);
$parcel$export(module.exports, "PopupContent", () => $5d8df9b2f1f656ce$export$2a2c7ba12d3231e3);

var $eUqFw = parcelRequire("eUqFw");

var $7rh0R = parcelRequire("7rh0R");

var $4Bees = parcelRequire("4Bees");

var $gGtKh = parcelRequire("gGtKh");

var $9IbuV = parcelRequire("9IbuV");

var $hLyIA = parcelRequire("hLyIA");

var $bHDAF = parcelRequire("bHDAF");

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $5d8df9b2f1f656ce$var$LazyPopupContent = (0, $7rh0R.lazy)(()=>Promise.resolve((parcelRequire("bHDAF"))), {
    moduleId: "./src/packages/issue-navigator/custom-filters/src/ui/details-popup/popup-content/index.tsx"
});
const $5d8df9b2f1f656ce$export$c115357d632001d1 = ()=>$5d8df9b2f1f656ce$var$LazyPopupContent.preload();
const $5d8df9b2f1f656ce$var$LoadingFallback = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $bHDAF.LoadingWrapper), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4Bees.default), null));
const $5d8df9b2f1f656ce$export$2a2c7ba12d3231e3 = (props)=>{
    (0, $9IbuV.useUFOComponentExperience)((0, $hLyIA.viewDetailsPopupExperience));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gGtKh.default), {
        name: "popup-content",
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($5d8df9b2f1f656ce$var$LoadingFallback, null)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($5d8df9b2f1f656ce$var$LazyPopupContent, props));
};

});
parcelRegister("9IbuV", function(module, exports) {

$parcel$export(module.exports, "useUFOComponentExperience", () => $dfcd8ff9c232688c$export$30ab340faaed55d4);

var $eUqFw = parcelRequire("eUqFw");
const $dfcd8ff9c232688c$var$useConstructor = (callback)=>{
    const hasBeenFired = (0, $eUqFw.useRef)(false);
    if (!hasBeenFired.current) {
        callback();
        hasBeenFired.current = true;
    }
    return null;
};
const $dfcd8ff9c232688c$export$30ab340faaed55d4 = (experience)=>{
    (0, $eUqFw.useEffect)(()=>{
        return ()=>{
            experience.abort();
        };
    // we want this cleanup to only happen on unmount so this is a legit use of empty array
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    $dfcd8ff9c232688c$var$useConstructor(()=>experience.start());
    return null;
};

});

parcelRegister("hLyIA", function(module, exports) {

$parcel$export(module.exports, "viewDetailsPopupExperience", () => $f9f6413bd9b715bd$export$54c37dd263cb6171);
$parcel$export(module.exports, "viewNewSubscriptionModal", () => $f9f6413bd9b715bd$export$1584a1158c503c0a);

var $12kyE = parcelRequire("12kyE");
var $kDfSL = parcelRequire("kDfSL");
const $f9f6413bd9b715bd$export$54c37dd263cb6171 = new (0, $kDfSL.UFOExperience)('jira-issue-navigator.custom-filters.view-details-popup', {
    type: (0, $12kyE.ExperienceTypes).Experience,
    performanceType: (0, $12kyE.ExperiencePerformanceTypes).PageSegmentLoad
});
const $f9f6413bd9b715bd$export$1584a1158c503c0a = new (0, $kDfSL.UFOExperience)('jira-issue-navigator.custom-filters.details-popup.view-new-subscription-modal', {
    type: (0, $12kyE.ExperienceTypes).Experience,
    performanceType: (0, $12kyE.ExperiencePerformanceTypes).PageSegmentLoad
});

});

parcelRegister("bHDAF", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "PopupContent", () => $656fba84bd179ccb$export$2a2c7ba12d3231e3);
$parcel$export(module.exports, "ContentWrapper", () => $656fba84bd179ccb$export$6ce170286acaa8d3);
$parcel$export(module.exports, "default", () => $656fba84bd179ccb$export$2e2bcd8739ae039);
$parcel$export(module.exports, "LoadingWrapper", () => $656fba84bd179ccb$export$43a792a870d28db2);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $iWLL0 = parcelRequire("iWLL0");

var $0cdA8 = parcelRequire("0cdA8");

var $huI7r = parcelRequire("huI7r");

var $8WuJm = parcelRequire("8WuJm");

var $2WfMW = parcelRequire("2WfMW");

var $4rWQe = parcelRequire("4rWQe");
var $dWLk9 = parcelRequire("dWLk9");
var $6yplV = parcelRequire("6yplV");


var $hLyIA = parcelRequire("hLyIA");

var $iCDb4 = parcelRequire("iCDb4");

var $31XX4 = parcelRequire("31XX4");
const $656fba84bd179ccb$export$2a2c7ba12d3231e3 = ({ filterId: filterId, ...props })=>{
    const isAnonymous = (0, $6yplV.useIsAnonymous)();
    const activationId = (0, $4rWQe.useActivationId)();
    const cloudId = (0, $dWLk9.useCloudId)();
    const filterAri = (0, $eUqFw.useMemo)(()=>(0, $huI7r.createAri)({
            resourceOwner: 'jira',
            cloudId: cloudId,
            resourceType: 'filter',
            resourceId: filterId,
            activationId: activationId
        }), [
        filterId,
        activationId,
        cloudId
    ]);
    const [queryReference, loadQuery, disposeQuery] = (0, $iWLL0.useQueryLoader)((0, $2WfMW.default));
    (0, $eUqFw.useEffect)(()=>{
        (0, $hLyIA.viewDetailsPopupExperience).start();
        loadQuery({
            filterAri: filterAri,
            isAnonymous: isAnonymous
        });
        return disposeQuery;
    }, [
        loadQuery,
        filterAri,
        isAnonymous,
        disposeQuery
    ]);
    const onRetry = (0, $eUqFw.useCallback)(()=>{
        loadQuery({
            filterAri: filterAri,
            isAnonymous: isAnonymous
        }, {
            fetchPolicy: 'network-only'
        });
    }, [
        loadQuery,
        filterAri,
        isAnonymous
    ]);
    const ErrorFallback = (0, $eUqFw.useCallback)((errorStateProps)=>{
        (0, $hLyIA.viewDetailsPopupExperience).failure();
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $iCDb4.ErrorState), {
            ...errorStateProps,
            onRetry: onRetry
        });
    }, [
        onRetry
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8WuJm.ContextualAnalyticsData), {
        sourceName: "filterDetails",
        sourceType: (0, $41ea3621645e2acc$export$cae2783c9279926)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($656fba84bd179ccb$export$6ce170286acaa8d3, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $0cdA8.JSErrorBoundary), {
        id: "DetailsPopupContentWrapper",
        packageName: (0, $3e27b2158b878ad6$export$ad257a98f20ee631),
        teamName: "empanada",
        fallback: ErrorFallback,
        key: queryReference?.fetchKey
    }, queryReference ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $31XX4.PopupContent), {
        ...props,
        queryReference: queryReference,
        onSuccess: onRetry
    }) : null)));
};
var $656fba84bd179ccb$export$2e2bcd8739ae039 = $656fba84bd179ccb$export$2a2c7ba12d3231e3;
const $656fba84bd179ccb$export$6ce170286acaa8d3 = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1bsb1vif _1yt4v47k _1reo1wug _18m91wug _c71lqdd9",
            __cmplp.className
        ])
    });
});
const $656fba84bd179ccb$export$43a792a870d28db2 = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = $656fba84bd179ccb$export$6ce170286acaa8d3, style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_y3gn1h6o",
            __cmplp.className
        ])
    });
});

});
parcelRegister("2WfMW", function(module, exports) {

$parcel$export(module.exports, "default", () => $b8afcbab42633374$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<cabde37d42247daed0f55869eb5b6fd9>>
 * @relayHash 9f4cdfd24c4837edbec911e81f56cc4c
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 6bc8c23e9cd41f906771238f4fc28eed8056bad2b96a927b890039d4d973ea8d
const $b8afcbab42633374$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "filterAri"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "isAnonymous"
        }
    ], v1 = [
        {
            "kind": "Variable",
            "name": "id",
            "variableName": "filterAri"
        }
    ], v2 = {
        "kind": "ScalarField",
        "name": "name"
    }, v3 = {
        "kind": "ClientExtension",
        "selections": [
            {
                "kind": "ScalarField",
                "name": "__id"
            }
        ]
    }, v4 = {
        "kind": "ScalarField",
        "name": "__typename"
    }, v5 = {
        "kind": "ScalarField",
        "name": "id"
    }, v6 = {
        "concreteType": "JiraProject",
        "kind": "LinkedField",
        "name": "project",
        "plural": false,
        "selections": [
            v2 /*: any*/ ,
            {
                "kind": "ScalarField",
                "name": "key"
            },
            v5 /*: any*/ 
        ]
    }, v7 = [
        v2 /*: any*/ ,
        v5 /*: any*/ 
    ], v8 = {
        "concreteType": "JiraGroup",
        "kind": "LinkedField",
        "name": "group",
        "plural": false,
        "selections": v7 /*: any*/ 
    }, v9 = {
        "kind": "LinkedField",
        "name": "user",
        "plural": false,
        "selections": [
            v4 /*: any*/ ,
            v2 /*: any*/ ,
            v5 /*: any*/ 
        ]
    }, v10 = [
        {
            "kind": "LinkedField",
            "name": "node",
            "plural": false,
            "selections": [
                v4 /*: any*/ ,
                {
                    "kind": "InlineFragment",
                    "selections": [
                        v6 /*: any*/ 
                    ],
                    "type": "JiraShareableEntityProjectGrant"
                },
                {
                    "kind": "InlineFragment",
                    "selections": [
                        v6 /*: any*/ ,
                        {
                            "concreteType": "JiraRole",
                            "kind": "LinkedField",
                            "name": "role",
                            "plural": false,
                            "selections": v7 /*: any*/ 
                        }
                    ],
                    "type": "JiraShareableEntityProjectRoleGrant"
                },
                {
                    "kind": "InlineFragment",
                    "selections": [
                        v8 /*: any*/ 
                    ],
                    "type": "JiraShareableEntityGroupGrant"
                },
                {
                    "kind": "InlineFragment",
                    "selections": [
                        v9 /*: any*/ 
                    ],
                    "type": "JiraShareableEntityUserGrant"
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "mainPopupContentFilterByAriQuery",
            "selections": [
                {
                    "kind": "RequiredField",
                    "field": {
                        "concreteType": "JiraQuery",
                        "kind": "LinkedField",
                        "name": "jira",
                        "plural": false,
                        "selections": [
                            {
                                "kind": "RequiredField",
                                "field": {
                                    "args": v1 /*: any*/ ,
                                    "kind": "LinkedField",
                                    "name": "filter",
                                    "plural": false,
                                    "selections": [
                                        v2 /*: any*/ ,
                                        {
                                            "kind": "InlineFragment",
                                            "selections": [
                                                {
                                                    "kind": "FragmentSpread",
                                                    "name": "description_issueNavigatorCustomFilters"
                                                },
                                                {
                                                    "condition": "isAnonymous",
                                                    "kind": "Condition",
                                                    "passingValue": false,
                                                    "selections": [
                                                        {
                                                            "kind": "FragmentSpread",
                                                            "name": "owner_issueNavigatorCustomFilters"
                                                        },
                                                        {
                                                            "kind": "FragmentSpread",
                                                            "name": "subscriptions_issueNavigatorCustomFilters"
                                                        }
                                                    ]
                                                },
                                                {
                                                    "kind": "FragmentSpread",
                                                    "name": "permissions_issueNavigatorCustomFilters"
                                                }
                                            ],
                                            "type": "JiraCustomFilter"
                                        },
                                        v3 /*: any*/ 
                                    ]
                                },
                                "action": "THROW",
                                "path": "jira.filter"
                            }
                        ]
                    },
                    "action": "THROW",
                    "path": "jira"
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "mainPopupContentFilterByAriQuery",
            "selections": [
                {
                    "concreteType": "JiraQuery",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "args": v1 /*: any*/ ,
                            "kind": "LinkedField",
                            "name": "filter",
                            "plural": false,
                            "selections": [
                                v4 /*: any*/ ,
                                v2 /*: any*/ ,
                                v5 /*: any*/ ,
                                {
                                    "kind": "InlineFragment",
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "description"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "isEditable"
                                        },
                                        {
                                            "concreteType": "JiraShareableEntityShareGrantConnection",
                                            "kind": "LinkedField",
                                            "name": "shareGrants",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "concreteType": "JiraShareableEntityShareGrantEdge",
                                                    "kind": "LinkedField",
                                                    "name": "edges",
                                                    "plural": true,
                                                    "selections": v10 /*: any*/ 
                                                }
                                            ]
                                        },
                                        {
                                            "concreteType": "JiraShareableEntityEditGrantConnection",
                                            "kind": "LinkedField",
                                            "name": "editGrants",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "concreteType": "JiraShareableEntityEditGrantEdge",
                                                    "kind": "LinkedField",
                                                    "name": "edges",
                                                    "plural": true,
                                                    "selections": v10 /*: any*/ 
                                                }
                                            ]
                                        },
                                        {
                                            "condition": "isAnonymous",
                                            "kind": "Condition",
                                            "passingValue": false,
                                            "selections": [
                                                {
                                                    "kind": "LinkedField",
                                                    "name": "owner",
                                                    "plural": false,
                                                    "selections": [
                                                        v4 /*: any*/ ,
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "accountId"
                                                        },
                                                        v2 /*: any*/ ,
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "picture"
                                                        },
                                                        v5 /*: any*/ 
                                                    ]
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "filterId"
                                                },
                                                {
                                                    "args": [
                                                        {
                                                            "kind": "Literal",
                                                            "name": "last",
                                                            "value": 5
                                                        }
                                                    ],
                                                    "concreteType": "JiraFilterEmailSubscriptionConnection",
                                                    "kind": "LinkedField",
                                                    "name": "emailSubscriptions",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "concreteType": "JiraFilterEmailSubscriptionEdge",
                                                            "kind": "LinkedField",
                                                            "name": "edges",
                                                            "plural": true,
                                                            "selections": [
                                                                {
                                                                    "concreteType": "JiraFilterEmailSubscription",
                                                                    "kind": "LinkedField",
                                                                    "name": "node",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        v5 /*: any*/ ,
                                                                        v9 /*: any*/ ,
                                                                        v8 /*: any*/ 
                                                                    ]
                                                                }
                                                            ]
                                                        }
                                                    ],
                                                    "storageKey": "emailSubscriptions(last:5)"
                                                }
                                            ]
                                        }
                                    ],
                                    "type": "JiraCustomFilter"
                                },
                                v3 /*: any*/ 
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "6bc8c23e9cd41f906771238f4fc28eed8056bad2b96a927b890039d4d973ea8d",
            "metadata": {},
            "name": "mainPopupContentFilterByAriQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$b8afcbab42633374$var$node.hash = "0d557f612ff494f70f6caa72336c5a34";
var $b8afcbab42633374$export$2e2bcd8739ae039 = $b8afcbab42633374$var$node;

});

const $3e27b2158b878ad6$export$ad257a98f20ee631 = 'jiraIssueNavigatorCustomFilters';

parcelRegister("iCDb4", function(module, exports) {

$parcel$export(module.exports, "ErrorState", () => $69a6e204ab391229$export$c1ed4f415b9e7023);

var $eUqFw = parcelRequire("eUqFw");

var $5JgJ2 = parcelRequire("5JgJ2");

var $cBaEp = parcelRequire("cBaEp");

var $2eEdW = parcelRequire("2eEdW");
const $69a6e204ab391229$export$c1ed4f415b9e7023 = ({ error: error, onRetry: onRetry, ...props })=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $cBaEp.ErrorState), {
        ...props,
        onRetry: onRetry,
        description: formatMessage((0, $2eEdW.default).errorMessage),
        pageAction: "detailsPopup"
    });
};

});
parcelRegister("cBaEp", function(module, exports) {

$parcel$export(module.exports, "ErrorState", () => $ef7ae4cf716abcda$export$c1ed4f415b9e7023);

var $eUqFw = parcelRequire("eUqFw");

var $7u4fN = parcelRequire("7u4fN");

var $gw74N = parcelRequire("gw74N");

var $c9TLT = parcelRequire("c9TLT");

var $5JgJ2 = parcelRequire("5JgJ2");

var $jMP2a = parcelRequire("jMP2a");
var $bFzGY = parcelRequire("bFzGY");

var $b1nxp = parcelRequire("b1nxp");

var $i90il = parcelRequire("i90il");
const $ef7ae4cf716abcda$var$BOX_HEIGHT = (0, $c9TLT.gridSize) * 18;
const $ef7ae4cf716abcda$var$ERROR_ICON_BOX_WRAPPER_HEIGHT = (0, $c9TLT.gridSize) * 9;
const $ef7ae4cf716abcda$var$ICON_SIZE = (0, $c9TLT.gridSize) * 9;
const $ef7ae4cf716abcda$export$c1ed4f415b9e7023 = (props)=>{
    const { pageAction: pageAction, onRetry: onRetry, description: description, role: role } = props;
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bFzGY.useAnalyticsEvents)();
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const onClick = ()=>{
        onRetry();
        (0, $jMP2a.fireOperationalAnalytics)(createAnalyticsEvent({}), `${pageAction}Retry clicked`);
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $i90il.StyledBox), {
        height: $ef7ae4cf716abcda$var$BOX_HEIGHT,
        role: role
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $i90il.StyledBox), {
        height: $ef7ae4cf716abcda$var$ERROR_ICON_BOX_WRAPPER_HEIGHT,
        iconSize: $ef7ae4cf716abcda$var$ICON_SIZE
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($gw74N))), {
        color: "var(--ds-icon, #44546F)",
        LEGACY_primaryColor: "var(--ds-icon, #44546F)",
        label: ""
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $i90il.StyledText), null, description !== undefined ? description : formatMessage((0, $b1nxp.default).errorMessage)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7u4fN.default), {
        onClick: onClick,
        appearance: "link",
        testId: "issue-navigator-actions-common.ui.error.button"
    }, formatMessage((0, $b1nxp.default).retryMessage)));
};

});
parcelRegister("b1nxp", function(module, exports) {

$parcel$export(module.exports, "default", () => $a45599fd1dabaf44$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
const $a45599fd1dabaf44$var$messages = (0, $90IgZ.defineMessages)({
    errorMessage: {
        "id": "issue-navigator-actions-common.error.error-message",
        "defaultMessage": "Couldn't retrieve data"
    },
    retryMessage: {
        "id": "issue-navigator-actions-common.error.retry-message",
        "defaultMessage": "Click to retry"
    }
});
var $a45599fd1dabaf44$export$2e2bcd8739ae039 = $a45599fd1dabaf44$var$messages;

});

parcelRegister("i90il", function(module, exports) {

$parcel$export(module.exports, "StyledBox", () => $1347616a23ba87bb$export$d675f139b342d51a);
$parcel$export(module.exports, "StyledText", () => $1347616a23ba87bb$export$31ea92f3997410dd);
/* styled.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");
var $9t7rW = parcelRequire("9t7rW");

var $hI5oG = parcelRequire("hI5oG");
const $1347616a23ba87bb$export$d675f139b342d51a = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { iconSize: iconSize, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmpldp,
        style: {
            ...__cmpls,
            "--_8jvb0j": (0, $9t7rW.default)(__cmplp.height, "px"),
            "--_1kpj8xj": (0, $9t7rW.default)(__cmplp.iconSize, "px")
        },
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_4cvr1h6o _1e0c1txw _2lx21bp4 _4t3i1474 _1bah1h6o _18s8dq2u",
            __cmplp.iconSize && "_w8l51dmb _17521dmb",
            __cmplp.className
        ])
    });
});
const $1347616a23ba87bb$var$StyledTextComponent = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_19pku2gc",
            __cmplp.className
        ])
    });
});
const $1347616a23ba87bb$export$31ea92f3997410dd = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $hI5oG.default), {
        size: "xsmall"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($1347616a23ba87bb$var$StyledTextComponent, props));

});


parcelRegister("2eEdW", function(module, exports) {

$parcel$export(module.exports, "default", () => $37ec60976b313db7$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $37ec60976b313db7$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    errorMessage: {
        "id": "issue-navigator-custom-filters.details-popup.popup-content.error-state.error-message",
        "defaultMessage": "We couldn't display the filter details."
    }
});

});


parcelRegister("31XX4", function(module, exports) {

$parcel$export(module.exports, "PopupContent", () => $1809d373ad9c4120$export$2a2c7ba12d3231e3);

var $2WfMW = parcelRequire("2WfMW");

var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $iWLL0 = parcelRequire("iWLL0");

var $jMP2a = parcelRequire("jMP2a");
var $bFzGY = parcelRequire("bFzGY");

var $6yplV = parcelRequire("6yplV");

var $9LnlF = parcelRequire("9LnlF");

var $4uMrU = parcelRequire("4uMrU");

var $haq7W = parcelRequire("haq7W");

var $iutCW = parcelRequire("iutCW");
const $1809d373ad9c4120$export$2a2c7ba12d3231e3 = ({ queryReference: queryReference, update: update, onSuccess: onSuccessParent, onOpenEditFilterModal: onOpenEditFilterModal, onOpenNewSubscriptionModal: onOpenNewSubscriptionModal })=>{
    const isAnonymous = (0, $6yplV.useIsAnonymous)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bFzGY.useAnalyticsEvents)();
    const { jira: { filter: filter } } = (0, $iWLL0.usePreloadedQuery)((0, $2WfMW.default), queryReference);
    (0, $eUqFw.useEffect)(()=>{
        if (filter) update();
    }, [
        update,
        filter
    ]);
    const environment = (0, $iWLL0.useRelayEnvironment)();
    const onSuccess = (0, $eUqFw.useCallback)(()=>{
        // Invalidate store in case popup is unmounted before query can be reloaded
        (0, $iWLL0.commitLocalUpdate)(environment, (store)=>{
            const filterRecord = store.get(filter.__id);
            if (filterRecord) filterRecord.invalidateRecord();
        }); // Call the success callback from parent in case popup stays open
        onSuccessParent();
    }, [
        environment,
        filter,
        onSuccessParent
    ]);
    (0, $eUqFw.useEffect)(()=>{
        (0, $jMP2a.fireUIAnalytics)(createAnalyticsEvent({
            action: 'viewed',
            actionSubject: 'inlineDialog'
        }), 'filterDetails');
    }, [
        createAnalyticsEvent
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($1809d373ad9c4120$var$FilterTitle, null, filter.name), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $9LnlF.Description), {
        filter: filter,
        onOpenEditFilterModal: onOpenEditFilterModal
    }), !isAnonymous && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4uMrU.Owner), {
        filter: filter
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $haq7W.Permissions), {
        filter: filter,
        onOpenEditFilterModal: onOpenEditFilterModal
    }), !isAnonymous && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $iutCW.Subscriptions), {
        filter: filter,
        onOpenNewSubscriptionModal: onOpenNewSubscriptionModal,
        onSuccess: onSuccess
    }));
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $1809d373ad9c4120$var$FilterTitle = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "h3", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1i4q1hna",
            __cmplp.className
        ])
    });
});

});
parcelRegister("9LnlF", function(module, exports) {

$parcel$export(module.exports, "Description", () => $d735a3860c7ec025$export$393edc798c47379d);

var $8rcVO = parcelRequire("8rcVO");

var $eUqFw = parcelRequire("eUqFw");

var $iWLL0 = parcelRequire("iWLL0");

var $7u4fN = parcelRequire("7u4fN");

var $5JgJ2 = parcelRequire("5JgJ2");

var $jMP2a = parcelRequire("jMP2a");

var $6Qy8u = parcelRequire("6Qy8u");

var $3v8lA = parcelRequire("3v8lA");

var $cwtlN = parcelRequire("cwtlN");

var $1MukO = parcelRequire("1MukO");

var $hLyIA = parcelRequire("hLyIA");

var $9mZxX = parcelRequire("9mZxX");
const $d735a3860c7ec025$export$393edc798c47379d = ({ filter: filter, onOpenEditFilterModal: onOpenEditFilterModal })=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const data = (0, $iWLL0.useFragment)((0, $8rcVO.default), filter);
    const openEditFilterNameAndDescriptionModal = (0, $eUqFw.useCallback)((_, analyticsEvent)=>{
        onOpenEditFilterModal();
        (0, $jMP2a.fireUIAnalytics)(analyticsEvent, 'editFilterNameAndDescription');
    }, [
        onOpenEditFilterModal
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1MukO.Section), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $3v8lA.SectionHeader), {
        actions: data.isEditable === true ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7u4fN.default), {
            onClick: openEditFilterNameAndDescriptionModal,
            appearance: "link",
            spacing: "none",
            testId: "issue-navigator-custom-filters.ui.details-popup.popup-content.description.edit-name-and-description-button"
        }, formatMessage((0, $9mZxX.default).editNameAndDescription)) : null
    }, formatMessage((0, $9mZxX.default).description)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $cwtlN.ShowMore), null, data.description != null && data.description.length ? data.description : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1MukO.PlaceholderText), null, formatMessage((0, $9mZxX.default).descriptionPlaceholder))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $6Qy8u.ExperienceSuccess), {
        experience: (0, $hLyIA.viewDetailsPopupExperience)
    }));
};

});
parcelRegister("8rcVO", function(module, exports) {

$parcel$export(module.exports, "default", () => $19c17e2bbd5ac3c4$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<3d1b4a29cfc95e0b21d359da9825db69>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $19c17e2bbd5ac3c4$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "description_issueNavigatorCustomFilters",
    "selections": [
        {
            "kind": "ScalarField",
            "name": "description"
        },
        {
            "kind": "ScalarField",
            "name": "isEditable"
        }
    ],
    "type": "JiraCustomFilter"
};
$19c17e2bbd5ac3c4$var$node.hash = "f9b450af0990be0be18e39994e4e39db";
var $19c17e2bbd5ac3c4$export$2e2bcd8739ae039 = $19c17e2bbd5ac3c4$var$node;

});

parcelRegister("3v8lA", function(module, exports) {

$parcel$export(module.exports, "SectionHeader", () => $6bb444347ca5aaf6$export$8adb256d999cd5a0);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $9Amv1 = parcelRequire("9Amv1");

var $c9TLT = parcelRequire("c9TLT");

var $6yplV = parcelRequire("6yplV");
const $6bb444347ca5aaf6$export$8adb256d999cd5a0 = ({ actions: actions, children: children })=>{
    const isAnonymous = (0, $6yplV.useIsAnonymous)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $9Amv1.default), {
        alignBlock: "center",
        spread: "space-between",
        space: "space.100",
        shouldWrap: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($6bb444347ca5aaf6$var$HeaderText, null, children), actions != null && !isAnonymous && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($6bb444347ca5aaf6$var$ActionsContainer, null, actions));
};
const $6bb444347ca5aaf6$var$HEADER_FONT_SIZE = (0, $c9TLT.fontSize);
const $6bb444347ca5aaf6$var$LINE_HEIGHT = 1.25;
const $6bb444347ca5aaf6$export$cdb7fd9d999c7168 = $6bb444347ca5aaf6$var$HEADER_FONT_SIZE * $6bb444347ca5aaf6$var$LINE_HEIGHT;
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $6bb444347ca5aaf6$var$HeaderText = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "h4", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_vwz410nf _1wybdlk8",
            __cmplp.className
        ])
    });
});
const $6bb444347ca5aaf6$var$ActionsContainer = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_vwz410nf _1wybdlk8 _k48p4jg8 _1q9t4jg8",
            __cmplp.className
        ])
    });
});

});

parcelRegister("cwtlN", function(module, exports) {

$parcel$export(module.exports, "ShowMore", () => $b5473e0957cc1354$export$ca7697601dcd7803);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");
var $9t7rW = parcelRequire("9t7rW");

var $7u4fN = parcelRequire("7u4fN");

var $5JgJ2 = parcelRequire("5JgJ2");

var $87jqX = parcelRequire("87jqX");
const $b5473e0957cc1354$var$DEFAULT_MAX_HEIGHT = 200;
const $b5473e0957cc1354$export$ca7697601dcd7803 = ({ children: children, maxHeight: maxHeight = $b5473e0957cc1354$var$DEFAULT_MAX_HEIGHT })=>{
    const contentRef = /*#__PURE__*/ (0, $eUqFw.createRef)();
    const [shouldShowShowMore, setShouldShowShowMore] = (0, $eUqFw.useState)(false);
    const [collapsed, setCollapsed] = (0, $eUqFw.useState)(true);
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    (0, $eUqFw.useEffect)(()=>{
        if (contentRef.current !== null && contentRef.current.clientHeight > maxHeight) setShouldShowShowMore(true);
    }, [
        contentRef,
        maxHeight
    ]);
    const toggleShowMore = (0, $eUqFw.useCallback)(()=>{
        setCollapsed(!collapsed);
    }, [
        collapsed
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($b5473e0957cc1354$var$Container, {
        collapsed: collapsed,
        maxHeight: maxHeight
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("p", {
        ref: contentRef
    }, children)), shouldShowShowMore && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($b5473e0957cc1354$var$ButtonContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7u4fN.default), {
        appearance: "link",
        spacing: "none",
        onClick: toggleShowMore
    }, collapsed ? formatMessage((0, $87jqX.default).showMore) : formatMessage((0, $87jqX.default).showLess))));
};
const $b5473e0957cc1354$var$Container = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { collapsed: collapsed, maxHeight: maxHeight, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmpldp,
        style: {
            ...__cmpls,
            "--_1upm8ip": (0, $9t7rW.default)(__cmplp.maxHeight, "px")
        },
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_18s81bpf _14cp1hna",
            __cmplp.collapsed && "_c71l1w9o _1reo15vq _18m915vq",
            __cmplp.className
        ])
    });
});
const $b5473e0957cc1354$var$ButtonContainer = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1q9t4jg8",
            __cmplp.className
        ])
    });
});

});
parcelRegister("87jqX", function(module, exports) {

$parcel$export(module.exports, "default", () => $79003edd8702ab19$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $79003edd8702ab19$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    showMore: {
        "id": "issue-navigator-custom-filters.common.details-popup.show-more.show-more",
        "defaultMessage": "Show more..."
    },
    showLess: {
        "id": "issue-navigator-custom-filters.common.details-popup.show-more.show-less",
        "defaultMessage": "Show less"
    }
});

});


parcelRegister("1MukO", function(module, exports) {

$parcel$export(module.exports, "PlaceholderText", () => $7f3839abc442c71c$export$5dd7e4f3fa008590);
$parcel$export(module.exports, "Section", () => $7f3839abc442c71c$export$6e2c8f0811a474ce);
$parcel$export(module.exports, "SectionBodyTitle", () => $7f3839abc442c71c$export$1d69e81357d9c7e8);
$parcel$export(module.exports, "SectionBody", () => $7f3839abc442c71c$export$e7049d4e10b2bdab);
/* styled.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");
const $7f3839abc442c71c$export$5dd7e4f3fa008590 = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $eUqFw.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_syaz1e9r",
            __cmplp.className
        ])
    });
});
const $7f3839abc442c71c$export$6e2c8f0811a474ce = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $eUqFw.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_n7zlh6cr _syaz1dv3 _1yt4r2fv _1lh4glyw _j2v5utpp",
            __cmplp.className
        ])
    });
});
const $7f3839abc442c71c$export$1d69e81357d9c7e8 = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "h5", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $eUqFw.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_syazaj1x _11c816g6 _vwz410yn _19pkidpf _2hwxidpf _otyridpf _18u0idpf _19pkpxbi",
            __cmplp.className
        ])
    });
});
const $7f3839abc442c71c$export$e7049d4e10b2bdab = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "p", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $eUqFw.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_syaz2l1e _vwz4gktf _19pkidpf _2hwxidpf _otyridpf _18u0idpf",
            __cmplp.className
        ])
    });
});

});

parcelRegister("9mZxX", function(module, exports) {

$parcel$export(module.exports, "default", () => $ca2d3d1f9b5e488d$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $ca2d3d1f9b5e488d$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    description: {
        "id": "issue-navigator-custom-filters.details-popup.popup-content.description.description",
        "defaultMessage": "Description"
    },
    editNameAndDescription: {
        "id": "issue-navigator-custom-filters.details-popup.popup-content.description.edit-name-and-description",
        "defaultMessage": "Edit name and description"
    },
    descriptionPlaceholder: {
        "id": "issue-navigator-custom-filters.details-popup.popup-content.description.description-placeholder",
        "defaultMessage": "This filter doesn't have a description."
    }
});

});


parcelRegister("4uMrU", function(module, exports) {

$parcel$export(module.exports, "Owner", () => $261f6fac82080cb3$export$25fb39c3824c9c44);

var $hCXch = parcelRequire("hCXch");

var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $iWLL0 = parcelRequire("iWLL0");

var $iJlfe = parcelRequire("iJlfe");

var $b5IAe = parcelRequire("b5IAe");
var $1ZAYh = parcelRequire("1ZAYh");

var $dnbhd = parcelRequire("dnbhd");

var $3x4sL = parcelRequire("3x4sL");

var $5JgJ2 = parcelRequire("5JgJ2");

var $jMP2a = parcelRequire("jMP2a");

var $490IT = parcelRequire("490IT");

var $2NwGr = parcelRequire("2NwGr");

var $gd0Sp = parcelRequire("gd0Sp");

var $1MukO = parcelRequire("1MukO");

var $dvxZd = parcelRequire("dvxZd");
const $261f6fac82080cb3$var$PROFILE_ACTIONS = [
    (0, $2f37035f7aaf1787$export$23cedd3261bd8015),
    (0, $2f37035f7aaf1787$export$56da0dd0b0aa67b9)
];
const $261f6fac82080cb3$export$25fb39c3824c9c44 = ({ filter: filter })=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const { owner: owner } = (0, $iWLL0.useFragment)((0, $hCXch.default), filter);
    const onOwnerLinkClick = (0, $eUqFw.useCallback)((_, analyticsEvent)=>{
        (0, $jMP2a.fireUIAnalytics)(analyticsEvent, 'filterOwner', {
            filterOwnerId: owner.accountId
        });
    }, [
        owner.accountId
    ]);
    const UserLink = (0, $eUqFw.useCallback)(({ children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $dnbhd.default), {
            href: (0, $490IT.generateUserLink)(owner.accountId),
            onClick: onOwnerLinkClick
        }, children), [
        owner.accountId,
        onOwnerLinkClick
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1MukO.Section), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($261f6fac82080cb3$var$OwnerContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
        xcss: $261f6fac82080cb3$var$avatarContainerStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $iJlfe.default), {
        src: owner.picture,
        size: "large",
        testId: "issue-navigator-custom-filters.ui.details-popup.popup-content.owner.avatar"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $2NwGr.AsyncProfileCardNext), {
        accountId: owner.accountId,
        TenantContextSubscriber: (0, $gd0Sp.TenantContextSubscriber),
        actions: $261f6fac82080cb3$var$PROFILE_ACTIONS
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $3x4sL.FormattedI18nMessage), {
        componentsMapping: {
            link: UserLink
        },
        message: formatMessage((0, $dvxZd.default).ownedBy, {
            ownerName: owner.name,
            linkStart: '{linkStart}',
            linkEnd: '{linkEnd}'
        })
    }))));
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $261f6fac82080cb3$var$OwnerContainer = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _4cvr1h6o _2lx2vrvc",
            __cmplp.className
        ])
    });
});
const $261f6fac82080cb3$var$avatarContainerStyles = (0, $1ZAYh.xcss)({
    marginRight: 'space.100'
});

});
parcelRegister("hCXch", function(module, exports) {

$parcel$export(module.exports, "default", () => $b7cd5934fc389c38$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<c93155984576afec4ca63b038a3900cd>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $b7cd5934fc389c38$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "owner_issueNavigatorCustomFilters",
    "selections": [
        {
            "kind": "RequiredField",
            "field": {
                "kind": "LinkedField",
                "name": "owner",
                "plural": false,
                "selections": [
                    {
                        "kind": "ScalarField",
                        "name": "accountId"
                    },
                    {
                        "kind": "ScalarField",
                        "name": "name"
                    },
                    {
                        "kind": "ScalarField",
                        "name": "picture"
                    }
                ]
            },
            "action": "THROW",
            "path": "owner"
        }
    ],
    "type": "JiraCustomFilter"
};
$b7cd5934fc389c38$var$node.hash = "cb1b46f3f320b4c4793ee7c164c198c7";
var $b7cd5934fc389c38$export$2e2bcd8739ae039 = $b7cd5934fc389c38$var$node;

});

parcelRegister("dnbhd", function(module, exports) {

$parcel$export(module.exports, "default", () => $92444a2f8aee76e7$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $eGI9v = parcelRequire("eGI9v");

var $lB25E = parcelRequire("lB25E");
function $92444a2f8aee76e7$var$Link(props) {
    const { children: children, ...rest } = props;
    delete rest.createAnalyticsEvent;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $lB25E.Link), rest, children);
}
var $92444a2f8aee76e7$export$2e2bcd8739ae039 = (0, $eGI9v.default)('link', {
    onClick: 'clicked'
})($92444a2f8aee76e7$var$Link);

});

parcelRegister("490IT", function(module, exports) {

$parcel$export(module.exports, "generateUserLink", () => $8b4d5377460cf9d7$export$f4673d7e11341514);
$parcel$export(module.exports, "generateTeamLink", () => $8b4d5377460cf9d7$export$b163ce931504dcff);
$parcel$export(module.exports, "isTeamProfileCardEventContentRendered", () => $8b4d5377460cf9d7$export$6dc006c3779708c0);
$parcel$export(module.exports, "fireLegacyTeamAnalytics", () => $8b4d5377460cf9d7$export$ffbbcf55d672ec61);

var $jMP2a = parcelRequire("jMP2a");
const $8b4d5377460cf9d7$export$f4673d7e11341514 = (userId)=>`/jira/people/${userId}`;
const $8b4d5377460cf9d7$export$b163ce931504dcff = (teamId)=>`/jira/people/team/${teamId}`;
const $8b4d5377460cf9d7$export$7b55c373f7e07896 = (label, profileUrl)=>({
        id: 'view-profile',
        label: label,
        callback: (event)=>{
            event.stopPropagation();
            window.open(profileUrl);
        }
    });
const $8b4d5377460cf9d7$export$6dc006c3779708c0 = (analyticsPayload)=>analyticsPayload?.action === 'rendered' && analyticsPayload?.actionSubjectId === 'content';
const $8b4d5377460cf9d7$export$ffbbcf55d672ec61 = (analyticsEvent)=>{
    if (analyticsEvent?.payload?.eventType === 'ui') {
        (0, $jMP2a.fireUIAnalytics)(analyticsEvent, `legacyTeamProfileCard ${analyticsEvent.payload.action}}`);
        if ($8b4d5377460cf9d7$export$6dc006c3779708c0(analyticsEvent?.payload)) (0, $jMP2a.fireScreenAnalytics)(analyticsEvent);
    }
};

});

parcelRegister("2NwGr", function(module, exports) {

$parcel$export(module.exports, "AsyncProfileCardNext", () => $d91bacdeb64d663f$export$a3c0845f856d4292);

var $eUqFw = parcelRequire("eUqFw");

var $7rh0R = parcelRequire("7rh0R");

var $0cdA8 = parcelRequire("0cdA8");

var $1lXFP = parcelRequire("1lXFP");

var $gGtKh = parcelRequire("gGtKh");


// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $d91bacdeb64d663f$var$LazyComponent = (0, $7rh0R.lazy)(()=>(parcelRequire("kvLbC")).then((module)=>module.ProfileCard), {
    moduleId: "./src/packages/profilecard-next/src/main.tsx"
});
const $d91bacdeb64d663f$export$a3c0845f856d4292 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $0cdA8.JSErrorBoundary), {
        id: "AsyncProfileCardNext",
        packageName: "jiraProfilecardNext",
        render: ()=>// props.children in this context is the code being wrapped
            // in a <ProfileCardTrigger> (I.e. it is the thing a user hovers over to
            // display a profile card).
            // In the event of an unexpected error within @atlaskit/profilecard,
            // just render the unwrapped children (I.e. they will render but nothing
            // happens on hover)
            /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, props.children),
        sendToPrivacyUnsafeSplunk: true,
        teamName: "empanada",
        attributes: (0, $1lXFP.isLoaderErrorAttributes)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gGtKh.default), {
        name: "async-profile-card-next-view",
        fallback: props.children
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($d91bacdeb64d663f$var$LazyComponent, props)));
var $d91bacdeb64d663f$export$2e2bcd8739ae039 = $d91bacdeb64d663f$export$a3c0845f856d4292;

});
// values which are passed into the tracking callback by atlaskit
const $2f37035f7aaf1787$export$febebefae5a09065 = 'profile-card.loaded';
const $2f37035f7aaf1787$export$3ca1936ee743bd18 = 'profile-card.view';
const $2f37035f7aaf1787$export$25bd35f2cd9ae0ea = 'profile-card.reload';
const $2f37035f7aaf1787$export$86aa8b9c379ebbbd = 'profile-card.error';
const $2f37035f7aaf1787$export$4442e31da6ba4127 = 'profile-card.click';
const $2f37035f7aaf1787$export$7ecd9c56ca354ac0 = 'profileCardNext';
const $2f37035f7aaf1787$export$81319ffa9c0d18d7 = 'profileCardNext';
const $2f37035f7aaf1787$export$3145fc6c544ad7bf = 'profileCardNextLegacy';
const $2f37035f7aaf1787$export$50632e21ea714398 = 'profileCardNextLegacy';
const $2f37035f7aaf1787$export$d053e144c034c8aa = 'teamProfileCardNextLegacy';
const $2f37035f7aaf1787$export$2549357601611c61 = 'loadError';
const $2f37035f7aaf1787$export$23cedd3261bd8015 = 'viewProfile';
const $2f37035f7aaf1787$export$6bef782d14a92db8 = 'assignedIssues';
const $2f37035f7aaf1787$export$6b36f20db7a18a86 = 'reportedIssues';
const $2f37035f7aaf1787$export$56da0dd0b0aa67b9 = 'viewFilters';

parcelRegister("kvLbC", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = Promise.all([
    $d1Cng("2hmUs"),
    $d1Cng("bCeK4"),
    $d1Cng("h2MrD"),
    $d1Cng("bYT2S"),
    $d1Cng("hPzOn"),
    $d1Cng("keVAk")
]).then(()=>parcelRequire('12NzK'));

});


parcelRegister("dvxZd", function(module, exports) {

$parcel$export(module.exports, "default", () => $ad864e7c8c980878$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $ad864e7c8c980878$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    ownedBy: {
        "id": "issue-navigator-custom-filters.details-popup.popup-content.owner.owned-by",
        "defaultMessage": "Owned by {linkStart}{ownerName}{linkEnd}"
    }
});

});


parcelRegister("haq7W", function(module, exports) {

$parcel$export(module.exports, "Permissions", () => $530578138fbd4655$export$2d41982586bbb6be);

var $7FI9b = parcelRequire("7FI9b");

var $eUqFw = parcelRequire("eUqFw");

var $iWLL0 = parcelRequire("iWLL0");

var $7u4fN = parcelRequire("7u4fN");

var $5JgJ2 = parcelRequire("5JgJ2");

var $jMP2a = parcelRequire("jMP2a");

var $3v8lA = parcelRequire("3v8lA");

var $1MukO = parcelRequire("1MukO");

var $7lawF = parcelRequire("7lawF");

var $ckTc8 = parcelRequire("ckTc8");

var $4sACA = parcelRequire("4sACA");
const $530578138fbd4655$export$2d41982586bbb6be = ({ filter: filter, onOpenEditFilterModal: onOpenEditFilterModal })=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const filterData = (0, $iWLL0.useFragment)((0, $7FI9b.default), filter);
    const onOpenEditPermissionsModal = (0, $eUqFw.useCallback)((_, analyticsEvent)=>{
        onOpenEditFilterModal();
        (0, $jMP2a.fireUIAnalytics)(analyticsEvent, 'editFilterPermissions');
    }, [
        onOpenEditFilterModal
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1MukO.Section), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $3v8lA.SectionHeader), {
        actions: filterData.isEditable === true ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7u4fN.default), {
            onClick: onOpenEditPermissionsModal,
            appearance: "link",
            spacing: "none",
            testId: "issue-navigator-custom-filters.ui.details-popup.popup-content.permissions.edit-permissions-button"
        }, formatMessage((0, $4sACA.default).editPermissions)) : null
    }, formatMessage((0, $4sACA.default).permissions)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7lawF.Access), {
        filter: filterData
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $ckTc8.Edit), {
        filter: filterData
    }));
};

});
parcelRegister("7FI9b", function(module, exports) {

$parcel$export(module.exports, "default", () => $7a735c3e59a01e4f$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<0a1736a97120f52a454a8b09e8d9dd6e>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $7a735c3e59a01e4f$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "permissions_issueNavigatorCustomFilters",
    "selections": [
        {
            "kind": "FragmentSpread",
            "name": "access_issueNavigatorCustomFilters"
        },
        {
            "kind": "FragmentSpread",
            "name": "edit_issueNavigatorCustomFilters"
        },
        {
            "kind": "ScalarField",
            "name": "isEditable"
        }
    ],
    "type": "JiraCustomFilter"
};
$7a735c3e59a01e4f$var$node.hash = "31add9aa56167a062969a5bd4dfaec78";
var $7a735c3e59a01e4f$export$2e2bcd8739ae039 = $7a735c3e59a01e4f$var$node;

});

parcelRegister("7lawF", function(module, exports) {

$parcel$export(module.exports, "Access", () => $70c8e75f9df1aead$export$3026e5a52c747d2c);

var $lGs4Z = parcelRequire("lGs4Z");

var $eUqFw = parcelRequire("eUqFw");

var $iWLL0 = parcelRequire("iWLL0");

var $5JgJ2 = parcelRequire("5JgJ2");

var $5XnMI = parcelRequire("5XnMI");

var $fJbsV = parcelRequire("fJbsV");

var $f6n7J = parcelRequire("f6n7J");

var $1MukO = parcelRequire("1MukO");

var $hq0hv = parcelRequire("hq0hv");

var $h3eoP = parcelRequire("h3eoP");

var $9sww0 = parcelRequire("9sww0");
const $70c8e75f9df1aead$export$3026e5a52c747d2c = ({ filter: filter })=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const { shareGrants: shareGrants } = (0, $iWLL0.useFragment)((0, $lGs4Z.default), filter);
    const users = (0, $eUqFw.useMemo)(()=>shareGrants?.edges && shareGrants.edges?.length > 0 ? shareGrants?.edges.filter((shareableEntity)=>shareableEntity?.node && shareableEntity.node.__typename === 'JiraShareableEntityUserGrant').map((shareableEntity)=>shareableEntity?.node?.user ? shareableEntity.node.user.name : '') : [], [
        shareGrants?.edges
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1MukO.SectionBodyTitle), null, formatMessage((0, $9sww0.default).visibleTo)), shareGrants?.edges && shareGrants.edges.length > 0 ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, // using index as key because these relations don't have individual IDs
    shareGrants.edges.map((shareableEntity, key)=>{
        if (shareableEntity?.node) {
            const { __typename: __typename } = shareableEntity.node;
            if (__typename === 'JiraShareableEntityProjectGrant') return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $fJbsV.ProjectGrant), {
                key: key,
                entity: shareableEntity.node
            });
            if (__typename === 'JiraShareableEntityProjectRoleGrant') return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $f6n7J.ProjectRoleGrant), {
                key: key,
                entity: shareableEntity.node
            });
            if (__typename === 'JiraShareableEntityGroupGrant') return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5XnMI.GroupGrant), {
                key: key,
                entity: shareableEntity.node
            });
            if (__typename === 'JiraShareableEntityAnonymousAccessGrant') return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1MukO.SectionBody), {
                key: key
            }, formatMessage((0, $9sww0.default).public));
            if (__typename === 'JiraShareableEntityAnyLoggedInUserGrant') return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1MukO.SectionBody), {
                key: key
            }, formatMessage((0, $9sww0.default).loggedInUsers));
            if (__typename === 'JiraShareableEntityUnknownProjectGrant') return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $hq0hv.UnknownProject), {
                key: key
            });
        }
        return null;
    }), users.length > 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $h3eoP.UsersGrant), {
        users: users
    })) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1MukO.SectionBody), null, formatMessage((0, $9sww0.default).private)));
};

});
parcelRegister("lGs4Z", function(module, exports) {

$parcel$export(module.exports, "default", () => $8d5c8df56a534561$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<8590f541f77918db05103a0e59693617>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $8d5c8df56a534561$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "access_issueNavigatorCustomFilters",
    "selections": [
        {
            "concreteType": "JiraShareableEntityShareGrantConnection",
            "kind": "LinkedField",
            "name": "shareGrants",
            "plural": false,
            "selections": [
                {
                    "concreteType": "JiraShareableEntityShareGrantEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                        {
                            "kind": "LinkedField",
                            "name": "node",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "__typename"
                                },
                                {
                                    "kind": "FragmentSpread",
                                    "name": "projectGrant_issueNavigatorCustomFilters"
                                },
                                {
                                    "kind": "FragmentSpread",
                                    "name": "projectRoleGrant_issueNavigatorCustomFilters"
                                },
                                {
                                    "kind": "FragmentSpread",
                                    "name": "groupGrant_issueNavigatorCustomFilters"
                                },
                                {
                                    "kind": "InlineFragment",
                                    "selections": [
                                        {
                                            "kind": "LinkedField",
                                            "name": "user",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "name"
                                                }
                                            ]
                                        }
                                    ],
                                    "type": "JiraShareableEntityUserGrant"
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    ],
    "type": "JiraCustomFilter"
};
$8d5c8df56a534561$var$node.hash = "723acfaab9c38e502d502422ae67f3e2";
var $8d5c8df56a534561$export$2e2bcd8739ae039 = $8d5c8df56a534561$var$node;

});

parcelRegister("5XnMI", function(module, exports) {

$parcel$export(module.exports, "GroupGrant", () => $d3a84620559a0074$export$7ab94d64a59792d5);

var $euaCZ = parcelRequire("euaCZ");

var $eUqFw = parcelRequire("eUqFw");

var $iWLL0 = parcelRequire("iWLL0");

var $5JgJ2 = parcelRequire("5JgJ2");

var $1MukO = parcelRequire("1MukO");

var $6HKDE = parcelRequire("6HKDE");
const $d3a84620559a0074$export$7ab94d64a59792d5 = ({ entity: entity })=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const groupGrant = (0, $iWLL0.useFragment)((0, $euaCZ.default), entity);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1MukO.SectionBody), null, groupGrant.group && groupGrant.group?.name !== undefined && formatMessage((0, $6HKDE.default).groupName, {
        name: groupGrant.group?.name
    }));
};

});
parcelRegister("euaCZ", function(module, exports) {

$parcel$export(module.exports, "default", () => $b3221eb9355d74f3$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<fb505eeac796a265fa1c28cfccde9545>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $b3221eb9355d74f3$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "groupGrant_issueNavigatorCustomFilters",
    "selections": [
        {
            "concreteType": "JiraGroup",
            "kind": "LinkedField",
            "name": "group",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "name"
                }
            ]
        }
    ],
    "type": "JiraShareableEntityGroupGrant"
};
$b3221eb9355d74f3$var$node.hash = "5d137f8bd705292955fe74f248e79b45";
var $b3221eb9355d74f3$export$2e2bcd8739ae039 = $b3221eb9355d74f3$var$node;

});

parcelRegister("6HKDE", function(module, exports) {

$parcel$export(module.exports, "default", () => $682ddc0753ee322c$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $682ddc0753ee322c$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    groupName: {
        "id": "issue-navigator-custom-filters.common.details-popup.group-grant.group-name",
        "defaultMessage": "Group: {name}"
    }
});

});


parcelRegister("fJbsV", function(module, exports) {

$parcel$export(module.exports, "ProjectGrant", () => $422c2bc49b0bd03c$export$c0fe5a638e35f019);

var $lIG4S = parcelRequire("lIG4S");

var $eUqFw = parcelRequire("eUqFw");

var $iWLL0 = parcelRequire("iWLL0");

var $5OdZ3 = parcelRequire("5OdZ3");

var $dnbhd = parcelRequire("dnbhd");

var $dnJL9 = parcelRequire("dnJL9");

var $3x4sL = parcelRequire("3x4sL");

var $5JgJ2 = parcelRequire("5JgJ2");

var $jMP2a = parcelRequire("jMP2a");

var $1MukO = parcelRequire("1MukO");

var $7fDPB = parcelRequire("7fDPB");
const $422c2bc49b0bd03c$var$linkStart = '{linkStart}';
const $422c2bc49b0bd03c$var$linkEnd = '{linkEnd}';
const $422c2bc49b0bd03c$var$ConditionalLink = (0, $dnJL9.componentWithFG)('nin_serious_accessibility_issues', (0, $5OdZ3.default), (0, $dnbhd.default));
const $422c2bc49b0bd03c$export$c0fe5a638e35f019 = ({ entity: entity })=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const projectGrant = (0, $iWLL0.useFragment)((0, $lIG4S.default), entity);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1MukO.SectionBody), null, projectGrant.project?.name && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $3x4sL.FormattedI18nMessage), {
        componentsMapping: {
            link: ({ children: children })=>projectGrant.project?.key ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($422c2bc49b0bd03c$var$ConditionalLink, {
                    href: `/browse/${projectGrant.project?.key}`,
                    onClick: (_, analyticsEvent)=>(0, $jMP2a.fireUIAnalytics)(analyticsEvent, 'projectGrant')
                }, children) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, children)
        },
        message: formatMessage((0, $7fDPB.default).projectNameLink, {
            name: projectGrant.project?.name,
            linkStart: $422c2bc49b0bd03c$var$linkStart,
            linkEnd: $422c2bc49b0bd03c$var$linkEnd
        })
    }));
};

});
parcelRegister("lIG4S", function(module, exports) {

$parcel$export(module.exports, "default", () => $5366e79b80c887be$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<830b56b1c6fd2336014f37af74b87fba>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $5366e79b80c887be$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "projectGrant_issueNavigatorCustomFilters",
    "selections": [
        {
            "concreteType": "JiraProject",
            "kind": "LinkedField",
            "name": "project",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "name"
                },
                {
                    "kind": "ScalarField",
                    "name": "key"
                }
            ]
        }
    ],
    "type": "JiraShareableEntityProjectGrant"
};
$5366e79b80c887be$var$node.hash = "a6f0045e8c355671600e72844955bb81";
var $5366e79b80c887be$export$2e2bcd8739ae039 = $5366e79b80c887be$var$node;

});

parcelRegister("7fDPB", function(module, exports) {

$parcel$export(module.exports, "default", () => $85188e01abc5704d$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $85188e01abc5704d$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    projectNameLink: {
        "id": "issue-navigator-custom-filters.common.details-popup.project-grant.project-name-link",
        "defaultMessage": "Project: {linkStart}{name}{linkEnd} (Everyone)"
    }
});

});


parcelRegister("f6n7J", function(module, exports) {

$parcel$export(module.exports, "ProjectRoleGrant", () => $033c7b2ef02db4e8$export$7da97d7ea4daa99e);

var $esTAR = parcelRequire("esTAR");

var $eUqFw = parcelRequire("eUqFw");

var $iWLL0 = parcelRequire("iWLL0");

var $5OdZ3 = parcelRequire("5OdZ3");

var $dnbhd = parcelRequire("dnbhd");

var $dnJL9 = parcelRequire("dnJL9");

var $3x4sL = parcelRequire("3x4sL");

var $5JgJ2 = parcelRequire("5JgJ2");

var $jMP2a = parcelRequire("jMP2a");

var $1MukO = parcelRequire("1MukO");

var $6glAt = parcelRequire("6glAt");
const $033c7b2ef02db4e8$var$linkStart = '{linkStart}';
const $033c7b2ef02db4e8$var$linkEnd = '{linkEnd}';
const $033c7b2ef02db4e8$var$ConditionalLink = (0, $dnJL9.componentWithFG)('nin_serious_accessibility_issues', (0, $5OdZ3.default), (0, $dnbhd.default));
const $033c7b2ef02db4e8$export$7da97d7ea4daa99e = ({ entity: entity })=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const projectRoleGrant = (0, $iWLL0.useFragment)((0, $esTAR.default), entity);
    const message = formatMessage((0, $6glAt.default).projectRoleNameLink, {
        name: projectRoleGrant.project?.name,
        role: projectRoleGrant.role?.name,
        linkStart: $033c7b2ef02db4e8$var$linkStart,
        linkEnd: $033c7b2ef02db4e8$var$linkEnd
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1MukO.SectionBody), null, projectRoleGrant.project?.name !== undefined && projectRoleGrant.role?.name !== undefined && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $3x4sL.FormattedI18nMessage), {
        componentsMapping: {
            link: ({ children: children })=>projectRoleGrant.project?.key ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($033c7b2ef02db4e8$var$ConditionalLink, {
                    href: `/browse/${projectRoleGrant.project?.key}`,
                    onClick: (_, analyticsEvent)=>(0, $jMP2a.fireUIAnalytics)(analyticsEvent, 'projectRoleGrant')
                }, children) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, children)
        },
        message: message
    }));
};

});
parcelRegister("esTAR", function(module, exports) {

$parcel$export(module.exports, "default", () => $b145fd49321639bb$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<cfc9b47a86609e2981aad8da17fded50>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $b145fd49321639bb$var$node = function() {
    var v0 = {
        "kind": "ScalarField",
        "name": "name"
    };
    return {
        "argumentDefinitions": [],
        "kind": "Fragment",
        "name": "projectRoleGrant_issueNavigatorCustomFilters",
        "selections": [
            {
                "concreteType": "JiraProject",
                "kind": "LinkedField",
                "name": "project",
                "plural": false,
                "selections": [
                    v0 /*: any*/ ,
                    {
                        "kind": "ScalarField",
                        "name": "key"
                    }
                ]
            },
            {
                "concreteType": "JiraRole",
                "kind": "LinkedField",
                "name": "role",
                "plural": false,
                "selections": [
                    v0 /*: any*/ 
                ]
            }
        ],
        "type": "JiraShareableEntityProjectRoleGrant"
    };
}();
$b145fd49321639bb$var$node.hash = "0353d445a52987cb7c245d2ca5cd2d8c";
var $b145fd49321639bb$export$2e2bcd8739ae039 = $b145fd49321639bb$var$node;

});

parcelRegister("6glAt", function(module, exports) {

$parcel$export(module.exports, "default", () => $8f15c2f34aa5f8b6$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $8f15c2f34aa5f8b6$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    projectRoleNameLink: {
        "id": "issue-navigator-custom-filters.common.details-popup.project-role-grant.project-role-name-link",
        "defaultMessage": "Project: {linkStart}{name}{linkEnd} ({role})"
    }
});

});


parcelRegister("hq0hv", function(module, exports) {

$parcel$export(module.exports, "UnknownProject", () => $2e69df7293ff1226$export$a8bd5ea331aa2c2c);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $ioiQ7 = parcelRequire("ioiQ7");

var $8cU5f = parcelRequire("8cU5f");

var $5JgJ2 = parcelRequire("5JgJ2");

var $1MukO = parcelRequire("1MukO");

var $4QDe3 = parcelRequire("4QDe3");
const $2e69df7293ff1226$export$a8bd5ea331aa2c2c = ()=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1MukO.SectionBody), null, formatMessage((0, $4QDe3.default).unknownProject), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8cU5f.default), {
        content: formatMessage((0, $4QDe3.default).infoTooltip),
        tag: $2e69df7293ff1226$var$QuestionCircleIconWrapper
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($ioiQ7))), {
        label: formatMessage((0, $4QDe3.default).infoTooltip),
        size: "small"
    })));
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $2e69df7293ff1226$var$QuestionCircleIconWrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1o8l _19bv1b66 _s7n4nkob _80omtlke",
            __cmplp.className
        ])
    });
});

});
parcelRegister("4QDe3", function(module, exports) {

$parcel$export(module.exports, "default", () => $9b4235735a3b7b45$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $9b4235735a3b7b45$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    unknownProject: {
        "id": "issue-navigator-custom-filters.common.details-popup.unknown-project.unknown-project",
        "defaultMessage": "Project: unknown"
    },
    infoTooltip: {
        "id": "issue-navigator-custom-filters.common.details-popup.unknown-project.info-tooltip",
        "defaultMessage": "You do not have access to this project"
    }
});

});


parcelRegister("h3eoP", function(module, exports) {

$parcel$export(module.exports, "UsersGrant", () => $7a8de7d0f8fd9de7$export$eafe47c6bcbc8617);

var $eUqFw = parcelRequire("eUqFw");

var $5JgJ2 = parcelRequire("5JgJ2");

var $1MukO = parcelRequire("1MukO");

var $dziwa = parcelRequire("dziwa");
const $7a8de7d0f8fd9de7$export$eafe47c6bcbc8617 = ({ users: users })=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1MukO.SectionBody), null, formatMessage((0, $dziwa.default).users), ":", ' ', users.map((user, index)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("span", {
            key: user
        }, user, index < users.length - 1 ? ', ' : '')));
};

});
parcelRegister("dziwa", function(module, exports) {

$parcel$export(module.exports, "default", () => $40c7aadd3f5aee0e$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $40c7aadd3f5aee0e$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    users: {
        "id": "issue-navigator-custom-filters.common.details-popup.users-grant.users",
        "defaultMessage": "Users"
    }
});

});


parcelRegister("9sww0", function(module, exports) {

$parcel$export(module.exports, "default", () => $9cf23019e440c63c$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $9cf23019e440c63c$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    private: {
        "id": "issue-navigator-custom-filters.details-popup.popup-content.permissions.access.private",
        "defaultMessage": "Private"
    },
    visibleTo: {
        "id": "issue-navigator-custom-filters.details-popup.popup-content.permissions.access.visible-to",
        "defaultMessage": "Visible to:"
    },
    public: {
        "id": "issue-navigator-custom-filters.details-popup.popup-content.permissions.access.public",
        "defaultMessage": "Public"
    },
    loggedInUsers: {
        "id": "issue-navigator-custom-filters.details-popup.popup-content.permissions.access.logged-in-users",
        "defaultMessage": "Logged in users on this instance"
    }
});

});


parcelRegister("ckTc8", function(module, exports) {

$parcel$export(module.exports, "Edit", () => $301306cec459c2ab$export$6ed0965c9443aaa6);

var $fuydX = parcelRequire("fuydX");

var $eUqFw = parcelRequire("eUqFw");

var $iWLL0 = parcelRequire("iWLL0");

var $5JgJ2 = parcelRequire("5JgJ2");

var $5XnMI = parcelRequire("5XnMI");

var $fJbsV = parcelRequire("fJbsV");

var $f6n7J = parcelRequire("f6n7J");

var $1MukO = parcelRequire("1MukO");

var $hq0hv = parcelRequire("hq0hv");

var $h3eoP = parcelRequire("h3eoP");

var $6AOrh = parcelRequire("6AOrh");
const $301306cec459c2ab$export$6ed0965c9443aaa6 = ({ filter: filter })=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const { editGrants: editGrants } = (0, $iWLL0.useFragment)((0, $fuydX.default), filter);
    const users = (0, $eUqFw.useMemo)(()=>editGrants?.edges && editGrants.edges?.length > 0 ? editGrants?.edges.filter((shareableEntity)=>shareableEntity?.node && shareableEntity.node.__typename === 'JiraShareableEntityUserGrant').map((shareableEntity)=>shareableEntity?.node?.user ? shareableEntity.node.user.name : '') : [], [
        editGrants?.edges
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1MukO.SectionBodyTitle), null, formatMessage((0, $6AOrh.default).editabledBy)), editGrants?.edges && editGrants.edges?.length > 0 ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, // using index as key because these relations don't have individual IDs
    editGrants.edges.map((shareableEntity, key)=>{
        if (shareableEntity?.node) {
            const { __typename: __typename } = shareableEntity?.node;
            if (__typename === 'JiraShareableEntityProjectGrant') return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $fJbsV.ProjectGrant), {
                key: key,
                entity: shareableEntity.node
            });
            if (__typename === 'JiraShareableEntityProjectRoleGrant') return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $f6n7J.ProjectRoleGrant), {
                key: key,
                entity: shareableEntity.node
            });
            if (__typename === 'JiraShareableEntityGroupGrant') return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5XnMI.GroupGrant), {
                key: key,
                entity: shareableEntity.node
            });
            if (__typename === 'JiraShareableEntityUnknownProjectGrant') return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $hq0hv.UnknownProject), {
                key: key
            });
        }
        return null;
    }), users.length > 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $h3eoP.UsersGrant), {
        users: users
    })) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1MukO.SectionBody), null, formatMessage((0, $6AOrh.default).private)));
};

});
parcelRegister("fuydX", function(module, exports) {

$parcel$export(module.exports, "default", () => $f9c3ef55d0ee80ab$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<99f0d9d9838b61861cbb2efaa1de9f54>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $f9c3ef55d0ee80ab$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "edit_issueNavigatorCustomFilters",
    "selections": [
        {
            "concreteType": "JiraShareableEntityEditGrantConnection",
            "kind": "LinkedField",
            "name": "editGrants",
            "plural": false,
            "selections": [
                {
                    "concreteType": "JiraShareableEntityEditGrantEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                        {
                            "kind": "LinkedField",
                            "name": "node",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "__typename"
                                },
                                {
                                    "kind": "FragmentSpread",
                                    "name": "projectGrant_issueNavigatorCustomFilters"
                                },
                                {
                                    "kind": "FragmentSpread",
                                    "name": "projectRoleGrant_issueNavigatorCustomFilters"
                                },
                                {
                                    "kind": "FragmentSpread",
                                    "name": "groupGrant_issueNavigatorCustomFilters"
                                },
                                {
                                    "kind": "InlineFragment",
                                    "selections": [
                                        {
                                            "kind": "LinkedField",
                                            "name": "user",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "name"
                                                }
                                            ]
                                        }
                                    ],
                                    "type": "JiraShareableEntityUserGrant"
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    ],
    "type": "JiraCustomFilter"
};
$f9c3ef55d0ee80ab$var$node.hash = "cb8085a4ada55e8e573b553cfab4d229";
var $f9c3ef55d0ee80ab$export$2e2bcd8739ae039 = $f9c3ef55d0ee80ab$var$node;

});

parcelRegister("6AOrh", function(module, exports) {

$parcel$export(module.exports, "default", () => $bd03b2cd40b2523a$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $bd03b2cd40b2523a$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    private: {
        "id": "issue-navigator-custom-filters.details-popup.popup-content.permissions.edit.private",
        "defaultMessage": "Private"
    },
    editabledBy: {
        "id": "issue-navigator-custom-filters.details-popup.popup-content.permissions.edit.editabled-by",
        "defaultMessage": "Editable by:"
    }
});

});


parcelRegister("4sACA", function(module, exports) {

$parcel$export(module.exports, "default", () => $a0d84a5f5502bd67$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $a0d84a5f5502bd67$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    permissions: {
        "id": "issue-navigator-custom-filters.details-popup.popup-content.permissions.permissions",
        "defaultMessage": "Permissions"
    },
    editPermissions: {
        "id": "issue-navigator-custom-filters.details-popup.popup-content.permissions.edit-permissions",
        "defaultMessage": "Edit Permissions"
    }
});

});


parcelRegister("iutCW", function(module, exports) {

$parcel$export(module.exports, "Subscriptions", () => $5cfa17e2af9740ea$export$d73dcc2e0bdfb5bd);

var $jLFEo = parcelRequire("jLFEo");

var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $iWLL0 = parcelRequire("iWLL0");

var $7u4fN = parcelRequire("7u4fN");

var $jgrQL = parcelRequire("jgrQL");

var $9Amv1 = parcelRequire("9Amv1");
var $1Yimi = parcelRequire("1Yimi");

var $8cU5f = parcelRequire("8cU5f");

var $dnbhd = parcelRequire("dnbhd");

var $5JgJ2 = parcelRequire("5JgJ2");

var $jMP2a = parcelRequire("jMP2a");

var $3v8lA = parcelRequire("3v8lA");

var $1MukO = parcelRequire("1MukO");

var $GEkEU = parcelRequire("GEkEU");

var $4y0mA = parcelRequire("4y0mA");

var $gUQW9 = parcelRequire("gUQW9");
const $5cfa17e2af9740ea$export$d73dcc2e0bdfb5bd = ({ filter: filter, onOpenNewSubscriptionModal: onOpenNewSubscriptionModal, onSuccess: onSuccess })=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const data = (0, $iWLL0.useFragment)((0, $jLFEo.default), filter);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1MukO.Section), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $3v8lA.SectionHeader), {
        actions: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $9Amv1.default), {
            space: "space.050",
            alignBlock: "center",
            shouldWrap: true
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4y0mA.AddSubscriptionModalProvider), {
            filter: data,
            onOpenNewSubscriptionModal: onOpenNewSubscriptionModal,
            onSuccess: onSuccess
        }, ({ isLoading: isLoading, open: open, preload: preload })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7u4fN.default), {
                appearance: "link",
                spacing: "none",
                onClick: open,
                onMouseOver: preload,
                isDisabled: isLoading,
                testId: "issue-navigator-custom-filters.ui.details-popup.popup-content.subscriptions.add-subscription-button"
            }, formatMessage((0, $gUQW9.default).addSubscription))), data.emailSubscriptions.edges.length > 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1Yimi.default), null, "\u2022"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $dnbhd.default), {
            href: (0, $GEkEU.getManageSubscriptionsLink)(data.filterId),
            onClick: (_, analyticsEvent)=>(0, $jMP2a.fireUIAnalytics)(analyticsEvent, 'manageSubscriptions'),
            "data-testid": "issue-navigator-custom-filters.ui.details-popup.popup-content.subscriptions.manage-subscriptions-link"
        }, formatMessage((0, $gUQW9.default).manageSubscriptions))))
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $9Amv1.default), {
        space: "space.025",
        alignBlock: "center"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1Yimi.default), {
        weight: "semibold"
    }, formatMessage((0, $gUQW9.default).subscriptions)), !data.emailSubscriptions.edges.length && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8cU5f.default), {
        content: formatMessage((0, $gUQW9.default).subscriptionsInfoTooltip),
        tag: $5cfa17e2af9740ea$var$InfoIconWrapper
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($jgrQL))), {
        label: formatMessage((0, $gUQW9.default).subscriptionsInfoTooltip),
        size: "medium"
    })))), data.emailSubscriptions.edges.length ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("p", null, formatMessage((0, $gUQW9.default).hasTheFollowingSubscriptions)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($5cfa17e2af9740ea$var$SubscriptionList, null, data.emailSubscriptions.edges.map((edge)=>edge?.node ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("li", {
            key: edge.node.id
        }, edge.node.group ? edge.node.group.name : edge.node.user?.name) : null))) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("p", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1MukO.PlaceholderText), null, formatMessage((0, $gUQW9.default).subscriptionsPlaceholder))));
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $5cfa17e2af9740ea$var$InfoIconWrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_19pkr5cr _4t3i77iu",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $5cfa17e2af9740ea$var$SubscriptionList = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "ul", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_2mzuglyw _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf",
            __cmplp.className
        ])
    });
});

});
parcelRegister("jLFEo", function(module, exports) {

$parcel$export(module.exports, "default", () => $21826a34e2e3a06c$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<bcf3fd047349255d1334d0cedddeea6f>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $21826a34e2e3a06c$var$node = function() {
    var v0 = [
        {
            "kind": "ScalarField",
            "name": "name"
        }
    ];
    return {
        "argumentDefinitions": [],
        "kind": "Fragment",
        "name": "subscriptions_issueNavigatorCustomFilters",
        "selections": [
            {
                "kind": "ScalarField",
                "name": "filterId"
            },
            {
                "kind": "FragmentSpread",
                "name": "addSubscriptionModal_issueNavigatorCustomFilters_AddSubscriptionModalProvider"
            },
            {
                "kind": "RequiredField",
                "field": {
                    "args": [
                        {
                            "kind": "Literal",
                            "name": "last",
                            "value": 5
                        }
                    ],
                    "concreteType": "JiraFilterEmailSubscriptionConnection",
                    "kind": "LinkedField",
                    "name": "emailSubscriptions",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "RequiredField",
                            "field": {
                                "concreteType": "JiraFilterEmailSubscriptionEdge",
                                "kind": "LinkedField",
                                "name": "edges",
                                "plural": true,
                                "selections": [
                                    {
                                        "concreteType": "JiraFilterEmailSubscription",
                                        "kind": "LinkedField",
                                        "name": "node",
                                        "plural": false,
                                        "selections": [
                                            {
                                                "kind": "ScalarField",
                                                "name": "id"
                                            },
                                            {
                                                "kind": "LinkedField",
                                                "name": "user",
                                                "plural": false,
                                                "selections": v0 /*: any*/ 
                                            },
                                            {
                                                "concreteType": "JiraGroup",
                                                "kind": "LinkedField",
                                                "name": "group",
                                                "plural": false,
                                                "selections": v0 /*: any*/ 
                                            }
                                        ]
                                    }
                                ]
                            },
                            "action": "THROW",
                            "path": "emailSubscriptions.edges"
                        }
                    ],
                    "storageKey": "emailSubscriptions(last:5)"
                },
                "action": "THROW",
                "path": "emailSubscriptions"
            }
        ],
        "type": "JiraCustomFilter"
    };
}();
$21826a34e2e3a06c$var$node.hash = "85c47f44d1a205822525c56240e74538";
var $21826a34e2e3a06c$export$2e2bcd8739ae039 = $21826a34e2e3a06c$var$node;

});

parcelRegister("jgrQL", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $e0651d627acb5549$var$_react = $e0651d627acb5549$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $igPbh = parcelRequire("igPbh");

var $e0651d627acb5549$var$_information = $e0651d627acb5549$var$_interopRequireDefault((parcelRequire("h6FFs")));
function $e0651d627acb5549$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
const $e0651d627acb5549$var$EditorInfoIcon = (props)=>/*#__PURE__*/ $e0651d627acb5549$var$_react.default.createElement($igPbh.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="M12 20a8 8 0 1 1 0-16 8 8 0 0 1 0 16m0-8.5a1 1 0 0 0-1 1V15a1 1 0 0 0 2 0v-2.5a1 1 0 0 0-1-1m0-1.125a1.375 1.375 0 1 0 0-2.75 1.375 1.375 0 0 0 0 2.75"/></svg>`
    }, props, {
        newIcon: $e0651d627acb5549$var$_information.default
    }));
$e0651d627acb5549$var$EditorInfoIcon.displayName = 'EditorInfoIcon';
var $e0651d627acb5549$var$_default = module.exports.default = $e0651d627acb5549$var$EditorInfoIcon;

});

parcelRegister("GEkEU", function(module, exports) {

$parcel$export(module.exports, "getManageSubscriptionsLink", () => $6dcb49eb18c759a8$export$426da445adfeedc1);
const $6dcb49eb18c759a8$export$426da445adfeedc1 = (filterId)=>`/secure/ViewSubscriptions.jspa?filterId=${filterId}`;

});

parcelRegister("4y0mA", function(module, exports) {

$parcel$export(module.exports, "AddSubscriptionModalProvider", () => $304d15629b02765d$export$1b56ce395ad0fc78);

var $iTwfO = parcelRequire("iTwfO");

var $eUqFw = parcelRequire("eUqFw");

var $iWLL0 = parcelRequire("iWLL0");

var $bFzGY = parcelRequire("bFzGY");

var $guiFP = parcelRequire("guiFP");

var $7EhAs = parcelRequire("7EhAs");

var $jxATW = parcelRequire("jxATW");

var $k8Qyf = parcelRequire("k8Qyf");

var $jMP2a = parcelRequire("jMP2a");

var $16kIm = parcelRequire("16kIm");


var $GEkEU = parcelRequire("GEkEU");

var $hLyIA = parcelRequire("hLyIA");

var $4HUA2 = parcelRequire("4HUA2");
const $304d15629b02765d$var$WRM_RESOURCES = [
    'wrc!jira.webresources:croneditor'
];
const $304d15629b02765d$var$preload = ()=>{
    (0, $16kIm.asyncWrmRequire)($304d15629b02765d$var$WRM_RESOURCES);
};
const $304d15629b02765d$var$getFormDialog = ()=>(0, $16kIm.asyncWrmRequire)($304d15629b02765d$var$WRM_RESOURCES).then(()=>window.JIRA.FormDialog);
const $304d15629b02765d$export$1b56ce395ad0fc78 = ({ filter: filter, children: children, onError: onError, onOpenNewSubscriptionModal: onOpenNewSubscriptionModal, onSuccess: onSuccess })=>{
    const [isLoading, setLoading] = (0, $eUqFw.useState)(false);
    const { showFlag: showFlag } = (0, $k8Qyf.useFlagService)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bFzGY.useAnalyticsEvents)();
    const filterData = (0, $iWLL0.useFragment)((0, $iTwfO.default), filter);
    const onSuccessfulSubmit = (0, $eUqFw.useCallback)(()=>{
        (0, $jMP2a.fireTrackAnalytics)(createAnalyticsEvent({
            actionSubject: 'issueFilterSubscription',
            action: 'created'
        }), 'issueFilterSubscription created', {
            issueFilterNameLength: filterData.name.length,
            issueFilterDescriptionLength: filterData.description?.length,
            issueFilterOwner: filterData.owner?.accountId
        });
        onSuccess && onSuccess();
    }, [
        createAnalyticsEvent,
        filterData,
        onSuccess
    ]);
    const open = (0, $eUqFw.useCallback)(()=>{
        (async ()=>{
            (0, $jMP2a.fireUIAnalytics)(createAnalyticsEvent({
                action: 'clicked',
                actionSubject: 'button'
            }), 'addFilterSubscription');
            (0, $hLyIA.viewNewSubscriptionModal).start();
            setLoading(true);
            try {
                const FormDialog = await $304d15629b02765d$var$getFormDialog();
                /**
         * Available options can be found in:
         * https://stash.atlassian.com/projects/JIRACLOUD/repos/jira/browse/jira-components/jira-webapp-resources/src/main/webapp/includes/jira/dialog/FormDialog.js
         * Look at `_getDefaultOptions` function and accesses to `this.options`
         */ const dialog = new FormDialog({
                    ajaxOptions: {
                        url: `https://${window.location.hostname}/secure/EditSubscription!default.jspa?filterId=${filterData.filterId}`,
                        data: {
                            decorator: 'dialog',
                            inline: 'true'
                        }
                    },
                    autoClose: true,
                    onUnSuccessfulSubmit (statusText, errorThrown, smartAjaxResult) {
                        const error = errorThrown || new (0, $7EhAs.default)(smartAjaxResult.status, undefined, (0, $jxATW.getTraceIdJq)(smartAjaxResult.xhr));
                        (0, $guiFP.default)({
                            meta: {
                                id: 'AddSubscriptionModalProvider.onUnSuccessfulSubmit',
                                packageName: (0, $3e27b2158b878ad6$export$ad257a98f20ee631),
                                teamName: 'empanada'
                            },
                            error: error,
                            sendToPrivacyUnsafeSplunk: true
                        });
                        onError && onError(error);
                    },
                    onDialogFinished () {
                        onSuccessfulSubmit();
                        showFlag({
                            type: 'success',
                            title: (0, $4HUA2.default).successFlagTitle,
                            description: [
                                (0, $4HUA2.default).successFlagDescription,
                                {
                                    filterName: filterData.name
                                }
                            ],
                            actions: [
                                {
                                    content: (0, $4HUA2.default).successFlagActionManage,
                                    href: (0, $GEkEU.getManageSubscriptionsLink)(filterData.filterId),
                                    target: '_blank'
                                }
                            ]
                        });
                    }
                });
                dialog.onContentReadyCallbacks?.push(()=>{
                    (0, $hLyIA.viewNewSubscriptionModal).success();
                });
                dialog.show();
                onOpenNewSubscriptionModal && onOpenNewSubscriptionModal();
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            } catch (error) {
                showFlag({
                    type: 'error',
                    title: (0, $4HUA2.default).showModalErrorTitle,
                    description: (0, $4HUA2.default).showModalErrorDescription,
                    error: error
                });
                (0, $guiFP.default)({
                    meta: {
                        id: 'AddSubscriptionModalProvider',
                        packageName: (0, $3e27b2158b878ad6$export$ad257a98f20ee631),
                        teamName: 'empanada'
                    },
                    error: error,
                    sendToPrivacyUnsafeSplunk: true
                });
                (0, $hLyIA.viewNewSubscriptionModal).failure();
            }
            setLoading(false);
        })();
    }, [
        createAnalyticsEvent,
        filterData,
        showFlag,
        onError,
        onOpenNewSubscriptionModal,
        onSuccessfulSubmit
    ]);
    return children({
        isLoading: isLoading,
        open: open,
        preload: $304d15629b02765d$var$preload
    });
};

});
parcelRegister("iTwfO", function(module, exports) {

$parcel$export(module.exports, "default", () => $88fd0dceb0eb03ba$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<6cdab0b62ebc5a697477607cd35b545c>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $88fd0dceb0eb03ba$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "addSubscriptionModal_issueNavigatorCustomFilters_AddSubscriptionModalProvider",
    "selections": [
        {
            "kind": "RequiredField",
            "field": {
                "kind": "ScalarField",
                "name": "filterId"
            },
            "action": "THROW",
            "path": "filterId"
        },
        {
            "kind": "RequiredField",
            "field": {
                "kind": "ScalarField",
                "name": "name"
            },
            "action": "THROW",
            "path": "name"
        },
        {
            "kind": "ScalarField",
            "name": "description"
        },
        {
            "kind": "LinkedField",
            "name": "owner",
            "plural": false,
            "selections": [
                {
                    "kind": "RequiredField",
                    "field": {
                        "kind": "ScalarField",
                        "name": "accountId"
                    },
                    "action": "THROW",
                    "path": "owner.accountId"
                }
            ]
        }
    ],
    "type": "JiraCustomFilter"
};
$88fd0dceb0eb03ba$var$node.hash = "9d8d65563104a3f742dd7a5adc73ec81";
var $88fd0dceb0eb03ba$export$2e2bcd8739ae039 = $88fd0dceb0eb03ba$var$node;

});

parcelRegister("4HUA2", function(module, exports) {

$parcel$export(module.exports, "default", () => $2067d5675f9ba072$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $2067d5675f9ba072$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    showModalErrorTitle: {
        "id": "issue-navigator-custom-filters.details-popup.popup-content.subscriptions.add-subscription-modal.show-modal-error-title",
        "defaultMessage": "Something went wrong"
    },
    showModalErrorDescription: {
        "id": "issue-navigator-custom-filters.details-popup.popup-content.subscriptions.add-subscription-modal.show-modal-error-description",
        "defaultMessage": "We couldn't create a new subscription. Please refresh the page and try again."
    },
    successFlagTitle: {
        "id": "issue-navigator-custom-filters.details-popup.popup-content.subscriptions.add-subscription-modal.success-flag-title",
        "defaultMessage": "Subscription created"
    },
    successFlagDescription: {
        "id": "issue-navigator-custom-filters.details-popup.popup-content.subscriptions.add-subscription-modal.success-flag-description",
        "defaultMessage": "You\u2019ve created a subscription for \u201C{filterName}\u201D filter."
    },
    successFlagActionManage: {
        "id": "issue-navigator-custom-filters.details-popup.popup-content.subscriptions.add-subscription-modal.success-flag-action-manage",
        "defaultMessage": "Manage subscriptions"
    }
});

});


parcelRegister("gUQW9", function(module, exports) {

$parcel$export(module.exports, "default", () => $7e3752a9e511f57d$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $7e3752a9e511f57d$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    subscriptions: {
        "id": "issue-navigator-custom-filters.details-popup.popup-content.subscriptions.subscriptions",
        "defaultMessage": "Subscriptions"
    },
    addSubscription: {
        "id": "issue-navigator-custom-filters.details-popup.popup-content.subscriptions.add-subscription",
        "defaultMessage": "Add subscription"
    },
    manageSubscriptions: {
        "id": "issue-navigator-custom-filters.details-popup.popup-content.subscriptions.manage-subscriptions",
        "defaultMessage": "Manage subscriptions"
    },
    subscriptionsPlaceholder: {
        "id": "issue-navigator-custom-filters.details-popup.popup-content.subscriptions.subscriptions-placeholder",
        "defaultMessage": "This filter doesn't have any subscriptions."
    },
    subscriptionsInfoTooltip: {
        "id": "issue-navigator-custom-filters.details-popup.popup-content.subscriptions.subscriptions-info-tooltip",
        "defaultMessage": "Get regular updates from issues in this filter."
    },
    hasTheFollowingSubscriptions: {
        "id": "issue-navigator-custom-filters.details-popup.popup-content.subscriptions.has-the-following-subscriptions",
        "defaultMessage": "This filter has the following subscriptions:"
    }
});

});





parcelRegister("5lWFW", function(module, exports) {

$parcel$export(module.exports, "DetailsButtonHeaderWrapper", () => $68a90300266936a7$export$1eb74eb504903ed6);
/* styled.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");
const $68a90300266936a7$export$1eb74eb504903ed6 = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $eUqFw.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1wybdlk8 _k48p4jg8 _18s8otz2 _19pkv77o",
            __cmplp.className
        ])
    });
});

});


parcelRegister("euIkl", function(module, exports) {

$parcel$export(module.exports, "FavoriteButton", () => $6f2c3d94b4640d68$export$8d5dab2ad1e19ea0);
$parcel$export(module.exports, "FavoriteButtonHeaderWrapper", () => $6f2c3d94b4640d68$export$5ca4047aa6ecffac);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $eai7U = parcelRequire("eai7U");

var $jrdvV = parcelRequire("jrdvV");
const $6f2c3d94b4640d68$export$8d5dab2ad1e19ea0 = ({ filterId: filterId, isFavoriteInitial: isFavoriteInitial, favoriteItemName: favoriteItemName })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $eai7U.default), {
        key: filterId,
        baseUrl: "",
        itemType: (0, $jrdvV.FILTERS_ITEM_TYPE),
        itemId: filterId,
        isFavoriteInitial: isFavoriteInitial,
        favoriteItemName: favoriteItemName,
        isShownInList: true
    });
const $6f2c3d94b4640d68$export$5ca4047aa6ecffac = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1wybdlk8 _4t3izwfg _18s81nu5",
            __cmplp.className
        ])
    });
});

});
parcelRegister("eai7U", function(module, exports) {

$parcel$export(module.exports, "default", () => $851158f210da4df7$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $hXex1 = parcelRequire("hXex1");

var $gwSUu = parcelRequire("gwSUu");

var $dQZ5c = parcelRequire("dQZ5c");
class $851158f210da4df7$export$2e2bcd8739ae039 extends (0, $eUqFw.Component) {
    render() {
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $dQZ5c.FavoriteChangeConsumer), null, (favoriteChangeContext)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gwSUu.FavoriteButton), {
                ...this.props,
                favoriteChangeContext: favoriteChangeContext
            }));
    }
}

});
parcelRegister("hXex1", function(module, exports) {

$parcel$export(module.exports, "getFavorite", () => $895d7ed98f35f49b$export$fce5eda070ce88d0);

var $lRmyA = parcelRequire("lRmyA");
const $895d7ed98f35f49b$export$959ca2ee969adb8d = (baseUrl, request)=>`${baseUrl}/rest/internal/2/favourites/${request.type}/${request.id}`;
const $895d7ed98f35f49b$export$fce5eda070ce88d0 = async (baseUrl, request)=>(0, $lRmyA.performGetRequest)($895d7ed98f35f49b$export$959ca2ee969adb8d(baseUrl, request));

});

parcelRegister("gwSUu", function(module, exports) {

$parcel$export(module.exports, "FavoriteButton", () => $f43e6d70f6db5981$export$8d5dab2ad1e19ea0);

var $eUqFw = parcelRequire("eUqFw");

var $jG2Eu = parcelRequire("jG2Eu");

var $ktkCe = parcelRequire("ktkCe");

var $hXex1 = parcelRequire("hXex1");

var $jrdvV = parcelRequire("jrdvV");

var $1ybV0 = parcelRequire("1ybV0");
const $f43e6d70f6db5981$var$isProduction = window.BUILD_KEY !== 'JF-TEST';
class $f43e6d70f6db5981$export$8d5dab2ad1e19ea0 extends (0, $eUqFw.Component) {
    static{
        this.defaultProps = {
            isFavoriteInitial: undefined,
            favoriteItemName: undefined,
            isSmall: false,
            hideTooltip: false,
            onClick: (0, (/*@__PURE__*/$parcel$interopDefault($jG2Eu)))
        };
    }
    constructor(props){
        super(props);
        this.onClick = (analyticsEvent)=>{
            const { favoriteChangeContext: favoriteChangeContext, itemId: itemId, itemType: itemType, onClick: onClick } = this.props;
            const { changeFavorite: changeFavorite } = favoriteChangeContext;
            if (changeFavorite) changeFavorite({
                id: itemId,
                type: itemType,
                value: !this.getIsFavorite()
            }, analyticsEvent);
            if (typeof onClick === 'function') onClick();
        };
        this.state = {
            isFavorite: props.isFavoriteInitial
        };
    }
    componentDidMount() {
        const { baseUrl: baseUrl, itemId: itemId, itemType: itemType } = this.props;
        if (typeof baseUrl === 'undefined' || typeof itemId === 'undefined' || typeof itemType === 'undefined') return;
        // Adding an Error here for the next dev to implement this button.
        // This error won't show in prod, but will show when running a fragment.
        if (!$f43e6d70f6db5981$var$isProduction && !(0, $jrdvV.VALID_ITEM_TYPES).includes(itemType)) throw new Error(`FavoriteButton: Invalid value for prop 'type'.\n You passed: "${itemType}"\n It must be one of [${JSON.stringify((0, $jrdvV.VALID_ITEM_TYPES))}]\n\n`);
        if (typeof this.props.isFavoriteInitial !== 'undefined') // @ts-expect-error - TS2532 - Object is possibly 'undefined'.
        this.props.favoriteChangeContext.items[itemType][itemId] = {
            id: itemId,
            type: itemType,
            value: this.props.isFavoriteInitial,
            pending: false
        };
        if (this.getIsFavorite() === undefined) (0, $hXex1.getFavorite)(baseUrl, {
            id: itemId,
            type: itemType
        }).then((isFavorite)=>{
            this.setState({
                isFavorite: isFavorite
            });
        });
    }
    getIsFavorite() {
        const { favoriteChangeContext: favoriteChangeContext, itemId: itemId, itemType: itemType } = this.props;
        let itemChanged;
        if (typeof favoriteChangeContext.items[itemType] !== 'undefined' && // @ts-expect-error - TS2532 - TS doesn't refine types with index access in this version.
        typeof favoriteChangeContext.items[itemType][itemId] !== 'undefined') // @ts-expect-error - TS2532 - TS doesn't refine types with index access in this version.
        itemChanged = favoriteChangeContext.items[itemType][itemId];
        return itemChanged ? itemChanged.value : this.state.isFavorite;
    }
    getIsPending() {
        const { favoriteChangeContext: favoriteChangeContext, itemId: itemId, itemType: itemType } = this.props;
        let itemChanged;
        if (typeof favoriteChangeContext.items[itemType] !== 'undefined' && // @ts-expect-error - TS2532 - TS doesn't refine types with index access in this version.
        typeof favoriteChangeContext.items[itemType][itemId] !== 'undefined') // @ts-expect-error - TS2532 - TS doesn't refine types with index access in this version.
        itemChanged = favoriteChangeContext.items[itemType][itemId];
        return itemChanged ? itemChanged.pending : false;
    }
    render() {
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", (0, $1ybV0.ff)('favourite-button-label-and-testid_of2ts') ? {
            'data-testid': 'favorite-button'
        } : {
            'data-test-id': 'favorite-button'
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $ktkCe.default), {
            isFavorite: this.getIsFavorite(),
            favoriteItemName: this.props.favoriteItemName,
            pending: this.getIsPending(),
            hideTooltip: this.props.hideTooltip,
            tooltipPosition: this.props.tooltipPosition,
            onClick: this.onClick,
            isShownInList: this.props.isShownInList,
            isSmall: this.props.isSmall
        }));
    }
}

});
parcelRegister("ktkCe", function(module, exports) {

$parcel$export(module.exports, "FavoriteButtonWrapper", () => $3e4b24f33924a6f9$export$bb1478fee6cd5f0c);
$parcel$export(module.exports, "default", () => $3e4b24f33924a6f9$export$2e2bcd8739ae039);
/* view.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $c8Guq = parcelRequire("c8Guq");

var $jG2Eu = parcelRequire("jG2Eu");

var $7u4fN = parcelRequire("7u4fN");

var $23Ou2 = parcelRequire("23Ou2");

var $7jsaI = parcelRequire("7jsaI");

var $daM3L = parcelRequire("daM3L");

var $hlWtt = parcelRequire("hlWtt");

var $8L5aC = parcelRequire("8L5aC");

var $cc1Cw = parcelRequire("cc1Cw");

var $8cU5f = parcelRequire("8cU5f");

var $8un0w = parcelRequire("8un0w");

var $1ybV0 = parcelRequire("1ybV0");

var $giAhk = parcelRequire("giAhk");

var $8rQuz = parcelRequire("8rQuz");

var $apShl = parcelRequire("apShl");

var $ivkNG = parcelRequire("ivkNG");
const $3e4b24f33924a6f9$var$SKELETON_TEST_ID = 'favouriting.favorite-button-stateless.skeleton';
const $3e4b24f33924a6f9$var$ICON_WRAPPER_TEST_ID_PREFIX = 'favouriting.favorite-button-stateless.icon-wrapper';
class $3e4b24f33924a6f9$export$f8ad2acf0ec4860f extends (0, $eUqFw.Component) {
    static{
        this.defaultProps = {
            isFavorite: undefined,
            favoriteItemName: undefined,
            isShownInList: false,
            isSmall: false,
            hideTooltip: false,
            onClick: (0, (/*@__PURE__*/$parcel$interopDefault($jG2Eu))),
            tooltipPosition: 'bottom',
            skipAnimation: false
        };
    }
    componentDidUpdate(prevProps) {
        if (!this.props.skipAnimation && (!prevProps.pending && this.props.pending || !prevProps.isFavorite && this.props.isFavorite)) {
            this.onAnimationStart();
            this.onSettingAnimationEnd();
        }
    }
    onAnimationStart() {
        this.setState({
            isAnimating: !this.state.isAnimating
        });
    }
    onSettingAnimationEnd() {
        setTimeout(()=>{
            this.setState({
                isAnimating: false
            });
        }, $3e4b24f33924a6f9$var$animationTime * 2);
    }
    render() {
        const { isFavorite: isFavorite, favoriteItemName: favoriteItemName, isShownInList: isShownInList, isSmall: isSmall, hideTooltip: hideTooltip, tooltipPosition: tooltipPosition, pending: pending, intl: { formatMessage: formatMessage } } = this.props;
        const { isAnimating: isAnimating } = this.state;
        if (isFavorite === undefined) // show skeleton as a space placeholder (to avoid layout recalculations in browser and visible "jump" when we got data)
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $apShl.default), {
            name: "favourite-button"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($3e4b24f33924a6f9$export$db65185b5889c83, {
            ...(0, $1ybV0.ff)('favourite-button-label-and-testid_of2ts') ? {
                'data-testid': $3e4b24f33924a6f9$var$SKELETON_TEST_ID
            } : {
                'data-test-id': $3e4b24f33924a6f9$var$SKELETON_TEST_ID
            },
            isSmall: isSmall
        }));
        const iconWrapperTestId = isShownInList ? `${$3e4b24f33924a6f9$var$ICON_WRAPPER_TEST_ID_PREFIX}-list` : $3e4b24f33924a6f9$var$ICON_WRAPPER_TEST_ID_PREFIX;
        const sizeProps = isSmall ? {
            size: 'small'
        } : {};
        const buttonContentOld = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($3e4b24f33924a6f9$var$FavIconWrapper, {
            isFavorite: isFavorite,
            isAnimating: isAnimating,
            ...(0, $1ybV0.ff)('favourite-button-label-and-testid_of2ts') ? {
                'data-testid': iconWrapperTestId
            } : {
                'data-test-id': iconWrapperTestId
            },
            isSmall: isSmall
        }, isFavorite ? // @ts-expect-error - TS2769 - No overload matches this call. | TS2769 - No overload matches this call.
        // eslint-disable-next-line @atlaskit/design-system/no-legacy-icons
        /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($hlWtt))), {
            ...sizeProps,
            ...(0, $1ybV0.ff)('favourite-button-label-and-testid_of2ts') && {
                label: formatMessage((0, $ivkNG.default).removeFromStarred)
            }
        }) : // @ts-expect-error - TS2769 - No overload matches this call. | TS2769 - No overload matches this call.
        // eslint-disable-next-line @atlaskit/design-system/no-legacy-icons
        /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($daM3L))), {
            ...sizeProps,
            ...(0, $1ybV0.ff)('favourite-button-label-and-testid_of2ts') && {
                label: formatMessage((0, $ivkNG.default).addToStarred)
            }
        }));
        const renderIcon = ()=>{
            let label = '';
            if ((0, $1ybV0.ff)('favourite-button-label-and-testid_of2ts')) {
                if (isFavorite) label = formatMessage((0, $ivkNG.default).removeFromStarred);
                else label = formatMessage((0, $ivkNG.default).addToStarred);
            }
            let StarIconComponent;
            if (isSmall) StarIconComponent = isFavorite ? (0, (/*@__PURE__*/$parcel$interopDefault($8L5aC))) : (0, (/*@__PURE__*/$parcel$interopDefault($cc1Cw)));
            else StarIconComponent = isFavorite ? (0, (/*@__PURE__*/$parcel$interopDefault($23Ou2))) : (0, (/*@__PURE__*/$parcel$interopDefault($7jsaI)));
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(StarIconComponent, {
                color: "currentColor",
                label: label
            });
        };
        const buttonContent = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($3e4b24f33924a6f9$var$FavIconWrapper, {
            isFavorite: isFavorite,
            isAnimating: isAnimating,
            ...(0, $1ybV0.ff)('favourite-button-label-and-testid_of2ts') ? {
                'data-testid': iconWrapperTestId
            } : {
                'data-test-id': iconWrapperTestId
            },
            isSmall: isSmall
        }, renderIcon());
        const tooltipContent = isFavorite ? formatMessage((0, $ivkNG.default).removeFromStarred) : formatMessage((0, $ivkNG.default).addToStarred);
        const ariaLabel = favoriteItemName ? formatMessage((0, $ivkNG.default).toggleStarredWithItemName, {
            itemName: favoriteItemName
        }) : formatMessage((0, $ivkNG.default).toggleStarred);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($3e4b24f33924a6f9$export$bb1478fee6cd5f0c, {
            role: "presentation",
            onClick: this.onBtnClickWrapper,
            onKeyPress: this.onBtnClickWrapper,
            "data-is-favorite": isFavorite
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8cU5f.default), {
            content: !hideTooltip && tooltipContent,
            hideTooltipOnClick: true,
            position: tooltipPosition
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7u4fN.default), {
            appearance: isShownInList ? 'subtle-link' : 'subtle',
            spacing: "none",
            "aria-label": ariaLabel,
            "aria-pressed": isFavorite,
            onClick: !pending ? this.onClick : (0, (/*@__PURE__*/$parcel$interopDefault($jG2Eu)))
        }, (0, $8rQuz.isVisualRefreshEnabled)() ? buttonContent : buttonContentOld)));
    }
    constructor(...args){
        super(...args);
        this.state = {
            isAnimating: false
        };
        this.onBtnClickWrapper = (e)=>{
            e.stopPropagation(); // should not let this event get outside of the component, to prevent issue when, for example, star button is clicked in an item or row, which goes somewhere else on onClick handler. Cannot put it in onBtnClick, otherwise hideTooltipOnClick in <Tooltip> will not work
            e.preventDefault(); // same for cases when btn is inside a link - not to go to that link (e.g. in Star Drawer)
        };
        this.onClick = (_, analyticsEvent)=>{
            this.props.onClick(analyticsEvent);
        };
    }
}
var $3e4b24f33924a6f9$export$2e2bcd8739ae039 = (0, (/*@__PURE__*/$parcel$interopDefault($c8Guq)))((0, $8un0w.default)({
    onClick: ()=>({
            name: 'star'
        })
}), (0, $giAhk.injectIntlV2))($3e4b24f33924a6f9$export$f8ad2acf0ec4860f);
const $3e4b24f33924a6f9$var$animationTime = 500; // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
const $3e4b24f33924a6f9$export$bb1478fee6cd5f0c = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1o8l",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $3e4b24f33924a6f9$var$FavoriteIconWrapperBase = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { isSmall: isSmall, isAnimating: isAnimating, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _4cvr1h6o _1bah1h6o",
            __cmplp.isSmall ? "_1bsb1tcg" : "_1bsbzwfg",
            __cmplp.isSmall ? "_4t3i1tcg" : "_4t3izwfg",
            __cmplp.isAnimating && "_11vn1ssb _1px1fmmq _48hmq7pw _1uvf1e03",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $3e4b24f33924a6f9$var$FavIconWrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = $3e4b24f33924a6f9$var$FavoriteIconWrapperBase, style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "",
            __cmplp.isFavorite ? "_syaz2kyj" : "_syaz2u25",
            __cmplp.isFavorite ? "_30l31ebw" : "_30l3w9a8",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
const $3e4b24f33924a6f9$export$db65185b5889c83 = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { isSmall: isSmall, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw",
            __cmplp.isSmall ? "_1bsb1tcg" : "_1bsbzwfg",
            __cmplp.isSmall ? "_4t3i1tcg" : "_4t3izwfg",
            __cmplp.className
        ])
    });
});

});
parcelRegister("8un0w", function(module, exports) {

$parcel$export(module.exports, "default", () => $da3e17e369dbbaa5$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $etqm0 = parcelRequire("etqm0");
/**
 * Adds analytics events to the given callbacks without altering the original behavior
 * Callback is expected to have analyticsEvent as a last argument
 * @example
 * ```tsx
 *  // will fire "select" event when onSelect is called
 *  fileWithUIAnalytics({ onSelect: 'select' })
 *
 *  // will fire "select" event with extra attributes
 *  fileWithUIAnalytics({ onSelect: (value) => ({ name: 'select', value: value}) }
 *  ```
 */ const $da3e17e369dbbaa5$var$fireWithUIAnalytics = (ConnectedProps)=>{
    // sort the keys so we can set the deps of useMemo
    const providedKeys = Object.keys(ConnectedProps).sort();
    /**
	 * We implement a custom caching mechanism rather than memoizeOne. We got
	 * more ops/sec this way and we only need to bust the changing props cache
	 * instead of destroying all references on a single prop change.
	 */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const cachedMappedProps = {}; /*    the actual prop value */ 
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const cachedConnectedProps = {}; /* the connected prop value (the callback) */ 
    const getStateFromMappedProps = (mapped)=>{
        providedKeys.forEach((key, index)=>{
            // firstly check the cache if the prop has changed before creating
            // any new connected props
            const prop = mapped[index];
            if (key in cachedMappedProps && cachedMappedProps[key] === prop) return;
            cachedMappedProps[key] = prop;
            // @ts-expect-error - TS7019 - Rest parameter 'attrs' implicitly has an 'any[]' type.
            cachedConnectedProps[key] = (...attrs)=>{
                // assume that analytics event is always the last one (it should be by convention)
                const analyticsEvent = attrs[attrs.length - 1].clone();
                const connectedProp = ConnectedProps[key];
                // example: { onSelect: 'select' }
                if (typeof ConnectedProps[key] === 'string') analyticsEvent.update({
                    name: connectedProp,
                    analyticsType: (0, $etqm0.UI_EVENT_TYPE)
                }).fire();
                else if (typeof connectedProp === 'function') {
                    const update = connectedProp(...attrs);
                    analyticsEvent.update({
                        ...update,
                        analyticsType: (0, $etqm0.UI_EVENT_TYPE)
                    }).fire();
                }
                if (typeof prop === 'function') prop(...attrs);
            };
        });
        return cachedConnectedProps;
    };
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    return (WrappedComponent)=>// eslint-disable-next-line jira/react/no-class-components, @typescript-eslint/no-explicit-any,@typescript-eslint/consistent-type-assertions
        class WithAnalytics extends (0, $eUqFw.Component) {
            static{
                // Note: This seems to render weirdly in the chrome debugger. May need to change the string formatting to work around it
                this.displayName = `WithAnalytics(${WrappedComponent.displayName || WrappedComponent.name || 'UnnamedComponent'}`;
            }
            render() {
                const newMappedProps = getStateFromMappedProps(providedKeys.map((key)=>this.props[key]));
                // @ts-expect-error TS2322: Type {} is not assignable to type
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(WrappedComponent, {
                    ...this.props,
                    ...newMappedProps
                });
            }
        }; // eslint-disable-line @typescript-eslint/no-explicit-any
};
var $da3e17e369dbbaa5$export$2e2bcd8739ae039 = $da3e17e369dbbaa5$var$fireWithUIAnalytics;

});

parcelRegister("ivkNG", function(module, exports) {

$parcel$export(module.exports, "default", () => $d79b2c2cf8a78bb3$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $d79b2c2cf8a78bb3$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    addToStarred: {
        "id": "platform.ui.favouriting.favourite-button-stateless.add-to-starred",
        "defaultMessage": "Add to Starred"
    },
    removeFromStarred: {
        "id": "platform.ui.favouriting.favourite-button-stateless.remove-from-starred",
        "defaultMessage": "Remove from Starred"
    },
    toggleStarred: {
        "id": "platform.ui.favouriting.favourite-button-stateless.toggle-starred",
        "defaultMessage": "Star"
    },
    toggleStarredWithItemName: {
        "id": "platform.ui.favouriting.favourite-button-stateless.toggle-starred-with-item-name",
        "defaultMessage": "Star {itemName}"
    }
});

});





parcelRegister("iIz2S", function(module, exports) {

$parcel$export(module.exports, "default", () => $01b0322b2897f09e$export$2e2bcd8739ae039);
/* eslint-disable jira/i18n/id-named-by-package */ 
var $90IgZ = parcelRequire("90IgZ");
const $01b0322b2897f09e$var$messages = (0, $90IgZ.defineMessages)({
    heading: {
        "id": "global-issue-navigator.heading",
        "defaultMessage": "Issues"
    },
    windowTitle: {
        "id": "global-issue-navigator.window-title-migration",
        "defaultMessage": "Issue navigator"
    },
    filterWindowTitle: {
        "id": "global-issue-navigator.filter-window-title-migration",
        "defaultMessage": "[{filterName}] Issue navigator"
    }
});
var $01b0322b2897f09e$export$2e2bcd8739ae039 = $01b0322b2897f09e$var$messages;

});

parcelRegister("28XQo", function(module, exports) {

$parcel$export(module.exports, "default", () => $d6d3f7887ce9bffc$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ // eslint-disable-next-line jira/restricted/react-component-props

var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $knfPo = parcelRequire("knfPo");

var $h6s1i = parcelRequire("h6s1i");

var $2uJP0 = parcelRequire("2uJP0");

var $lENSF = parcelRequire("lENSF");

var $cWCvn = parcelRequire("cWCvn");

var $gYJxa = parcelRequire("gYJxa");

var $6yplV = parcelRequire("6yplV");
const $d6d3f7887ce9bffc$var$PageActions = ({ jql: jql, filterId: filterId, isModifiedFilter: isModifiedFilter, searchResultPageData: searchResultPageData, filterName: filterName })=>{
    (0, $cWCvn.markOnce)((0, $cWCvn.marks).PAGE_ACTIONS_START);
    (0, $eUqFw.useLayoutEffect)(()=>{
        (0, $cWCvn.markOnce)((0, $cWCvn.marks).PAGE_ACTIONS_END);
    }, []);
    const isAnonymous = (0, $6yplV.useIsAnonymous)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($d6d3f7887ce9bffc$export$48377ae1c677702b, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($d6d3f7887ce9bffc$var$StyledPageAction, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $2uJP0.default), null)), !isAnonymous && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($d6d3f7887ce9bffc$var$StyledPageAction, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $lENSF.ShareButton), {
        jql: jql,
        filterId: filterId,
        isModifiedFilter: isModifiedFilter
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($d6d3f7887ce9bffc$var$StyledPageAction, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $knfPo.default), {
        jql: jql,
        filterId: filterId,
        isModifiedFilter: isModifiedFilter,
        showEcosystemApps: true,
        filterName: filterName
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($d6d3f7887ce9bffc$var$StyledPageAction, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gYJxa.default), {
        filterId: filterId
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($d6d3f7887ce9bffc$var$StyledPageAction, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $h6s1i.default), {
        jql: jql,
        filterId: filterId,
        searchResultPageData: searchResultPageData
    })));
};
var $d6d3f7887ce9bffc$export$2e2bcd8739ae039 = $d6d3f7887ce9bffc$var$PageActions;
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $d6d3f7887ce9bffc$var$StyledPageAction = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_18s8otz2 _1ul9idpf _1xoqidpf",
            __cmplp.className
        ])
    });
});
const $d6d3f7887ce9bffc$export$48377ae1c677702b = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _2lx2vrvc _1n261q9c",
            __cmplp.className
        ])
    });
});

});
parcelRegister("knfPo", function(module, exports) {

$parcel$export(module.exports, "default", () => $f47583b52f51f07c$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $7rh0R = parcelRequire("7rh0R");

var $6OfWd = parcelRequire("6OfWd");

var $0cdA8 = parcelRequire("0cdA8");

var $79xbN = parcelRequire("79xbN");

var $5JgJ2 = parcelRequire("5JgJ2");

var $cBaEp = parcelRequire("cBaEp");
var $5n2jn = parcelRequire("5n2jn");

var $gGtKh = parcelRequire("gGtKh");

var $5as8g = parcelRequire("5as8g");

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $f47583b52f51f07c$var$ExportIssues = (0, $7rh0R.lazyAfterPaint)(()=>(parcelRequire("tp3yA")), {
    ssr: false,
    moduleId: "./src/packages/issue-navigator/actions/export-issues/src/ui/index.tsx"
});
const $f47583b52f51f07c$var$Fallback = ({ onRetry: onRetry, customTriggerButton: customTriggerButton })=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const triggerButton = ({ triggerRef: triggerRef, ...props })=>customTriggerButton ? customTriggerButton(false, {
            triggerRef: triggerRef,
            ...props
        }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5n2jn.FilterButton), {
            ...props,
            text: formatMessage((0, $79xbN.expVal)('issue-terminology-refresh-m1-fade', 'isIssueTermFaded', false) ? (0, $5as8g.default).exportButtonText : (0, $5as8g.default).exportIssuesButtonText),
            label: formatMessage((0, $5as8g.default).exportIssuesButtonIconLabel),
            ref: triggerRef
        });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $6OfWd.default), {
        trigger: ({ triggerRef: triggerRef, ...props })=>triggerButton({
                triggerRef: triggerRef,
                ...props
            }),
        shouldFlip: true,
        placement: "bottom-end",
        spacing: "compact"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $cBaEp.ErrorState), {
        onRetry: onRetry,
        pageAction: "exportIssues"
    }));
};
const $f47583b52f51f07c$var$AsyncExportIssues = (props)=>{
    const { customTriggerButton: customTriggerButton, customDisabledButton: customDisabledButton } = props;
    const [resetCaughtError, setResetCaughtError] = (0, $eUqFw.useState)();
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $0cdA8.JSErrorBoundary), {
        packageName: "jiraIssueNavigatorActionExportIssues",
        id: "async-export-issues",
        sendToPrivacyUnsafeSplunk: true,
        // Attempt to re-render children when retry is pressed in the fallback error state
        fallback: ({ error: error })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($f47583b52f51f07c$var$Fallback, {
                onRetry: ()=>setResetCaughtError(error),
                customTriggerButton: customTriggerButton
            }),
        onError: ()=>setResetCaughtError(undefined),
        resetCaughtError: resetCaughtError
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gGtKh.default), {
        name: "async-export-issues",
        fallback: customDisabledButton ?? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5n2jn.FilterButton), {
            isDisabled: true,
            text: formatMessage((0, $79xbN.expVal)('issue-terminology-refresh-m1-fade', 'isIssueTermFaded', false) ? (0, $5as8g.default).exportButtonText : (0, $5as8g.default).exportIssuesButtonText),
            label: formatMessage((0, $5as8g.default).exportIssuesButtonIconLabel)
        })
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($f47583b52f51f07c$var$ExportIssues, props)));
};
var $f47583b52f51f07c$export$2e2bcd8739ae039 = $f47583b52f51f07c$var$AsyncExportIssues;

});
parcelRegister("5n2jn", function(module, exports) {

$parcel$export(module.exports, "FilterButton", () => $7f3e65699e396200$export$fb46dd9777cc6db0);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $7JEyt = parcelRequire("7JEyt");

var $eUqFw = parcelRequire("eUqFw");

var $7u4fN = parcelRequire("7u4fN");

var $e9T6i = parcelRequire("e9T6i");

var $b5IAe = parcelRequire("b5IAe");
var $1ZAYh = parcelRequire("1ZAYh");
const $7f3e65699e396200$export$fb46dd9777cc6db0 = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ isSelected: isSelected, onClick: onClick, testId: testId, isDisabled: isDisabled, text: text, label: label, customTriggerProps: customTriggerProps }, ref)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
        xcss: $7f3e65699e396200$var$buttonWrapperStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7u4fN.default), {
        isSelected: isSelected,
        onClick: onClick,
        ref: ref,
        testId: testId,
        isDisabled: isDisabled,
        iconAfter: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($7f3e65699e396200$var$IconWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($e9T6i))), {
            label: label,
            color: "currentColor"
        })),
        ...customTriggerProps
    }, text)));
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $7f3e65699e396200$var$IconWrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c116y _4cvr1h6o _2hwx196n",
            __cmplp.className
        ])
    });
});
const $7f3e65699e396200$var$buttonWrapperStyles = (0, $1ZAYh.xcss)({
    position: 'relative'
});

});

parcelRegister("5as8g", function(module, exports) {

$parcel$export(module.exports, "default", () => $4e63f95712ce3819$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
const $4e63f95712ce3819$var$messages = (0, $90IgZ.defineMessages)({
    // remove on cleanup of jira-issue-term-fade-m1
    exportIssuesButtonText: {
        "id": "issue-navigator-action-export-issues.export-issues-button-text",
        "defaultMessage": "Export issues"
    },
    exportButtonText: {
        "id": "issue-navigator-action-export-issues.export-button-text",
        "defaultMessage": "Export"
    },
    exportIssuesButtonIconLabel: {
        "id": "issue-navigator-action-export-issues.export-issues-button-icon-label",
        "defaultMessage": "Open export issues dropdown"
    }
});
var $4e63f95712ce3819$export$2e2bcd8739ae039 = $4e63f95712ce3819$var$messages;

});

parcelRegister("tp3yA", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = $d1Cng("iMn9S").then(()=>parcelRequire('5vc4W'));

});


parcelRegister("h6s1i", function(module, exports) {

$parcel$export(module.exports, "default", () => $4a7fc7b195c224bc$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $7rh0R = parcelRequire("7rh0R");

var $7u4fN = parcelRequire("7u4fN");

var $6OfWd = parcelRequire("6OfWd");

var $jG1wZ = parcelRequire("jG1wZ");

var $0cdA8 = parcelRequire("0cdA8");

var $cBaEp = parcelRequire("cBaEp");

var $gGtKh = parcelRequire("gGtKh");

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $4a7fc7b195c224bc$var$MeatballMenu = (0, $7rh0R.lazyAfterPaint)(()=>(parcelRequire("8dSKD")), {
    ssr: false,
    moduleId: "./src/packages/issue-navigator/actions/meatball-menu/src/ui/index.tsx"
});
const $4a7fc7b195c224bc$var$Fallback = ({ onRetry: onRetry })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $6OfWd.default), {
        trigger: ({ triggerRef: triggerRef, ...props })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7u4fN.default), {
                ...props,
                appearance: "subtle",
                spacing: "default",
                iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($jG1wZ))), {
                    label: "",
                    size: "medium"
                }),
                ref: triggerRef
            }),
        shouldFlip: true,
        placement: "bottom-end",
        spacing: "compact"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $cBaEp.ErrorState), {
        onRetry: onRetry,
        pageAction: "meatballMenu"
    }));
const $4a7fc7b195c224bc$var$AsyncMeatballMenu = ({ jql: jql, filterId: filterId, searchResultPageData: searchResultPageData, additionalMenuItems: additionalMenuItems })=>{
    const [resetCaughtError, setResetCaughtError] = (0, $eUqFw.useState)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $0cdA8.JSErrorBoundary), {
        packageName: "jiraIssueNavigatorActionMeatballMenu",
        id: "async-issue-navigator-actions-meatball-menu",
        sendToPrivacyUnsafeSplunk: true,
        // Attempt to re-render children when retry is pressed in the fallback error state
        fallback: ({ error: error })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($4a7fc7b195c224bc$var$Fallback, {
                onRetry: ()=>setResetCaughtError(error)
            }),
        onError: ()=>setResetCaughtError(undefined),
        resetCaughtError: resetCaughtError
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gGtKh.default), {
        name: "async-issue-navigator-actions-meatball-menu",
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7u4fN.default), {
            appearance: "subtle",
            spacing: "default",
            isDisabled: true,
            iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($jG1wZ))), {
                label: "",
                size: "medium"
            })
        })
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($4a7fc7b195c224bc$var$MeatballMenu, {
        jql: jql,
        filterId: filterId,
        searchResultPageData: searchResultPageData,
        additionalMenuItems: additionalMenuItems
    })));
};
var $4a7fc7b195c224bc$export$2e2bcd8739ae039 = $4a7fc7b195c224bc$var$AsyncMeatballMenu;

});
parcelRegister("8dSKD", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = $d1Cng("hljUD").then(()=>parcelRequire('6pT9Z'));

});


parcelRegister("2uJP0", function(module, exports) {

$parcel$export(module.exports, "default", () => $c0d723ea8492ab89$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $7rh0R = parcelRequire("7rh0R");

var $6OfWd = parcelRequire("6OfWd");

var $0cdA8 = parcelRequire("0cdA8");

var $cBaEp = parcelRequire("cBaEp");

var $gGtKh = parcelRequire("gGtKh");

var $k6dT5 = parcelRequire("k6dT5");

// eslint-disable-next-line @typescript-eslint/no-explicit-any, jira/deprecations/no-rll-client-async-experiences
const $c0d723ea8492ab89$var$PluggableItems = (0, $7rh0R.lazyAfterPaint)(()=>(parcelRequire("kYHZk")), {
    ssr: false,
    moduleId: "./src/packages/issue-navigator/actions/pluggable-items/src/ui/main.tsx"
});
const $c0d723ea8492ab89$var$Fallback = ({ onRetry: onRetry })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $6OfWd.default), {
        trigger: ({ triggerRef: triggerRef, ...props })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $k6dT5.PluggableItemsFilterButton), {
                ...props,
                ref: triggerRef
            }),
        shouldFlip: true,
        placement: "bottom-end",
        spacing: "compact"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $cBaEp.ErrorState), {
        onRetry: onRetry,
        pageAction: "apps"
    }));
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $c0d723ea8492ab89$var$AsyncPluggableItems = ()=>{
    const [resetCaughtError, setResetCaughtError] = (0, $eUqFw.useState)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $0cdA8.JSErrorBoundary), {
        packageName: "jiraIssueNavigatorActionPluggableItems",
        id: "async-pluggable-items",
        sendToPrivacyUnsafeSplunk: true,
        // Attempt to re-render children when retry is pressed in the fallback error state
        fallback: ({ error: error })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($c0d723ea8492ab89$var$Fallback, {
                onRetry: ()=>setResetCaughtError(error)
            }),
        onError: ()=>setResetCaughtError(undefined),
        resetCaughtError: resetCaughtError
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gGtKh.default), {
        name: "async-pluggable-items",
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $k6dT5.PluggableItemsFilterButton), {
            isDisabled: true
        })
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($c0d723ea8492ab89$var$PluggableItems, null)));
};
var $c0d723ea8492ab89$export$2e2bcd8739ae039 = $c0d723ea8492ab89$var$AsyncPluggableItems;

});
parcelRegister("k6dT5", function(module, exports) {

$parcel$export(module.exports, "PluggableItemsFilterButton", () => $b94af5cf1a4ed3e7$export$7f94e3b48172a1bd);

var $eUqFw = parcelRequire("eUqFw");

var $5JgJ2 = parcelRequire("5JgJ2");

var $5n2jn = parcelRequire("5n2jn");

var $84ekY = parcelRequire("84ekY");
const $b94af5cf1a4ed3e7$export$7f94e3b48172a1bd = /*#__PURE__*/ (0, $eUqFw.forwardRef)((props, ref)=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5n2jn.FilterButton), {
        testId: "issue-navigator-action-pluggable-items.ui.filter-button.menu-trigger",
        text: formatMessage((0, $84ekY.default).pluggableItemsButtonText),
        label: formatMessage((0, $84ekY.default).pluggableItemsButtonIconLabel),
        ...props,
        ref: ref
    });
});

});
parcelRegister("84ekY", function(module, exports) {

$parcel$export(module.exports, "default", () => $8d3acdf85f10082e$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
const $8d3acdf85f10082e$var$messages = (0, $90IgZ.defineMessages)({
    pluggableItemsButtonText: {
        "id": "issue-navigator-action-pluggable-items.filter-button.pluggable-items-button-text",
        "defaultMessage": "Apps"
    },
    pluggableItemsButtonIconLabel: {
        "id": "issue-navigator-action-pluggable-items.filter-button.pluggable-items-button-icon-label",
        "defaultMessage": "Open pluggable items dropdown"
    }
});
var $8d3acdf85f10082e$export$2e2bcd8739ae039 = $8d3acdf85f10082e$var$messages;

});


parcelRegister("kYHZk", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = $d1Cng("8EJzH").then(()=>parcelRequire('aNyyT'));

});


parcelRegister("lENSF", function(module, exports) {

$parcel$export(module.exports, "ShareButton", () => $e5291975c0a502e1$export$e980dfbc2840e8bc);

var $eUqFw = parcelRequire("eUqFw");

var $jYVKV = parcelRequire("jYVKV");

var $9aFSa = parcelRequire("9aFSa");

var $5JgJ2 = parcelRequire("5JgJ2");

var $5n2jn = parcelRequire("5n2jn");
var $5as0a = parcelRequire("5as0a");

var $jMP2a = parcelRequire("jMP2a");
var $bFzGY = parcelRequire("bFzGY");

var $fQ7Iw = parcelRequire("fQ7Iw");

var $dWlsy = parcelRequire("dWlsy");

var $30zCP = parcelRequire("30zCP");

var $9vsYV = parcelRequire("9vsYV");

var $2ThFu = parcelRequire("2ThFu");

var $hDLbh = parcelRequire("hDLbh");

var $9tAVu = parcelRequire("9tAVu");
const $e5291975c0a502e1$var$getShareLink = (param, value)=>{
    const { hostname: hostname, protocol: protocol } = window.location;
    return `${protocol}//${hostname}/issues/?${param}=${encodeURIComponent(value)}`;
};
const $e5291975c0a502e1$var$CustomTriggerButton = ({ isDisabled: isDisabled, isSelected: isSelected, onClick: onClick }, triggerProps)=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bFzGY.useAnalyticsEvents)();
    const onKeyboardShortcutClick = (0, $eUqFw.useCallback)(()=>{
        (0, $jMP2a.fireUIAnalytics)(createAnalyticsEvent({
            action: 'pressed',
            actionSubject: 'keyboardShortcut'
        }), 'shareSearchCriteriaModalKeyboardShortcut', {
            keyPressed: 's',
            keyboardShortcut: true
        });
        onClick();
    }, [
        createAnalyticsEvent,
        onClick
    ]);
    const shortcutsKeyMap = (0, $eUqFw.useMemo)(()=>({
            s: {
                callback: onKeyboardShortcutClick,
                label: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", null, formatMessage((0, $9tAVu.messages).shareKeyboardShortcut))
            }
        }), [
        formatMessage,
        onKeyboardShortcutClick
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $9aFSa.default), {
        keyMap: shortcutsKeyMap
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5n2jn.FilterButton), {
        isDisabled: isDisabled,
        isSelected: isSelected,
        onClick: onClick,
        label: "",
        text: formatMessage((0, $9tAVu.messages).share),
        customTriggerProps: {
            ...triggerProps,
            'aria-haspopup': false
        }
    }));
};
const $e5291975c0a502e1$var$addContextToEvent = (event)=>{
    const attributes = event.context.map((context)=>context.attributes);
    event.update((payload)=>({
            ...payload,
            attributes: Object.assign(event.payload.attributes || {}, ...attributes)
        }));
};
const $e5291975c0a502e1$export$e980dfbc2840e8bc = ({ jql: jql, filterId: filterId, isModifiedFilter: isModifiedFilter = false })=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const subProduct = (0, $dWlsy.useSubProduct)();
    const [shouldShowThirdPartyNudge, setShouldShowThirdPartyNudge] = (0, $eUqFw.useState)(false);
    const showFilterShareLinkNew = filterId !== undefined && (0, $5as0a.isCustomFilter)(filterId) && !isModifiedFilter;
    // share custom filters by ID if the JQL is not overridden, otherwise just share the JQL
    const additionalProps = showFilterShareLinkNew ? {
        integrationType: (0, $9vsYV.INTEGRATION_TYPES).FILTER,
        shareContentType: (0, $9vsYV.INTEGRATION_TYPES).FILTER,
        shareLink: $e5291975c0a502e1$var$getShareLink('filter', filterId),
        shareTitle: formatMessage((0, $9tAVu.messages).filter),
        shareFormTitle: formatMessage((0, $9tAVu.messages).dialogTitleFilter)
    } : {
        integrationType: (0, $9vsYV.INTEGRATION_TYPES).SEARCH,
        shareContentType: (0, $9vsYV.INTEGRATION_TYPES).SEARCH,
        shareLink: $e5291975c0a502e1$var$getShareLink('jql', jql),
        shareTitle: formatMessage((0, $9tAVu.messages).search),
        shareFormTitle: formatMessage((0, $9tAVu.messages).dialogTitleSearch)
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $jYVKV.default), {
        channel: "*",
        onEvent: $e5291975c0a502e1$var$addContextToEvent
    }, shouldShowThirdPartyNudge && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $30zCP.default), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $fQ7Iw.default), {
        triggerButtonStyle: "icon-with-text",
        productId: "jira",
        subProductId: (0, $hDLbh.getShareSubProductId)(subProduct),
        objectAri: "" // The legacy sharing API does not use ARIs
        ,
        legacyShareClientConfig: (0, $2ThFu.shareSearchClientConfig),
        renderCustomTriggerButton: $e5291975c0a502e1$var$CustomTriggerButton,
        onTriggerButtonClick: ()=>{
            setShouldShowThirdPartyNudge(true);
        },
        ...additionalProps
    }));
};

});
parcelRegister("fQ7Iw", function(module, exports) {

$parcel$export(module.exports, "ShareLoadingPlaceholder", () => $eb292e1f91805d5c$export$5619d05bf511476b);
$parcel$export(module.exports, "default", () => $eb292e1f91805d5c$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $jG2Eu = parcelRequire("jG2Eu");

var $7rh0R = parcelRequire("7rh0R");

var $7u4fN = parcelRequire("7u4fN");

var $dFWNP = parcelRequire("dFWNP");


var $5GxEP = parcelRequire("5GxEP");

var $5JgJ2 = parcelRequire("5JgJ2");

var $gGtKh = parcelRequire("gGtKh");


var $8nUKh = parcelRequire("8nUKh");
const $eb292e1f91805d5c$export$5619d05bf511476b = ({ triggerButtonStyle: triggerButtonStyle = 'icon-only' })=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7u4fN.default), {
        appearance: "subtle",
        iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($dFWNP))), {
            size: "medium",
            label: formatMessage((0, $8nUKh.messages).shareTriggerButtonText),
            primaryColor: `var(--ds-icon, ${(0, $73a5c9d720aa66e1$exports).N30})`
        }),
        isDisabled: true
    }, triggerButtonStyle === 'icon-with-text' ? formatMessage((0, $8nUKh.messages).shareTriggerButtonText) : null));
};

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $eb292e1f91805d5c$var$ShareButton = (0, $7rh0R.lazyAfterPaint)(()=>(parcelRequire("cD4TX")), {
    ssr: false,
    moduleId: "./src/packages/growth/share-button/src/ui/index.tsx"
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$eb292e1f91805d5c$export$2e2bcd8739ae039 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5GxEP.default), {
        id: "async.share.button",
        packageName: "share-button"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gGtKh.default), {
        name: "share-button",
        fallback: props.renderCustomTriggerButton === undefined ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($eb292e1f91805d5c$export$5619d05bf511476b, {
            triggerButtonStyle: props.triggerButtonStyle
        }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(props.renderCustomTriggerButton, {
            isDisabled: true,
            onClick: (0, (/*@__PURE__*/$parcel$interopDefault($jG2Eu)))
        })
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($eb292e1f91805d5c$var$ShareButton, props)));

});
parcelRegister("dFWNP", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $9f4cb7ac67043f68$var$_react = $9f4cb7ac67043f68$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $igPbh = parcelRequire("igPbh");

var $9f4cb7ac67043f68$var$_share = $9f4cb7ac67043f68$var$_interopRequireDefault((parcelRequire("ec2xp")));
function $9f4cb7ac67043f68$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
const $9f4cb7ac67043f68$var$ShareIcon = (props)=>/*#__PURE__*/ $9f4cb7ac67043f68$var$_react.default.createElement($igPbh.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill="currentcolor" fill-rule="evenodd"><path fill-rule="nonzero" d="M6 15a3 3 0 1 0 0-6 3 3 0 0 0 0 6m0-2a1 1 0 1 1 0-2 1 1 0 0 1 0 2m12-4a3 3 0 1 0 0-6 3 3 0 0 0 0 6m0-2a1 1 0 1 1 0-2 1 1 0 0 1 0 2m0 14a3 3 0 1 0 0-6 3 3 0 0 0 0 6m0-2a1 1 0 1 1 0-2 1 1 0 0 1 0 2"/><path d="m7 13.562 8.66 5 1-1.732-8.66-5z"/><path d="m7 10.83 1 1.732 8.66-5-1-1.732z"/></g></svg>`
    }, props, {
        newIcon: $9f4cb7ac67043f68$var$_share.default
    }));
$9f4cb7ac67043f68$var$ShareIcon.displayName = 'ShareIcon';
var $9f4cb7ac67043f68$var$_default = module.exports.default = $9f4cb7ac67043f68$var$ShareIcon;

});
parcelRegister("ec2xp", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::6b1d38bd881e36a60e1d8f11863c2679>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $a55427aa389adc57$var$_react = $a55427aa389adc57$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $a55427aa389adc57$var$_UNSAFE_baseNew = $a55427aa389adc57$var$_interopRequireDefault((parcelRequire("gCIXy")));
function $a55427aa389adc57$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 * Please reach out in #icon-contributions before using these in production.
 *
 * Icon: "Share".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for sharing an object.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $a55427aa389adc57$var$ShareIcon = (props)=>/*#__PURE__*/ $a55427aa389adc57$var$_react.default.createElement($a55427aa389adc57$var$_UNSAFE_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path stroke="currentcolor" stroke-width="1.5" d="M10.434 11.717a1.75 1.75 0 1 0 3.131 1.566 1.75 1.75 0 0 0-3.13-1.566Zm0 0L5.316 8.783m0 0a1.74 1.74 0 0 0 0-1.566m0 1.566a1.75 1.75 0 1 1 0-1.566m0 0 5.118-2.934m0 0a1.75 1.75 0 1 0 3.13-1.566 1.75 1.75 0 0 0-3.13 1.566Z"/>`
    }, props));
$a55427aa389adc57$var$ShareIcon.displayName = 'ShareIcon';
var $a55427aa389adc57$var$_default = module.exports.default = $a55427aa389adc57$var$ShareIcon;

});


parcelRegister("8nUKh", function(module, exports) {

$parcel$export(module.exports, "messages", () => $c445af617ae0da86$export$defe85febe8b728c);

var $90IgZ = parcelRequire("90IgZ");
const $c445af617ae0da86$export$defe85febe8b728c = (0, $90IgZ.defineMessages)({
    shareTriggerButtonText: {
        "id": "share-button.share-trigger-button-text",
        "defaultMessage": "Share"
    }
});

});

parcelRegister("cD4TX", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = Promise.all([
    $d1Cng("2hmUs"),
    $d1Cng("bCeK4"),
    $d1Cng("hPzOn"),
    $d1Cng("h2MrD"),
    $d1Cng("bYT2S"),
    $d1Cng("2xQrm")
]).then(()=>parcelRequire('iHQJU'));

});


parcelRegister("9vsYV", function(module, exports) {

$parcel$export(module.exports, "INTEGRATION_TYPES", () => $d18c1776cefd37b8$export$195813ac8b6ae6f9);
const $d18c1776cefd37b8$export$195813ac8b6ae6f9 = {
    FILTER: 'filter',
    SEARCH: 'search'
};

});

parcelRegister("2ThFu", function(module, exports) {

$parcel$export(module.exports, "shareSearchClientConfig", () => $6ae9a3c91a3ab0ce$export$14295897acb58714);

var $9vsYV = parcelRequire("9vsYV");
const $6ae9a3c91a3ab0ce$export$14295897acb58714 = {
    getShareEndpoint: ({ link: link, type: type })=>type === (0, $9vsYV.INTEGRATION_TYPES).FILTER ? `/rest/share/1.0/filter/${new URL(link).searchParams.get('filter') || ''}` : '/rest/share/1.0/search',
    getSharePayload: ({ link: link, type: type })=>{
        const jql = new URL(link).searchParams.get('jql');
        return type === (0, $9vsYV.INTEGRATION_TYPES).SEARCH && jql !== null ? {
            jql: jql
        } : {};
    }
};

});

parcelRegister("hDLbh", function(module, exports) {

$parcel$export(module.exports, "getShareSubProductId", () => $9f06030df1b2a7dc$export$4a20278dd1d015dd);
const $9f06030df1b2a7dc$var$subProductMap = {
    addon: 'jira-addon',
    core: 'jira-core',
    polaris: 'jira-polaris',
    portfolio: 'jira-portfolio',
    serviceDesk: 'jira-servicedesk',
    software: 'jira-software',
    platform: 'jira-platform',
    unknown: 'jira-unknown'
};
const $9f06030df1b2a7dc$export$4a20278dd1d015dd = (subProduct)=>subProduct && $9f06030df1b2a7dc$var$subProductMap[subProduct] || 'jira-platform';

});

parcelRegister("9tAVu", function(module, exports) {

$parcel$export(module.exports, "messages", () => $c4ad6e9e767bee6f$export$defe85febe8b728c);

var $90IgZ = parcelRequire("90IgZ");
const $c4ad6e9e767bee6f$export$defe85febe8b728c = (0, $90IgZ.defineMessages)({
    dialogTitleFilter: {
        "id": "issue-navigator-action-share-button.dialog-title-filter",
        "defaultMessage": "Share current filter"
    },
    dialogTitleSearch: {
        "id": "issue-navigator-action-share-button.dialog-title-search",
        "defaultMessage": "Share search criteria"
    },
    filter: {
        "id": "issue-navigator-action-share-button.filter",
        "defaultMessage": "Filter"
    },
    search: {
        "id": "issue-navigator-action-share-button.search",
        "defaultMessage": "Search"
    },
    share: {
        "id": "issue-navigator-action-share-button.share",
        "defaultMessage": "Share"
    },
    shareKeyboardShortcut: {
        "id": "issue-navigator-action-share-button.share-keyboard-shortcut",
        "defaultMessage": "Open share modal"
    }
});

});


parcelRegister("gYJxa", function(module, exports) {

$parcel$export(module.exports, "default", () => $46042cbfdd614d98$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $jG2Eu = parcelRequire("jG2Eu");

var $fD5Ev = parcelRequire("fD5Ev");

var $kODOJ = parcelRequire("kODOJ");

var $b5IAe = parcelRequire("b5IAe");
var $1Yimi = parcelRequire("1Yimi");


var $9aFSa = parcelRequire("9aFSa");

var $1ybV0 = parcelRequire("1ybV0");

var $4ksts = parcelRequire("4ksts");

var $5as0a = parcelRequire("5as0a");

var $cHJdq = parcelRequire("cHJdq");
var $dqYzB = parcelRequire("dqYzB");
var $4085S = parcelRequire("4085S");
var $4eIC4 = parcelRequire("4eIC4");

var $jMP2a = parcelRequire("jMP2a");
var $bFzGY = parcelRequire("bFzGY");

var $6vrw7 = parcelRequire("6vrw7");

var $idWR0 = parcelRequire("idWR0");

var $8rQuz = parcelRequire("8rQuz");

var $jccNB = parcelRequire("jccNB");

var $3wKQY = parcelRequire("3wKQY");

var $cWCvn = parcelRequire("cWCvn");

var $1ydM0 = parcelRequire("1ydM0");

var $4RwIp = parcelRequire("4RwIp");

var $dKsVN = parcelRequire("dKsVN");
const $46042cbfdd614d98$var$KeyboardShortcuts = ({ view: view, onToggle: onToggle, intl: { formatMessage: formatMessage } })=>{
    const isDetailView = view === (0, $jccNB.views).detail;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $9aFSa.default), {
        keyMap: {
            t: {
                callback: ()=>{
                    const newView = isDetailView ? (0, $jccNB.views).list : (0, $jccNB.views).detail;
                    onToggle(newView, true);
                },
                label: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, formatMessage(isDetailView ? (0, $dKsVN.default).listText : (0, $dKsVN.default).detailText))
            }
        }
    });
};
const $46042cbfdd614d98$export$c774a1845e27fedc = ({ view: view, onToggle: onToggle, intl: intl })=>{
    const { formatMessage: formatMessage } = intl;
    const testIdPrefix = 'issue-navigator.ui.refinement-bar.view-switcher.toggle-button.';
    const options = (0, $1ybV0.ff)('sea-2744-jsw-tabs-nav') ? [
        {
            id: (0, $jccNB.views).list,
            label: (0, $8rQuz.isVisualRefreshEnabled)() ? formatMessage((0, $dKsVN.default).listOptionLabel) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1Yimi.default), {
                size: "UNSAFE_small",
                weight: "semibold"
            }, formatMessage((0, $dKsVN.default).listOptionLabel)),
            testId: `${testIdPrefix}${(0, $jccNB.views).list}`
        },
        {
            id: (0, $jccNB.views).detail,
            label: (0, $8rQuz.isVisualRefreshEnabled)() ? formatMessage((0, $dKsVN.default).detailOptionLabel) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1Yimi.default), {
                size: "UNSAFE_small",
                weight: "semibold"
            }, formatMessage((0, $dKsVN.default).detailOptionLabel)),
            testId: `${testIdPrefix}${(0, $jccNB.views).detail}`
        }
    ] : [
        {
            id: (0, $jccNB.views).list,
            label: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($46042cbfdd614d98$var$IconLabel, null, (0, $8rQuz.isVisualRefreshEnabled)() ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
                as: "span"
            }, formatMessage((0, $dKsVN.default).listOptionLabel)) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
                as: "span"
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1Yimi.default), {
                size: "UNSAFE_small",
                weight: "semibold"
            }, formatMessage((0, $dKsVN.default).listOptionLabel))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($fD5Ev))), {
                label: "",
                size: "small"
            })),
            testId: `${testIdPrefix}${(0, $jccNB.views).list}`
        },
        {
            id: (0, $jccNB.views).detail,
            label: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($46042cbfdd614d98$var$IconLabel, null, (0, $8rQuz.isVisualRefreshEnabled)() ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
                as: "span"
            }, formatMessage((0, $dKsVN.default).detailOptionLabel)) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
                as: "span"
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1Yimi.default), {
                size: "UNSAFE_small",
                weight: "semibold"
            }, formatMessage((0, $dKsVN.default).detailOptionLabel))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($kODOJ))), {
                label: "",
                size: "small"
            })),
            testId: `${testIdPrefix}${(0, $jccNB.views).detail}`
        }
    ];
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($46042cbfdd614d98$var$KeyboardShortcuts, {
        view: view,
        onToggle: onToggle,
        intl: intl
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $idWR0.default), {
        label: formatMessage((0, $dKsVN.default).toggleButtonsLabel),
        options: options,
        selectedOption: view,
        onChange: (newView)=>{
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            onToggle(newView, false);
        }
    }));
};
$46042cbfdd614d98$export$c774a1845e27fedc.defaultProps = {
    onToggle: (0, (/*@__PURE__*/$parcel$interopDefault($jG2Eu)))
};
const $46042cbfdd614d98$export$3f624639bbe23442 = ({ filterId: filterId })=>{
    (0, $cWCvn.markOnce)((0, $cWCvn.marks).PAGE_ACTIONS_VIEW_SWITCHER_START);
    (0, $eUqFw.useLayoutEffect)(()=>{
        (0, $cWCvn.markOnce)((0, $cWCvn.marks).PAGE_ACTIONS_VIEW_SWITCHER_END);
    }, []);
    const [selectedIssueKey] = (0, $1ydM0.useSelectedIssueKey)();
    const [{ view: view }, { setView: setView }] = (0, $4RwIp.useSelectedViewState)();
    const intl = (0, $4ksts.useIntlV2)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bFzGY.useAnalyticsEvents)();
    const handleOnToggle = (0, $eUqFw.useCallback)((newView, isKeyboardShortcut)=>{
        // When toggling to detail view we want to update the issue key in the URL to match the currently selected
        // issue. When toggling to list view we want to discard the issue key from the URL.
        const newIssueKey = newView === (0, $jccNB.views).detail ? selectedIssueKey : (0, $6vrw7.toIssueKey)('');
        let resolvedNewView = (0, $3wKQY.convertToIssueNavigatorId)(newView);
        if (newView === (0, $jccNB.views).list && filterId && (0, $5as0a.isCustomFilter)(filterId)) resolvedNewView = (0, $3wKQY.convertFilterIdToIssueNavigatorId)(filterId);
        setView(resolvedNewView, newIssueKey);
        const analyticsEvent = createAnalyticsEvent({
            action: 'clicked',
            actionSubject: 'button'
        });
        (0, $jMP2a.fireUIAnalytics)(analyticsEvent, 'switchIssueNavigatorView', {
            keyboardShortcut: isKeyboardShortcut,
            switchToView: newView
        });
        return true;
    }, [
        selectedIssueKey,
        filterId,
        setView,
        createAnalyticsEvent
    ]);
    const children = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $cHJdq.NinChangeboardingTourTarget), {
        engagementId: "nin.view-switcher"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($46042cbfdd614d98$export$c774a1845e27fedc, {
        view: (0, $3wKQY.convertToView)(view),
        onToggle: handleOnToggle,
        intl: intl
    }));
    const renderSpotlightCard = ({ onEndTour: onEndTour, onSetActiveCard: onSetActiveCard })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4085S.default), {
            cardKey: (0, $dqYzB.cardKeys).GLOBAL_SCOPE_VIEW_SWITCHER,
            dialogWidth: 272,
            dialogPlacement: "bottom right",
            actions: view === 'detail' ? [
                {
                    onClick: ()=>{
                        onEndTour();
                    },
                    text: intl.formatMessage((0, $dKsVN.default).done)
                }
            ] : [
                {
                    onClick: ()=>{
                        onSetActiveCard((0, $dqYzB.cardKeys).GLOBAL_SCOPE_COLUMN_PICKER);
                    },
                    text: intl.formatMessage((0, $dKsVN.default).next)
                },
                {
                    appearance: 'subtle',
                    onClick: ()=>{
                        onEndTour();
                    },
                    text: intl.formatMessage((0, $dKsVN.default).skip)
                }
            ],
            heading: intl.formatMessage((0, $dKsVN.default).tourHeading),
            target: "nin.spotlight.view-switcher",
            targetBgColor: `var(--ds-surface, ${(0, $73a5c9d720aa66e1$exports).N0})`,
            targetRadius: 3,
            messageId: "jira-issue-navigator.ui.view-switcher.spotlight",
            messageType: "transactional"
        }, intl.formatMessage((0, $dKsVN.default).tourBody));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4eIC4.default), {
        name: "nin.spotlight.view-switcher",
        renderSpotlightCard: renderSpotlightCard
    }, children);
};
var $46042cbfdd614d98$export$2e2bcd8739ae039 // clean up this styled element with sea-2744-jsw-tabs-nav
 = $46042cbfdd614d98$export$3f624639bbe23442;
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $46042cbfdd614d98$var$IconLabel = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _4cvr1h6o",
            (0, $8rQuz.isVisualRefreshEnabled)() ? "_zulp1b66" : "_10cu1b66 _2t30idpf",
            __cmplp.className
        ])
    });
});

});
parcelRegister("fD5Ev", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $b60ee1f4d4329714$var$_react = $b60ee1f4d4329714$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $igPbh = parcelRequire("igPbh");

var $b60ee1f4d4329714$var$_listBulleted = $b60ee1f4d4329714$var$_interopRequireDefault((parcelRequire("bH5AZ")));
function $b60ee1f4d4329714$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
const $b60ee1f4d4329714$var$BulletListIcon = (props)=>/*#__PURE__*/ $b60ee1f4d4329714$var$_react.default.createElement($igPbh.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill="currentcolor" fill-rule="evenodd"><rect width="8" height="2" x="10" y="15" rx="1"/><rect width="2" height="2" x="6" y="15" rx="1"/><rect width="8" height="2" x="10" y="11" rx="1"/><rect width="2" height="2" x="6" y="11" rx="1"/><rect width="8" height="2" x="10" y="7" rx="1"/><rect width="2" height="2" x="6" y="7" rx="1"/></g></svg>`
    }, props, {
        newIcon: $b60ee1f4d4329714$var$_listBulleted.default
    }));
$b60ee1f4d4329714$var$BulletListIcon.displayName = 'BulletListIcon';
var $b60ee1f4d4329714$var$_default = module.exports.default = $b60ee1f4d4329714$var$BulletListIcon;

});
parcelRegister("bH5AZ", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::38bd678c7566e24589e760902a3381f2>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $88380d0c63fc4ead$var$_react = $88380d0c63fc4ead$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $88380d0c63fc4ead$var$_UNSAFE_baseNew = $88380d0c63fc4ead$var$_interopRequireDefault((parcelRequire("gCIXy")));
function $88380d0c63fc4ead$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 * Please reach out in #icon-contributions before using these in production.
 *
 * Icon: "ListBulleted".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: bulleted lists, view all.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $88380d0c63fc4ead$var$ListBulletedIcon = (props)=>/*#__PURE__*/ $88380d0c63fc4ead$var$_react.default.createElement($88380d0c63fc4ead$var$_UNSAFE_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" d="M2.75 2.75a.5.5 0 1 1-1 0 .5.5 0 0 1 1 0m0 5.25a.5.5 0 1 1-1 0 .5.5 0 0 1 1 0m0 5.25a.5.5 0 1 1-1 0 .5.5 0 0 1 1 0"/><path stroke="currentcolor" stroke-width="1.5" d="M5 2.75h10M5 8h10M5 13.25h10M2.75 8a.5.5 0 1 1-1 0 .5.5 0 0 1 1 0Zm0 5.25a.5.5 0 1 1-1 0 .5.5 0 0 1 1 0Zm0-10.5a.5.5 0 1 1-1 0 .5.5 0 0 1 1 0Z"/>`
    }, props));
$88380d0c63fc4ead$var$ListBulletedIcon.displayName = 'ListBulletedIcon';
var $88380d0c63fc4ead$var$_default = module.exports.default = $88380d0c63fc4ead$var$ListBulletedIcon;

});


parcelRegister("kODOJ", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $f2775d08fa787154$var$_react = $f2775d08fa787154$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $igPbh = parcelRequire("igPbh");
function $f2775d08fa787154$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
const $f2775d08fa787154$var$DetailViewIcon = (props)=>/*#__PURE__*/ $f2775d08fa787154$var$_react.default.createElement($igPbh.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" d="M14 17h6V7.01C20 7 14 7 14 7zM12 5h8c1.11 0 2 .9 2 2.01V17a2 2 0 0 1-2 2h-8zM2 7h8V5H3a1 1 0 0 0-1 1zm0 4h8V9H2zm0 7c0 .55.45 1 1 1h7v-2H2zm0-3h8v-2H2z"/></svg>`
    }, props));
$f2775d08fa787154$var$DetailViewIcon.displayName = 'DetailViewIcon';
var $f2775d08fa787154$var$_default = module.exports.default = $f2775d08fa787154$var$DetailViewIcon;

});

parcelRegister("dqYzB", function(module, exports) {

$parcel$export(module.exports, "cardKeys", () => $313a4b88a1b80018$export$79399c5778983d77);
/**
 * Collection of keys representing individual spotlight cards displayed within the issue navigator.
 */ const $313a4b88a1b80018$export$79399c5778983d77 = {
    GLOBAL_SCOPE_JQL_BUILDER_NL_TO_JQL: 'global-scope.jql-builder-with-ai.natural-language-to-jql',
    GLOBAL_SCOPE_VIEW_SWITCHER: 'global-scope.view-switcher',
    GLOBAL_SCOPE_COLUMN_PICKER: 'global-scope.column-picker',
    JQL_BUILDER_NL_TOGGLE: 'jql-builder-with-ai.natural-language-toggle',
    JQL_BUILDER_NL_TO_JQL: 'jql-builder-with-ai.natural-language-to-jql'
};

});

parcelRegister("4085S", function(module, exports) {

$parcel$export(module.exports, "default", () => $64f57c7c3674fcbe$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $7rh0R = parcelRequire("7rh0R");

var $0cdA8 = parcelRequire("0cdA8");

var $gGtKh = parcelRequire("gGtKh");

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $64f57c7c3674fcbe$var$SpotlightTourCardAsync = (0, $7rh0R.lazyForPaint)(()=>(parcelRequire("jT5fU")), {
    ssr: false,
    moduleId: "./src/packages/issue-navigator/changeboarding/src/ui/spotlight-tour-card/main.tsx"
});
const $64f57c7c3674fcbe$var$SpotlightTourCard = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $0cdA8.JSErrorBoundary), {
        packageName: "jiraIssueNavigatorChangeboarding",
        id: "async-issue-navigator-changeboarding-spotlight-tour-card",
        sendToPrivacyUnsafeSplunk: true,
        fallback: "unmount"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gGtKh.default), {
        name: "async-issue-navigator-changeboarding-spotlight-tour-card"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($64f57c7c3674fcbe$var$SpotlightTourCardAsync, props)));
var $64f57c7c3674fcbe$export$2e2bcd8739ae039 = $64f57c7c3674fcbe$var$SpotlightTourCard;

});
parcelRegister("jT5fU", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = $d1Cng("bxqVy").then(()=>parcelRequire('lpOp3'));

});


parcelRegister("4eIC4", function(module, exports) {

$parcel$export(module.exports, "default", () => $b5bbb51b3bc2f363$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $aOINP = parcelRequire("aOINP");
var $ltfxy = parcelRequire("ltfxy");
var $7zpSo = parcelRequire("7zpSo");

var $kIyph = parcelRequire("kIyph");
/**
 *
 * Renders a spotlight target and associated spotlight card.
 */ const $b5bbb51b3bc2f363$var$SpotlightTourTarget = ({ children: children, name: name, renderSpotlightCard: renderSpotlightCard })=>{
    const { onEndTour: onEndTour, onSetActiveCard: onSetActiveCard } = (0, $kIyph.useSpotlightCoordinationActions)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $aOINP.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $ltfxy.default), {
        name: name
    }, children), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7zpSo.default), null, typeof renderSpotlightCard === 'function' ? renderSpotlightCard({
        onEndTour: onEndTour,
        onSetActiveCard: onSetActiveCard
    }) : renderSpotlightCard));
};
var $b5bbb51b3bc2f363$export$2e2bcd8739ae039 = $b5bbb51b3bc2f363$var$SpotlightTourTarget;

});
parcelRegister("kIyph", function(module, exports) {

$parcel$export(module.exports, "useIsActiveSpotlightCard", () => $7b3c8bc552587421$export$ac706a6842f43035);
$parcel$export(module.exports, "useSpotlightCoordinationActions", () => $7b3c8bc552587421$export$d0297e733168e478);

var $1yZQx = parcelRequire("1yZQx");
var $kEDjj = parcelRequire("kEDjj");

var $dqYzB = parcelRequire("dqYzB");
const $7b3c8bc552587421$var$initialState = {
    cardKey: null,
    onStopCoordination: null
};
const $7b3c8bc552587421$var$actions = {
    onSetActiveCard: (cardKey, stop)=>({ getState: getState, setState: setState })=>{
            const { onStopCoordination: onStopCoordination } = getState();
            setState({
                cardKey: cardKey,
                onStopCoordination: stop ?? onStopCoordination
            });
        },
    onEndTour: ()=>({ getState: getState, setState: setState })=>{
            const { onStopCoordination: onStopCoordination } = getState();
            onStopCoordination && onStopCoordination();
            setState({
                cardKey: null,
                onStopCoordination: null
            });
        }
};
const $7b3c8bc552587421$var$Store = (0, $kEDjj.createStore)({
    initialState: $7b3c8bc552587421$var$initialState,
    actions: $7b3c8bc552587421$var$actions
});
const $7b3c8bc552587421$export$ac706a6842f43035 = (0, $1yZQx.createHook)($7b3c8bc552587421$var$Store, {
    selector: (state, cardKeys)=>Array.isArray(cardKeys) ? state.cardKey !== null && cardKeys.includes(state.cardKey) : state.cardKey === cardKeys
});
const $7b3c8bc552587421$export$d0297e733168e478 = (0, $1yZQx.createActionsHook)($7b3c8bc552587421$var$Store);

});


parcelRegister("idWR0", function(module, exports) {

$parcel$export(module.exports, "default", () => $73632070bf5ddd84$export$2e2bcd8739ae039);

var $dnJL9 = parcelRequire("dnJL9");

var $eH00z = parcelRequire("eH00z");

var $jMs5R = parcelRequire("jMs5R");
var $73632070bf5ddd84$export$2e2bcd8739ae039 = (0, $dnJL9.componentWithFG)('visual-refresh', (0, $eH00z.ToggleButtons), (0, $jMs5R.default));

});
parcelRegister("eH00z", function(module, exports) {

$parcel$export(module.exports, "ToggleButtons", () => $0ddb838bd67d365a$export$34301fadafd0cd9d);

var $eUqFw = parcelRequire("eUqFw");

var $b5IAe = parcelRequire("b5IAe");
var $4ZL0y = parcelRequire("4ZL0y");
var $1ZAYh = parcelRequire("1ZAYh");
const $0ddb838bd67d365a$export$34301fadafd0cd9d = ({ options: options, selectedOption: selectedOption, onChange: onChange, label: label, isCompact: isCompact })=>{
    const getButtonWithContext = (0, $eUqFw.useCallback)(({ option: option, isSelected: isSelected })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4ZL0y.default), {
            key: option.id,
            role: "radio",
            "aria-checked": isSelected,
            xcss: [
                $0ddb838bd67d365a$var$baseStyles,
                !isCompact && $0ddb838bd67d365a$var$wideStyles,
                isSelected && $0ddb838bd67d365a$var$selectedStyles
            ],
            onClick: (event)=>!isSelected && onChange(option.id, event),
            isDisabled: option.isDisabled,
            testId: option.testId
        }, option.label), [
        onChange,
        isCompact
    ]);
    return(// eslint-disable-next-line jsx-a11y/no-noninteractive-element-to-interactive-role
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
        role: "radiogroup",
        xcss: $0ddb838bd67d365a$var$containerStyles,
        "aria-label": label,
        as: "fieldset"
    }, options.map((option)=>getButtonWithContext({
            option: option,
            isSelected: option.id === selectedOption
        }))));
};
const $0ddb838bd67d365a$var$containerStyles = (0, $1ZAYh.xcss)({
    borderColor: 'color.border',
    borderWidth: '1px',
    borderStyle: 'solid',
    borderRadius: "var(--ds-border-radius-100, 4px)",
    paddingInline: 'space.025',
    gap: 'space.025',
    display: 'inline-flex',
    alignItems: 'center',
    height: '2rem'
});
const $0ddb838bd67d365a$var$baseStyles = (0, $1ZAYh.xcss)({
    background: "var(--ds-background-neutral-subtle, #00000000)",
    border: '1px solid transparent',
    borderRadius: "var(--ds-border-radius-050, 2px)",
    color: 'color.text.subtle',
    height: '26px',
    fontWeight: '500',
    padding: 'space.0',
    ':hover': {
        background: "var(--ds-background-neutral-subtle-hovered, #091E420F)",
        color: 'color.text.subtle'
    },
    ':active': {
        background: "var(--ds-background-neutral-subtle-pressed, #091E4224)",
        color: 'color.text.subtle'
    },
    ':focus': {
        outlineOffset: 'space.0'
    },
    ':disabled': {
        background: "var(--ds-background-disabled, #091E4208)",
        color: 'color.text.disabled'
    }
});
const $0ddb838bd67d365a$var$selectedStyles = (0, $1ZAYh.xcss)({
    background: "var(--ds-background-selected, #E9F2FF)",
    border: `1px solid ${"var(--ds-border-selected, #0C66E4)"}`,
    color: 'color.text.selected',
    cursor: 'default',
    ':hover': {
        background: "var(--ds-background-selected, #E9F2FF)",
        color: 'color.text.selected'
    }
});
const $0ddb838bd67d365a$var$wideStyles = (0, $1ZAYh.xcss)({
    paddingLeft: 'space.150',
    paddingRight: 'space.150'
});

});

parcelRegister("jMs5R", function(module, exports) {

$parcel$export(module.exports, "default", () => $64888888ab0ff674$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");
var $9t7rW = parcelRequire("9t7rW");


var $c9TLT = parcelRequire("c9TLT");

var $41hTH = parcelRequire("41hTH");

var $jXplI = parcelRequire("jXplI");
let $64888888ab0ff674$var$uniqueId = 0;
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$64888888ab0ff674$export$2e2bcd8739ae039 = ({ label: label, options: options, selectedOption: selectedOption, onChange: onChange })=>{
    (0, $jXplI.assertPrecondition)(()=>({
            precondition: options.length > 0,
            message: `ToggleButtons requires at least one option, but received ${options.length}`
        }));
    (0, $jXplI.assertPrecondition)(()=>({
            precondition: (0, $jXplI.findDuplicateIds)(options) === null,
            message: `ToggleButtons requires that every option has a unique ID, but received "${(0, $jXplI.findDuplicateIds)(options)}" multiple times`
        }));
    (0, $jXplI.assertPrecondition)(()=>({
            precondition: options.findIndex((option)=>option.id === selectedOption) !== -1,
            message: `ToggleButtons requires that the selectedOption matches the ID of one of the passed options, but "${selectedOption}" did not`
        }));
    const [id] = (0, $eUqFw.useState)(()=>`toggle-buttons-${$64888888ab0ff674$var$uniqueId++}`);
    const fieldsetRef = (0, $eUqFw.useRef)(null);
    const selectedOptionRef = (0, $eUqFw.useRef)();
    const [selectedOptionPosition, setSelectedOptionPosition] = (0, $eUqFw.useState)();
    (0, $eUqFw.useEffect)(()=>{
        const fieldset = fieldsetRef.current;
        // Replace with lodash/noop
        // eslint-disable-next-line @typescript-eslint/no-empty-function
        if (!fieldset || !window.ResizeObserver) return ()=>{};
        const resizeObserver = new window.ResizeObserver(()=>{
            const element = selectedOptionRef.current;
            if (element) setSelectedOptionPosition({
                left: element.offsetLeft,
                top: element.offsetTop,
                width: element.offsetWidth,
                height: element.offsetHeight
            });
        });
        resizeObserver.observe(fieldset);
        return ()=>{
            resizeObserver.unobserve(fieldset);
        };
    }, [
        selectedOption
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($64888888ab0ff674$var$Fieldset, {
        ref: fieldsetRef,
        selectedOptionPosition: selectedOptionPosition
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("legend", null, label), options.map((option)=>{
        const isChecked = selectedOption === option.id;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $41hTH.default), {
            key: option.id,
            name: id,
            value: option.id,
            isChecked: isChecked,
            isDisabled: !!option.isDisabled,
            onChange: onChange,
            // @ts-expect-error - TS2322 - Type 'MutableRefObject<unknown> | undefined' is not assignable to type 'Ref<OptionProps> | undefined'.
            ref: isChecked ? selectedOptionRef : undefined,
            testId: option.testId
        }, option.label);
    }));
};
// The !important rules are required so that we can use this mixin on selectors
// with arbitrary specificity
const $64888888ab0ff674$var$selectedOptionIndicator = {
    backgroundColor: `${`var(--ds-background-accent-gray-subtler, ${(0, $73a5c9d720aa66e1$exports).N0})`} !important`,
    borderRadius: `${(0, $c9TLT.borderRadius)}px !important`
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $64888888ab0ff674$var$Fieldset = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "fieldset", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { selectedOptionPosition: selectedOptionPosition, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmpldp,
        style: {
            ...__cmpls,
            "--_ozn9do": (0, $9t7rW.default)(__cmplp.selectedOptionPosition?.left, "px"),
            "--_1ibdxcf": (0, $9t7rW.default)(__cmplp.selectedOptionPosition?.top, "px"),
            "--_1ggrzjo": (0, $9t7rW.default)(__cmplp.selectedOptionPosition?.width, "px"),
            "--_1797z6d": (0, $9t7rW.default)(__cmplp.selectedOptionPosition?.height, "px")
        },
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _1n261g80 _1bsb1ris _p12f1osq _kqswh2mm _bfhk1s4m _2rko1l7b _1yt41b66 _11c8qk37 _k48p1pd9 _vwz41clk _1p1dangw _syazaj1x _1r9t7mnp _ho6m1wmp _soiet94y _1se6t94y _1jdg1n1a _z71v1n1a _1o5t1n1a _irrs1n1a _p8t715vq _b4u715vq _1qiiidpf _12o6idpf _19mbidpf _1ob8idpf _1jhnstnw _10bvh2mm _1nvfze3t _1nei1b66 _rt2pze3t _bmksze3t _fhioidpf _1kt9b3bt _1cs8stnw _1rus1tag _rfx31wa3 _qs2z1l1k _1cg61yx9 _mlfedkwg",
            __cmplp.selectedOptionPosition ? "_cfu11ule" : "_cfu1glyw",
            __cmplp.selectedOptionPosition?.left ? "_qnecejz7" : "_qnecidpf",
            __cmplp.selectedOptionPosition?.top ? "_1auk1nuc" : "_1aukidpf",
            __cmplp.selectedOptionPosition?.width ? "_1mp412nj" : "_1mp4idpf",
            __cmplp.selectedOptionPosition?.height ? "_kfgt1d85" : "_kfgtidpf",
            !__cmplp.selectedOptionPosition && "_15e91tag _1ph31wa3",
            __cmplp.className
        ])
    });
});

});
parcelRegister("41hTH", function(module, exports) {

$parcel$export(module.exports, "default", () => $add48a5e476f4f24$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $7JEyt = parcelRequire("7JEyt");

var $eUqFw = parcelRequire("eUqFw");
var $add48a5e476f4f24$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ name: name, value: value, isChecked: isChecked, isDisabled: isDisabled, onChange: onChange, children: children, testId: testId }, ref)=>{
    const id = `${name}-${value}`;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($add48a5e476f4f24$var$Container, {
        ref: ref
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("input", {
        type: "radio",
        id: id,
        name: name,
        value: value,
        checked: isChecked,
        disabled: isDisabled,
        "data-testid": testId,
        onChange: (event)=>onChange(value, event)
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("label", {
        htmlFor: id
    }, children));
});
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $add48a5e476f4f24$var$Container = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "p", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_11127mnp _1q091wmp _pytkt94y _5hv9t94y _2x4g1n1a _12hv1n1a _x5bd1n1a _1rgf1n1a _1yzy15vq _bgrh15vq _v69yidpf _ogxmidpf _1qtqidpf _n9z4idpf _khufstnw _15pj1ule _136ejjoz _1vzltlke _1ioh1l7b _1hhy73ad _1emz73ad _1efl8q0r _7el91vt6 _15pqglyw _vrjh14ae _c2fy18uv _ynfu18uv",
            __cmplp.className
        ])
    });
});

});

parcelRegister("jXplI", function(module, exports) {

$parcel$export(module.exports, "findDuplicateIds", () => $e5a01c78f2e53866$export$e5f5e25214715ca1);
$parcel$export(module.exports, "assertPrecondition", () => $e5a01c78f2e53866$export$5565eefbe4b468a0);
const $e5a01c78f2e53866$export$e5f5e25214715ca1 = (options)=>{
    for(let i = 0; i < options.length - 1; ++i)for(let j = i + 1; j < options.length; ++j){
        if (options[i].id === options[j].id) return options[i].id;
    }
    return null;
};
const $e5a01c78f2e53866$export$5565eefbe4b468a0 = (evaluatePrecondition)=>{};

});



parcelRegister("dKsVN", function(module, exports) {

$parcel$export(module.exports, "default", () => $6bb49378eb4ca498$export$2e2bcd8739ae039);
/* eslint-disable jira/i18n/id-named-by-package */ 
var $90IgZ = parcelRequire("90IgZ");
const $6bb49378eb4ca498$var$messages = (0, $90IgZ.defineMessages)({
    done: {
        "id": "issue-navigator.view-switcher.done",
        "defaultMessage": "Done"
    },
    next: {
        "id": "issue-navigator.view-switcher.next",
        "defaultMessage": "Next"
    },
    skip: {
        "id": "issue-navigator.view-switcher.skip",
        "defaultMessage": "Skip"
    },
    tourHeading: {
        "id": "issue-navigator.view-switcher.tour-heading",
        "defaultMessage": "View switcher"
    },
    tourBody: {
        "id": "issue-navigator.view-switcher.tour-body",
        "defaultMessage": "Switch between these two views to easily scan through a list or view the details of the issues."
    },
    detailText: {
        "id": "issue-navigator.refinement-bar.view-switcher.detail-text",
        "defaultMessage": "Switch to detail view"
    },
    listText: {
        "id": "issue-navigator.refinement-bar.view-switcher.list-text",
        "defaultMessage": "Switch to list view"
    },
    toggleButtonsLabel: {
        "id": "issue-navigator.refinement-bar.view-switcher.toggle-buttons-label",
        "defaultMessage": "Select view"
    },
    detailOptionLabel: {
        "id": "issue-navigator.refinement-bar.view-switcher.detail-option-label",
        "defaultMessage": "Detail view"
    },
    listOptionLabel: {
        "id": "issue-navigator.refinement-bar.view-switcher.list-option-label",
        "defaultMessage": "List view"
    }
});
var $6bb49378eb4ca498$export$2e2bcd8739ae039 = $6bb49378eb4ca498$var$messages;

});





parcelRegister("eMGKM", function(module, exports) {

$parcel$export(module.exports, "getJqlFromParamValues", () => $58d137b95f298e69$export$52de656da34011c3);
$parcel$export(module.exports, "getSearchInput", () => $58d137b95f298e69$export$2fa22ca814667ff4);
$parcel$export(module.exports, "useUpdateUrlQueryParamCallback", () => $58d137b95f298e69$export$f6b4f46bd8314b51);
$parcel$export(module.exports, "isFilterId", () => (parcelRequire("5as0a")).isFilterId);

var $eUqFw = parcelRequire("eUqFw");

var $5as0a = parcelRequire("5as0a");

var $lB25E = parcelRequire("lB25E");

var $jccNB = parcelRequire("jccNB");
const $58d137b95f298e69$export$52de656da34011c3 = (defaultJql, jqlParam, filter, /**
	 * when `filter` has a value that is not a standard numeric filter ID, consumers can provide a
	 * customMapper function to transform the filter value to a jql string. For example this is used
	 * by Project Issue Navigator to map filter query params such as '?filter=myopenissues into jql
	 * strings without calling the backend API
	 */ customMapper, /**
	 * callback in the event of jql being returned is different to the jqlParam value, such as when
	 * it is undefined and the default jql is being returned. This allows the caller to sync the new
	 * jql value with the `?jql=...` url query param
	 */ onMutateJqlParam)=>{
    let jql = jqlParam;
    if (typeof jql === 'string') return jql;
    if ((0, $5as0a.isFilterId)(filter)) return undefined;
    if (typeof filter === 'string' && customMapper) jql = customMapper(filter);
    if (jql === undefined) jql = defaultJql;
    if (jql !== jqlParam) onMutateJqlParam?.(jql);
    return jql;
};
const $58d137b95f298e69$var$getFilter = (filterInput)=>(0, $5as0a.isFilterId)(filterInput) ? {
        value: filterInput,
        type: (0, $jccNB.FilterTypes).ID
    } : {
        value: filterInput,
        type: (0, $jccNB.FilterTypes).JQL
    };
const $58d137b95f298e69$export$2fa22ca814667ff4 = (jqlInput, filterInput)=>{
    const filter = filterInput !== undefined ? $58d137b95f298e69$var$getFilter(filterInput) : undefined;
    if (jqlInput === undefined) {
        if (filter === undefined) throw new Error('filter is missing for search input');
        return filter;
    }
    if (filter === undefined) return {
        jql: jqlInput,
        type: (0, $jccNB.SearchInputTypes).JQL
    };
    return {
        jql: jqlInput,
        filter: filter,
        type: (0, $jccNB.SearchInputTypes).FILTER_AND_JQL
    };
};
const $58d137b95f298e69$export$f6b4f46bd8314b51 = (queryParamKey)=>{
    const [_, setQueryParam] = (0, $lB25E.useQueryParam)(queryParamKey);
    const setJqlQueryParamCallback = (0, $eUqFw.useCallback)((value)=>setQueryParam(value, 'replace'), [
        setQueryParam
    ]);
    return setJqlQueryParamCallback;
};

});

parcelRegister("7vf5z", function(module, exports) {

$parcel$export(module.exports, "checkAndEmitApdexSignal", () => $074ba9858fda469d$export$3082c88b693a5230);
$parcel$export(module.exports, "default", () => $074ba9858fda469d$export$2e2bcd8739ae039);
$parcel$export(module.exports, "baseDefaultProps", () => $074ba9858fda469d$export$9b3029ee6188a41f);

var $eUqFw = parcelRequire("eUqFw");

var $1ybV0 = parcelRequire("1ybV0");

var $3iMaY = parcelRequire("3iMaY");

var $eJ3kO = parcelRequire("eJ3kO");

var $51JrV = parcelRequire("51JrV");

var $4nnPJ = parcelRequire("4nnPJ");

var $22iQy = parcelRequire("22iQy");

var $brm1D = parcelRequire("brm1D");

var $ifyPR = parcelRequire("ifyPR");

var $aS0xb = parcelRequire("aS0xb");

var $45wsB = parcelRequire("45wsB");
const $074ba9858fda469d$export$3082c88b693a5230 = (appName, metricKey)=>{
    var emitSignal;
};
class $074ba9858fda469d$export$2e2bcd8739ae039 extends (0, $eUqFw.Component) {
    static{
        this.defaultProps = {
            isExpectedToHaveSsr: false,
            withMarks: [],
            extra: {},
            emitOnAnimationFrame: false
        };
    }
    render() {
        const { appName: appName, metricKey: metricKey, extra: extra, metric: metric, emitOnAnimationFrame: emitOnAnimationFrame, waitForLongTaskIdleTTI: waitForLongTaskIdleTTI } = this.props;
        $074ba9858fda469d$export$3082c88b693a5230(appName, metricKey);
        const isUFODefined = (0, $1ybV0.ff)('uip.ufo') && (0, $4nnPJ.GlobalPageLoadExperience).loadingPageLoadId !== 'UNKNOWN';
        if (isUFODefined) (0, $aS0xb.addUFOSSRDoneAsFMPToInteraction)();
        if (metric) {
            // https://product-fabric.atlassian.net/browse/UFO-323
            (0, $ifyPR.addBM3SSRDoneAsFMPToInteraction)(metric);
            (0, $45wsB.trackBM3FeatureFlagsAccessed)(metric);
        }
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $3iMaY.default), {
            data: extra
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $eJ3kO.UFOBM3TimingsToUFO), {
            marks: metric?.getData()?.marks,
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            timings: metric?.getData()?.config?.timings
        }), isUFODefined ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $brm1D.StopUfo), {
            appName: appName,
            customData: extra,
            key: (0, $51JrV.getInteractionId)().current
        }) : metric && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $22iQy.StopBrowserMetrics3), {
            metric: metric,
            customData: extra,
            emitOnAnimationFrame: emitOnAnimationFrame,
            waitForLongTaskIdleTTI: waitForLongTaskIdleTTI
        }));
    }
}
const $074ba9858fda469d$export$9b3029ee6188a41f = $074ba9858fda469d$export$2e2bcd8739ae039.defaultProps;

});
parcelRegister("eJ3kO", function(module, exports) {

$parcel$export(module.exports, "getBm3Timings", () => $8841aa10a213faf4$export$f02972da195a43bb);
$parcel$export(module.exports, "UFOBM3TimingsToUFO", () => $8841aa10a213faf4$export$30f0b5e5acd268bf);
$parcel$export(module.exports, "addBM3TimingsToUFO", () => $8841aa10a213faf4$export$d93d677ef2f33c5c);

var $eUqFw = parcelRequire("eUqFw");

var $3Hphq = parcelRequire("3Hphq");

var $51JrV = parcelRequire("51JrV");

var $fYqUr = parcelRequire("fYqUr");
function $8841aa10a213faf4$export$f02972da195a43bb(marks, timingConfigs) {
    const bm3Timings = {};
    if (!marks || !timingConfigs) return bm3Timings;
    timingConfigs.forEach((item)=>{
        if (!item.startMark || !item.endMark) return;
        const startTime = marks[item.startMark];
        if (!startTime) return;
        const endTime = marks[item.endMark];
        if (!endTime) return;
        bm3Timings[item.key] = {
            startTime: startTime,
            endTime: endTime
        };
    });
    return bm3Timings;
}
function $8841aa10a213faf4$export$30f0b5e5acd268bf({ marks: marks, timings: timings }) {
    const interactionContext = (0, $eUqFw.useContext)((0, $3Hphq.default));
    const interactionId = (0, $51JrV.getInteractionId)().current;
    (0, $eUqFw.useMemo)(()=>{
        if (interactionContext != null && interactionId != null && marks != null && timings != null) {
            const interactionType = (0, $fYqUr.getCurrentInteractionType)(interactionId);
            if (interactionType === 'press') return;
            const bm3Timings = $8841aa10a213faf4$export$f02972da195a43bb(marks, timings);
            interactionContext.addCustomTimings(bm3Timings);
        }
    }, [
        interactionContext,
        interactionId,
        marks,
        timings
    ]);
    return null;
}
function $8841aa10a213faf4$export$d93d677ef2f33c5c(marks, timingsConfig) {
    const interactionId = (0, $51JrV.getInteractionId)().current;
    if (interactionId) {
        const interactionType = (0, $fYqUr.getCurrentInteractionType)(interactionId);
        if (interactionType === 'press') return;
        const bm3Timings = $8841aa10a213faf4$export$f02972da195a43bb(marks, timingsConfig);
        (0, $fYqUr.addCustomTiming)(interactionId, [], bm3Timings);
    }
}

});

parcelRegister("22iQy", function(module, exports) {

$parcel$export(module.exports, "StopBrowserMetrics3", () => $c48b51f586335ad5$export$575e93c0f9905999);

var $eUqFw = parcelRequire("eUqFw");

var $acbV3 = parcelRequire("acbV3");

var $6iz4v = parcelRequire("6iz4v");

var $6xYPC = parcelRequire("6xYPC");

var $1ybV0 = parcelRequire("1ybV0");

var $cNlZD = parcelRequire("cNlZD");

var $6M8Uw = parcelRequire("6M8Uw");

var $2B87Z = parcelRequire("2B87Z");

var $87isp = parcelRequire("87isp");

var $3Hphq = parcelRequire("3Hphq");

const $c48b51f586335ad5$var$emitMetrics = (metric, customData, stopTime)=>{
    !(0, $1ybV0.ff)('bm3.emit-on-raf.top-experiences') && (0, $2B87Z.stopInitialPageLoadTimingFromPerformanceMarkStart)('product', (0, $6M8Uw.PRODUCT_START_MARK), true);
    (0, $2B87Z.setInitialPageLoadTimingFromPerformanceMarks)('batch-js-heritage.eval', 'jira.heritage_batch_file_eval:start', 'jira.heritage_batch_file_eval:end');
    if (stopTime !== undefined) {
        if (!(0, $1ybV0.ff)('bm3.wait-for-long-task')) {
            metric.mark((0, $37f655a4e4d5690e$export$99c08ec92759c71c));
            (0, $6iz4v.setMark)((0, $37f655a4e4d5690e$export$99c08ec92759c71c));
            (0, $6iz4v.setMeasure)('BROWSER_METRICS_TTI_RAF', 'BROWSER_METRICS_TTI_START', (0, $37f655a4e4d5690e$export$99c08ec92759c71c));
        }
        metric.stop({
            customData: customData,
            stopTime: stopTime
        });
    } else metric.stop({
        customData: customData
    });
    if ((0, $87isp.isAutomaticExposureCollectionEnabled)()) (0, $6xYPC.stopLowPriorityEventDelay)();
};
class $c48b51f586335ad5$export$575e93c0f9905999 extends (0, $eUqFw.Component) {
    componentDidMount() {
        const { metric: metric, customData: customData, emitOnAnimationFrame: emitOnAnimationFrame } = this.props;
        if (!metric) return;
        const start = (0, $1ybV0.ff)('bm3.wait-for-long-task') ? (0, $acbV3.browserMetrics).getPageLoadMetric().getData()?.start || 0 : 0;
        (0, $6iz4v.setMark)('BROWSER_METRICS_TTI_START', {
            startTime: start
        });
        (0, $6iz4v.setMark)('BROWSER_METRICS_TTI_END');
        (0, $6iz4v.setMeasure)('BROWSER_METRICS_TTI', 'BROWSER_METRICS_TTI_START', 'BROWSER_METRICS_TTI_END');
        const bm3Data = metric.getData();
        if (this.props.waitForLongTaskIdleTTI) {
            const stopTime = performance.now();
            (0, $1ybV0.ff)('bm3.emit-on-raf.top-experiences') && (0, $2B87Z.stopInitialPageLoadTimingFromPerformanceMarkStart)('product', (0, $6M8Uw.PRODUCT_START_MARK), true);
            (0, $cNlZD.getTTIValue)().then((tti)=>{
                (0, $cNlZD.resetTTIObserver)();
                (0, $6iz4v.setMark)('BROWSER_METRICS_LONG_TASK_TTI_END', {
                    startTime: tti
                });
                (0, $6iz4v.setMeasure)('BROWSER_METRICS_LONG_TASK_TTI', 'BROWSER_METRICS_TTI_START', 'BROWSER_METRICS_LONG_TASK_TTI_END');
                $c48b51f586335ad5$var$emitMetrics(metric, customData, stopTime);
            });
            if (bm3Data) this.context?.addApdex({
                key: bm3Data.key,
                startTime: bm3Data.start,
                stopTime: stopTime
            });
        } else if (emitOnAnimationFrame) {
            const stopTime = performance.now();
            (0, $1ybV0.ff)('bm3.emit-on-raf.top-experiences') && (0, $2B87Z.stopInitialPageLoadTimingFromPerformanceMarkStart)('product', (0, $6M8Uw.PRODUCT_START_MARK), true);
            if (bm3Data) this.context?.addApdex({
                key: bm3Data.key,
                startTime: bm3Data.start,
                stopTime: stopTime
            });
            if (typeof queueMicrotask !== 'undefined') queueMicrotask(()=>{
                (0, $6iz4v.setMark)('BROWSER_METRICS_TTI_TASK_END');
                (0, $6iz4v.setMeasure)('BROWSER_METRICS_TTI_TASK', 'BROWSER_METRICS_TTI_START', 'BROWSER_METRICS_TTI_TASK_END');
            });
            requestAnimationFrame(()=>{
                if ((0, $1ybV0.ff)('bm3.wait-for-long-task')) {
                    metric.mark((0, $37f655a4e4d5690e$export$99c08ec92759c71c));
                    (0, $6iz4v.setMark)((0, $37f655a4e4d5690e$export$99c08ec92759c71c));
                    (0, $6iz4v.setMeasure)('BROWSER_METRICS_TTI_RAF', 'BROWSER_METRICS_TTI_START', (0, $37f655a4e4d5690e$export$99c08ec92759c71c));
                }
                if ((0, $1ybV0.ff)('bm3.wait-for-long-task')) setTimeout(()=>{
                    $c48b51f586335ad5$var$emitMetrics(metric, customData, stopTime);
                }, 500);
                else $c48b51f586335ad5$var$emitMetrics(metric, customData, stopTime);
            });
        } else {
            if (bm3Data) this.context?.addApdex({
                key: bm3Data.key,
                startTime: bm3Data.start,
                stopTime: performance.now()
            });
            (0, $1ybV0.ff)('bm3.emit-on-raf.top-experiences') && (0, $2B87Z.stopInitialPageLoadTimingFromPerformanceMarkStart)('product', (0, $6M8Uw.PRODUCT_START_MARK), true);
            $c48b51f586335ad5$var$emitMetrics(metric, customData);
        }
    }
    static{
        this.contextType = (0, $3Hphq.default);
    }
    render() {
        return null;
    }
}

});
parcelRegister("cNlZD", function(module, exports) {

$parcel$export(module.exports, "resetTTIObserver", () => $2134fd1f8b4ec9b6$export$1250c0c41b64ee5c);
$parcel$export(module.exports, "startTTIObserver", () => $2134fd1f8b4ec9b6$export$d2209a9a3184ff99);
$parcel$export(module.exports, "getTTIValue", () => $2134fd1f8b4ec9b6$export$e67176cf000b0a2e);

var $ba8ih = parcelRequire("ba8ih");
// Replace with lodash/noop
// eslint-disable-next-line @typescript-eslint/no-empty-function
let $2134fd1f8b4ec9b6$var$resolveTti = (_v)=>{};
let $2134fd1f8b4ec9b6$var$observerStarted = false;
/**
 * Initialize module state and return the promise a consumer can use to wait
 * for the TTI event.
 */ function $2134fd1f8b4ec9b6$var$initTtiPromise() {
    return new Promise((resolve)=>{
        let hasResolved = false;
        const callback = (ttiResult)=>{
            if (hasResolved) return;
            hasResolved = true;
            resolve(ttiResult);
        };
        $2134fd1f8b4ec9b6$var$resolveTti = callback;
    });
}
let $2134fd1f8b4ec9b6$var$ttiPromise = $2134fd1f8b4ec9b6$var$initTtiPromise();
function $2134fd1f8b4ec9b6$export$1250c0c41b64ee5c() {
    $2134fd1f8b4ec9b6$var$ttiPromise = $2134fd1f8b4ec9b6$var$initTtiPromise();
    $2134fd1f8b4ec9b6$var$observerStarted = false;
}
function $2134fd1f8b4ec9b6$export$d2209a9a3184ff99() {
    $2134fd1f8b4ec9b6$var$observerStarted = true;
    let cleanupObserver = null;
    let lastSeenEventTime = performance.now();
    const callback = ()=>{
        cleanupObserver?.();
        $2134fd1f8b4ec9b6$var$resolveTti(lastSeenEventTime);
    };
    let timeoutId = setTimeout(callback, 5000);
    cleanupObserver = (0, $ba8ih.startLongTaskObserver)(()=>{
        lastSeenEventTime = performance.now();
        clearTimeout(timeoutId);
        timeoutId = setTimeout(callback, 5000);
    });
}
function $2134fd1f8b4ec9b6$export$e67176cf000b0a2e() {
    const promise = $2134fd1f8b4ec9b6$var$ttiPromise ?? $2134fd1f8b4ec9b6$var$initTtiPromise();
    if (!$2134fd1f8b4ec9b6$var$observerStarted) $2134fd1f8b4ec9b6$export$d2209a9a3184ff99();
    return promise;
}

});
parcelRegister("ba8ih", function(module, exports) {

$parcel$export(module.exports, "startLongTaskObserver", () => $c3f66a1c0c2d8c9c$export$af412d3da3bf848a);
/**
 * Starts a long-task observer that will call `cb` on each observation.
 * Returns a disposal function
 */ function $c3f66a1c0c2d8c9c$export$af412d3da3bf848a(cb) {
    const observer = new PerformanceObserver(()=>{
        cb();
    });
    observer.observe({
        type: 'longtask'
    });
    return ()=>{
        observer.disconnect();
    };
}

});


parcelRegister("6M8Uw", function(module, exports) {

$parcel$export(module.exports, "PRODUCT_START_MARK", () => $e57b25b6033962a3$export$8e54fca0a680fdfd);
$parcel$export(module.exports, "MarkProductStart", () => $e57b25b6033962a3$export$2a999c5f84501025);

var $6iz4v = parcelRequire("6iz4v");
const $e57b25b6033962a3$export$8e54fca0a680fdfd = 'PRODUCT_START';
const $e57b25b6033962a3$export$2a999c5f84501025 = ()=>{
    if (!false) {
        performance.clearMarks($e57b25b6033962a3$export$8e54fca0a680fdfd);
        (0, $6iz4v.setMark)($e57b25b6033962a3$export$8e54fca0a680fdfd);
    }
    return null;
};

});

const $37f655a4e4d5690e$export$56940a9488e85199 = 'jira.fe.spa-';
const $37f655a4e4d5690e$export$45c4b6bf7935c69a = `${$37f655a4e4d5690e$export$56940a9488e85199}start`;
const $37f655a4e4d5690e$export$135c96ab5afee429 = 'ssr.spa.rendered';
const $37f655a4e4d5690e$export$ff834eccc35b9089 = 'appBundleReady';
const $37f655a4e4d5690e$export$86b05e34d462ead8 = 'prefetchApiReady';
const $37f655a4e4d5690e$export$d6a604a7d9a390fb = 'prefetchApiStart';
const $37f655a4e4d5690e$export$1211adfff27a31fe = 'issueViewInitialDataReady';
const $37f655a4e4d5690e$export$3ae43cc1782d058f = 'jswRenderStart';
const $37f655a4e4d5690e$export$363f6703ffa600be = 'jswCreateReduxStoreStart';
const $37f655a4e4d5690e$export$e87b74567b79c8 = 'jswCreateReduxStoreEnd';
const $37f655a4e4d5690e$export$99fe642459a8b02 = 'jswTransformCriticalDataStart';
const $37f655a4e4d5690e$export$ab1f5705fc8e0571 = 'jswTransformCriticalDataEnd';
const $37f655a4e4d5690e$export$8c3a9046da692c35 = 'jswReduxSoftwareAppLoadedStart';
const $37f655a4e4d5690e$export$5aa497d1efdcc5bf = 'jswReduxSoftwareAppLoadedEnd';
const $37f655a4e4d5690e$export$99c08ec92759c71c = 'tti-raf-mark';
const $37f655a4e4d5690e$export$48552baa9db8ce1d = 'tti-raf';


parcelRegister("brm1D", function(module, exports) {

$parcel$export(module.exports, "StopUfo", () => $aa08c3eb931d9705$export$d91154f099475c5);

var $eUqFw = parcelRequire("eUqFw");

var $3Hphq = parcelRequire("3Hphq");

var $4nnPJ = parcelRequire("4nnPJ");
class $aa08c3eb931d9705$export$d91154f099475c5 extends (0, $eUqFw.Component) {
    componentDidMount() {
        const { customData: customData, appName: appName } = this.props;
        (0, $4nnPJ.GlobalPageLoadExperience).success({
            force: true,
            metadata: customData
        });
        const name = appName || (0, $4nnPJ.GlobalPageLoadExperience).loadingPageLoadId;
        if (name) this.context?.addApdex({
            key: name,
            stopTime: performance.now()
        });
    }
    static{
        this.contextType = (0, $3Hphq.default);
    }
    render() {
        return null;
    }
}

});

parcelRegister("ifyPR", function(module, exports) {

$parcel$export(module.exports, "addBM3SSRDoneAsFMPToInteraction", () => $d6714c8d166fb68b$export$bf239ac2bfb04967);

var $51JrV = parcelRequire("51JrV");

var $fYqUr = parcelRequire("fYqUr");
function $d6714c8d166fb68b$export$bf239ac2bfb04967(metric) {
    const interactionId = (0, $51JrV.getInteractionId)();
    const currentInteractionId = interactionId.current;
    if (!currentInteractionId) return;
    const data = metric.getData();
    // Use BM3 SSR mark as FMP config for UFO if it exists, temporarily.
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    const config = data?.config;
    if (config && data?.isInitial) (0, $fYqUr.addMetadata)(currentInteractionId, {
        __legacy__bm3ConfigSSRDoneAsFmp: config.ssr?.doneAsFmp || false
    });
}

});

parcelRegister("aS0xb", function(module, exports) {

$parcel$export(module.exports, "addUFOSSRDoneAsFMPToInteraction", () => $714e33db0dc77e43$export$e63862cd888fe05a);

var $51JrV = parcelRequire("51JrV");

var $fYqUr = parcelRequire("fYqUr");

var $4nnPJ = parcelRequire("4nnPJ");
var $aPkDp = parcelRequire("aPkDp");
async function $714e33db0dc77e43$export$e63862cd888fe05a() {
    const interactionId = (0, $51JrV.getInteractionId)();
    const currentInteractionId = interactionId.current;
    if (!currentInteractionId) return;
    // Use UFO SSR mark as FMP config for rUFO if it exists, temporarily.
    const data = await (0, $4nnPJ.GlobalPageLoadExperience).exportData();
    const fmpMark = data.metrics.marks.find((mark)=>mark.name === 'fmp') || (0, $aPkDp.payloadPublisher).ssr?.getDoneMark();
    if (data.initial && fmpMark) (0, $fYqUr.addMetadata)(currentInteractionId, {
        __legacy__ufoConfigSSRDoneAsFmp: true
    });
}

});

parcelRegister("45wsB", function(module, exports) {

$parcel$export(module.exports, "trackBM3FeatureFlagsAccessed", () => $58cb476ec3ec20ed$export$f00f1e874ce869e9);

var $aWbzA = parcelRequire("aWbzA");

var $51JrV = parcelRequire("51JrV");
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $58cb476ec3ec20ed$var$startsAsObject = (value)=>{
    try {
        if (value.charAt(0) === '{') return true;
    } catch (e) {
        return false;
    }
    return false;
};
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $58cb476ec3ec20ed$var$isObject = (value)=>value && typeof value === 'object' && value.constructor === Object;
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $58cb476ec3ec20ed$var$isString = (input)=>{
    let result;
    try {
        result = typeof input === 'string' || input instanceof String;
    } catch (err) {
        // swallow any errors
        result = false;
    }
    return result;
};
const $58cb476ec3ec20ed$export$7b4abba432e57989 = (value)=>$58cb476ec3ec20ed$var$isString(value) && $58cb476ec3ec20ed$var$startsAsObject(value) || $58cb476ec3ec20ed$var$isObject(value);
const $58cb476ec3ec20ed$export$fcc03ee4c944962f = (featureFlagValue)=>$58cb476ec3ec20ed$export$7b4abba432e57989(featureFlagValue) ? 'non_boolean' : featureFlagValue;
const $58cb476ec3ec20ed$export$d2818866b4acbea4 = new Map();
const $58cb476ec3ec20ed$export$f00f1e874ce869e9 = (metric)=>{
    const interactionId = (0, $51JrV.getInteractionId)();
    const currentInteractionId = interactionId.current;
    if (!currentInteractionId) return;
    const data = metric.getData();
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    const config = data?.config;
    if (config && config?.featureFlags?.length) {
        const allFeatureFlags = (0, $aWbzA.default)();
        config.featureFlags.forEach((featureFlagName)=>{
            const value = allFeatureFlags[featureFlagName];
            if (value === undefined) return;
            const featureFlagValue = $58cb476ec3ec20ed$export$fcc03ee4c944962f(value);
            $58cb476ec3ec20ed$export$d2818866b4acbea4.set(featureFlagName, featureFlagValue);
        });
    }
};

});


parcelRegister("fO5rB", function(module, exports) {

$parcel$export(module.exports, "SubProductUpdater", () => $0dcc4693f2e4993e$export$eb40d3df56aa5c53);

var $eUqFw = parcelRequire("eUqFw");

var $3viaK = parcelRequire("3viaK");

var $cOnuN = parcelRequire("cOnuN");

var $6QL9v = parcelRequire("6QL9v");

var $kxBN8 = parcelRequire("kxBN8");

var $2SV7r = parcelRequire("2SV7r");
const $0dcc4693f2e4993e$export$eb40d3df56aa5c53 = ({ allowMonolithDeferral: allowMonolithDeferral = false, ...props })=>{
    const subProduct = (0, $2SV7r.isSubProductProps)(props) ? props.subProduct : (0, $6QL9v.getSubProductFromProjectType)(props.projectType);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $3viaK.default), {
        op: (0, $kxBN8.default),
        args: [
            subProduct,
            allowMonolithDeferral
        ]
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $cOnuN.default), {
        subProduct: subProduct
    }));
};

});
parcelRegister("cOnuN", function(module, exports) {

$parcel$export(module.exports, "default", () => $b3e22c81c3ebeab6$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $lgxha = parcelRequire("lgxha");

var $j5W2t = parcelRequire("j5W2t");
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$b3e22c81c3ebeab6$export$2e2bcd8739ae039 = ({ subProduct: subProduct })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $lgxha.default), {
        op: (0, $j5W2t.default),
        args: [
            subProduct
        ]
    });

});
parcelRegister("j5W2t", function(module, exports) {

$parcel$export(module.exports, "default", () => $8613fa53f568085a$export$2e2bcd8739ae039);

var $gUUjF = parcelRequire("gUUjF");

var $lRmyA = parcelRequire("lRmyA");
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$8613fa53f568085a$export$2e2bcd8739ae039 = (subProduct)=>{
    (0, $lRmyA.performGetRequest)(`/rest/internal/2/mauTag/${subProduct}`).catch((err)=>{
        (0, $gUUjF.default).safeErrorWithoutCustomerData('common.tag-mau.tag-mau-event', 'Error connecting to monolith mau tag endpoint', err);
    });
};

});


parcelRegister("6QL9v", function(module, exports) {

$parcel$export(module.exports, "getSubProductFromProjectType", () => $c2784746c0813b99$export$b1fe420ed15dff7b);

var $1ybV0 = parcelRequire("1ybV0");

var $dWlsy = parcelRequire("dWlsy");
const $c2784746c0813b99$export$b1fe420ed15dff7b = (projectType)=>{
    // for Analytics only 'product_discovery' is mapped to 'polaris'. In other cases it is mapped to 'software'
    if ((0, $1ybV0.ff)('polaris-detect-subproduct-for-jpd-by-project-type_8jxfy', false)) {
        if (projectType === 'product_discovery') return 'polaris';
        return (0, $dWlsy.subProductFromProjectType)(projectType);
    }
    return (0, $dWlsy.subProductFromProjectType)(projectType);
};

});

parcelRegister("kxBN8", function(module, exports) {

$parcel$export(module.exports, "default", () => $95a7ec92a66826ce$export$2e2bcd8739ae039);
// eslint-disable-next-line jira/wrm/no-load-bridge

var $2BvS3 = parcelRequire("2BvS3");
var $ds5Im = parcelRequire("ds5Im");
var $4DtuZ = parcelRequire("4DtuZ");


var $gUUjF = parcelRequire("gUUjF");

var $3FyZ4 = parcelRequire("3FyZ4");
const $95a7ec92a66826ce$var$maybeDelayAndRace = (// @ts-expect-error - TS2304 - Cannot find name 'Deferred'.
maybeWaitPromise, getDefaultPromise, getRacePromise)=>maybeWaitPromise ? Promise.race([
        maybeWaitPromise.then(getDefaultPromise),
        getRacePromise()
    ]) : getDefaultPromise();
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$95a7ec92a66826ce$export$2e2bcd8739ae039 = async (subProduct, allowMonolithDeferral)=>{
    (0, $3FyZ4.getAnalyticsWebClientPromise)().then((client)=>{
        client.setSubProduct(subProduct);
        if (subProduct === 'serviceDesk') client.setUIViewedAttributes({
            solutions: [
                (0, $96da08ab2c7a3243$export$c8b406ad8ee0dab9)
            ]
        });
        else client.removeUIViewedAttribute('solutions');
    });
    // IMPORTANT -
    // Until such time as all pre-TTI WRM loads are removed we find that waitForHeritage() then
    // loadBridgeStrict() is too slow, resulting in `subproduct:unknown` for analytics events.
    // In that same case however, profiling shows us that polling in loadBridgeWeak() somehow
    // resolves the same AMD code faster.
    // This is not well understood, but it does allow us to work around the issue by racing these
    // two techniques.
    // Once there is no pre-TTI WRM loads we the waitForHeritage() then loadBridgeStrict() does seem
    // to be faster such that we can remove the `Promise.race()`.
    /* eslint-disable jira/wrm/no-load-bridge */ $95a7ec92a66826ce$var$maybeDelayAndRace(allowMonolithDeferral ? (0, $4DtuZ.waitForHeritage)() : null, ()=>(0, $2BvS3.loadBridgeStrict)({
            name: 'jira/analytics/sub-product-resolver',
            wrmKeys: [
                'wrc!com.atlassian.jira.jira-client-analytics-plugin:analytics-web-client'
            ]
        }), ()=>(0, $ds5Im.loadBridgeWeak)({
            name: 'jira/analytics/sub-product-resolver'
        })).then((subProductResolver)=>{
        subProductResolver.setSubProduct(subProduct);
    }).catch((e)=>(0, $gUUjF.default).safeErrorWithoutCustomerData('common.analytics-sub-product.sub-product-updater', 'Error connecting to monolith sub product resolver', e));
/* eslint-enable jira/wrm/no-load-bridge */ };

});
const $96da08ab2c7a3243$export$c8b406ad8ee0dab9 = 'jiraServiceManagement';


parcelRegister("2SV7r", function(module, exports) {

$parcel$export(module.exports, "isSubProductProps", () => $5e5ef73a1d4e492a$export$c3063d6d7a8c075f);
const $5e5ef73a1d4e492a$export$c3063d6d7a8c075f = (props)=>'subProduct' in props && typeof props.subProduct === 'string';
const $5e5ef73a1d4e492a$export$81da4a7e1ba1dcee = (props)=>'projectType' in props && typeof props.projectType === 'string';

});





//# sourceMappingURL=async-global-issue-navigator.a114aa9d.js.map
